{
	"key": {
		"global \ninstruction": "global \ninstruction",
		"safe": "safe",
		"information": "information",
		"secure_checkout": "secure_checkout",
		"encrypted": "encrypted",
		"help": "help",
		"contact": "contact",
		"here": "here",
		"undefined": "",
		"featured": "featured",
		"main_title": "main_title",
		"per_year": "per_year",
		"special_offer": "special_offer",
		"card_number": "card_number",
		"card_expiry": "card_expiry",
		"security_number": "security_number",
		"email": "email",
		"To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of __period__ and at the full, not discounted, price of __fullPriceText__ To learn more visit our <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">terms of use</a>.": "To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of __period__ and at the full, not discounted, price of __fullPriceText__ To learn more visit our <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">terms of use</a>.",
		"secure_server": "secure_server",
		"pay": "pay",
		"enter_your_email": "enter_your_email",
		"comment_1": "comment_1",
		"comment_2": "comment_2",
		"success_story": "success_story",
		"get_my_plan": "get_my_plan",
		"delimiter": "delimiter",
		"pay_buy_card": "pay_buy_card",
		"get_my_plan_warning_1": "get_my_plan_warning_1",
		"get_my_plan_warning_2": "get_my_plan_warning_2",
		"get_my_plan_warning_3": "get_my_plan_warning_3",
		"get_my_plan_warning_text": "get_my_plan_warning_text",
		"terms_of_use": "terms_of_use",
		"privacy_policy": "privacy_policy",
		"terms_conditions": "terms_conditions",
		"privacy_policy_footer": "privacy_policy_footer",
		"terms_conditions_footer": "terms_conditions_footer",
		"guaranteed": "guaranteed",
		"special_features": "special_features",
		"calories_value": "calories_value",
		"personalized_plan": "personalized_plan",
		"mobile_app": "mobile_app",
		"daily_programs": "daily_programs",
		"audio_guided": "audio_guided",
		"easy_to_cook": "easy_to_cook",
		"comprehensive_stats": "comprehensive_stats",
		"secret_tips": "secret_tips",
		"mobile_app_tailor": "mobile_app_tailor",
		"daily_programs_for": "daily_programs_for",
		"daily_programs_for_2": "daily_programs_for_2",
		"audio_trainers": "audio_trainers",
		"comprehensive_track": "comprehensive_track",
		"price": "price",
		"users_love": "users_love",
		"alternative_review_name_1": "alternative_review_name_1",
		"alternative_review_title_1": "alternative_review_title_1",
		"alternative_review_contentent_1": "alternative_review_contentent_1",
		"alternative_review_name_2": "alternative_review_name_2",
		"alternative_review_title_2": "alternative_review_title_2",
		"alternative_review_contentent_2": "alternative_review_contentent_2",
		"you_re_in": "you_re_in",
		"personal_plan_starts": "personal_plan_starts",
		"app_by_link": "app_by_link",
		"download_now": "download_now",
		"or": "or",
		"price_after_trial": "price_after_trial",
		"seven_days_trial_unlocked": "seven_days_trial_unlocked",
		"total_today": "total_today",
		"reserved_price_for": "reserved_price_for",
		"new_subscritions1_title": "new_subscritions1_title",
		"new_subscritions1_subscription1_line1": "new_subscritions1_subscription1_line1",
		"new_subscritions1_subscription1_price1_time": "new_subscritions1_subscription1_price1_time",
		"new_subscritions1_subscription2_line1": "new_subscritions1_subscription2_line1",
		"new_subscritions1_subscription2_price2_time": "new_subscritions1_subscription2_price2_time",
		"new_subscritions1_subscription3_line1": "new_subscritions1_subscription3_line1",
		"new_subscritions1_subscription3_price3_time": "new_subscritions1_subscription3_price3_time",
		"new_subscription_save": "new_subscription_save",
		"new_subscritions_agreement": "new_subscritions_agreement",
		"new_subscritions_and": "new_subscritions_and",
		"new_subscritions_subtitle": "new_subscritions_subtitle",
		"new_subscritions_join": "new_subscritions_join",
		"statistic_block_item1_text": "statistic_block_item1_text",
		"statistic_block_item2_text": "statistic_block_item2_text",
		"statistic_block_item3_text": "statistic_block_item3_text",
		"get_your_personalized_plan": "get_your_personalized_plan",
		"for": "for",
		"new_subscription_save_mostPopular1MonthPrice": "new_subscription_save_mostPopular1MonthPrice",
		"timer_additional_discount": "timer_additional_discount",
		"timer_additional_discount_bold": "timer_additional_discount_bold",
		"timer_offer_expires": "timer_offer_expires",
		"Payment Successful": "Payment Successful",
		"payment_successful_title": "payment_successful_title",
		"payment_successful_download": "payment_successful_download",
		"payment_successful_press": "payment_successful_press",
		"payment_successful_login": "payment_successful_login",
		"payment_successful_email": "payment_successful_email",
		"payment_successful_code": "payment_successful_code",
		"payment_successful_hit": "payment_successful_hit",
		"payment_successful_done": "payment_successful_done",
		"payment_successful_description": "payment_successful_description",
		"Tariffs Variants": "Tariffs Variants",
		"tariff_title_choose": "tariff_title_choose",
		"tariff_title_get": "tariff_title_get",
		"tariff_one_month": "tariff_one_month",
		"tariff_three_month": "tariff_three_month",
		"tariff_six_month": "tariff_six_month",
		"tariff_one_year": "tariff_one_year",
		"tariff_one_week": "tariff_one_week",
		"tariff_three_day": "tariff_three_day",
		"tariff_per_year": "tariff_per_year",
		"tariff_per_day": "tariff_per_day",
		"tariff_per_days": "tariff_per_days",
		"tariff_per_week": "tariff_per_week",
		"tariff_week": "tariff_week",
		"tariff_annual": "tariff_annual",
		"tariff_trial_one_week": "tariff_trial_one_week",
		"tariff_after": "tariff_after",
		"tariff_save": "tariff_save",
		"tariff_best_offer": "tariff_best_offer",
		"tariff_most_popular": "tariff_most_popular",
		"tariff_limited_promo": "tariff_limited_promo",
		"tariff_6_for_3": "tariff_6_for_3",
		"tariff_first_month": "tariff_first_month",
		"tariff_first_week": "tariff_first_week",
		"tariff_monthly": "tariff_monthly",
		"tariff_quaterly": "tariff_quaterly",
		"tariff_semiannually": "tariff_semiannually",
		"tariff_billed_every ": "tariff_billed_every ",
		"tariff_year": "tariff_year",
		"tariff_month": "tariff_month",
		"tariff_months": "tariff_months",
		"tariff_months_variable": "tariff_months_variable",
		"tariff_organic_gift": "tariff_organic_gift",
		"tariff_full_price": "tariff_full_price",
		"tariff_no_hidden_fees": "tariff_no_hidden_fees",
		"tariff_start_right_now": "tariff_start_right_now",
		"tariff_more_than": "tariff_more_than",
		"tariff_intro_offer": "tariff_intro_offer",
		"Тарифы плиткой в ряд": "Тарифы плиткой в ряд",
		"": "",
		"Checkout": "Checkout",
		"checkout_title": "checkout_title",
		"insufficient_funds": "insufficient_funds",
		"insufficient_we_have": "insufficient_we_have",
		"insufficient_special_price": "insufficient_special_price",
		"insufficient_for_you": "insufficient_for_you",
		"checkout_edit_card": "checkout_edit_card",
		"checkout_pay_via": "checkout_pay_via",
		"checkout_paypal": "checkout_paypal",
		"checkout_credit_card": "checkout_credit_card",
		"checkout_paypal_description": "checkout_paypal_description",
		"checkout_total_price": "checkout_total_price",
		"checkout_warning_1": "checkout_warning_1",
		"checkout_warning_2": "checkout_warning_2",
		"checkout_warning_3": "checkout_warning_3",
		"spv2_warning": "spv2_warning",
		"checkout_offer_day_for": "checkout_offer_day_for",
		"checkout_offer_days_for": "checkout_offer_days_for",
		"checkout_offer_month_for": "checkout_offer_month_for",
		"checkout_offer_months_for": "checkout_offer_months_for",
		"checkout_offer_week_for": "checkout_offer_week_for",
		"Values": "Values",
		"value_kg": "value_kg",
		"value_pounds": "value_pounds",
		"value_st": "value_st",
		"value_g": "value_g",
		"value_kcal": "value_kcal",
		"value_min": "value_min",
		"value_min_cooking": "value_min_cooking",
		"welcome_title": "welcome_title",
		"item_1_title": "item_1_title",
		"item_1_description": "item_1_description",
		"item_2_title": "item_2_title",
		"item_2_description": "item_2_description",
		"item_2_description_2": "item_2_description_2",
		"item_3_title": "item_3_title",
		"item_3_description": "item_3_description",
		"change": "change",
		"change_mail": "change_mail",
		"email_warning": "email_warning",
		"Promo Code Block": "Promo Code Block",
		"promo_code_title": "promo_code_title",
		"promo_code_save": "promo_code_save",
		"EveryDoggy": "EveryDoggy",
		"dog_courses": "dog_courses",
		"why_we_best_active": "why_we_best_active",
		"why_we_best_lessons": "why_we_best_lessons",
		"why_we_best_brain": "why_we_best_brain",
		"why_we_best": "why_we_best",
		"why_we_best_join": "why_we_best_join",
		"why_we_best_enjoy": "why_we_best_enjoy",
		"why_we_best_keep": "why_we_best_keep",
		"dog_problems": "dog_problems",
		"dog_problems_choose": "dog_problems_choose",
		"dog_problems_leash": "dog_problems_leash",
		"dog_problems_biting": "dog_problems_biting",
		"dog_problems_anxiety": "dog_problems_anxiety",
		"dog_problems_chewing": "dog_problems_chewing",
		"dog_plan": "dog_plan",
		"dog_plan_our": "dog_plan_our",
		"dog_reviews": "dog_reviews",
		"dog_reviews_text_1": "dog_reviews_text_1",
		"dog_reviews_name_1": "dog_reviews_name_1",
		"dog_reviews_text_2": "dog_reviews_text_2",
		"dog_reviews_name_2": "dog_reviews_name_2",
		"dog_reviews_text_3": "dog_reviews_text_3",
		"dog_reviews_name_3": "dog_reviews_name_3",
		"join_text": "join_text",
		"join_courses": "join_courses",
		"checkout_introductory": "checkout_introductory",
		"checkout_personalized_plan": "checkout_personalized_plan",
		"Personal plan": "Personal plan",
		"goal_lose_weight": "goal_lose_weight",
		"goal_gain_muscles": "goal_gain_muscles",
		"goal_gain_healthier_life": "goal_gain_healthier_life",
		"goal_gain_flexibility": "goal_gain_flexibility",
		"goal_gain_build_endurance": "goal_gain_build_endurance",
		"goal_love_myself": "goal_love_myself",
		"body_type_apple": "body_type_apple",
		"body_type_pear": "body_type_pear",
		"body_type_square": "body_type_square",
		"body_type_hourglass": "body_type_hourglass",
		"body_type_triangle": "body_type_triangle",
		"body_type_unknown": "body_type_unknown",
		"excercises_time_morning": "excercises_time_morning",
		"excercises_time_day": "excercises_time_day",
		"excercises_time_evening": "excercises_time_evening",
		"excercises_not_sure": "excercises_not_sure",
		"diet_type_all": "diet_type_all",
		"diet_type_vegetarian": "diet_type_vegetarian",
		"diet_type_vegan": "diet_type_vegan",
		"diet_type_keto": "diet_type_keto",
		"personal_plan_providers_title": "personal_plan_providers_title",
		"special_features_title": "special_features_title",
		"special_features_duration_minimum": "special_features_duration_minimum",
		"special_features_duration_normal": "special_features_duration_normal",
		"special_features_duration_maximum": "special_features_duration_maximum",
		"special_features_duration_verv": "special_features_duration_verv",
		"special_features_goal_lose_weight": "special_features_goal_lose_weight",
		"special_features_goal_gain": "special_features_goal_gain",
		"special_features_goal_health": "special_features_goal_health",
		"special_features_goal_flexibility": "special_features_goal_flexibility",
		"special_features_goal_endurance": "special_features_goal_endurance",
		"special_features_goal_love": "special_features_goal_love",
		"discount_activated": "discount_activated",
		"discount_no_activated": "discount_no_activated",
		"unlocked_with_promo": "unlocked_with_promo",
		"use_with_button": "use_with_button",
		"plan_optimal": "plan_optimal",
		"plan_standard": "plan_standard",
		"plan_basic": "plan_basic",
		"plan_extra": "plan_extra",
		"daypayback_review_name_1": "daypayback_review_name_1",
		"daypayback_review_text_1": "daypayback_review_text_1",
		"daypayback_review_name_2": "daypayback_review_name_2",
		"daypayback_review_text_2": "daypayback_review_text_2",
		"daypayback_review_name_3": "daypayback_review_name_3",
		"daypayback_review_text_3": "daypayback_review_text_3",
		"daypayback_review_name_4": "daypayback_review_name_4",
		"daypayback_review_text_4": "daypayback_review_text_4",
		"personal_plan_you_get": "personal_plan_you_get",
		"goal": "goal",
		"goal_other": "goal_other",
		"goal_teaching_puppy": "goal_teaching_puppy",
		"goal_surviving_puppy": "goal_surviving_puppy",
		"goal_socializing_puppy": "goal_socializing_puppy",
		"goal_teaching_obedience": "goal_teaching_obedience",
		"age_puppy": "age_puppy",
		"age_adult": "age_adult",
		"biting_yes": "biting_yes",
		"biting_no": "biting_no",
		"biting_sometimes": "biting_sometimes",
		"quick_tips": "quick_tips",
		"potty_training_a_bit": "potty_training_a_bit",
		"potty_training_yes": "potty_training_yes",
		"potty_training_no": "potty_training_no",
		"success screen": "success screen",
		"success_screen_text_1": "success_screen_text_1",
		"success_screen_text_2": "success_screen_text_2",
		"success_screen_text_3": "success_screen_text_3",
		"success_screen_text_4": "success_screen_text_4",
		"success_screen_text_5": "success_screen_text_5",
		"success_screen_text_6": "success_screen_text_6",
		"success_screen_text_7": "success_screen_text_7",
		"success_screen_text_8": "success_screen_text_8",
		"success_screen_text_9": "success_screen_text_9",
		"success_screen_text_10": "success_screen_text_10",
		"success_screen_text_11": "success_screen_text_11",
		"success_screen_text_12": "success_screen_text_12",
		"success_screen_text_13": "success_screen_text_13",
		"success_screen_text_14": "success_screen_text_14",
		"success_screen_text_15": "success_screen_text_15",
		"success_screen_text_16": "success_screen_text_16",
		"payment_text_1": "payment_text_1",
		"payment_text_2": "payment_text_2",
		"payment_text_3": "payment_text_3",
		"payment_text_4": "payment_text_4",
		"payment_text_5": "payment_text_5",
		"payment_text_6": "payment_text_6",
		"payment_text_7": "payment_text_7",
		"payment_text_8": "payment_text_8",
		"payment_text_9": "payment_text_9",
		"payment_text_10": "payment_text_10",
		"payment_text_11": "payment_text_11",
		"payment_text_12": "payment_text_12",
		"payment_text_13": "payment_text_13",
		"payment_text_14": "payment_text_14",
		"payment_text_14_2": "payment_text_14_2",
		"payment_text_15": "payment_text_15",
		"payment_text_16": "payment_text_16",
		"payment_text_17": "payment_text_17",
		"payment_text_18": "payment_text_18",
		"payment_text_19": "payment_text_19",
		"payment_text_20": "payment_text_20",
		"payment_text_21": "payment_text_21",
		"payment_text_22": "payment_text_22",
		"payment_text_23": "payment_text_23",
		"payment_text_24": "payment_text_24",
		"payment_text_25": "payment_text_25",
		"payment_text_26": "payment_text_26",
		"payment_text_27": "payment_text_27",
		"payment_text_28": "payment_text_28",
		"payment_text_29": "payment_text_29",
		"payment_text_30": "payment_text_30",
		"payment_text_31": "payment_text_31",
		"payment_text_32": "payment_text_32",
		"payment_text_33": "payment_text_33",
		"payment_text_34": "payment_text_34",
		"payment_text_35": "payment_text_35",
		"payment_text_36": "payment_text_36",
		"payment_text_37": "payment_text_37",
		"payment_text_38": "payment_text_38",
		"payment_text_39": "payment_text_39",
		"payment_text_40": "payment_text_40",
		"payment_text_41": "payment_text_41",
		"payment_text_42": "payment_text_42",
		"payment_text_43": "payment_text_43",
		"payment_text_44": "payment_text_44",
		"payment_text_45": "payment_text_45",
		"payment_text_46": "payment_text_46",
		"payment_text_47": "payment_text_47",
		"payment_text_48": "payment_text_48",
		"payment_text_49": "payment_text_49",
		"payment_text_50": "payment_text_50",
		"payment_text_51": "payment_text_51",
		"payment_text_52": "payment_text_52",
		"payment_text_53": "payment_text_53",
		"payment_text_54": "payment_text_54",
		"payment_text_55": "payment_text_55",
		"payment_text_56": "payment_text_56",
		"payment_text_57": "payment_text_57",
		"payment_text_58": "payment_text_58",
		"payment_text_59": "payment_text_59",
		"payment_text_60": "payment_text_60",
		"payment_text_61": "payment_text_61",
		"payment_text_62": "payment_text_62",
		"payment_text_63": "payment_text_63",
		"payment_text_64": "payment_text_64",
		"payment_text_65": "payment_text_65",
		"payment_text_66": "payment_text_66",
		"payment_text_67": "payment_text_67",
		"payment_text_68": "payment_text_68",
		"payment_text_69": "payment_text_69",
		"payment_text_70": "payment_text_70",
		"payment_text_71": "payment_text_71",
		"payment_text_72": "payment_text_72",
		"payment_text_73": "payment_text_73",
		"payment_text_74": "payment_text_74",
		"payment_text_75": "payment_text_75",
		"payment_text_76": "payment_text_76",
		"payment_text_77": "payment_text_77",
		"payment_text_78": "payment_text_78",
		"payment_text_79": "payment_text_79",
		"payment_text_80": "payment_text_80",
		"payment_text_81": "payment_text_81",
		"payment_text_82": "payment_text_82",
		"payment_text_83": "payment_text_83",
		"payment_text_84": "payment_text_84",
		"payment_text_85": "payment_text_85",
		"payment_text_86": "payment_text_86",
		"payment_text_87": "payment_text_87",
		"payment_text_88": "payment_text_88",
		"payment_text_89": "payment_text_89",
		"payment_text_90": "payment_text_90",
		"payment_text_91": "payment_text_91",
		"payment_text_92": "payment_text_92",
		"payment_text_93": "payment_text_93",
		"payment_text_94": "payment_text_94",
		"payment_text_95": "payment_text_95",
		"payment_text_96": "payment_text_96",
		"payment_text_97": "payment_text_97",
		"payment_text_98": "payment_text_98",
		"payment_text_99": "payment_text_99",
		"payment_text_100": "payment_text_100",
		"payment_text_101": "payment_text_101",
		"payment_text_102": "payment_text_102",
		"payment_text_103": "payment_text_103",
		"payment_text_104": "payment_text_104",
		"payment_text_105": "payment_text_105",
		"payment_text_106": "payment_text_106",
		"payment_text_107": "payment_text_107",
		"payment_text_108": "payment_text_108",
		"payment_text_109": "payment_text_109",
		"payment_text_110": "payment_text_110",
		"payment_text_111": "payment_text_111",
		"payment_text_112": "payment_text_112",
		"payment_text_113": "payment_text_113",
		"payment_text_114": "payment_text_114",
		"payment_text_115": "payment_text_115",
		"payment_text_116": "payment_text_116",
		"payment_text_117": "payment_text_117",
		"payment_text_118": "payment_text_118",
		"payment_text_119": "payment_text_119",
		"payment_text_120": "payment_text_120",
		"payment_text_121": "payment_text_121",
		"payment_text_122": "payment_text_122",
		"payment_text_123": "payment_text_123",
		"payment_text_124": "payment_text_124",
		"payment_text_125": "payment_text_125",
		"payment_text_126": "payment_text_126",
		"payment_text_127": "payment_text_127",
		"payment_text_128": "payment_text_128",
		"payment_text_129": "payment_text_129",
		"payment_text_130": "payment_text_130",
		"payment_text_131": "payment_text_131",
		"payment_text_132": "payment_text_132",
		"payment_text_133": "payment_text_133",
		"payment_text_134": "payment_text_134",
		"payment_text_135": "payment_text_135",
		"payment_text_136": "payment_text_136",
		"payment_text_137": "payment_text_137",
		"payment_text_138": "payment_text_138",
		"payment_text_139": "payment_text_139",
		"payment_text_140": "payment_text_140",
		"payment_text_141": "payment_text_141",
		"payment_text_142": "payment_text_142",
		"payment_text_143": "payment_text_143",
		"payment_text_144": "payment_text_144",
		"payment_text_145": "payment_text_145",
		"payment_text_146": "payment_text_146",
		"payment_text_147": "payment_text_147",
		"payment_text_148": "payment_text_148",
		"payment_text_149": "payment_text_149",
		"payment_text_150": "payment_text_150",
		"payment_text_151": "payment_text_151",
		"payment_text_152": "payment_text_152",
		"payment_text_153": "payment_text_153",
		"payment_text_154": "payment_text_154",
		"payment_text_155": "payment_text_155",
		"payment_text_156": "payment_text_156",
		"payment_text_157": "payment_text_157",
		"payment_text_158": "payment_text_158",
		"payment_text_159": "payment_text_159",
		"payment_text_160": "payment_text_160",
		"payment_text_161": "payment_text_161",
		"payment_text_162": "payment_text_162",
		"payment_text_163": "payment_text_163",
		"payment_text_164": "payment_text_164",
		"payment_text_165": "payment_text_165",
		"payment_text_166": "payment_text_166",
		"payment_text_167": "payment_text_167",
		"payment_text_168": "payment_text_168",
		"payment_text_169": "payment_text_169",
		"payment_text_170": "payment_text_170",
		"payment_text_171": "payment_text_171",
		"payment_text_172": "payment_text_172",
		"payment_text_173": "payment_text_173",
		"payment_text_174": "payment_text_174",
		"payment_text_175": "payment_text_175",
		"payment_text_176": "payment_text_176",
		"payment_text_177": "payment_text_177",
		"payment_text_178": "payment_text_178",
		"payment_text_179": "payment_text_179",
		"payment_text_180": "payment_text_180",
		"payment_text_181": "payment_text_181",
		"payment_text_182": "payment_text_182",
		"payment_text_183": "payment_text_183",
		"payment_text_184": "payment_text_184",
		"payment_text_185": "payment_text_185",
		"payment_text_186": "payment_text_186",
		"payment_text_187": "payment_text_187",
		"payment_text_188": "payment_text_188",
		"payment_text_189": "payment_text_189",
		"payment_text_190": "payment_text_190",
		"payment_text_191": "payment_text_191",
		"payment_text_192": "payment_text_192",
		"payment_text_193": "payment_text_193",
		"payment_text_194": "payment_text_194",
		"payment_text_195": "payment_text_195",
		"payment_text_196": "payment_text_196",
		"payment_text_197": "payment_text_197",
		"payment_text_198": "payment_text_198",
		"payment_text_199": "payment_text_199",
		"payment_text_200": "payment_text_200",
		"payment_text_201": "payment_text_201",
		"payment_text_202": "payment_text_202",
		"payment_text_203": "payment_text_203",
		"payment_text_204": "payment_text_204",
		"payment_text_205": "payment_text_205",
		"payment_text_206": "payment_text_206",
		"payment_text_207": "payment_text_207",
		"payment_text_208": "payment_text_208",
		"payment_text_209": "payment_text_209",
		"payment_text_210": "payment_text_210",
		"payment_text_211": "payment_text_211",
		"payment_text_212": "payment_text_212",
		"payment_text_213": "payment_text_213",
		"payment_text_214": "payment_text_214",
		"payment_text_215": "payment_text_215",
		"payment_text_216": "payment_text_216",
		"payment_text_217": "payment_text_217",
		"payment_text_218": "payment_text_218",
		"payment_text_219": "payment_text_219",
		"payment_text_220": "payment_text_220",
		"payment_text_221": "payment_text_221",
		"payment_text_222": "payment_text_222",
		"payment_text_223": "payment_text_223",
		"payment_text_224": "payment_text_224",
		"payment_text_225": "payment_text_225",
		"payment_text_226": "payment_text_226",
		"payment_text_227": "payment_text_227",
		"payment_text_228": "payment_text_228",
		"payment_text_229": "payment_text_229",
		"payment_text_230": "payment_text_230",
		"payment_text_231": "payment_text_231",
		"payment_text_232": "payment_text_232",
		"payment_text_233": "payment_text_233",
		"payment_text_234": "payment_text_234",
		"payment_text_235": "payment_text_235",
		"payment_text_236": "payment_text_236",
		"payment_text_237": "payment_text_237",
		"payment_text_238": "payment_text_238",
		"payment_text_239": "payment_text_239",
		"payment_text_240": "payment_text_240",
		"payment_text_241": "payment_text_241",
		"payment_text_242": "payment_text_242",
		"payment_text_243": "payment_text_243",
		"payment_text_244": "payment_text_244",
		"payment_text_245": "payment_text_245",
		"payment_text_246": "payment_text_246",
		"payment_text_247": "payment_text_247",
		"payment_text_248": "payment_text_248",
		"payment_text_249": "payment_text_249",
		"payment_text_250": "payment_text_250",
		"payment_text_251": "payment_text_251",
		"payment_text_252": "payment_text_252",
		"payment_text_253": "payment_text_253",
		"payment_text_254": "payment_text_254",
		"payment_text_255": "payment_text_255",
		"payment_text_256": "payment_text_256",
		"payment_text_257": "payment_text_257",
		"payment_text_258": "payment_text_258",
		"payment_text_259": "payment_text_259",
		"payment_text_260": "payment_text_260",
		"payment_text_261": "payment_text_261",
		"payment_text_262": "payment_text_262",
		"payment_text_263": "payment_text_263",
		"payment_text_264": "payment_text_264",
		"payment_text_265": "payment_text_265",
		"payment_text_266": "payment_text_266",
		"payment_text_267": "payment_text_267",
		"payment_text_268": "payment_text_268",
		"payment_text_269": "payment_text_269",
		"payment_text_270": "payment_text_270",
		"payment_text_271": "payment_text_271",
		"payment_text_272": "payment_text_272",
		"payment_text_273": "payment_text_273",
		"payment_text_274": "payment_text_274",
		"payment_text_275": "payment_text_275",
		"payment_text_276": "payment_text_276",
		"payment_text_277": "payment_text_277",
		"payment_text_278": "payment_text_278",
		"payment_text_279": "payment_text_279",
		"payment_text_280": "payment_text_280",
		"payment_text_281": "payment_text_281",
		"payment_text_282": "payment_text_282",
		"payment_text_283": "payment_text_283",
		"payment_text_284": "payment_text_284",
		"payment_text_285": "payment_text_285",
		"payment_text_286": "payment_text_286",
		"payment_text_287": "payment_text_287",
		"payment_text_288": "payment_text_288",
		"payment_text_289": "payment_text_289",
		"payment_text_290": "payment_text_290",
		"payment_text_291": "payment_text_291",
		"payment_text_292": "payment_text_292",
		"payment_text_293": "payment_text_293",
		"payment_text_294": "payment_text_294",
		"payment_text_295": "payment_text_295",
		"payment_text_296": "payment_text_296",
		"payment_text_297": "payment_text_297",
		"payment_text_298": "payment_text_298",
		"payment_text_299": "payment_text_299",
		"payment_text_300": "payment_text_300",
		"payment_text_301": "payment_text_301",
		"payment_text_302": "payment_text_302",
		"payment_text_303": "payment_text_303",
		"payment_text_304": "payment_text_304",
		"payment_text_305": "payment_text_305",
		"payment_text_306": "payment_text_306",
		"payment_text_307": "payment_text_307",
		"payment_text_308": "payment_text_308",
		"payment_text_309": "payment_text_309",
		"payment_text_310": "payment_text_310",
		"payment_text_311": "payment_text_311",
		"payment_text_312": "payment_text_312",
		"payment_text_313": "payment_text_313",
		"payment_text_314": "payment_text_314",
		"payment_text_315": "payment_text_315",
		"payment_text_316": "payment_text_316",
		"payment_text_317": "payment_text_317",
		"payment_text_318": "payment_text_318",
		"payment_text_319": "payment_text_319",
		"payment_text_320": "payment_text_320",
		"payment_text_321": "payment_text_321",
		"payment_text_322": "payment_text_322",
		"payment_text_323": "payment_text_323",
		"payment_text_324": "payment_text_324",
		"payment_text_325": "payment_text_325",
		"payment_text_326": "payment_text_326",
		"payment_text_327": "payment_text_327",
		"payment_text_328": "payment_text_328",
		"payment_text_329": "payment_text_329",
		"payment_text_330": "payment_text_330",
		"payment_text_331": "payment_text_331",
		"payment_text_332": "payment_text_332",
		"payment_text_333": "payment_text_333",
		"payment_text_334": "payment_text_334",
		"payment_text_335": "payment_text_335",
		"payment_text_336": "payment_text_336",
		"payment_text_337": "payment_text_337",
		"payment_text_338": "payment_text_338",
		"payment_text_339": "payment_text_339",
		"payment_text_340": "payment_text_340",
		"payment_text_341": "payment_text_341",
		"payment_text_342": "payment_text_342",
		"payment_text_343": "payment_text_343",
		"payment_text_344": "payment_text_344",
		"payment_text_345": "payment_text_345",
		"payment_text_346": "payment_text_346",
		"payment_text_347": "payment_text_347",
		"payment_text_348": "payment_text_348",
		"payment_text_349": "payment_text_349",
		"payment_text_350": "payment_text_350",
		"payment_text_351": "payment_text_351",
		"payment_text_352": "payment_text_352",
		"payment_text_353": "payment_text_353",
		"payment_text_354": "payment_text_354",
		"payment_text_355": "payment_text_355",
		"payment_text_356": "payment_text_356",
		"payment_text_357": "payment_text_357",
		"payment_text_358": "payment_text_358",
		"payment_text_359": "payment_text_359",
		"payment_text_360": "payment_text_360",
		"payment_text_361": "payment_text_361",
		"payment_text_362": "payment_text_362",
		"payment_text_363": "payment_text_363",
		"payment_text_364": "payment_text_364",
		"payment_text_365": "payment_text_365",
		"payment_text_366": "payment_text_366",
		"payment_text_367": "payment_text_367",
		"payment_text_368": "payment_text_368",
		"payment_text_369": "payment_text_369",
		"payment_text_370": "payment_text_370",
		"payment_text_371": "payment_text_371",
		"payment_text_372": "payment_text_372",
		"payment_text_373": "payment_text_373",
		"payment_text_374": "payment_text_374",
		"payment_text_375": "payment_text_375",
		"payment_text_376": "payment_text_376",
		"payment_text_377": "payment_text_377",
		"payment_text_378": "payment_text_378",
		"payment_text_379": "payment_text_379",
		"payment_text_380": "payment_text_380",
		"payment_text_381": "payment_text_381",
		"payment_text_382": "payment_text_382",
		"payment_text_383": "payment_text_383",
		"payment_text_384": "payment_text_384",
		"payment_text_385": "payment_text_385",
		"payment_text_386": "payment_text_386",
		"payment_text_387": "payment_text_387",
		"payment_text_388": "payment_text_388",
		"payment_text_389": "payment_text_389",
		"pdfUpselling": "pdfUpselling",
		"pdfUpselling_1": "pdfUpselling_1",
		"pdfUpselling_2": "pdfUpselling_2",
		"pdfUpselling_3": "pdfUpselling_3",
		"pdfUpselling_4": "pdfUpselling_4",
		"pdfUpselling_5": "pdfUpselling_5",
		"pdfUpselling_6": "pdfUpselling_6",
		"pdfUpselling_7": "pdfUpselling_7",
		"pdfUpselling_8": "pdfUpselling_8",
		"pdfUpselling_9": "pdfUpselling_9",
		"pdfUpselling_10": "pdfUpselling_10",
		"pdfUpselling_11": "pdfUpselling_11",
		"pdfUpselling_12": "pdfUpselling_12",
		"pdfUpselling_13": "pdfUpselling_13",
		"pdfUpselling_14": "pdfUpselling_14",
		"pdfUpselling_15": "pdfUpselling_15",
		"pdfUpselling_16": "pdfUpselling_16",
		"chatUpsale_1": "chatUpsale_1",
		"chatUpsale_2": "chatUpsale_2",
		"chatUpsale_3": "chatUpsale_3",
		"chatUpsale_4": "chatUpsale_4",
		"chatUpsale_5": "chatUpsale_5",
		"chatUpsale_6": "chatUpsale_6",
		"chatUpsale_7": "chatUpsale_7",
		"chatUpsale_8": "chatUpsale_8",
		"chatUpsale_9": "chatUpsale_9",
		"chatUpsale_10": "chatUpsale_10",
		"chatUpsale_11": "chatUpsale_11",
		"chatUpsale_12": "chatUpsale_12",
		"chatUpsale_13": "chatUpsale_13",
		"chatUpsale_14": "chatUpsale_14",
		"chatUpsale_15": "chatUpsale_15",
		"checkoutV2_text1": "checkoutV2_text1",
		"checkoutV2_text2": "checkoutV2_text2",
		"checkoutV2_text3": "checkoutV2_text3",
		"checkoutV2_text4": "checkoutV2_text4",
		"checkoutV2_text5": "checkoutV2_text5",
		"checkoutV2_text6": "checkoutV2_text6",
		"checkoutV2_text7": "checkoutV2_text7",
		"checkoutV2_text8": "checkoutV2_text8",
		"checkoutV2_text9": "checkoutV2_text9",
		"checkoutV2_text10": "checkoutV2_text10",
		"checkoutV2_text11": "checkoutV2_text11",
		"error_1": "error_1",
		"error_2": "error_2",
		"error_3": "error_3",
		"error_4": "error_4",
		"error_5": "error_5",
		"error_6": "error_6",
		"error_7": "error_7",
		"error_8": "error_8",
		"error_9": "error_9",
		"error_10": "error_10",
		"disclaimerV2_text_1": "disclaimerV2_text_1",
		"disclaimerV2_text_2": "disclaimerV2_text_2",
		"disclaimerV2_text_3": "disclaimerV2_text_3",
		"chatUpsaleV2_1": "chatUpsaleV2_1",
		"chatUpsaleV2_2": "chatUpsaleV2_2",
		"chatUpsaleV2_3": "chatUpsaleV2_3",
		"chatUpsaleV2_4": "chatUpsaleV2_4",
		"chatUpsaleV2_5": "chatUpsaleV2_5",
		"chatUpsaleV2_6": "chatUpsaleV2_6",
		"chatUpsaleV2_7": "chatUpsaleV2_7",
		"chatUpsaleV2_8": "chatUpsaleV2_8",
		"chatUpsaleV2_9": "chatUpsaleV2_9",
		"chatUpsaleV2_10": "chatUpsaleV2_10",
		"chatUpsaleV2_11": "chatUpsaleV2_11",
		"chatUpsaleV2_12": "chatUpsaleV2_12",
		"chatUpsaleV2_13": "chatUpsaleV2_13",
		"chatUpsaleV2_14": "chatUpsaleV2_14",
		"chatUpsaleV2_15": "chatUpsaleV2_15",
		"chatUpsaleV2_16": "chatUpsaleV2_16",
		"chatUpsaleV2_17": "chatUpsaleV2_17",
		"chatUpsaleV2_18": "chatUpsaleV2_18",
		"chatUpsaleV2_19": "chatUpsaleV2_19",
		"chatUpsaleV2_20": "chatUpsaleV2_20",
		"chatUpsaleV2_21": "chatUpsaleV2_21",
		"chatUpsaleV2_22": "chatUpsaleV2_22",
		"chatUpsaleV2_23": "chatUpsaleV2_23",
		"chatUpsaleV2_24": "chatUpsaleV2_24",
		"chatUpsaleV2_25": "chatUpsaleV2_25",
		"chatUpsaleV2_26": "chatUpsaleV2_26",
		"chatUpsaleV2_27": "chatUpsaleV2_27",
		"chatUpsaleV2_28": "chatUpsaleV2_28",
		"chatUpsaleV2_29": "chatUpsaleV2_29",
		"chatUpsaleV2_30": "chatUpsaleV2_30",
		"chatUpsaleV2_31": "chatUpsaleV2_31",
		"chatUpsaleV2_32": "chatUpsaleV2_32",
		"chatUpsaleV2_33": "chatUpsaleV2_33"
	},
	"en": {
		"global \ninstruction": "These texts are used for a mobile application",
		"safe": "Your information is safe",
		"information": "We will not sell or rent your personal contact information for any marketing purposes whatsoever.",
		"secure_checkout": "Secure checkout",
		"encrypted": "All information is encrypted and transmitted without risk using a Secure Sockets Layer protocol.",
		"help": "Need any help?",
		"contact": "Contact us",
		"here": "here.",
		"undefined": "",
		"featured": "As featured in",
		"main_title": "Dog Training Courses",
		"per_year": "per year",
		"special_offer": "Special offer",
		"card_number": "Card number",
		"card_expiry": "Card expires",
		"security_number": "Security number",
		"email": "Email",
		"To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of __period__ and at the full, not discounted, price of __fullPriceText__ To learn more visit our <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">terms of use</a>.": "Payment information",
		"secure_server": "Secure Server",
		"pay": "Pay",
		"enter_your_email": "Enter your email",
		"comment_1": "During a few stressful years, I totally lost my shape and gained some fat, but I had no time or motivation to do anything about it. A family member suggested Verv and I now rely on my Coach daily!",
		"comment_2": "Verv made me enjoy home workouts and I have lost 7 kg in a month. This app could really help you with working out and losing weight if you were a beginner like me.",
		"success_story": "Success story",
		"get_my_plan": "GET MY PLAN",
		"delimiter": "or",
		"pay_buy_card": "Pay by Card",
		"get_my_plan_warning_1": "To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of",
		"get_my_plan_warning_2": "and at the full, not discounted, price of",
		"get_my_plan_warning_3": "To learn more visit our",
		"get_my_plan_warning_text": "By continuing, you agree that if you don’t cancel at least 24 hours prior to the end of the first renewal period, you will automatically be charged the full price of __fullPriceText__ every __period__ until you cancel.",
		"terms_of_use": "Terms of Use",
		"privacy_policy": "Privacy Policy",
		"terms_conditions": "Terms & Conditions",
		"privacy_policy_footer": "Privacy Policy",
		"terms_conditions_footer": "Terms & Conditions",
		"guaranteed": "Guaranteed safe checkout",
		"special_features": "Special features for you",
		"calories_value": "kcal",
		"personalized_plan": "Get Your Personalized Plan:",
		"mobile_app": "Mobile app with your plan",
		"daily_programs": "Daily programs for different goals (burn fat, reduce stress, muscle gain)",
		"audio_guided": "Audio guided workouts",
		"easy_to_cook": "Easy-to-cook and tasty dishes",
		"comprehensive_stats": "Comprehensive stats",
		"secret_tips": "Secret tips on developing healthy habits",
		"mobile_app_tailor": "Tailor-made plan in your pocket",
		"daily_programs_for": "Daily programs",
		"daily_programs_for_2": "For different goals (burn fat, reduce stress, muscle gain)",
		"audio_trainers": "Professional trainers guides",
		"comprehensive_track": "Track your progress with ultimate stats",
		"price": "Price",
		"users_love": "Users love our Personalized Plan",
		"alternative_review_name_1": "Therealtierra",
		"alternative_review_title_1": "Great app!",
		"alternative_review_contentent_1": "I’m on my 9th week and my body has changed tremendously!",
		"alternative_review_name_2": "tenniagirl",
		"alternative_review_title_2": "It works!",
		"alternative_review_contentent_2": "Just finished the program. love it. Down 33lbs!!",
		"you_re_in": "You’re in!",
		"personal_plan_starts": "Your Verv personal plan starts today and the clock is ticking. So check it out!",
		"app_by_link": "To enter your program download app by link",
		"download_now": "Download Now",
		"or": "or",
		"price_after_trial": "Price after trial",
		"seven_days_trial_unlocked": "7 days trial unlocked",
		"total_today": "Total today",
		"reserved_price_for": "Reserved price for",
		"new_subscritions1_title": "Choose your plan",
		"new_subscritions1_subscription1_line1": "Half-year plan",
		"new_subscritions1_subscription1_price1_time": "per week",
		"new_subscritions1_subscription2_line1": "3-month plan",
		"new_subscritions1_subscription2_price2_time": "per week",
		"new_subscritions1_subscription3_line1": "1-month plan",
		"new_subscritions1_subscription3_price3_time": "per week",
		"new_subscription_save": "SAVE",
		"new_subscritions_agreement": "By continuing, you agree with the",
		"new_subscritions_and": "and",
		"new_subscritions_subtitle": "Our users have lost 10 million pounds",
		"new_subscritions_join": "Join Millions of Our Happy Users",
		"statistic_block_item1_text": "Stars out of 5",
		"statistic_block_item2_text": "5-star ratings",
		"statistic_block_item3_text": "downloads",
		"get_your_personalized_plan": "Get Your Personalized Plan",
		"for": "for",
		"new_subscription_save_mostPopular1MonthPrice": "the most popular plan",
		"timer_additional_discount": "Additional discount applied just ",
		"timer_additional_discount_bold": "for you",
		"timer_offer_expires": "This offer expires in:",
		"Payment Successful": "",
		"payment_successful_title": "Hi from the Verv team!",
		"payment_successful_download": "Download the app",
		"payment_successful_press": "Press",
		"payment_successful_login": "Log in with email",
		"payment_successful_email": "Enter your email",
		"payment_successful_code": "and your confirmation code:",
		"payment_successful_hit": "Then hit",
		"payment_successful_done": "Done",
		"payment_successful_description": "You’re in, enjoy your personalized training plan!",
		"Tariffs Variants": "",
		"tariff_title_choose": "Choose your plan",
		"tariff_title_get": "Get your plan",
		"tariff_one_month": "1-Month plan",
		"tariff_three_month": "3-Month plan",
		"tariff_six_month": "6-Month plan",
		"tariff_one_year": "1-Year plan",
		"tariff_one_week": "1-Week plan",
		"tariff_three_day": "3-Day plan",
		"tariff_per_year": "per year",
		"tariff_per_day": "per day",
		"tariff_per_days": "per 3 days",
		"tariff_per_week": "per week",
		"tariff_week": "week",
		"tariff_annual": "Annual plan",
		"tariff_trial_one_week": "1-week trial",
		"tariff_after": "after ",
		"tariff_save": "Save",
		"tariff_best_offer": "best offer",
		"tariff_most_popular": "most popular",
		"tariff_limited_promo": "limited promo price",
		"tariff_6_for_3": "6 for the price of 3",
		"tariff_first_month": "first month",
		"tariff_first_week": "first week",
		"tariff_monthly": "monthly",
		"tariff_quaterly": "quarterly",
		"tariff_semiannually": "semiannually",
		"tariff_billed_every ": "billed every ",
		"tariff_year": "year",
		"tariff_month": "month",
		"tariff_months": "months",
		"tariff_months_variable": "months",
		"tariff_organic_gift": "Meditation plan",
		"tariff_full_price": "Full price",
		"tariff_no_hidden_fees": "No hidden fees",
		"tariff_start_right_now": "Start right now",
		"tariff_more_than": "More than 1 000 000 active members of Verv family",
		"tariff_intro_offer": "INTRO OFFER",
		"Тарифы плиткой в ряд": "",
		"": "Never thought my dog is so incredibly smart. With EveryDoggy we’ve learned 5 new tricks literally in a week!",
		"Checkout": "",
		"checkout_title": "Select payment method",
		"insufficient_funds": "Insufficient funds",
		"insufficient_we_have": "We have a",
		"insufficient_special_price": "special price",
		"insufficient_for_you": "for you",
		"checkout_edit_card": "Edit card",
		"checkout_pay_via": "Pay via",
		"checkout_paypal": "PayPal",
		"checkout_credit_card": "Credit card",
		"checkout_paypal_description": "Your payment will be processed through PayPal",
		"checkout_total_price": "Total Price",
		"checkout_warning_1": "To avoid any disruption, you agree that the subscription you\n                    selected will automatically be extended for a successive\n                    renewal period of",
		"checkout_warning_2": "and at the full, not\n                    discounted, price of",
		"checkout_warning_3": "To learn more visit\n                    our",
		"spv2_warning": "To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of __period__ and at the full, not discounted, price of __productDetailsAmount__ To learn more visit our <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">terms of use</a>.",
		"checkout_offer_day_for": "day for",
		"checkout_offer_days_for": "days for",
		"checkout_offer_month_for": "month for",
		"checkout_offer_months_for": "months for",
		"checkout_offer_week_for": "week for",
		"Values": "",
		"value_kg": "kg",
		"value_pounds": "lbs",
		"value_st": "st",
		"value_g": "g",
		"value_kcal": "kcal",
		"value_min": "min",
		"value_min_cooking": "min cooking",
		"welcome_title": "Welcome to Verv Premium!",
		"item_1_title": "Whoopee!",
		"item_1_description": "Your goal weight of __weight__ is now just around the corner.",
		"item_2_title": "How to activate",
		"item_2_description": "Download the app using the link below, use your email __mail__ and enter this validation code: __code__.",
		"item_2_description_2": "To change the email click <button id=\"changeMail\">here</button>.",
		"item_3_title": "Something went wrong?",
		"item_3_description": "A detailed instruction was sent to your email. If you didn’t get it, contact <a target=\"_blank\" href=\"mailto:support@verv.com?subject=Problem with login (simple-login)\">support</a>.",
		"change": "Confirm",
		"change_mail": "Change your email here to activate Premium",
		"email_warning": "Please fill in a valid email address",
		"Promo Code Block": "",
		"promo_code_title": "Promo code applied!",
		"promo_code_save": "% off",
		"EveryDoggy": "",
		"dog_courses": "dog courses",
		"why_we_best_active": "Active Users.",
		"why_we_best_lessons": "Video Lessons.",
		"why_we_best_brain": "Brain Games.",
		"why_we_best": "Why we are the best?",
		"why_we_best_join": "Join our dog parent community and do your best with EveryDoggy.",
		"why_we_best_enjoy": "Enjoy your personalized training plan, tailored to your and your pooch’s goals.",
		"why_we_best_keep": "Keep your dog mentally and physically active with 70+ brain games.",
		"dog_problems": "Fast solutions to behavioral problems",
		"dog_problems_choose": "Choose the unwanted behaviors you'd like to improve",
		"dog_problems_leash": "Leash<br/>pulling",
		"dog_problems_biting": "Biting",
		"dog_problems_anxiety": "Separation<br/>anxiety",
		"dog_problems_chewing": "Destructive<br/>chewing",
		"dog_plan": "Personalized training plan",
		"dog_plan_our": "Our training program is 100% tailored to your dog’s needs.",
		"dog_reviews": "What dog parents say about EveryDoggy",
		"dog_reviews_text_1": "«Very clear and easy-to-follow lessons. My puppy likes training and we’ve both learned a lot.»",
		"dog_reviews_name_1": "Megan and Leo",
		"dog_reviews_text_2": "«The \"Zen\" command makes wonders. Thanks to it, my dog is super-calm at the veterinary clinic during procedures.»",
		"dog_reviews_name_2": "Linda B.",
		"dog_reviews_text_3": "«Thanks for the clicker-training lesson. I’ve heard it’s very popular but it was unclear how to use it. I’ve quickly familiarized my dog with the clicker and now we have started to learn tricks.»",
		"dog_reviews_name_3": "Jake L.",
		"join_text": "Happy dog parenting starts with EveryDoggy",
		"join_courses": "Join Web Courses",
		"checkout_introductory": "Introductory offer discount",
		"checkout_personalized_plan": "Your personalized plan",
		"Personal plan": "",
		"goal_lose_weight": "Effective weight loss program with guided workouts, nutrition tracker and a variety of activities for you",
		"goal_gain_muscles": "Effective full body toning program with guided workouts, nutrition tracker and a variety of activities for you",
		"goal_gain_healthier_life": "New healthy routine with full body guided workouts, nutrition tracker and a variety of activities for you",
		"goal_gain_flexibility": "Yoga program for flexibility with guided sessions and calming music, nutrition tracker and a variety of other activities",
		"goal_gain_build_endurance": "Endurance training program with guided workouts, nutrition tracker and a variety of activities for you",
		"goal_love_myself": "A variety of activities for boosting your self-esteem, guided meditations, yoga sessions and full body workouts",
		"body_type_apple": "Exercises for apple shaped body to tone your core and slim your waist",
		"body_type_pear": "Exercises for pear shaped body to tone your hips and thighs",
		"body_type_square": "Exercises for square shaped body to define your waist and work your glutes",
		"body_type_hourglass": "Exercises for hourglass shaped body to help you get the astonishing results",
		"body_type_triangle": "Inverted triangle body shape exercises for strengthening your hips and thighs",
		"body_type_unknown": "Exercises to bring out the best in your body shape",
		"excercises_time_morning": "Morning workouts to boost your metabolism and energize you for the whole day",
		"excercises_time_day": "Workouts that fit perfectly into your schedule, boost your metabolism and keep you energized for the day",
		"excercises_time_evening": "Evening workouts to help you relieve stress after a long day and prepare you for a good night sleep",
		"excercises_not_sure": "Workouts that fit perfectly into your schedule, boost your metabolism and keep you energized for the day",
		"diet_type_all": "Easy healthy recipes",
		"diet_type_vegetarian": "Healthy vegetarian recipes",
		"diet_type_vegan": "Healthy vegan recipes",
		"diet_type_keto": "Healthy keto recipes",
		"personal_plan_providers_title": "",
		"special_features_title": "Special features for you",
		"special_features_duration_minimum": "Quick sessions under 10 minutes",
		"special_features_duration_normal": "Convenient sessions under 20 minutes",
		"special_features_duration_maximum": "Effective sessions over 20 minutes",
		"special_features_duration_verv": "Convenient sessions from our coaches",
		"special_features_goal_lose_weight": "Secret weight loss tips from experts",
		"special_features_goal_gain": "Secret muscle toning tips from experts",
		"special_features_goal_health": "Secret healthy tips from experts",
		"special_features_goal_flexibility": "Secret flexibility tips from experts",
		"special_features_goal_endurance": "Secret tips for boosting endurance",
		"special_features_goal_love": "Secret tips for self-esteem boost",
		"discount_activated": "50% discount activated",
		"discount_no_activated": "50% discount",
		"unlocked_with_promo": "Unlocked with the promo code:",
		"use_with_button": "Use your special promo code:",
		"plan_optimal": "OPTIMAL",
		"plan_standard": "STANDARD",
		"plan_basic": "BASIC ",
		"plan_extra": "EXTRA",
		"daypayback_review_name_1": "melliebeth",
		"daypayback_review_text_1": "During a few stressful years, I totally lost my shape and gained some fat, but I had no time or motivation to do anything about it. A family member suggested Verv and I decided to try it. I followed the plan and results were fantastic! It helped me lose weight and get back into shape. Now I can’t imagine my life without Verv and quick at-home workouts.",
		"daypayback_review_name_2": "katie_zu13",
		"daypayback_review_text_2": "Love Verv! Following my personal workout and meal plan has helped me get back in shape and become confident again! I started with short fitness workouts under 15 minutes which were perfect for a beginner like me. Then I build up my endurance and my workout time went up to 30-40 minutes per session. I slowly but surely lost 56 pounds during 6 months with Verv!",
		"daypayback_review_name_3": "Jean_leon1",
		"daypayback_review_text_3": "I gained a lot of weight during college. After I graduated I tried different diets that helped me lose weight but that weight would always come back a few months after the diet was over. Last year I heard of Verv from my colleague and decided to give it a try. With Verv’s personalized recommendations I managed to lose weight and to keep it off afterwards!",
		"daypayback_review_name_4": "maryanne1993",
		"daypayback_review_text_4": "After a hard breakup I decided to change my life, lose weight and become healthier. But I didn’t know where to start. I didn’t feel confident enough exercising with others so I decided to try at-home workout apps and Verv came across my search. It offered me a plan tailored to my needs. I followed it and managed to get the body of my dreams!",
		"personal_plan_you_get": "With you personalized plan you get",
		"goal": "Goal",
		"goal_other": "Lessons for training your furry friend",
		"goal_teaching_puppy": "Lessons for teaching your furry friend manners and obedience",
		"goal_surviving_puppy": "Lessons to help you prepare for the first days with your furry friend",
		"goal_socializing_puppy": "Lessons to help you socialize your furry friend",
		"goal_teaching_obedience": "Lessons for teaching your furry friend manners and obedience",
		"age_puppy": "Detailed training tips from our experts to help you raise a happy and well-behaved puppy",
		"age_adult": "Detailed training tips from our experts to help you train your dog in the most effective way",
		"biting_yes": "Step-by-step instructions to stop your dog from biting",
		"biting_no": "Entertaining games to play with your dog",
		"biting_sometimes": "Step-by-step instructions to stop your dog from biting",
		"quick_tips": "Quick and easy tips for learning new commands",
		"potty_training_a_bit": "A special guide to effectively potty train your pup",
		"potty_training_yes": "Special guides to teach your pup new fun tricks",
		"potty_training_no": "A special guide to effectively potty train your pup",
		"success screen": "",
		"success_screen_text_1": "Thank you for your purchase!",
		"success_screen_text_2": "Follow the instructions below to set up<br />your account:",
		"success_screen_text_3": "Go to your <b>account</b>",
		"success_screen_text_4": "Scan <b>QR code</b> or tap <b>the link</b>",
		"success_screen_text_5": "<b>Download</b> the app",
		"success_screen_text_6": "<b>Open the app</b> and <b>enjoy</b><br /> training with your doggy!",
		"success_screen_text_7": "We have duplicated QR code and link to you at&nbsp;<b>example@gmail.com</b>",
		"success_screen_text_8": "If the premium account was not applied in the app, press <b>‘Contact us’</b> on the welcome screen and reach out to our support team.",
		"success_screen_text_9": "By pressing ‘Get started’ button I confirm that I have reviewed and accept the <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Privacy Policy</a> and <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Terms and Conditions</a> and I hereby agree to processing of my personal data.",
		"success_screen_text_10": "Contact us",
		"success_screen_text_11": "Go to my account",
		"success_screen_text_12": "We have sent a duplicated QR code and link to you via email.",
		"success_screen_text_13": "Your PDF guide was sent to your email <b>v.stsiopina@gmail.com</b>.",
		"success_screen_text_14": "Your PDF guide was sent to your email.",
		"success_screen_text_15": "If the premium account was not applied in the app, press <span>'Log in'</span> link on the welcome screen in the app and enter your email and the password we sent to you at <b>stepinavalerie@gmail.com</b>",
		"success_screen_text_16": "If the premium account was not applied in the app, press <span>'Log in'</span> link on the welcome screen in the app and enter your email and the password we sent to you via email",
		"payment_text_1": "Your dog training program starts now!",
		"payment_text_2": "Everydoggy app will help <span>solve any of your dog's behavior problems</span> quickly and with fun.",
		"payment_text_3": "Personal offer expires",
		"payment_text_4": " of our users notice positive changes in their dog’s behavior just 1 week after starting training with our experts",
		"payment_text_5": "EveryDoggy vs Coaches",
		"payment_text_6": "Average amount of commands per month",
		"payment_text_7": "EveryDoggy benefits",
		"payment_text_8": "Personalized dog training plan",
		"payment_text_9": "Just 15 minutes a day to a perfect pet",
		"payment_text_10": "70+ easy-to-understand video training lessons for quick results",
		"payment_text_11": "80+ games and tricks for new skills and just for fun",
		"payment_text_12": "Tips on hygiene, health and nutrition",
		"payment_text_13": "Train at home and outdoors, no equipment needed",
		"payment_text_14": "98% of our users notice positive changes in their dog’s behavior just in 1 week after starting training with our experts",
		"payment_text_14_2": "<span>98% of our users</span> notice positive changes in their dog’s behavior just in 1 week after starting training with our experts",
		"payment_text_15": "By clicking the “Get my plan” button, you agree to our <a href='https://everydoggy.com/terms/' target=\"_blank\" >Terms and Conditions</a> and <a href='https://everydoggy.com/policy/' target=\"_blank\" >Privacy Policy</a>, <b>authorize automatic renewal</b> of your subscription at the end of each billing cycle of <span>1 month</span> at the full price of <i>$29.99</i> plus applicable taxes. You may cancel automatic renewal of your subscription anytime before the renewal date. Check our <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Cancellation Terms</a> for more details.",
		"payment_text_16": "By clicking the “Get my plan” button, you agree to our <a href='https://everydoggy.com/terms/' target=\"_blank\" >Terms and Conditions</a> and <a href='https://everydoggy.com/policy/' target=\"_blank\" >Privacy Policy</a>, <b>authorize automatic renewal</b> of your subscription at the end of each billing cycle of <span>1 month</span> at the full price of <i>$29.99</i> plus applicable taxes. You may cancel automatic renewal of your subscription anytime before the renewal date. Check our <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Cancellation Terms</a> for more details.",
		"payment_text_17": "Got a question?",
		"payment_text_18": "Just write to us at ",
		"payment_text_19": "It works!",
		"payment_text_20": "Just finished the obedience training program with our puppy, I love it! 👏",
		"payment_text_21": "Fantastic!",
		"payment_text_22": "I can say I am 💯 happy with this app. No more potty issues, wow!",
		"payment_text_23": "Great app 🎉",
		"payment_text_24": "We`re on our 3rd month of training with my dog and his skills improved tremendously!",
		"payment_text_25": "Worth a try",
		"payment_text_26": "By far the best app to train a dog! ",
		"payment_text_27": "Get inspired by our users",
		"payment_text_28": " Star Focus, Inc.",
		"payment_text_29": "If you still have questions just write to us at <a href=\"mailto:welove@everydoggy.com\">welove@everydoggy.com</a>",
		"payment_text_30": "Visible results in just 7 days of training",
		"payment_text_31": "Get your personal plan<br> with special discount",
		"payment_text_32": "The earlier you start training, the better results you will achieve",
		"payment_text_33": "Training is essential for every dog. It’s not only about eliminating behavior problems but also about socialization, building a bond with your dog and expressing your love.",
		"payment_text_34": "Created from and for <span>love</span> of dogs. Based on world-class expertise",
		"payment_text_35": "Everything you’ll find in the app draws from the latest research and is absolutely dog-centric.",
		"payment_text_36": "If your dog could talk, they would ask you to try EveryDoggy!",
		"payment_text_37": "Your information is safe",
		"payment_text_38": "We won’t sell or rent your personal contact information for any marketing purposes whatsoever.",
		"payment_text_39": "Secure checkout",
		"payment_text_40": "All information is encrypted and transmitted without risk.",
		"payment_text_41": "Need help?",
		"payment_text_42": "Send us an email: <a href=\"mailto:welove@everydoggy.com\">welove@everydoggy.com</a>",
		"payment_text_43": "monthly",
		"payment_text_44": "continue",
		"payment_text_45": "Your Personalized Plan:",
		"payment_text_46": "Introductory offer discount:",
		"payment_text_47": "By continuing, you agree with the <a href='https://everydoggy.com/terms/' target='_blank' rel=\"noreferrer\">Terms & Conditions</a>, <a href='https://everydoggy.com/policy/' target='_blank' rel=\"noreferrer\">Privacy Policy</a> and <a href='https://everydoggy.com/subscription-terms/#subscription_cancellation' target='_blank' rel=\"noreferrer\">Cancellation Terms</a>",
		"payment_text_48": "Your subscription lasts until",
		"payment_text_49": "You may cancel anytime without charge at least 24 hours before the expiration of the subscription period.",
		"payment_text_50": "If you don't cancel, your membership will automatically renew at the end of your <span>1 month</span> subscription. You'll be charged EveryDoggy's membership fee of <b>$</b><i>$29.99</i> until you cancel.",
		"payment_text_51": "We don't currently offer refunds or credits for partial memberships.",
		"payment_text_52": "Personal<br>handler",
		"payment_text_53": "Dog<br>school",
		"payment_text_54": "YouTube<br>lessons",
		"payment_text_55": "Books",
		"payment_text_56": "weekly",
		"payment_text_57": "Significantly better results",
		"payment_text_58": "With EveryDoggy",
		"payment_text_59": "Without EveryDoggy",
		"payment_text_60": "Now",
		"payment_text_61": "After 1 week",
		"payment_text_62": "This is your last chance",
		"payment_text_63": "Don’t miss out on the exclusive 65% discount and discover how quickly your dog learns and obeys commands!",
		"payment_text_64": "Get 65% off",
		"payment_text_65": "52-WEEK PLAN",
		"payment_text_66": "4-WEEK PLAN",
		"payment_text_67": "12-WEEK PLAN",
		"payment_text_68": "weeks",
		"payment_text_69": "January",
		"payment_text_70": "February",
		"payment_text_71": "March",
		"payment_text_72": "April",
		"payment_text_73": "May",
		"payment_text_74": "June",
		"payment_text_75": "July",
		"payment_text_76": "August",
		"payment_text_77": "September",
		"payment_text_78": "October",
		"payment_text_79": "November",
		"payment_text_80": "December",
		"payment_text_81": "Please fill in a valid email address",
		"payment_text_82": "You will only be charged <b>$6.99</b> today for your first week (details below)",
		"payment_text_83": "Your introductory period will last until <b>Oct 11, 2024</b>.",
		"payment_text_84": "You may cancel at any time before <b>Oct 10, 2024</b>, and you will not be charged.",
		"payment_text_85": "If you don’t cancel, Everydoggy will automatically continue your membership at the end of your introductory period and charge the membership fee (currently <b>$39.99 USD</b>) <span>monthly</span> until you cancel.",
		"payment_text_86": "No partial refunds. You can cancel your subscription anytime in your Account.",
		"payment_text_87": "Your subscription will be bound by our <a href='https://everydoggy.com/terms/' target=\"_blank\" >Terms and Conditions</a>, <a href='https://everydoggy.com/policy/' target=\"_blank\" >Privacy Policy</a> and <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Cancellation Terms</a>.",
		"payment_text_88": "Payment method",
		"payment_text_89": "EveryDoggy will use your payment details for seamless future payments",
		"payment_text_90": "Easy and private payments with Face/Touch ID",
		"payment_text_91": "Keeps your financial info safe with end-to-end encryption",
		"payment_text_92": "Protected by Apple Pay’s unique Device Account Number",
		"payment_text_93": "Your payment information is secure with SSL/TLS encryption",
		"payment_text_94": "Fast, convenient payment option",
		"payment_text_95": "Backed by PayPal’s industry-leading fraud protection",
		"payment_text_96": "Confirm purchase",
		"payment_text_97": "1-WEEK",
		"payment_text_98": "1-MONTH",
		"payment_text_99": "3-MONTH",
		"payment_text_100": "You will only be charged <b>$6.99</b> today for your first month (details below)",
		"payment_text_101": "You will only be charged <b>$6.99</b> today for your first 3 months (details below)",
		"payment_text_102": "Subscribe with",
		"payment_text_103": "By clicking ‘Get my plan’ button you agree with the  <a href='https://everydoggy.com/policy/' target=\"_blank\" >Privacy Policy</a>,  <a href='https://everydoggy.com/terms/' target=\"_blank\" >Terms and Conditions</a> and <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Cancellation Terms</a>",
		"payment_text_104": "Easy and private payments",
		"payment_text_105": "Credit Card",
		"payment_text_106": "Expiry date",
		"payment_text_107": "CVC",
		"payment_text_108": "great start",
		"payment_text_109": "1-Week plan",
		"payment_text_110": "Everydoggy app will help <span>solve potty issues and any other dog's behavior problems</span> quickly and with fun.",
		"payment_text_111": "Safe checkout",
		"payment_text_112": "Personalized training plan for <span>your doggy</span>",
		"payment_text_113": "Whistle & clicker for training",
		"payment_text_114": "80+ games & tricks for your pet",
		"payment_text_115": "30+ health care tips & articles",
		"payment_text_116": "🔥 You just saved <span>$113.50&nbsp;</span>🔥",
		"payment_text_117": "7-Day plan",
		"payment_text_118": "By clicking the “Get my plan” button, you agree to our <a href='https://everydoggy.com/terms/' target=\"_blank\" >Terms and Conditions</a> and <a href='https://everydoggy.com/policy/' target=\"_blank\" >Privacy Policy</a> and <b>authorize automatic renewal</b> of your subscription. You will only be charged <span class=\"trialPrice\">$4.99</span> today for your first <span class=\"trialPeriod\">7 days</span> of introductory period. If you don’t cancel, Everydoggy will automatically continue your membership at the end of your introductory period and charge the membership fee <span class='price'>$39.99</span> every <span class='period'>month</span> until you cancel. You may cancel automatic renewal of your subscription anytime before the renewal date. Check our Cancellation Terms for more details.",
		"payment_text_119": "7 days",
		"payment_text_120": "You will only be charged <b>$29.99</b> today for your first <span>12 weeks</span> (details below)",
		"payment_text_121": "The Everydoggy app will <span>help train</span> your dog <span>to go potty</span> in the right place and <span>fix behavior issues</span> quickly and with fun.",
		"payment_text_122": "A potty-trained dog in 3 days",
		"payment_text_123": "Your account is linked to this email and can't be changed",
		"payment_text_124": "By continuing, you agree to our <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Terms and Conditions</a> and <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Privacy Policy</a> and <span>authorize automatic renewal</span> of your subscription.",
		"payment_text_125": "26-WEEK PLAN",
		"payment_text_126": "If you don’t cancel, Everydoggy will automatically continue your membership at the end of your introductory period and charge the membership fee (currently <b>$39.99 USD</b>) <span>every 3 months</span> until you cancel.",
		"payment_text_127": "If you don’t cancel, Everydoggy will automatically continue your membership at the end of your introductory period and charge the membership fee (currently <b>$39.99 USD</b>) <span>every 6 months</span> until you cancel.",
		"payment_text_128": "Current level",
		"payment_text_129": "commands",
		"payment_text_130": "Goal",
		"payment_text_131": "50+ commands & obedience",
		"payment_text_132": "Experience noticeable progress",
		"payment_text_133": "Achieve obedience",
		"payment_text_134": "Keep your dog well-trained for life",
		"payment_text_135": "Save 53%",
		"payment_text_136": "Money-back Guarantee",
		"payment_text_137": "30-Day Money-Back Guarantee",
		"payment_text_138": "We believe that our plan may work for you and you'll get visible results in 4 weeks! We even are ready to return your money back if you don't see visible results and can demonstrate that you followed our plan.",
		"payment_text_139": "Find more about applicable limitations in our <a href=\"https://everydoggy.com/terms/#section5_2\" target=\"_blank\" rel=\"noreferrer\">terms of use</a>.",
		"payment_text_140": "Save 65%",
		"payment_text_141": "Your Dog Training Plan is ready!",
		"payment_text_142": "Obedience",
		"payment_text_143": "Knows Commands",
		"payment_text_144": "Toilet Accidents",
		"payment_text_145": "Frequent",
		"payment_text_146": "None",
		"payment_text_147": "Barking",
		"payment_text_148": "Barks at everything",
		"payment_text_149": "Quiet & Relaxed",
		"payment_text_150": "Biting & chewing",
		"payment_text_151": "Often",
		"payment_text_152": "Stopped",
		"payment_text_153": "Pulling the leash",
		"payment_text_154": "Always",
		"payment_text_155": "Walks calmly",
		"payment_text_156": "Anxiety When Left Alone",
		"payment_text_157": "Calm and independent",
		"payment_text_158": "Before",
		"payment_text_159": "After",
		"payment_text_160": "minutes",
		"payment_text_161": "seconds",
		"payment_text_162": "Proven. Tested. It Works",
		"payment_text_163": "Significant changes in a dog’s obedience",
		"payment_text_164": "Today",
		"payment_text_165": "Week 2",
		"payment_text_166": "Week 3",
		"payment_text_167": "Week 4",
		"payment_text_168": "What makes Everydoggy so effective",
		"payment_text_169": "Our users' success stories",
		"payment_text_170": "Crafted by Experts Who <span>Love Dogs</span>",
		"payment_text_171": "Every our course and lesson is grounded in scientific studies of dog training.",
		"payment_text_172": "Build a strong bond with your dog, try EveryDoggy!",
		"payment_text_173": "Proven. Tested. It Works",
		"payment_text_174": "<span>93% of our users</span> notice significant changes in their dog’s behavior within the first month of training.",
		"payment_text_175": "With EveryDoggy",
		"payment_text_176": "Without EveryDoggy",
		"payment_text_177": "Today",
		"payment_text_178": "Week 2",
		"payment_text_179": "Week 4",
		"payment_text_180": "Week 6",
		"payment_text_181": "About Luna",
		"payment_text_182": "My puppy kept having accidents in the house. Everydoggy gave us a clear routine, and it actually worked!",
		"payment_text_183": "About Cooper",
		"payment_text_184": "Our pup used to nip at everyone during playtime. The app gave us step-by-step guidance, and it worked!",
		"payment_text_185": "About Bella",
		"payment_text_186": "Our dog chewed everything – from shoes to the couch. The app helped us redirect that energy!",
		"payment_text_187": "About Charlie",
		"payment_text_188": "Leash pulling was a daily struggle. Thanks to the app, walks are now enjoyable and stress-free.",
		"payment_text_189": "Potty trained",
		"payment_text_190": "Solved biting",
		"payment_text_191": "Chewing solved",
		"payment_text_192": "Leash pulling solved",
		"payment_text_193": "<span>93% of our users</span> notice significant changes in their <span>dog's behavior & obedience</span> within the first month of training.</span>",
		"payment_text_194": "Our users are amazed by the results!",
		"payment_text_195": "Start training with your dog now!",
		"payment_text_196": "If you don’t cancel, Everydoggy will automatically continue your membership at the end of your introductory period and charge the membership fee (currently <b>$39.99 USD</b>) <span>biweekly</span> until you cancel.",
		"payment_text_197": "Money-back Guarantee",
		"payment_text_198": "30-Day Money-Back Guarantee",
		"payment_text_199": "We believe that our plan may work for you and you'll get visible results in 4 weeks! We even are ready to return your money back if you don't see visible results and can demonstrate that you followed our plan.",
		"payment_text_200": "Find more about applicable limitations in our <a href=\"https://everydoggy.com/terms/#section5_2\" target=\"_blank\">terms of use</a>.",
		"payment_text_201": "People often ask",
		"payment_text_202": "How long will it take to see results from training?",
		"payment_text_203": "Most dogs show progress after the very first session – and within a couple of weeks, you’ll see impressive, significant results!",
		"payment_text_204": "Is Everydoggy app as effective as working with a trainer?",
		"payment_text_205": "Yes and even more effective – you can train every day at your own pace, follow clear step-by-step lessons, and reinforce skills consistently, not just once a week with a trainer.",
		"payment_text_206": "Are training results permanent?",
		"payment_text_207": "Yes! As long as you keep reinforcing good habits, the results last a lifetime.",
		"payment_text_208": "Get 72% off",
		"payment_text_209": "Don’t miss out on the exclusive 72% discount and discover how quickly your dog learns and obeys commands!",
		"payment_text_210": "Continue with another payment method",
		"payment_text_211": "Buy with",
		"payment_text_212": "BARK FRIDAY SALE!",
		"payment_text_213": "FREE Bonus",
		"payment_text_214": "Puppy Essentials<br/>Checklists",
		"payment_text_215": "Puppy-Proof Your Home",
		"payment_text_216": "The Ultimate Puppy Starter Kit",
		"payment_text_217": "Free Bonus: Puppy Essentials Checklists",
		"payment_text_218": "Your puppy training program starts now!",
		"payment_text_219": "Train with Everydoggy app from <span>your puppy’s earliest days</span> and get a <span>perfectly well-behaved dog</span>!",
		"payment_text_220": "of our users notice positive changes in their puppy’s behavior just 1 week after starting training with our experts",
		"payment_text_221": "Personalized training plan for puppies under 6 months",
		"payment_text_222": "Personalized training plan for puppies aged 6-12 months",
		"payment_text_223": "Proven with 3 Million Puppies",
		"payment_text_224": "Significant changes in a dog’s obedience",
		"payment_text_225": "Get 70% off",
		"payment_text_226": "LAST CHANCE!",
		"payment_text_227": "24-WEEK PLAN",
		"payment_text_228": "The last dog training you’ll ever need starts now!",
		"payment_text_229": "Personalized dog training plan for lifelong results",
		"payment_text_230": "One program.<br />\nA lifetime of good behavior",
		"payment_text_231": "Dog’s Age",
		"payment_text_232": "Training time",
		"payment_text_233": "Lifetime results",
		"payment_text_234": "0-1 years",
		"payment_text_235": "1-3 years",
		"payment_text_236": "3-5 years",
		"payment_text_237": "5+ years",
		"payment_text_238": "1-2 years",
		"payment_text_239": "3 years",
		"payment_text_240": "4 years",
		"payment_text_241": "2-7 years",
		"payment_text_242": "8 years",
		"payment_text_243": "9 years",
		"payment_text_244": "10+ years",
		"payment_text_245": "Boost Your<br />Puppy’s Progress",
		"payment_text_246": "Add smart bundles to support <span>health, learning</span>, and <span>steady progress</span>",
		"payment_text_247": "Play & Clean Kit",
		"payment_text_248": "Play & Chew Toy",
		"payment_text_249": "Quick-Dry Towel",
		"payment_text_250": "Potty Training Kit",
		"payment_text_251": "Absorbent Puppy Pads",
		"payment_text_252": "Poop Bags",
		"payment_text_253": "Training Essentials Kit",
		"payment_text_254": "Training Clicker",
		"payment_text_255": "Mini Fetch Ball",
		"payment_text_256": "Selected items",
		"payment_text_257": "Pay now",
		"payment_text_258": "Out of stock",
		"payment_text_259": "This kit is temporarily unavailable 😔",
		"payment_text_260": "Subscribe to get notified the moment it’s back in stock – we’ll reach out within 24 hours!",
		"payment_text_261": "We process your personal data as described in our <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Privacy Policy</a>, and do not share your sensitive data with third parties.",
		"payment_text_262": "Subscribe",
		"payment_text_263": "Dog Translator ",
		"payment_text_264": "Understand Your Dog.<br/> See the Results",
		"payment_text_265": "Obedience improves with signal and behavior analysis",
		"payment_text_266": "Personalized dog training plan powered by analysis of your dog’s barking and behavior",
		"payment_text_267": "Double the Speed, <br />Double the Fun!",
		"payment_text_268": "Get the Ultimate Puppy Training Guide",
		"payment_text_269": "Get the Ultimate Dog Training Guide",
		"payment_text_270": "Say goodbye to accidents! Step-by-step methods to teach your dog proper potty habits fast.",
		"payment_text_271": "Save your shoes and fingers! Turn your pup into a gentle companion with easy techniques to stop unwanted biting and chewing.",
		"payment_text_272": "Create a safe, happy space for your dog while teaching calm and confident crate behavior.",
		"payment_text_273": "Unlock a full toolkit of expert tricks for behavior, obedience and daily life with your dog.",
		"payment_text_274": "End unwanted behaviors at home and on walks with proven, easy-to-follow techniques.",
		"payment_text_275": "Make learning fun! Master the art of praise and rewards to motivate your dog instantly.",
		"payment_text_276": "Teach your dog more than the basics! From essential safety commands to fun and impressive tricks for dogs of all ages.",
		"payment_text_277": "Boost your dog's<br /> progress <span>2x!</span>",
		"payment_text_278": "Practical guide:",
		"payment_text_279": "98% OFF Members-only discount",
		"payment_text_280": "70% OFF Members-only discount",
		"payment_text_281": "Your dog vet care program starts now!",
		"payment_text_282": "Take care of your dog’s health with <span>expert vet support</span> from Everydoggy and <span>raise a healthy, well-behaved dog</span> with less worry!",
		"payment_text_283": "Instant vet chat support – no appointments, no delays",
		"payment_text_284": "Share photos to get more accurate guidance",
		"payment_text_285": "Learn first aid for emergencies like heatstroke, injuries, or frostbite",
		"payment_text_286": "Stay on track with up-to-date vaccination and checkup schedules",
		"payment_text_287": "Get care tips for teeth, ears, eyes, nails, deworming, and more",
		"payment_text_288": "Feel confident about your dog’s health and worry less every day",
		"payment_text_289": "What makes Everydoggy VET so effective",
		"payment_text_290": "Trusted by 3M+ Dog Owners",
		"payment_text_291": "Chat anytime with vet support you can count on",
		"payment_text_292": "Train your dog with Everydoggy app and enjoy a <span>perfectly well-behaved companion</span>!",
		"payment_text_293": "Proven with 3 Million Dogs",
		"payment_text_294": "Personalized training plan tailored to your dog",
		"payment_text_295": "When my puppy had diarrhea, I got quick advice from a vet and knew exactly how to handle it. It saved me a lot of stress.",
		"payment_text_296": "The advice is clear and reliable. I feel like I always have a professional I can trust.",
		"payment_text_297": "I used it when my dog had skin irritation and constant scratching. The guidance was clear, and I felt reassured right away.",
		"payment_text_298": "As a new puppy owner, this has been incredibly useful. I don’t have to guess anymore.",
		"payment_text_299": "of our users feel more confident about their dog’s health and worry less with our vet support",
		"payment_text_300": "<span>98% of our users</span> feel more confident about their dog’s health and worry less with our vet support",
		"payment_text_301": "Your personalized Play & Talk Program starts now!",
		"payment_text_302": "With Everydoggy, you’ll <span>understand your dog</span>, have more <span>fun together</span>, and build a <span>lasting bond</span>!",
		"payment_text_303": "3+ million users",
		"payment_text_304": "Enjoy life with their dogs to the fullest",
		"payment_text_305": "Now",
		"payment_text_306": "Understanding your dog",
		"payment_text_307": "Communication with your dog",
		"payment_text_308": "Play enjoyment",
		"payment_text_309": "Connection",
		"payment_text_310": "Personalized program for communication and play with your dog",
		"payment_text_311": "Translate and understand your dog’s barking with Bark AI",
		"payment_text_312": "🎁 Your welcome discount applied:",
		"payment_text_313": "<span>53%</span> OFF",
		"payment_text_314": "Your personalized dog training program starts now!",
		"payment_text_315": "See fast results and enjoy life with a well-behaved dog!",
		"payment_text_316": "Commands learned:",
		"payment_text_317": "Obedience level:",
		"payment_text_318": "Low",
		"payment_text_319": "High",
		"payment_text_320": "Personalized training program for <span>Your dog</span> is ready!",
		"payment_text_321": "Training profile",
		"payment_text_322": "Dog’s breed",
		"payment_text_323": "Age",
		"payment_text_324": "Behavior issues",
		"payment_text_325": "Current level",
		"payment_text_326": "3+ million",
		"payment_text_327": "dog owners are already enjoying results",
		"payment_text_328": "Ashley K. & Moly",
		"payment_text_329": "I love how simple the daily training tasks are. My dog actually listens now!",
		"payment_text_330": "Kevin R. & Tommy",
		"payment_text_331": "Potty training was our biggest struggle. This program was the only thing that actually worked.",
		"payment_text_332": "Chloe N. & Ami",
		"payment_text_333": "My puppy used to chew everything. Now he only goes for his toys!",
		"payment_text_334": "Daniel H. & Cherry",
		"payment_text_335": "I liked that everything is divided into small steps. My dog learned commands faster than expected.",
		"payment_text_336": "Your stress-free puppy training plan starts now!",
		"payment_text_337": "Your stress-free dog training plan starts now!",
		"payment_text_338": "Your personalized dog nutrition & health plan starts now!",
		"payment_text_339": "Scan dog food labels, get expert nutrition advice and keep your dog <span>healthy and happy</span>!",
		"payment_text_340": "Scan Food Labels. Protect Your Dog’s Health",
		"payment_text_341": "Scan dog food labels and quickly understand ingredients and quality",
		"payment_text_342": "Get tailored feeding advice for your dog’s needs",
		"payment_text_343": "The food label scanner is a game changer. I instantly know what’s really in my dog’s food.",
		"payment_text_344": "Great tool for tracking health and improving my dog’s diet. Noticeable results!",
		"payment_text_345": "This app made my dog’s nutrition so much easier to manage. I love the personalized tips!",
		"payment_text_346": "It’s like I’ve learned my dog’s language – even the barking makes sense now.",
		"payment_text_347": "The games are amazing. My dog is excited every single time!",
		"payment_text_348": "We play, we connect, and I finally understand what my dog is saying!",
		"payment_text_349": "of our users feel more confident about their dog’s health and worry less with our app",
		"payment_text_350": "What makes Everydoggy  so effective",
		"payment_text_351": "<span>98% of our users</span> feel more confident about their dog’s health and worry less with our plan",
		"payment_text_352": "Trainee",
		"payment_text_353": "Your personalized small dog training program starts now!",
		"payment_text_354": "Your personalized K9 dog training program starts now!",
		"payment_text_355": "See fast results and get a dog that listens on the first command!",
		"payment_text_356": "Huge difference in just a few weeks. My dog finally listens the first time.",
		"payment_text_357": "Walking my dog is no longer stressful. Total control now.",
		"payment_text_358": "We went from chaos to calm behavior really fast. Amazing program.",
		"payment_text_359": "First-command obedience actually works. I didn’t think it was possible.",
		"payment_text_360": "Personalized K9 dog training plan",
		"payment_text_361": "Wellness Special",
		"payment_text_362": "Boost Your Dog&apos;s Training Journey with <span>41% Off</span>",
		"payment_text_363": "Add premium supplements to help keep your dog healthy and engaged during training",
		"payment_text_364": "Add",
		"payment_text_365": "Selected items",
		"payment_text_366": "Shipping",
		"payment_text_367": "Total",
		"payment_text_368": "Pay now",
		"payment_text_369": "Out of stock",
		"payment_text_370": "These supplements are temporarily unavailable 😔",
		"payment_text_371": "Subscribe to get notified the moment it&apos;s back in stock – we&apos;ll reach out within 24 hours!",
		"payment_text_372": "Subscribe",
		"payment_text_373": "Joint Health & Mobility",
		"payment_text_374": "Capsules",
		"payment_text_375": "4.9 (186 reviews)",
		"payment_text_376": "Supports healthy joints and mobility for everyday movement and play",
		"payment_text_377": "Gut & Digestive Health",
		"payment_text_378": "4.8 (109 reviews)",
		"payment_text_379": "Supports digestive health and a balanced gut microbiome",
		"payment_text_380": "Tooth Health",
		"payment_text_381": "Dental Chews",
		"payment_text_382": "4.8 (93 reviews)",
		"payment_text_383": "Supports clean teeth, healthy gums, and fresher breath every day",
		"payment_text_384": "<span>Kickstart your journey to an obedient dog:</span> Grab an ultimate K9 guide to reactivity",
		"payment_text_385": "Unlock the <span>K9 Reactivity Field Manual</span>",
		"payment_text_386": "Get your dog to listen around triggers",
		"payment_text_387": "Stop reactions before they escalate",
		"payment_text_388": "Regain control when your dog loses it",
		"payment_text_389": "Handle dogs, people, runners & cars with confidence",
		"pdfUpselling": "",
		"pdfUpselling_1": "<span>Kickstart your journey to an obedient dog:</span> Grab an ultimate guide to dog raising training",
		"pdfUpselling_2": "<span>Kickstart your journey to an obedient dog:</span> Grab an ultimate guide to puppy raising and training",
		"pdfUpselling_3": "Get your <span>personal plan</span>",
		"pdfUpselling_4": "Unlock the <span>practical guide</span>",
		"pdfUpselling_5": "Behavior correction (indoors & outdoors)",
		"pdfUpselling_6": "How to praise and reward your dog",
		"pdfUpselling_7": "Various commands",
		"pdfUpselling_8": "Enrichment games & much more",
		"pdfUpselling_9": "Potty training",
		"pdfUpselling_10": "Stop biting & chewing",
		"pdfUpselling_11": "Crate training",
		"pdfUpselling_12": "Plus 43 other helpful tips and solutions",
		"pdfUpselling_13": "Total today",
		"pdfUpselling_14": "Unlock guide",
		"pdfUpselling_15": "Unlock with",
		"pdfUpselling_16": "Continue without guide",
		"chatUpsale_1": "Dog trainer chat",
		"chatUpsale_2": "Describe dog's behavior. <br/>The solution is on us",
		"chatUpsale_3": "Chat with our real human Dog Trainer Experts without limitations",
		"chatUpsale_4": "Get more than you expect out of Everydoggy!",
		"chatUpsale_5": "Boost ×2",
		"chatUpsale_6": "EveryDoggy plan",
		"chatUpsale_7": "Dog trainer chat",
		"chatUpsale_8": "Training on your own",
		"chatUpsale_9": "UNLIMITED ACCESS",
		"chatUpsale_10": "Boost results with Expert Trainer Chat!",
		"chatUpsale_11": "chat access",
		"chatUpsale_12": "30-Day",
		"chatUpsale_13": "90-Day",
		"chatUpsale_14": "Continue without dog trainer chat",
		"chatUpsale_15": "Dog trainer chat unlimited access",
		"checkoutV2_text1": "total",
		"checkoutV2_text2": "Easy and private payments with Face/Touch ID",
		"checkoutV2_text3": "Keeps your financial info safe with end-to-end encryption",
		"checkoutV2_text4": "Protected by Apple Pay’s unique Device Account Number",
		"checkoutV2_text5": "Fast, convenient payment option",
		"checkoutV2_text6": "Keeps your financial info safe with ent-to-end encryption",
		"checkoutV2_text7": "Backed by PayPal’s industry-leading fraud protection",
		"checkoutV2_text8": "Money-back Guarantee",
		"checkoutV2_text9": "Checkout",
		"checkoutV2_text10": "Payment information",
		"checkoutV2_text11": "Protected",
		"error_1": "Payment declined. Please check card details and try again.",
		"error_2": "Payment declined. Please check card details and try again.",
		"error_3": "Insufficient funds. Please try another card or payment method.",
		"error_4": "Your card has expired. Please try another card or payment method.",
		"error_5": "An error occurred while processing your card. Please try again.",
		"error_6": "Security code is incorrect. Please check card details and try again.",
		"error_7": "American Express cards are not supported at this time. Please try another card or payment method.",
		"error_8": "Payment declined. Please check card details and try again.",
		"error_9": "Payment declined. This email is already associated with an active subscription.",
		"error_10": "Payment declined. Too many attempts or card limit exceeded. Please try again later.",
		"disclaimerV2_text_1": "By continuing, you agree to our <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Terms and Conditions</a> and <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Privacy Policy</a> and authorize automatic renewal of your subscription. You will only be charged <span class=\"price1\">$1.99</span> today for your first week. If you don’t cancel, Everydoggy will automatically continue your membership at the end of your introductory period and \ncharge the membership fee (currently <span class=\"price2\">$29.99</span>) every 2 weeks until you cancel.",
		"disclaimerV2_text_2": "By continuing, you agree to our <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Terms and Conditions</a> and <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Privacy Policy</a> and authorize automatic renewal of your subscription.\nYou will only be charged <span class=\"price1\">$6.99</span> today for your first 4 weeks. \nIf you don’t cancel, Everydoggy will automatically continue your membership at the end of your introductory period and \ncharge the membership fee (currently <span class=\"price2\">$29.99</span>) every 2 weeks until you cancel.",
		"disclaimerV2_text_3": "By continuing, you agree to our <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Terms and Conditions</a> and <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Privacy Policy</a> and authorize automatic renewal of your subscription.\nYou will only be charged <span class=\"price1\">$14.99</span> today for your first 12 weeks. \nIf you don’t cancel, Everydoggy will automatically continue your membership at the end of your introductory period and \ncharge the membership fee (currently <span class=\"price2\">$49.99</span>) every 4 weeks until you cancel.",
		"chatUpsaleV2_1": "Dog trainer chat",
		"chatUpsaleV2_2": "Train With a Dog Behavior Expert",
		"chatUpsaleV2_3": "Add unlimited chat support from experienced dog trainers to your plan",
		"chatUpsaleV2_4": "With trainer",
		"chatUpsaleV2_5": "Efficiency",
		"chatUpsaleV2_6": "Clear answers from a real expert",
		"chatUpsaleV2_7": "Personalized advice for your dog",
		"chatUpsaleV2_8": "Faster results with fewer mistakes",
		"chatUpsaleV2_9": "Calm, confident training process",
		"chatUpsaleV2_10": "Without trainer",
		"chatUpsaleV2_11": "Guessing if you’re doing it right",
		"chatUpsaleV2_12": "Slow progress and repeated mistakes",
		"chatUpsaleV2_13": "Unclear reasons behind bad behavior",
		"chatUpsaleV2_14": "Frustration for you and your dog",
		"chatUpsaleV2_15": "Every dog is different. Get expert help for yours!",
		"chatUpsaleV2_16": "Get answers to even the toughest dog behavior questions",
		"chatUpsaleV2_17": "Receive both emotional and hands-on training help",
		"chatUpsaleV2_18": "Reduce stress and frustration in training",
		"chatUpsaleV2_19": "Enjoy personalized guidance tailored to you and your dog",
		"chatUpsaleV2_20": "Achieve Professional Support for Maximum Results",
		"chatUpsaleV2_21": "Limited Spots",
		"chatUpsaleV2_22": "Exclusive spots left",
		"chatUpsaleV2_23": "4-week expert dog trainer chat access:",
		"chatUpsaleV2_24": "Limited extra 75% discount:",
		"chatUpsaleV2_25": "Total",
		"chatUpsaleV2_26": "Get Expert Help Now",
		"chatUpsaleV2_27": "Continue without dog trainer chat",
		"chatUpsaleV2_28": "Can I ask any question about my dog?",
		"chatUpsaleV2_29": "Yes! You can ask about behavior, training, puppy issues, or specific challenges you’re facing.",
		"chatUpsaleV2_30": "How quickly will I get a reply?",
		"chatUpsaleV2_31": "Our experienced trainers typically respond within 24 hours on weekdays.",
		"chatUpsaleV2_32": "Do I need previous training experience?",
		"chatUpsaleV2_33": "Not at all. Our trainers guide you step by step, whether you’re a beginner or experienced owner."
	},
	"ru": {
		"global \ninstruction": "",
		"safe": "Ваши данные в безопасности",
		"information": "Мы не будем продавать или сдавать в аренду вашу личную контактную информацию для каких-либо маркетинговых целей.",
		"secure_checkout": "Безопасная проверка",
		"encrypted": "Вся информация зашифрована и передается без риска с использованием протокола SSL (Secure Sockets Layer).",
		"help": "Нужна помощь?",
		"contact": "Свяжитесь с нами",
		"here": "здесь.",
		"undefined": "",
		"featured": "Как показано в",
		"main_title": "Курсы дрессировки собак",
		"per_year": "в год",
		"special_offer": "Специальное предложение",
		"card_number": "Номер карты",
		"card_expiry": "Срок действия карты истекает",
		"security_number": "Номер безопасности",
		"email": "Электронная почта",
		"To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of __period__ and at the full, not discounted, price of __fullPriceText__ To learn more visit our <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">terms of use</a>.": "Информация о платеже",
		"secure_server": "Безопасный сервер",
		"pay": "Оплатить",
		"enter_your_email": "Введите вашу электронную почту",
		"comment_1": "В течение нескольких стрессовых лет я полностью потерял форму и набрал лишний вес, но у меня не было ни времени, ни мотивации что-либо с этим делать. Один из членов семьи посоветовал Верв, и теперь я ежедневно полагусь на своего тренера!",
		"comment_2": "Verv заставил меня полюбить домашние тренировки, и за месяц я потерял 7 кг. Это приложение действительно может помочь вам в тренировках и снижении веса, если вы новичок, как и я.",
		"success_story": "История успеха",
		"get_my_plan": "ПОЛУЧИТЬ МОЙ ПЛАН",
		"delimiter": "или",
		"pay_buy_card": "Оплатить картой",
		"get_my_plan_warning_1": "Чтобы избежать перебоев, вы соглашаетесь с тем, что выбранная вами подписка будет автоматически продлена на следующий срок",
		"get_my_plan_warning_2": "и по полной, не_discounted цене",
		"get_my_plan_warning_3": "Чтобы узнать больше, посетите наш",
		"get_my_plan_warning_text": "Продолжая, вы соглашаетесь с тем, что если вы не отмените подписку как минимум за 24 часа до конца первого периода продления, с вас автоматически будет взиматься полная цена __fullPriceText__ каждые __period__ до тех пор, пока вы не отмените подписку.",
		"terms_of_use": "Условия использования",
		"privacy_policy": "Политика конфиденциальности",
		"terms_conditions": "Условия и положения",
		"privacy_policy_footer": "Политика конфиденциальности",
		"terms_conditions_footer": "Условия и положения",
		"guaranteed": "Гарантированно безопасная покупка",
		"special_features": "Специальные функции для вас",
		"calories_value": "ккал",
		"personalized_plan": "Получите ваш персонализированный план:",
		"mobile_app": "Мобильное приложение с вашим планом",
		"daily_programs": "Ежедневные программы для разных целей (снижение жира, уменьшение стресса, наращивание мышц)",
		"audio_guided": "Аудио-гидированные тренировки",
		"easy_to_cook": "Легкие в приготовлении и вкусные блюда",
		"comprehensive_stats": "Подробная статистика",
		"secret_tips": "Секретные советы по развитию здоровых привычек",
		"mobile_app_tailor": "Индивидуальный план у вас в кармане",
		"daily_programs_for": "Ежедневные программы",
		"daily_programs_for_2": "Для различных целей (сжигание жира, снижение стресса, набор мышечной массы)",
		"audio_trainers": "Профессиональные тренеры",
		"comprehensive_track": "Отслеживайте свой прогресс с помощью окончательной статистики",
		"price": "Цена",
		"users_love": "Пользователи любят наш Персонализированный План",
		"alternative_review_name_1": "Therealtierra",
		"alternative_review_title_1": "Отличное приложение!",
		"alternative_review_contentent_1": "Я на девятой неделе, и моё тело изменилось невероятно!",
		"alternative_review_name_2": "теннисная девушка",
		"alternative_review_title_2": "Это работает!",
		"alternative_review_contentent_2": "Только что завершил программу. Мне это нравится. Сбросил 15 кг!!",
		"you_re_in": "Вы внутри!",
		"personal_plan_starts": "Ваш личный план Verv начинается сегодня, и время идет. Так что ознакомьтесь с ним!",
		"app_by_link": "Чтобы перейти к вашей программе, скачайте приложение по ссылке",
		"download_now": "Скачайте сейчас",
		"or": "или",
		"price_after_trial": "Цена послеTrial",
		"seven_days_trial_unlocked": "7-дневная пробная версия разблокирована",
		"total_today": "Всего сегодня",
		"reserved_price_for": "Резервная цена для",
		"new_subscritions1_title": "Выберите свой план",
		"new_subscritions1_subscription1_line1": "Полугодовой план",
		"new_subscritions1_subscription1_price1_time": "в неделю",
		"new_subscritions1_subscription2_line1": "3-месячный план",
		"new_subscritions1_subscription2_price2_time": "в неделю",
		"new_subscritions1_subscription3_line1": "1-месячный план",
		"new_subscritions1_subscription3_price3_time": "в неделю",
		"new_subscription_save": "СОХРАНИТЬ",
		"new_subscritions_agreement": "Продолжая, вы соглашаетесь с",
		"new_subscritions_and": "и",
		"new_subscritions_subtitle": "Наши пользователи потеряли 10 миллионов фунтов",
		"new_subscritions_join": "Присоединяйтесь к миллионам наших довольных пользователей",
		"statistic_block_item1_text": "Звёзды из 5",
		"statistic_block_item2_text": "5-звездочные оценки",
		"statistic_block_item3_text": "скачивания",
		"get_your_personalized_plan": "Получите ваш персонализированный план",
		"for": "для",
		"new_subscription_save_mostPopular1MonthPrice": "самый популярный план",
		"timer_additional_discount": "Дополнительная скидка применена только что ",
		"timer_additional_discount_bold": "для вас",
		"timer_offer_expires": "Это предложение истекает через:",
		"Payment Successful": "",
		"payment_successful_title": "Привет от команды Verv!",
		"payment_successful_download": "Скачайте приложение",
		"payment_successful_press": "Нажмите",
		"payment_successful_login": "Войдите с помощью электронной почты",
		"payment_successful_email": "Введите ваш электронный адрес",
		"payment_successful_code": "и ваш код подтверждения:",
		"payment_successful_hit": "Затем нажмите",
		"payment_successful_done": "Готово",
		"payment_successful_description": "Вы в системе, наслаждайтесь своим персонализированным планом тренировок!",
		"Tariffs Variants": "",
		"tariff_title_choose": "Выберите ваш план",
		"tariff_title_get": "Получите свой план",
		"tariff_one_month": "1-месячный план",
		"tariff_three_month": "3-месячный план",
		"tariff_six_month": "6-месячный план",
		"tariff_one_year": "1-летний план",
		"tariff_one_week": "План на 1 неделю",
		"tariff_three_day": "3-дневный план",
		"tariff_per_year": "в год",
		"tariff_per_day": "в день",
		"tariff_per_days": "каждые 3 дня",
		"tariff_per_week": "в неделю",
		"tariff_week": "неделя",
		"tariff_annual": "Годовой план",
		"tariff_trial_one_week": "1-недельный пробный период",
		"tariff_after": "после ",
		"tariff_save": "Сохранить",
		"tariff_best_offer": "лучшее предложение",
		"tariff_most_popular": "самый популярный",
		"tariff_limited_promo": "ограниченная цена акций",
		"tariff_6_for_3": "6 по цене 3",
		"tariff_first_month": "первый месяц",
		"tariff_first_week": "первую неделю",
		"tariff_monthly": "ежемесячный",
		"tariff_quaterly": "ежеквартально",
		"tariff_semiannually": "полугодично",
		"tariff_billed_every ": "выставлено счетов каждую ",
		"tariff_year": "год",
		"tariff_month": "месяц",
		"tariff_months": "месяцы",
		"tariff_months_variable": "месяцы",
		"tariff_organic_gift": "План медитации",
		"tariff_full_price": "Полная цена",
		"tariff_no_hidden_fees": "Без скрытых платежей",
		"tariff_start_right_now": "Начать прямо сейчас",
		"tariff_more_than": "Более 1 000 000 активных участников семьи Verv",
		"tariff_intro_offer": "ПРЕДЛОЖЕНИЕ ДЛЯ НОВЫХ КЛИЕНТОВ",
		"Тарифы плиткой в ряд": "",
		"": "",
		"Checkout": "",
		"checkout_title": "Выберите метод оплаты",
		"insufficient_funds": "Недостаточно средств",
		"insufficient_we_have": "У нас есть",
		"insufficient_special_price": "специальная цена",
		"insufficient_for_you": "для вас",
		"checkout_edit_card": "Редактировать карту",
		"checkout_pay_via": "Оплатить через",
		"checkout_paypal": "PayPal",
		"checkout_credit_card": "Кредитная карта",
		"checkout_paypal_description": "Ваш платеж будет обработан через PayPal",
		"checkout_total_price": "Общая цена",
		"checkout_warning_1": "Чтобы избежать любых сбоев, вы соглашаетесь, что выбранная вами подписка автоматически продлится на следующий период продления",
		"checkout_warning_2": "и по полной, не со скидкой, цене",
		"checkout_warning_3": "Чтобы узнать больше, посетите наш",
		"spv2_warning": "Чтобы избежать каких-либо перерывов, вы соглашаетесь, что выбранная вами подписка будет автоматически продлена на следующий период __________ и по полной цене, а не со скидкой, __________. Узнать больше можно в наших <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">условиях использования</a>.",
		"checkout_offer_day_for": "день для",
		"checkout_offer_days_for": "дни для",
		"checkout_offer_month_for": "месяц для",
		"checkout_offer_months_for": "месяцы для",
		"checkout_offer_week_for": "неделя для",
		"Values": "",
		"value_kg": "кг",
		"value_pounds": "фунт",
		"value_st": "ст",
		"value_g": "г",
		"value_kcal": "ккал",
		"value_min": "мин",
		"value_min_cooking": "мин готовки",
		"welcome_title": "Добро пожаловать в Verv Premium!",
		"item_1_title": "Ура!",
		"item_1_description": "Ваш целевой вес в __weight__ теперь совсем близко.",
		"item_2_title": "Как активировать",
		"item_2_description": "Скачайте приложение, используя ссылку ниже, введите свою электронную почту __mail__ и введите этот код подтверждения: __code__.",
		"item_2_description_2": "Чтобы изменить электронную почту, нажмите <button id=\"changeMail\">здесь</button>.",
		"item_3_title": "Что-то пошло не так?",
		"item_3_description": "Подробная инструкция была отправлена на вашу электронную почту. Если вы не получили ее, свяжитесь с <a target=\"_blank\" href=\"mailto:support@verv.com?subject=Проблема с входом (simple-login)\">поддержкой</a>.",
		"change": "Подтвердить",
		"change_mail": "Измените свой адрес электронной почты здесь, чтобы активировать Premium",
		"email_warning": "Пожалуйста, введите действующий адрес электронной почты",
		"Promo Code Block": "",
		"promo_code_title": "Промо-код применен!",
		"promo_code_save": "% скидка",
		"EveryDoggy": "",
		"dog_courses": "курсы для собак",
		"why_we_best_active": "Активные пользователи.",
		"why_we_best_lessons": "Видеоуроки.",
		"why_we_best_brain": "Игры для ума.",
		"why_we_best": "Почему мы лучшие?",
		"why_we_best_join": "Присоединяйтесь к нашему сообществу владельцев собак и делайте все возможное с EveryDoggy.",
		"why_we_best_enjoy": "Наслаждайтесь вашим персонализированным планом тренировок, разработанным с учетом ваших и целей вашего пса.",
		"why_we_best_keep": "Держите свою собаку умственно и физически активной с помощью более 70 игр для ума.",
		"dog_problems": "Быстрые решения для поведенческих проблем",
		"dog_problems_choose": "Выберите нежелательные поведения, которые вы хотели бы улучшить",
		"dog_problems_leash": "Поводок<br/>тянет",
		"dog_problems_biting": "Укус",
		"dog_problems_anxiety": "Тревога при разлуке<br/>",
		"dog_problems_chewing": "Разрушающее<br/>жевание",
		"dog_plan": "Персонализированный план тренировок",
		"dog_plan_our": "Наша программа тренировок на 100% соответствует потребностям вашей собаки.",
		"dog_reviews": "Что говорят владельцы собак о EveryDoggy",
		"dog_reviews_text_1": "«Очень понятные и легкие для восприятия уроки. Моему щенку нравится тренироваться, и мы оба многому научились.»",
		"dog_reviews_name_1": "Мegan и Лео",
		"dog_reviews_text_2": "Команда «Зен» творит чудеса. Благодаря ей, моя собака в ветеринарной клинике во время процедур супер-спокойна.",
		"dog_reviews_name_2": "Линда Б.",
		"dog_reviews_text_3": "«Спасибо за урок по кликер-тренировке. Я слышал, что это очень популярно, но было неясно, как его использовать. Я быстро познакомил свою собаку с кликером, и теперь мы начали учиться трюкам.»",
		"dog_reviews_name_3": "Джейк Л.",
		"join_text": "Счастливое воспитание собаки начинается с EveryDoggy",
		"join_courses": "Присоединиться к веб-курсам",
		"checkout_introductory": "Скидка на вводное предложение",
		"checkout_personalized_plan": "Ваш персонализированный план",
		"Personal plan": "",
		"goal_lose_weight": "Эффективная программа похудения с направляемыми тренировками, трекером питания и разнообразными активностями для вас",
		"goal_gain_muscles": "Эффективная программа тонуса всего тела с индивидуально подобранными тренировками, трекером питания и разнообразными активностями для вас",
		"goal_gain_healthier_life": "Новая здоровая рутина с полными упражнениями под руководством, трекером питания и разнообразными активностями для вас",
		"goal_gain_flexibility": "Йога-программа для гибкости с руководимыми сессиями и успокаивающей музыкой, трекером питания и множеством других активностей",
		"goal_gain_build_endurance": "Программа тренировок на выносливость с управляемыми тренировками, трекером питания и различными видами активности для вас",
		"goal_love_myself": "Разнообразие мероприятий для повышения вашей самооценки,guided медитаций, йога-сессий и тренировок на все тело",
		"body_type_apple": "Упражнения для тела в форме яблока, чтобы укрепить пресс и стройнить талию.",
		"body_type_pear": "Упражнения для тела в форме груши, чтобы подтянуть бедра и ягодицы",
		"body_type_square": "Упражнения для квадратной формы тела, чтобы определить талию и прокачать ягодицы",
		"body_type_hourglass": "Упражнения для тела в форме песочных часов, чтобы помочь вам добиться потрясающих результатов",
		"body_type_triangle": "Упражнения для телосложения в форме перевернутого треугольника для укрепления ваших бедер и ягодиц",
		"body_type_unknown": "Упражнения для раскрытия лучших сторон вашей фигуры",
		"excercises_time_morning": "Утренние тренировки для ускорения вашего метаболизма и зарядки энергией на весь день",
		"excercises_time_day": "Тренировки, которые идеально вписываются в ваше расписание, ускоряют ваш метаболизм и помогут вам поддерживать энергию в течение дня.",
		"excercises_time_evening": "Вечерние тренировки, которые помогут вам снять стресс после длинного дня и подготовят к хорошему ночному сну.",
		"excercises_not_sure": "Тренировки, которые идеально вписываются в ваш график, ускоряют ваш метаболизм и наполняют вас энергией на весь день",
		"diet_type_all": "Легкие здоровые рецепты",
		"diet_type_vegetarian": "Здоровые вегетарианские рецепты",
		"diet_type_vegan": "Здоровые веганские рецепты",
		"diet_type_keto": "Здоровые кето рецепты",
		"personal_plan_providers_title": "",
		"special_features_title": "Специальные возможности для вас",
		"special_features_duration_minimum": "Быстрые сессии до 10 минут",
		"special_features_duration_normal": "Удобные сессии менее 20 минут",
		"special_features_duration_maximum": "Эффективные занятия более 20 минут",
		"special_features_duration_verv": "Удобные сессии от наших тренеров",
		"special_features_goal_lose_weight": "Секретные советы по снижению веса от экспертов",
		"special_features_goal_gain": "Секретные советы по тонизированию мышц от экспертов",
		"special_features_goal_health": "Секретные советы по здоровью от экспертов",
		"special_features_goal_flexibility": "Секретные советы по гибкости от экспертов",
		"special_features_goal_endurance": "Секретные советы для повышения выносливости",
		"special_features_goal_love": "Секретные советы для повышения самооценки",
		"discount_activated": "Активирована скидка 50%",
		"discount_no_activated": "50% скидка",
		"unlocked_with_promo": "Разблокировано с помощью промокода:",
		"use_with_button": "Используйте свой специальный промокод:",
		"plan_optimal": "Оптимально",
		"plan_standard": "СТАНДАРТ",
		"plan_basic": "БАЗОВЫЙ",
		"plan_extra": "ДОПОЛНИТЕЛЬНО",
		"daypayback_review_name_1": "меллибет",
		"daypayback_review_text_1": "",
		"daypayback_review_name_2": "кэти_зу13",
		"daypayback_review_text_2": "Я люблю Verv! Следование моему личному плану тренировок и питания помогло мне вернуться в форму и стать уверенным в себе снова! Я начал с коротких тренировок по фитнесу продолжительностью менее 15 минут, которые были идеальны для начинающего, как я. Затем я увеличил свою выносливость, и время моих тренировок возросло до 30-40 минут за сессию. Я медленно, но верно сбросил 25 килограммов за 6 месяцев с Verv!",
		"daypayback_review_name_3": "Жан_леон1",
		"daypayback_review_text_3": "Во время колледжа я сильно поправился. После окончания учебы я пробовал разные диеты, которые помогали мне сбрасывать вес, но этот вес всегда возвращался через несколько месяцев после завершения диеты. В прошлом году я услышал о Verv от своего коллеги и решил попробовать. Благодаря персонализированным рекомендациям Verv мне удалось сбросить вес и удерживать его после этого!",
		"daypayback_review_name_4": "мэриан1993",
		"daypayback_review_text_4": "После трудного разрыва я решила изменить свою жизнь, похудеть и стать здоровее. Но я не знала, с чего начать. Мне не хватало уверенности заниматься с другими, поэтому я решила попробовать приложения для домашних тренировок, и Verv попалось мне на глаза. Оно предложило мне план, адаптированный к моим нуждам. Я следовала ему и смогла достичь тела своей мечты!",
		"personal_plan_you_get": "С вашим персонализированным планом вы получите",
		"goal": "Цель",
		"goal_other": "Уроки для тренировки вашего пушистого друга",
		"goal_teaching_puppy": "Уроки по обучению вашего пушистого друга манерам и послушанию",
		"goal_surviving_puppy": "Уроки, которые помогут вам подготовиться к первым дням с вашим пушистым другом",
		"goal_socializing_puppy": "Уроки, которые помогут вам социализировать вашего пушистого друга",
		"goal_teaching_obedience": "Уроки для обучения вашего пушистого друга манерам и послушанию",
		"age_puppy": "Подробные советы по тренировке от наших экспертов, чтобы помочь вам вырастить счастливого и хорошо воспитанного щенка",
		"age_adult": "Подробные советы по тренировке от наших экспертов, чтобы помочь вам тренировать вашего собаку наиболее эффективным образом",
		"biting_yes": "Пошаговые инструкции, как остановить вашу собаку от укусов",
		"biting_no": "Развлекательные игры, в которые можно играть с вашей собакой",
		"biting_sometimes": "Пошаговые инструкции, как остановить вашу собаку от укусов",
		"quick_tips": "Быстрые и простые советы по изучению новых команд",
		"potty_training_a_bit": "Специальный гид по эффективному приучению вашего щенка к туалету",
		"potty_training_yes": "Специальные руководства, чтобы научить вашего щенка новым забавным трюкам",
		"potty_training_no": "Специальное руководство по эффективному домашнему обучению вашей щенки",
		"success screen": "",
		"success_screen_text_1": "Спасибо за вашу покупку!",
		"success_screen_text_2": "Следуйте инструкциям ниже, чтобы настроить<br />вашу учетную запись:",
		"success_screen_text_3": "Перейдите в ваш <b>аккаунт</b>",
		"success_screen_text_4": "Отсканируйте <b>QR код</b> или нажмите <b>на ссылку</b>",
		"success_screen_text_5": "<b>Скачайте</b> приложение",
		"success_screen_text_6": "<b>Откройте приложение</b> и <b>наслаждайтесь</b><br /> тренировками с вашей собакой!",
		"success_screen_text_7": "Мы дублировали QR-код и ссылку для вас на &nbsp;<b>example@gmail.com</b>",
		"success_screen_text_8": "Если премиум-аккаунт не был применен в приложении, нажмите <b>«Свяжитесь с нами»</b> на экране приветствия и свяжитесь с нашей службой поддержки.",
		"success_screen_text_9": "Нажимая на кнопку «Начать», я подтверждаю, что ознакомился и принимаю <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Политику конфиденциальности</a> и <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Условия использования</a>, а также согласен на обработку моих персональных данных.",
		"success_screen_text_10": "Связаться с нами",
		"success_screen_text_11": "Перейти в мой аккаунт",
		"success_screen_text_12": "Мы отправили вам дублированный QR-код и ссылку по электронной почте.",
		"success_screen_text_13": "Ваш PDF-руководство было отправлено на ваш электронный адрес <b>v.stsiopina@gmail.com</b>.",
		"success_screen_text_14": "Ваш PDF-гид был отправлен на вашу электронную почту.",
		"success_screen_text_15": "Если премиум-аккаунт не был применен в приложении, нажмите на <span>'Войти'</span> на экране приветствия в приложении и введите свой адрес электронной почты и пароль, который мы отправили вам на <b>stepinavalerie@gmail.com</b>",
		"success_screen_text_16": "Если премиум аккаунт не был применён в приложении, нажмите на ссылку <span>'Войти'</span> на приветственном экране приложения и введите ваш адрес электронной почты и пароль, который мы отправили вам по электронной почте.",
		"payment_text_1": "Ваша программа дрессировки собак начинается сейчас!",
		"payment_text_2": "Приложение Everydoggy поможет <span>быстро и весело решить любую из проблем поведения вашего пса</span>.",
		"payment_text_3": "Срок действия персонального предложения истекает",
		"payment_text_4": "наших пользователей замечают положительные изменения в поведении своих собак всего через 1 неделю после начала тренировок с нашими экспертами",
		"payment_text_5": "КаждаяСобака против Тренеров",
		"payment_text_6": "Среднее количество команд в месяц",
		"payment_text_7": "КаждаяСобака приносит пользу",
		"payment_text_8": "Персонализированный план тренировок для собак",
		"payment_text_9": "Всего 15 минут в день к идеальному питомцу",
		"payment_text_10": "70+ простых для понимания видеоуроков для быстрого результата",
		"payment_text_11": "80+ игр и трюков для новых навыков и просто для удовольствия",
		"payment_text_12": "Советы по гигиене, здоровью и питанию",
		"payment_text_13": "Тренируйтесь дома и на улице, оборудование не требуется",
		"payment_text_14": "98% наших пользователей замечают положительные изменения в поведении своих собак всего через 1 неделю после начала тренировки с нашими экспертами.",
		"payment_text_14_2": "<span>98% наших пользователей</span> замечают положительные изменения в поведении своей собаки всего за 1 неделю после начала дрессировки с нашими экспертами",
		"payment_text_15": "Нажимая кнопку «Получить мой план», вы соглашаетесь с нашими <a href='https://everydoggy.com/terms/' target=\"_blank\" >Условиями использования</a> и <a href='https://everydoggy.com/policy/' target=\"_blank\" >Политикой конфиденциальности</a>, <b>автоматически подтверждаете продление</b> вашей подписки в конце каждого расчетного периода <span>1 месяц</span> по полной цене <i>$29.99</i> плюс применимые налоги. Вы можете отменить автоматическое продление подписки в любое время до даты продления. Ознакомьтесь с нашими <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Условиями отмены</a> для получения дополнительной информации.",
		"payment_text_16": "Нажимая кнопку «Получить мой тариф», вы соглашаетесь с нашими <a href='https://everydoggy.com/terms/' target='_blank'>Условиями и положениями</a> и <a href='https://everydoggy.com/policy/' target='_blank'>Политикой конфиденциальности</a>, <b>даете согласие на автоматическое продление</b> вашей подписки в конце каждого расчетного периода в <span>1 месяц</span> по полной стоимости <i>$29.99</i> плюс применимые налоги. Вы можете отменить автоматическое продление вашей подписки в любое время до даты продления. Ознакомьтесь с нашими <a href='https://everydoggy.com/subscription-terms/' target='_blank'>Условиями отмены</a> для получения более подробной информации.",
		"payment_text_17": "У вас есть вопрос?",
		"payment_text_18": "Просто напишите нам на ",
		"payment_text_19": "Это работает!",
		"payment_text_20": "Только что закончил программу послушания с нашим щенком, мне это нравится! 👏",
		"payment_text_21": "Фантастика!",
		"payment_text_22": "Могу сказать, что я на 💯 довольна этим приложением. Больше никаких проблем с туалетом, вау!",
		"payment_text_23": "Отличное приложение 🎉",
		"payment_text_24": "Мы находимся на третьем месяце тренировки с моей собакой, и его навыки значительно улучшились!",
		"payment_text_25": "Стоит попробовать",
		"payment_text_26": "Безусловно, лучшее приложение для дрессировки собак!",
		"payment_text_27": "Вдохновляйтесь нашими пользователями!",
		"payment_text_28": " Star Focus, Inc.",
		"payment_text_29": "Если у вас еще есть вопросы, просто напишите нам на <a href=\"mailto:welove@everydoggy.com\">welove@everydoggy.com</a>",
		"payment_text_30": "Видимые результаты всего через 7 дней тренировок",
		"payment_text_31": "Получите свой персональный план со специальной скидкой",
		"payment_text_32": "Чем раньше вы начнете тренировки, тем лучших результатов вы достигнете",
		"payment_text_33": "Дрессировка необходима каждой собаке. Это не только устранение проблем с поведением, но и социализация, установление связи с вашей собакой и выражение вашей любви.",
		"payment_text_34": "Создано из любви и для <span>любви</span> к собакам. Основано на мировом опыте",
		"payment_text_35": "Все, что вы найдете в приложении, основано на последних исследованиях и полностью ориентировано на собак.",
		"payment_text_36": "Если бы ваша собака могла говорить, она бы попросила вас попробовать EveryDoggy!",
		"payment_text_37": "Ваша информация в безопасности",
		"payment_text_38": "Мы не будем продавать вашу контактную информацию для любых маркетинговых целей.",
		"payment_text_39": "Безопасная оплата",
		"payment_text_40": "Вся информация зашифрована и передается без риска.",
		"payment_text_41": "Нужна помощь?",
		"payment_text_42": "Напишите нам на email:  <a href=\"mailto:welove@everydoggy.com\">welove@everydoggy.com</a>",
		"payment_text_43": "ежемесячно",
		"payment_text_44": "продолжить",
		"payment_text_45": "Ваш персонализированный план:",
		"payment_text_46": "Скидка по вступительному предложению:",
		"payment_text_47": "Продолжая, вы соглашаетесь с <a href='https://everydoggy.com/terms/' target='_blank' rel=\"noreferrer\">Условиями использования</a>, <a href='https://everydoggy.com/policy/' target='_blank' rel=\"noreferrer\">Политикой конфиденциальности</a> и <a href='https://everydoggy.com/subscription-terms/#subscription_cancellation' target='_blank' rel=\"noreferrer\">Условиями отмены</a>.",
		"payment_text_48": "Ваша подписка длится до",
		"payment_text_49": "Вы можете отменить подписку в любое время без оплаты за 24 часа до окончания подписки.",
		"payment_text_50": "Если вы не отмените подписку, ваше членство автоматически продлится в конце вашего <span>1 month</span>. С вас будет взиматься плата за членство EveryDoggy в размере <b>$</b><i>$29.99</i>, пока вы не отмените подписку.",
		"payment_text_51": "В настоящее время мы не предлагаем возвратов или компенсации за частичное использование подписки.",
		"payment_text_52": "Личный <br>тренер",
		"payment_text_53": "Школа<br> для собак",
		"payment_text_54": "Уроки<br> на YouTube",
		"payment_text_55": "Книги",
		"payment_text_56": "еженедельно",
		"payment_text_57": "Значительно лучше результаты",
		"payment_text_58": "С EveryDoggy",
		"payment_text_59": "Без EveryDoggy",
		"payment_text_60": "Сейчас",
		"payment_text_61": "Через 1 неделю",
		"payment_text_62": "Это ваш последний шанс",
		"payment_text_63": "Не упустите уникальную скидку 65% и узнайте, как быстро ваша собака научится выполнять команды!",
		"payment_text_64": "Получить 65% скидки",
		"payment_text_65": "52-НЕДЕЛЬНЫЙ ПЛАН",
		"payment_text_66": "4-НЕДЕЛЬНЫЙ ПЛАН",
		"payment_text_67": "12-НЕДЕЛЬНЫЙ ПЛАН",
		"payment_text_68": "недели",
		"payment_text_69": "Января",
		"payment_text_70": "Февраля",
		"payment_text_71": "Марта",
		"payment_text_72": "Апреля",
		"payment_text_73": "Мая",
		"payment_text_74": "Июня",
		"payment_text_75": "Июля",
		"payment_text_76": "Августа",
		"payment_text_77": "Сентября",
		"payment_text_78": "Октября",
		"payment_text_79": "Ноября",
		"payment_text_80": "Декабря",
		"payment_text_81": "Пожалуйста, введите правильный адрес электронной почты.",
		"payment_text_82": "Сегодня с вас будет снята сумма <b>$6.99</b> за первую неделю (подробности ниже).",
		"payment_text_83": "Ваш пробный период продлится до <b>Oct 11, 2024</b>.",
		"payment_text_84": "Вы можете отменить подписку в любое время до <b>Oct 10, 2024</b>, и с вас не будет взиматься плата.",
		"payment_text_85": "Если вы не отмените подписку, Everydoggy автоматически продлит ваше членство по завершении пробного периода и будет взимать членский взнос (в настоящее время <b>$39.99 USD</b>) <span>ежемесячно</span> до отмены.",
		"payment_text_86": "Частичные возвраты не предусмотрены. Вы можете отменить подписку в любое время в своем аккаунте.",
		"payment_text_87": "Ваша подписка регулируется нашими <a href='https://everydoggy.com/terms/' target=\"_blank\" >Условиями и положениями</a>, <a href='https://everydoggy.com/policy/' target=\"_blank\" >Политикой конфиденциальности</a> и <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Условиями отмены</a>.",
		"payment_text_88": "Способ оплаты",
		"payment_text_89": "EveryDoggy будет использовать ваши платежные данные для удобных будущих платежей",
		"payment_text_90": "Простые и конфиденциальные платежи с использованием Face/Touch ID",
		"payment_text_91": "Ваша финансовая информация в безопасности благодаря сквозному шифрованию",
		"payment_text_92": "Защищено уникальным номером устройства Apple Pay",
		"payment_text_93": "Ваши платежные данные защищены шифрованием SSL/TLS",
		"payment_text_94": "Быстрый и удобный способ оплаты",
		"payment_text_95": "Поддерживается ведущей системой защиты от мошенничества PayPal",
		"payment_text_96": "Подтвердить покупку",
		"payment_text_97": "1 НЕДЕЛЯ",
		"payment_text_98": "1 МЕСЯЦ",
		"payment_text_99": "3 МЕСЯЦА",
		"payment_text_100": "Сегодня с вас будет списано всего <b>$6.99</b> за первый месяц (подробности ниже).",
		"payment_text_101": "Сегодня с вас будет списано всего <b>$6.99</b> за первые 3 месяца (подробности ниже).",
		"payment_text_102": "Подписаться с",
		"payment_text_103": "Нажимая кнопку «Получить мой план», вы соглашаетесь с <a href='https://everydoggy.com/policy/' target=\"_blank\" >Политикой конфиденциальности</a>, <a href='https://everydoggy.com/terms/' target=\"_blank\" >Условиями и положениями</a> и <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Условиями отмены</a>.",
		"payment_text_104": "Простые и конфиденциальные платежи",
		"payment_text_105": "Номер карты",
		"payment_text_106": "Срок действия",
		"payment_text_107": "CVC",
		"payment_text_108": "отличный старт",
		"payment_text_109": "1-недельный план",
		"payment_text_110": "Приложение Everydoggy поможет <span>решить проблемы с туалетом и любые другие проблемы с поведением собаки</span> быстро и легко.",
		"payment_text_111": "Безопасная оплата",
		"payment_text_112": "Персонализированный план тренировок для <span>вашей собаки</span>",
		"payment_text_113": "Свисток и кликер для тренировок",
		"payment_text_114": "80+ игр и трюков для вашего питомца",
		"payment_text_115": "30+ советов и статей по уходу за здоровьем",
		"payment_text_116": "🔥 Вы только что сэкономили <span>$113.50&nbsp;</span>🔥",
		"payment_text_117": "7-дневный план",
		"payment_text_118": "Нажимая кнопку «Получить мой план», вы соглашаетесь с нашими <a href='https://everydoggy.com/terms/' target=\"_blank\">Условиями и положениями</a> и <a href='https://everydoggy.com/policy/' target=\"_blank\">Политикой конфиденциальности</a> и <b>авторизуете автоматическое продление</b> вашей подписки. Сегодня с вас будет списано всего <span class=\"trialPrice\">$4.99</span> за первые <span class=\"trialPeriod\">7 дней</span> вводного периода. Если вы не отмените подписку, Everydoggy автоматически продлит ваше членство по окончании пробного периода и спишет абонентскую плату в размере <span class='price'>$39.99</span> каждые <span class='period'>месяц</span> до отмены. Вы можете отменить автоматическое продление подписки в любое время до даты продления. Подробнее в наших Условиях отмены.",
		"payment_text_119": "7 дней",
		"payment_text_120": "Сегодня с вас будет списано всего <b>$29.99</b> за первые <span>12 недель</span> (подробности ниже).",
		"payment_text_121": "Everydoggy <span>поможет обучить</span> вашу собаку <span>ходить в туалет</span> в правильном месте и <span>исправить проблемы с поведением</span> быстро и весело.",
		"payment_text_122": "Приучите собаку к туалету за 3 дня!",
		"payment_text_123": "Ваш профиль привязан к этому email и не может быть изменен",
		"payment_text_124": "Продолжая, вы соглашаетесь с нашими <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Условиями</a> и <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Политикой конфиденциальности</a> и <span>даёте разрешение на автоматическое продление</span> вашей подписки.",
		"payment_text_125": "26-НЕДЕЛЬНЫЙ ПЛАН",
		"payment_text_126": "Если вы не отмените подписку, Everydoggy автоматически продлит ваше членство по завершении пробного периода и будет взимать членский взнос (в настоящее время <b>$39.99 USD</b>) <span>каждые 3 месяца</span> до отмены.",
		"payment_text_127": "Если вы не отмените подписку, Everydoggy автоматически продлит ваше членство по завершении пробного периода и будет взимать членский взнос (в настоящее время <b>$39.99 USD</b>) <span>каждые 6 месяцев</span> до отмены.",
		"payment_text_128": "Текущий уровень",
		"payment_text_129": "команд",
		"payment_text_130": "Цель",
		"payment_text_131": "Более 50 команд и послушание",
		"payment_text_132": "Ощутите заметный прогресс",
		"payment_text_133": "Добейтесь послушания",
		"payment_text_134": "Сохраняйте хорошее поведение собаки на всю жизнь",
		"payment_text_135": "Сэкономьте 53%",
		"payment_text_136": "Гарантия возврата денег",
		"payment_text_137": "30-дневная гарантия возврата денег",
		"payment_text_138": "Мы уверены, что наш план подойдёт вам, и вы увидите заметные результаты за 4 недели! Мы даже готовы вернуть вам деньги, если вы не увидите результата и сможете доказать, что следовали нашему плану.",
		"payment_text_139": "Узнайте больше об ограничениях в наших <a href=\"https://everydoggy.com/terms/#section5_2\" target=\"_blank\" rel=\"noreferrer\">условиях использования</a>.",
		"payment_text_140": "Сэкономьте 65%",
		"payment_text_141": "План тренировки для вашей собаки готов!",
		"payment_text_142": "Послушание",
		"payment_text_143": "Знает команды",
		"payment_text_144": "Промахи с туалетом",
		"payment_text_145": "Часто",
		"payment_text_146": "Ни одного",
		"payment_text_147": "Лай",
		"payment_text_148": "Лает на всё",
		"payment_text_149": "Тихий и расслабленный",
		"payment_text_150": "Кусание и жевание",
		"payment_text_151": "Часто",
		"payment_text_152": "Прекратилось",
		"payment_text_153": "Тянет поводок",
		"payment_text_154": "Всегда",
		"payment_text_155": "Идёт спокойно",
		"payment_text_156": "Беспокоится, оставаясь один",
		"payment_text_157": "Спокоен и уверен",
		"payment_text_158": "До",
		"payment_text_159": "После",
		"payment_text_160": "минут",
		"payment_text_161": "секунд",
		"payment_text_162": "Протестировано. Доказано. Работает",
		"payment_text_163": "Значительные улучшения в поведении собаки",
		"payment_text_164": "Сегодня",
		"payment_text_165": "Неделя 2",
		"payment_text_166": "Неделя 3",
		"payment_text_167": "Неделя 4",
		"payment_text_168": "Секрет эффективности EveryDoggy",
		"payment_text_169": "Истории успеха наших пользователей",
		"payment_text_170": "Создано экспертами, которые <span>любят собак</span>",
		"payment_text_171": "Каждый наш курс и урок основан на научных исследованиях в области дрессировки собак.",
		"payment_text_172": "Постройте крепкую дружбу со своей собакой, попробуйте EveryDoggy!",
		"payment_text_173": "Доказано. Проверено. Работает",
		"payment_text_174": "<span>93% наших пользователей</span>\nотмечают заметные изменения\nв поведении своих собак уже в\nпервый месяц занятий.",
		"payment_text_175": "С EveryDoggy",
		"payment_text_176": "Без EveryDoggy",
		"payment_text_177": "Сегодня",
		"payment_text_178": "Неделя 2",
		"payment_text_179": "Неделя 4",
		"payment_text_180": "Неделя 6",
		"payment_text_181": "О Луне",
		"payment_text_182": "Мой щенок всё время устраивал\nбеспорядок в доме. EveryDoggy дал\nнам понятный план — и это сработало!",
		"payment_text_183": "О Купере",
		"payment_text_184": "Наш пёс раньше кусал всех во\nвремя игры. Это приложение расписало\nнам чёткие шаги — и они помогли!",
		"payment_text_185": "О Белле",
		"payment_text_186": "Наша собака жевала всё подряд —\nот обуви до дивана. Приложение\nпомогло перенаправить её энергию!",
		"payment_text_187": "О Чарли",
		"payment_text_188": "Он постоянно тянул поводок.\nБлагодаря этому приложению прогулки\nстали спокойными и приятными.\n\n",
		"payment_text_189": "Приучен к туалету",
		"payment_text_190": "Проблема кусания решена",
		"payment_text_191": "Проблема жевания решена",
		"payment_text_192": "Проблема с натягиванием поводка решена",
		"payment_text_193": "<span>93% наших пользователей</span> замечают значительные изменения в <span>поведении и дисциплине их собак</span> уже в первый месяц тренировок.</span>",
		"payment_text_194": "Наши пользователи в восторге от результатов!",
		"payment_text_195": "Начните тренироваться со своей собакой уже сейчас!",
		"payment_text_196": "Если вы не отмените подписку, Everydoggy автоматически продолжит ваше членство по завершении пробного периода и будет взимать плату за членство (в настоящее время <b>$39.99 USD</b>) <span>раз в две недели</span> до тех пор, пока вы не отмените.",
		"payment_text_197": "Гарантия возврата денег",
		"payment_text_198": "30-дневная гарантия возврата денег",
		"payment_text_199": "Мы уверены, что наш план подойдёт вам, и вы увидите заметные результаты за 4 недели! Мы даже готовы вернуть вам деньги, если вы не увидите результата и сможете доказать, что следовали нашему плану.",
		"payment_text_200": "Узнайте больше об ограничениях в наших <a href=\"https://everydoggy.com/terms/#section5_2\" target=\"_blank\" rel=\"noreferrer\">условиях использования</a>.",
		"payment_text_201": "Нас часто спрашивают",
		"payment_text_202": "Сколько времени понадобится, чтобы увидеть результаты от тренировок?",
		"payment_text_203": "Большинство собак показывают прогресс уже после первого занятия – и в течение пары недель вы увидите впечатляющие, значительные результаты!",
		"payment_text_204": "Такое же ли эффективное приложение Everydoggy, как и работа с тренером?",
		"payment_text_205": "Да, и даже более эффективное – вы можете заниматься каждый день в своем темпе, следовать понятным пошаговым урокам и постоянно закреплять навыки, а не только раз в неделю с тренером.",
		"payment_text_206": "Результаты тренировок сохраняются навсегда?",
		"payment_text_207": "Да! Пока вы продолжаете закреплять хорошие привычки, результаты сохраняются на всю жизнь.",
		"payment_text_208": "Получить 72% скидки",
		"payment_text_209": "Не упустите уникальную скидку 72% и узнайте, как быстро ваша собака научится выполнять команды!",
		"payment_text_210": "Продолжить с другим способом оплаты",
		"payment_text_211": "Buy with",
		"payment_text_212": "СКИДКА К ЧЕРНОЙ ПЯТНИЦЕ!",
		"payment_text_213": "",
		"payment_text_214": "",
		"payment_text_215": "",
		"payment_text_216": "",
		"payment_text_217": "",
		"payment_text_218": "Программа дрессировки щенка начинается прямо сейчас!",
		"payment_text_219": "Тренируйтесь с приложением Everydoggy с <span>самых ранних дней вашего щенка</span> и получите <span>идеально послушную собаку</span>!",
		"payment_text_220": "наших пользователей замечают положительные изменения в поведении щенка уже через 1 неделю после начала тренировок с нашими экспертами",
		"payment_text_221": "Персональный план тренировок для щенков младше 6 месяцев",
		"payment_text_222": "Персональный план тренировок для щенков 6–12 месяцев",
		"payment_text_223": "Проверено на 3 миллионах щенков",
		"payment_text_224": "Заметные изменения в послушании собаки",
		"payment_text_225": "Получить скидку 70%",
		"payment_text_226": "ПОСЛЕДНИЙ ШАНС!",
		"payment_text_227": "24-НЕДЕЛЬНЫЙ ПЛАН",
		"payment_text_228": "Единственная программа дрессировок, которая вам нужна, начинается сейчас! ",
		"payment_text_229": "Персональный план дрессировки для результата на всю жизнь",
		"payment_text_230": "Одна программа.<br />\nХорошее поведение навсегда",
		"payment_text_231": "Возраст собаки",
		"payment_text_232": "Время дрессировки",
		"payment_text_233": "Результат на долгие годы",
		"payment_text_234": "0-1 лет",
		"payment_text_235": "1-3 лет",
		"payment_text_236": "3-5 лет",
		"payment_text_237": "5+ лет",
		"payment_text_238": "1-2 лет",
		"payment_text_239": "3 года",
		"payment_text_240": "4 года",
		"payment_text_241": "2-7 лет",
		"payment_text_242": "8 лет",
		"payment_text_243": "9 лет",
		"payment_text_244": "10+ лет",
		"payment_text_245": "",
		"payment_text_246": "",
		"payment_text_247": "",
		"payment_text_248": "",
		"payment_text_249": "",
		"payment_text_250": "",
		"payment_text_251": "",
		"payment_text_252": "",
		"payment_text_253": "",
		"payment_text_254": "",
		"payment_text_255": "",
		"payment_text_256": "",
		"payment_text_257": "",
		"payment_text_258": "",
		"payment_text_259": "",
		"payment_text_260": "",
		"payment_text_261": "",
		"payment_text_262": "",
		"payment_text_263": "Собачий переводчик",
		"payment_text_264": "Поймите свою собаку.<br/> Получите результат",
		"payment_text_265": "Послушание улучшается благодаря анализу сигналов и поведения собаки",
		"payment_text_266": "Персонализированный план дрессировки на основе анализа лая и поведения вашей собаки",
		"payment_text_267": "Вдвое быстрее, <br />вдвое веселее!",
		"payment_text_268": "Получите полное руководство по воспитанию щенка",
		"payment_text_269": "Получите полное руководство по дрессировке собаки",
		"payment_text_270": "Забудьте о проблемах с туалетом! Пошаговые методы помогут быстро приучить собаку к туалету.",
		"payment_text_271": "Спасите обувь и пальцы! Простые приемы помогут отучить щенка кусаться и грызть все подряд.",
		"payment_text_272": "Создайте для собаки безопасное и уютное место и спокойно приучите ее к клетке.",
		"payment_text_273": "Получите полный набор советов от экспертов по поведению, послушанию и жизни с собакой.",
		"payment_text_274": "Скорректируйте нежелательное поведение дома и на прогулке с помощью простых и рабочих методов.",
		"payment_text_275": "Учиться может быть весело! Освойте похвалу и поощрения, чтобы собака охотнее слушалась.",
		"payment_text_276": "Научите собаку не только базовым командам! Освойте все: от команд для безопасности до эффектных трюков для собак любого возраста.",
		"payment_text_277": "Ускорьте<br /> прогресс вашей собаки <span>в 2 раза!</span>",
		"payment_text_278": "Практическое руководство:",
		"payment_text_279": "СКИДКА 98% только для участников",
		"payment_text_280": "СКИДКА 70% только для участников",
		"payment_text_281": "Ваша программа ветеринарной поддержки для собаки начинается сейчас!",
		"payment_text_282": "Заботьтесь о здоровье собаки с <span>профессиональной поддержкой ветеринара</span> от Everydoggy и <span>растите здоровую, послушную собаку</span> с меньшими переживаниями!",
		"payment_text_283": "Мгновенный чат с ветеринаром — без записи и ожидания",
		"payment_text_284": "Отправляйте фото, чтобы получить более точные рекомендации",
		"payment_text_285": "Изучите первую помощь при экстренных ситуациях: перегрев, травмы, обморожение",
		"payment_text_286": "Следите за актуальным графиком прививок и осмотров",
		"payment_text_287": "Получайте советы по уходу за зубами, ушами, глазами, когтями, дегельминтизации и не только",
		"payment_text_288": "Чувствуйте уверенность в здоровье своей собаки и меньше переживайте каждый день",
		"payment_text_289": "Что делает Everydoggy VET таким эффективным",
		"payment_text_290": "Нам доверяют более 3 млн владельцев собак",
		"payment_text_291": "Общайтесь в любое время с ветеринаром, на которого можно положиться",
		"payment_text_292": "Тренируйте собаку с приложением Everydoggy и наслаждайтесь <span>идеально воспитанным компаньоном</span>!",
		"payment_text_293": "Проверено на 3 миллионах собак",
		"payment_text_294": "Персональный план дрессировки, созданный для вашей собаки",
		"payment_text_295": "Когда у моего щенка была диарея, я быстро получила совет от ветеринара и точно знала, что делать. Это избавило меня от большого стресса.",
		"payment_text_296": "Советы понятные и надёжные. Такое ощущение, что рядом всегда есть профессионал, которому можно доверять.",
		"payment_text_297": "Я воспользовалась сервисом, когда у моей собаки появилось раздражение кожи и постоянный зуд. Рекомендации были понятными, и я сразу почувствовала спокойствие.",
		"payment_text_298": "Для меня, как для владельца щенка впервые, это оказалось очень полезно. Мне больше не приходится гадать.",
		"payment_text_299": "наших пользователей чувствуют себя увереннее в вопросах здоровья своей собаки и меньше переживают благодаря нашей ветеринарной поддержке",
		"payment_text_300": "<span>98% наших пользователей</span> чувствуют себя увереннее в вопросах здоровья своей собаки и меньше переживают благодаря нашей ветеринарной поддержке",
		"payment_text_301": "Ваша персональная программа игр и общения <span>начинается прямо сейчас</span>!",
		"payment_text_302": "С Everydoggy вы сможете <span>лучше понимать свою собаку</span>, <span>получать больше радости от времени вместе</span> и <span>строить крепкую связь</span>!",
		"payment_text_303": "3+ млн пользователей",
		"payment_text_304": "Наслаждаются жизнью со своими собаками",
		"payment_text_305": "Сейчас",
		"payment_text_306": "Понимание собаки",
		"payment_text_307": "Общение с собакой",
		"payment_text_308": "Удовольствие от игры",
		"payment_text_309": "Связь",
		"payment_text_310": "Персональная программа общения и игр с вашей собакой",
		"payment_text_311": "Переводите и понимайте лай своей собаки с Лай ИИ",
		"payment_text_312": "🎁 Ваша приветственная скидка применена:",
		"payment_text_313": "<span>53%</span> СКИДКА",
		"payment_text_314": "Ваша персональная программа дрессировки собаки начинается сейчас!",
		"payment_text_315": "Быстро замечайте результат и наслаждайтесь жизнью с воспитанной собакой!",
		"payment_text_316": "Команд выучено:",
		"payment_text_317": "Уровень послушания:",
		"payment_text_318": "Низкий",
		"payment_text_319": "Высокий",
		"payment_text_320": "Персональная программа дрессировки для <span>вашей собаки</span> готова!",
		"payment_text_321": "Профиль тренировки",
		"payment_text_322": "Порода собаки",
		"payment_text_323": "Возраст",
		"payment_text_324": "Проблемы поведения",
		"payment_text_325": "Текущий уровень",
		"payment_text_326": "Более 3 млн",
		"payment_text_327": "владельцев собак уже радуются результатам",
		"payment_text_328": "Ashley K. и Moly",
		"payment_text_329": "Мне нравится, что ежедневные задания очень простые. Моя собака теперь правда слушается!",
		"payment_text_330": "Kevin R. и Tommy",
		"payment_text_331": "Приучение к туалету было нашей главной трудностью. Эта программа оказалась единственным, что действительно сработало.",
		"payment_text_332": "Chloe N. и Ami",
		"payment_text_333": "Раньше мой щенок грыз всё подряд. Теперь он выбирает только свои игрушки!",
		"payment_text_334": "Daniel H. и Cherry",
		"payment_text_335": "Мне понравилось, что всё разделено на маленькие шаги. Моя собака выучила команды быстрее, чем я ожидал.",
		"payment_text_336": "Ваш план дрессировки щенка без стресса начинается прямо сейчас!",
		"payment_text_337": "Ваш план дрессировки собаки без стресса начинается прямо сейчас!",
		"payment_text_338": "Ваш персональный план питания и здоровья собаки начинается прямо сейчас!",
		"payment_text_339": "Сканируйте состав корма, получайте советы экспертов по питанию и помогайте своей собаке оставаться <span>здоровой и счастливой</span>!",
		"payment_text_340": "Сканируйте состав корма. Защитите здоровье своей собаки",
		"payment_text_341": "Сканируйте состав корма и быстро узнавайте ингредиенты и качество",
		"payment_text_342": "Получайте персональные рекомендации по кормлению с учётом потребностей вашей собаки",
		"payment_text_343": "Сканер состава корма — это находка. Теперь я сразу понимаю, что на самом деле в корме моей собаки.",
		"payment_text_344": "Отличный инструмент, чтобы следить за здоровьем и улучшать рацион моей собаки. Заметил реальные результаты!",
		"payment_text_345": "С этим приложением мне стало намного проще следить за питанием моей собаки. Очень нравятся персональные советы!",
		"payment_text_346": "Как будто я выучила язык своей собаки — теперь даже лай стал понятен.",
		"payment_text_347": "Игры просто потрясающие. Моя собака каждый раз в восторге!",
		"payment_text_348": "Мы играем, становимся ближе, и я наконец понимаю, о чём хочет сказать моя собака!",
		"payment_text_349": "наших пользователей чувствуют себя увереннее в вопросах здоровья своей собаки и меньше переживают благодаря нашему приложению",
		"payment_text_350": "Что делает EveryDoggy таким эффективным",
		"payment_text_351": "<span>98% наших пользователей</span> увереннее следят за здоровьем своей собаки и меньше переживают с нашим планом",
		"payment_text_352": "Новичок",
		"payment_text_353": "Ваша персональная программа дрессировки маленькой собаки начинается сейчас!",
		"payment_text_354": "Ваша персональная программа K9-тренировок начинается прямо сейчас!",
		"payment_text_355": "Получите быстрый результат: собака будет слушаться с первой команды!",
		"payment_text_356": "Огромная разница всего за несколько недель. Моя собака наконец слушается с первого раза.",
		"payment_text_357": "Прогулки с собакой больше не вызывают стресс. Теперь всё под контролем.",
		"payment_text_358": "От хаоса к спокойному поведению, и очень быстро. Отличная программа.",
		"payment_text_359": "Послушание с первой команды правда работает. Я и не думала, что такое возможно.",
		"payment_text_360": "Персональный план K9-тренировок для собаки",
		"payment_text_361": "",
		"payment_text_362": "",
		"payment_text_363": "",
		"payment_text_364": "",
		"payment_text_365": "",
		"payment_text_366": "",
		"payment_text_367": "",
		"payment_text_368": "",
		"payment_text_369": "",
		"payment_text_370": "",
		"payment_text_371": "",
		"payment_text_372": "",
		"payment_text_373": "",
		"payment_text_374": "",
		"payment_text_375": "",
		"payment_text_376": "",
		"payment_text_377": "",
		"payment_text_378": "",
		"payment_text_379": "",
		"payment_text_380": "",
		"payment_text_381": "",
		"payment_text_382": "",
		"payment_text_383": "",
		"payment_text_384": "<span>Сделайте первый шаг к послушной собаке:</span> получите полное руководство К9 по реактивности",
		"payment_text_385": "Откройте доступ к <span>практическому K9-руководству по реактивности</span>",
		"payment_text_386": "Научите собаку слушаться рядом с триггерами",
		"payment_text_387": "Останавливайте реакции, не давая им усилиться ",
		"payment_text_388": "Возвращайте контроль, когда собака срывается",
		"payment_text_389": "Отучите собаку остро реагировать на людей, других собак и машины",
		"pdfUpselling": "",
		"pdfUpselling_1": "<span>Начните путь к послушной собаке:</span> получите книгу по воспитанию и дрессировке собак",
		"pdfUpselling_2": "<span>Начните путь к послушной собаке:</span> получите книгу по воспитанию и дрессировке щенков",
		"pdfUpselling_3": "Получите <span>персональный план</span>",
		"pdfUpselling_4": "Откройте <span>практическое пособие</span>",
		"pdfUpselling_5": "Коррекция поведения (дома и на улице)",
		"pdfUpselling_6": "Как хвалить и награждать собаку",
		"pdfUpselling_7": "Различные команды",
		"pdfUpselling_8": "Игры для развития и многое другое",
		"pdfUpselling_9": "Приучение к туалету",
		"pdfUpselling_10": "Как отучить кусаться и жевать вещи",
		"pdfUpselling_11": "Тренировка с использованием клетки",
		"pdfUpselling_12": "Плюс еще 43 полезных совета и решения",
		"pdfUpselling_13": "Итого сегодня",
		"pdfUpselling_14": "Разблокировать книгу",
		"pdfUpselling_15": "Разблокировать с помощью",
		"pdfUpselling_16": "Продолжить без книги",
		"chatUpsale_1": "Чат с кинологом",
		"chatUpsale_2": "Опишите поведение вашей собаки. Решение — за нами!",
		"chatUpsale_3": "Общайтесь с нашими настоящими экспертами-кинологами без ограничений.",
		"chatUpsale_4": "Получите от EveryDoggy больше, чем ожидаете!",
		"chatUpsale_5": "Ускорение ×2",
		"chatUpsale_6": "План EveryDoggy",
		"chatUpsale_7": "Чат с кинологом",
		"chatUpsale_8": "Тренировки самостоятельно",
		"chatUpsale_9": "БЕЗЛИМИТНЫЙ ДОСТУП",
		"chatUpsale_10": "Ускорьте результаты с помощью чата с экспертом-кинологом!",
		"chatUpsale_11": "Доступ к чату",
		"chatUpsale_12": "30 дней",
		"chatUpsale_13": "90 дней",
		"chatUpsale_14": "Продолжить без чата с кинологом",
		"chatUpsale_15": "Чат с кинологом неограниченный доступ",
		"checkoutV2_text1": "итого",
		"checkoutV2_text2": "Простые и конфиденциальные платежи с Face/Touch ID",
		"checkoutV2_text3": "Защищает вашу финансовую информацию с помощью сквозного шифрования",
		"checkoutV2_text4": "Защищено с помощью уникального номера устройства Apple Pay",
		"checkoutV2_text5": "Быстрый и удобный способ оплаты",
		"checkoutV2_text6": "Защищает вашу финансовую информацию с помощью сквозного шифрования",
		"checkoutV2_text7": "Поддерживается передовой защитой от мошенничества PayPal",
		"checkoutV2_text8": "Гарантия возврата денег",
		"checkoutV2_text9": "Оформление<br />заказа",
		"checkoutV2_text10": "Платёжная информация",
		"checkoutV2_text11": "Защищено",
		"error_1": "Платеж отклонен. Пожалуйста, проверьте данные карты и попробуйте снова.",
		"error_2": "Платеж отклонен. Пожалуйста, проверьте данные карты и попробуйте снова.",
		"error_3": "Недостаточно средств. Пожалуйста, попробуйте другую карту или способ оплаты.",
		"error_4": "Срок действия вашей карты истек. Пожалуйста, попробуйте другую карту или способ оплаты.",
		"error_5": "Произошла ошибка при обработке вашей карты. Пожалуйста, попробуйте снова.",
		"error_6": "Неверный код безопасности. Пожалуйста, проверьте данные карты и попробуйте снова.",
		"error_7": "Карты American Express в данный момент не поддерживаются. Пожалуйста, попробуйте другую карту или способ оплаты.",
		"error_8": "Платеж отклонен. Пожалуйста, проверьте данные карты и попробуйте снова.",
		"error_9": "Платеж отклонен. Этот адрес электронной почты уже привязан к активной подписке.",
		"error_10": "Платеж отклонен. Слишком много попыток или превышен лимит карты. Пожалуйста, попробуйте позже.",
		"disclaimerV2_text_1": " Продолжая, Вы соглашаетесь с нашими <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Условиями и положениями</a> и <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Политикой конфиденциальности</a> и разрешаете автоматическое продление Вашей подписки. Сегодня с Вас будет списано только <span class=\"price1\">$1.99</span> за первую неделю. Если Вы не отмените подписку, Everydoggy автоматически продлит Вашу подписку по окончании пробного периода и будет взимать плату за подписку (в настоящее время <span class=\"price2\">$29.99</span>) каждые 2 недели до тех пор, пока Вы не отмените подписку.\n",
		"disclaimerV2_text_2": "Продолжая, Вы соглашаетесь с нашими <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Условиями и положениями</a> и <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Политикой конфиденциальности</a> и разрешаете автоматическое продление Вашей подписки.\r\nСегодня с Вас будет списано только <span class=\"price1\">$6.99</span> за первые 4 недели. \r\nЕсли Вы не отмените подписку, Everydoggy автоматически продлит Вашу подписку по окончании пробного периода и \r\nбудет взимать плату за подписку (в настоящее время <span class=\"price2\">$29.99</span>) каждые 2 недели до тех пор, пока Вы не отмените подписку.\r\n",
		"disclaimerV2_text_3": "Продолжая, Вы соглашаетесь с нашими <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Условиями и положениями</a> и <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Политикой конфиденциальности</a> и разрешаете автоматическое продление Вашей подписки.\r\nСегодня с Вас будет списано только <span class=\"price1\">$14.99</span> за первые 12 недель. \r\nЕсли Вы не отмените подписку, Everydoggy автоматически продлит Вашу подписку по окончании пробного периода и \r\nбудет взимать плату за подписку (в настоящее время <span class=\"price2\">$49.99</span>) каждые 4 недели до тех пор, пока Вы не отмените подписку.\r\n",
		"chatUpsaleV2_1": "Чат с кинологом",
		"chatUpsaleV2_2": "Тренируйтесь с экспертом по поведению собак",
		"chatUpsaleV2_3": "Добавьте к вашему плану безлимитную поддержку в чате от опытных кинологов",
		"chatUpsaleV2_4": "С кинологом",
		"chatUpsaleV2_5": "Эффективность",
		"chatUpsaleV2_6": "Чёткие ответы от настоящего эксперта",
		"chatUpsaleV2_7": "Персональные рекомендации для вашей собаки",
		"chatUpsaleV2_8": "Быстрее результат — меньше ошибок",
		"chatUpsaleV2_9": "Спокойный, уверенный процесс обучения",
		"chatUpsaleV2_10": "Без кинолога",
		"chatUpsaleV2_11": "Сомнения, всё ли вы делаете правильно",
		"chatUpsaleV2_12": "Медленный прогресс и повторяющиеся ошибки",
		"chatUpsaleV2_13": "Непонятные причины плохого поведения",
		"chatUpsaleV2_14": "Фрустрация у вас и у вашей собаки",
		"chatUpsaleV2_15": "Каждая собака уникальна. Получите помощь эксперта именно для вашей!",
		"chatUpsaleV2_16": "Ответы даже на самые сложные вопросы о поведении собаки",
		"chatUpsaleV2_17": "Поддержка и по эмоциям, и по практике обучения",
		"chatUpsaleV2_18": "Меньше стресса и раздражения во время тренировок",
		"chatUpsaleV2_19": "Персональные рекомендации, подходящие вам и вашей собаке",
		"chatUpsaleV2_20": "Профессиональная поддержка для максимальных результатов",
		"chatUpsaleV2_21": "Количество мест ограничено",
		"chatUpsaleV2_22": "Остались последние места",
		"chatUpsaleV2_23": "Доступ к чату с кинологом на 4 недели:",
		"chatUpsaleV2_24": "Дополнительная скидка 75% — ограничено:",
		"chatUpsaleV2_25": "Итого",
		"chatUpsaleV2_26": "Получить помощь эксперта сейчас",
		"chatUpsaleV2_27": "Продолжить без чата с кинологом",
		"chatUpsaleV2_28": "Могу ли я задать любой вопрос о своей собаке?",
		"chatUpsaleV2_29": "Да! Вы можете спрашивать о поведении, дрессировке, вопросах со щенком или конкретных трудностях, с которыми вы сталкиваетесь.",
		"chatUpsaleV2_30": "Как быстро я получу ответ?",
		"chatUpsaleV2_31": "Обычно наши опытные кинологи отвечают в течение 24 часов по будням.",
		"chatUpsaleV2_32": "Нужен ли мне предыдущий опыт дрессировки?",
		"chatUpsaleV2_33": "Совсем нет. Наши кинологи ведут вас шаг за шагом — независимо от того, новичок вы или опытный владелец."
	},
	"fr": {
		"global \ninstruction": "",
		"safe": "Vos informations sont en sécurité",
		"information": "Nous ne vendrons ni ne louerons vos informations de contact personnelles à des fins de marketing.",
		"secure_checkout": "Paiement sécurisé",
		"encrypted": "Toutes les informations sont chiffrées et transmises sans risque en utilisant un protocole de couche de socket sécurisé.",
		"help": "Besoin d'aide?",
		"contact": "Contactez-nous",
		"here": "ici.",
		"undefined": "",
		"featured": "Présenté dans",
		"main_title": "Cours d'entraînement canin",
		"per_year": "par an",
		"special_offer": "Offre spéciale",
		"card_number": "Numéro de carte",
		"card_expiry": "La carte expire",
		"security_number": "Numéro de sécurité",
		"email": "Email",
		"To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of __period__ and at the full, not discounted, price of __fullPriceText__ To learn more visit our <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">terms of use</a>.": "Informations de paiement",
		"secure_server": "Serveur sécurisé",
		"pay": "Payer",
		"enter_your_email": "Entrez votre e-mail",
		"comment_1": "Pendant quelques années stressantes, j'ai complètement perdu ma forme et pris du poids, mais je n'avais ni le temps ni la motivation d'y remédier. Un membre de ma famille m'a suggéré Verv et j'ai maintenant confiance en mon Coach au quotidien !",
		"comment_2": "Verv m'a fait apprécier les entraînements à la maison et j'ai perdu 7 kg en un mois. Cette application peut vraiment vous aider à vous entraîner et à perdre du poids si vous êtes un débutant comme moi.",
		"success_story": "Histoire de réussite",
		"get_my_plan": "OBTENIR MON PLAN",
		"delimiter": "ou",
		"pay_buy_card": "Payer par carte",
		"get_my_plan_warning_1": "Pour éviter toute interruption, vous acceptez que l'abonnement que vous avez sélectionné soit automatiquement prolongé pour une période de renouvellement successive de",
		"get_my_plan_warning_2": "et au prix plein, non remisé de",
		"get_my_plan_warning_3": "Pour en savoir plus, visitez notre",
		"get_my_plan_warning_text": "En continuant, vous acceptez que si vous ne vous désabonnez pas au moins 24 heures avant la fin de la première période de renouvellement, vous serez automatiquement facturé du prix complet de __fullPriceText__ tous les __period__ jusqu'à ce que vous annuliez.",
		"terms_of_use": "Conditions d'utilisation",
		"privacy_policy": "Politique de confidentialité",
		"terms_conditions": "Termes et conditions",
		"privacy_policy_footer": "Politique de confidentialité",
		"terms_conditions_footer": "Conditions générales",
		"guaranteed": "Paiement sécurisé garanti",
		"special_features": "Fonctionnalités spéciales pour vous",
		"calories_value": "kcal",
		"personalized_plan": "Obtenez votre plan personnalisé :",
		"mobile_app": "Application mobile avec votre plan",
		"daily_programs": "Programmes quotidiens pour différents objectifs (brûler des graisses, réduire le stress, prise de muscle)",
		"audio_guided": "Séances d'entraînement guidées par audio",
		"easy_to_cook": "Plats faciles à cuisiner et savoureux",
		"comprehensive_stats": "Statistiques complètes",
		"secret_tips": "Conseils secrets pour développer des habitudes saines",
		"mobile_app_tailor": "Plan sur mesure dans votre poche",
		"daily_programs_for": "Programmes quotidiens",
		"daily_programs_for_2": "Pour différents objectifs (brûler des graisses, réduire le stress, gain musculaire)",
		"audio_trainers": "Guides de formateurs professionnels",
		"comprehensive_track": "Suivez vos progrès avec des statistiques ultimes",
		"price": "Prix",
		"users_love": "Les utilisateurs adorent notre Plan Personnalisé",
		"alternative_review_name_1": "Therealtierra",
		"alternative_review_title_1": "Super application !",
		"alternative_review_contentent_1": "Je suis à ma neuvième semaine et mon corps a beaucoup changé !",
		"alternative_review_name_2": "tennisfille",
		"alternative_review_title_2": "Ça marche !",
		"alternative_review_contentent_2": "Je viens de finir le programme. Je l'adore. J'ai perdu 15 kg !!",
		"you_re_in": "Vous y êtes !",
		"personal_plan_starts": "Votre plan personnel Verv commence aujourd'hui et le temps presse. Alors allez-y !",
		"app_by_link": "Pour entrer dans votre programme, téléchargez l'application via le lien",
		"download_now": "Télécharger maintenant",
		"or": "ou",
		"price_after_trial": "Prix après l'essai",
		"seven_days_trial_unlocked": "Essai de 7 jours débloqué",
		"total_today": "Total aujourd'hui",
		"reserved_price_for": "Prix réservé pour",
		"new_subscritions1_title": "Choisissez votre plan",
		"new_subscritions1_subscription1_line1": "Plan semestriel",
		"new_subscritions1_subscription1_price1_time": "par semaine",
		"new_subscritions1_subscription2_line1": "plan de 3 mois",
		"new_subscritions1_subscription2_price2_time": "par semaine",
		"new_subscritions1_subscription3_line1": "plan de 1 mois",
		"new_subscritions1_subscription3_price3_time": "par semaine",
		"new_subscription_save": "ENREGISTRER",
		"new_subscritions_agreement": "En continuant, vous acceptez",
		"new_subscritions_and": "et",
		"new_subscritions_subtitle": "Nos utilisateurs ont perdu 10 millions de livres",
		"new_subscritions_join": "Rejoignez des millions de nos utilisateurs satisfaits",
		"statistic_block_item1_text": "Étoiles sur 5",
		"statistic_block_item2_text": "évaluations 5 étoiles",
		"statistic_block_item3_text": "téléchargements",
		"get_your_personalized_plan": "Obtenez votre plan personnalisé",
		"for": "pour",
		"new_subscription_save_mostPopular1MonthPrice": "le plan le plus populaire",
		"timer_additional_discount": "Remise supplémentaire appliquée juste ",
		"timer_additional_discount_bold": "pour vous",
		"timer_offer_expires": "Cette offre expire dans :",
		"Payment Successful": "",
		"payment_successful_title": "Salut de l'équipe Verv !",
		"payment_successful_download": "Téléchargez l'application",
		"payment_successful_press": "Appuyez",
		"payment_successful_login": "Connectez-vous avec un email",
		"payment_successful_email": "Entrez votre adresse e-mail",
		"payment_successful_code": "et votre code de confirmation :",
		"payment_successful_hit": "Puis touchez",
		"payment_successful_done": "Fait",
		"payment_successful_description": "Vous êtes dedans, profitez de votre plan d'entraînement personnalisé !",
		"Tariffs Variants": "",
		"tariff_title_choose": "Choisissez votre plan",
		"tariff_title_get": "Obtenez votre plan",
		"tariff_one_month": "Plan de 1 mois",
		"tariff_three_month": "Plan de 3 mois",
		"tariff_six_month": "Plan de 6 mois",
		"tariff_one_year": "Plan d'un an",
		"tariff_one_week": "Plan de 1 semaine",
		"tariff_three_day": "Plan de 3 jours",
		"tariff_per_year": "par an",
		"tariff_per_day": "par jour",
		"tariff_per_days": "tous les 3 jours",
		"tariff_per_week": "par semaine",
		"tariff_week": "semaine",
		"tariff_annual": "Plan annuel",
		"tariff_trial_one_week": "Essai de 1 semaine",
		"tariff_after": "après ",
		"tariff_save": "Enregistrer",
		"tariff_best_offer": "meilleure offre",
		"tariff_most_popular": "le plus populaire",
		"tariff_limited_promo": "prix promo limité",
		"tariff_6_for_3": "6 pour le prix de 3",
		"tariff_first_month": "premier mois",
		"tariff_first_week": "première semaine",
		"tariff_monthly": "mensuel",
		"tariff_quaterly": "trimestriel",
		"tariff_semiannually": "semi-annuellement",
		"tariff_billed_every ": "facturé chaque ",
		"tariff_year": "année",
		"tariff_month": "mois",
		"tariff_months": "mois",
		"tariff_months_variable": "mois",
		"tariff_organic_gift": "Plan de méditation",
		"tariff_full_price": "Prix total",
		"tariff_no_hidden_fees": "Pas de frais cachés",
		"tariff_start_right_now": "Commencez tout de suite",
		"tariff_more_than": "Plus de 1 000 000 de membres actifs de la famille Verv",
		"tariff_intro_offer": "OFFRE DE LANCEMENT",
		"Тарифы плиткой в ряд": "",
		"": "Je n’aurais jamais pensé que mon chien était aussi incroyablement intelligent. Avec EveryDoggy nous avons appris 5 nouvelles astuces en une semaine littéralement !",
		"Checkout": "",
		"checkout_title": "Sélectionnez le mode de paiement",
		"insufficient_funds": "Fonds insuffisants",
		"insufficient_we_have": "Nous avons un",
		"insufficient_special_price": "prix spécial",
		"insufficient_for_you": "pour vous",
		"checkout_edit_card": "Modifier la carte",
		"checkout_pay_via": "Payer via",
		"checkout_paypal": "PayPal",
		"checkout_credit_card": "Carte de crédit",
		"checkout_paypal_description": "Votre paiement sera traité via PayPal",
		"checkout_total_price": "Prix total",
		"checkout_warning_1": "Pour éviter toute interruption, vous acceptez que l'abonnement que vous avez sélectionné soit automatiquement prolongé pour une période de renouvellement successif de",
		"checkout_warning_2": "et au prix plein, non remisé, de",
		"checkout_warning_3": "Pour en savoir plus, visitez notre",
		"spv2_warning": "Pour éviter toute interruption, vous acceptez que l'abonnement que vous avez sélectionné sera automatiquement reconduit pour une durée de renouvellement successive de __________ et au prix plein, pas à prix réduit, __________. Pour en savoir plus, visitez nos <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">conditions d'utilisation</a>.",
		"checkout_offer_day_for": "jour pour",
		"checkout_offer_days_for": "jours pour",
		"checkout_offer_month_for": "mois pour",
		"checkout_offer_months_for": "mois pour",
		"checkout_offer_week_for": "semaine pour",
		"Values": "",
		"value_kg": "kg",
		"value_pounds": "lbs",
		"value_st": "st",
		"value_g": "g",
		"value_kcal": "kcal",
		"value_min": "min",
		"value_min_cooking": "min de cuisson",
		"welcome_title": "Bienvenue dans Verv Premium !",
		"item_1_title": "Youpi !",
		"item_1_description": "Votre poids cible de __weight__ est maintenant à portée de main.",
		"item_2_title": "Comment activer",
		"item_2_description": "Téléchargez l'application en utilisant le lien ci-dessous, utilisez votre e-mail __mail__ et entrez ce code de validation : __code__.",
		"item_2_description_2": "Pour changer l'email, cliquez <button id=\"changeMail\">ici</button>.",
		"item_3_title": "Quelque chose a mal tourné?",
		"item_3_description": "Une instruction détaillée a été envoyée à votre e-mail. Si vous ne l'avez pas reçue, contactez <a target=\"_blank\" href=\"mailto:support@verv.com?subject=Problème de connexion (simple-login)\">le support</a>.",
		"change": "Confirmer",
		"change_mail": "Changez votre adresse e-mail ici pour activer Premium",
		"email_warning": "Veuillez renseigner une adresse e-mail valide",
		"Promo Code Block": "",
		"promo_code_title": "Code promo appliqué !",
		"promo_code_save": "% de réduction",
		"EveryDoggy": "",
		"dog_courses": "cours pour chiens",
		"why_we_best_active": "Utilisateurs actifs.",
		"why_we_best_lessons": "Leçons vidéo.",
		"why_we_best_brain": "Jeux de cerveau.",
		"why_we_best": "Pourquoi sommes-nous les meilleurs ?",
		"why_we_best_join": "Rejoignez notre communauté de propriétaires de chiens et faites de votre mieux avec EveryDoggy.",
		"why_we_best_enjoy": "Profitez de votre plan d'entraînement personnalisé, adapté à vos objectifs et à ceux de votre chien.",
		"why_we_best_keep": "Gardez votre chien mentalement et physiquement actif avec plus de 70 jeux cérébraux.",
		"dog_problems": "Solutions rapides aux problèmes de comportement",
		"dog_problems_choose": "Choisissez les comportements indésirables que vous souhaitez améliorer",
		"dog_problems_leash": "Tirage de la<br/> laisse",
		"dog_problems_biting": "Mordre",
		"dog_problems_anxiety": "Anxiété de séparation<br/>",
		"dog_problems_chewing": "Mastication<br/>destructive",
		"dog_plan": "Plan d'entraînement personnalisé",
		"dog_plan_our": "Notre programme d'entraînement est 100 % adapté aux besoins de votre chien.",
		"dog_reviews": "Ce que les propriétaires de chiens disent d'EveryDoggy",
		"dog_reviews_text_1": "«Des leçons très claires et faciles à suivre. Mon chiot aime s'entraîner et nous avons tous les deux beaucoup appris.»",
		"dog_reviews_name_1": "Megan et Leo",
		"dog_reviews_text_2": "La commande « Zen » fait des merveilles. Grâce à elle, mon chien est super calme à la clinique vétérinaire pendant les procédures.",
		"dog_reviews_name_2": "Linda B.",
		"dog_reviews_text_3": "«Merci pour la leçon de clicker-training. J'ai entendu dire que c'est très populaire mais je ne savais pas comment l'utiliser. J'ai rapidement familiarisé mon chien avec le clicker et maintenant nous avons commencé à apprendre des tours.»",
		"dog_reviews_name_3": "Jake L.",
		"join_text": "Être un parent de chien heureux commence avec EveryDoggy",
		"join_courses": "Rejoindre des cours en ligne",
		"checkout_introductory": "Remise sur l'offre d'introduction",
		"checkout_personalized_plan": "Votre plan personnalisé",
		"Personal plan": "",
		"goal_lose_weight": "Programme de perte de poids efficace avec des entraînements guidés, un suivi nutritionnel et une variété d'activités pour vous",
		"goal_gain_muscles": "Programme de tonification du corps entier efficace avec des entraînements guidés, un suivi nutritionnel et une variété d'activités pour vous",
		"goal_gain_healthier_life": "Nouvelle routine santé avec des entraînements guidés pour tout le corps, un suivi nutritionnel et une variété d'activités pour vous",
		"goal_gain_flexibility": "Programme de yoga pour la flexibilité avec des séances guidées et de la musique apaisante, un tracker nutritionnel et une variété d'autres activités",
		"goal_gain_build_endurance": "Programme d'entraînement à l'endurance avec des séances guidées, un suivi nutritionnel et une variété d'activités pour vous",
		"goal_love_myself": "Une variété d'activités pour renforcer votre estime de soi, des méditations guidées, des séances de yoga et des entraînements complets du corps",
		"body_type_apple": "Exercices pour le corps en forme de pomme pour tonifier votre cœur et affiner votre taille.",
		"body_type_pear": "Exercices pour un corps en forme de poire pour tonifier vos hanches et cuisses",
		"body_type_square": "Exercices pour un corps en forme de carré afin de définir votre taille et de travailler vos fessiers",
		"body_type_hourglass": "Exercices pour un corps en forme de sablier pour vous aider à obtenir des résultats étonnants",
		"body_type_triangle": "Exercices pour les silhouettes en triangle inversé pour renforcer vos hanches et vos cuisses",
		"body_type_unknown": "Exercices pour mettre en valeur votre silhouette",
		"excercises_time_morning": "Entraînements du matin pour stimuler votre métabolisme et vous énergiser toute la journée",
		"excercises_time_day": "Des entraînements qui s'intègrent parfaitement dans votre emploi du temps, boostent votre métabolisme et vous maintiennent énergique tout au long de la journée.",
		"excercises_time_evening": "Entraînements du soir pour vous aider à soulager le stress après une longue journée et vous préparer à une bonne nuit de sommeil.",
		"excercises_not_sure": "Des entraînements qui s'intègrent parfaitement à votre emploi du temps, stimulent votre métabolisme et vous gardent énergique tout au long de la journée",
		"diet_type_all": "Recettes saines et faciles",
		"diet_type_vegetarian": "Recettes végétariennes saines",
		"diet_type_vegan": "Recettes véganes saines",
		"diet_type_keto": "Recettes keto saines",
		"personal_plan_providers_title": "",
		"special_features_title": "Fonctionnalités spéciales pour vous",
		"special_features_duration_minimum": "Séances rapides de moins de 10 minutes",
		"special_features_duration_normal": "Séances pratiques de moins de 20 minutes",
		"special_features_duration_maximum": "Séances efficaces de plus de 20 minutes",
		"special_features_duration_verv": "Séances pratiques avec nos coachs",
		"special_features_goal_lose_weight": "Conseils secrets de perte de poids d'experts",
		"special_features_goal_gain": "Conseils secrets de tonification musculaire d'experts",
		"special_features_goal_health": "Conseils secrets pour la santé d'experts",
		"special_features_goal_flexibility": "Conseils secrets de flexibilité des experts",
		"special_features_goal_endurance": "Conseils secrets pour améliorer l'endurance",
		"special_features_goal_love": "Conseils secrets pour booster l'estime de soi",
		"discount_activated": "Remise de 50% activée",
		"discount_no_activated": "50 % de réduction",
		"unlocked_with_promo": "Débloqué avec le code promo :",
		"use_with_button": "Utilisez votre code promo spécial :",
		"plan_optimal": "Optimal",
		"plan_standard": "STANDARD",
		"plan_basic": "BASIC",
		"plan_extra": "EXTRA",
		"daypayback_review_name_1": "melliebeth",
		"daypayback_review_text_1": "",
		"daypayback_review_name_2": "katie_zu13",
		"daypayback_review_text_2": "J'adore Verv ! Suivre mon programme d'entraînement et de repas personnel m'a aidé à retrouver la forme et à redevenir confiant ! J'ai commencé avec des entraînements de fitness courts de moins de 15 minutes, parfaits pour un débutant comme moi. Puis, j'ai augmenté mon endurance et mon temps d'entraînement est passé à 30-40 minutes par session. J'ai lentement mais sûrement perdu 25 kilos en 6 mois avec Verv !",
		"daypayback_review_name_3": "Jean_leon1",
		"daypayback_review_text_3": "J'ai pris beaucoup de poids pendant mes études. Après avoir obtenu mon diplôme, j'ai essayé différents régimes qui m'ont aidé à perdre du poids, mais ce poids revenait toujours quelques mois après la fin du régime. L'année dernière, j'ai entendu parler de Verv par un collègue et j'ai décidé d'essayer. Grâce aux recommandations personnalisées de Verv, j'ai réussi à perdre du poids et à le maintenir ensuite !",
		"daypayback_review_name_4": "maryanne1993",
		"daypayback_review_text_4": "Après une rupture difficile, j'ai décidé de changer ma vie, de perdre du poids et de devenir plus saine. Mais je ne savais pas par où commencer. Je ne me sentais pas assez confiante pour m'entraîner avec d'autres, alors j'ai décidé d'essayer des applications d'entraînement à domicile et Verv est tombé sur ma recherche. Il m'a proposé un plan adapté à mes besoins. Je l'ai suivi et j'ai réussi à obtenir le corps de mes rêves !",
		"personal_plan_you_get": "Avec votre plan personnalisé, vous obtenez",
		"goal": "But",
		"goal_other": "Leçons pour entraîner votre ami à fourrure",
		"goal_teaching_puppy": "Leçons pour enseigner à votre ami à fourrure les bonnes manières et l'obéissance",
		"goal_surviving_puppy": "Leçons pour vous aider à vous préparer pour les premiers jours avec votre ami à quatre pattes",
		"goal_socializing_puppy": "Des leçons pour aider votre ami à fourrure à se socialiser",
		"goal_teaching_obedience": "Leçons pour enseigner à votre ami à quatre pattes les bonnes manières et l'obéissance",
		"age_puppy": "Des conseils de formation détaillés de nos experts pour vous aider à élever un chiot heureux et bien élevé",
		"age_adult": "Des conseils de formation détaillés de nos experts pour vous aider à entraîner votre chien de la manière la plus efficace",
		"biting_yes": "Instructions étape par étape pour empêcher votre chien de mordre",
		"biting_no": "Des jeux divertissants à jouer avec votre chien",
		"biting_sometimes": "Instructions étape par étape pour empêcher votre chien de mordre",
		"quick_tips": "Astuces rapides et faciles pour apprendre de nouvelles commandes",
		"potty_training_a_bit": "Un guide spécial pour apprendre efficacement à votre chiot à être propre",
		"potty_training_yes": "Des guides spéciaux pour apprendre à votre chiot de nouveaux tours amusants",
		"potty_training_no": "Un guide spécial pour apprendre efficacement la propreté à votre chiot",
		"success screen": "",
		"success_screen_text_1": "Merci pour votre achat !",
		"success_screen_text_2": "Suivez les instructions ci-dessous pour configurer<br />votre compte:",
		"success_screen_text_3": "Allez à votre <b>compte</b>",
		"success_screen_text_4": "Scannez le <b>code QR</b> ou appuyez sur <b>le lien</b>",
		"success_screen_text_5": "<b>Téléchargez</b> l'application",
		"success_screen_text_6": "<b>Ouvrez l'application</b> et <b>profitez</b><br /> de l'entraînement avec votre chien!",
		"success_screen_text_7": "Nous avons dupliqué le code QR et le lien pour vous à &nbsp;<b>example@gmail.com</b>",
		"success_screen_text_8": "Si le compte premium n'a pas été appliqué dans l'application, appuyez sur <b>« Contactez-nous »</b> sur l'écran d'accueil et contactez notre équipe d'assistance.",
		"success_screen_text_9": "En appuyant sur le bouton «Commencer», je confirme que j'ai examiné et accepté la <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Politique de confidentialité</a> et les <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Conditions générales</a> et j'accepte par la présente le traitement de mes données personnelles.",
		"success_screen_text_10": "Contactez-nous",
		"success_screen_text_11": "Aller à mon compte",
		"success_screen_text_12": "Nous vous avons envoyé un code QR dupliqué et un lien par e-mail.",
		"success_screen_text_13": "Votre guide PDF a été envoyé à votre adresse e-mail <b>v.stsiopina@gmail.com</b>.",
		"success_screen_text_14": "Votre guide PDF a été envoyé à votre email.",
		"success_screen_text_15": "Si le compte premium n'a pas été appliqué dans l'application, appuyez sur le lien <span>'Se connecter'</span> sur l'écran d'accueil de l'application et saisissez votre e-mail et le mot de passe que nous vous avons envoyé à <b>stepinavalerie@gmail.com</b>",
		"success_screen_text_16": "Si le compte premium n'a pas été appliqué dans l'application, appuyez sur le lien <span>'Se connecter'</span> sur l'écran d'accueil de l'application et saisissez votre email et le mot de passe que nous vous avons envoyé par email.",
		"payment_text_1": "Votre programme de dressage de chien commence maintenant !",
		"payment_text_2": "L'application Everydoggy vous aidera à <span>résoudre rapidement et de manière ludique n'importe quel problème de comportement de votre chien</span>.",
		"payment_text_3": "L'offre personnelle expire",
		"payment_text_4": "de nos utilisateurs remarquent des changements positifs dans le comportement de leur chien seulement 1 semaine après avoir commencé l'entraînement avec nos experts",
		"payment_text_5": "ChaqueChien contre Entraîneurs",
		"payment_text_6": "Nombre moyen de commandes par mois",
		"payment_text_7": "ChaqueChien bénéficie",
		"payment_text_8": "Plan d'entraînement canin personnalisé",
		"payment_text_9": "Juste 15 minutes par jour pour un animal de compagnie parfait",
		"payment_text_10": "Plus de 70 leçons vidéo faciles à comprendre pour des résultats rapides",
		"payment_text_11": "Plus de 80 jeux et astuces pour de nouvelles compétences et juste pour le plaisir",
		"payment_text_12": "Conseils sur l'hygiène, la santé et la nutrition",
		"payment_text_13": "Entraînez-vous à la maison et en plein air, aucun équipement nécessaire",
		"payment_text_14": "98% de nos utilisateurs remarquent des changements positifs dans le comportement de leur chien dès 1 semaine après avoir commencé l'entraînement avec nos experts.",
		"payment_text_14_2": "<span>98 % de nos utilisateurs</span> remarquent des changements positifs dans le comportement de leur chien en seulement 1 semaine après avoir commencé l'entraînement avec nos experts",
		"payment_text_15": "En cliquant sur le bouton «Obtenir mon plan», vous acceptez nos <a href='https://everydoggy.com/terms/' target=\"_blank\" >Conditions générales</a> et <a href='https://everydoggy.com/policy/' target=\"_blank\" >Politique de confidentialité</a>, <b>autorisez le renouvellement automatique</b> de votre abonnement à la fin de chaque cycle de facturation de <span>1 mois</span> au prix total de <i>$29.99</i> plus les taxes applicables. Vous pouvez annuler le renouvellement automatique de votre abonnement à tout moment avant la date de renouvellement. Consultez nos <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Conditions d'annulation</a> pour plus de détails.",
		"payment_text_16": "En cliquant sur le bouton «Obtenir mon plan», vous acceptez nos <a href='https://everydoggy.com/terms/' target='_blank'>Conditions générales</a> et <a href='https://everydoggy.com/policy/' target='_blank'>Politique de confidentialité</a>, <b>autorisez le renouvellement automatique</b> de votre abonnement à la fin de chaque cycle de facturation de <span>1 mois</span> au prix total de <i>$29.99</i> plus les taxes applicables. Vous pouvez annuler le renouvellement automatique de votre abonnement à tout moment avant la date de renouvellement. Consultez nos <a href='https://everydoggy.com/subscription-terms/' target='_blank'>Conditions d'annulation</a> pour plus de détails.",
		"payment_text_17": "Vous avez une question ?",
		"payment_text_18": "Il suffit de nous écrire à ",
		"payment_text_19": "Ça marche !",
		"payment_text_20": "Je viens de terminer le programme d'éducation avec notre chiot, j'adore ! 👏",
		"payment_text_21": "Fantastique!",
		"payment_text_22": "Je peux dire que je suis 💯 satisfait de cette application. Plus de problèmes de propreté, waouh !",
		"payment_text_23": "Une super application 🎉",
		"payment_text_24": "Nous sommes rendus à notre 3e mois d’entraînement avec mon chien et ses compétences se sont énormément améliorées&nbsp;!",
		"payment_text_25": "Ça vaut la peine d'essayer",
		"payment_text_26": "De loin la meilleure application pour dresser un chien&nbsp;! ",
		"payment_text_27": "Laissez-vous inspirer par nos utilisateur·ices",
		"payment_text_28": " Star Focus, Inc.",
		"payment_text_29": "Si vous avez encore des questions, écrivez-nous à <a href=\"mailto:welove@everydoggy.com\">welove@everydoggy.com</a>",
		"payment_text_30": "Des résultats visibles en seulement sept jours d'entraînement",
		"payment_text_31": "Obtenez votre plan personnalisé avec une remise spéciale",
		"payment_text_32": "Plus tôt vous commencerez à vous entraîner, meilleurs seront les résultats que vous obtiendrez",
		"payment_text_33": "L’entraînement est essentiel pour chaque chien. Il ne s’agit pas seulement d’éliminer les problèmes de comportement, mais aussi de favoriser sa socialisation, de créer un lien avec votre chien et d’exprimer votre amour.",
		"payment_text_34": "Créé en raison de et pour <span>l'amour</span> des chiens. Basé sur une expertise de classe mondiale",
		"payment_text_35": "Tout ce que vous trouverez dans l'application s'inspire des dernières recherches et est absolument centré sur les chiens.",
		"payment_text_36": "Si votre chien pouvait parler, il vous demanderait d'essayer EveryDoggy !",
		"payment_text_37": "Vos informations sont en sécurité",
		"payment_text_38": "Nous ne vendrons ni ne louerons vos coordonnées personnelles à des fins de marketing, quelles qu'elles soient.",
		"payment_text_39": "Paiement sécurisé",
		"payment_text_40": "Toutes les informations sont cryptées et transmises sans risque.",
		"payment_text_41": "Besoin d'aide",
		"payment_text_42": "Envoyez-nous un e-mail : <a href=\"mailto:welove@everydoggy.com\">welove@everydoggy.com</a>",
		"payment_text_43": "par mois",
		"payment_text_44": "continuer",
		"payment_text_45": "Votre plan personnalisé :",
		"payment_text_46": "Offre de lancement avec remise :",
		"payment_text_47": "En continuant, vous acceptez les <a href='https://everydoggy.com/terms/' target='_blank' rel=\"noreferrer\">conditions générales</a>, la politique de <a href='https://everydoggy.com/policy/' target='_blank' rel=\"noreferrer\">confidentialité</a> et les <a href='https://everydoggy.com/subscription-terms/#subscription_cancellation' target='_blank' rel=\"noreferrer\">conditions d'annulation</a>",
		"payment_text_48": "Votre abonnement dure jusqu'au",
		"payment_text_49": "Vous pouvez annuler à tout moment sans frais au moins 24 heures avant l'expiration de la période d'abonnement.",
		"payment_text_50": "Si vous n'annulez pas, votre abonnement sera automatiquement renouvelé à la fin de sa période de validité. Des frais d'adhésion à EveryDoggy de <b>$</b><i>$29.99</i> vous seront facturés jusqu'à ce que vous annuliez.",
		"payment_text_51": "Nous n'offrons actuellement pas de remboursements ou de crédits pour les adhésions partielles.",
		"payment_text_52": "Assistant <br>personnel",
		"payment_text_53": "École<br> canine",
		"payment_text_54": "Cours<br> sur YouTube",
		"payment_text_55": "Livres",
		"payment_text_56": "hebdomadaire",
		"payment_text_57": "Des résultats nettement meilleurs",
		"payment_text_58": "Avec EveryDoggy",
		"payment_text_59": "Sans EveryDoggy",
		"payment_text_60": "Maintenant",
		"payment_text_61": "Après une semaine",
		"payment_text_62": "C'est votre dernière chance",
		"payment_text_63": "Ne manquez pas la remise exclusive de 65&nbsp;% et découvrez à quelle vitesse votre chien apprend et obéit aux ordres !",
		"payment_text_64": "Bénéficiez de 65&nbsp;% de réduction",
		"payment_text_65": "FORFAIT DE 52 SEMAINES",
		"payment_text_66": "FORFAIT DE 4 SEMAINES",
		"payment_text_67": "FORFAIT DE 12 SEMAINES",
		"payment_text_68": "semaines",
		"payment_text_69": "Janvier",
		"payment_text_70": "Février",
		"payment_text_71": "Mars",
		"payment_text_72": "Avril",
		"payment_text_73": "Mai",
		"payment_text_74": "Juin",
		"payment_text_75": "Juillet",
		"payment_text_76": "Août",
		"payment_text_77": "Septembre",
		"payment_text_78": "Octobre",
		"payment_text_79": "Novembre",
		"payment_text_80": "Décembre",
		"payment_text_81": "Veuillez saisir une adresse e-mail valide.",
		"payment_text_82": "Vous ne serez facturé que <b>$6.99</b> aujourd'hui pour votre première semaine (détails ci-dessous)",
		"payment_text_83": "Votre période de bienvenue se prolongera jusqu'au <b>Oct 11, 2024</b>. ",
		"payment_text_84": "Vous pouvez annuler à tout moment avant le <b>Oct 10, 2024</b> et aucun frais ne vous sera facturé. ",
		"payment_text_85": "Si vous n'annulez pas votre adhésion, Everydoggy poursuivra automatiquement votre adhésion à la fin de votre période d'introduction et vous facturera les frais d'adhésion (actuellement <b>$39.99 USD</b>) <span>mensuellement</span> jusqu'à ce que vous annuliez votre adhésion.",
		"payment_text_86": "Aucun remboursement partiel.  Vous pouvez annuler votre abonnement à tout moment dans votre compte. ",
		"payment_text_87": "Votre abonnement sera soumis à nos <a href='https://everydoggy.com/terms/' target=\"_blank\" >conditions générales</a>, à notre <a href='https://everydoggy.com/policy/' target=\"_blank\" >politique de confidentialité</a> et à nos <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >conditions d'annulation</a>.",
		"payment_text_88": "Mode de paiement ",
		"payment_text_89": "EveryDoggy utilisera vos informations de paiement pour des paiements futurs fluides ",
		"payment_text_90": "Paiements faciles et privés avec Face/Touch ID ",
		"payment_text_91": "Vos informations financières sont sécurisées grâce au cryptage de bout en bout.",
		"payment_text_92": "Protégé par le numéro de compte d'appareil unique d'Apple Pay ",
		"payment_text_93": "Vos informations de paiement sont sécurisées grâce au cryptage SSL/TLS ",
		"payment_text_94": "Option de paiement rapide et pratique ",
		"payment_text_95": "Bénéficiez de la protection anti-fraude de pointe de PayPal ",
		"payment_text_96": "Confirmer l'achat ",
		"payment_text_97": "1-SEMAINE",
		"payment_text_98": "1-MOIS",
		"payment_text_99": "3-MOIS",
		"payment_text_100": "Vous ne serez facturé que <b>$6.99</b> aujourd'hui pour votre premier mois (détails ci-dessous).",
		"payment_text_101": "Vous ne serez facturé que <b>$6.99</b> aujourd'hui pour vos 3 premiers mois (détails ci-dessous).",
		"payment_text_102": "S'abonner avec",
		"payment_text_103": "En cliquant sur le bouton « Obtenir mon plan », vous acceptez la <a href='https://everydoggy.com/policy/' target=\"_blank\" >Politique de confidentialité</a>, les <a href='https://everydoggy.com/terms/' target=\"_blank\" >Conditions générales</a> et la <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Politique d'annulation</a>.",
		"payment_text_104": "Paiements faciles et privés",
		"payment_text_105": "Carte de crédit",
		"payment_text_106": "Date d’expiration",
		"payment_text_107": "CVC",
		"payment_text_108": "bon début",
		"payment_text_109": "Abonnement d'une semaine",
		"payment_text_110": "L'application Everydoggy vous aidera à <span>résoudre les problèmes de toilettes et autres problèmes de comportement de votre chien</span> rapidement et en prenant du plaisir.",
		"payment_text_111": "Paiement sécurisé",
		"payment_text_112": "Plan d'éducation personnalisé de <span>votre chien</span>",
		"payment_text_113": "Sifflet et clicker pour le dressage",
		"payment_text_114": "Plus de 80 jeux et tours pour votre animal de compagnie",
		"payment_text_115": "Plus de 30 conseils et articles de santé",
		"payment_text_116": "🔥Vous venez d'économiser <span>$113,50&nbsp;</span>🔥",
		"payment_text_117": "Forfait de sept jours\n",
		"payment_text_118": "En cliquant sur le bouton « Obtenir mon forfait », vous acceptez nos <a href='https://everydoggy.com/terms/' target=\"_blank\" >Conditions générales</a>, notre <a href='https://everydoggy.com/policy/' target=\"_blank\" >Politique de confidentialité</a> et <b>autorisez le renouvellement automatique</b> de votre abonnement. Vous ne serez facturé que <span class=\"trialPrice\">4,99 $</span> aujourd'hui pour les <span class=\"trialPeriod\">sept premiers jours</span> de votre période d'essai. À défaut d'annulation, Everydoggy poursuivra automatiquement votre abonnement à la fin de votre période d'essai et facturera les frais d'abonnement à <span class='price'>39,99 $</span> tous les <span class='period'>mois</span> jusqu'à ce que vous l'annuliez. Vous pouvez annuler le renouvellement automatique de votre abonnement à tout moment avant la date de renouvellement. Consultez nos conditions d'annulation pour en savoir plus.",
		"payment_text_119": "Sept jours",
		"payment_text_120": "Vous ne serez facturé que <b>29,99 $</b> aujourd'hui pour vos <span>12 premières semaines</span> (voir détails ci-dessous)",
		"payment_text_121": "L'application Everydoggy vous <span>aidera à entraîner</span> votre chien à <span>faire ses besoins</span> au bon endroit et à <span>corriger ses problèmes de comportement</span> rapidement tout en s'amusant.",
		"payment_text_122": "Un chien dressé pour la propreté en trois jours",
		"payment_text_123": "Votre compte est lié à cet e-mail et ne peut pas être modifié",
		"payment_text_124": "En continuant, vous acceptez nos <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">conditions générales</a> et notre <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">politique de confidentialité</a> et <span>autorisez le renouvellement automatique de votre abonnement</span>.",
		"payment_text_125": "FORFAIT DE 26 SEMAINES",
		"payment_text_126": "Si vous n'annulez pas votre adhésion, Everydoggy poursuivra automatiquement votre adhésion à la fin de votre période d'introduction et vous facturera les frais d'adhésion (actuellement <b>$39.99 USD</b>) <span>tous les 3 mois</span> jusqu'à ce que vous annuliez votre adhésion.",
		"payment_text_127": "Si vous n'annulez pas votre adhésion, Everydoggy poursuivra automatiquement votre adhésion à la fin de votre période d'introduction et vous facturera les frais d'adhésion (actuellement <b>$39.99 USD</b>) <span>tous les 6 mois</span> jusqu'à ce que vous annuliez votre adhésion.",
		"payment_text_128": "Niveau actuel",
		"payment_text_129": "commandes",
		"payment_text_130": "But",
		"payment_text_131": "Plus de 50 commandes et obéissance",
		"payment_text_132": "Constatez des progrès notables",
		"payment_text_133": "Atteindre l'obéissance",
		"payment_text_134": "Gardez votre chien bien dressé toute sa vie",
		"payment_text_135": "Économisez 53 %",
		"payment_text_136": "Garantie de remboursement",
		"payment_text_137": "Garantie de remboursement de 30 jours",
		"payment_text_138": "Nous pensons que notre plan peut fonctionner pour vous et que vous obtiendrez des résultats visibles en quatre semaines ! Nous sommes même prêts à vous rembourser si vous ne voyez pas de résultats visibles et pouvez démontrer que vous avez suivi notre plan.",
		"payment_text_139": "Pour en savoir plus sur les limitations applicables, consultez nos <a href=\"https://everydoggy.com/terms/#section5_2\" target=\"_blank\" rel=\"noreferrer\">conditions générales d'utilisation</a>.",
		"payment_text_140": "Économisez 65 %",
		"payment_text_141": "Votre programme de dressage canin est prêt !",
		"payment_text_142": "Obéissance",
		"payment_text_143": "Connaît les ordres",
		"payment_text_144": "Accidents de propreté",
		"payment_text_145": "Fréquent",
		"payment_text_146": "Aucun",
		"payment_text_147": "Aboiement",
		"payment_text_148": "Aboie sur tout",
		"payment_text_149": "Calme et détendu",
		"payment_text_150": "Mordre et mâcher",
		"payment_text_151": "Souvent",
		"payment_text_152": "A arrêté",
		"payment_text_153": "Tirer sur la laisse",
		"payment_text_154": "Toujours",
		"payment_text_155": "Marche calmement",
		"payment_text_156": "Angoisse lorsque laissé seul",
		"payment_text_157": "Calme et indépendant",
		"payment_text_158": "Avant",
		"payment_text_159": "Après",
		"payment_text_160": "minutes",
		"payment_text_161": "secondes",
		"payment_text_162": "Éprouvé. Testé. Ça marche",
		"payment_text_163": "Des changements significatifs sur l'obéissance d'un chien",
		"payment_text_164": "Aujourd'hui",
		"payment_text_165": "Semaine 2",
		"payment_text_166": "Semaine 3",
		"payment_text_167": "Semaine 4",
		"payment_text_168": "Qu'est-ce qui rend Everydoggy si efficace ?",
		"payment_text_169": "Les réussites de nos utilisateurs",
		"payment_text_170": "Conçu par des experts qui <span>aiment les chiens</span>",
		"payment_text_171": "Tous nos cours et leçons s'appuient sur des études scientifiques sur le dressage des chiens.",
		"payment_text_172": "Créez un lien fort avec votre chien, essayez EveryDoggy !",
		"payment_text_173": "Éprouvé. Testé. Ça marche",
		"payment_text_174": "<span>93 % de nos utilisateurs</span> constatent des changements significatifs dans le comportement de leur chien dès le premier mois d'entraînement.",
		"payment_text_175": "Avec EveryDoggy",
		"payment_text_176": "Sans EveryDoggy",
		"payment_text_177": "Aujourd'hui",
		"payment_text_178": "Semaine 2",
		"payment_text_179": "Semaine 4",
		"payment_text_180": "Semaine 6",
		"payment_text_181": "À propos de Luna",
		"payment_text_182": "Mon chiot n’arrêtait pas d’avoir des accidents dans la maison. Everydoggy nous a fourni une routine claire, et cela a réellement fonctionné!",
		"payment_text_183": "À propos de Cooper",
		"payment_text_184": "Notre chiot avait l'habitude de mordre tout le monde quand il jouait. L'application nous a donné des instructions étape par étape et cela a fonctionné!",
		"payment_text_185": "À propos de Bella",
		"payment_text_186": "Notre chien mastiquait tout, des chaussures au canapé. L'application nous a aidés à canaliser cette énergie!",
		"payment_text_187": "À propos de Charlie",
		"payment_text_188": "Il tirait constamment sur la laisse, c’était épuisant. Grâce à l'application, les promenades sont désormais agréables et relaxantes.",
		"payment_text_189": "Chien propre",
		"payment_text_190": "Ne mord plus",
		"payment_text_191": "Ne détruit plus les objets",
		"payment_text_192": "Ne tire plus en laisse",
		"payment_text_193": "<span>93 % de nos utilisateurs</span> constatent des changements significatifs dans le <span>comportement et l'obéissance de leur chien</span> dès le premier mois d'entraînement.</span>",
		"payment_text_194": "Nos utilisateurs sont impressionnés par les résultats !",
		"payment_text_195": "Commencez dès maintenant à entraîner votre chien !",
		"payment_text_196": "Si vous n'annulez pas, Everydoggy prolongera automatiquement votre abonnement à la fin de votre période d'essai et facturera les frais d'adhésion (actuellement de <b>39,99 $</b>) <span>toutes les deux semaines</span> jusqu'à ce que vous procédiez à l'annulation.",
		"payment_text_197": "Garantie de remboursement",
		"payment_text_198": "Garantie de remboursement de 30 jours",
		"payment_text_199": "Nous pensons que notre plan peut fonctionner pour vous et que vous obtiendrez des résultats visibles en quatre semaines ! Nous sommes même prêts à vous rembourser si vous ne voyez pas de résultats visibles et pouvez démontrer que vous avez suivi notre plan.",
		"payment_text_200": "Pour en savoir plus sur les limitations applicables, consultez nos <a href=\"https://everydoggy.com/terms/#section5_2\" target=\"_blank\" rel=\"noreferrer\">conditions générales d'utilisation</a>.",
		"payment_text_201": "Les gens se demandent souvent :",
		"payment_text_202": "Combien de temps faut-il pour voir les résultats du dressage ?",
		"payment_text_203": "La plupart des chiens montrent des progrès dès la première séance, et en quelques semaines seulement, vous constaterez des résultats impressionnants et significatifs !",
		"payment_text_204": "L'application Everydoggy est-elle aussi efficace que de travailler avec un dresseur ?",
		"payment_text_205": "Oui, et même plus : vous pouvez dresser votre chien tous les jours à votre rythme, suivre des leçons structurées étape par étape et renforcer ses compétences de manière régulière, plutôt que de vous contenter d'une seule séance par semaine avec un dresseur.",
		"payment_text_206": "Les résultats du dressage sont-ils permanents ?",
		"payment_text_207": "Oui ! Tant que vous continuez à renforcer les bonnes habitudes, les résultats sont permanents.",
		"payment_text_208": "Bénéficiez de 72&nbsp;% de réduction",
		"payment_text_209": "Ne manquez pas la remise exclusive de 72&nbsp;% et découvrez à quelle vitesse votre chien apprend et obéit aux ordres !",
		"payment_text_210": "Continuer avec un autre moyen de paiement",
		"payment_text_211": "Buy with",
		"payment_text_212": "PROMOTION DU BLACK FRIDAY !",
		"payment_text_213": "",
		"payment_text_214": "",
		"payment_text_215": "",
		"payment_text_216": "",
		"payment_text_217": "",
		"payment_text_218": "Le programme d’éducation de votre chiot commence maintenant !",
		"payment_text_219": "Entraînez-vous avec l’app Everydoggy dès <span>les tout premiers jours de votre chiot</span> et obtenez <span>un chien parfaitement obéissant</span> !",
		"payment_text_220": "de nos utilisateurs constatent des changements positifs dans le comportement de leur chiot dès 1 semaine après avoir commencé l’entraînement avec nos experts",
		"payment_text_221": "Plan d’entraînement personnalisé pour les chiots de moins de 6 mois",
		"payment_text_222": "Plan d’entraînement personnalisé pour les chiots de 6 à 12 mois",
		"payment_text_223": "Prouvé sur 3 millions de chiots",
		"payment_text_224": "Des changements significatifs dans l’obéissance du chien",
		"payment_text_225": "Bénéficiez de 70&nbsp;% de réduction",
		"payment_text_226": "DERNIÈRE CHANCE !",
		"payment_text_227": "FORFAIT DE 24 SEMAINES",
		"payment_text_228": "Le dernier programme de dressage dont vous aurez besoin commence maintenant !",
		"payment_text_229": "Plan de dressage personnalisé pour des résultats durables",
		"payment_text_230": "Un programme.<br />\nUn bon comportement durable",
		"payment_text_231": "Âge du chien",
		"payment_text_232": "Temps de dressage",
		"payment_text_233": "Résultats durables",
		"payment_text_234": "0-1 an",
		"payment_text_235": "1-3 ans",
		"payment_text_236": "3-5 ans",
		"payment_text_237": "5+ ans",
		"payment_text_238": "1-2 ans",
		"payment_text_239": "3 ans",
		"payment_text_240": "4 ans",
		"payment_text_241": "2-7 ans",
		"payment_text_242": "8 ans",
		"payment_text_243": "9 ans",
		"payment_text_244": "10+ ans",
		"payment_text_245": "",
		"payment_text_246": "",
		"payment_text_247": "",
		"payment_text_248": "",
		"payment_text_249": "",
		"payment_text_250": "",
		"payment_text_251": "",
		"payment_text_252": "",
		"payment_text_253": "",
		"payment_text_254": "",
		"payment_text_255": "",
		"payment_text_256": "",
		"payment_text_257": "",
		"payment_text_258": "",
		"payment_text_259": "",
		"payment_text_260": "",
		"payment_text_261": "",
		"payment_text_262": "",
		"payment_text_263": "Traducteur canin",
		"payment_text_264": "Comprenez votre chien.<br/> Voyez les résultats",
		"payment_text_265": "L’obéissance s’améliore grâce à l’analyse des signaux et du comportement",
		"payment_text_266": "Plan d’éducation personnalisé pour votre chien, basé sur l’analyse de ses aboiements et de son comportement",
		"payment_text_267": "Deux fois plus vite, <br />deux fois plus de plaisir !",
		"payment_text_268": "Obtenez le guide ultime d'éducation du chiot",
		"payment_text_269": "Obtenez le guide ultime de dressage canin",
		"payment_text_270": "Fini les problèmes de propreté ! Des méthodes pas à pas pour apprendre vite à votre chien à être propre.",
		"payment_text_271": "Sauvez vos chaussures et vos doigts ! Des techniques simples pour apprendre à votre chiot à ne plus mordre ni tout mâchouiller.",
		"payment_text_272": "Créez pour votre chien un espace sûr et rassurant, et apprenez-lui à rester calme dans sa cage.",
		"payment_text_273": "Accédez à une boîte à outils complète de conseils d'experts sur le comportement, l'obéissance et le quotidien avec votre chien.",
		"payment_text_274": "Corrigez les comportements gênants à la maison et en promenade avec des méthodes efficaces et faciles à appliquer.",
		"payment_text_275": "Rendez l'apprentissage agréable ! Maîtrisez les félicitations et les récompenses pour motiver votre chien immédiatement.",
		"payment_text_276": "Apprenez à votre chien bien plus que les bases ! Vous découvrirez tout, des commandes de sécurité aux tours impressionnants pour les chiens de tous âges.",
		"payment_text_277": "Accélérez les<br /> progrès de votre chien <span>x2 !</span>",
		"payment_text_278": "Guide pratique :",
		"payment_text_279": "RÉDUCTION DE 98% réservée aux membres",
		"payment_text_280": "RÉDUCTION DE 70% réservée aux membres",
		"payment_text_281": "Votre programme de soins vétérinaires pour votre chien commence maintenant",
		"payment_text_282": "Prenez soin de la santé de votre chien avec <span>l’accompagnement de vétérinaires experts</span> d’Everydoggy et <span>élevez un chien en bonne santé et bien éduqué</span> avec moins d’inquiétude",
		"payment_text_283": "Chat vétérinaire instantané — sans rendez-vous ni attente",
		"payment_text_284": "Partagez des photos pour obtenir des conseils plus précis",
		"payment_text_285": "Apprenez les gestes de premiers secours en cas d’urgence : coup de chaleur, blessures ou gelures",
		"payment_text_286": "Restez à jour avec les calendriers de vaccination et de suivi",
		"payment_text_287": "Recevez des conseils pour les dents, oreilles, yeux, griffes, vermifugation et plus encore",
		"payment_text_288": "Soyez rassuré sur la santé de votre chien et inquiétez-vous moins au quotidien",
		"payment_text_289": "Ce qui rend Everydoggy VET si efficace",
		"payment_text_290": "Plus de 3M propriétaires de chiens nous font confiance",
		"payment_text_291": "Discutez à tout moment avec un vétérinaire de confiance",
		"payment_text_292": "Dressez votre chien avec l'application Everydoggy et profitez d'un <span>compagnon parfaitement bien élevé</span> !",
		"payment_text_293": "Approuvé par 3 millions de chiens",
		"payment_text_294": "Plan de dressage personnalisé adapté à votre chien",
		"payment_text_295": "Quand mon chiot a eu la diarrhée, j’ai vite reçu les conseils d’un vétérinaire et j’ai su exactement quoi faire. Ça m’a évité beaucoup de stress.",
		"payment_text_296": "Les conseils sont clairs et fiables. J’ai l’impression d’avoir toujours un professionnel de confiance à mes côtés.",
		"payment_text_297": "Je l’ai utilisé quand mon chien a eu une irritation de la peau et se grattait sans arrêt. Les conseils étaient clairs, et je me suis sentie rassurée tout de suite.",
		"payment_text_298": "Pour moi, en tant que nouveau propriétaire de chiot, cela a été incroyablement utile. Je n’ai plus besoin de deviner.",
		"payment_text_299": "de nos utilisateurs se sentent plus confiants concernant la santé de leur chien et s’inquiètent moins grâce à notre accompagnement vétérinaire",
		"payment_text_300": "<span>98 % de nos utilisateurs</span> se sentent plus confiants concernant la santé de leur chien et s’inquiètent moins grâce à notre accompagnement vétérinaire",
		"payment_text_301": "Votre programme personnalisé de jeu et de communication <span>commence maintenant</span> !",
		"payment_text_302": "Avec Everydoggy, vous allez <span>mieux comprendre votre chien</span>, <span>prendre encore plus de plaisir ensemble</span> et <span>créer un lien durable</span> !",
		"payment_text_303": "3 M+ utilisateurs",
		"payment_text_304": "Profitent pleinement de la vie avec leur chien",
		"payment_text_305": "Maintenant",
		"payment_text_306": "Comprendre votre chien",
		"payment_text_307": "Communication avec votre chien",
		"payment_text_308": "Plaisir du jeu",
		"payment_text_309": "Lien",
		"payment_text_310": "Programme personnalisé de communication et de jeu avec votre chien",
		"payment_text_311": "Traduisez et comprenez les aboiements de votre chien avec Aboiement IA",
		"payment_text_312": "🎁 Votre réduction de bienvenue est appliquée :",
		"payment_text_313": "<span>53%</span> DE RÉDUCTION",
		"payment_text_314": "Votre programme personnalisé d’éducation canine commence maintenant !",
		"payment_text_315": "Obtenez vite des résultats et profitez de la vie avec un chien bien éduqué !",
		"payment_text_316": "Ordres appris :",
		"payment_text_317": "Niveau d’obéissance :",
		"payment_text_318": "Faible",
		"payment_text_319": "Élevé",
		"payment_text_320": "Le programme d’éducation personnalisé pour <span>votre chien</span> est prêt !",
		"payment_text_321": "Profil d’entraînement",
		"payment_text_322": "Race du chien",
		"payment_text_323": "Âge",
		"payment_text_324": "Troubles du comportement",
		"payment_text_325": "Niveau actuel",
		"payment_text_326": "Plus de 3 millions",
		"payment_text_327": "de propriétaires de chiens profitent déjà des résultats",
		"payment_text_328": "Ashley K. et Moly",
		"payment_text_329": "J’adore la simplicité des exercices quotidiens. Maintenant, mon chien m’écoute vraiment !",
		"payment_text_330": "Kevin R. et Tommy",
		"payment_text_331": "L’apprentissage de la propreté était notre plus grande difficulté. Ce programme est la seule chose qui ait vraiment fonctionné.",
		"payment_text_332": "Chloe N. et Ami",
		"payment_text_333": "Avant, mon chiot mâchait tout. Maintenant, il ne s’attaque qu’à ses jouets !",
		"payment_text_334": "Daniel H. et Cherry",
		"payment_text_335": "J’ai aimé que tout soit divisé en petites étapes. Mon chien a appris les ordres plus vite que je ne l’espérais.",
		"payment_text_336": "Votre plan de dressage sans stress pour votre chiot commence maintenant !",
		"payment_text_337": "Votre plan de dressage sans stress pour votre chien commence maintenant !",
		"payment_text_338": "Votre plan personnalisé de nutrition et de santé pour votre chien commence maintenant !",
		"payment_text_339": "Scannez les étiquettes des aliments pour chiens, recevez des conseils nutritionnels d’experts et gardez votre chien <span>en bonne santé et heureux</span> !",
		"payment_text_340": "Scannez les étiquettes alimentaires. Protégez la santé de votre chien",
		"payment_text_341": "Scannez les étiquettes des aliments pour chiens et comprenez rapidement les ingrédients et la qualité",
		"payment_text_342": "Recevez des conseils alimentaires adaptés aux besoins de votre chien",
		"payment_text_343": "Le scanner d’étiquettes alimentaires change tout. Je sais instantanément ce qu’il y a vraiment dans la nourriture de mon chien.",
		"payment_text_344": "Un excellent outil pour suivre la santé de mon chien et améliorer son alimentation. Les résultats sont visibles !",
		"payment_text_345": "Cette app m’a beaucoup facilité la gestion de l’alimentation de mon chien. J’adore les conseils personnalisés !",
		"payment_text_346": "C’est comme si j’avais appris le langage de ma chienne — même ses aboiements ont du sens maintenant.",
		"payment_text_347": "Les jeux sont incroyables. Mon chien est enthousiaste à chaque fois !",
		"payment_text_348": "Nous jouons, nous créons du lien, et je comprends enfin ce que ma chienne veut me dire !",
		"payment_text_349": "de nos utilisateurs se sentent plus confiants concernant la santé de leur chien et s’inquiètent moins grâce à notre application",
		"payment_text_350": "Ce qui rend EveryDoggy si efficace",
		"payment_text_351": "<span>98 % de nos utilisateurs</span> se sentent plus confiants pour la santé de leur chien et s’inquiètent moins avec notre programme",
		"payment_text_352": "Débutant",
		"payment_text_353": "Votre programme personnalisé d’éducation pour petit chien commence maintenant !",
		"payment_text_354": "Votre programme d’entraînement K9 personnalisé commence maintenant !",
		"payment_text_355": "Obtenez des résultats rapides : votre chien obéira au premier ordre.",
		"payment_text_356": "Une énorme différence en quelques semaines seulement. Mon chien obéit enfin du premier coup.",
		"payment_text_357": "Promener mon chien n’est plus stressant. J’ai enfin le contrôle.",
		"payment_text_358": "Nous sommes passés du chaos à un comportement calme très vite. Programme incroyable.",
		"payment_text_359": "L’obéissance au premier ordre fonctionne vraiment. Je ne pensais pas que c’était possible.",
		"payment_text_360": "Plan d’entraînement K9 personnalisé pour chien",
		"payment_text_361": "",
		"payment_text_362": "",
		"payment_text_363": "",
		"payment_text_364": "",
		"payment_text_365": "",
		"payment_text_366": "",
		"payment_text_367": "",
		"payment_text_368": "",
		"payment_text_369": "",
		"payment_text_370": "",
		"payment_text_371": "",
		"payment_text_372": "",
		"payment_text_373": "",
		"payment_text_374": "",
		"payment_text_375": "",
		"payment_text_376": "",
		"payment_text_377": "",
		"payment_text_378": "",
		"payment_text_379": "",
		"payment_text_380": "",
		"payment_text_381": "",
		"payment_text_382": "",
		"payment_text_383": "",
		"payment_text_384": "<span>Lancez-vous vers un chien obéissant :</span> obtenez le guide K9 ultime sur la réactivité",
		"payment_text_385": "Débloquez le <span>manuel pratique K9 sur la réactivité</span>",
		"payment_text_386": "Apprenez à votre chien à vous écouter face aux déclencheurs",
		"payment_text_387": " Stoppez les réactions sans les laisser s'amplifier",
		"payment_text_388": "Reprenez le contrôle quand votre chien perd les pédales",
		"payment_text_389": "Apprenez à votre chien à ne plus réagir de façon excessive aux gens, aux autres chiens et aux voitures",
		"pdfUpselling": "",
		"pdfUpselling_1": "<span>Lancez-vous dans votre parcours pour un chien obéissant :</span> obtenez un guide ultime sur l'éducation et le dressage des chiens",
		"pdfUpselling_2": "<span>Lancez-vous dans votre parcours pour un chien obéissant :</span> obtenez un guide ultime sur l'éducation et le dressage des chiots",
		"pdfUpselling_3": "Obtenez votre <span>projet personnalisé</span>",
		"pdfUpselling_4": "Débloquez le <span>guide pratique</span>",
		"pdfUpselling_5": "Correction du comportement (à l'intérieur et à l'extérieur)",
		"pdfUpselling_6": "Comment féliciter et récompenser votre chien",
		"pdfUpselling_7": "Commandes diverses",
		"pdfUpselling_8": "Jeux d'enrichissement et bien plus encore",
		"pdfUpselling_9": "Apprentissage de la propreté",
		"pdfUpselling_10": "Arrêter de mordre et de mâchouiller",
		"pdfUpselling_11": "Entraînement à la caisse",
		"pdfUpselling_12": "Plus 43 autres conseils et solutions utiles",
		"pdfUpselling_13": "La totalité aujourd'hui",
		"pdfUpselling_14": "Dévérouiller le guide",
		"pdfUpselling_15": "Déverrouiller avec",
		"pdfUpselling_16": "Continuer sans guide",
		"chatUpsale_1": "Chat avec éducateur canin",
		"chatUpsale_2": "Décrivez le comportement du chien. Nous avons la solution",
		"chatUpsale_3": "Discutez avec nos véritables experts en dressage canin, sans limites",
		"chatUpsale_4": "Everydoggy vous apporte plus que vous ne l'espérez !",
		"chatUpsale_5": "Boost × 2",
		"chatUpsale_6": "Forfait EveryDoggy",
		"chatUpsale_7": "Chat avec éducateur canin",
		"chatUpsale_8": "Dresser soi-même",
		"chatUpsale_9": "ACCÈS ILLIMITÉ",
		"chatUpsale_10": "Améliorez vos résultats grâce au chat avec un expert en dressage !",
		"chatUpsale_11": "accès au chat",
		"chatUpsale_12": "30 jours",
		"chatUpsale_13": "90 jours",
		"chatUpsale_14": "Continuer sans discuter avec l'éducateur canin",
		"chatUpsale_15": "Accès illimité au chat dresseur de chiens",
		"checkoutV2_text1": "total",
		"checkoutV2_text2": "Paiements faciles et privés avec Face/Touch ID",
		"checkoutV2_text3": "Vos informations financières sont protégées grâce à un cryptage complet",
		"checkoutV2_text4": "Protection assurée grâce au numéro de compte unique de l'appareil Apple Pay",
		"checkoutV2_text5": "Option de paiement rapide et pratique",
		"checkoutV2_text6": "Vos informations financières sont protégées grâce à un cryptage complet",
		"checkoutV2_text7": "Bénéficiez de la protection anti-fraude de pointe de PayPal",
		"checkoutV2_text8": "Garantie de remboursement",
		"checkoutV2_text9": "Paiement",
		"checkoutV2_text10": "Informations de paiement",
		"checkoutV2_text11": "Protégé·es",
		"error_1": "Paiement refusé. Veuillez vérifier les détails de la carte et réessayer.",
		"error_2": "Paiement refusé. Veuillez vérifier les détails de la carte et réessayer.",
		"error_3": "Fonds insuffisants. Veuillez essayer une autre carte ou un autre mode de paiement.",
		"error_4": "Votre carte a expiré. Veuillez essayer une autre carte ou un autre mode de paiement.",
		"error_5": "Une erreur s'est produite lors du traitement de votre carte. Veuillez réessayer.",
		"error_6": "Le code de sécurité est incorrect. Veuillez vérifier les détails de la carte et réessayer.",
		"error_7": "Les cartes American Express ne sont pas prises en charge pour le moment. Veuillez essayer une autre carte ou un autre mode de paiement.",
		"error_8": "Paiement refusé. Veuillez vérifier les détails de la carte et réessayer.",
		"error_9": "Paiement refusé. Cette adresse e-mail est déjà associée à un abonnement actif.",
		"error_10": "Paiement refusé. Trop de tentatives ou limite de carte dépassée. Veuillez réessayer plus tard.",
		"disclaimerV2_text_1": "En continuant, vous acceptez nos <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Conditions générales d'utilisation</a> et notre <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Politique de confidentialité</a> et autorisez le renouvellement automatique de votre abonnement. Aujourd'hui, seul un montant de <span class=\"price1\">$1.99</span> vous sera facturé pour votre première semaine. Si vous ne résiliez pas, Everydoggy prolongera automatiquement votre abonnement à la fin de votre période d'essai et prélèvera les frais d'abonnement (actuellement <span class=\"price2\">$29.99</span>) toutes les 2 semaines jusqu'à résiliation.\r\n\n",
		"disclaimerV2_text_2": "En continuant, vous acceptez nos <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Conditions générales d'utilisation</a> et notre <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Politique de confidentialité</a> et autorisez le renouvellement automatique de votre abonnement.\r\nAujourd'hui, seul un montant de <span class=\"price1\">$6.99</span> vous sera facturé pour vos 4 premières semaines. \r\nSi vous ne résiliez pas, Everydoggy renouvellera automatiquement votre abonnement à la fin de votre période d'essai et \r\nprélèvera les frais d'abonnement (actuellement <span class=\"price2\">$29.99</span>) toutes les 2 semaines jusqu'à résiliation.\r\n",
		"disclaimerV2_text_3": "En continuant, vous acceptez nos <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Conditions générales d'utilisation</a> et notre <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Politique de confidentialité</a> et autorisez le renouvellement automatique de votre abonnement.\r\nAujourd'hui, seul un montant de <span class=\"price1\">$14.99</span> vous sera facturé pour vos 12 premières semaines. \r\nSi vous ne résiliez pas, Everydoggy renouvellera automatiquement votre abonnement à la fin de votre période d'essai et \r\nprélèvera les frais d'abonnement (actuellement <span class=\"price2\">$49.99</span>) toutes les 4 semaines jusqu'à résiliation.\r\n",
		"chatUpsaleV2_1": "Chat avec un éducateur canin",
		"chatUpsaleV2_2": "Entraînez-vous avec un expert en comportement canin",
		"chatUpsaleV2_3": "Ajoutez un support chat illimité d’éducateurs canins expérimentés à votre plan",
		"chatUpsaleV2_4": "Avec éducateur",
		"chatUpsaleV2_5": "Efficacité",
		"chatUpsaleV2_6": "Des réponses claires d’un véritable expert",
		"chatUpsaleV2_7": "Des conseils personnalisés pour votre chien",
		"chatUpsaleV2_8": "Des résultats plus rapides avec moins d’erreurs",
		"chatUpsaleV2_9": "Un entraînement calme et en confiance",
		"chatUpsaleV2_10": "Sans éducateur",
		"chatUpsaleV2_11": "Se demander si vous faites bien les choses",
		"chatUpsaleV2_12": "Des progrès lents et des erreurs répétées",
		"chatUpsaleV2_13": "Des raisons floues derrière les mauvais comportements",
		"chatUpsaleV2_14": "De la frustration pour vous et votre chien",
		"chatUpsaleV2_15": "Chaque chien est différent. Obtenez l’aide d’un expert pour le vôtre !",
		"chatUpsaleV2_16": "Obtenez des réponses même aux questions les plus difficiles sur le comportement canin",
		"chatUpsaleV2_17": "Recevez un soutien à la fois émotionnel et pratique pour l’entraînement",
		"chatUpsaleV2_18": "Réduisez le stress et la frustration pendant l’entraînement",
		"chatUpsaleV2_19": "Profitez d’un accompagnement personnalisé adapté à vous et à votre chien",
		"chatUpsaleV2_20": "Bénéficiez d’un soutien professionnel pour des résultats maximum",
		"chatUpsaleV2_21": "Places limitées",
		"chatUpsaleV2_22": "Dernières places disponibles",
		"chatUpsaleV2_23": "Accès au chat avec un éducateur canin pendant 4 semaines :",
		"chatUpsaleV2_24": "Remise supplémentaire de 75 % — durée limitée :",
		"chatUpsaleV2_25": "Total",
		"chatUpsaleV2_26": "Obtenir l’aide d’un expert maintenant",
		"chatUpsaleV2_27": "Continuer sans chat avec un éducateur canin",
		"chatUpsaleV2_28": "Puis-je poser n’importe quelle question sur mon chien ?",
		"chatUpsaleV2_29": "Oui ! Vous pouvez poser des questions sur le comportement, l’éducation, les problèmes de chiot ou les difficultés spécifiques que vous rencontrez.",
		"chatUpsaleV2_30": "Sous quel délai vais-je recevoir une réponse ?",
		"chatUpsaleV2_31": "En semaine, nos éducateurs expérimentés répondent généralement sous 24 heures.",
		"chatUpsaleV2_32": "Ai-je besoin d’une expérience préalable en éducation ?",
		"chatUpsaleV2_33": "Pas du tout. Nos éducateurs vous guident pas à pas, que vous soyez débutant(e) ou propriétaire expérimenté(e)."
	},
	"de": {
		"global \ninstruction": "",
		"safe": "Ihre Informationen sind sicher",
		"information": "Wir werden Ihre persönlichen Kontaktdaten unter keinen Umständen verkaufen oder vermieten.",
		"secure_checkout": "Sicherer Checkout",
		"encrypted": "Alle Informationen sind verschlüsselt und risikofrei über ein Secure Sockets Layer-Protokoll übertragen.",
		"help": "Brauchen Sie Hilfe?",
		"contact": "Kontaktieren Sie uns",
		"here": "hier.",
		"undefined": "",
		"featured": "Wie in",
		"main_title": "Hundeausbildungskurse",
		"per_year": "pro Jahr",
		"special_offer": "Sonderangebot",
		"card_number": "Kartennummer",
		"card_expiry": "Karte läuft ab",
		"security_number": "Sicherheitsnummer",
		"email": "E-Mail",
		"To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of __period__ and at the full, not discounted, price of __fullPriceText__ To learn more visit our <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">terms of use</a>.": "Zahlungsinformationen",
		"secure_server": "Sicherer Server",
		"pay": "Bezahlen",
		"enter_your_email": "Geben Sie Ihre E-Mail ein",
		"comment_1": "Während einiger stressiger Jahre habe ich völlig meine Form verloren und etwas Fett zugenommen, aber ich hatte keine Zeit oder Motivation, etwas dagegen zu tun. Ein Familienmitglied schlug Verv vor und jetzt verlasse ich mich täglich auf meinen Coach!",
		"comment_2": "Verv hat mir geholfen, Home-Workouts zu genießen, und ich habe in einem Monat 7 kg verloren. Diese App könnte Ihnen wirklich helfen, wenn Sie wie ich ein Anfänger beim Workout und Abnehmen sind.",
		"success_story": "Erfolgsgeschichte",
		"get_my_plan": "MEINEN PLAN HOLEN",
		"delimiter": "oder",
		"pay_buy_card": "Mit Karte bezahlen",
		"get_my_plan_warning_1": "Um Unterbrechungen zu vermeiden, stimmen Sie zu, dass das von Ihnen gewählte Abonnement automatisch für einen aufeinanderfolgenden Verlängerungszeitraum von",
		"get_my_plan_warning_2": "und zum vollen, nicht rabattierten Preis von",
		"get_my_plan_warning_3": "Um mehr zu erfahren, besuchen Sie unser",
		"get_my_plan_warning_text": "Indem Sie fortfahren, stimmen Sie zu, dass, wenn Sie nicht mindestens 24 Stunden vor dem Ende des ersten Verlängerungszeitraums stornieren, Ihnen automatisch der volle Preis von __fullPriceText__ alle __period__ in Rechnung gestellt wird, bis Sie stornieren.",
		"terms_of_use": "Nutzungsbedingungen",
		"privacy_policy": "Datenschutzrichtlinie",
		"terms_conditions": "Allgemeine Geschäftsbedingungen",
		"privacy_policy_footer": "Datenschutzrichtlinie",
		"terms_conditions_footer": "Allgemeine Geschäftsbedingungen",
		"guaranteed": "Garantierte sichere Zahlung",
		"special_features": "Besondere Funktionen für Sie",
		"calories_value": "kcal",
		"personalized_plan": "Erhalten Sie Ihren persönlichen Plan:",
		"mobile_app": "Mobile App mit Ihrem Plan",
		"daily_programs": "Tägliche Programme für verschiedene Ziele (Fettverbrennung, Stressabbau, Muskelaufbau)",
		"audio_guided": "Audio-geführte Workouts",
		"easy_to_cook": "Einfach zuzubereitende und schmackhafte Gerichte",
		"comprehensive_stats": "Umfassende Statistiken",
		"secret_tips": "Geheime Tipps zur Entwicklung gesunder Gewohnheiten",
		"mobile_app_tailor": "Maßgeschneiderter Plan in Ihrer Tasche",
		"daily_programs_for": "Tägliche Programme",
		"daily_programs_for_2": "Für verschiedene Ziele (Fett verbrennen, Stress reduzieren, Muskelaufbau)",
		"audio_trainers": "Professionelle Traineranleitungen",
		"comprehensive_track": "Verfolgen Sie Ihren Fortschritt mit ultimativen Statistiken",
		"price": "Preis",
		"users_love": "Benutzer lieben unseren Personalisierten Plan",
		"alternative_review_name_1": "Therealtierra",
		"alternative_review_title_1": "Tolle App!",
		"alternative_review_contentent_1": "Ich bin in der neunten Woche und mein Körper hat sich enorm verändert!",
		"alternative_review_name_2": "Tennismädchen",
		"alternative_review_title_2": "Es funktioniert!",
		"alternative_review_contentent_2": "Gerade das Programm beendet. Ich liebe es. Habe 15 kg abgenommen!!",
		"you_re_in": "Du bist dabei!",
		"personal_plan_starts": "Ihr persönlicher Verv-Plan beginnt heute und die Uhr tickt. Also schauen Sie es sich an!",
		"app_by_link": "Um in Ihr Programm einzutreten, laden Sie die App über den Link herunter",
		"download_now": "Jetzt herunterladen",
		"or": "oder",
		"price_after_trial": "Preis nach der-Testphase",
		"seven_days_trial_unlocked": "7-tägige Testversion freigeschaltet",
		"total_today": "Insgesamt heute",
		"reserved_price_for": "Reservierter Preis für",
		"new_subscritions1_title": "Wählen Sie Ihren Plan",
		"new_subscritions1_subscription1_line1": "Halbjahresplan",
		"new_subscritions1_subscription1_price1_time": "pro Woche",
		"new_subscritions1_subscription2_line1": "3-Monats-Plan",
		"new_subscritions1_subscription2_price2_time": "pro Woche",
		"new_subscritions1_subscription3_line1": "1-Monats-Plan",
		"new_subscritions1_subscription3_price3_time": "pro Woche",
		"new_subscription_save": "SPEICHERN",
		"new_subscritions_agreement": "Durch die Fortsetzung stimmen Sie zu",
		"new_subscritions_and": "und",
		"new_subscritions_subtitle": "Unsere Nutzer haben 10 Millionen Pfund verloren",
		"new_subscritions_join": "Schließen Sie sich Millionen unserer zufriedenen Nutzer an",
		"statistic_block_item1_text": "Sterne aus 5",
		"statistic_block_item2_text": "5-Sterne-Bewertungen",
		"statistic_block_item3_text": "Downloads",
		"get_your_personalized_plan": "Erhalten Sie Ihren personalisierten Plan",
		"for": "für",
		"new_subscription_save_mostPopular1MonthPrice": "der beliebteste Plan",
		"timer_additional_discount": "Zusätzlicher Rabatt gerade angewendet ",
		"timer_additional_discount_bold": "für dich",
		"timer_offer_expires": "Dieses Angebot läuft ab in:",
		"Payment Successful": "",
		"payment_successful_title": "Hallo vom Verv-Team!",
		"payment_successful_download": "Laden Sie die App herunter",
		"payment_successful_press": "Drücken",
		"payment_successful_login": "Melden Sie sich mit Ihrer E-Mail an",
		"payment_successful_email": "Geben Sie Ihre E-Mail-Adresse ein",
		"payment_successful_code": "und Ihr Bestätigungscode:",
		"payment_successful_hit": "Dann tippen Sie",
		"payment_successful_done": "Fertig",
		"payment_successful_description": "Sie sind dabei, genießen Sie Ihren personalisierten Trainingsplan!",
		"Tariffs Variants": "",
		"tariff_title_choose": "Wählen Sie Ihren Plan",
		"tariff_title_get": "Holen Sie sich Ihren Plan",
		"tariff_one_month": "1-Monatsplan",
		"tariff_three_month": "3-Monats-Plan",
		"tariff_six_month": "6-Monats-Plan",
		"tariff_one_year": "1-Jahres-Plan",
		"tariff_one_week": "1-Wochen-Plan",
		"tariff_three_day": "3-Tage-Plan",
		"tariff_per_year": "pro Jahr",
		"tariff_per_day": "pro Tag",
		"tariff_per_days": "alle 3 Tage",
		"tariff_per_week": "pro Woche",
		"tariff_week": "Woche",
		"tariff_annual": "Jahresplan",
		"tariff_trial_one_week": "1-Wochen-Test",
		"tariff_after": "nach ",
		"tariff_save": "Speichern",
		"tariff_best_offer": "bester Preis",
		"tariff_most_popular": "am beliebtesten",
		"tariff_limited_promo": "begrenzter Aktionspreis",
		"tariff_6_for_3": "6 zum Preis von 3",
		"tariff_first_month": "erster Monat",
		"tariff_first_week": "erste Woche",
		"tariff_monthly": "monatlich",
		"tariff_quaterly": "vierteljährlich",
		"tariff_semiannually": "halbjährlich",
		"tariff_billed_every ": "gerechnet jeden ",
		"tariff_year": "Jahr",
		"tariff_month": "Monat",
		"tariff_months": "Monate",
		"tariff_months_variable": "Monate",
		"tariff_organic_gift": "Meditationsplan",
		"tariff_full_price": "Gesamtpreis",
		"tariff_no_hidden_fees": "Keine versteckten Gebühren",
		"tariff_start_right_now": "Jetzt starten",
		"tariff_more_than": "Mehr als 1.000.000 aktive Mitglieder der Verv-Familie",
		"tariff_intro_offer": "EINSTEIGEROFFERTE",
		"Тарифы плиткой в ряд": "",
		"": "Hätte nie gedacht, dass mein Hund so unglaublich schlau ist. Mit EveryDoggy haben wir 5 neue Tricks in nur einer Woche gelernt!",
		"Checkout": "",
		"checkout_title": "Wählen Sie die Zahlungsmethode",
		"insufficient_funds": "Unzureichende Mittel",
		"insufficient_we_have": "Wir haben ein",
		"insufficient_special_price": "Sonderpreis",
		"insufficient_for_you": "für dich",
		"checkout_edit_card": "Karte bearbeiten",
		"checkout_pay_via": "Bezahlen über",
		"checkout_paypal": "PayPal",
		"checkout_credit_card": "Kreditkarte",
		"checkout_paypal_description": "Ihre Zahlung wird über PayPal verarbeitet",
		"checkout_total_price": " Gesamtpreis",
		"checkout_warning_1": "Um Unterbrechungen zu vermeiden, stimmen Sie zu, dass das von Ihnen ausgewählte Abonnement automatisch für einen nachfolgenden Verlängerungszeitraum verlängert wird",
		"checkout_warning_2": "und zum vollen, nicht rabattierten Preis von",
		"checkout_warning_3": "Um mehr zu erfahren, besuchen Sie unser",
		"spv2_warning": "Um Unterbrechungen zu vermeiden, stimmen Sie zu, dass das von Ihnen ausgewählte Abonnement automatisch für einen nachfolgenden Verlängerungszeitraum von __________ und zum vollen, nicht ermäßigten Preis von __________ verlängert wird. Um mehr zu erfahren, besuchen Sie unsere <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">Nutzungsbedingungen</a>.",
		"checkout_offer_day_for": "Tag für",
		"checkout_offer_days_for": "Tage für",
		"checkout_offer_month_for": "Monat für",
		"checkout_offer_months_for": "Monate für",
		"checkout_offer_week_for": "Woche für",
		"Values": "",
		"value_kg": "kg",
		"value_pounds": "lbs",
		"value_st": "st",
		"value_g": "g",
		"value_kcal": "kcal",
		"value_min": "min",
		"value_min_cooking": "Minuten Kochen",
		"welcome_title": "Willkommen bei Verv Premium!",
		"item_1_title": "Juhu!",
		"item_1_description": "Ihr Zielgewicht von __weight__ ist jetzt zum Greifen nah.",
		"item_2_title": "Wie man aktiviert",
		"item_2_description": "Laden Sie die App über den folgenden Link herunter, verwenden Sie Ihre E-Mail __mail__ und geben Sie diesen Validierungscode ein: __code__.",
		"item_2_description_2": "Um die E-Mail zu ändern, klicken Sie <button id=\"changeMail\">hier</button>.",
		"item_3_title": "Etwas ist schiefgegangen?",
		"item_3_description": "Eine detaillierte Anleitung wurde an Ihre E-Mail-Adresse gesendet. Wenn Sie sie nicht erhalten haben, kontaktieren Sie <a target=\"_blank\" href=\"mailto:support@verv.com?subject=Problem beim Anmelden (simple-login)\">den Support</a>.",
		"change": "Bestätigen",
		"change_mail": "Ändern Sie hier Ihre E-Mail-Adresse, um Premium zu aktivieren",
		"email_warning": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
		"Promo Code Block": "",
		"promo_code_title": "Gutscheincode angewendet!",
		"promo_code_save": "% Rabatt",
		"EveryDoggy": "",
		"dog_courses": "Hunde-Kurse",
		"why_we_best_active": "Aktive Benutzer.",
		"why_we_best_lessons": "Video-Lektionen.",
		"why_we_best_brain": "Gehirnspiele.",
		"why_we_best": "Warum sind wir die Besten?",
		"why_we_best_join": "Treten Sie unserer Gemeinschaft von Hundebesitzern bei und geben Sie Ihr Bestes mit EveryDoggy.",
		"why_we_best_enjoy": "Genießen Sie Ihren personalisierten Trainingsplan, der auf Ihre und die Ziele Ihres Hundes abgestimmt ist.",
		"why_we_best_keep": "Halten Sie Ihren Hund mit über 70 Denkspielen geistig und körperlich aktiv.",
		"dog_problems": "Schnelle Lösungen für Verhaltensprobleme",
		"dog_problems_choose": "Wählen Sie die unerwünschten Verhaltensweisen aus, die Sie verbessern möchten",
		"dog_problems_leash": "Leine<br/>zieht",
		"dog_problems_biting": "Beißen",
		"dog_problems_anxiety": "Trennungsangst<br/>",
		"dog_problems_chewing": "Zerstörerisches<br/>Kauen",
		"dog_plan": "Personalisierter Trainingsplan",
		"dog_plan_our": "Unser Trainingsprogramm ist zu 100 % auf die Bedürfnisse Ihres Hundes abgestimmt.",
		"dog_reviews": "Was Hundebesitzer über EveryDoggy sagen",
		"dog_reviews_text_1": "«Sehr klare und leicht verständliche Lektionen. Mein Welpe liebt das Training und wir haben beide viel gelernt.»",
		"dog_reviews_name_1": "Megan und Leo",
		"dog_reviews_text_2": "Der Befehl „Zen“ bewirkt Wunder. Dank ihm ist mein Hund in der Tierklinik während der Behandlungen super ruhig.",
		"dog_reviews_name_2": "Linda B.",
		"dog_reviews_text_3": "„Danke für die Clicker-Trainingsstunde. Ich habe gehört, dass es sehr beliebt ist, aber ich wusste nicht, wie man es benutzt. Ich habe meinen Hund schnell mit dem Clicker vertraut gemacht und jetzt haben wir begonnen, Tricks zu lernen.“",
		"dog_reviews_name_3": "Jake L.",
		"join_text": "Glückliches Hundepartner werden Sie mit EveryDoggy",
		"join_courses": "Webkurse beitreten",
		"checkout_introductory": "Einführungsangebot Rabatt",
		"checkout_personalized_plan": "Ihr personalisierter Plan",
		"Personal plan": "",
		"goal_lose_weight": "Effektives Gewichtsverlustprogramm mit geleiteten workouts, Ernährungs-Tracker und einer Vielzahl von Aktivitäten für Sie",
		"goal_gain_muscles": "Effektives Ganzkörperstraffungsprogramm mit geführten Workouts, Ernährungstracker und einer Vielzahl von Aktivitäten für Sie",
		"goal_gain_healthier_life": "Neue gesunde Routine mit geführten Ganzkörper-Workouts, Ernährungstracker und einer Vielzahl von Aktivitäten für Sie",
		"goal_gain_flexibility": "Yoga-Programm für Flexibilität mit geführten Sitzungen und beruhigender Musik, Ernährungstracker und einer Vielzahl anderer Aktivitäten",
		"goal_gain_build_endurance": "Ausdauertrainingsprogramm mit geführten Workouts, Ernährungs-Tracker und einer Vielzahl von Aktivitäten für Sie",
		"goal_love_myself": "Eine Vielzahl von Aktivitäten zur Steigerung Ihres Selbstwertgefühls, geführte Meditationen, Yoga-Sitzungen und Ganzkörper-Workouts",
		"body_type_apple": "Übungen für den apfelförmigen Körper, um deinen Kern zu straffen und deine Taille zu verfeinern.",
		"body_type_pear": "Übungen für einen birnenförmigen Körper, um Hüften und Oberschenkel zu straffen",
		"body_type_square": "Übungen für einen quadratischen Körpertyp, um Ihre Taille zu definieren und Ihre Gesäßmuskeln zu trainieren",
		"body_type_hourglass": "Übungen für einen Sanduhr-förmigen Körper, um Ihnen zu helfen, erstaunliche Ergebnisse zu erzielen",
		"body_type_triangle": "Übungen für den Körperbau in Form eines umgedrehten Dreiecks zur Stärkung Ihrer Hüften und Oberschenkel",
		"body_type_unknown": "Übungen, um das Beste aus Ihrer Körperform herauszuholen",
		"excercises_time_morning": "Morgentraining, um Ihren Stoffwechsel anzukurbeln und Sie den ganzen Tag über zu beleben",
		"excercises_time_day": "Workout-Programme, die perfekt in Ihren Zeitplan passen, Ihren Stoffwechsel ankurbeln und Ihnen den ganzen Tag über Energie verleihen.",
		"excercises_time_evening": "Abendliche Workouts, um Ihnen zu helfen, Stress nach einem langen Tag abzubauen und Sie auf einen guten Schlaf vorzubereiten.",
		"excercises_not_sure": "Workouts, die perfekt in Ihren Zeitplan passen, Ihren Stoffwechsel ankurbeln und Sie den ganzen Tag über energiegeladen halten",
		"diet_type_all": "Einfache gesunde Rezepte",
		"diet_type_vegetarian": "Gesunde vegetarische Rezepte",
		"diet_type_vegan": "Gesunde vegane Rezepte",
		"diet_type_keto": "Gesunde Keto-Rezepte",
		"personal_plan_providers_title": "",
		"special_features_title": "Besondere Funktionen für Sie",
		"special_features_duration_minimum": "Kurze Sitzungen unter 10 Minuten",
		"special_features_duration_normal": "Bequeme Sitzungen unter 20 Minuten",
		"special_features_duration_maximum": "Effektive Sitzungen über 20 Minuten",
		"special_features_duration_verv": "Bequeme Sitzungen mit unseren Trainern",
		"special_features_goal_lose_weight": "Geheime Abnehmtipps von Experten",
		"special_features_goal_gain": "Geheime Muskelstraffungstipps von Experten",
		"special_features_goal_health": "Geheime Gesundheitstipps von Experten",
		"special_features_goal_flexibility": "Geheime Flexibilitätstipps von Experten",
		"special_features_goal_endurance": "Geheime Tipps zur Steigerung der Ausdauer",
		"special_features_goal_love": "Geheime Tipps zur Steigerung des Selbstwertgefühls",
		"discount_activated": "50 % Rabatt aktiviert",
		"discount_no_activated": "50 % Rabatt",
		"unlocked_with_promo": "Mit dem Aktionscode entsperrt:",
		"use_with_button": "Verwenden Sie Ihren speziellen Promo-Code:",
		"plan_optimal": "Optimal",
		"plan_standard": "STANDARD",
		"plan_basic": "GRUNDLEGEND",
		"plan_extra": "EXTRA",
		"daypayback_review_name_1": "melliebeth",
		"daypayback_review_text_1": "",
		"daypayback_review_name_2": "katie_zu13",
		"daypayback_review_text_2": "Ich liebe Verv! Das Folgen meines persönlichen Trainings- und Ernährungsplans hat mir geholfen, wieder in Form zu kommen und selbstbewusster zu werden! Ich habe mit kurzen Fitness-Workouts von unter 15 Minuten begonnen, die perfekt für einen Anfänger wie mich waren. Dann habe ich meine Ausdauer gesteigert und meine Trainingszeit auf 30-40 Minuten pro Sitzung erhöht. Ich habe langsam aber sicher 25 Pfund in 6 Monaten mit Verv verloren!",
		"daypayback_review_name_3": "Jean_leon1",
		"daypayback_review_text_3": "Ich habe während des Studiums viel zugenommen. Nach meinem Abschluss habe ich verschiedene Diäten ausprobiert, die mir beim Abnehmen geholfen haben, aber das Gewicht kam immer ein paar Monate nach der Diät zurück. Letztes Jahr habe ich von Verv von einem Kollegen gehört und beschlossen, es auszuprobieren. Mit den personalisierten Empfehlungen von Verv habe ich es geschafft, Gewicht zu verlieren und es danach zu halten!",
		"daypayback_review_name_4": "maryanne1993",
		"daypayback_review_text_4": "Nach einer schweren Trennung habe ich beschlossen, mein Leben zu ändern, Gewicht zu verlieren und gesünder zu werden. Aber ich wusste nicht, wo ich anfangen sollte. Ich fühlte mich nicht selbstbewusst genug, um mit anderen zu trainieren, also beschloss ich, es mit Home-Workout-Apps zu versuchen, und Verv kam mir bei meiner Suche in den Sinn. Es bot mir einen auf meine Bedürfnisse zugeschnittenen Plan an. Ich habe ihm gefolgt und es geschafft, den Körper meiner Träume zu bekommen!",
		"personal_plan_you_get": "Mit Ihrem personalisierten Plan erhalten Sie",
		"goal": "Ziel",
		"goal_other": "Lektionen zur Ausbildung Ihres pelzigen Freundes",
		"goal_teaching_puppy": "Lektionen, um Ihrem pelzigen Freund Manieren und Gehorsam beizubringen",
		"goal_surviving_puppy": "Lektionen, die Ihnen helfen, sich auf die ersten Tage mit Ihrem pelzigen Freund vorzubereiten",
		"goal_socializing_puppy": "Lektionen, die Ihnen helfen, Ihren pelzigen Freund zu sozialisieren",
		"goal_teaching_obedience": "Lektionen für die Erziehung Ihres pelzigen Freundes in Anstand und Gehorsam",
		"age_puppy": "Detaillierte Trainingstipps von unseren Experten, um Ihnen zu helfen, einen glücklichen und gut erzogenen Welpen großzuziehen",
		"age_adult": "Detaillierte Trainingstipps von unseren Experten, um Ihnen zu helfen, Ihren Hund auf die effektivste Weise zu trainieren",
		"biting_yes": "Schritt-für-Schritt-Anleitungen, um Ihren Hund vom Beißen abzuhalten",
		"biting_no": "Unterhaltsame Spiele, um mit Ihrem Hund zu spielen",
		"biting_sometimes": "Schritt-für-Schritt-Anleitungen, um Ihren Hund am Beißen zu hindern",
		"quick_tips": "Schnelle und einfache Tipps zum Erlernen neuer Befehle",
		"potty_training_a_bit": "Ein spezieller Leitfaden, um Ihren Welpen effektiv stubenrein zu machen",
		"potty_training_yes": "Besondere Anleitungen, um Ihrem Welpen neue lustige Tricks beizubringen",
		"potty_training_no": "Ein spezieller Leitfaden, um Ihren Welpen effektiv stubenrein zu bekommen",
		"success screen": "",
		"success_screen_text_1": "Danke für Ihren Kauf!",
		"success_screen_text_2": "Befolgen Sie die Anweisungen unten, um<br />Ihr Konto einzurichten:",
		"success_screen_text_3": "Gehe zu deinem <b>Konto</b>",
		"success_screen_text_4": "Scannen Sie den <b>QR-Code</b> oder tippen Sie auf <b>den Link</b>",
		"success_screen_text_5": "<b>Laden Sie</b> die App herunter",
		"success_screen_text_6": "<b>Öffnen Sie die App</b> und <b>freuen Sie sich</b><br /> auf das Training mit Ihrem Hund!",
		"success_screen_text_7": "Wir haben den QR-Code und den Link für Sie unter &nbsp;<b>example@gmail.com</b> dupliziert",
		"success_screen_text_8": "Wenn das Premium-Konto in der App nicht angewendet wurde, drücken Sie <b>„Kontaktieren Sie uns“</b> auf dem Begrüßungsbildschirm und wenden Sie sich an unser Support-Team.",
		"success_screen_text_9": "Durch Drücken der Schaltfläche „Loslegen“ bestätige ich, dass ich die <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Datenschutzerklärung</a> und die <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Allgemeinen Geschäftsbedingungen</a> gelesen habe und damit einverstanden bin, dass meine personenbezogenen Daten verarbeitet werden.",
		"success_screen_text_10": "Kontaktieren Sie uns",
		"success_screen_text_11": "Gehe zu meinem Konto",
		"success_screen_text_12": "Wir haben Ihnen einen duplizierten QR-Code und einen Link per E-Mail geschickt.",
		"success_screen_text_13": "Ihr PDF-Leitfaden wurde an Ihre E-Mail-Adresse <b>v.stsiopina@gmail.com</b> gesendet.",
		"success_screen_text_14": "Ihr PDF-Guide wurde an Ihre E-Mail-Adresse gesendet.",
		"success_screen_text_15": "Wenn das Premium-Konto in der App nicht aktiviert wurde, drücken Sie den <span>'Einloggen'</span>-Link auf dem Begrüßungsbildschirm in der App und geben Sie Ihre E-Mail und das Passwort ein, das wir Ihnen unter <b>stepinavalerie@gmail.com</b> gesendet haben.",
		"success_screen_text_16": "Wenn das Premium-Konto in der App nicht angewendet wurde, klicken Sie auf den <span>'Anmelden'</span>-Link auf dem Welcome-Bildschirm in der App und geben Sie Ihre E-Mail-Adresse und das Passwort ein, das wir Ihnen per E-Mail gesendet haben.",
		"payment_text_1": "Ihr Hundetrainingsprogramm beginnt jetzt!",
		"payment_text_2": "Die Everydoggy-App wird Ihnen helfen, <span>alle Verhaltensprobleme Ihres Hundes schnell und mit Spaß zu lösen</span>.",
		"payment_text_3": "Das persönliche Angebot läuft ab",
		"payment_text_4": "von unseren Nutzern bemerken positive Veränderungen im Verhalten ihres Hundes nur 1 Woche nach Beginn des Trainings mit unseren Experten",
		"payment_text_5": "JederHund gegen Trainer",
		"payment_text_6": "Durchschnittliche Anzahl der Bestellungen pro Monat",
		"payment_text_7": "JederHund profitiert",
		"payment_text_8": "Personalisierter Trainingsplan für Hunde",
		"payment_text_9": "Nur 15 Minuten am Tag zu einem perfekten Haustier",
		"payment_text_10": "Über 70 leicht verständliche Video-Trainingseinheiten für schnelle Ergebnisse",
		"payment_text_11": "Über 80 Spiele und Tricks für neue Fähigkeiten und einfach zum Spaß",
		"payment_text_12": "Tipps zu Hygiene, Gesundheit und Ernährung",
		"payment_text_13": "Trainieren Sie zu Hause und im Freien, keine Ausrüstung erforderlich",
		"payment_text_14": "98 % unserer Nutzer bemerken bereits nach 1 Woche positive Veränderungen im Verhalten ihres Hundes, nachdem sie mit unseren Experten mit dem Training begonnen haben.",
		"payment_text_14_2": "<span>98 % unserer Nutzer</span> bemerken positive Veränderungen im Verhalten ihres Hundes bereits nach 1 Woche Training mit unseren Experten",
		"payment_text_15": "Durch Klicken auf die Schaltfläche „Mein Plan abrufen“ stimmen Sie unseren <a href='https://everydoggy.com/terms/' target=\"_blank\" >Allgemeinen Geschäftsbedingungen</a> und <a href='https://everydoggy.com/policy/' target=\"_blank\" >Datenschutzrichtlinie</a> zu, <b>genehmigen Sie die automatische Verlängerung</b> Ihres Abonnements am Ende jedes Abrechnungszyklus von <span>1 Monat</span> zum Vollpreis von <i>$29.99</i> zuzüglich der geltenden Steuern. Sie können die automatische Verlängerung Ihres Abonnements jederzeit vor dem Verlängerungsdatum kündigen. Überprüfen Sie unsere <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Kündigungsbedingungen</a> für weitere Details.",
		"payment_text_16": "Durch Klicken auf die Schaltfläche „Mein Plan abrufen“ stimmen Sie unseren <a href='https://everydoggy.com/terms/' target='_blank'>Allgemeinen Geschäftsbedingungen</a> und <a href='https://everydoggy.com/policy/' target='_blank'>Datenschutzrichtlinie</a> zu und <b>genehmigen die automatische Verlängerung</b> Ihres Abonnements am Ende jedes Abrechnungszyklus von <span>1 Monat</span> zum Vollpreis von <i>$29.99</i> zuzüglich der geltenden Steuern. Sie können die automatische Verlängerung Ihres Abonnements jederzeit vor dem Verlängern-Termin kündigen. Überprüfen Sie unsere <a href='https://everydoggy.com/subscription-terms/' target='_blank'>Kündigungsbedingungen</a> für weitere Informationen.",
		"payment_text_17": "Haben Sie eine Frage?",
		"payment_text_18": "Schreiben Sie uns einfach an ",
		"payment_text_19": "Es funktioniert!",
		"payment_text_20": "Habe gerade das Gehorsamkeitstraining mit unserem Welpen abgeschlossen, ich liebe es! 👏",
		"payment_text_21": "Fantastisch!",
		"payment_text_22": "Ich bin mit dieser App zu 💯 Prozent zufrieden. Keine Probleme mehr mit dem Toilettengang, wow!",
		"payment_text_23": "Großartige App 🎉",
		"payment_text_24": "Wir sind jetzt im 3. Monat des Trainings mit meinem Hund und seine Fähigkeiten haben sich enorm verbessert!",
		"payment_text_25": "Einen Versuch wert",
		"payment_text_26": "Die mit Abstand beste App zum Trainieren eines Hundes! ",
		"payment_text_27": "Lass dich von unseren Nutzern inspirieren",
		"payment_text_28": " Star Focus, Inc.",
		"payment_text_29": "Solltest du noch Fragen haben, schreibe uns einfach an <a href=\"mailto:welove@everydoggy.com\">welove@everydoggy.com</a>",
		"payment_text_30": "Sichtbare Ergebnisse nach nur 7 Tagen Training",
		"payment_text_31": "Erhalte deinen persönlichen Plan mit Sonderrabatt",
		"payment_text_32": "Je früher du mit dem Training beginnst, desto besser werden die Ergebnisse sein.",
		"payment_text_33": "Training ist für jeden Hund unerlässlich. Dabei geht es nicht nur um die Beseitigung von Verhaltensproblemen, sondern auch um Sozialisierung, den Aufbau einer Bindung zu deinem Hund und darum, deine Liebe zum Ausdruck zu bringen.",
		"payment_text_34": "Aus und für <span>Liebe</span> zu Hunden geschaffen. Basierend auf erstklassigem Fachwissen",
		"payment_text_35": "Alles, was du in der App findest, basiert auf den neuesten Forschungsergebnissen und ist ganz auf Hunde ausgerichtet.",
		"payment_text_36": "Wenn dein Hund sprechen könnte, würde er dich bitten, EveryDoggy zu testen!",
		"payment_text_37": "Deine Daten sind sicher",
		"payment_text_38": "Ihre persönlichen Kontaktdaten werden von uns keinesfalls zu Marketingzwecken verkauft oder vermietet.",
		"payment_text_39": "Sicherer Kassenvorgang",
		"payment_text_40": "Alle Daten werden verschlüsselt und ohne Risiko übertragen.",
		"payment_text_41": "Du benötigst Hilfe?",
		"payment_text_42": "Sende eine E-Mail an: <a href=\"mailto:welove@everydoggy.com\">welove@everydoggy.com</a>",
		"payment_text_43": "monatlich",
		"payment_text_44": "weiter",
		"payment_text_45": "Dein personalisierter Plan:",
		"payment_text_46": "Einführungsrabatt:",
		"payment_text_47": "Indem du fortfährst, erklärst du dich mit den <a href='https://everydoggy.com/terms/' target='_blank' rel=\"noreferrer\">Geschäftsbedingungen</a>, der <a href='https://everydoggy.com/policy/' target='_blank' rel=\"noreferrer\">Datenschutzerklärung</a> und <a href='https://everydoggy.com/subscription-terms/#subscription_cancellation' target='_blank' rel=\"noreferrer\">den Kündigungsbedingungen einverstanden</a>.",
		"payment_text_48": "Dein Abonnement läuft bis",
		"payment_text_49": "Du kannst jederzeit bis spätestens 24 Stunden vor Ablauf des Abonnementzeitraums kostenlos kündigen.",
		"payment_text_50": "Wenn du nicht kündigst, verlängert sich deine Mitgliedschaft automatisch zum Ende deines Abonnements. Bis zu deiner Kündigung wird dir der Mitgliedsbeitrag von EveryDoggy in Höhe von <b>$</b><i>$29.99</i> berechnet.",
		"payment_text_51": "Wir bieten derzeit keine Rückerstattungen oder Gutschriften für Teilmitgliedschaften an.",
		"payment_text_52": "Persön-licher<br> Betreuer",
		"payment_text_53": "Hunde-schule",
		"payment_text_54": "YouTube-<br>Lektionen",
		"payment_text_55": "Bücher",
		"payment_text_56": "wöchentlich",
		"payment_text_57": "Erheblich bessere Ergebnisse",
		"payment_text_58": "Mit EveryDoggy",
		"payment_text_59": "Ohne EveryDoggy",
		"payment_text_60": "Jetzt",
		"payment_text_61": "Nach 1 Woche",
		"payment_text_62": "Das ist Ihre letzte Chance",
		"payment_text_63": "Verpassen Sie nicht den exklusiven Rabatt von 65&nbsp;% und entdecken Sie, wie schnell Ihr Hund lernt und gehorcht!",
		"payment_text_64": "Erhalten Sie 65&nbsp;% Rabatt",
		"payment_text_65": "52-WOCHEN-PLAN",
		"payment_text_66": "4-WOCHEN-PLAN",
		"payment_text_67": "12-WOCHEN-PLAN",
		"payment_text_68": "Wochen",
		"payment_text_69": "Januar",
		"payment_text_70": "Februar",
		"payment_text_71": "März",
		"payment_text_72": "April",
		"payment_text_73": "Mai",
		"payment_text_74": "Juni",
		"payment_text_75": "Juli",
		"payment_text_76": "August",
		"payment_text_77": "September",
		"payment_text_78": "Oktober",
		"payment_text_79": "November",
		"payment_text_80": "Dezember",
		"payment_text_81": "Bitte gib eine gültige E-Mail Adresse ein",
		"payment_text_82": "Für die erste Woche werden Ihnen heute nur <b>$6.99</b> berechnet (weitere Informationen unten)",
		"payment_text_83": "Ihr Einführungszeitraum läuft bis zum <b>Oct 11, 2024</b>.",
		"payment_text_84": "Sie können vor dem <b>Oct 10, 2024</b> jederzeit gebührenfrei kündigen.",
		"payment_text_85": "Wenn Sie nicht kündigen, verlängert sich Ihre Mitgliedschaft bei EveryDoggy zum Ende des Einführungszeitraums. Im Anschluss fällt <span>monatlich</span> eine Mitgliedsgebühr (aktuell <b>$39.99 USD</b>) an, bis Sie Ihr Abonnement kündigen.",
		"payment_text_86": "Teilerstattungen sind nicht möglich. Sie können Ihr Abonnement jederzeit in Ihren Kontoeinstellungen kündigen.",
		"payment_text_87": "Ihr Abonnement unterliegt unseren allgemeinen <a href='https://everydoggy.com/terms/' target=\"_blank\" >Geschäftsbedingungen</a>, unseren <a href='https://everydoggy.com/policy/' target=\"_blank\" >Datenschutzbestimmungen</a> und unseren <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Kündigungsbedingungen</a>.",
		"payment_text_88": "Zahlungsmethode",
		"payment_text_89": "EveryDoggy verwendet Ihre Zahlungsinformationen, um künftige Zahlungsvorgänge einfacher durchführen zu können",
		"payment_text_90": "Einfache und private Zahlungen mit Face ID/Touch ID",
		"payment_text_91": "Ihre finanziellen Informationen bleiben dank Ende-zu-Ende-Verschlüsselung sicher geschützt",
		"payment_text_92": "Geschützt durch Apple Pays einmalige Gerätekontonummer",
		"payment_text_93": "Ihre Zahlungsinformationen werden mit SSL-/TLS-Verschlüsselung abgesichert",
		"payment_text_94": "Schnelle, bequeme Zahlungsmöglichkeit",
		"payment_text_95": "Unterstützt durch den marktführenden Betrugsschutz von PayPal",
		"payment_text_96": "Kauf bestätigen",
		"payment_text_97": "1-WOCHE",
		"payment_text_98": "1-MONAT",
		"payment_text_99": "3-MONATE",
		"payment_text_100": "Ihnen werden heute nur <b>$6.99</b> $ für Ihren ersten Monat berechnet (Details unten).",
		"payment_text_101": "Ihnen werden heute nur <b>$6.99</b> für Ihre ersten 3 Monate berechnet (Details unten).",
		"payment_text_102": "Abonnieren mit",
		"payment_text_103": "Durch Klicken auf die Schaltfläche „Meinen Plan erhalten“ stimmen Sie der <a href='https://everydoggy.com/policy/' target=\"_blank\" >Datenschutzrichtlinie</a>, den <a href='https://everydoggy.com/terms/' target=\"_blank\" >Allgemeinen Geschäftsbedingungen</a> und den <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Stornierungsbedingungen</a> zu.",
		"payment_text_104": "Einfache und private Zahlungen",
		"payment_text_105": "Kreditkarte",
		"payment_text_106": "Ablaufdatum",
		"payment_text_107": "CVC",
		"payment_text_108": "Toller Start",
		"payment_text_109": "1-Wochen Plan",
		"payment_text_110": "Die App Everydoggy löst <span>Töpfchenprobleme und andere Verhaltensprobleme von Hunden</span> schnell und mit Spaß.",
		"payment_text_111": "Sicheres Bezahlen",
		"payment_text_112": "Personalisierter Trainingsplan für <span>Ihr Hündchen</span>",
		"payment_text_113": "Pfeife und Klicker für das Training",
		"payment_text_114": "80+ Spiele und Tricks für Ihr Haustier",
		"payment_text_115": "30+ Tipps und Artikel zur Gesundheitspflege",
		"payment_text_116": "🔥 Sie haben gerade <span>$113,50&nbsp;</span>🔥",
		"payment_text_117": "7-Tage-Tarif",
		"payment_text_118": "Indem Sie den \"Meinen Tarif erhalten\"-Button anklicken, stimmen Sie unseren <a href='https://everydoggy.com/terms/' target=\"_blank\" >allgemeinen Geschäftsbedingungen</a> sowie unserer <a href='https://everydoggy.com/policy/' target=\"_blank\" >Datenschutzrichtlinie</a> zu und <b>gestatten die automatische Verlängerung</b> Ihres Abonnements. Ihnen werden heute nur <span class=\"trialPrice\">4,99 $</span> für Ihre ersten <span class=\"trialPeriod\">7 Tage</span>   Einführungszeitraum berechnet. Wenn Sie nicht kündigen, setzt Everydoggy Ihre Mitgliedschaft am Ende Ihres Einführungszeitraums automatisch fort und berechnet Ihnen die Mitgliedschaftsgebühr von <span class='price'>39,99 $</span> jeden <span class='period'>Monat</span>, bis Sie kündigen. Sie können die automatische Verlängerung Ihres Abonnements jederzeit vor dem Verlängerungsdatum beenden.  Weitere Einzelheiten finden Sie in unseren Kündigungsbedingungen.",
		"payment_text_119": "7 Tage",
		"payment_text_120": "Ihnen werden heute nur <b>29,99 $</b> für Ihre ersten <span>12 Wochen</span> berechnet (Einzelheiten nachfolgend).",
		"payment_text_121": "Mit der Everydoggy-App können Sie Ihrem Hund <span>beibringen</span>, <span>an der richtigen Stelle sein Geschäft zu verrichten</span> und <span>Verhaltensprobleme schnell und mit Spaß beheben</span>.",
		"payment_text_122": "Ein stubenreiner Hund in nur 3 Tagen",
		"payment_text_123": "Ihr Konto ist mit dieser E-Mail-Adresse verknüpft und kann nicht geändert werden.",
		"payment_text_124": "Indem Sie fortfahren, stimmen Sie unseren <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">allgemeinen Geschäftsbedingungen</a> sowie unserer <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Datenschutzrichtlinie</a> zu und <span>genehmigen die automatische Verlängerung Ihres Abonnements</span>.",
		"payment_text_125": "26-WOCHEN-PLAN",
		"payment_text_126": "Wenn Sie nicht kündigen, verlängert sich Ihre Mitgliedschaft bei EveryDoggy zum Ende des Einführungszeitraums. Im Anschluss fällt <span>alle 3 Monate</span> eine Mitgliedsgebühr (aktuell <b>$39.99 USD</b>) an, bis Sie Ihr Abonnement kündigen.",
		"payment_text_127": "Wenn Sie nicht kündigen, verlängert sich Ihre Mitgliedschaft bei EveryDoggy zum Ende des Einführungszeitraums. Im Anschluss fällt <span>alle 6 Monate</span> eine Mitgliedsgebühr (aktuell <b>$39.99 USD</b>) an, bis Sie Ihr Abonnement kündigen.",
		"payment_text_128": "Aktueller Stand",
		"payment_text_129": "Kommandos",
		"payment_text_130": "Ziel",
		"payment_text_131": "Mehr als 50 Kommandos und Gehorsamkeit",
		"payment_text_132": "Spürbare Fortschritte erleben",
		"payment_text_133": "Erreichen Sie Gehorsamkeit",
		"payment_text_134": "Halten Sie Ihren Hund ein Leben lang gut erzogen",
		"payment_text_135": "53 % speichern",
		"payment_text_136": "Geld-zurück-Garantie",
		"payment_text_137": "30 Tage Geld-zurück-Garantie",
		"payment_text_138": "Wir glauben, dass unser Plan für Sie funktionieren kann und Sie innerhalb von 4 Wochen sichtbare Ergebnisse erzielen werden! Wir sind sogar bereit, Ihnen Ihr Geld zurückzugeben, wenn Sie keine sichtbaren Ergebnisse sehen und nachweisen können, dass Sie unseren Plan befolgt haben.",
		"payment_text_139": "Mehr über die geltenden Einschränkungen finden Sie in unseren <a href=\"https://everydoggy.com/terms/#section5_2\" target=\"_blank\" rel=\"noreferrer\">Nutzungsbedingungen</a>.",
		"payment_text_140": "65 % speichern",
		"payment_text_141": "Dein Hundetrainingsplan ist bereit!",
		"payment_text_142": "Gehorsamkeit",
		"payment_text_143": "Beherrscht Befehle",
		"payment_text_144": "Toilettenunfälle",
		"payment_text_145": "Häufig",
		"payment_text_146": "Keines",
		"payment_text_147": "Bellen",
		"payment_text_148": "Bellt alles an",
		"payment_text_149": "Ruhig und entspannt",
		"payment_text_150": "Beißen und Kauen",
		"payment_text_151": "Oft",
		"payment_text_152": "Aufgehört",
		"payment_text_153": "An der Leine ziehen",
		"payment_text_154": "Immer",
		"payment_text_155": "Läuft ruhig",
		"payment_text_156": "Trennungsangst",
		"payment_text_157": "Ruhig und unabhängig",
		"payment_text_158": "Vorher",
		"payment_text_159": "Nachher",
		"payment_text_160": "minuten",
		"payment_text_161": "sekunden",
		"payment_text_162": "Bewährt. Getestet. Es funktioniert",
		"payment_text_163": "Deutliche Veränderungen bei der Folgsamkeit des Hundes",
		"payment_text_164": "Heute",
		"payment_text_165": "Woche 2",
		"payment_text_166": "Woche 3",
		"payment_text_167": "Woche 4",
		"payment_text_168": "Deshalb ist EveryDoggy so wirksam",
		"payment_text_169": "Die Erfolgsberichte unserer Anwender",
		"payment_text_170": "Erstellt von Experten, die <span>Hunde lieben</span>",
		"payment_text_171": "Jeder unserer Kurse und Einheiten basiert auf wissenschaftlichen Studien zur Hundeerziehung.",
		"payment_text_172": "Bauen Sie eine tiefe Verbindung zu Ihrem Hund auf, probieren Sie EveryDoggy!",
		"payment_text_173": "Bewährt. Getestet. Es funktioniert",
		"payment_text_174": "<span>93 % unserer Nutzer</span> stellen innerhalb des ersten Trainingsmonats erhebliche Veränderungen im Verhalten ihres Hundes fest.",
		"payment_text_175": "Mit EveryDoggy",
		"payment_text_176": "Ohne EveryDoggy",
		"payment_text_177": "Heute",
		"payment_text_178": "Woche 2",
		"payment_text_179": "Woche 4",
		"payment_text_180": "Woche 6",
		"payment_text_181": "Über Luna",
		"payment_text_182": "Mein Welpe hatte ständig Missgeschicke im Haus. Everydoggy gab uns eine klare Routine, und sie hat tatsächlich funktioniert!",
		"payment_text_183": "Über Cooper",
		"payment_text_184": "Unser Welpe hat beim Spielen nach allen geschnappt. Die App gab uns Schritt-für-Schritt-Anweisungen, und sie haben funktioniert!",
		"payment_text_185": "Über Bella",
		"payment_text_186": "Unser Hund hat an allem gekaut – von Schuhen bis hin zur Couch. Die App half uns, diese Energie umzuleiten!",
		"payment_text_187": "Über Charlie",
		"payment_text_188": "Das Leinenziehen war ein täglicher Kampf. Dank der App sind Gassigänge nun angenehm und stressfrei.",
		"payment_text_189": "Hundeklotrainiert",
		"payment_text_190": "Beißen behoben",
		"payment_text_191": "Kauen behoben",
		"payment_text_192": "Leinenziehen behoben",
		"payment_text_193": "<span>93 % unserer Nutzer</span> bemerken bereits im ersten Trainingsmonat deutliche Veränderungen im <span>Verhalten und Gehorsam ihres Hundes</span>.</span>",
		"payment_text_194": "Unsere Nutzer sind von den Ergebnissen begeistert!",
		"payment_text_195": "Beginnen Sie jetzt, Ihren Hund zu trainieren!",
		"payment_text_196": "Wenn Sie nicht kündigen, wird Everydoggy Ihre Mitgliedschaft am Ende des Schnupperzeitraums automatisch fortsetzen und den Mitgliedsbeitrag (derzeit <b>39,99 USD</b>) <span>alle zwei Wochen</span> berechnen, bis Sie kündigen.",
		"payment_text_197": "Geld-zurück-Garantie",
		"payment_text_198": "30 Tage Geld-zurück-Garantie",
		"payment_text_199": "Wir glauben, dass unser Plan für Sie funktionieren kann und Sie innerhalb von 4 Wochen sichtbare Ergebnisse erzielen werden! Wir sind sogar bereit, Ihnen Ihr Geld zurückzugeben, wenn Sie keine sichtbaren Ergebnisse sehen und nachweisen können, dass Sie unseren Plan befolgt haben.",
		"payment_text_200": "Mehr über die geltenden Einschränkungen finden Sie in unseren <a href=\"https://everydoggy.com/terms/#section5_2\" target=\"_blank\" rel=\"noreferrer\">Nutzungsbedingungen</a>.",
		"payment_text_201": "Häufig gestellte Fragen",
		"payment_text_202": "Wie lange dauert es, bis man Ergebnisse des Trainings sieht?",
		"payment_text_203": "Die meisten Hunde machen schon nach der ersten Sitzung Fortschritte – und innerhalb weniger Wochen sehen Sie beeindruckende, deutliche Ergebnisse!",
		"payment_text_204": "Ist die Everydoggy-App genauso effektiv wie die Zusammenarbeit mit einem Trainer?",
		"payment_text_205": "Ja, und die App ist sogar noch effektiver – Sie können ihren Hund jeden Tag in Ihrem eigenen Tempo trainieren, klare Schritt-für-Schritt-Anleitungen befolgen und seine Fähigkeiten kontinuierlich verbessern, anstatt nur einmal pro Woche mit einem Trainer zu trainieren.",
		"payment_text_206": "Sind die Ergebnisse des Trainings permanent?",
		"payment_text_207": "Ja! Solange Sie weiterhin gute Gewohnheiten pflegen, bleiben die Ergebnisse ein Leben lang bestehen.",
		"payment_text_208": "Erhalten Sie 72&nbsp;% Rabatt",
		"payment_text_209": "Verpassen Sie nicht den exklusiven Rabatt von 72&nbsp;% und entdecken Sie, wie schnell Ihr Hund lernt und gehorcht!",
		"payment_text_210": "Mit einer anderen Zahlungsmethode fortfahren",
		"payment_text_211": "Buy with",
		"payment_text_212": "BLACK-FRIDAY-SALE!",
		"payment_text_213": "",
		"payment_text_214": "",
		"payment_text_215": "",
		"payment_text_216": "",
		"payment_text_217": "",
		"payment_text_218": "Das Trainingsprogramm für Ihren Welpen startet jetzt!",
		"payment_text_219": "Trainieren Sie mit der Everydoggy-App ab <span>den ersten Tagen Ihres Welpen</span> und erhalten Sie <span>einen perfekt erzogenen Hund</span>!",
		"payment_text_220": "unserer Nutzer bemerken positive Veränderungen im Verhalten ihres Welpen bereits 1 Woche nach Trainingsbeginn mit unseren Experten",
		"payment_text_221": "Personalisierter Trainingsplan für Welpen unter 6 Monaten",
		"payment_text_222": "Personalisierter Trainingsplan für Welpen im Alter von 6–12 Monaten",
		"payment_text_223": "Bewährt bei 3 Millionen Welpen",
		"payment_text_224": "Deutliche Verbesserungen im Gehorsam des Hundes",
		"payment_text_225": "Erhalten Sie 70&nbsp;% Rabatt",
		"payment_text_226": "LETZTE CHANCE",
		"payment_text_227": "24-WOCHEN-PLAN",
		"payment_text_228": "Das letzte Trainingsprogramm, das Sie je brauchen werden, beginnt jetzt!",
		"payment_text_229": "Personalisierter Trainingsplan für langfristige Ergebnisse",
		"payment_text_230": "Ein Programm.<br />\nGutes Verhalten auf Dauer",
		"payment_text_231": "Alter des Hundes",
		"payment_text_232": "Trainingsdauer",
		"payment_text_233": "Langfristige Ergebnisse",
		"payment_text_234": "0-1 Jahr",
		"payment_text_235": "1-3 Jahre",
		"payment_text_236": "3-5 Jahre",
		"payment_text_237": "5+ Jahre",
		"payment_text_238": "1-2 Jahre",
		"payment_text_239": "3 Jahre",
		"payment_text_240": "4 Jahre",
		"payment_text_241": "2-7 Jahre",
		"payment_text_242": "8 Jahre",
		"payment_text_243": "9 Jahre",
		"payment_text_244": "10+ Jahre",
		"payment_text_245": "",
		"payment_text_246": "",
		"payment_text_247": "",
		"payment_text_248": "",
		"payment_text_249": "",
		"payment_text_250": "",
		"payment_text_251": "",
		"payment_text_252": "",
		"payment_text_253": "",
		"payment_text_254": "",
		"payment_text_255": "",
		"payment_text_256": "",
		"payment_text_257": "",
		"payment_text_258": "",
		"payment_text_259": "",
		"payment_text_260": "",
		"payment_text_261": "",
		"payment_text_262": "",
		"payment_text_263": "Hunde-Übersetzer",
		"payment_text_264": "Verstehen Sie Ihren Hund.<br/> Sehen Sie die Ergebnisse",
		"payment_text_265": "Die Gehorsamkeit verbessert sich durch die Analyse von Signalen und Verhalten",
		"payment_text_266": "Personalisierter Trainingsplan für Ihren Hund, basierend auf der Analyse seines Bellens und Verhaltens",
		"payment_text_267": "Doppelt so schnell, <br />doppelt so viel Spaß!",
		"payment_text_268": "Holen Sie sich den ultimativen Welpentrainings-Ratgeber",
		"payment_text_269": "Holen Sie sich den ultimativen Hundetrainings-Ratgeber",
		"payment_text_270": "Schluss mit Toilettenproblemen! Mit Schritt-für-Schritt-Methoden bringen Sie Ihrem Hund schnell Stubenreinheit bei.",
		"payment_text_271": "Retten Sie Schuhe und Finger! Mit einfachen Techniken gewöhnen Sie Ihrem Welpen Beißen und Kauen schnell ab.",
		"payment_text_272": "Schaffen Sie Ihrem Hund einen sicheren, angenehmen Platz und gewöhnen Sie ihn entspannt an die Box.",
		"payment_text_273": "Nutzen Sie ein komplettes Paket an Expertentipps zu Verhalten, Gehorsam und dem Alltag mit Ihrem Hund.",
		"payment_text_274": "Korrigieren Sie unerwünschtes Verhalten zu Hause und beim Spazierengehen mit bewährten, leicht umsetzbaren Methoden.",
		"payment_text_275": "Machen Sie Lernen zum Vergnügen! Lernen Sie, Lob und Belohnungen so einzusetzen, dass Ihr Hund sofort motiviert ist.",
		"payment_text_276": "Bringen Sie Ihrem Hund mehr als nur die Grundlagen bei! Sie lernen alles: von wichtigen Sicherheitskommandos bis zu tollen Tricks für Hunde jeden Alters.",
		"payment_text_277": "Beschleunigen Sie die<br /> Fortschritte Ihres Hundes <span>um das 2-Fache!</span>",
		"payment_text_278": "Praktischer Ratgeber:",
		"payment_text_279": "98% RABATT nur für Mitglieder",
		"payment_text_280": "70% RABATT nur für Mitglieder",
		"payment_text_281": "Ihr Tierarztprogramm für Ihren Hund startet jetzt!",
		"payment_text_282": "Kümmern Sie sich um die Gesundheit Ihres Hundes mit <span>professioneller tierärztlicher Unterstützung</span> von Everydoggy und <span>ziehen Sie einen gesunden, gut erzogenen Hund groß</span> mit weniger Sorgen",
		"payment_text_283": "Sofortiger Tierarzt-Chat — keine Termine, keine Wartezeit",
		"payment_text_284": "Teilen Sie Fotos, um genauere Empfehlungen zu erhalten",
		"payment_text_285": "Lernen Sie Erste Hilfe für Notfälle wie Hitzschlag, Verletzungen oder Erfrierungen",
		"payment_text_286": "Bleiben Sie mit aktuellen Impf- und Vorsorgeplänen immer auf dem Laufenden",
		"payment_text_287": "Erhalten Sie Pflegetipps für Zähne, Ohren, Augen, Krallen, Entwurmung und mehr",
		"payment_text_288": "Fühlen Sie sich bei der Gesundheit Ihres Hundes sicherer und sorgen Sie sich im Alltag weniger",
		"payment_text_289": "Was Everydoggy VET so effektiv macht",
		"payment_text_290": "Mehr als 3 Mio. Hundebesitzer vertrauen uns",
		"payment_text_291": "Chatten Sie jederzeit mit tierärztlicher Unterstützung, auf die Sie sich verlassen können",
		"payment_text_292": "Trainieren Sie Ihren Hund mit der Everydoggy-App und genießen Sie einen <span>perfekt erzogenen Begleiter</span>!",
		"payment_text_293": "Bewährt bei 3 Millionen Hunden",
		"payment_text_294": "Personalisierter Trainingsplan, abgestimmt auf Ihren Hund",
		"payment_text_295": "Als mein Welpe Durchfall hatte, bekam ich schnell Rat von einem Tierarzt und wusste genau, was zu tun war. Das hat mir viel Stress erspart.",
		"payment_text_296": "Die Beratung ist klar und verlässlich. Ich habe das Gefühl, immer einen Profi an meiner Seite zu haben, dem ich vertrauen kann.",
		"payment_text_297": "Ich habe es genutzt, als mein Hund Hautreizungen hatte und sich ständig gekratzt hat. Die Empfehlungen waren klar, und ich fühlte mich sofort beruhigt.",
		"payment_text_298": "Als neuer Welpenbesitzer war das unglaublich hilfreich. Ich muss nicht mehr raten.",
		"payment_text_299": "unserer Nutzer fühlen sich mit unserer tierärztlichen Unterstützung sicherer in Bezug auf die Gesundheit ihres Hundes und sorgen sich weniger",
		"payment_text_300": "<span>98 % unserer Nutzer</span> fühlen sich mit unserer tierärztlichen Unterstützung sicherer in Bezug auf die Gesundheit ihres Hundes und sorgen sich weniger",
		"payment_text_301": "Ihr personalisiertes Spiel- und Kommunikationsprogramm <span>startet jetzt</span>!",
		"payment_text_302": "Mit Everydoggy werden Sie <span>Ihren Hund besser verstehen</span>, <span>mehr Freude an der gemeinsamen Zeit haben</span> und <span>eine starke Bindung aufbauen</span>!",
		"payment_text_303": "3+ Mio. Nutzer",
		"payment_text_304": "Genießen das Leben mit ihren Hunden",
		"payment_text_305": "Jetzt",
		"payment_text_306": "Ihren Hund verstehen",
		"payment_text_307": "Kommunikation mit Ihrem Hund",
		"payment_text_308": "Freude am Spiel",
		"payment_text_309": "Bindung",
		"payment_text_310": "Personalisiertes Programm für Kommunikation und Spiel mit Ihrem Hund",
		"payment_text_311": "Übersetzen und verstehen Sie das Bellen Ihres Hundes mit KI-Bellen",
		"payment_text_312": "🎁 Ihr Willkommensrabatt wurde angewendet:",
		"payment_text_313": "<span>53%</span> RABATT",
		"payment_text_314": "Ihr personalisiertes Hundetrainingsprogramm beginnt jetzt!",
		"payment_text_315": "Sehen Sie schnell Fortschritte und genießen Sie das Leben mit einem gut erzogenen Hund!",
		"payment_text_316": "Gelernte Kommandos:",
		"payment_text_317": "Gehorsamsniveau:",
		"payment_text_318": "Niedrig",
		"payment_text_319": "Hoch",
		"payment_text_320": "Das personalisierte Trainingsprogramm für <span>Ihren Hund</span> ist bereit!",
		"payment_text_321": "Trainingsprofil",
		"payment_text_322": "Hunderasse",
		"payment_text_323": "Alter",
		"payment_text_324": "Verhaltensprobleme",
		"payment_text_325": "Aktuelles Niveau",
		"payment_text_326": "Über 3 Millionen",
		"payment_text_327": "Hundebesitzer sehen bereits Erfolge",
		"payment_text_328": "Ashley K. & Moly",
		"payment_text_329": "Ich finde toll, wie einfach die täglichen Trainingsaufgaben sind. Mein Hund hört jetzt wirklich!",
		"payment_text_330": "Kevin R. & Tommy",
		"payment_text_331": "Stubenreinheit war unsere größte Herausforderung. Dieses Programm war das Einzige, was wirklich funktioniert hat.",
		"payment_text_332": "Chloe N. & Ami",
		"payment_text_333": "Mein Welpe hat früher alles angeknabbert. Jetzt nimmt er nur noch sein Spielzeug!",
		"payment_text_334": "Daniel H. & Cherry",
		"payment_text_335": "Mir hat gefallen, dass alles in kleine Schritte aufgeteilt ist. Mein Hund hat Kommandos schneller gelernt, als ich erwartet hatte.",
		"payment_text_336": "Ihr stressfreier Trainingsplan für Ihren Welpen beginnt jetzt!",
		"payment_text_337": "Ihr stressfreier Trainingsplan für Ihren Hund beginnt jetzt!",
		"payment_text_338": "Ihr personalisierter Ernährungs- und Gesundheitsplan für Ihren Hund beginnt jetzt!",
		"payment_text_339": "Scannen Sie Hundefutter-Etiketten, erhalten Sie Ernährungstipps von Experten und halten Sie Ihren Hund <span>gesund und glücklich</span>!",
		"payment_text_340": "Scannen Sie Futteretiketten. Schützen Sie die Gesundheit Ihres Hundes",
		"payment_text_341": "Scannen Sie Hundefutter-Etiketten und verstehen Sie schnell Inhaltsstoffe und Qualität",
		"payment_text_342": "Erhalten Sie Fütterungsempfehlungen, die auf die Bedürfnisse Ihres Hundes abgestimmt sind",
		"payment_text_343": "Der Scanner für Futteretiketten ist ein echter Gamechanger. Ich weiß sofort, was wirklich im Futter meines Hundes steckt.",
		"payment_text_344": "Ein großartiges Tool, um die Gesundheit meines Hundes im Blick zu behalten und seine Ernährung zu verbessern. Die Ergebnisse sind deutlich spürbar!",
		"payment_text_345": "Diese App macht es so viel einfacher, die Ernährung meines Hundes zu managen. Ich liebe die personalisierten Tipps!",
		"payment_text_346": "Es ist, als hätte ich die Sprache meiner Hündin gelernt — sogar ihr Bellen ergibt jetzt Sinn.",
		"payment_text_347": "Die Spiele sind großartig. Mein Hund ist jedes Mal begeistert!",
		"payment_text_348": "Wir spielen, wir wachsen enger zusammen, und ich verstehe endlich, was meine Hündin mir sagen will!",
		"payment_text_349": "unserer Nutzer fühlen sich bei der Gesundheit ihres Hundes sicherer und machen sich dank unserer App weniger Sorgen",
		"payment_text_350": "Was EveryDoggy so effektiv macht",
		"payment_text_351": "<span>98 % unserer Nutzer</span> fühlen sich bei der Gesundheit ihres Hundes sicherer und sorgen sich mit unserem Plan weniger",
		"payment_text_352": "Anfänger",
		"payment_text_353": "Ihr personalisiertes Trainingsprogramm für kleine Hunde beginnt jetzt!",
		"payment_text_354": "Ihr personalisiertes K9-Hundetraining beginnt jetzt!",
		"payment_text_355": "Erzielen Sie schnell Ergebnisse: Ihr Hund hört aufs erste Kommando.",
		"payment_text_356": "Ein riesiger Unterschied in nur wenigen Wochen. Mein Hund hört endlich beim ersten Mal.",
		"payment_text_357": "Mit meinem Hund spazieren zu gehen ist nicht mehr stressig. Jetzt habe ich volle Kontrolle.",
		"payment_text_358": "Wir kamen sehr schnell von Chaos zu ruhigem Verhalten. Tolles Programm.",
		"payment_text_359": "Gehorsam aufs erste Kommando funktioniert wirklich. Ich hätte nicht gedacht, dass das möglich ist.",
		"payment_text_360": "Personalisierter K9-Trainingsplan für Hunde",
		"payment_text_361": "",
		"payment_text_362": "",
		"payment_text_363": "",
		"payment_text_364": "",
		"payment_text_365": "",
		"payment_text_366": "",
		"payment_text_367": "",
		"payment_text_368": "",
		"payment_text_369": "",
		"payment_text_370": "",
		"payment_text_371": "",
		"payment_text_372": "",
		"payment_text_373": "",
		"payment_text_374": "",
		"payment_text_375": "",
		"payment_text_376": "",
		"payment_text_377": "",
		"payment_text_378": "",
		"payment_text_379": "",
		"payment_text_380": "",
		"payment_text_381": "",
		"payment_text_382": "",
		"payment_text_383": "",
		"payment_text_384": "<span>Machen Sie den ersten Schritt zu einem gehorsamen Hund:</span> Sichern Sie sich den ultimativen K9-Ratgeber zur Reaktivität",
		"payment_text_385": "Schalten Sie das <span>K9-Praxishandbuch zur Reaktivität</span> frei",
		"payment_text_386": "Bringen Sie Ihrem Hund bei, trotz Auslösern auf Sie zu hören",
		"payment_text_387": "Stoppen Sie Reaktionen, bevor sie eskalieren",
		"payment_text_388": "Gewinnen Sie die Kontrolle zurück, wenn Ihr Hund ausrastet",
		"payment_text_389": "Gewöhnen Sie Ihrem Hund das Überreagieren auf Menschen, andere Hunde und Autos ab",
		"pdfUpselling": "",
		"pdfUpselling_1": "<span>Starten Sie Ihre Reise zu einem gehorsamen Hund:</span>  Holen Sie sich den ultimativen Leitfaden zur Hundeerziehung.",
		"pdfUpselling_2": "<span>Starten Sie Ihre Reise zu einem gehorsamen Hund:</span> Holen Sie sich den ultimativen Leitfaden für Welpenerziehung und Training.",
		"pdfUpselling_3": "Holen Sie sich Ihren </span>persönlichen Plan!</span>",
		"pdfUpselling_4": "Schalten Sie den <span>praktischen Leitfaden</span> frei!",
		"pdfUpselling_5": "Verhaltenskorrektur (drinnen und draußen)",
		"pdfUpselling_6": "Wie man seinen Hund lobt und belohnt",
		"pdfUpselling_7": "Verschiedene Komandos",
		"pdfUpselling_8": "Bereicherungsspiele und vieles mehr",
		"pdfUpselling_9": "Sauberkeitstraining",
		"pdfUpselling_10": "Schluss mit Beißen und Kauen",
		"pdfUpselling_11": "Kistentraining",
		"pdfUpselling_12": "Plus 43 weitere hilfreiche Tipps und Lösungen",
		"pdfUpselling_13": "Gesamt heute",
		"pdfUpselling_14": "Leitfaden freischalten",
		"pdfUpselling_15": "Freischalten mit",
		"pdfUpselling_16": "Ohne Leitfaden fortfahren",
		"chatUpsale_1": "Hundetrainer-Chat",
		"chatUpsale_2": "Beschreiben Sie das Verhalten des Hundes. Wir kümmern uns um die Lösung.",
		"chatUpsale_3": "Chatten Sie mit unseren echten menschlichen Hundetrainer-Experten ohne Einschränkungen.",
		"chatUpsale_4": "Sie bekommen mehr von Everydoggy, als Sie erwarten!",
		"chatUpsale_5": "Boost ×2",
		"chatUpsale_6": "EveryDoggy-Plan",
		"chatUpsale_7": "Hundetrainer-Chat",
		"chatUpsale_8": "Training auf eigene Faust",
		"chatUpsale_9": "UNBEGRENZTER ZUGANG",
		"chatUpsale_10": "Verbessern Sie Ihre Ergebnisse mit dem Expertentrainer-Chat!",
		"chatUpsale_11": "Chat-Zugang",
		"chatUpsale_12": "30-Tage",
		"chatUpsale_13": "90-Tage",
		"chatUpsale_14": "Weiter ohne Hundetrainer-Chat",
		"chatUpsale_15": "Unbegrenzter Zugang zum Hundetrainer-Chat",
		"checkoutV2_text1": "gesamt",
		"checkoutV2_text2": "Einfache und vertrauliche Zahlungen mit Face-ID/Touch-ID",
		"checkoutV2_text3": "Schützt Ihre Finanzinformationen durch Ende-zu-Ende-Verschlüsselung",
		"checkoutV2_text4": "Geschützt durch die einmalige Gerätekontonummer von Apple Pay",
		"checkoutV2_text5": "Schnelle, bequeme Zahlungsmöglichkeit",
		"checkoutV2_text6": "Schützt Ihre Finanzinformationen durch Ende-zu-Ende-Verschlüsselung",
		"checkoutV2_text7": "Unterstützt durch den branchenführenden Betrugsschutz von PayPal",
		"checkoutV2_text8": "Geld-zurück-Garantie",
		"checkoutV2_text9": "Kasse",
		"checkoutV2_text10": "Zahlungsinformationen",
		"checkoutV2_text11": "Geschützt",
		"error_1": "Zahlung abgelehnt. Bitte überprüfen Sie Ihre Kartendaten und versuchen Sie es erneut.",
		"error_2": "Zahlung abgelehnt. Bitte überprüfen Sie Ihre Kartendaten und versuchen Sie es erneut.",
		"error_3": "Nicht genügend Guthaben. Bitte versuchen Sie es mit einer anderen Karte oder einer anderen Zahlungsmethode.",
		"error_4": "Ihre Karte ist abgelaufen. Bitte versuchen Sie es mit einer anderen Karte oder einer anderen Zahlungsmethode.",
		"error_5": "Bei der Verarbeitung Ihrer Karte ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
		"error_6": "Der Sicherheitscode ist falsch. Bitte überprüfen Sie Ihre Kartendaten und versuchen Sie es erneut.",
		"error_7": "American Express-Karten werden derzeit nicht unterstützt. Bitte versuchen Sie es mit einer anderen Karte oder einer anderen Zahlungsmethode.",
		"error_8": "Zahlung abgelehnt. Bitte überprüfen Sie Ihre Kartendaten und versuchen Sie es erneut.",
		"error_9": "Zahlung abgelehnt. Diese E-Mail-Adresse ist bereits mit einem aktiven Abonnement verknüpft.",
		"error_10": "Zahlung abgelehnt. Zu viele Versuche oder Kartenlimit überschritten\nBitte versuchen Sie es später erneut.",
		"disclaimerV2_text_1": "Indem Sie fortfahren, stimmen Sie unseren <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Allgemeinen Geschäftsbedingungen</a> und unserer <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Datenschutzerklärung</a> zu und autorisieren die automatische Verlängerung Ihres Abonnements. Für Ihre erste Woche wird Ihnen heute nur ein Betrag von <span class=\"price1\">$1.99</span> berechnet. Wenn Sie nicht kündigen, verlängert Everydoggy Ihr Abonnement am Ende Ihres Testzeitraums automatisch und berechnet die Abonnementgebühr (derzeit <span class=\"price2\">$29.99</span>) alle 2 Wochen, bis Sie kündigen.\r\n\n",
		"disclaimerV2_text_2": "Indem Sie fortfahren, stimmen Sie unseren <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Allgemeinen Geschäftsbedingungen</a> und unserer <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Datenschutzerklärung</a> zu und autorisieren die automatische Verlängerung Ihres Abonnements.\r\nFür Ihre ersten 4 Wochen wird Ihnen heute nur ein Betrag von <span class=\"price1\">$6.99</span> berechnet. \r\nWenn Sie nicht kündigen, verlängert Everydoggy Ihr Abonnement am Ende Ihres Testzeitraums automatisch und \r\nberechnet die Abonnementgebühr (derzeit <span class=\"price2\">$29.99</span>) alle 2 Wochen, bis Sie kündigen.",
		"disclaimerV2_text_3": "Indem Sie fortfahren, stimmen Sie unseren <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Allgemeinen Geschäftsbedingungen</a> und unserer <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Datenschutzerklärung</a> zu und autorisieren die automatische Verlängerung Ihres Abonnements.\r\nFür Ihre ersten 12 Wochen wird Ihnen heute nur ein Betrag von <span class=\"price1\">$14.99</span> berechnet. \r\nWenn Sie nicht kündigen, verlängert Everydoggy Ihr Abonnement am Ende Ihres Testzeitraums automatisch und \r\nberechnet die Abonnementgebühr (derzeit <span class=\"price2\">$49.99</span>) alle 4 Wochen, bis Sie kündigen.\r\n",
		"chatUpsaleV2_1": "Chat mit Hundetrainer",
		"chatUpsaleV2_2": "Trainieren Sie mit einem Hundeverhaltensexperten",
		"chatUpsaleV2_3": "Fügen Sie Ihrem Plan unbegrenzten Chat-Support von erfahrenen Hundetrainern hinzu",
		"chatUpsaleV2_4": "Mit Trainer",
		"chatUpsaleV2_5": "Effizienz",
		"chatUpsaleV2_6": "Klare Antworten von einem echten Experten",
		"chatUpsaleV2_7": "Individuelle Tipps für Ihren Hund",
		"chatUpsaleV2_8": "Schnellere Ergebnisse mit weniger Fehlern",
		"chatUpsaleV2_9": "Ruhiger, selbstsicherer Trainingsprozess",
		"chatUpsaleV2_10": "Ohne Trainer",
		"chatUpsaleV2_11": "Raten, ob Sie es richtig machen",
		"chatUpsaleV2_12": "Langsamer Fortschritt und wiederholte Fehler",
		"chatUpsaleV2_13": "Unklare Ursachen für schlechtes Verhalten",
		"chatUpsaleV2_14": "Frust für Sie und Ihren Hund",
		"chatUpsaleV2_15": "Jeder Hund ist anders. Holen Sie sich Expertenhilfe für Ihren!",
		"chatUpsaleV2_16": "Antworten selbst auf die schwierigsten Fragen zum Hundeverhalten",
		"chatUpsaleV2_17": "Sowohl emotionale als auch praktische Trainingsunterstützung erhalten",
		"chatUpsaleV2_18": "Stress und Frust beim Training reduzieren",
		"chatUpsaleV2_19": "Individuelle Anleitung, abgestimmt auf Sie und Ihren Hund",
		"chatUpsaleV2_20": "Professionelle Unterstützung für maximale Ergebnisse sichern",
		"chatUpsaleV2_21": "Begrenzte Plätze",
		"chatUpsaleV2_22": "Exklusive Plätze verfügbar",
		"chatUpsaleV2_23": "4 Wochen Zugang zum Experten-Hundetrainer-Chat:",
		"chatUpsaleV2_24": "Zusätzlicher Rabatt von 75 % — nur begrenzt:",
		"chatUpsaleV2_25": "Gesamt",
		"chatUpsaleV2_26": "Jetzt Expertenhilfe erhalten",
		"chatUpsaleV2_27": "Ohne Hundetrainer-Chat fortfahren",
		"chatUpsaleV2_28": "Kann ich jede Frage über meinen Hund stellen?",
		"chatUpsaleV2_29": "Ja! Sie können zu Verhalten, Training, Welpenthemen oder konkreten Herausforderungen fragen, die Sie gerade haben.",
		"chatUpsaleV2_30": "Wie schnell erhalte ich eine Antwort?",
		"chatUpsaleV2_31": "Unsere erfahrenen Trainer antworten werktags in der Regel innerhalb von 24 Stunden.",
		"chatUpsaleV2_32": "Brauche ich Vorerfahrung im Training?",
		"chatUpsaleV2_33": "Überhaupt nicht. Unsere Trainer begleiten Sie Schritt für Schritt – egal, ob Sie Anfänger oder erfahrene Halterin bzw. erfahrener Halter sind."
	},
	"it": {
		"global \ninstruction": "",
		"safe": "Le tue informazioni sono al sicuro",
		"information": "Non venderemo né affitteremo le tue informazioni di contatto personali per scopi di marketing.",
		"secure_checkout": "Pagamento sicuro",
		"encrypted": "Tutte le informazioni sono criptate e trasmesse senza rischi utilizzando un protocollo Secure Sockets Layer.",
		"help": "Hai bisogno di aiuto?",
		"contact": "Contattaci",
		"here": "qui.",
		"undefined": "",
		"featured": "Presentato in",
		"main_title": "Corsi di addestramento per cani",
		"per_year": "all'anno",
		"special_offer": "Offerta speciale",
		"card_number": "Numero della carta",
		"card_expiry": "La carta scade",
		"security_number": "Numero di sicurezza",
		"email": "Email",
		"To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of __period__ and at the full, not discounted, price of __fullPriceText__ To learn more visit our <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">terms of use</a>.": "Informazioni sul pagamento",
		"secure_server": "Server sicuro",
		"pay": "Pagare",
		"enter_your_email": "Inserisci la tua email",
		"comment_1": "Durante alcuni anni stressanti, ho perso completamente la forma e guadagnato un po' di grasso, ma non avevo tempo né motivazione per fare qualcosa al riguardo. Un familiare mi ha suggerito Verv e ora mi affido al mio Coach ogni giorno!",
		"comment_2": "Verv mi ha fatto apprezzare gli allenamenti a casa e ho perso 7 kg in un mese. Questa app potrebbe davvero aiutarti a fare esercizio e perdere peso se sei un principiante come me.",
		"success_story": "Storia di successo",
		"get_my_plan": "OTTENERE IL MIO PIANO",
		"delimiter": "o",
		"pay_buy_card": "Paga con carta",
		"get_my_plan_warning_1": "Per evitare interruzioni, accetti che l'abbonamento selezionato verrà automaticamente esteso per un periodo di rinnovo successivo di",
		"get_my_plan_warning_2": "e al prezzo intero, non scontato di",
		"get_my_plan_warning_3": "Per saperne di più, visita il nostro",
		"get_my_plan_warning_text": "Continuando, accetti che se non annulli almeno 24 ore prima della fine del primo periodo di rinnovo, ti verrà addebitato automaticamente il prezzo intero di __fullPriceText__ ogni __period__ fino a quando non annulli.",
		"terms_of_use": "Termini di utilizzo",
		"privacy_policy": "Informativa sulla privacy",
		"terms_conditions": "Termini e condizioni",
		"privacy_policy_footer": "Informativa sulla privacy",
		"terms_conditions_footer": "Termini e condizioni",
		"guaranteed": "Checkout sicuro garantito",
		"special_features": "Caratteristiche speciali per te",
		"calories_value": "kcal",
		"personalized_plan": "Ottieni il tuo piano personalizzato:",
		"mobile_app": "App mobile con il tuo piano",
		"daily_programs": "Programmi giornalieri per diversi obiettivi (bruciare grasso, ridurre lo stress, guadagnare muscoli)",
		"audio_guided": "Allenamenti guidati da audio",
		"easy_to_cook": "Piatti facili da cucinare e gustosi",
		"comprehensive_stats": "Statistiche complete",
		"secret_tips": "Consigli segreti per sviluppare abitudini salutari",
		"mobile_app_tailor": "Piano su misura nella tua tasca",
		"daily_programs_for": "Programmi giornalieri",
		"daily_programs_for_2": "Per obiettivi diversi (bruciare grassi, ridurre lo stress, guadagnare muscoli)",
		"audio_trainers": "Guide di allenatori professionisti",
		"comprehensive_track": "Monitora i tuoi progressi con statistiche definitive",
		"price": "Prezzo",
		"users_love": "Gli utenti amano il nostro Piano Personalizzato",
		"alternative_review_name_1": "Therealtierra",
		"alternative_review_title_1": "Ottima app!",
		"alternative_review_contentent_1": "Sono alla mia nona settimana e il mio corpo è cambiato notevolmente!",
		"alternative_review_name_2": "ragazza tennis",
		"alternative_review_title_2": "Funziona!",
		"alternative_review_contentent_2": "Ho appena finito il programma. Mi piace! Ho perso 15 kg!!",
		"you_re_in": "Sei dentro!",
		"personal_plan_starts": "Il tuo piano personale Verv inizia oggi e il tempo stringe. Quindi, controllalo!",
		"app_by_link": "Per accedere al tuo programma, scarica l'app dal link",
		"download_now": "Scarica ora",
		"or": "o",
		"price_after_trial": "Prezzo dopo la prova",
		"seven_days_trial_unlocked": "Prova di 7 giorni sbloccata",
		"total_today": "Totale oggi",
		"reserved_price_for": "Prezzo riservato per",
		"new_subscritions1_title": "Scegli il tuo piano",
		"new_subscritions1_subscription1_line1": "Piano semestrale",
		"new_subscritions1_subscription1_price1_time": "a settimana",
		"new_subscritions1_subscription2_line1": "piano di 3 mesi",
		"new_subscritions1_subscription2_price2_time": "a settimana",
		"new_subscritions1_subscription3_line1": "piano di 1 mese",
		"new_subscritions1_subscription3_price3_time": "a settimana",
		"new_subscription_save": "SALVA",
		"new_subscritions_agreement": "Continuando, accetti",
		"new_subscritions_and": "e",
		"new_subscritions_subtitle": "I nostri utenti hanno perso 10 milioni di sterline",
		"new_subscritions_join": "Unisciti a milioni dei nostri utenti soddisfatti",
		"statistic_block_item1_text": "Stelle su 5",
		"statistic_block_item2_text": "valutazioni a 5 stelle",
		"statistic_block_item3_text": "download",
		"get_your_personalized_plan": "Ottieni il tuo piano personalizzato",
		"for": "per",
		"new_subscription_save_mostPopular1MonthPrice": "il piano più popolare",
		"timer_additional_discount": "Ulteriore sconto applicato da poco ",
		"timer_additional_discount_bold": "per te",
		"timer_offer_expires": "Questa offerta scade tra:",
		"Payment Successful": "",
		"payment_successful_title": "Ciao dal team Verv!",
		"payment_successful_download": "Scarica l'app",
		"payment_successful_press": "Premi",
		"payment_successful_login": "Accedi con l'email",
		"payment_successful_email": "Inserisci la tua email",
		"payment_successful_code": "e il tuo codice di conferma:",
		"payment_successful_hit": "Poi premi",
		"payment_successful_done": "Fatto",
		"payment_successful_description": "Sei dentro, goditi il tuo piano di allenamento personalizzato!",
		"Tariffs Variants": "",
		"tariff_title_choose": "Scegli il tuo piano",
		"tariff_title_get": "Ottieni il tuo piano",
		"tariff_one_month": "Piano di 1 mese",
		"tariff_three_month": "Piano di 3 mesi",
		"tariff_six_month": "Piano di 6 mesi",
		"tariff_one_year": "Piano di 1 anno",
		"tariff_one_week": "Piano di 1 settimana",
		"tariff_three_day": "Piano di 3 giorni",
		"tariff_per_year": "all'anno",
		"tariff_per_day": "al giorno",
		"tariff_per_days": "ogni 3 giorni",
		"tariff_per_week": "a settimana",
		"tariff_week": "settimana",
		"tariff_annual": "Piano annuale",
		"tariff_trial_one_week": "Prova di 1 settimana",
		"tariff_after": "dopo ",
		"tariff_save": "Salva",
		"tariff_best_offer": "migliore offerta",
		"tariff_most_popular": "il più popolare",
		"tariff_limited_promo": "prezzo promozionale limitato",
		"tariff_6_for_3": "6 al prezzo di 3",
		"tariff_first_month": "primo mese",
		"tariff_first_week": "prima settimana",
		"tariff_monthly": "mensile",
		"tariff_quaterly": "trimestrale",
		"tariff_semiannually": "semestralmente",
		"tariff_billed_every ": "fatturato ogni ",
		"tariff_year": "anno",
		"tariff_month": "mese",
		"tariff_months": "mesi",
		"tariff_months_variable": "mesi",
		"tariff_organic_gift": "Piano di meditazione",
		"tariff_full_price": "Prezzo intero",
		"tariff_no_hidden_fees": "Nessuna spesa nascosta",
		"tariff_start_right_now": "Inizia subito",
		"tariff_more_than": "Oltre 1.000.000 di membri attivi della famiglia Verv",
		"tariff_intro_offer": "OFFERTA INTRODUTTIVA",
		"Тарифы плиткой в ряд": "",
		"": "Non avevo idea che il mio cane fosse così intelligente. Dopo aver iniziato con EveryDoggy ha imparato 5 nuovi trucchi in una settimana!",
		"Checkout": "",
		"checkout_title": "Seleziona il metodo di pagamento",
		"insufficient_funds": "Fondi insufficienti",
		"insufficient_we_have": "Abbiamo un",
		"insufficient_special_price": "prezzo speciale",
		"insufficient_for_you": "per te",
		"checkout_edit_card": "Modifica la scheda",
		"checkout_pay_via": "Paga tramite",
		"checkout_paypal": "PayPal",
		"checkout_credit_card": "Carta di credito",
		"checkout_paypal_description": "Il tuo pagamento sarà elaborato tramite PayPal",
		"checkout_total_price": "Prezzo totale",
		"checkout_warning_1": "Per evitare interruzioni, accetti che l'abbonamento selezionato verrà automaticamente esteso per un periodo di rinnovo successivo di",
		"checkout_warning_2": "e al prezzo pieno, non scontato, di",
		"checkout_warning_3": "Per saperne di più, visita il nostro",
		"spv2_warning": "Per evitare interruzioni, accetti che l'abbonamento selezionato verrà automaticamente rinnovato per un periodo successivo di __________ e al prezzo pieno, non scontato, di __________. Per saperne di più, visita i nostri <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">termini di utilizzo</a>.",
		"checkout_offer_day_for": "giorno per",
		"checkout_offer_days_for": "giorni per",
		"checkout_offer_month_for": "mese per",
		"checkout_offer_months_for": "mesi per",
		"checkout_offer_week_for": "settimana per",
		"Values": "",
		"value_kg": "kg",
		"value_pounds": "lbs",
		"value_st": "st",
		"value_g": "g",
		"value_kcal": "kcal",
		"value_min": "min",
		"value_min_cooking": "minuti di cottura",
		"welcome_title": "Benvenuto in Verv Premium!",
		"item_1_title": "Evviva!",
		"item_1_description": "Il tuo peso obiettivo di __weight__ è ormai a portata di mano.",
		"item_2_title": "Come attivare",
		"item_2_description": "Scarica l'app utilizzando il link qui sotto, utilizza la tua email __mail__ e inserisci questo codice di convalida: __code__.",
		"item_2_description_2": "Per cambiare l'email, fai clic <button id=\"changeMail\">qui</button>.",
		"item_3_title": "Qualcosa è andato storto?",
		"item_3_description": "Un'istruzione dettagliata è stata inviata alla tua email. Se non l'hai ricevuta, contatta <a target=\"_blank\" href=\"mailto:support@verv.com?subject=Problema di accesso (simple-login)\">il supporto</a>.",
		"change": "Confermare",
		"change_mail": "Cambia la tua email qui per attivare Premium",
		"email_warning": "Si prega di inserire un indirizzo email valido",
		"Promo Code Block": "",
		"promo_code_title": "Codice promo applicato!",
		"promo_code_save": "% di sconto",
		"EveryDoggy": "",
		"dog_courses": "corsi per cani",
		"why_we_best_active": "Utenti attivi.",
		"why_we_best_lessons": "Lezioni video.",
		"why_we_best_brain": "Giochi per il cervello.",
		"why_we_best": "Perché siamo i migliori?",
		"why_we_best_join": "Unisciti alla nostra comunità di genitori di cani e fai del tuo meglio con EveryDoggy.",
		"why_we_best_enjoy": "Goditi il tuo piano di allenamento personalizzato, adattato ai tuoi obiettivi e a quelli del tuo cane.",
		"why_we_best_keep": "Tieni il tuo cane mentalmente e fisicamente attivo con oltre 70 giochi per il cervello.",
		"dog_problems": "Soluzioni rapide ai problemi comportamentali",
		"dog_problems_choose": "Scegli i comportamenti indesiderati che desideri migliorare",
		"dog_problems_leash": "Trazione del<br/>guinzaglio",
		"dog_problems_biting": "Bite",
		"dog_problems_anxiety": "Ansia da separazione<br/>",
		"dog_problems_chewing": "Masticazione<br/>distruttiva",
		"dog_plan": "Piano di allenamento personalizzato",
		"dog_plan_our": "Il nostro programma di addestramento è personalizzato al 100% per le esigenze del tuo cane.",
		"dog_reviews": "Cosa dicono i genitori di cani su EveryDoggy",
		"dog_reviews_text_1": "«Lezioni molto chiare e facili da seguire. Il mio cucciolo ama allenarsi e entrambi abbiamo imparato molto.»",
		"dog_reviews_name_1": "Megan e Leo",
		"dog_reviews_text_2": "Il comando « Zen » fa miracoli. Grazie a esso, il mio cane è super calmo presso la clinica veterinaria durante le procedure.",
		"dog_reviews_name_2": "Linda B.",
		"dog_reviews_text_3": "«Grazie per la lezione di clicker training. Ho sentito dire che è molto popolare, ma non era chiaro come usarlo. Ho rapidamente familiarizzato il mio cane con il clicker e ora abbiamo iniziato a imparare trucchi.»",
		"dog_reviews_name_3": "Jake L.",
		"join_text": "Essere un genitore felice per il tuo cane inizia con EveryDoggy",
		"join_courses": "Unisciti ai corsi online",
		"checkout_introductory": "Sconto offerta introduttiva",
		"checkout_personalized_plan": "Il tuo piano personalizzato",
		"Personal plan": "",
		"goal_lose_weight": "Programma di perdita di peso efficace con allenamenti guidati, tracker nutrizionale e una varietà di attività per te",
		"goal_gain_muscles": "Programma efficace di tonificazione totale del corpo con allenamenti guidati, tracker nutrizionale e una varietà di attività per te",
		"goal_gain_healthier_life": "Nuova routine salutare con allenamenti guidati per tutto il corpo, tracker nutrizionale e una varietà di attività per te",
		"goal_gain_flexibility": "Programma di yoga per la flessibilità con sessioni guidate e musica rilassante, tracker nutrizionale e una varietà di altre attività",
		"goal_gain_build_endurance": "Programma di allenamento per la resistenza con allenamenti guidati, tracker nutrizionale e una varietà di attività per te",
		"goal_love_myself": "Una varietà di attività per migliorare la tua autostima, meditazioni guidate, sessioni di yoga e allenamenti per tutto il corpo",
		"body_type_apple": "Esercizi per il corpo a forma di mela per tonificare il core e snellire la vita.",
		"body_type_pear": "Esercizi per un corpo a forma di pera per tonificare i fianchi e le cosce",
		"body_type_square": "Esercizi per un corpo a forma quadrata per definire la vita e lavorare i glutei",
		"body_type_hourglass": "Esercizi per un corpo a clessidra per aiutarti a ottenere risultati sorprendenti",
		"body_type_triangle": "Esercizi per il corpo a forma di triangolo invertito per rinforzare i fianchi e le cosce",
		"body_type_unknown": "Esercizi per valorizzare la tua forma fisica",
		"excercises_time_morning": "Allenamenti mattutini per accelerare il tuo metabolismo e darti energia per tutto il giorno",
		"excercises_time_day": "Allenamenti che si adattano perfettamente al tuo programma, accelerano il tuo metabolismo e ti mantengono energico durante la giornata.",
		"excercises_time_evening": "Allenamenti serali per aiutarti a alleviare lo stress dopo una lunga giornata e prepararti a un buon sonno.",
		"excercises_not_sure": "Allenamenti che si integrano perfettamente nel tuo programma, accelerano il tuo metabolismo e ti mantengono energico per tutta la giornata",
		"diet_type_all": "Ricette salutari e facili",
		"diet_type_vegetarian": "Ricette vegetariane salutari",
		"diet_type_vegan": "Ricette vegan sane",
		"diet_type_keto": "Ricette keto sane",
		"personal_plan_providers_title": "",
		"special_features_title": "Funzionalità speciali per te",
		"special_features_duration_minimum": "Sessioni rapide di meno di 10 minuti",
		"special_features_duration_normal": "Sessioni convenienti di meno di 20 minuti",
		"special_features_duration_maximum": "Sessioni efficaci di oltre 20 minuti",
		"special_features_duration_verv": "Sessioni convenienti dai nostri allenatori",
		"special_features_goal_lose_weight": "Consigli segreti per la perdita di peso da esperti",
		"special_features_goal_gain": "Suggerimenti segreti per tonificare i muscoli da esperti",
		"special_features_goal_health": "Suggerimenti segreti per la salute degli esperti",
		"special_features_goal_flexibility": "Consigli segreti di flessibilità dagli esperti",
		"special_features_goal_endurance": "Suggerimenti segreti per aumentare la resistenza",
		"special_features_goal_love": "Consigli segreti per aumentare l'autostima",
		"discount_activated": "Sconto del 50% attivato",
		"discount_no_activated": "50% di sconto",
		"unlocked_with_promo": "Sbloccato con il codice promozionale:",
		"use_with_button": "Usa il tuo codice promo speciale:",
		"plan_optimal": "Ottimale",
		"plan_standard": "STANDARD",
		"plan_basic": "BASICO",
		"plan_extra": "EXTRA",
		"daypayback_review_name_1": "melliebeth",
		"daypayback_review_text_1": "",
		"daypayback_review_name_2": "katie_zu13",
		"daypayback_review_text_2": "Amo Verv! Seguire il mio piano personale di allenamento e alimentazione mi ha aiutato a tornare in forma e a riacquistare fiducia in me stesso! Ho iniziato con brevi allenamenti di fitness di meno di 15 minuti, perfetti per un principiante come me. Poi ho aumentato la mia resistenza e il mio tempo di allenamento è salito a 30-40 minuti per sessione. Ho perso lentamente ma inesorabilmente 25 libbre in 6 mesi con Verv!",
		"daypayback_review_name_3": "Jean_leon1",
		"daypayback_review_text_3": "Ho preso molto peso durante il college. Dopo laurea, ho provato diverse diete che mi hanno aiutato a perdere peso, ma quel peso tornava sempre qualche mese dopo la fine della dieta. L'anno scorso ho sentito parlare di Verv da un collega e ho deciso di provarlo. Grazie alle raccomandazioni personalizzate di Verv, sono riuscito a perdere peso e mantenerlo!",
		"daypayback_review_name_4": "maryanne1993",
		"daypayback_review_text_4": "Dopo una brutta rottura, ho deciso di cambiare vita, perdere peso e diventare più sana. Ma non sapevo da dove iniziare. Non mi sentivo abbastanza sicura per allenarmi con gli altri, così ho deciso di provare le app per l'allenamento a casa e Verv è emerso nella mia ricerca. Mi ha offerto un piano su misura per le mie esigenze. L'ho seguito e sono riuscita a ottenere il corpo dei miei sogni!",
		"personal_plan_you_get": "Con il tuo piano personalizzato ottieni",
		"goal": "Obiettivo",
		"goal_other": "Lezioni per addestrare il tuo amico peloso",
		"goal_teaching_puppy": "Lezioni per insegnare al tuo amico peloso le buone maniere e l'obbedienza",
		"goal_surviving_puppy": "Lezioni per aiutarti a prepararti ai primi giorni con il tuo amico peloso",
		"goal_socializing_puppy": "Lezioni per aiutarti a socializzare il tuo amico peloso",
		"goal_teaching_obedience": "Lezioni per insegnare al tuo amico peloso buone maniere e obbedienza",
		"age_puppy": "Suggerimenti di allenamento dettagliati dai nostri esperti per aiutarti a crescere un cucciolo felice e ben educato",
		"age_adult": "Consigli dettagliati per l'addestramento dai nostri esperti per aiutarti a addestrare il tuo cane nel modo più efficace",
		"biting_yes": "Istruzioni passo dopo passo per fermare il tuo cane dal mordere",
		"biting_no": "Giochi divertenti da fare con il tuo cane",
		"biting_sometimes": "Istruzioni passo-passo per fermare il tuo cane dal mordere",
		"quick_tips": "Consigli rapidi e facili per imparare nuovi comandi",
		"potty_training_a_bit": "Una guida speciale per addestrare efficacemente il tuo cucciolo a fare i bisogni",
		"potty_training_yes": "Guide speciali per insegnare al tuo cucciolo nuovi divertenti trucchi",
		"potty_training_no": "Una guida speciale per addestrare il tuo cucciolo a fare i bisogni fuori",
		"success screen": "",
		"success_screen_text_1": "Grazie per il tuo acquisto!",
		"success_screen_text_2": "Segui le istruzioni qui sotto per impostare<br />il tuo account:",
		"success_screen_text_3": "Vai al tuo <b>account</b>",
		"success_screen_text_4": "Scansiona il <b>codice QR</b> o tocca <b>il link</b>",
		"success_screen_text_5": "<b>Scarica</b> l'app",
		"success_screen_text_6": "<b>Apri l'app</b> e <b>goditi</b><br /> l'allenamento con il tuo cagnolino!",
		"success_screen_text_7": "Abbiamo duplicato il codice QR e il link per te a &nbsp;<b>example@gmail.com</b>",
		"success_screen_text_8": "Se l'account premium non è stato applicato nell'app, premi <b>‘Contattaci’</b> nella schermata di benvenuto e contatta il nostro team di supporto.",
		"success_screen_text_9": "Premendo il pulsante 'Inizia', confermo di aver esaminato e accettato la <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Informativa sulla privacy</a> e i <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Termini e le condizioni</a> e acconsento quindi al trattamento dei miei dati personali.",
		"success_screen_text_10": "Contattaci",
		"success_screen_text_11": "Vai al mio account",
		"success_screen_text_12": "Ti abbiamo inviato un codice QR duplicato e un link via email.",
		"success_screen_text_13": "La tua guida PDF è stata inviata alla tua email <b>v.stsiopina@gmail.com</b>.",
		"success_screen_text_14": "La tua guida PDF è stata inviata al tuo email.",
		"success_screen_text_15": "Se l'account premium non è stato applicato nell'app, premi il link <span>'Accedi'</span> sulla schermata di benvenuto nell'app e inserisci la tua email e la password che ti abbiamo inviato a <b>stepinavalerie@gmail.com</b>",
		"success_screen_text_16": "Se l'account premium non è stato applicato nell'app, premi il link <span>'Accedi'</span> sullo schermo di benvenuto nell'app e inserisci la tua email e la password che ti abbiamo inviato via email.",
		"payment_text_1": "Il tuo programma di addestramento per cani inizia ora!",
		"payment_text_2": "L'app Everydoggy ti aiuterà a <span>risolvere rapidamente e divertendoti qualsiasi problema di comportamento del tuo cane</span>.",
		"payment_text_3": "L'offerta personale scade",
		"payment_text_4": "dei nostri utenti notano cambiamenti positivi nel comportamento del loro cane solo 1 settimana dopo aver iniziato l’addestramento con i nostri esperti",
		"payment_text_5": "OgniCane contro Allenatori",
		"payment_text_6": "Numero medio di comandi al mese",
		"payment_text_7": "OgniCane beneficia",
		"payment_text_8": "Piano di addestramento per cani personalizzato",
		"payment_text_9": "Bastano solo 15 minuti al giorno per un animale perfetto",
		"payment_text_10": "Oltre 70 lezioni video facili da comprendere per risultati rapidi",
		"payment_text_11": "Oltre 80 giochi e trucchi per nuove abilità e solo per divertirsi",
		"payment_text_12": "Consigli su igiene, salute e nutrizione",
		"payment_text_13": "Allenati a casa e all'aperto, nessuna attrezzatura necessaria",
		"payment_text_14": "Il 98% dei nostri utenti nota cambiamenti positivi nel comportamento del proprio cane già dopo 1 settimana dall'inizio dell'addestramento con i nostri esperti.",
		"payment_text_14_2": "<span>Il 98 % dei nostri utenti</span> nota cambiamenti positivi nel comportamento del proprio cane già dopo 1 settimana dall’inizio dell’addestramento con i nostri esperti",
		"payment_text_15": "Cliccando sul pulsante “Ottieni il mio piano”, accetti i nostri <a href='https://everydoggy.com/terms/' target=\"_blank\" >Termini e condizioni</a> e <a href='https://everydoggy.com/policy/' target=\"_blank\" >Informativa sulla privacy</a>, <b>autorizzi il rinnovo automatico</b> del tuo abbonamento al termine di ogni ciclo di fatturazione di <span>1 mese</span> al prezzo pieno di <i>$29.99</i> più le tasse applicabili. Puoi annullare il rinnovo automatico del tuo abbonamento in qualsiasi momento prima della data di rinnovo. Controlla i nostri <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Termini di annullamento</a> per ulteriori dettagli.",
		"payment_text_16": "Cliccando sul pulsante «Ottieni il mio piano», accetti i nostri <a href='https://everydoggy.com/terms/' target='_blank'>Termini e condizioni</a> e <a href='https://everydoggy.com/policy/' target='_blank'>Informativa sulla privacy</a>, <b>autorizzi il rinnovo automatico</b> del tuo abbonamento alla fine di ciascun ciclo di fatturazione di <span>1 mese</span> al prezzo intero di <i>$29.99</i> più le tasse applicabili. Puoi annullare il rinnovo automatico del tuo abbonamento in qualsiasi momento prima della data di rinnovo. Controlla i nostri <a href='https://everydoggy.com/subscription-terms/' target='_blank'>Termini di cancellazione</a> per maggiori dettagli.",
		"payment_text_17": "Hai una domanda?",
		"payment_text_18": "Scrivici semplicemente a ",
		"payment_text_19": "Funziona!",
		"payment_text_20": "Ho appena finito il programma di addestramento all'ubbidienza con il nostro cucciolo, mi piace! 👏",
		"payment_text_21": "Fantastico!",
		"payment_text_22": "Posso dire che sono soddisfatto al 💯 di questa app. Niente più problemi con i bisogni, wow!",
		"payment_text_23": "Ottima app 🎉",
		"payment_text_24": "Siamo al terzo mese di addestramento con il mio cane e le sue abilità sono migliorate moltissimo!",
		"payment_text_25": "Vale la pena provare",
		"payment_text_26": "Di gran lunga la migliore app per addestrare un cane! ",
		"payment_text_27": "Lasciati ispirare dai nostri utenti",
		"payment_text_28": " Star Focus, Inc",
		"payment_text_29": "Se hai ancora domande scrivici a <a href=\\\"mailto:welove@everydoggy.com\\\">welove@everydoggy.com</a>",
		"payment_text_30": "Risultati visibili in soli 7 giorni di addestramento",
		"payment_text_31": "Ottieni il tuo piano personale con uno sconto speciale",
		"payment_text_32": "Prima inizi l'addestramento, migliori saranno i risultati che otterrai",
		"payment_text_33": "L'addestramento è essenziale per ogni cane. Non si tratta solo di eliminare i problemi comportamentali, ma anche di socializzare, di costruire un legame con il tuo cane e di esprimere il tuo amore.",
		"payment_text_34": "Creato per amore dei cani. Basato su competenze di livello mondiale",
		"payment_text_35": "Tutto ciò che troverai nell'app trae spunto dalle ricerche più recenti ed è assolutamente incentrato sui cani.",
		"payment_text_36": "Se il tuo cane potesse parlare, ti chiederebbe di provare EveryDoggy!",
		"payment_text_37": "Le tue informazioni sono al sicuro",
		"payment_text_38": "Non venderemo né presteremo i tuoi dati personali per nessun scopo di marketing.",
		"payment_text_39": "Pagamento sicuro",
		"payment_text_40": "Tutte le informazioni vengono criptate e trasmesse senza rischi.",
		"payment_text_41": "Hai bisogno di aiuto?",
		"payment_text_42": "Inviaci una email: <a href=\\\"mailto:welove@everydoggy.com\\\">welove@everydoggy.com</a>",
		"payment_text_43": "mensile",
		"payment_text_44": "continua",
		"payment_text_45": "Il tuo piano personalizzato",
		"payment_text_46": "Sconto offerta introduttiva:",
		"payment_text_47": "Continuando accetti i <a href='https://everydoggy.com/terms/' target='_blank' rel=\\\"noreferrer\\\">Termini e condizioni</a>, la <a href='https://everydoggy.com/policy/' target='_blank' rel=\\\"noreferrer\\\">Politica sulla privacy</a> e i <a href='https://everydoggy.com/subscription-terms/#subscription_cancellation' target='_blank' rel=\\\"noreferrer\\\">Termini di cancellazione</a>",
		"payment_text_48": "Il tuo abbonamento dura fino a",
		"payment_text_49": "Puoi annullare in qualsiasi momento e senza alcun costo aggiuntivo almeno 24 ore prima della scadenza del periodo di abbonamento.",
		"payment_text_50": "e non annulli l'abbonamento, questo verrà automaticamente rinnovato al termine del mese di abbonamento. Ti verrà addebitata la quota di iscrizione a EveryDoggy di <b>$</b><i>$29.99</i> fino a quando non annullerai.",
		"payment_text_51": "Al momento non offriamo rimborsi o accrediti per abbonamenti parziali.",
		"payment_text_52": "Respon-sabile personale",
		"payment_text_53": "Scuola per cani",
		"payment_text_54": "Lezioni su YouTube",
		"payment_text_55": "Libri",
		"payment_text_56": "ogni settimana",
		"payment_text_57": "Risultati significativamente migliori",
		"payment_text_58": "Con EveryDoggy",
		"payment_text_59": "Senza EveryDoggy",
		"payment_text_60": "Adesso",
		"payment_text_61": "Dopo 1 settimana",
		"payment_text_62": "Questa è la tua ultima occasione",
		"payment_text_63": "Non perdere l'esclusivo sconto del 65% e scopri quanto velocemente il tuo cane impara e obbedisce ai comandi!",
		"payment_text_64": "Ottieni il 65% di sconto",
		"payment_text_65": "PIANO DA 52 SETTIMANE",
		"payment_text_66": "PIANO DA 4 SETTIMANE",
		"payment_text_67": "PIANO DA 12 SETTIMANE",
		"payment_text_68": "settimane",
		"payment_text_69": "Gennaio",
		"payment_text_70": "Febbraio",
		"payment_text_71": "Marzo",
		"payment_text_72": "Aprile",
		"payment_text_73": "Maggio",
		"payment_text_74": "Giugno",
		"payment_text_75": "Luglio",
		"payment_text_76": "Agosto",
		"payment_text_77": "Settembre",
		"payment_text_78": "Ottobre",
		"payment_text_79": "Novembre",
		"payment_text_80": "Dicembre",
		"payment_text_81": "Inserisci un indirizzo email valido",
		"payment_text_82": "",
		"payment_text_83": "Il periodo introduttivo durerà fino all'<b>11 ottobre 2024</b>.",
		"payment_text_84": "È possibile cancellare l'abbonamento in qualsiasi momento prima del <b>10 ottobre 2024</b> e non verrà addebitato alcun costo.",
		"payment_text_85": "Qualora non venga cancellato, Everydoggy rinnoverà automaticamente l'abbonamento al termine del periodo introduttivo e addebiterà la quota di iscrizione (attualmente pari a <b>39,99 USD</b>) <span>ogni mese</span> fino alla disdetta.\" with \"If you don’t cancel, Everydoggy will automatically continue your membership at the end of your introductory period and charge the membership fee (currently <b>$39.99 USD</b>) monthly until you cancel.",
		"payment_text_86": "",
		"payment_text_87": "Your subscription will be bound by our <a href='https://everydoggy.com/terms/' target=\"_blank\" >Terms and Conditions</a>, <a href='https://everydoggy.com/policy/' target=\"_blank\" >Privacy Policy</a> and <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Cancellation Terms</a>.",
		"payment_text_88": "Metodo di pagamento",
		"payment_text_89": "EveryDoggy will use your payment details for seamless future payments",
		"payment_text_90": "Easy and private payments with Face/Touch ID",
		"payment_text_91": "Keeps your financial info safe with end-to-end encryption",
		"payment_text_92": "Protected by Apple Pay’s unique Device Account Number",
		"payment_text_93": "Le tue informazioni di pagamento sono protette dalla crittografia SSL/TLS",
		"payment_text_94": "Fast, convenient payment option",
		"payment_text_95": "Backed by PayPal’s industry-leading fraud protection",
		"payment_text_96": "Confirm purchase",
		"payment_text_97": "1-WEEK",
		"payment_text_98": "1-MONTH",
		"payment_text_99": "3-MONTH",
		"payment_text_100": "You will only be charged <b>$6.99</b> today for your first month (details below)",
		"payment_text_101": "You will only be charged <b>$6.99</b> today for your first 3 months (details below)",
		"payment_text_102": "Subscribe with",
		"payment_text_103": "Facendo clic sul pulsante \\\"Ottieni il mio piano\\\" accetti l'<a href='https://everydoggy.com/policy/' target=\\\"_blank\\\" >Informativa sulla privacy</a>, i <a href='https://everydoggy.com/terms/' target=\\\"_blank\\\" >Termini e condizioni</a> e i <a href='https://everydoggy.com/subscription-terms/' target=\\\"_blank\\\" >Termini di cancellazione</a>",
		"payment_text_104": "Pagamenti facili e privati",
		"payment_text_105": "Carta di credito",
		"payment_text_106": "Data di scadenza",
		"payment_text_107": "CVC",
		"payment_text_108": "ottimo inizio",
		"payment_text_109": "Piano di 1 settimana",
		"payment_text_110": "L'app Everydoggy ti aiuterà a <span>risolvere i problemi di evacuazione e qualsiasi altro problema comportamentale del tuo cane</span> in modo rapido e divertente.",
		"payment_text_111": "Pagamento sicuro",
		"payment_text_112": "Piano di addestramento personalizzato per <span>il tuo cagnolino</span>",
		"payment_text_113": "Fischietto e clicker per l'addestramento",
		"payment_text_114": "Oltre 80 giochi e trucchi per il tuo animale domestico",
		"payment_text_115": "Oltre 30 consigli e articoli sulla salute",
		"payment_text_116": "🔥 Hai appena risparmiato <span>$113.50&nbsp;</span>🔥",
		"payment_text_117": "Piano di 7 giorni",
		"payment_text_118": "Cliccando sul pulsante \\\"Ottieni il piano\\\", accetti i nostri <a href='https://everydoggy.com/terms/' target=\\\"_blank\\\" >Termini e condizioni</a> e la <a href='https://everydoggy.com/policy/' target=\\\"_blank\\\" >Informativa sulla privacy</a> e <b>autorizzi il rinnovo automatico</b> del tuo abbonamento. Oggi ti verranno addebitati solo <span class=\\\"trialPrice\\\">$4,99</span> per i primi <span class=\\\"trialPeriod\\\">7 giorni</span> del periodo iniziale. Se non annulli, Everydoggy rinnoverà automaticamente il tuo abbonamento al termine del periodo iniziale e addebiterà la quota di iscrizione di <span class='price'>$39,99</span> ogni <span class='period'>mese</span> fino alla disdetta. Puoi annullare il rinnovo automatico del tuo abbonamento in qualsiasi momento prima della data di rinnovo. Per maggiori dettagli consulta le nostre Condizioni di Cancellazione.",
		"payment_text_119": "7 giorni",
		"payment_text_120": "Oggi ti verranno addebitati solo <b>$29,99</b> per le prime <span>12 settimane</span> (dettagli di seguito)",
		"payment_text_121": "L'app Everydoggy <span>ti aiuterà ad addestrare</span> il tuo cane <span>a fare i suoi bisogni</span> nel posto giusto e a <span>risolvere i problemi comportamentali</span> in modo rapido e divertente.",
		"payment_text_122": "Un cane addestrato in 3 giorni a fare i suoi bisogni",
		"payment_text_123": "Il tuo account è collegato a questa email e non può essere modificato",
		"payment_text_124": "Proseguendo, accetti i nostri <a href=\\\"https://everydoggy.com/terms/\\\" target=\\\"_blank\\\">Termini e Condizioni</a> e l'Informativa sulla <a href=\\\"https://everydoggy.com/policy/\\\" target=\\\"_blank\\\">Privacy</a> e <span>autorizzi il rinnovo automatico</span> del tuo abbonamento.",
		"payment_text_125": "PIANO DA 26 SETTIMANE",
		"payment_text_126": "Qualora non venga cancellato, Everydoggy rinnoverà automaticamente l'abbonamento al termine del periodo introduttivo e addebiterà la quota di iscrizione (attualmente pari a <b>39,99 USD</b>) <span>ogni 3 mesi</span> fino alla disdetta.",
		"payment_text_127": "Qualora non venga cancellato, Everydoggy rinnoverà automaticamente l'abbonamento al termine del periodo introduttivo e addebiterà la quota di iscrizione (attualmente pari a <b>39,99 USD</b>) <span>ogni 6 mesi</span> fino alla disdetta.",
		"payment_text_128": "Livello attuale",
		"payment_text_129": "comandi",
		"payment_text_130": "Obiettivo",
		"payment_text_131": "Oltre 50 comandi e obbedienza",
		"payment_text_132": "Sperimenta progressi evidenti",
		"payment_text_133": "Raggiungi l'obbedienza",
		"payment_text_134": "Mantieni il tuo cane ben addestrato per tutta la vita",
		"payment_text_135": "Risparmia il 53%",
		"payment_text_136": "Garanzia di rimborso",
		"payment_text_137": "Garanzia di rimborso entro 30 giorni",
		"payment_text_138": "Siamo convinti che il nostro piano possa funzionare per te e che otterrai risultati visibili in 4 settimane! Siamo anche pronti a rimborsarti i soldi spesi se non vedi risultati visibili e puoi dimostrare di aver seguito il nostro piano.",
		"payment_text_139": "Per ulteriori informazioni sulle limitazioni applicabili, consulta i nostri <a href=\\\"https://everydoggy.com/terms/#section5_2\\\" target=\\\"_blank\\\" rel=\\\"noreferrer\\\">termini di utilizzo</a>.\\n",
		"payment_text_140": "Risparmia il 65%",
		"payment_text_141": "Il piano per addestrare il cane è pronto!",
		"payment_text_142": "Obbedienza",
		"payment_text_143": "Conosce i comandi",
		"payment_text_144": "Fa i bisogni in casa",
		"payment_text_145": "Frequente",
		"payment_text_146": "Nessuno",
		"payment_text_147": "Abbaiare",
		"payment_text_148": "Abbaia a tutto",
		"payment_text_149": "Tranquillo e rilassato",
		"payment_text_150": "Mordere e masticare",
		"payment_text_151": "Spesso",
		"payment_text_152": "Interrotto",
		"payment_text_153": "Tirare il guinzaglio",
		"payment_text_154": "Sempre",
		"payment_text_155": "Cammina con calma",
		"payment_text_156": "Ansia quando è solo",
		"payment_text_157": "Calmo e indipendente",
		"payment_text_158": "Prima",
		"payment_text_159": "Dopo",
		"payment_text_160": "minuti",
		"payment_text_161": "secondi",
		"payment_text_162": "Collaudato. Testato. Funziona",
		"payment_text_163": "Cambiamenti significativi nell'obbedienza del cane",
		"payment_text_164": "Oggi",
		"payment_text_165": "Settimana 2",
		"payment_text_166": "Settimana 3",
		"payment_text_167": "Settimana 4",
		"payment_text_168": "Cosa rende Everydoggy così efficace",
		"payment_text_169": "Le storie di successo dei nostri utenti",
		"payment_text_170": "Realizzato da esperti che <span>amano i cani</span>",
		"payment_text_171": "Tutti i corsi e le lezioni si basano su studi scientifici sull'addestramento dei cani.",
		"payment_text_172": "Crea un legame forte con il tuo cane, prova EveryDoggy!",
		"payment_text_173": "Collaudata. Testata. Funziona",
		"payment_text_174": "<span>Il 93% dei nostri utenti</span> nota cambiamenti significativi nel comportamento del proprio cane già nel primo mese di addestramento.",
		"payment_text_175": "Con EveryDoggy",
		"payment_text_176": "Senza EveryDoggy",
		"payment_text_177": "Oggi",
		"payment_text_178": "Settimana 2",
		"payment_text_179": "Settimana 4",
		"payment_text_180": "Settimana 6",
		"payment_text_181": "L'esperienza di Luna",
		"payment_text_182": "La mia cucciola continuava a sporcare in casa. Everydoggy ci ha fornito una routine chiara che ha funzionato\\nveramente!",
		"payment_text_183": "L'esperienza di Cooper",
		"payment_text_184": "Il nostro cucciolo mordicchiava tutti durante il gioco. L'app ci ha fornito istruzioni dettagliate, e hanno\\nfunzionato!",
		"payment_text_185": "L'esperienza di Bella",
		"payment_text_186": "Il nostro cane rosicchiava tutto, dalle scarpe al divano. L'app ci ha aiutato a reindirizzare\\nquell'energia!",
		"payment_text_187": "L'esperienza di Charlie",
		"payment_text_188": "Tirare il guinzaglio era una\\nbattaglia quotidiana. Grazie all'app, le passeggiate adesso sono piacevoli e senza\\nstress.",
		"payment_text_189": "Sporcare in casa: risolto",
		"payment_text_190": "Morsi: risolto",
		"payment_text_191": "Rosicchiare: risolto",
		"payment_text_192": "Tirare il guinzaglio: risolto",
		"payment_text_193": "<span>Il 93% dei nostri utenti</span> nota cambiamenti significativi nel <span>comportamento e nell'obbedienza del proprio cane</span> già dal primo mese di addestramento.</span>",
		"payment_text_194": "I nostri utenti sono stupiti dai risultati!",
		"payment_text_195": "Inizia subito ad addestrare il tuo cane!",
		"payment_text_196": "Se non annulli l'abbonamento, Everydoggy continuerà automaticamente a rinnovarlo al termine del periodo introduttivo e addebiterà la quota associativa (attualmente pari a <b>39,99 USD</b>) <span>ogni due settimane</span> fino a quando non effettuerai l'annullamento.",
		"payment_text_197": "Garanzia di rimborso",
		"payment_text_198": "Garanzia di rimborso entro 30 giorni",
		"payment_text_199": "Siamo convinti che il nostro piano possa funzionare per te e che otterrai risultati visibili in 4 settimane! Siamo anche pronti a rimborsarti i soldi spesi se non vedi risultati visibili e puoi dimostrare di aver seguito il nostro piano.",
		"payment_text_200": "Per ulteriori informazioni sulle limitazioni applicabili, consulta i nostri <a href=\\\"https://everydoggy.com/terms/#section5_2\\\" target=\\\"_blank\\\" rel=\\\"noreferrer\\\">termini di utilizzo</a>.",
		"payment_text_201": "Le persone spesso chiedono",
		"payment_text_202": "Quanto tempo ci vuole prima di vedere i risultati dell'allenamento?",
		"payment_text_203": "La maggior parte dei cani mostra progressi già dopo la prima sessione e, nel giro di un paio di settimane, noterai risultati notevoli e impressionanti!",
		"payment_text_204": "L'app Everydoggy è tanto efficace quanto lavorare con un addestratore?",
		"payment_text_205": "Sì, e ancora più efficace: puoi allenarti ogni giorno al tuo ritmo, seguire lezioni chiare e dettagliate e rafforzare le competenze in modo costante, senza limitarti a una volta alla settimana con un addestratore.",
		"payment_text_206": "I risultati dell'allenamento sono permanenti?",
		"payment_text_207": "SÌ! Finché continuerai a rafforzare le buone abitudini, i risultati dureranno tutta la vita.",
		"payment_text_208": "Ottieni il 72% di sconto",
		"payment_text_209": "Non perdere l'esclusivo sconto del 72% e scopri quanto velocemente il tuo cane impara e obbedisce ai comandi!",
		"payment_text_210": "Continua con un altro metodo di pagamento",
		"payment_text_211": "Buy with",
		"payment_text_212": "SCONTI PER IL BLACK FRIDAY!",
		"payment_text_213": "",
		"payment_text_214": "",
		"payment_text_215": "",
		"payment_text_216": "",
		"payment_text_217": "",
		"payment_text_218": "Il programma di addestramento del suo cucciolo inizia ora!",
		"payment_text_219": "Si alleni con l’app Everydoggy fin <span>dai primissimi giorni del suo cucciolo</span> e ottenga <span>un cane perfettamente obbediente</span>!",
		"payment_text_220": "dei nostri utenti notano cambiamenti positivi nel comportamento del loro cucciolo già 1 settimana dopo aver iniziato ad allenarsi con i nostri esperti",
		"payment_text_221": "Piano di addestramento personalizzato per cuccioli sotto i 6 mesi",
		"payment_text_222": "Piano di addestramento personalizzato per cuccioli dai 6 ai 12 mesi",
		"payment_text_223": "Testato su 3 milioni di cuccioli",
		"payment_text_224": "Cambiamenti significativi nell’obbedienza del cane",
		"payment_text_225": "Ottieni il 70% di sconto",
		"payment_text_226": "ULTIMA OCCASIONE!",
		"payment_text_227": "PIANO DA 24 SETTIMANE",
		"payment_text_228": "L’ultimo programma di addestramento di cui avrà bisogno inizia ora!",
		"payment_text_229": "Piano di addestramento personalizzato per risultati duraturi",
		"payment_text_230": "Un programma.<br />\nBuon comportamento per sempre",
		"payment_text_231": "Età del cane",
		"payment_text_232": "Tempo di addestramento",
		"payment_text_233": "Risultati duraturi",
		"payment_text_234": "0-1 anno",
		"payment_text_235": "1-3 anni",
		"payment_text_236": "3-5 anni",
		"payment_text_237": "5+ anni",
		"payment_text_238": "1-2 anni",
		"payment_text_239": "3 anni",
		"payment_text_240": "4 anni",
		"payment_text_241": "2-7 anni",
		"payment_text_242": "8 anni",
		"payment_text_243": "9 anni",
		"payment_text_244": "10+ anni",
		"payment_text_245": "",
		"payment_text_246": "",
		"payment_text_247": "",
		"payment_text_248": "",
		"payment_text_249": "",
		"payment_text_250": "",
		"payment_text_251": "",
		"payment_text_252": "",
		"payment_text_253": "",
		"payment_text_254": "",
		"payment_text_255": "",
		"payment_text_256": "",
		"payment_text_257": "",
		"payment_text_258": "",
		"payment_text_259": "",
		"payment_text_260": "",
		"payment_text_261": "",
		"payment_text_262": "",
		"payment_text_263": "Traduttore canino",
		"payment_text_264": "Capite il vostro cane.<br/> Scoprite i risultati",
		"payment_text_265": "L’obbedienza migliora grazie all’analisi dei segnali e del comportamento",
		"payment_text_266": "Piano di addestramento personalizzato per il vostro cane basato sull’analisi del suo abbaiare e del suo comportamento",
		"payment_text_267": "Il doppio della velocità, <br />il doppio del divertimento!",
		"payment_text_268": "Ottieni la guida definitiva per l'addestramento del cucciolo",
		"payment_text_269": "Ottieni la guida definitiva per l'addestramento del cane",
		"payment_text_270": "Dì addio agli incidenti in casa! Metodi passo dopo passo per insegnare rapidamente al tuo cane a fare i bisogni nel posto giusto.",
		"payment_text_271": "Salva scarpe e dita! Tecniche semplici per aiutare il tuo cucciolo a smettere di mordere e rosicchiare tutto.",
		"payment_text_272": "Crea per il tuo cane uno spazio sicuro e sereno e insegnagli a stare tranquillo nel trasportino.",
		"payment_text_273": "Accedi a una raccolta completa di consigli esperti su comportamento, obbedienza e vita quotidiana con il tuo cane.",
		"payment_text_274": "Correggi i comportamenti indesiderati in casa e durante le passeggiate con metodi efficaci e facili da seguire.",
		"payment_text_275": "Rendi l'apprendimento divertente! Impara a usare lodi e premi per motivare subito il tuo cane.",
		"payment_text_276": "Insegna al tuo cane molto più delle basi! Scoprirai tutto, dai comandi di sicurezza ai trucchi più belli per cani di tutte le età.",
		"payment_text_277": "Accelera i<br /> progressi del tuo cane <span>2x!</span>",
		"payment_text_278": "Guida pratica:",
		"payment_text_279": "SCONTO del 98% riservato ai membri",
		"payment_text_280": "SCONTO del 70% riservato ai membri",
		"payment_text_281": "Il tuo programma di assistenza veterinaria per il tuo cane inizia ora!",
		"payment_text_282": "Prenditi cura della salute del tuo cane con <span>il supporto di veterinari esperti</span> di Everydoggy e <span>cresci un cane sano e ben educato</span> con meno preoccupazioni!",
		"payment_text_283": "Supporto veterinario via chat immediato — senza appuntamenti, senza attese",
		"payment_text_284": "Condividi foto per ricevere indicazioni più precise",
		"payment_text_285": "Impara il primo soccorso per emergenze come colpo di calore, ferite o congelamento",
		"payment_text_286": "Resta al passo con calendari aggiornati di vaccinazioni e controlli",
		"payment_text_287": "Ricevi consigli per la cura di denti, orecchie, occhi, unghie, sverminazione e molto altro",
		"payment_text_288": "Sentiti più sicuro sulla salute del tuo cane e preoccupati meno ogni giorno",
		"payment_text_289": "Cosa rende Everydoggy VET così efficace",
		"payment_text_290": "Scelto da oltre 3M proprietari di cani",
		"payment_text_291": "Chatta in qualsiasi momento con un supporto veterinario su cui puoi contare",
		"payment_text_292": "Addestri il suo cane con l'app Everydoggy e goda di un <span>compagno perfettamente educato</span>!",
		"payment_text_293": "Testato su 3 milioni di cani",
		"payment_text_294": "Piano di addestramento personalizzato su misura per il suo cane",
		"payment_text_295": "Quando il mio cucciolo ha avuto la diarrea, ho ricevuto subito il consiglio di un veterinario e ho saputo esattamente come gestire la situazione. Mi ha risparmiato molto stress.",
		"payment_text_296": "I consigli sono chiari e affidabili. Mi sembra di avere sempre accanto un professionista di cui potermi fidare.",
		"payment_text_297": "L’ho usato quando il mio cane aveva un’irritazione cutanea e si grattava continuamente. Le indicazioni erano chiare e mi sono sentita subito rassicurata.",
		"payment_text_298": "Come nuovo proprietario di un cucciolo, è stato incredibilmente utile. Non devo più andare a tentativi.",
		"payment_text_299": "dei nostri utenti si sentono più sicuri sulla salute del loro cane e si preoccupano meno grazie al nostro supporto veterinario",
		"payment_text_300": "<span>Il 98% dei nostri utenti</span> si sente più sicuro sulla salute del proprio cane e si preoccupa meno grazie al nostro supporto veterinario",
		"payment_text_301": "Il tuo programma personalizzato di gioco e comunicazione <span>inizia ora</span>!",
		"payment_text_302": "Con Everydoggy potrai <span>capire meglio il tuo cane</span>, <span>divertirti di più insieme a lui</span> e <span>costruire un legame duraturo</span>!",
		"payment_text_303": "3M+ utenti",
		"payment_text_304": "Si godono al massimo la vita con i loro cani",
		"payment_text_305": "Ora",
		"payment_text_306": "Capire il tuo cane",
		"payment_text_307": "Comunicazione con il tuo cane",
		"payment_text_308": "Piacere del gioco",
		"payment_text_309": "Legame",
		"payment_text_310": "Programma personalizzato di comunicazione e gioco con il tuo cane",
		"payment_text_311": "Traduci e comprendi l’abbaiare del tuo cane con Abbaio IA",
		"payment_text_312": "🎁 Il tuo sconto di benvenuto è stato applicato:",
		"payment_text_313": "<span>53%</span> DI SCONTO",
		"payment_text_314": "Il tuo programma personalizzato di addestramento per cani inizia ora!",
		"payment_text_315": "Vedi risultati rapidi e goditi la vita con un cane ben educato!",
		"payment_text_316": "Comandi imparati:",
		"payment_text_317": "Livello di obbedienza:",
		"payment_text_318": "Basso",
		"payment_text_319": "Alto",
		"payment_text_320": "Il programma di addestramento personalizzato per <span>il tuo cane</span> è pronto!",
		"payment_text_321": "Profilo di addestramento",
		"payment_text_322": "Razza del cane",
		"payment_text_323": "Età",
		"payment_text_324": "Problemi di comportamento",
		"payment_text_325": "Livello attuale",
		"payment_text_326": "Oltre 3 milioni",
		"payment_text_327": "di proprietari di cani stanno già ottenendo risultati",
		"payment_text_328": "Ashley K. e Moly",
		"payment_text_329": "Mi piace quanto siano semplici le attività quotidiane di addestramento. Ora il mio cane mi ascolta davvero!",
		"payment_text_330": "Kevin R. e Tommy",
		"payment_text_331": "L’educazione ai bisogni era la nostra difficoltà più grande. Questo programma è stato l’unico che abbia funzionato davvero.",
		"payment_text_332": "Chloe N. e Ami",
		"payment_text_333": "Il mio cucciolo prima masticava tutto. Ora sceglie solo i suoi giochi!",
		"payment_text_334": "Daniel H. e Cherry",
		"payment_text_335": "Mi è piaciuto che tutto sia diviso in piccoli passi. Il mio cane ha imparato i comandi più in fretta di quanto mi aspettassi.",
		"payment_text_336": "Il suo piano di addestramento senza stress per il cucciolo inizia ora!",
		"payment_text_337": "Il suo piano di addestramento senza stress per il cane inizia ora!",
		"payment_text_338": "Il piano personalizzato per la nutrizione e la salute del tuo cane inizia ora!",
		"payment_text_339": "Scansiona le etichette del cibo per cani, ricevi consigli nutrizionali da esperti e mantieni il tuo cane <span>sano e felice</span>!",
		"payment_text_340": "Scansiona le etichette del cibo. Proteggi la salute del tuo cane",
		"payment_text_341": "Scansiona le etichette del cibo per cani e capisci rapidamente ingredienti e qualità",
		"payment_text_342": "Ricevi consigli alimentari pensati per le esigenze del tuo cane",
		"payment_text_343": "Lo scanner delle etichette del cibo è una vera svolta. Ora so subito cosa c’è davvero nel cibo del mio cane.",
		"payment_text_344": "Ottimo strumento per monitorare la salute del mio cane e migliorare la sua dieta. Risultati evidenti!",
		"payment_text_345": "Questa app ha reso molto più semplice gestire l’alimentazione del mio cane. Adoro i consigli personalizzati!",
		"payment_text_346": "È come se avessi imparato la lingua della mia cagnolina: ora persino l’abbaiare ha senso.",
		"payment_text_347": "I giochi sono fantastici. Il mio cane si entusiasma ogni volta!",
		"payment_text_348": "Giochiamo, creiamo un legame e finalmente capisco cosa vuole dirmi la mia cagnolina!",
		"payment_text_349": "dei nostri utenti si sentono più sicuri riguardo alla salute del loro cane e si preoccupano meno grazie alla nostra app",
		"payment_text_350": "Cosa rende EveryDoggy così efficace",
		"payment_text_351": "<span>Il 98% dei nostri utenti</span> si sente più sicuro sulla salute del proprio cane e si preoccupa meno con il nostro piano",
		"payment_text_352": "Principiante",
		"payment_text_353": "Il tuo programma personalizzato di addestramento per cani piccoli inizia ora!",
		"payment_text_354": "Il tuo programma personalizzato di addestramento K9 per cani inizia ora!",
		"payment_text_355": "Ottieni risultati rapidi: il tuo cane ascolterà al primo comando.",
		"payment_text_356": "Una differenza enorme in poche settimane. Il mio cane finalmente ascolta al primo colpo.",
		"payment_text_357": "Portare a spasso il mio cane non è più stressante. Ora ho tutto sotto controllo.",
		"payment_text_358": "Siamo passati dal caos a un comportamento calmo molto in fretta. Programma fantastico.",
		"payment_text_359": "L’obbedienza al primo comando funziona davvero. Non pensavo fosse possibile.",
		"payment_text_360": "Piano personalizzato di addestramento K9 per cani",
		"payment_text_361": "",
		"payment_text_362": "",
		"payment_text_363": "",
		"payment_text_364": "",
		"payment_text_365": "",
		"payment_text_366": "",
		"payment_text_367": "",
		"payment_text_368": "",
		"payment_text_369": "",
		"payment_text_370": "",
		"payment_text_371": "",
		"payment_text_372": "",
		"payment_text_373": "",
		"payment_text_374": "",
		"payment_text_375": "",
		"payment_text_376": "",
		"payment_text_377": "",
		"payment_text_378": "",
		"payment_text_379": "",
		"payment_text_380": "",
		"payment_text_381": "",
		"payment_text_382": "",
		"payment_text_383": "",
		"payment_text_384": "<span>Inizia il percorso verso un cane obbediente:</span> ottieni la guida K9 definitiva sulla reattività",
		"payment_text_385": "Sblocca il <span>Manuale pratico K9 sulla reattività</span>",
		"payment_text_386": "Fai in modo che il tuo cane ti ascolti vicino ai fattori scatenanti",
		"payment_text_387": "Ferma le reazioni senza lasciarle degenerare",
		"payment_text_388": "Riprendi il controllo quando il tuo cane perde la testa",
		"payment_text_389": "Insegna al tuo cane a non reagire in modo eccessivo a persone, altri cani e auto",
		"pdfUpselling": "",
		"pdfUpselling_1": "<span>Dai il via al tuo percorso verso un cane obbediente:</span> scarica la guida definitiva all'addestramento per l'allevamento dei cani",
		"pdfUpselling_2": "<span>Dai il via al tuo percorso verso un cane obbediente:</span> scarica la guida definitiva all'allevamento e all'addestramento dei cuccioli",
		"pdfUpselling_3": "Ottieni il tuo <span>piano personale</span>",
		"pdfUpselling_4": "Sblocca la <span>guida pratica</span>",
		"pdfUpselling_5": "Correzione del comportamento (in casa e all'aperto)",
		"pdfUpselling_6": "Come lodare e premiare il tuo cane",
		"pdfUpselling_7": "Vari comandi",
		"pdfUpselling_8": "Giochi di arricchimento e molto altro",
		"pdfUpselling_9": "Addestramento a fare i bisognini",
		"pdfUpselling_10": "Far smettere di mordere e masticare",
		"pdfUpselling_11": "Addestramento alla gabbia",
		"pdfUpselling_12": "Più altri 43 utili suggerimenti e soluzioni",
		"pdfUpselling_13": "Totale oggi",
		"pdfUpselling_14": "Sblocca la guida",
		"pdfUpselling_15": "Sblocca con",
		"pdfUpselling_16": "Continua senza guida",
		"chatUpsale_1": "Chat con addestratore cinofilo",
		"chatUpsale_2": "Descrivi il comportamento del cane. Troveremo noi la soluzione",
		"chatUpsale_3": "Conversa con i nostri reali addestratori cinofili esperti senza limitazioni",
		"chatUpsale_4": "Ottieni più di quanto ti aspetti da Everydoggy!",
		"chatUpsale_5": "Potenziamento x2",
		"chatUpsale_6": "Piano EveryDoggy",
		"chatUpsale_7": "Chat con addestratore cinofilo",
		"chatUpsale_8": "Addestrare in autonomia",
		"chatUpsale_9": "ACCESSO ILLIMITATO",
		"chatUpsale_10": "Migliora i risultati tramite la chat con addestratori esperti!",
		"chatUpsale_11": "accesso alla chat",
		"chatUpsale_12": "30 giorni",
		"chatUpsale_13": "90 giorni",
		"chatUpsale_14": "Continua senza la chat con addestratore cinofilo",
		"chatUpsale_15": "Accesso illimitato alla chat degli addestratori di cani",
		"checkoutV2_text1": "totale",
		"checkoutV2_text2": "Pagamenti facili e privati con Face/Touch ID",
		"checkoutV2_text3": "Mantiene al sicuro le tue informazioni finanziarie con la crittografia end-to-end",
		"checkoutV2_text4": "Protetto dal numero di account dispositivo univoco di Apple Pay",
		"checkoutV2_text5": "Opzione di pagamento veloce e conveniente",
		"checkoutV2_text6": "Mantiene al sicuro le tue informazioni finanziarie con la crittografia end-to-end",
		"checkoutV2_text7": "Supportato dalla protezione antifrode leader del settore di PayPal",
		"checkoutV2_text8": "Garanzia di rimborso",
		"checkoutV2_text9": "Pagamento",
		"checkoutV2_text10": "Informazioni sul pagamento",
		"checkoutV2_text11": "Protetto",
		"error_1": "Pagamento rifiutato. Controlla i dettagli della carta e riprova.",
		"error_2": "Pagamento rifiutato. Controlla i dettagli della carta e riprova.",
		"error_3": "Fondi insufficienti. Prova un'altra carta o un altro metodo di pagamento.",
		"error_4": "La carta è scaduta. Prova un'altra carta o un altro metodo di pagamento.",
		"error_5": "Si è verificato un errore durante l'elaborazione della carta. Riprova.",
		"error_6": "Il codice di sicurezza non è corretto. Controlla i dettagli della carta e riprova.",
		"error_7": "Al momento le carte American Express non sono supportate. Prova un'altra carta o un altro metodo di pagamento.",
		"error_8": "Pagamento rifiutato. Controlla i dettagli della carta e riprova.",
		"error_9": "Pagamento rifiutato. Questo indirizzo email è già associato a un abbonamento attivo.",
		"error_10": "Pagamento rifiutato. Troppi tentativi o limite della carta superato. Riprova più tardi.",
		"disclaimerV2_text_1": "Continuando, Lei accetta i nostri <a href=\\\"https://everydoggy.com/terms/\\\" target=\\\"_blank\\\">Termini e condizioni</a> e la nostra <a href=\\\"https://everydoggy.com/policy/\\\" target=\\\"_blank\\\">Informativa sulla privacy</a> e autorizza il rinnovo automatico del Suo abbonamento. Oggi Le verrà addebitato solo <span class=\\\"price1\\\">$1.99</span> per la Sua prima settimana. Se non annulla, Everydoggy rinnoverà automaticamente il Suo abbonamento al termine del periodo di prova e Le addebiterà il costo dell'abbonamento (attualmente <span class=\\\"price2\\\">$29.99</span>) ogni 2 settimane finché non lo annulla.",
		"disclaimerV2_text_2": "Continuando, Lei accetta i nostri <a href=\\\"https://everydoggy.com/terms/\\\" target=\\\"_blank\\\">Termini e condizioni</a> e la nostra <a href=\\\"https://everydoggy.com/policy/\\\" target=\\\"_blank\\\">Informativa sulla privacy</a> e autorizza il rinnovo automatico del Suo abbonamento.\\r\\nOggi Le verrà addebitato solo l'importo di <span class=\\\"price1\\\">$6.99</span> per le Sue prime 4 settimane. \\r\\nSe non annulla, Everydoggy rinnoverà automaticamente il Suo abbonamento al termine del periodo di prova e \\r\\naddebiterà il costo dell'abbonamento (attualmente <span class=\\\"price2\\\">$29.99</span>) ogni 2 settimane finché non lo annulla",
		"disclaimerV2_text_3": "Indem Sie fortfahren, stimmen Sie unseren <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Allgemeinen Geschäftsbedingungen</a> und unserer <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Datenschutzerklärung</a> zu und autorisieren die automatische Verlängerung Ihres Abonnements.\r\nFür Ihre ersten 12 Wochen wird Ihnen heute nur ein Betrag von <span class=\"price1\">$14.99</span> berechnet. \r\nWenn Sie nicht kündigen, verlängert Everydoggy Ihr Abonnement am Ende Ihres Testzeitraums automatisch und \r\nberechnet die Abonnementgebühr (derzeit <span class=\"price2\">$49.99</span>) alle 4 Wochen, bis Sie kündigen.\r\n",
		"chatUpsaleV2_1": "Chat con un educatore cinofilo",
		"chatUpsaleV2_2": "Si alleni con un esperto di comportamento canino",
		"chatUpsaleV2_3": "Aggiunga al suo piano un supporto in chat illimitato da educatori cinofili esperti",
		"chatUpsaleV2_4": "Con educatore",
		"chatUpsaleV2_5": "Efficienza",
		"chatUpsaleV2_6": "Risposte chiare da un vero esperto",
		"chatUpsaleV2_7": "Consigli personalizzati per il suo cane",
		"chatUpsaleV2_8": "Risultati più rapidi con meno errori",
		"chatUpsaleV2_9": "Un percorso di training calmo e sicuro",
		"chatUpsaleV2_10": "Senza educatore",
		"chatUpsaleV2_11": "Dubbi sul fatto che stia facendo tutto correttamente",
		"chatUpsaleV2_12": "Progressi lenti ed errori ripetuti",
		"chatUpsaleV2_13": "Cause poco chiare dei comportamenti indesiderati",
		"chatUpsaleV2_14": "Frustrazione per lei e per il suo cane",
		"chatUpsaleV2_15": "Ogni cane è diverso. Ottenga l’aiuto di un esperto per il suo!",
		"chatUpsaleV2_16": "Risposte anche alle domande più difficili sul comportamento del cane",
		"chatUpsaleV2_17": "Supporto sia emotivo sia pratico per l’addestramento",
		"chatUpsaleV2_18": "Meno stress e frustrazione durante il training",
		"chatUpsaleV2_19": "Guida personalizzata su misura per lei e per il suo cane",
		"chatUpsaleV2_20": "Supporto professionale per risultati al massimo",
		"chatUpsaleV2_21": "Posti limitati",
		"chatUpsaleV2_22": "Ultimi posti disponibili",
		"chatUpsaleV2_23": "Accesso alla chat con educatore cinofilo esperto per 4 settimane:",
		"chatUpsaleV2_24": "Sconto extra del 75% a tempo limitato:",
		"chatUpsaleV2_25": "Totale",
		"chatUpsaleV2_26": "Ottenga aiuto da un esperto ora",
		"chatUpsaleV2_27": "Continua senza chat con educatore cinofilo",
		"chatUpsaleV2_28": "Posso fare qualsiasi domanda sul mio cane?",
		"chatUpsaleV2_29": "Sì! Può chiedere di comportamento, addestramento, problemi del cucciolo o difficoltà specifiche che sta affrontando.",
		"chatUpsaleV2_30": "Quanto velocemente riceverò una risposta?",
		"chatUpsaleV2_31": "Di solito i nostri educatori esperti rispondono entro 24 ore nei giorni feriali.",
		"chatUpsaleV2_32": "Serve esperienza di addestramento precedente?",
		"chatUpsaleV2_33": "Assolutamente no. I nostri educatori la guidano passo dopo passo, che sia un principiante o un proprietario esperto."
	},
	"pt": {
		"global \ninstruction": "",
		"safe": "Suas informações estão seguras",
		"information": "Não venderemos ou alugaremos suas informações de contato pessoais para quaisquer fins de marketing.",
		"secure_checkout": "Checkout seguro",
		"encrypted": "Todas as informações são criptografadas e transmitidas sem risco usando um protocolo Secure Sockets Layer.",
		"help": "Precisa de ajuda?",
		"contact": "Entre em contato conosco",
		"here": "aqui.",
		"undefined": "",
		"featured": "Conforme apresentado em",
		"main_title": "Cursos de treinamento de cães",
		"per_year": "por ano",
		"special_offer": "Oferta especial",
		"card_number": "Número do cartão",
		"card_expiry": "O cartão expira",
		"security_number": "Número de segurança",
		"email": "Email",
		"To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of __period__ and at the full, not discounted, price of __fullPriceText__ To learn more visit our <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">terms of use</a>.": "Informações de pagamento",
		"secure_server": "Servidor seguro",
		"pay": "Pagar",
		"enter_your_email": "Digite seu e-mail",
		"comment_1": "Durante alguns anos estressantes, perdi totalmente minha forma e ganhei um pouco de gordura, mas não tinha tempo nem motivação para fazer algo a respeito. Um membro da família sugeriu o Verv e agora conto com meu treinador diariamente!",
		"comment_2": "O Verv me fez gostar de treinos em casa e eu perdi 7 kg em um mês. Este aplicativo pode realmente te ajudar a treinar e perder peso, se você for um iniciante como eu.",
		"success_story": "História de sucesso",
		"get_my_plan": "OBTER MEU PLANO",
		"delimiter": "ou",
		"pay_buy_card": "Pagar com cartão",
		"get_my_plan_warning_1": "Para evitar qualquer interrupção, você concorda que a assinatura que selecionou será automaticamente estendida por um período de renovação sucessivo de",
		"get_my_plan_warning_2": "e pelo preço cheio, não descontado de",
		"get_my_plan_warning_3": "Para saber mais, visite nosso",
		"get_my_plan_warning_text": "Ao continuar, você concorda que, se não cancelar pelo menos 24 horas antes do final do primeiro período de renovação, será cobrado automaticamente o preço total de __fullPriceText__ a cada __period__ até que você cancele.",
		"terms_of_use": "Termos de Uso",
		"privacy_policy": "Política de Privacidade",
		"terms_conditions": "Termos e Condições",
		"privacy_policy_footer": "Política de Privacidade",
		"terms_conditions_footer": "Termos e Condições",
		"guaranteed": "Finalização da compra segura garantida",
		"special_features": "Recursos especiais para você",
		"calories_value": "kcal",
		"personalized_plan": "Obtenha seu plano personalizado:",
		"mobile_app": "Aplicativo móvel com seu plano",
		"daily_programs": "Programas diários para diferentes objetivos (queimar gordura, reduzir estresse, ganho de massa muscular)",
		"audio_guided": "Treinos guiados por áudio",
		"easy_to_cook": "Pratos fáceis de cozinhar e saborosos",
		"comprehensive_stats": "Estatísticas abrangentes",
		"secret_tips": "Dicas secretas para desenvolver hábitos saudáveis",
		"mobile_app_tailor": "Plano sob medida no seu bolso",
		"daily_programs_for": "Programas diários",
		"daily_programs_for_2": "Para diferentes objetivos (queimar gordura, reduzir o estresse, ganho muscular)",
		"audio_trainers": "Guias de treinadores profissionais",
		"comprehensive_track": "Acompanhe seu progresso com estatísticas definitivas",
		"price": "Preço",
		"users_love": "Os usuários adoram nosso Plano Personalizado",
		"alternative_review_name_1": "Therealtierra",
		"alternative_review_title_1": "Ótimo aplicativo!",
		"alternative_review_contentent_1": "Estou na minha nona semana e meu corpo mudou tremendamente!",
		"alternative_review_name_2": "menina do tênis",
		"alternative_review_title_2": "Funciona!",
		"alternative_review_contentent_2": "Acabei de finalizar o programa. Adoro! Perdi 15 kg!!",
		"you_re_in": "Você está dentro!",
		"personal_plan_starts": "Seu plano pessoal Verv começa hoje e o tempo está passando. Confira!",
		"app_by_link": "Para entrar no seu programa, baixe o aplicativo pelo link",
		"download_now": "Baixar agora",
		"or": "ou",
		"price_after_trial": "Preço após o teste",
		"seven_days_trial_unlocked": "Teste de 7 dias desbloqueado",
		"total_today": "Total hoje",
		"reserved_price_for": "Preço reservado para",
		"new_subscritions1_title": "Escolha seu plano",
		"new_subscritions1_subscription1_line1": "Plano semestral",
		"new_subscritions1_subscription1_price1_time": "por semana",
		"new_subscritions1_subscription2_line1": "plano de 3 meses",
		"new_subscritions1_subscription2_price2_time": "por semana",
		"new_subscritions1_subscription3_line1": "plano de 1 mês",
		"new_subscritions1_subscription3_price3_time": "por semana",
		"new_subscription_save": "SALVAR",
		"new_subscritions_agreement": "Ao continuar, você concorda com",
		"new_subscritions_and": "e",
		"new_subscritions_subtitle": "Nossos usuários perderam 10 milhões de libras",
		"new_subscritions_join": "Junte-se a milhões de nossos usuários felizes",
		"statistic_block_item1_text": "Estrelas de 5",
		"statistic_block_item2_text": "avaliações de 5 estrelas",
		"statistic_block_item3_text": "downloads",
		"get_your_personalized_plan": "Obtenha seu plano personalizado",
		"for": "para",
		"new_subscription_save_mostPopular1MonthPrice": "o plano mais popular",
		"timer_additional_discount": "Desconto adicional aplicado agora ",
		"timer_additional_discount_bold": "para você",
		"timer_offer_expires": "Esta oferta expira em:",
		"Payment Successful": "",
		"payment_successful_title": "Olá da equipe Verv!",
		"payment_successful_download": "Baixe o aplicativo",
		"payment_successful_press": "Pressione",
		"payment_successful_login": "Entre com o e-mail",
		"payment_successful_email": "Digite seu e-mail",
		"payment_successful_code": "e seu código de confirmação:",
		"payment_successful_hit": "Então toque",
		"payment_successful_done": "Feito",
		"payment_successful_description": "Você está dentro, aproveite seu plano de treinamento personalizado!",
		"Tariffs Variants": "",
		"tariff_title_choose": "Escolha seu plano",
		"tariff_title_get": "Obtenha seu plano",
		"tariff_one_month": "Plano de 1 mês",
		"tariff_three_month": "Plano de 3 meses",
		"tariff_six_month": "Plano de 6 meses",
		"tariff_one_year": "Plano de 1 ano",
		"tariff_one_week": "Plano de 1 semana",
		"tariff_three_day": "Plano de 3 dias",
		"tariff_per_year": "por ano",
		"tariff_per_day": "por dia",
		"tariff_per_days": "a cada 3 dias",
		"tariff_per_week": "por semana",
		"tariff_week": "semana",
		"tariff_annual": "Plano anual",
		"tariff_trial_one_week": "Teste de 1 semana",
		"tariff_after": "depois ",
		"tariff_save": "Salvar",
		"tariff_best_offer": "melhor oferta",
		"tariff_most_popular": "o mais popular",
		"tariff_limited_promo": "preço promocional limitado",
		"tariff_6_for_3": "6 pelo preço de 3",
		"tariff_first_month": "primeiro mês",
		"tariff_first_week": "primeira semana",
		"tariff_monthly": "mensal",
		"tariff_quaterly": "trimestral",
		"tariff_semiannually": "semanalmente",
		"tariff_billed_every ": "cobrado a cada ",
		"tariff_year": "ano",
		"tariff_month": "mês",
		"tariff_months": "meses",
		"tariff_months_variable": "meses",
		"tariff_organic_gift": "Plano de meditação",
		"tariff_full_price": "Preço total",
		"tariff_no_hidden_fees": "Sem taxas escondidas",
		"tariff_start_right_now": "Comece agora mesmo",
		"tariff_more_than": "Mais de 1.000.000 membros ativos da família Verv",
		"tariff_intro_offer": "OFERTA DE INTRODUÇÃO",
		"Тарифы плиткой в ряд": "",
		"": "Eu nunca pensei que meu cão fosse tão inteligente! Com o EveryDoggy, aprendemos 5 novos truques em apenas uma semana!",
		"Checkout": "",
		"checkout_title": "Selecione o método de pagamento",
		"insufficient_funds": "Fundos insuficientes",
		"insufficient_we_have": "Temos um",
		"insufficient_special_price": "preço especial",
		"insufficient_for_you": "para você",
		"checkout_edit_card": "Editar cartão",
		"checkout_pay_via": "Pagar via",
		"checkout_paypal": "PayPal",
		"checkout_credit_card": "Cartão de crédito",
		"checkout_paypal_description": "Seu pagamento será processado através do PayPal",
		"checkout_total_price": "Preço total",
		"checkout_warning_1": "Para evitar qualquer interrupção, você concorda que a assinatura selecionada será automaticamente estendida por um período de renovação sucessivo de",
		"checkout_warning_2": "e ao preço total, não descontado, de",
		"checkout_warning_3": "Para saber mais, visite nosso",
		"spv2_warning": "Para evitar qualquer interrupção, você concorda que a assinatura que selecionou será automaticamente renovada por um período sucessivo de __________ e ao preço cheio, não com desconto, de __________. Para saber mais, visite nossos <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">termos de uso</a>.",
		"checkout_offer_day_for": "dia para",
		"checkout_offer_days_for": "dias para",
		"checkout_offer_month_for": "mês para",
		"checkout_offer_months_for": "meses para",
		"checkout_offer_week_for": "semana para",
		"Values": "",
		"value_kg": "kg",
		"value_pounds": "lbs",
		"value_st": "st",
		"value_g": "g",
		"value_kcal": "kcal",
		"value_min": "min",
		"value_min_cooking": "min de cozimento",
		"welcome_title": "Bem-vindo ao Verv Premium!",
		"item_1_title": "Êba!",
		"item_1_description": "Seu peso ideal de __weight__ está agora bem perto.",
		"item_2_title": "Como ativar",
		"item_2_description": "Baixe o aplicativo usando o link abaixo, use seu e-mail __mail__ e insira este código de validação: __code__.",
		"item_2_description_2": "Para mudar o e-mail, clique <button id=\"changeMail\">aqui</button>.",
		"item_3_title": "Algo deu errado?",
		"item_3_description": "Uma instrução detalhada foi enviada para o seu e-mail. Se você não a recebeu, entre em contato com <a target=\"_blank\" href=\"mailto:support@verv.com?subject=Problema de login (simple-login)\">o suporte</a>.",
		"change": "Confirmar",
		"change_mail": "Altere seu e-mail aqui para ativar o Premium",
		"email_warning": "Por favor, preencha um endereço de e-mail válido",
		"Promo Code Block": "",
		"promo_code_title": "Código promocional aplicado!",
		"promo_code_save": "% de desconto",
		"EveryDoggy": "",
		"dog_courses": "cursos para cães",
		"why_we_best_active": "Usuários ativos.",
		"why_we_best_lessons": "Aulas em vídeo.",
		"why_we_best_brain": "Jogos de raciocínio.",
		"why_we_best": "Por que somos os melhores?",
		"why_we_best_join": "Junte-se à nossa comunidade de pais de cães e dê o seu melhor com EveryDoggy.",
		"why_we_best_enjoy": "Aproveite seu plano de treinamento personalizado, adaptado aos seus objetivos e aos de seu cachorro.",
		"why_we_best_keep": "Mantenha seu cachorro mentalmente e fisicamente ativo com mais de 70 jogos de raciocínio.",
		"dog_problems": "Soluções rápidas para problemas de comportamento",
		"dog_problems_choose": "Escolha os comportamentos indesejados que você gostaria de melhorar",
		"dog_problems_leash": "Puxando a<br/>coleira",
		"dog_problems_biting": "Morder",
		"dog_problems_anxiety": "Ansiedade de separação<br/>",
		"dog_problems_chewing": "Mastigação<br/>destrutiva",
		"dog_plan": "Plano de treinamento personalizado",
		"dog_plan_our": "O nosso programa de treinamento é 100% adaptado às necessidades do seu cão.",
		"dog_reviews": "O que os pais de cães dizem sobre o EveryDoggy",
		"dog_reviews_text_1": "«Aulas muito claras e fáceis de seguir. Meu filhote gosta de treinar e nós dois aprendemos muito.»",
		"dog_reviews_name_1": "Megan e Leo",
		"dog_reviews_text_2": "O comando \"Zen\" faz maravilhas. Graças a ele, meu cachorro fica super calmo na clínica veterinária durante os procedimentos.",
		"dog_reviews_name_2": "Linda B.",
		"dog_reviews_text_3": "«Obrigado pela aula de treinamento com clicker. Ouvi dizer que é muito popular, mas não estava claro como usá-lo. Familiarizei rapidamente meu cachorro com o clicker e agora começamos a aprender truques.»",
		"dog_reviews_name_3": "Jake L.",
		"join_text": "A felicidade na criação de cães começa com EveryDoggy",
		"join_courses": "Junte-se aos cursos online",
		"checkout_introductory": "Desconto na oferta introdutória",
		"checkout_personalized_plan": "Seu plano personalizado",
		"Personal plan": "",
		"goal_lose_weight": "Programa de perda de peso eficaz com treinos guiados, rastreador de nutrição e uma variedade de atividades para você",
		"goal_gain_muscles": "Programa eficaz de tonificação corporal total com treinos guiados, rastreador nutricional e uma variedade de atividades para você",
		"goal_gain_healthier_life": "Nova rotina saudável com treinos guiados para o corpo inteiro, rastreador de nutrição e uma variedade de atividades para você",
		"goal_gain_flexibility": "Programa de yoga para flexibilidade com sessões guiadas e música calma, rastreador de nutrição e uma variedade de outras atividades",
		"goal_gain_build_endurance": "Programa de treinamento de resistência com treinos guiados, rastreador de nutrição e uma variedade de atividades para você",
		"goal_love_myself": "Uma variedade de atividades para aumentar sua autoestima, meditações guiadas, sessões de yoga e treinos de corpo inteiro",
		"body_type_apple": "Exercícios para corpo em forma de maçã para tonificar o seu core e afinar a sua cintura.",
		"body_type_pear": "Exercícios para corpo em forma de pera para tonificar seus quadris e coxas",
		"body_type_square": "Exercícios para corpo em forma de quadrado para definir sua cintura e trabalhar seus glúteos",
		"body_type_hourglass": "Exercícios para o corpo em forma de ampulheta para ajudar você a alcançar resultados surpreendentes",
		"body_type_triangle": "Exercícios para o corpo em forma de triângulo invertido para fortalecer seus quadris e coxas",
		"body_type_unknown": "Exercícios para destacar o melhor da sua forma corporal",
		"excercises_time_morning": "Exercícios matinais para aumentar seu metabolismo e energizá-lo para o dia todo",
		"excercises_time_day": "Treinos que se encaixam perfeitamente na sua agenda, aceleram seu metabolismo e mantêm você energizado ao longo do dia.",
		"excercises_time_evening": "Treinos noturnos para ajudá-lo a aliviar o estresse após um longo dia e prepará-lo para uma boa noite de sono.",
		"excercises_not_sure": "Treinos que se encaixam perfeitamente na sua agenda, aumentam seu metabolismo e mantêm você energizado durante o dia",
		"diet_type_all": "Receitas saudáveis e fáceis",
		"diet_type_vegetarian": "Receitas vegetarianas saudáveis",
		"diet_type_vegan": "Receitas veganas saudáveis",
		"diet_type_keto": "Receitas keto saudáveis",
		"personal_plan_providers_title": "",
		"special_features_title": "Recursos especiais para você",
		"special_features_duration_minimum": "Sessões rápidas de menos de 10 minutos",
		"special_features_duration_normal": "Sessões convenientes de menos de 20 minutos",
		"special_features_duration_maximum": "Sessões eficazes com mais de 20 minutos",
		"special_features_duration_verv": "Sessões convenientes com nossos treinadores",
		"special_features_goal_lose_weight": "Dicas secretas para perda de peso de especialistas",
		"special_features_goal_gain": "Dicas secretas de tonificação muscular de especialistas",
		"special_features_goal_health": "Dicas secretas de saúde de especialistas",
		"special_features_goal_flexibility": "Dicas secretas de flexibilidade de especialistas",
		"special_features_goal_endurance": "Dicas secretas para aumentar a resistência",
		"special_features_goal_love": "Dicas secretas para aumentar a autoestima",
		"discount_activated": "Desconto de 50% ativado",
		"discount_no_activated": "50% de desconto",
		"unlocked_with_promo": "Desbloqueado com o código promocional:",
		"use_with_button": "Use seu código promocional especial:",
		"plan_optimal": "Otimizado",
		"plan_standard": "PADRÃO",
		"plan_basic": "BÁSICO",
		"plan_extra": "EXTRA",
		"daypayback_review_name_1": "melliebeth",
		"daypayback_review_text_1": "",
		"daypayback_review_name_2": "katie_zu13",
		"daypayback_review_text_2": "Eu amo Verv! Seguir meu plano pessoal de treino e alimentação me ajudou a voltar à forma e recuperar a confiança! Comecei com treinos curtos de menos de 15 minutos, que eram perfeitos para um iniciante como eu. Depois, aumentei minha resistência e meu tempo de treino chegou a 30-40 minutos por sessão. Perdi lentamente, mas com certeza, 25 quilos em 6 meses com Verv!",
		"daypayback_review_name_3": "Jean_leon1",
		"daypayback_review_text_3": "Ganhei muito peso durante a faculdade. Depois de me formar, tentei diferentes dietas que me ajudaram a perder peso, mas esse peso sempre voltava alguns meses após o término da dieta. No ano passado, ouvi falar do Verv por um colega e decidi experimentar. Com as recomendações personalizadas do Verv, consegui perder peso e mantê-lo!",
		"daypayback_review_name_4": "maryanne1993",
		"daypayback_review_text_4": "Depois de uma separação difícil, decidi mudar minha vida, perder peso e me tornar mais saudável. Mas não sabia por onde começar. Eu não me sentia confiante o suficiente para me exercitar com outras pessoas, então decidi tentar aplicativos de treino em casa e o Verv apareceu na minha busca. Ele me ofereceu um plano adaptado às minhas necessidades. Eu o segui e consegui obter o corpo dos meus sonhos!",
		"personal_plan_you_get": "Com o seu plano personalizado, você obtém",
		"goal": "Meta",
		"goal_other": "Aulas para treinar seu amigo peludo",
		"goal_teaching_puppy": "Aulas para ensinar ao seu amigo peludo maneiras e obediência",
		"goal_surviving_puppy": "Aulas para ajudá-lo a se preparar para os primeiros dias com seu amigo peludo",
		"goal_socializing_puppy": "Aulas para ajudar você a socializar seu amigo peludo",
		"goal_teaching_obedience": "Aulas para ensinar seu amigo peludo a ter boas maneiras e obediência",
		"age_puppy": "Dicas de treinamento detalhadas dos nossos especialistas para ajudá-lo a criar um filhote feliz e bem comportado",
		"age_adult": "Dicas de treinamento detalhadas de nossos especialistas para ajudar você a treinar seu cachorro da maneira mais eficaz",
		"biting_yes": "Instruções passo a passo para evitar que seu cachorro morda",
		"biting_no": "Jogos divertidos para jogar com seu cachorro",
		"biting_sometimes": "Instruções passo a passo para impedir seu cachorro de morder",
		"quick_tips": "Dicas rápidas e fáceis para aprender novos comandos",
		"potty_training_a_bit": "Um guia especial para ensinar seu filhote a fazer as necessidades no lugar certo",
		"potty_training_yes": "Guias especiais para ensinar seu filhote a fazer novos truques divertidos",
		"potty_training_no": "Um guia especial para treinar efetivamente seu filhote a usar o banheiro",
		"success screen": "",
		"success_screen_text_1": "Obrigado pela sua compra!",
		"success_screen_text_2": "Siga as instruções abaixo para configurar<br />sua conta:",
		"success_screen_text_3": "Vá para sua <b>conta</b>",
		"success_screen_text_4": "Escaneie o <b>código QR</b> ou toque em <b>o link</b>",
		"success_screen_text_5": "<b>Baixe</b> o aplicativo",
		"success_screen_text_6": "<b>Abra o app</b> e <b>aproveite</b><br /> o treinamento com seu cachorro!",
		"success_screen_text_7": "Duplicamos o código QR e o link para você em &nbsp;<b>example@gmail.com</b>",
		"success_screen_text_8": "Se a conta premium não foi aplicada no aplicativo, pressione <b>‘Entre em contato conosco’</b> na tela de boas-vindas e entre em contato com nossa equipe de suporte.",
		"success_screen_text_9": "Ao pressionar o botão ‘Começar’, confirmo que revisei e aceito a <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Política de Privacidade</a> e os <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Termos e Condições</a> e, por meio deste, concordo com o processamento dos meus dados pessoais.",
		"success_screen_text_10": "Entre em contato conosco",
		"success_screen_text_11": "Ir para minha conta",
		"success_screen_text_12": "Nós enviamos um código QR duplicado e um link para você por e-mail.",
		"success_screen_text_13": "Seu guia em PDF foi enviado para seu email <b>v.stsiopina@gmail.com</b>.",
		"success_screen_text_14": "Seu guia em PDF foi enviado para o seu e-mail.",
		"success_screen_text_15": "Se a conta premium não foi aplicada no aplicativo, pressione o link <span>'Entrar'</span> na tela de boas-vindas no aplicativo e insira seu e-mail e a senha que enviamos para <b>stepinavalerie@gmail.com</b>",
		"success_screen_text_16": "Se a conta premium não foi aplicada no aplicativo, pressione o link <span>'Entrar'</span> na tela de boas-vindas do aplicativo e insira seu e-mail e a senha que enviamos para você por e-mail.",
		"payment_text_1": "Seu programa de treinamento de cães começa agora!",
		"payment_text_2": "O aplicativo Everydoggy ajudará a <span>resolver rapidamente e de forma divertida qualquer problema de comportamento do seu cachorro</span>.",
		"payment_text_3": "A oferta pessoal expira",
		"payment_text_4": "dos nossos usuários notam mudanças positivas no comportamento de seus cães apenas 1 semana após o início do treinamento com nossos especialistas",
		"payment_text_5": "CadaCachorro vs Treinadores",
		"payment_text_6": "Quantidade média de comandos por mês",
		"payment_text_7": "CadaCachorro se beneficia",
		"payment_text_8": "Plano de treinamento de cães personalizado",
		"payment_text_9": "Apenas 15 minutos por dia para um animal de estimação perfeito",
		"payment_text_10": "Mais de 70 lições em vídeo fáceis de entender para resultados rápidos",
		"payment_text_11": "Mais de 80 jogos e truques para novas habilidades e apenas por diversão",
		"payment_text_12": "Dicas sobre higiene, saúde e nutrição",
		"payment_text_13": "Treine em casa e ao ar livre, sem equipamentos necessários",
		"payment_text_14": "98% dos nossos usuários notam mudanças positivas no comportamento de seus cães apenas 1 semana após o início do treinamento com nossos especialistas.",
		"payment_text_14_2": "<span>98% dos nossos usuários</span> notam mudanças positivas no comportamento de seus cães em apenas 1 semana após o início do treinamento com nossos especialistas",
		"payment_text_15": "Ao clicar no botão “Obter meu plano”, você concorda com nossos <a href='https://everydoggy.com/terms/' target=\"_blank\" >Termos e Condições</a> e <a href='https://everydoggy.com/policy/' target=\"_blank\" >Política de Privacidade</a>, <b>autoriza a renovação automática</b> da sua assinatura no final de cada ciclo de faturamento de <span>1 mês</span> pelo preço total de <i>$29.99</i> mais impostos aplicáveis. Você pode cancelar a renovação automática da sua assinatura a qualquer momento antes da data de renovação. Confira nossos <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Termos de Cancelamento</a> para mais detalhes.",
		"payment_text_16": "Ao clicar no botão “Obter meu plano”, você concorda com nossos <a href='https://everydoggy.com/terms/' target='_blank'>Termos e Condições</a> e <a href='https://everydoggy.com/policy/' target='_blank'>Política de Privacidade</a>, <b>autoriza a renovação automática</b> da sua assinatura ao final de cada ciclo de faturamento de <span>1 mês</span> pelo preço total de <i>$29.99</i> mais os impostos aplicáveis. Você pode cancelar a renovação automática da sua assinatura a qualquer momento antes da data de renovação. Confira nossos <a href='https://everydoggy.com/subscription-terms/' target='_blank'>Termos de Cancelamento</a> para mais detalhes.",
		"payment_text_17": "Tem uma pergunta?",
		"payment_text_18": "Basta escrever para nós em ",
		"payment_text_19": "Funciona!",
		"payment_text_20": "Acabei de concluir o programa de treinamento de obediência com nosso filhote, eu adoro! 👏",
		"payment_text_21": "Fantástico!",
		"payment_text_22": "Posso afirmar que estou 💯 satisfeito com esta app. Nunca mais tive problemas com necessidades fisiológicas, uau!",
		"payment_text_23": "Excelente app 🎉",
		"payment_text_24": "Estamos no nosso 3º mês de treino com o nosso cão e as habilidades dele melhoraram imenso!",
		"payment_text_25": "Vale a pena experimentar",
		"payment_text_26": "De longe a melhor app para treinar um cão!",
		"payment_text_27": "Receba inspiração dos nossos utilizadores",
		"payment_text_28": " Star Focus, Inc.",
		"payment_text_29": "Se ainda tiver dúvidas, contacte-nos em <a href=\"mailto:welove@everydoggy.com\">welove@everydoggy.com</a>",
		"payment_text_30": "Resultados visíveis com apenas 7 dias de treino",
		"payment_text_31": "Obtenha o seu plano pessoal com um desconto especial",
		"payment_text_32": "Quanto mais cedo começar a treinar, melhores serão os seus resultados",
		"payment_text_33": "O treino é essencial para cada cão. Faz mais do que eliminar problemas de comportamento, também inclui socialização, criar uma relação com o seu cão e expressar o seu carinho.",
		"payment_text_34": "Criado com e para o <span>carinho</span> com os cães. Com base em especialistas de classe mundial",
		"payment_text_35": "Tudo o que vai encontrar nesta aplicação é baseado nos estudos mais recentes e é totalmente focado nos cães.",
		"payment_text_36": "Se o seu cão pudesse falar, iria pedir-lhe para experimentar a EveryDoggy!",
		"payment_text_37": "As suas informações estão segura",
		"payment_text_38": "Não iremos vender ou alugar as suas informações de contacto pessoais para quaisquer propósitos de marketing.",
		"payment_text_39": "Checkout seguro",
		"payment_text_40": "Todas as informações são encriptadas e transmitidas sem riscos.",
		"payment_text_41": "Preciso de ajuda",
		"payment_text_42": "Envie-nos um email: <a href=\"mailto:welove@everydoggy.com\">welove@everydoggy.com</a>",
		"payment_text_43": "mensal",
		"payment_text_44": "continuar",
		"payment_text_45": "O seu plano pessoal:",
		"payment_text_46": "Desconto de oferta introdutória:",
		"payment_text_47": "Ao continuar, está a concordar com os <a href='https://everydoggy.com/terms/' target='_blank' rel=\"noreferrer\">Termos e Condições</a>, <a href='https://everydoggy.com/policy/' target='_blank' rel=\"noreferrer\">Política de Privacidade</a> e <a href='https://everydoggy.com/subscription-terms/#subscription_cancellation' target='_blank' rel=\"noreferrer\">Termos de Cancelamento</a>",
		"payment_text_48": "A sua subscrição dura até",
		"payment_text_49": "Pode cancelar a qualquer momento sem encargos, até 24 horas antes da expiração do período de subscrição.",
		"payment_text_50": "Se não a cancelar, a sua assinatura será renovada automaticamente no final da sua subscrição. Será cobrada a taxa de assinatura de <b>$</b><i>$29.99</i> da EveryDoggy até que esta seja cancelada.",
		"payment_text_51": "Neste momento não oferecemos reembolsos ou créditos para assinaturas parciais.",
		"payment_text_52": "Treinador<br> pessoal",
		"payment_text_53": "Escola<br> de cães",
		"payment_text_54": "Aulas<br> no YouTube",
		"payment_text_55": "Livros",
		"payment_text_56": "semanalmente",
		"payment_text_57": "Resultados significativamente melhores",
		"payment_text_58": "Com o EveryDoggy",
		"payment_text_59": "Sem o EveryDoggy",
		"payment_text_60": "Agora",
		"payment_text_61": "Após 1 semana",
		"payment_text_62": "Esta é a sua última oportunidade",
		"payment_text_63": "Aproveite o desconto exclusivo de 65% e veja a rapidez com que o seu cão aprende e obedece aos comandos!",
		"payment_text_64": "Obter 65% de desconto",
		"payment_text_65": "PLANO DE 52 SEMANAS",
		"payment_text_66": "PLANO DE 4 SEMANAS",
		"payment_text_67": "PLANO DE 12 SEMANAS",
		"payment_text_68": "semanas",
		"payment_text_69": "Janeiro",
		"payment_text_70": "Fevereiro",
		"payment_text_71": "Março",
		"payment_text_72": "Abril",
		"payment_text_73": "Maio",
		"payment_text_74": "Junho",
		"payment_text_75": "Julho",
		"payment_text_76": "Agosto",
		"payment_text_77": "Setembro",
		"payment_text_78": "Outubro",
		"payment_text_79": "Novembro",
		"payment_text_80": "Dezembro",
		"payment_text_81": "Insira um endereço de e-mail válido",
		"payment_text_82": "Apenas lhe será cobrado o valor de <b>$6.99</b> hoje pela sua primeira semana (detalhes abaixo)",
		"payment_text_83": "O seu período inicial termina a <b>Oct 11, 2024</b>.",
		"payment_text_84": "Poderá cancelar a qualquer altura antes de <b>Oct 10, 2024</b>, e não lhe será cobrado qualquer valor.",
		"payment_text_85": "Se não cancelar, a EveryDoggy irá automaticamente dar continuidade à sua adesão no final do seu período inicial e ser-lhe-á cobrada uma quota (atualmente <b>$39.99 USD</b>) <span>mensalmente</span> até cancelar.",
		"payment_text_86": "Sem reembolsos parciais. Pode cancelar a sua subscrição a qualquer altura na sua Conta.",
		"payment_text_87": "A sua subscrição estará vinculada aos nossos <a href='https://everydoggy.com/terms/' target=\"_blank\" >Termos e Condições</a>, <a href='https://everydoggy.com/policy/' target=\"_blank\" >Política de Privacidade</a> e <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Termos de Cancelamento</a>.",
		"payment_text_88": "Método de pagamento",
		"payment_text_89": "A EveryDoggy irá utilizar os seus detalhes de pagamento para pagamentos futuros e consistentes",
		"payment_text_90": "Pagamentos fáceis e privados com ID de rosto/toque",
		"payment_text_91": "Mantêm a sua informação financeira segura com encriptação ponta-a-ponta",
		"payment_text_92": "Protegida pelo Número de Conta do Dispositivo único do Apple Pay",
		"payment_text_93": "A sua informação de pagamento está segura com a encriptação SSL/TLS",
		"payment_text_94": "Opção de pagamento rápida e conveniente",
		"payment_text_95": "Com apoio da proteção contra fraude líder de mercado do PayPal",
		"payment_text_96": "Confirmar compra",
		"payment_text_97": "1-SEMANA",
		"payment_text_98": "1-MÊS",
		"payment_text_99": "3-MESES",
		"payment_text_100": "Hoje você será cobrado apenas <b>$6.99</b> pelo seu primeiro mês (detalhes abaixo).",
		"payment_text_101": "Hoje você será cobrado apenas <b>$6.99</b> pelos seus primeiros 3 meses (detalhes abaixo).",
		"payment_text_102": "Assinar com",
		"payment_text_103": "Ao clicar no botão \"Obter meu plano\", você concorda com a <a href='https://everydoggy.com/policy/' target=\"_blank\" >Política de Privacidade</a>, os <a href='https://everydoggy.com/terms/' target=\"_blank\" >Termos e Condições</a> e a <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Política de Cancelamento</a>.",
		"payment_text_104": "Pagamentos fáceis e privados",
		"payment_text_105": "Cartão de crédito",
		"payment_text_106": "Data de validade",
		"payment_text_107": "CVC",
		"payment_text_108": "excelente início",
		"payment_text_109": "plano de uma semana",
		"payment_text_110": "A aplicação Everydoggy <span>ajuda a resolver problemas a fazer as necessidades ou qualquer outro problema de comportamento do cão</span> de forma rápida e divertida.",
		"payment_text_111": "Checkout seguro",
		"payment_text_112": "Plano de treino personalizado para <span>o seu cachorro</span>",
		"payment_text_113": "Apito e dispositivo de clique para treino",
		"payment_text_114": "Mais de 80 jogos e truques para o seu animal de estimação",
		"payment_text_115": "Mais de 30 dicas e artigos sobre cuidados de saúde",
		"payment_text_116": "🔥 Acabou de poupar <span>$113,50&nbsp;</span>🔥",
		"payment_text_117": "Plano de sete dias",
		"payment_text_118": "Ao clicar no botão “Obter o meu plano”, concorda com os nossos <a href='https://everydoggy.com/terms/' target=\"_blank\" >Termos e Condições</a> e <a href='https://everydoggy.com/policy/' target=\"_blank\" >Política de Privacidade</a> e <b>autoriza a renovação automática</b> da sua subscrição. Apenas lhe será cobrado <span class=\"trialPrice\">4,99 $</span> hoje pelos primeiros <span class=\"trialPeriod\">sete dias</span> do período introdutório. Se não cancelar, a Everydoggy continuará automaticamente a sua subscrição no final do seu período introdutório e cobrará a taxa de subscrição de <span class='price'>39,99 $</span> a cada <span class='period'>mês</span> até que cancele. Pode cancelar a renovação automática da sua subscrição em qualquer altura antes da data de renovação. Consulte os nossos Termos de cancelamento para obter mais pormenores.",
		"payment_text_119": "Sete dias",
		"payment_text_120": "Só lhe será cobrado <b>29,99 $</b> hoje pelas suas primeiras <span>12 semanas</span> (detalhes abaixo)",
		"payment_text_121": "A aplicação Everydoggy irá <span>ajudar a treinar</span> o seu cão <span>a fazer as necessidades</span> no sítio certo e <span>corrigir problemas de comportamento</span> de forma rápida e divertida.",
		"payment_text_122": "Um cão treinado a fazer as necessidades em 3 dias",
		"payment_text_123": "A tua conta está associada a este email e não pode ser alterada",
		"payment_text_124": "Ao continuar, concorda com os nossos <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Termos e Condições</a> e com a nossa <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Política de Privacidade</a>, e <span>autoriza a renovação automática da sua subscrição</span>.",
		"payment_text_125": "PLANO DE 26 SEMANAS",
		"payment_text_126": "Se não cancelar, a EveryDoggy irá automaticamente dar continuidade à sua adesão no final do seu período inicial e ser-lhe-á cobrada uma quota (atualmente <b>$39.99 USD</b>) <span>a cada 3 meses</span> até cancelar.",
		"payment_text_127": "Se não cancelar, a EveryDoggy irá automaticamente dar continuidade à sua adesão no final do seu período inicial e ser-lhe-á cobrada uma quota (atualmente <b>$39.99 USD</b>) <span>a cada 6 meses</span> até cancelar.",
		"payment_text_128": "Nível atual",
		"payment_text_129": "comandos",
		"payment_text_130": "Objetivo",
		"payment_text_131": "Mais de 50 comandos e obediência",
		"payment_text_132": "Progressos visíveis",
		"payment_text_133": "Consiga obediência",
		"payment_text_134": "Mantenha o seu cão bem treinado para toda a vida",
		"payment_text_135": "Poupe 53%",
		"payment_text_136": "Garantia de reembolso",
		"payment_text_137": "Garantia de 30 dias para reembolso",
		"payment_text_138": "Acreditamos que o nosso plano trará resultados visíveis em 4 semanas! Até estamos dispostos a devolver-lhe o seu dinheiro se não vir resultados concretos e conseguir demonstrar que seguiu o nosso plano.",
		"payment_text_139": "Para mais informações sobre as limitações aplicáveis, consulte as nossas <a href=\"https://everydoggy.com/terms/#section5_2\" target=\"_blank\" rel=\"noreferrer\">condições de utilização</a>.\n",
		"payment_text_140": "Poupe 65%",
		"payment_text_141": "O teu Plano de Treino Canino está pronto!",
		"payment_text_142": "Obediência",
		"payment_text_143": "Reconhecer Ordens",
		"payment_text_144": "Incidentes de WC",
		"payment_text_145": "Frequente",
		"payment_text_146": "Nenhum",
		"payment_text_147": "Ladrar",
		"payment_text_148": "Ladra a tudo",
		"payment_text_149": "Calmo e relaxado",
		"payment_text_150": "Morder e mastigar",
		"payment_text_151": "Frequentemente",
		"payment_text_152": "Parou",
		"payment_text_153": "Puxar a trela",
		"payment_text_154": "Sempre",
		"payment_text_155": "Caminha calmamente",
		"payment_text_156": "Ansiedade Quando Deixado Sozinho",
		"payment_text_157": "Calmo e independente",
		"payment_text_158": "Antes",
		"payment_text_159": "Depois",
		"payment_text_160": "minutos",
		"payment_text_161": "segundos",
		"payment_text_162": "Comprovado. Testado. Funciona",
		"payment_text_163": "Mudanças significativas na obediência do cão",
		"payment_text_164": "Hoje",
		"payment_text_165": "Semana 2",
		"payment_text_166": "Semana 3",
		"payment_text_167": "Semana 4",
		"payment_text_168": "O que torna a Everydoggy tão eficaz",
		"payment_text_169": "Histórias de sucesso dos nossos utilizadores",
		"payment_text_170": "Criada por especialistas que <span>adoram cães</span>",
		"payment_text_171": "Todos os nossos cursos e exercícios são baseados em estudos científicos sobre treino de cães.",
		"payment_text_172": "Crie uma ligação forte com o seu cão, experimente a EveryDoggy!",
		"payment_text_173": "Provada. Testada. Funciona",
		"payment_text_174": "<span>93% dos nossos utilizadores</span> notam alterações significativas no comportamento do seu cão no primeiro mês de treino.",
		"payment_text_175": "Com a EveryDoggy",
		"payment_text_176": "Sem a EveryDoggy",
		"payment_text_177": "Hoje",
		"payment_text_178": "Semana 2",
		"payment_text_179": "Semana 4",
		"payment_text_180": "Semana 6",
		"payment_text_181": "Acerca da Luna",
		"payment_text_182": "A minha cachorrinha estava sempre a ter acidentes em casa. A Everydoggy deu-nos uma rotina clara, e realmente funcionou!",
		"payment_text_183": "Acerca do Cooper",
		"payment_text_184": "O nosso cachorro costumava mordiscar toda a gente durante as suas brincadeiras. A aplicação deu-nos uma orientação detalhada, e funcionou!",
		"payment_text_185": "Acerca da Bella",
		"payment_text_186": "A nossa cadela roía tudo - de sapatos até ao sofá. A aplicação ajudou-nos a redirecionar aquela energia!",
		"payment_text_187": "Acerca do Charlie",
		"payment_text_188": "Puxar a trela era uma luta diária. Graças à aplicação, os passeios são agora agradáveis e sem stress.",
		"payment_text_189": "Fazer necessidades treinado",
		"payment_text_190": "Resolveu as mordidelas",
		"payment_text_191": "Roer resolvido",
		"payment_text_192": "Puxar a trela resolvido",
		"payment_text_193": "<span>93% dos nossos utilizadores</span> notam mudanças significativas no<span>comportamento e obediência do seu cão</span> no primeiro mês de treino.</span>",
		"payment_text_194": "Os nossos utilizadores ficam espantados com os resultados!",
		"payment_text_195": "Comece já a treinar com o seu cão!",
		"payment_text_196": "Se não cancelar, a Everydoggy renovará automaticamente a sua subscrição no final do período introdutório e cobrar-lhe-á a taxa de subscrição (valor atual: <b>39,99 USD</b>), <span>com uma periodicidade quinzenal</span>, até ao momento em que efetuar o cancelamento. ",
		"payment_text_197": "Garantia de reembolso",
		"payment_text_198": "Garantia de 30 dias para reembolso",
		"payment_text_199": "Acreditamos que o nosso plano trará resultados visíveis em 4 semanas! Até estamos dispostos a devolver-lhe o seu dinheiro se não vir resultados concretos e conseguir demonstrar que seguiu o nosso plano.",
		"payment_text_200": "Para mais informações sobre as limitações aplicáveis, consulte as nossas <a href=\"https://everydoggy.com/terms/#section5_2\" target=\"_blank\" rel=\"noreferrer\">condições de utilização</a>.\n",
		"payment_text_201": "Perguntas frequentes",
		"payment_text_202": "Quanto tempo demora até ver resultados do treino?",
		"payment_text_203": "A maioria dos cães mostra progresso logo após a primeira sessão — e, em apenas algumas semanas, verá resultados impressionantes e significativos!",
		"payment_text_204": "A app Everydoggy é tão eficaz como trabalhar com um treinador?",
		"payment_text_205": "Sim, e até mais eficaz — pode treinar todos os dias ao seu próprio ritmo, seguir lições passo a passo bem estruturadas e reforçar os comportamentos de forma consistente, em vez de apenas uma vez por semana com um treinador.",
		"payment_text_206": "Os resultados do treino são permanentes?",
		"payment_text_207": "Sim! Desde que continue a reforçar os bons hábitos, os resultados duram para toda a vida.",
		"payment_text_208": "Obter 72% de desconto",
		"payment_text_209": "Aproveite o desconto exclusivo de 72% e veja a rapidez com que o seu cão aprende e obedece aos comandos!",
		"payment_text_210": "Continuar com outro método de pagamento ",
		"payment_text_211": "Buy with",
		"payment_text_212": "VENDA DA BLACK FRIDAY!",
		"payment_text_213": "",
		"payment_text_214": "",
		"payment_text_215": "",
		"payment_text_216": "",
		"payment_text_217": "",
		"payment_text_218": "O programa de treino do seu cachorro começa agora!",
		"payment_text_219": "Treine com a app Everydoggy desde <span>os primeiros dias do seu cachorro</span> e tenha <span>um cão perfeitamente obediente</span>!",
		"payment_text_220": "dos nossos utilizadores notam mudanças positivas no comportamento do seu cachorro apenas 1 semana após começarem a treinar com os nossos especialistas",
		"payment_text_221": "Plano de treino personalizado para cachorros com menos de 6 meses",
		"payment_text_222": "Plano de treino personalizado para cachorros dos 6 aos 12 meses",
		"payment_text_223": "Comprovado com 3 milhões de cachorros",
		"payment_text_224": "Mudanças significativas na obediência do cão",
		"payment_text_225": "Obter 70% de desconto",
		"payment_text_226": "ÚLTIMA CHANCE!\r",
		"payment_text_227": "PLANO DE 24 SEMANAS",
		"payment_text_228": "O último programa de treino de que vai precisar começa agora!",
		"payment_text_229": "Plano de treino personalizado para resultados duradouros",
		"payment_text_230": "Um programa.<br />\nBom comportamento para toda a vida",
		"payment_text_231": "Idade do cão",
		"payment_text_232": "Tempo de treino",
		"payment_text_233": "Resultados duradouros",
		"payment_text_234": "0-1 ano",
		"payment_text_235": "1-3 anos",
		"payment_text_236": "3-5 anos",
		"payment_text_237": "5+ anos",
		"payment_text_238": "1-2 anos",
		"payment_text_239": "3 anos",
		"payment_text_240": "4 anos",
		"payment_text_241": "2-7 anos",
		"payment_text_242": "8 anos",
		"payment_text_243": "9 anos",
		"payment_text_244": "10+ anos",
		"payment_text_245": "",
		"payment_text_246": "",
		"payment_text_247": "",
		"payment_text_248": "",
		"payment_text_249": "",
		"payment_text_250": "",
		"payment_text_251": "",
		"payment_text_252": "",
		"payment_text_253": "",
		"payment_text_254": "",
		"payment_text_255": "",
		"payment_text_256": "",
		"payment_text_257": "",
		"payment_text_258": "",
		"payment_text_259": "",
		"payment_text_260": "",
		"payment_text_261": "",
		"payment_text_262": "",
		"payment_text_263": "Tradutor canino",
		"payment_text_264": "Compreenda o seu cão.<br/> Veja os resultados",
		"payment_text_265": "A obediência melhora com a análise dos sinais e do comportamento",
		"payment_text_266": "Plano de treino personalizado para o seu cão com base na análise do ladrar e do comportamento",
		"payment_text_267": "Duas vezes mais rápido, <br />duas vezes mais divertido!",
		"payment_text_268": "Obtenha o guia definitivo de treino para cachorros",
		"payment_text_269": "Obtenha o guia definitivo de treino canino",
		"payment_text_270": "Diga adeus aos problemas com a higiene! Métodos passo a passo para ensinar rapidamente o seu cão a fazer no sítio certo.",
		"payment_text_271": "Proteja os sapatos e os dedos! Com técnicas simples, o seu cachorro deixa de morder e roer tudo.",
		"payment_text_272": "Crie um espaço seguro e tranquilo para o seu cão e ensine-o a estar calmo e confiante na box.",
		"payment_text_273": "Tenha acesso a um conjunto completo de estratégias de especialistas para o comportamento, a obediência e o dia a dia com o seu cão.",
		"payment_text_274": "Corrija comportamentos indesejados em casa e nos passeios com métodos comprovados e fáceis de aplicar.",
		"payment_text_275": "Torne a aprendizagem divertida! Aprenda a usar elogios e recompensas para motivar o seu cão de imediato.",
		"payment_text_276": "Ensine ao seu cão muito mais do que o básico! Vai aprender tudo, desde comandos de segurança a truques divertidos e impressionantes para cães de todas as idades.",
		"payment_text_277": "Acelere os<br /> progressos do seu cão <span>2x!</span>",
		"payment_text_278": "Guia prático:",
		"payment_text_279": "DESCONTO de 98% exclusivo para membros",
		"payment_text_280": "DESCONTO de 70% exclusivo para membros",
		"payment_text_281": "O seu programa de apoio veterinário para o seu cão começa agora!",
		"payment_text_282": "Cuide da saúde do seu cão com <span>apoio veterinário especializado</span> da Everydoggy e <span>crie um cão saudável e bem-comportado</span> com menos preocupações!",
		"payment_text_283": "Apoio veterinário por chat imediato — sem marcações, sem esperas",
		"payment_text_284": "Partilhe fotos para receber orientações mais precisas",
		"payment_text_285": "Aprenda primeiros socorros para emergências como golpe de calor, ferimentos ou queimaduras pelo frio",
		"payment_text_286": "Mantenha-se a par de calendários atualizados de vacinação e check-ups",
		"payment_text_287": "Receba dicas de cuidados para dentes, ouvidos, olhos, unhas, desparasitação e muito mais",
		"payment_text_288": "Sinta-se mais confiante sobre a saúde do seu cão e preocupe-se menos todos os dias",
		"payment_text_289": "O que torna o Everydoggy VET tão eficaz",
		"payment_text_290": "Mais de 3M donos de cães confiam em nós",
		"payment_text_291": "Fale por chat a qualquer momento com apoio veterinário em que pode confiar",
		"payment_text_292": "Treine o seu cão com a app Everydoggy e desfrute de um <span>companheiro perfeitamente bem-educado</span>!",
		"payment_text_293": "Comprovado com 3 milhões de cães",
		"payment_text_294": "Plano de treino personalizado, adaptado ao seu cão",
		"payment_text_295": "Quando o meu cachorro teve diarreia, recebi rapidamente o conselho de um veterinário e soube exatamente como agir. Poupou-me muito stress.",
		"payment_text_296": "Os conselhos são claros e fiáveis. Sinto que tenho sempre um profissional em quem posso confiar.",
		"payment_text_297": "Usei-o quando o meu cão teve irritação na pele e comichão constante. A orientação foi clara e senti-me tranquila de imediato.",
		"payment_text_298": "Como novo dono de um cachorro, isto tem sido incrivelmente útil. Já não tenho de adivinhar.",
		"payment_text_299": "dos nossos utilizadores sentem-se mais confiantes em relação à saúde do seu cão e preocupam-se menos com o nosso apoio veterinário",
		"payment_text_300": "<span>98% dos nossos utilizadores</span> sentem-se mais confiantes em relação à saúde do seu cão e preocupam-se menos com o nosso apoio veterinário",
		"payment_text_301": "O seu programa personalizado de brincadeira e comunicação <span>começa agora</span>!",
		"payment_text_302": "Com a Everydoggy, vai <span>entender melhor o seu cão</span>, <span>divertir-se mais em conjunto</span> e <span>criar uma ligação duradoura</span>!",
		"payment_text_303": "3M+ utilizadores",
		"payment_text_304": "Desfrutam da vida com os seus cães ao máximo",
		"payment_text_305": "Agora",
		"payment_text_306": "Compreender o seu cão",
		"payment_text_307": "Comunicação com o seu cão",
		"payment_text_308": "Prazer na brincadeira",
		"payment_text_309": "Ligação",
		"payment_text_310": "Programa personalizado de comunicação e brincadeira com o seu cão",
		"payment_text_311": "Traduza e compreenda os latidos do seu cão com Latido IA",
		"payment_text_312": "🎁 O seu desconto de boas-vindas foi aplicado:",
		"payment_text_313": "<span>53%</span> DE DESCONTO",
		"payment_text_314": "O seu programa personalizado de treino canino começa agora!",
		"payment_text_315": "Veja resultados rápidos e desfrute da vida com um cão bem-comportado!",
		"payment_text_316": "Comandos aprendidos:",
		"payment_text_317": "Nível de obediência:",
		"payment_text_318": "Baixo",
		"payment_text_319": "Alto",
		"payment_text_320": "O programa de treino personalizado para <span>o seu cão</span> está pronto!",
		"payment_text_321": "Perfil de treino",
		"payment_text_322": "Raça do cão",
		"payment_text_323": "Idade",
		"payment_text_324": "Problemas de comportamento",
		"payment_text_325": "Nível atual",
		"payment_text_326": "Mais de 3 milhões",
		"payment_text_327": "de tutores de cães já desfrutam dos resultados",
		"payment_text_328": "Ashley K. e Moly",
		"payment_text_329": "Adoro como as tarefas diárias de treino são simples. O meu cão agora ouve mesmo!",
		"payment_text_330": "Kevin R. e Tommy",
		"payment_text_331": "O treino para fazer as necessidades no sítio certo era a nossa maior dificuldade. Este programa foi a única coisa que realmente resultou.",
		"payment_text_332": "Chloe N. e Ami",
		"payment_text_333": "O meu cachorro costumava roer tudo. Agora só procura os brinquedos dele!",
		"payment_text_334": "Daniel H. e Cherry",
		"payment_text_335": "Gostei de tudo estar dividido em pequenos passos. O meu cão aprendeu comandos mais depressa do que eu esperava.",
		"payment_text_336": "O seu plano de treino sem stress para o seu cachorro começa agora!",
		"payment_text_337": "O seu plano de treino sem stress para o seu cão começa agora!",
		"payment_text_338": "O plano personalizado de nutrição e saúde do seu cão começa agora!",
		"payment_text_339": "Analise os rótulos dos alimentos para cães, receba conselhos de nutrição de especialistas e mantenha o seu cão <span>saudável e feliz</span>!",
		"payment_text_340": "Analise os rótulos dos alimentos. Proteja a saúde do seu cão",
		"payment_text_341": "Analise os rótulos dos alimentos para cães e perceba rapidamente os ingredientes e a qualidade",
		"payment_text_342": "Receba recomendações de alimentação adaptadas às necessidades do seu cão",
		"payment_text_343": "O scanner de rótulos dos alimentos mudou tudo. Sei imediatamente o que está realmente na comida do meu cão.",
		"payment_text_344": "Uma excelente ferramenta para acompanhar a saúde do meu cão e melhorar a sua alimentação. Resultados visíveis!",
		"payment_text_345": "Esta app tornou muito mais fácil gerir a nutrição do meu cão. Adoro as dicas personalizadas!",
		"payment_text_346": "É como se tivesse aprendido a linguagem da minha cadela — agora até o ladrar faz sentido.",
		"payment_text_347": "Os jogos são fantásticos. O meu cão fica entusiasmado sempre!",
		"payment_text_348": "Brincamos, criamos uma ligação, e finalmente percebo o que a minha cadela me quer dizer!",
		"payment_text_349": "dos nossos utilizadores sentem-se mais confiantes em relação à saúde do seu cão e preocupam-se menos com a ajuda da nossa app",
		"payment_text_350": "O que torna a EveryDoggy tão eficaz",
		"payment_text_351": "<span>98% dos nossos utilizadores</span> sentem-se mais confiantes sobre a saúde do seu cão e preocupam-se menos com o nosso plano",
		"payment_text_352": "Principiante",
		"payment_text_353": "O seu programa personalizado de treino para cães pequenos começa agora!",
		"payment_text_354": "O seu programa personalizado de treino K9 para cães começa agora!",
		"payment_text_355": "Obtenha resultados rápidos: o seu cão vai obedecer ao primeiro comando.",
		"payment_text_356": "Uma diferença enorme em poucas semanas. O meu cão finalmente obedece à primeira.",
		"payment_text_357": "Passear o meu cão já não é stressante. Agora tenho tudo sob controlo.",
		"payment_text_358": "Passámos do caos a um comportamento calmo muito depressa. Programa incrível.",
		"payment_text_359": "A obediência ao primeiro comando funciona mesmo. Não pensei que fosse possível.",
		"payment_text_360": "Plano personalizado de treino K9 para cães",
		"payment_text_361": "",
		"payment_text_362": "",
		"payment_text_363": "",
		"payment_text_364": "",
		"payment_text_365": "",
		"payment_text_366": "",
		"payment_text_367": "",
		"payment_text_368": "",
		"payment_text_369": "",
		"payment_text_370": "",
		"payment_text_371": "",
		"payment_text_372": "",
		"payment_text_373": "",
		"payment_text_374": "",
		"payment_text_375": "",
		"payment_text_376": "",
		"payment_text_377": "",
		"payment_text_378": "",
		"payment_text_379": "",
		"payment_text_380": "",
		"payment_text_381": "",
		"payment_text_382": "",
		"payment_text_383": "",
		"payment_text_384": "<span>Começa o teu caminho para um cão obediente:</span> obtém o guia K9 definitivo sobre reatividade",
		"payment_text_385": "Desbloqueia o <span>Manual prático K9 sobre reatividade</span>",
		"payment_text_386": "Faz o teu cão obedecer-te perto dos estímulos",
		"payment_text_387": "Trava as reações sem as deixar agravar",
		"payment_text_388": "Recupera o controlo quando o teu cão se descontrola",
		"payment_text_389": "Ensina o teu cão a não reagir de forma exagerada a pessoas, outros cães e carros",
		"pdfUpselling": "",
		"pdfUpselling_1": "<span>Dá o pontapé de saída na tua jornada para teres um cão obediente:</span> Agarra o guia definitivo para treino e educação canina.",
		"pdfUpselling_2": "<span>Dá o pontapé de saída na tua jornada para teres um cão obediente:</span> Agarra o guia definitivo para treino e educação de cachorros.",
		"pdfUpselling_3": "Recebe o teu <span>plano pessoal</span>",
		"pdfUpselling_4": "Desbloqueia o <span>guia prático</span>",
		"pdfUpselling_5": "Correção de comportamentos (dentro e fora de casa)  ",
		"pdfUpselling_6": "Como elogiar e recompensar o teu cão  ",
		"pdfUpselling_7": "Comandos diversos  ",
		"pdfUpselling_8": "Jogos de estimulação e muito mais  ",
		"pdfUpselling_9": "Treino de higiene ",
		"pdfUpselling_10": "Parar de morder e mastigar  ",
		"pdfUpselling_11": "Treino para caixa de transporte",
		"pdfUpselling_12": "Além de 43 outras dicas e soluções úteis  ",
		"pdfUpselling_13": "Total hoje",
		"pdfUpselling_14": "Desbloqueia o guia  ",
		"pdfUpselling_15": "Desbloqueia com  ",
		"pdfUpselling_16": "Continuar sem o guia",
		"chatUpsale_1": "Chat com treinador de cães",
		"chatUpsale_2": "Descreve o comportamento do teu cão. Nós temos a solução.",
		"chatUpsale_3": "Conversa com os nossos especialistas em adestramento de cães, sem limitações.",
		"chatUpsale_4": "Recebe mais do que esperas com o Everydoggy!",
		"chatUpsale_5": "Boost ×2",
		"chatUpsale_6": "Plano EveryDoggy",
		"chatUpsale_7": "Chat com treinador de cães",
		"chatUpsale_8": "Treino por sua conta",
		"chatUpsale_9": "ACESSO ILIMITADO",
		"chatUpsale_10": "Melhore os resultados com o Chat do Treinador Especialista!",
		"chatUpsale_11": "Acesso ao chat",
		"chatUpsale_12": "30 Dias",
		"chatUpsale_13": "90 Dias",
		"chatUpsale_14": "Continuar sem a conversa com o treinador de cães",
		"chatUpsale_15": "Acesso ilimitado ao chat com treinador de cães",
		"checkoutV2_text1": "total",
		"checkoutV2_text2": "Pagamentos fáceis e privados com o Face/Touch ID",
		"checkoutV2_text3": "Mantém as suas informações financeiras seguras com encriptação de ponta a ponta",
		"checkoutV2_text4": "Protegido pelo número de conta de dispositivo exclusivo do Apple Pay",
		"checkoutV2_text5": "Opção de pagamento rápida e conveniente",
		"checkoutV2_text6": "Mantém as suas informações financeiras seguras com encriptação de ponta a ponta",
		"checkoutV2_text7": "Apoiado pela proteção contra fraude líder de mercado da PayPal",
		"checkoutV2_text8": "Garantia de devolução do dinheiro",
		"checkoutV2_text9": "Checkout",
		"checkoutV2_text10": "Informações de pagamento",
		"checkoutV2_text11": "Protegido",
		"error_1": "Pagamento recusado. Verifique os dados do cartão e tente de novo.",
		"error_2": "Pagamento recusado. Verifique os dados do cartão e tente de novo.",
		"error_3": "Fundos insuficientes. Tente utilizar outro cartão ou método de pagamento.",
		"error_4": "O seu cartão expirou. Tente utilizar outro cartão ou método de pagamento.",
		"error_5": "Ocorreu um erro ao processar o seu cartão. Tente de novo.",
		"error_6": "O código de segurança está incorreto. Verifique os dados do cartão e tente de novo.",
		"error_7": "Neste momento, os cartões American Express não são suportados. Tente utilizar outro cartão ou método de pagamento.",
		"error_8": "Pagamento recusado. Verifique os dados do cartão e tente de novo.",
		"error_9": "Pagamento recusado. Este email já está associado a uma subscrição ativa.",
		"error_10": "Pagamento recusado. Demasiadas tentativas ou limite do cartão excedido. Por favor, tente novamente mais tarde.",
		"disclaimerV2_text_1": "Ao continuar, concorda com os nossos <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Termos e Condições</a> e com a nossa <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Política de Privacidade</a> e autoriza a renovação automática da sua subscrição. Hoje ser-lhe-á cobrado apenas <span class=\"price1\">$1.99</span> pela sua primeira semana. Se não cancelar, a Everydoggy renovará automaticamente a sua subscrição no final do período experimental e cobrará a taxa de subscrição (atualmente <span class=\"price2\">$29.99</span>) de 2 em 2 semanas, até que cancele.\n",
		"disclaimerV2_text_2": "Ao continuar, concorda com os nossos <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Termos e Condições</a> e com a nossa <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Política de Privacidade</a> e autoriza a renovação automática da sua subscrição.\r\nHoje ser-lhe-á cobrado apenas <span class=\"price1\">$6.99</span> pelas suas primeiras 4 semanas. \r\nSe não cancelar, a Everydoggy renovará automaticamente a sua subscrição no final do período experimental e \r\ncobrará a taxa de subscrição (atualmente <span class=\"price2\">$29.99</span>) de 2 em 2 semanas, até que cancele.\r\n",
		"disclaimerV2_text_3": "Ao continuar, concorda com os nossos <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Termos e Condições</a> e com a nossa <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Política de Privacidade</a> e autoriza a renovação automática da sua subscrição.\r\nHoje ser-lhe-á cobrado apenas <span class=\"price1\">$14.99</span> pelas suas primeiras 12 semanas. \r\nSe não cancelar, a Everydoggy renovará automaticamente a sua subscrição no final do período experimental e \r\ncobrará a taxa de subscrição (atualmente <span class=\"price2\">$49.99</span>) de 4 em 4 semanas, até que cancele.\r\n",
		"chatUpsaleV2_1": "Chat com treinador canino",
		"chatUpsaleV2_2": "Treine com um especialista em comportamento canino",
		"chatUpsaleV2_3": "Adicione ao seu plano suporte ilimitado por chat de treinadores caninos experientes",
		"chatUpsaleV2_4": "Com treinador",
		"chatUpsaleV2_5": "Eficiência",
		"chatUpsaleV2_6": "Respostas claras de um verdadeiro especialista",
		"chatUpsaleV2_7": "Aconselhamento personalizado para o seu cão",
		"chatUpsaleV2_8": "Resultados mais rápidos com menos erros",
		"chatUpsaleV2_9": "Um processo de treino calmo e confiante",
		"chatUpsaleV2_10": "Sem treinador",
		"chatUpsaleV2_11": "Dúvidas se está a fazer tudo corretamente",
		"chatUpsaleV2_12": "Progresso lento e erros repetidos",
		"chatUpsaleV2_13": "Razões pouco claras por trás do mau comportamento",
		"chatUpsaleV2_14": "Frustração para si e para o seu cão",
		"chatUpsaleV2_15": "Cada cão é diferente. Obtenha ajuda especializada para o seu!",
		"chatUpsaleV2_16": "Obtenha respostas até às perguntas mais difíceis sobre comportamento canino",
		"chatUpsaleV2_17": "Receba apoio tanto emocional como prático no treino",
		"chatUpsaleV2_18": "Reduza o stress e a frustração durante o treino",
		"chatUpsaleV2_19": "Desfrute de orientação personalizada, ajustada a si e ao seu cão",
		"chatUpsaleV2_20": "Garanta apoio profissional para resultados máximos",
		"chatUpsaleV2_21": "Vagas limitadas",
		"chatUpsaleV2_22": "Últimas vagas exclusivas",
		"chatUpsaleV2_23": "Acesso ao chat com treinador canino especialista por 4 semanas:",
		"chatUpsaleV2_24": "Desconto extra limitado de 75%:",
		"chatUpsaleV2_25": "Total",
		"chatUpsaleV2_26": "Obter ajuda de especialista agora",
		"chatUpsaleV2_27": "Continuar sem chat com treinador canino",
		"chatUpsaleV2_28": "Posso fazer qualquer pergunta sobre o meu cão?",
		"chatUpsaleV2_29": "Sim! Pode perguntar sobre comportamento, treino, questões de cachorro ou desafios específicos que esteja a enfrentar.",
		"chatUpsaleV2_30": "Quão rápido vou receber uma resposta?",
		"chatUpsaleV2_31": "Os nossos treinadores experientes costumam responder em até 24 horas nos dias úteis.",
		"chatUpsaleV2_32": "Preciso de experiência prévia de treino?",
		"chatUpsaleV2_33": "De modo nenhum. Os nossos treinadores orientam-no passo a passo, quer seja iniciante quer seja um tutor experiente."
	},
	"es": {
		"global \ninstruction": "",
		"safe": "Tu información está segura",
		"information": "No venderemos ni alquilaremos su información de contacto personal para ningún propósito de marketing.",
		"secure_checkout": "Pago seguro",
		"encrypted": "Toda la información está cifrada y transmitida sin riesgo utilizando un protocolo Secure Sockets Layer.",
		"help": "¿Necesitas ayuda?",
		"contact": "Contáctanos",
		"here": "aquí.",
		"undefined": "",
		"featured": "Como se presenta en",
		"main_title": "Cursos de adiestramiento de perros",
		"per_year": "por año",
		"special_offer": "Oferta especial",
		"card_number": "Número de tarjeta",
		"card_expiry": "La tarjeta expira",
		"security_number": "Número de seguridad",
		"email": "Correo electrónico",
		"To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of __period__ and at the full, not discounted, price of __fullPriceText__ To learn more visit our <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">terms of use</a>.": "Información de pago",
		"secure_server": "Servidor seguro",
		"pay": "Pagar",
		"enter_your_email": "Ingresa tu correo electrónico",
		"comment_1": "Durante unos años estresantes, perdí totalmente mi forma y gané un poco de grasa, pero no tenía tiempo ni motivación para hacer nada al respecto. Un miembro de la familia me sugirió Verv y ahora confío en mi Coach a diario.",
		"comment_2": "Verv me hizo disfrutar de los entrenamientos en casa y he perdido 7 kg en un mes. Esta aplicación realmente puede ayudarte a hacer ejercicio y perder peso si eres un principiante como yo.",
		"success_story": "Historia de éxito",
		"get_my_plan": "OBTENER MI PLAN",
		"delimiter": "o",
		"pay_buy_card": "Pagar con tarjeta",
		"get_my_plan_warning_1": "Para evitar cualquier interrupción, aceptas que la suscripción que seleccionaste se renovará automáticamente por un período sucesivo de",
		"get_my_plan_warning_2": "y al precio completo, no descontado de",
		"get_my_plan_warning_3": "Para saber más, visita nuestro",
		"get_my_plan_warning_text": "Al continuar, aceptas que si no cancelas al menos 24 horas antes del final del primer período de renovación, se te cobrará automáticamente el precio completo de __fullPriceText__ cada __period__ hasta que cancels.",
		"terms_of_use": "Términos de uso",
		"privacy_policy": "Política de privacidad",
		"terms_conditions": "Términos y condiciones",
		"privacy_policy_footer": "Política de privacidad",
		"terms_conditions_footer": "Términos y condiciones",
		"guaranteed": "Pago garantizado y seguro",
		"special_features": "Funciones especiales para ti",
		"calories_value": "kcal",
		"personalized_plan": "Obtén tu plan personalizado:",
		"mobile_app": "Aplicación móvil con tu plan",
		"daily_programs": "Programas diarios para diferentes objetivos (quemar grasa, reducir el estrés, ganar músculo)",
		"audio_guided": "Entrenamientos guiados por audio",
		"easy_to_cook": "Platos fáciles de cocinar y sabrosos",
		"comprehensive_stats": "Estadísticas completas",
		"secret_tips": "Consejos secretos para desarrollar hábitos saludables",
		"mobile_app_tailor": "Plan personalizado en tu bolsillo",
		"daily_programs_for": "Programas diarios",
		"daily_programs_for_2": "Para diferentes objetivos (quemar grasa, reducir el estrés, aumento de masa muscular)",
		"audio_trainers": "Guías de entrenadores profesionales",
		"comprehensive_track": "Sigue tu progreso con estadísticas definitivas",
		"price": "Precio",
		"users_love": "A los usuarios les encanta nuestro Plan Personalizado",
		"alternative_review_name_1": "Therealtierra",
		"alternative_review_title_1": "¡Gran aplicación!",
		"alternative_review_contentent_1": "Estoy en mi novena semana y mi cuerpo ha cambiado muchísimo!",
		"alternative_review_name_2": "chica de tenis",
		"alternative_review_title_2": "¡Funciona!",
		"alternative_review_contentent_2": "Acabo de terminar el programa. ¡Me encanta! ¡He bajado 15 kg!!",
		"you_re_in": "¡Estás dentro!",
		"personal_plan_starts": "Tu plan personal de Verv comienza hoy y el tiempo corre. ¡Así que échale un vistazo!",
		"app_by_link": "Para ingresar a tu programa, descarga la aplicación a través del enlace",
		"download_now": "Descargar ahora",
		"or": "o",
		"price_after_trial": "Precio después de la prueba",
		"seven_days_trial_unlocked": "Prueba de 7 días desbloqueada",
		"total_today": "Total hoy",
		"reserved_price_for": "Precio reservado para",
		"new_subscritions1_title": "Elige tu plan",
		"new_subscritions1_subscription1_line1": "Plan semestral",
		"new_subscritions1_subscription1_price1_time": "por semana",
		"new_subscritions1_subscription2_line1": "plan de 3 meses",
		"new_subscritions1_subscription2_price2_time": "por semana",
		"new_subscritions1_subscription3_line1": "plan de 1 mes",
		"new_subscritions1_subscription3_price3_time": "por semana",
		"new_subscription_save": "GUARDAR",
		"new_subscritions_agreement": "Al continuar, aceptas",
		"new_subscritions_and": "y",
		"new_subscritions_subtitle": "Nuestros usuarios han perdido 10 millones de libras",
		"new_subscritions_join": "Únete a millones de nuestros usuarios felices",
		"statistic_block_item1_text": "Estrellas de 5",
		"statistic_block_item2_text": "calificaciones de 5 estrellas",
		"statistic_block_item3_text": "descargas",
		"get_your_personalized_plan": "Obtén tu plan personalizado",
		"for": "para",
		"new_subscription_save_mostPopular1MonthPrice": "el plan más popular",
		"timer_additional_discount": "Descuento adicional aplicado justo ",
		"timer_additional_discount_bold": "para ti",
		"timer_offer_expires": "Esta oferta expira en:",
		"Payment Successful": "",
		"payment_successful_title": "¡Hola del equipo Verv!",
		"payment_successful_download": "Descarga la aplicación",
		"payment_successful_press": "Presiona",
		"payment_successful_login": "Iniciar sesión con correo electrónico",
		"payment_successful_email": "Introduce tu correo electrónico",
		"payment_successful_code": "y su código de confirmación:",
		"payment_successful_hit": "Entonces toca",
		"payment_successful_done": "Hecho",
		"payment_successful_description": "¡Estás dentro, disfruta de tu plan de entrenamiento personalizado!",
		"Tariffs Variants": "",
		"tariff_title_choose": "Elige tu plan",
		"tariff_title_get": "Obtén tu plan",
		"tariff_one_month": "Plan de 1 mes",
		"tariff_three_month": "Plan de 3 meses",
		"tariff_six_month": "Plan de 6 meses",
		"tariff_one_year": "Plan de 1 año",
		"tariff_one_week": "Plan de 1 semana",
		"tariff_three_day": "Plan de 3 días",
		"tariff_per_year": "por año",
		"tariff_per_day": "por día",
		"tariff_per_days": "cada 3 días",
		"tariff_per_week": "por semana",
		"tariff_week": "semana",
		"tariff_annual": "Plan anual",
		"tariff_trial_one_week": "Prueba de 1 semana",
		"tariff_after": "después ",
		"tariff_save": "Guardar",
		"tariff_best_offer": "mejor oferta",
		"tariff_most_popular": "el más popular",
		"tariff_limited_promo": "precio promocional limitado",
		"tariff_6_for_3": "6 al precio de 3",
		"tariff_first_month": "primer mes",
		"tariff_first_week": "primera semana",
		"tariff_monthly": "mensual",
		"tariff_quaterly": "trimestral",
		"tariff_semiannually": "semestralmente",
		"tariff_billed_every ": "facturado cada ",
		"tariff_year": "año",
		"tariff_month": "mes",
		"tariff_months": "meses",
		"tariff_months_variable": "meses",
		"tariff_organic_gift": "Plan de meditación",
		"tariff_full_price": "Precio completo",
		"tariff_no_hidden_fees": "Sin tarifas ocultas",
		"tariff_start_right_now": "Empieza ahora mismo",
		"tariff_more_than": "Más de 1.000.000 de miembros activos de la familia Verv",
		"tariff_intro_offer": "OFERTA INICIAL",
		"Тарифы плиткой в ряд": "",
		"": "Nunca pensé que mi perro fuera tan inteligente. ¡Con EveryDoggy hemos aprendido 5 nuevos trucos en una sola semana!",
		"Checkout": "",
		"checkout_title": "Selecciona el método de pago",
		"insufficient_funds": "Fondos insuficientes",
		"insufficient_we_have": "Tenemos un",
		"insufficient_special_price": "precio especial",
		"insufficient_for_you": "para ti",
		"checkout_edit_card": "Editar tarjeta",
		"checkout_pay_via": "Pagar a través de",
		"checkout_paypal": "PayPal",
		"checkout_credit_card": "Tarjeta de crédito",
		"checkout_paypal_description": "Su pago será procesado a través de PayPal",
		"checkout_total_price": "Precio total",
		"checkout_warning_1": "Para evitar cualquier interrupción, acepta que la suscripción seleccionada se renovará automáticamente por un período sucesivo de",
		"checkout_warning_2": "y al precio total, no rebajado, de",
		"checkout_warning_3": "Para obtener más información, visita nuestro",
		"spv2_warning": "Para evitar cualquier interrupción, usted acepta que la suscripción seleccionada se renovará automáticamente por un período sucesivo de __________ y al precio completo, no con descuento, de __________. Para obtener más información, visite nuestros <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">términos de uso</a>.",
		"checkout_offer_day_for": "día para",
		"checkout_offer_days_for": "días para",
		"checkout_offer_month_for": "mes para",
		"checkout_offer_months_for": "meses para",
		"checkout_offer_week_for": "semana para",
		"Values": "",
		"value_kg": "kg",
		"value_pounds": "lbs",
		"value_st": "st",
		"value_g": "g",
		"value_kcal": "kcal",
		"value_min": "min",
		"value_min_cooking": "minutos de cocción",
		"welcome_title": "¡Bienvenido a Verv Premium!",
		"item_1_title": "¡Yupi!",
		"item_1_description": "Tu peso objetivo de __weight__ ahora está a la vuelta de la esquina.",
		"item_2_title": "Cómo activar",
		"item_2_description": "Descarga la aplicación utilizando el enlace de abajo, usa tu correo electrónico __mail__ e ingresa este código de validación: __code__.",
		"item_2_description_2": "Para cambiar el correo electrónico, haga clic <button id=\"changeMail\">aquí</button>.",
		"item_3_title": "¿Algo salió mal?",
		"item_3_description": "Se envió una instrucción detallada a su correo electrónico. Si no la recibió, comuníquese con <a target=\"_blank\" href=\"mailto:support@verv.com?subject=Problema de inicio de sesión (simple-login)\">soporte</a>.",
		"change": "Confirmar",
		"change_mail": "Cambia tu correo electrónico aquí para activar Premium",
		"email_warning": "Por favor, completa una dirección de correo electrónico válida",
		"Promo Code Block": "",
		"promo_code_title": "¡Código promocional aplicado!",
		"promo_code_save": "% de descuento",
		"EveryDoggy": "",
		"dog_courses": "cursos de perros",
		"why_we_best_active": "Usuarios activos.",
		"why_we_best_lessons": "Lecciones en vídeo.",
		"why_we_best_brain": "Juegos mentales.",
		"why_we_best": "¿Por qué somos los mejores?",
		"why_we_best_join": "Únete a nuestra comunidad de dueños de perros y haz lo mejor que puedas con EveryDoggy.",
		"why_we_best_enjoy": "Disfruta de tu plan de entrenamiento personalizado, adaptado a tus objetivos y a los de tu perro.",
		"why_we_best_keep": "Mantén a tu perro mental y físicamente activo con más de 70 juegos para el cerebro.",
		"dog_problems": "Soluciones rápidas a problemas de comportamiento",
		"dog_problems_choose": "Elige los comportamientos no deseados que te gustaría mejorar",
		"dog_problems_leash": "Tirando de la<br/>correa",
		"dog_problems_biting": "Morder",
		"dog_problems_anxiety": "Ansiedad por separación<br/>",
		"dog_problems_chewing": "Masticación<br/>destructiva",
		"dog_plan": "Plan de entrenamiento personalizado",
		"dog_plan_our": "Nuestro programa de entrenamiento está 100% adaptado a las necesidades de tu perro.",
		"dog_reviews": "Lo que los dueños de perros dicen sobre EveryDoggy",
		"dog_reviews_text_1": "«Lecciones muy claras y fáciles de seguir. A mi cachorro le gusta entrenar y ambos hemos aprendido mucho.»",
		"dog_reviews_name_1": "Megan y Leo",
		"dog_reviews_text_2": "El comando \"Zen\" hace maravillas. Gracias a él, mi perro está súper tranquilo en la clínica veterinaria durante los procedimientos.",
		"dog_reviews_name_2": "Linda B.",
		"dog_reviews_text_3": "«Gracias por la lección de entrenamiento con clicker. He oído que es muy popular, pero no estaba claro cómo usarlo. Rápidamente familiaricé a mi perro con el clicker y ahora hemos comenzado a aprender trucos.»",
		"dog_reviews_name_3": "Jake L.",
		"join_text": "La crianza feliz de perros comienza con EveryDoggy",
		"join_courses": "Únete a los cursos en línea",
		"checkout_introductory": "Descuento de oferta introductoria",
		"checkout_personalized_plan": "Tu plan personalizado",
		"Personal plan": "",
		"goal_lose_weight": "Programa efectivo de pérdida de peso con entrenamientos guiados, rastreador de nutrición y una variedad de actividades para ti",
		"goal_gain_muscles": "Programa efectivo de tonificación corporal completo con entrenamientos guiados, seguimiento de nutrición y una variedad de actividades para ti",
		"goal_gain_healthier_life": "Nueva rutina saludable con entrenamientos guiados para todo el cuerpo, un rastreador de nutrición y una variedad de actividades para ti",
		"goal_gain_flexibility": "Programa de yoga para la flexibilidad con sesiones guiadas y música calmante, rastreador de nutrición y una variedad de otras actividades",
		"goal_gain_build_endurance": "Programa de entrenamiento de resistencia con entrenamientos guiados, rastreador de nutrición y una variedad de actividades para ti",
		"goal_love_myself": "Una variedad de actividades para aumentar tu autoestima, meditaciones guiadas, sesiones de yoga y entrenamientos de cuerpo completo",
		"body_type_apple": "Ejercicios para cuerpo en forma de manzana para tonificar tu abdomen y adelgazar tu cintura.",
		"body_type_pear": "Ejercicios para cuerpo en forma de pera para tonificar tus caderas y muslos",
		"body_type_square": "Ejercicios para cuerpo en forma de cuadrado para definir tu cintura y trabajar tus glúteos",
		"body_type_hourglass": "Ejercicios para un cuerpo con forma de reloj de arena que te ayudarán a obtener resultados asombrosos",
		"body_type_triangle": "Ejercicios para el cuerpo en forma de triángulo invertido para fortalecer tus caderas y muslos",
		"body_type_unknown": "Ejercicios para resaltar lo mejor de tu figura",
		"excercises_time_morning": "Entrenamientos matutinos para aumentar tu metabolismo y energizarte para todo el día",
		"excercises_time_day": "Entrenamientos que se adaptan perfectamente a tu horario, estimulan tu metabolismo y te mantienen energizado durante el día.",
		"excercises_time_evening": "Entrenamientos nocturnos para ayudarte a aliviar el estrés después de un largo día y prepararte para un buen sueño.",
		"excercises_not_sure": "Entrenamientos que se adaptan perfectamente a tu horario, aceleran tu metabolismo y te mantienen energizado durante el día",
		"diet_type_all": "Recetas saludables y fáciles",
		"diet_type_vegetarian": "Recetas vegetarianas saludables",
		"diet_type_vegan": "Recetas veganas saludables",
		"diet_type_keto": "Recetas keto saludables",
		"personal_plan_providers_title": "",
		"special_features_title": "Características especiales para ti",
		"special_features_duration_minimum": "Sesiones rápidas de menos de 10 minutos",
		"special_features_duration_normal": "Sesiones convenientes de menos de 20 minutos",
		"special_features_duration_maximum": "Sesiones efectivas de más de 20 minutos",
		"special_features_duration_verv": "Sesiones convenientes de nuestros entrenadores",
		"special_features_goal_lose_weight": "Consejos secretos para perder peso de expertos",
		"special_features_goal_gain": "Consejos secretos de tonificación muscular de expertos",
		"special_features_goal_health": "Consejos secretos de salud de expertos",
		"special_features_goal_flexibility": "Consejos secretos de flexibilidad de expertos",
		"special_features_goal_endurance": "Consejos secretos para aumentar la resistencia",
		"special_features_goal_love": "Consejos secretos para aumentar la autoestima",
		"discount_activated": "Descuento del 50% activado",
		"discount_no_activated": "50% de descuento",
		"unlocked_with_promo": "Desbloqueado con el código promocional:",
		"use_with_button": "Usa tu código promocional especial:",
		"plan_optimal": "Óptimo",
		"plan_standard": "ESTÁNDAR",
		"plan_basic": "BÁSICO",
		"plan_extra": "EXTRA",
		"daypayback_review_name_1": "melliebeth",
		"daypayback_review_text_1": "",
		"daypayback_review_name_2": "katie_zu13",
		"daypayback_review_text_2": "¡Amo Verv! Seguir mi plan personal de entrenamiento y alimentación me ha ayudado a volver a estar en forma y a recuperar la confianza. Comencé con entrenamientos cortos de menos de 15 minutos, perfectos para un principiante como yo. Luego, aumenté mi resistencia y el tiempo de mi entrenamiento subió a 30-40 minutos por sesión. Lenta pero seguramente, perdí 25 libras en 6 meses con Verv.",
		"daypayback_review_name_3": "Jean_leon1",
		"daypayback_review_text_3": "Gané mucho peso durante la universidad. Después de graduarme, probé diferentes dietas que me ayudaron a perder peso, pero ese peso siempre regresaba unos meses después de que la dieta había terminado. El año pasado escuché sobre Verv por un colega y decidí probarlo. Con las recomendaciones personalizadas de Verv, logré perder peso y mantenerlo después.",
		"daypayback_review_name_4": "maryanne1993",
		"daypayback_review_text_4": "Después de una dura ruptura, decidí cambiar mi vida, perder peso y volverme más saludable. Pero no sabía por dónde empezar. No me sentía lo suficientemente segura para hacer ejercicio con otros, así que decidí probar aplicaciones de entrenamiento en casa y Verv apareció en mi búsqueda. Me ofreció un plan adaptado a mis necesidades. Lo seguí y logré tener el cuerpo de mis sueños.",
		"personal_plan_you_get": "Con tu plan personalizado obtienes",
		"goal": "Meta",
		"goal_other": "Lecciones para entrenar a tu amigo peludo",
		"goal_teaching_puppy": "Lecciones para enseñar a tu amigo peludo modales y obediencia",
		"goal_surviving_puppy": "Lecciones para ayudarte a prepararte para los primeros días con tu amigo peludo",
		"goal_socializing_puppy": "Lecciones para ayudar a socializar a tu amigo peludo",
		"goal_teaching_obedience": "Lecciones para enseñar a tu amigo peludo modales y obediencia",
		"age_puppy": "Consejos de entrenamiento detallados de nuestros expertos para ayudarte a criar un cachorro feliz y bien educado",
		"age_adult": "Consejos de entrenamiento detallados de nuestros expertos para ayudarte a entrenar a tu perro de la manera más efectiva",
		"biting_yes": "Instrucciones paso a paso para evitar que tu perro muerda",
		"biting_no": "Juegos entretenidos para jugar con tu perro",
		"biting_sometimes": "Instrucciones paso a paso para evitar que tu perro muerda",
		"quick_tips": "Consejos rápidos y fáciles para aprender nuevos comandos",
		"potty_training_a_bit": "Una guía especial para entrenar eficazmente a tu cachorro a hacer sus necesidades",
		"potty_training_yes": "Guías especiales para enseñar a tu cachorro nuevos trucos divertidos",
		"potty_training_no": "Una guía especial para entrenar eficazmente a tu cachorro a hacer sus necesidades",
		"success screen": "",
		"success_screen_text_1": "¡Gracias por tu compra!",
		"success_screen_text_2": "Sigue las instrucciones a continuación para configurar<br />tu cuenta:",
		"success_screen_text_3": "Ve a tu <b>cuenta</b>",
		"success_screen_text_4": "Escanea el <b>código QR</b> o toca <b>el enlace</b>",
		"success_screen_text_5": "<b>Descarga</b> la aplicación",
		"success_screen_text_6": "<b>Abre la app</b> y <b>disfruta</b><br /> del entrenamiento con tu perrito!",
		"success_screen_text_7": "Hemos duplicado el código QR y el enlace para usted en &nbsp;<b>example@gmail.com</b>",
		"success_screen_text_8": "Si la cuenta premium no se aplicó en la aplicación, presiona <b>‘Contáctanos’</b> en la pantalla de bienvenida y comunícate con nuestro equipo de soporte.",
		"success_screen_text_9": "Al presionar el botón ‘Comenzar’ confirmo que he revisado y acepto la <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Política de Privacidad</a> y los <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Términos y Condiciones</a> y por la presente consiento el procesamiento de mis datos personales.",
		"success_screen_text_10": "Contáctanos",
		"success_screen_text_11": "Ir a mi cuenta",
		"success_screen_text_12": "Te hemos enviado un código QR duplicado y un enlace por correo electrónico.",
		"success_screen_text_13": "Tu guía PDF ha sido enviada a tu correo electrónico <b>v.stsiopina@gmail.com</b>.",
		"success_screen_text_14": "Tu guía en PDF fue enviada a tu correo electrónico.",
		"success_screen_text_15": "Si la cuenta premium no se aplicó en la aplicación, presiona el enlace <span>'Iniciar sesión'</span> en la pantalla de bienvenida de la aplicación e ingresa tu correo electrónico y la contraseña que te enviamos a <b>stepinavalerie@gmail.com</b>",
		"success_screen_text_16": "Si la cuenta premium no se aplicó en la aplicación, presiona el enlace <span>'Iniciar sesión'</span> en la pantalla de bienvenida de la aplicación e ingresa tu correo electrónico y la contraseña que te enviamos por correo electrónico.",
		"payment_text_1": "¡Tu programa de entrenamiento para perros comienza ahora!",
		"payment_text_2": "La aplicación Everydoggy te ayudará a <span>resolver rápidamente y de forma divertida cualquier problema de comportamiento de tu perro</span>.",
		"payment_text_3": "La oferta personal expira",
		"payment_text_4": "de nuestros usuarios notan cambios positivos en el comportamiento de su perro solo 1 semana después de comenzar el entrenamiento con nuestros expertos",
		"payment_text_5": "CadaPerro vs Entrenadores",
		"payment_text_6": "Cantidad promedio de comandos por mes",
		"payment_text_7": "CadaPerro se beneficia",
		"payment_text_8": "Plan de entrenamiento personalizado para perros",
		"payment_text_9": "Solo 15 minutos al día para tener una mascota perfecta",
		"payment_text_10": "Más de 70 lecciones de video fáciles de entender para resultados rápidos",
		"payment_text_11": "Más de 80 juegos y trucos para nuevas habilidades y solo por diversión",
		"payment_text_12": "Consejos sobre higiene, salud y nutrición",
		"payment_text_13": "Entrena en casa y al aire libre, no se necesita equipo",
		"payment_text_14": "El 98% de nuestros usuarios notan cambios positivos en el comportamiento de su perro solo 1 semana después de comenzar el entrenamiento con nuestros expertos.",
		"payment_text_14_2": "<span>El 98 % de nuestros usuarios</span> notan cambios positivos en el comportamiento de su perro solamente 1 semana después de comenzar el entrenamiento con nuestros expertos",
		"payment_text_15": "Al hacer clic en el botón “Obtener mi plan”, aceptas nuestros <a href='https://everydoggy.com/terms/' target=\"_blank\" >Términos y Condiciones</a> y <a href='https://everydoggy.com/policy/' target=\"_blank\" >Política de Privacidad</a>, <b>autoriza la renovación automática</b> de tu suscripción al final de cada ciclo de facturación de <span>1 mes</span> al precio total de <i>$29.99</i> más impuestos aplicables. Puedes cancelar la renovación automática de tu suscripción en cualquier momento antes de la fecha de renovación. Consulta nuestros <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Términos de Cancelación</a> para más detalles.",
		"payment_text_16": "Al hacer clic en el botón “Obtener mi plan”, aceptas nuestros <a href='https://everydoggy.com/terms/' target='_blank'>Términos y Condiciones</a> y <a href='https://everydoggy.com/policy/' target='_blank'>Política de Privacidad</a>, <b>autorizas la renovación automática</b> de tu suscripción al final de cada ciclo de facturación de <span>1 mes</span> al precio completo de <i>$29.99</i> más impuestos aplicables. Puedes cancelar la renovación automática de tu suscripción en cualquier momento antes de la fecha de renovación. Consulta nuestros <a href='https://everydoggy.com/subscription-terms/' target='_blank'>Términos de Cancelación</a> para más detalles.",
		"payment_text_17": "¿Tienes una pregunta?",
		"payment_text_18": "Simplemente escríbenos a ",
		"payment_text_19": "¡Funciona!",
		"payment_text_20": "Acabo de terminar el programa de entrenamiento de obediencia con nuestro cachorro, ¡me encanta! 👏",
		"payment_text_21": "¡Fantástico!",
		"payment_text_22": "Puedo decir que estoy 💯 feliz con esta aplicación. ¡No más problemas para ir al baño, guau!",
		"payment_text_23": "Gran aplicación 🎉",
		"payment_text_24": "Estamos en nuestro tercer mes de entrenamiento con mi perro y sus habilidades han mejorado enormemente.",
		"payment_text_25": "Vale la pena intentarlo",
		"payment_text_26": "La mejor aplicación para entrenar a un perro. ",
		"payment_text_27": "Inspírate con nuestros usuarios",
		"payment_text_28": " Star Focus, Inc.",
		"payment_text_29": "Si aún tienes dudas escríbenos a <a href=\"mailto:welove@everydoggy.com\">welove@everydoggy.com</a>",
		"payment_text_30": "Resultados visibles en solo 7 días de entrenamiento",
		"payment_text_31": "Consigue tu plan personal con descuento especial",
		"payment_text_32": "Cuanto antes empieces a entrenar, mejores resultados obtendrás",
		"payment_text_33": "El entrenamiento es esencial para cada perro. No se trata solo de eliminar problemas de comportamiento, sino también de socializar, construir un vínculo con tu perro y expresar tu amor.",
		"payment_text_34": "Creado por y para el <span>amor</span> a los perros. Basado en experiencia de clase mundial",
		"payment_text_35": "Todo lo que encontrarás en la aplicación se basa en las últimas investigaciones y está absolutamente centrado en los perros.",
		"payment_text_36": "Si tu perro pudiese hablar, ¡te pediría que probaras EveryDoggy!",
		"payment_text_37": "Tu información está segura",
		"payment_text_38": "No venderemos ni alquilaremos tu información de contacto personal para ningún propósito de marketing.",
		"payment_text_39": "Pago seguro",
		"payment_text_40": "Toda la información está encriptada y se transmite sin riesgos.",
		"payment_text_41": "Necesitar ayuda",
		"payment_text_42": "Envíenos un correo electrónico: <a href=\"mailto:welove@everydoggy.com\">welove@everydoggy.com</a>",
		"payment_text_43": "mensual",
		"payment_text_44": "continuar",
		"payment_text_45": "Tu plan personalizado:",
		"payment_text_46": "Oferta de lanzamiento con descuento:",
		"payment_text_47": "Al continuar, aceptas los <a href='https://everydoggy.com/terms/' target='_blank' rel=\"noreferrer\">Términos y condiciones</a>, la <a href='https://everydoggy.com/policy/' target='_blank' rel=\"noreferrer\">Política de privacidad</a> y los <a href='https://everydoggy.com/subscription-terms/#subscription_cancellation' target='_blank' rel=\"noreferrer\">Términos de cancelación</a>.",
		"payment_text_48": "Tu suscripción dura hasta",
		"payment_text_49": "Puedes cancelar en cualquier momento sin cargo al menos 24 horas antes del vencimiento del período de suscripción.",
		"payment_text_50": "Si no cancelas, tu membresía se renovará automáticamente al final de tu suscripción. Se te cobrará la tarifa de membresía de EveryDoggy de <b>$</b><i>$29.99</i> hasta que canceles.",
		"payment_text_51": "Actualmente no ofrecemos reembolsos ni créditos por membresías parciales.",
		"payment_text_52": "Adies-trador<br> personal",
		"payment_text_53": "Escuela<br> canina",
		"payment_text_54": "Lecciones<br> en YouTube",
		"payment_text_55": "Libros",
		"payment_text_56": "semanalmente",
		"payment_text_57": "Resultados mucho mejores",
		"payment_text_58": "Con EveryDoggy",
		"payment_text_59": "Sin EveryDoggy",
		"payment_text_60": "Ahora",
		"payment_text_61": "1 semana después",
		"payment_text_62": "Esta es tu última oportunidad",
		"payment_text_63": "No te pierdas el descuento exclusivo del 65&nbsp;% y descubre lo rápido que tu perro aprenderá y obedecerá órdenes.",
		"payment_text_64": "Obtén un 65&nbsp;% de descuento",
		"payment_text_65": "PLAN DE 52 SEMANAS",
		"payment_text_66": "PLAN DE 4 SEMANAS",
		"payment_text_67": "PLAN DE 12 SEMANAS",
		"payment_text_68": "semanas",
		"payment_text_69": "Enero",
		"payment_text_70": "Febrero",
		"payment_text_71": "Marzo",
		"payment_text_72": "Abril",
		"payment_text_73": "Puede",
		"payment_text_74": "Junio",
		"payment_text_75": "Julio",
		"payment_text_76": "Agosto",
		"payment_text_77": "Septiembre",
		"payment_text_78": "Octubre",
		"payment_text_79": "Noviembre",
		"payment_text_80": "Diciembre",
		"payment_text_81": "Por favor, introduce una dirección de correo electrónico válida",
		"payment_text_82": "Hoy solo se te cobrará <b>$6.99</b> por tu primera semana (información más adelante)",
		"payment_text_83": "Tu período introductorio durará hasta el <b>Oct 11, 2024</b>.",
		"payment_text_84": "Puedes cancelar en cualquier momento antes del <b>Oct 10, 2024</b> y no se te cobrará nada.",
		"payment_text_85": "Si no cancelas, Everydoggy continuará automáticamente con tu afiliación después del período introductorio y te cobrará la cuota de afiliación (actualmente <b>$39.99 USD</b>) <span>mensual</span> hasta que la canceles.",
		"payment_text_86": "No hay reembolsos parciales. Puedes cancelar la suscripción en cualquier momento en tu Cuenta.",
		"payment_text_87": "Tu suscripción estará sujeta a nuestros <a href='https://everydoggy.com/terms/' target=\"_blank\" >Términos y condiciones</a>, <a href='https://everydoggy.com/policy/' target=\"_blank\" >Política de privacidad</a> y <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Términos de cancelación</a>.",
		"payment_text_88": "Formas de pago",
		"payment_text_89": "EveryDoggy utilizará tus datos de pago para futuros pagos",
		"payment_text_90": "Pagos fáciles y privados con Face ID o Touch ID",
		"payment_text_91": "Protege tu información financiera con cifrado de extremo a extremo",
		"payment_text_92": "Protegido por el Número de cuenta de dispositivo único de Apple Pay",
		"payment_text_93": "Tu información de pago está segura con el cifrado SSL o TLS",
		"payment_text_94": "Opción de pago rápida y cómoda",
		"payment_text_95": "Respaldado por la protección líder del sector contra el fraude de PayPal",
		"payment_text_96": "Confirmar compra",
		"payment_text_97": "1-SEMANA",
		"payment_text_98": "1-MES",
		"payment_text_99": "3-MESES",
		"payment_text_100": "Hoy solo se le cobrará <b>$6.99</b> por su primer mes (detalles a continuación).",
		"payment_text_101": "Hoy solo se le cobrará<b>$6.99</b> por sus primeros 3 meses (detalles a continuación).",
		"payment_text_102": "Suscribirse con",
		"payment_text_103": "Al hacer clic en el botón \"Obtener mi plan\", aceptas la <a href='https://everydoggy.com/policy/' target=\"_blank\" >Política de Privacidad</a>, los <a href='https://everydoggy.com/terms/' target=\"_blank\" >Términos y Condiciones</a> y la <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Política de Cancelación</a>.",
		"payment_text_104": "Pagos fáciles y privados",
		"payment_text_105": "Tarjeta de crédito",
		"payment_text_106": "Fecha de vencimiento",
		"payment_text_107": "CVC",
		"payment_text_108": "gran comienzo",
		"payment_text_109": "Plan de 1 semana",
		"payment_text_110": "La aplicación Everydoggy te ayudará a <span>enseñar a tu perro a hacer sus necesidades fuera de casa y a corregir cualquier otro problema de comportamiento</span> de forma rápida y divertida.",
		"payment_text_111": "Pago seguro",
		"payment_text_112": "Plan de adiestramiento personalizado para <span>tu perrito</span>",
		"payment_text_113": "Silbato y «clicker» para el adiestramiento",
		"payment_text_114": "Más de 80 juegos y trucos para tu mascota",
		"payment_text_115": "Más de 30 consejos y artículos sobre la salud",
		"payment_text_116": "🔥 Acabas de ahorrar <span>$113,50&nbsp;</span>🔥",
		"payment_text_117": "Plan de 7 días",
		"payment_text_118": "Al hacer clic en el botón «Conseguir mi plan», aceptas nuestros <a href='https://everydoggy.com/terms/' target=\"_blank\" >Términos y condiciones</a> y nuestra <a href='https://everydoggy.com/policy/' target=\"_blank\" >Política de privacidad</a>, y <b>autorizas la renovación automática</b> de tu suscripción. Hoy solo se te cobrarán <span class=\"trialPrice\">4,99 $</span> por los primeros <span class=\"trialPeriod\">7 días</span> del periodo introductorio. Si no cancelas la suscripción, Everydoggy la continuará automáticamente al final del periodo introductorio y cobrará la tarifa de suscripción de <span class='price'>39,99 $</span> cada <span class='period'>mes</span> hasta que la canceles. Puedes cancelar la renovación automática de la suscripción en cualquier momento antes de la fecha de renovación. Consulta nuestros Términos de cancelación para más información.",
		"payment_text_119": "7 días",
		"payment_text_120": "Hoy solo se te cobrarán <b>29,99 $</b> por las primeras <span>12 semanas</span> (más información a continuación)",
		"payment_text_121": "La aplicación Everydoggy <span>ayudará</span> a tu perro a <span>hacer sus necesidades</span> en el lugar correcto y a <span>solucionar problemas de comportamiento</span> de forma rápida y divertida.",
		"payment_text_122": "Un perro adiestrado para ir al baño en 3 días",
		"payment_text_123": "Tu cuenta está vinculada a este correo electrónico y no se puede cambiar",
		"payment_text_124": "Al continuar, usted acepta nuestros <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">términos y condiciones</a>, nuestra <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">política de privacidad</a> y <span>autoriza la renovación automática de su suscripción</span>.",
		"payment_text_125": "PLAN DE 26 SEMANAS",
		"payment_text_126": "Si no cancelas, Everydoggy continuará automáticamente con tu afiliación después del período introductorio y te cobrará la cuota de afiliación (actualmente <b>$39.99 USD</b>) <span>cada 3 meses</span> hasta que la canceles.",
		"payment_text_127": "Si no cancelas, Everydoggy continuará automáticamente con tu afiliación después del período introductorio y te cobrará la cuota de afiliación (actualmente <b>$39.99 USD</b>) <span>cada 6 meses</span> hasta que la canceles.",
		"payment_text_128": "Nivel actual",
		"payment_text_129": "órdenes",
		"payment_text_130": "Meta",
		"payment_text_131": "Más de 50 órdenes y obediencia",
		"payment_text_132": "Siente un progreso apreciable",
		"payment_text_133": "Logra la obediencia",
		"payment_text_134": "Mantén a tu perro bien entrenado de por vida",
		"payment_text_135": "Ahorra un 53%",
		"payment_text_136": "Garantía de devolución de dinero",
		"payment_text_137": "Garantía de devolución de dinero de 30 días",
		"payment_text_138": "¡Creemos que nuestro plan logrará funcionar para ti y obtendrás resultados visibles en 4 semanas! Incluso estamos dispuestos a devolverte el dinero si no obtienes resultados visibles y logras demostrar que seguiste nuestro plan.",
		"payment_text_139": "Obtén más información sobre las limitaciones aplicables en nuestros <a href=\"https://everydoggy.com/terms/#section5_2\" target=\"_blank\" rel=\"noreferrer\">términos de uso</a>.",
		"payment_text_140": "Ahorra un 65%",
		"payment_text_141": "¡Tu plan de entrenamiento canino está listo!",
		"payment_text_142": "Obediencia",
		"payment_text_143": "Conoce comandos",
		"payment_text_144": "Accidentes en el baño",
		"payment_text_145": "Frecuente",
		"payment_text_146": "Ninguno",
		"payment_text_147": "Ladrido",
		"payment_text_148": "Ladra a todo",
		"payment_text_149": "Tranquilo y relajado",
		"payment_text_150": "Morder y masticar",
		"payment_text_151": "A menudo",
		"payment_text_152": "Interrumpido",
		"payment_text_153": "Tirando de la correa",
		"payment_text_154": "Siempre",
		"payment_text_155": "Camina con calma",
		"payment_text_156": "Ansiedad al quedarse solo",
		"payment_text_157": "Tranquilo e independiente",
		"payment_text_158": "Antes",
		"payment_text_159": "Después",
		"payment_text_160": "minutos",
		"payment_text_161": "segundos",
		"payment_text_162": "Probado. Demostrado. Funciona",
		"payment_text_163": "Cambios significativos en la obediencia del perro",
		"payment_text_164": "Hoy",
		"payment_text_165": "Semana 2",
		"payment_text_166": "Semana 3",
		"payment_text_167": "Semana 4",
		"payment_text_168": "Por qué Everydoggy es tan eficaz",
		"payment_text_169": "Historias de éxito de nuestros usuarios",
		"payment_text_170": "Creado por expertos que <span>aman a los perros</span>",
		"payment_text_171": "Todos nuestros cursos y lecciones se basan en estudios científicos sobre el adiestramiento canino.",
		"payment_text_172": "Cree un vínculo fuerte con su perro: ¡pruebe EveryDoggy!",
		"payment_text_173": "Probado. Probado. Funciona",
		"payment_text_174": "El <span>93 % de nuestros usuarios</span> notan cambios significativos en el comportamiento de su perro durante el primer mes de entrenamiento.",
		"payment_text_175": "Con EveryDoggy",
		"payment_text_176": "Sin EveryDoggy",
		"payment_text_177": "Hoy",
		"payment_text_178": "Semana 2",
		"payment_text_179": "Semana 4",
		"payment_text_180": "Semana 6",
		"payment_text_181": "Acerca de Luna",
		"payment_text_182": "Mi cachorro seguía teniendo accidentes en la casa. Everydoggy nos dio una rutina clara ¡y realmente funcionó!",
		"payment_text_183": "Acerca de Cooper",
		"payment_text_184": "Nuestro cachorro solía morder a todo el mundo durante el tiempo de juego. La aplicación nos brindó una guía paso a paso y ¡funcionó!",
		"payment_text_185": "Acerca de Bella",
		"payment_text_186": "Nuestro perro mordía todo: desde los zapatos hasta el sofá. La aplicación nos ayudó a redirigir esa energía.",
		"payment_text_187": "Acerca de Charlie",
		"payment_text_188": "Tirar de la correa era una lucha diaria. Gracias a la aplicación, los paseos ahora son placenteros y sin estrés.",
		"payment_text_189": "Entrenado para ir al baño",
		"payment_text_190": "Resuelto el problema de la mordedura",
		"payment_text_191": "La masticación se ha solucionado",
		"payment_text_192": "Solucionado el problema de tirar de la correa",
		"payment_text_193": "El <span>93 % de nuestros usuarios</span> notan cambios significativos en el <span>comportamiento y la obediencia de su perro</span> durante el primer mes de adiestramiento.</span>",
		"payment_text_194": "¡Nuestros usuarios están sorprendidos con los resultados!",
		"payment_text_195": "¡Empieza a adiestrar a tu perro ahora!",
		"payment_text_196": "Si no cancelas, Everydoggy continuará automáticamente tu suscripción al final del periodo de introducción y te cobrará la cuota de suscripción (actualmente <b>39,99 USD</b>) <span>cada dos semanas</span> hasta que canceles.",
		"payment_text_197": "Garantía de devolución de dinero",
		"payment_text_198": "Garantía de devolución de dinero de 30 días",
		"payment_text_199": "¡Creemos que nuestro plan logrará funcionar para ti y obtendrás resultados visibles en 4 semanas! Incluso estamos dispuestos a devolverte el dinero si no obtienes resultados visibles y logras demostrar que seguiste nuestro plan.",
		"payment_text_200": "Obtén más información sobre las limitaciones aplicables en nuestros <a href=\"https://everydoggy.com/terms/#section5_2\" target=\"_blank\" rel=\"noreferrer\">términos de uso</a>.",
		"payment_text_201": "La gente suele preguntar",
		"payment_text_202": "¿En cuánto tiempo veré los resultados del adiestramiento?",
		"payment_text_203": "La mayoría de los perros muestran progreso después de la primera sesión, ¡y en un par de semanas verás resultados impresionantes y significativos!",
		"payment_text_204": "¿La aplicación Everydoggy es tan eficaz como trabajar con un adiestrador?",
		"payment_text_205": "Sí, y aún más eficaz: puedes practicar todos los días a tu propio ritmo, recibir lecciones claras paso a paso y reforzar tus habilidades de manera constante, no solo una vez a la semana como con un adiestrador.",
		"payment_text_206": "¿Los resultados del adiestramiento son permanentes?",
		"payment_text_207": "¡Sí! Mientras sigas reforzando los buenos hábitos, los resultados durarán toda la vida.",
		"payment_text_208": "Obtén un 72&nbsp;% de descuento",
		"payment_text_209": "No te pierdas el descuento exclusivo del 72&nbsp;% y descubre lo rápido que tu perro aprenderá y obedecerá órdenes.",
		"payment_text_210": "Continuar con otro método de pago",
		"payment_text_211": "Buy with",
		"payment_text_212": "¡OFERTA DEL VIERNES NEGRO!",
		"payment_text_213": "",
		"payment_text_214": "",
		"payment_text_215": "",
		"payment_text_216": "",
		"payment_text_217": "",
		"payment_text_218": "¡El programa de entrenamiento de su cachorro empieza ahora!",
		"payment_text_219": "Entrene con la app Everydoggy desde <span>los primeros días de su cachorro</span> y consiga <span>un perro perfectamente educado</span>!",
		"payment_text_220": "de nuestros usuarios notan cambios positivos en el comportamiento de su cachorro tan solo 1 semana después de empezar a entrenar con nuestros expertos",
		"payment_text_221": "Plan de entrenamiento personalizado para cachorros menores de 6 meses",
		"payment_text_222": "Plan de entrenamiento personalizado para cachorros de 6 a 12 meses",
		"payment_text_223": "Probado con 3 millones de cachorros",
		"payment_text_224": "Cambios significativos en la obediencia del perro",
		"payment_text_225": "Obtén un 70&nbsp;% de descuento",
		"payment_text_226": "¡ÚLTIMA OPORTUNIDAD!\r",
		"payment_text_227": "PLAN DE 24 SEMANAS",
		"payment_text_228": "¡El último programa de adiestramiento que necesitará empieza ahora!",
		"payment_text_229": "Plan de adiestramiento personalizado para resultados duraderos",
		"payment_text_230": "Un programa.<br />\nBuen comportamiento para toda la vida",
		"payment_text_231": "Edad del perro",
		"payment_text_232": "Tiempo de adiestramiento",
		"payment_text_233": "Resultados duraderos",
		"payment_text_234": "0-1 año",
		"payment_text_235": "1-3 años",
		"payment_text_236": "3-5 años",
		"payment_text_237": "5+ años",
		"payment_text_238": "1-2 años",
		"payment_text_239": "3 años",
		"payment_text_240": "4 años",
		"payment_text_241": "2-7 años",
		"payment_text_242": "8 años",
		"payment_text_243": "9 años",
		"payment_text_244": "10+ años",
		"payment_text_245": "",
		"payment_text_246": "",
		"payment_text_247": "",
		"payment_text_248": "",
		"payment_text_249": "",
		"payment_text_250": "",
		"payment_text_251": "",
		"payment_text_252": "",
		"payment_text_253": "",
		"payment_text_254": "",
		"payment_text_255": "",
		"payment_text_256": "",
		"payment_text_257": "",
		"payment_text_258": "",
		"payment_text_259": "",
		"payment_text_260": "",
		"payment_text_261": "",
		"payment_text_262": "",
		"payment_text_263": "Traductor canino",
		"payment_text_264": "Entienda a su perro.<br/> Vea los resultados",
		"payment_text_265": "La obediencia mejora con el análisis de las señales y el comportamiento",
		"payment_text_266": "Plan de entrenamiento personalizado para su perro basado en el análisis de sus ladridos y su comportamiento",
		"payment_text_267": "¡El doble de rápido, <br />el doble de divertido!",
		"payment_text_268": "Consiga la guía definitiva de adiestramiento para cachorros",
		"payment_text_269": "Consiga la guía definitiva de adiestramiento canino",
		"payment_text_270": "¡Dígale adiós a los problemas con sus necesidades! Métodos paso a paso para enseñar rápido a su perro a hacerlas donde corresponde.",
		"payment_text_271": "¡Proteja sus zapatos y sus dedos! Con técnicas sencillas, su cachorro dejará de morder y masticar todo.",
		"payment_text_272": "Cree un espacio seguro y agradable para su perro y enséñele a estar tranquilo y seguro en la jaula.",
		"payment_text_273": "Acceda a un conjunto completo de recursos de expertos sobre conducta, obediencia y vida diaria con su perro.",
		"payment_text_274": "Corrija las conductas no deseadas en casa y durante los paseos con métodos eficaces y fáciles de seguir.",
		"payment_text_275": "¡Haga que aprender sea divertido! Domine el uso de los elogios y las recompensas para motivar a su perro al instante.",
		"payment_text_276": "¡Enseñe a su perro mucho más que lo básico! Aprenderá de todo: desde órdenes esenciales de seguridad hasta trucos divertidos e impresionantes para perros de todas las edades.",
		"payment_text_277": "¡Acelere el<br /> progreso de su perro <span>2x!</span>",
		"payment_text_278": "Guía práctica:",
		"payment_text_279": "DESCUENTO del 98% solo para miembros",
		"payment_text_280": "DESCUENTO del 70% solo para miembros",
		"payment_text_281": "¡Tu programa de cuidado veterinario para tu perro empieza ahora!",
		"payment_text_282": "Cuida la salud de tu perro con <span>soporte veterinario profesional</span> de Everydoggy y <span>cría un perro sano y bien educado</span> con menos preocupaciones",
		"payment_text_283": "Chat veterinario al instante — sin citas ni esperas",
		"payment_text_284": "Comparte fotos para recibir orientación más precisa",
		"payment_text_285": "Aprende primeros auxilios para emergencias como golpe de calor, lesiones o congelación",
		"payment_text_286": "Sigue al día con calendarios actualizados de vacunas y revisiones",
		"payment_text_287": "Recibe consejos para el cuidado de dientes, oídos, ojos, uñas, desparasitación y más",
		"payment_text_288": "Siéntete seguro de la salud de tu perro y preocúpate menos cada día",
		"payment_text_289": "Qué hace que Everydoggy VET sea tan eficaz",
		"payment_text_290": "Más de 3M dueños de perros confían en nosotros",
		"payment_text_291": "Chatea en cualquier momento con soporte veterinario en el que puedes confiar",
		"payment_text_292": "¡Entrene a su perro con la app Everydoggy y disfrute de un <span>compañero perfectamente educado</span>!",
		"payment_text_293": "Probado con 3 millones de perros",
		"payment_text_294": "Plan de entrenamiento personalizado, adaptado a su perro",
		"payment_text_295": "Cuando mi cachorro tuvo diarrea, recibí enseguida el consejo de un veterinario y supe exactamente cómo actuar. Me ahorró muchísimo estrés.",
		"payment_text_296": "Los consejos son claros y fiables. Siento que siempre tengo a un profesional en quien confiar.",
		"payment_text_297": "Lo usé cuando mi perro tuvo irritación en la piel y se rascaba sin parar. La orientación fue clara y me sentí tranquila de inmediato.",
		"payment_text_298": "Como dueño primerizo de un cachorro, esto me ha sido increíblemente útil. Ya no tengo que adivinar.",
		"payment_text_299": "de nuestros usuarios se sienten más seguros sobre la salud de su perro y se preocupan menos con nuestro soporte veterinario",
		"payment_text_300": "<span>El 98% de nuestros usuarios</span> se sienten más seguros sobre la salud de su perro y se preocupan menos con nuestro soporte veterinario",
		"payment_text_301": "¡Tu programa personalizado de juego y comunicación <span>empieza ahora</span>!",
		"payment_text_302": "Con Everydoggy, podrás <span>entender mejor a tu perro</span>, <span>disfrutar más del tiempo juntos</span> y <span>crear un vínculo duradero</span>!",
		"payment_text_303": "3M+ usuarios",
		"payment_text_304": "Disfrutan de la vida con sus perros al máximo",
		"payment_text_305": "Ahora",
		"payment_text_306": "Entender a tu perro",
		"payment_text_307": "Comunicación con tu perro",
		"payment_text_308": "Disfrute del juego",
		"payment_text_309": "Vínculo",
		"payment_text_310": "Programa personalizado de comunicación y juego con tu perro",
		"payment_text_311": "Traduce y entiende los ladridos de tu perro con Ladrido IA",
		"payment_text_312": "🎁 Tu descuento de bienvenida se ha aplicado:",
		"payment_text_313": "<span>53%</span> DE DESCUENTO",
		"payment_text_314": "Tu programa personalizado de adiestramiento canino empieza ahora!",
		"payment_text_315": "Consigue resultados rápidos y disfruta de la vida con un perro bien educado.",
		"payment_text_316": "Comandos aprendidos:",
		"payment_text_317": "Nivel de obediencia:",
		"payment_text_318": "Bajo",
		"payment_text_319": "Alto",
		"payment_text_320": "El programa personalizado de adiestramiento para <span>tu perro</span> está listo!",
		"payment_text_321": "Perfil de entrenamiento",
		"payment_text_322": "Raza del perro",
		"payment_text_323": "Edad",
		"payment_text_324": "Problemas de conducta",
		"payment_text_325": "Nivel actual",
		"payment_text_326": "Más de 3 millones",
		"payment_text_327": "de dueños de perros ya disfrutan de los resultados",
		"payment_text_328": "Ashley K. y Moly",
		"payment_text_329": "Me encanta lo sencillas que son las tareas diarias de entrenamiento. ¡Ahora mi perro sí me escucha!",
		"payment_text_330": "Kevin R. y Tommy",
		"payment_text_331": "Enseñarle a hacer sus necesidades era nuestro mayor reto. Este programa fue lo único que de verdad funcionó.",
		"payment_text_332": "Chloe N. y Ami",
		"payment_text_333": "Mi cachorro antes mordía todo. ¡Ahora solo va a por sus juguetes!",
		"payment_text_334": "Daniel H. y Cherry",
		"payment_text_335": "Me gustó que todo esté dividido en pasos pequeños. Mi perro aprendió órdenes más rápido de lo que esperaba.",
		"payment_text_336": "¡Su plan de entrenamiento sin estrés para su cachorro comienza ahora!",
		"payment_text_337": "¡Su plan de entrenamiento sin estrés para su perro comienza ahora!",
		"payment_text_338": "¡Tu plan personalizado de nutrición y salud para tu perro empieza ahora!",
		"payment_text_339": "Escanea etiquetas de alimentos para perros, recibe consejos de nutrición de expertos y mantén a tu perro <span>sano y feliz</span>!",
		"payment_text_340": "Escanea etiquetas de alimentos. Protege la salud de tu perro",
		"payment_text_341": "Escanea etiquetas de alimentos para perros y entiende rápidamente los ingredientes y la calidad",
		"payment_text_342": "Recibe consejos de alimentación adaptados a las necesidades de tu perro",
		"payment_text_343": "El escáner de etiquetas de alimentos lo cambia todo. Sé al instante qué contiene realmente la comida de mi perro.",
		"payment_text_344": "Una herramienta excelente para hacer seguimiento de la salud de mi perro y mejorar su dieta. ¡Resultados visibles!",
		"payment_text_345": "Esta app hizo que gestionar la nutrición de mi perro fuera mucho más fácil. ¡Me encantan los consejos personalizados!",
		"payment_text_346": "Es como si hubiera aprendido el idioma de mi perrita: ahora hasta los ladridos tienen sentido.",
		"payment_text_347": "Los juegos son increíbles. ¡Mi perro se emociona cada vez!",
		"payment_text_348": "Jugamos, conectamos y por fin entiendo lo que mi perrita quiere decirme.",
		"payment_text_349": "de nuestros usuarios se sienten más seguros sobre la salud de su perro y se preocupan menos gracias a nuestra app",
		"payment_text_350": "Qué hace que EveryDoggy sea tan eficaz",
		"payment_text_351": "<span>El 98% de nuestros usuarios</span> se sienten más seguros sobre la salud de su perro y se preocupan menos con nuestro plan",
		"payment_text_352": "Principiante",
		"payment_text_353": "¡Tu programa personalizado de entrenamiento para perros pequeños empieza ahora!",
		"payment_text_354": "¡Tu programa personalizado de entrenamiento K9 para perros empieza ahora!",
		"payment_text_355": "Consigue resultados rápidos: tu perro obedecerá a la primera orden.",
		"payment_text_356": "Un cambio enorme en solo unas semanas. Mi perro por fin obedece a la primera.",
		"payment_text_357": "Pasear a mi perro ya no es estresante. Ahora tengo todo bajo control.",
		"payment_text_358": "Pasamos del caos a un comportamiento tranquilo muy rápido. Un programa increíble.",
		"payment_text_359": "La obediencia a la primera orden funciona de verdad. No pensé que fuera posible.",
		"payment_text_360": "Plan personalizado de entrenamiento K9 para perros",
		"payment_text_361": "",
		"payment_text_362": "",
		"payment_text_363": "",
		"payment_text_364": "",
		"payment_text_365": "",
		"payment_text_366": "",
		"payment_text_367": "",
		"payment_text_368": "",
		"payment_text_369": "",
		"payment_text_370": "",
		"payment_text_371": "",
		"payment_text_372": "",
		"payment_text_373": "",
		"payment_text_374": "",
		"payment_text_375": "",
		"payment_text_376": "",
		"payment_text_377": "",
		"payment_text_378": "",
		"payment_text_379": "",
		"payment_text_380": "",
		"payment_text_381": "",
		"payment_text_382": "",
		"payment_text_383": "",
		"payment_text_384": "<span>Empieza el camino hacia un perro obediente:</span> hazte con la guía K9 definitiva sobre reactividad",
		"payment_text_385": "Desbloquea el <span>Manual práctico K9 sobre reactividad</span>",
		"payment_text_386": "Consigue que tu perro te haga caso ante los estímulos",
		"payment_text_387": "Frena las reacciones antes de que vayan a más",
		"payment_text_388": "Recupera el control cuando tu perro se descontrola",
		"payment_text_389": "Enseña a tu perro a no sobrerreaccionar ante personas, otros perros y coches",
		"pdfUpselling": "",
		"pdfUpselling_1": "<span>Comience el camino hacia la crianza de un perro obediente:</span> obtenga una guía definitiva sobre el adiestramiento para la crianza de perros",
		"pdfUpselling_2": "<span>Comience el camino hacia la crianza de un perro obediente:</span> obtenga una guía definitiva sobre la crianza y el entrenamiento de cachorros",
		"pdfUpselling_3": "Consiga su <span>plan personal</span>",
		"pdfUpselling_4": "Desbloquee la <span>guía práctica</span>",
		"pdfUpselling_5": "Corrección de conducta (en interiores y exteriores)",
		"pdfUpselling_6": "Cómo elogiar y recompensar a su perro",
		"pdfUpselling_7": "Varios comandos",
		"pdfUpselling_8": "Juegos de enriquecimiento y mucho más",
		"pdfUpselling_9": "Entrenamiento para ir al baño",
		"pdfUpselling_10": "Deja de morder y masticar",
		"pdfUpselling_11": "Entrenamiento en jaulas",
		"pdfUpselling_12": "Más 43 consejos y soluciones útiles",
		"pdfUpselling_13": "Total hoy",
		"pdfUpselling_14": "Guía de desbloqueo",
		"pdfUpselling_15": "Desbloquear con",
		"pdfUpselling_16": "Continuar sin guía",
		"chatUpsale_1": "Chat con adiestradores de perros",
		"chatUpsale_2": "Describe el comportamiento del perro. Nosotros tenemos la solución",
		"chatUpsale_3": "Chatea con nuestros verdaderos expertos humanos en adiestramiento canino sin limitaciones",
		"chatUpsale_4": "¡Obtén más de lo que esperas de Everydoggy!",
		"chatUpsale_5": "Impulso ×2",
		"chatUpsale_6": "Plan EveryDoggy",
		"chatUpsale_7": "Chat con adiestradores de perros",
		"chatUpsale_8": "Adiestramiento por tu cuenta",
		"chatUpsale_9": "ACCESO ILIMITADO",
		"chatUpsale_10": "¡Mejora tus resultados con el chat con adiestradores de perros!",
		"chatUpsale_11": "acceso al chat",
		"chatUpsale_12": "30 días",
		"chatUpsale_13": "90 días",
		"chatUpsale_14": "Continuar sin chat con adiestrador de perros",
		"chatUpsale_15": "Acceso ilimitado al chat del entrenador canino",
		"checkoutV2_text1": "total",
		"checkoutV2_text2": "Pagos fáciles y privados con Face ID y Touch ID",
		"checkoutV2_text3": "Protege tu información financiera con cifrado de extremo a extremo",
		"checkoutV2_text4": "Protegido por el número de cuenta de dispositivo único de Apple Pay",
		"checkoutV2_text5": "Opción de pago rápida y cómoda",
		"checkoutV2_text6": "Protege tu información financiera con cifrado de extremo a extremo",
		"checkoutV2_text7": "Respaldado por la protección contra fraudes líder del sector de PayPal",
		"checkoutV2_text8": "Garantía de devolución de dinero",
		"checkoutV2_text9": "Caja",
		"checkoutV2_text10": "Información de pago",
		"checkoutV2_text11": "Protegido",
		"error_1": "Pago rechazado. Verifique los detalles de la tarjeta y vuelva a intentarlo.",
		"error_2": "Pago rechazado. Verifique los detalles de la tarjeta y vuelva a intentarlo.",
		"error_3": "Fondos insuficientes. Pruebe con otra tarjeta o método de pago.",
		"error_4": "Su tarjeta ha caducado. Pruebe con otra tarjeta o método de pago.",
		"error_5": "Se ha producido un error al procesar su tarjeta. Inténtelo de nuevo.",
		"error_6": "El código de seguridad es incorrecto. Verifique los detalles de la tarjeta y vuelva a intentarlo.",
		"error_7": "Las tarjetas American Express no están admitidas en este momento. Pruebe con otra tarjeta o método de pago.",
		"error_8": "Pago rechazado. Verifique los detalles de la tarjeta y vuelva a intentarlo.",
		"error_9": "Pago rechazado. Este correo electrónico ya está asociado a una suscripción activa.",
		"error_10": "Pago rechazado. Demasiados intentos o límite de la tarjeta excedido.\nInténtalo de nuevo más tarde.",
		"disclaimerV2_text_1": "Al continuar, usted acepta nuestros <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Términos y Condiciones</a> y nuestra <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Política de Privacidad</a> y autoriza la renovación automática de su suscripción. Hoy solo se le cobrará <span class=\"price1\">$1.99</span> por su primera semana. Si no cancela, Everydoggy renovará automáticamente su suscripción al final de su período de prueba y cobrará la cuota de suscripción (actualmente <span class=\"price2\">$29.99</span>) cada 2 semanas hasta que usted la cancele.\r\n",
		"disclaimerV2_text_2": "Al continuar, usted acepta nuestros <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Términos y Condiciones</a> y nuestra <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Política de Privacidad</a> y autoriza la renovación automática de su suscripción.\r\nHoy solo se le cobrará <span class=\"price1\">$6.99</span> por sus primeras 4 semanas. \r\nSi no cancela, Everydoggy renovará automáticamente su suscripción al final de su período de prueba y \r\ncobrará la cuota de suscripción (actualmente <span class=\"price2\">$29.99</span>) cada 2 semanas hasta que usted la cancele.\r\n",
		"disclaimerV2_text_3": "Al continuar, usted acepta nuestros <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Términos y Condiciones</a> y nuestra <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Política de Privacidad</a> y autoriza la renovación automática de su suscripción.\r\nHoy solo se le cobrará <span class=\"price1\">$14.99</span> por sus primeras 12 semanas. \r\nSi no cancela, Everydoggy renovará automáticamente su suscripción al final de su período de prueba y \r\ncobrará la cuota de suscripción (actualmente <span class=\"price2\">$49.99</span>) cada 4 semanas hasta que usted la cancele.\r\n",
		"chatUpsaleV2_1": "Chat con adiestrador canino",
		"chatUpsaleV2_2": "Entrene con un experto en comportamiento canino",
		"chatUpsaleV2_3": "Añada a su plan soporte ilimitado por chat de adiestradores caninos con experiencia",
		"chatUpsaleV2_4": "Con adiestrador",
		"chatUpsaleV2_5": "Eficiencia",
		"chatUpsaleV2_6": "Respuestas claras de un experto real",
		"chatUpsaleV2_7": "Consejos personalizados para su perro",
		"chatUpsaleV2_8": "Resultados más rápidos con menos errores",
		"chatUpsaleV2_9": "Un proceso de entrenamiento tranquilo y seguro",
		"chatUpsaleV2_10": "Sin adiestrador",
		"chatUpsaleV2_11": "Dudar si lo está haciendo bien",
		"chatUpsaleV2_12": "Progreso lento y errores repetidos",
		"chatUpsaleV2_13": "Motivos poco claros detrás del mal comportamiento",
		"chatUpsaleV2_14": "Frustración para usted y su perro",
		"chatUpsaleV2_15": "Cada perro es diferente. ¡Obtenga ayuda experta para el suyo!",
		"chatUpsaleV2_16": "Respuestas incluso a las preguntas más difíciles sobre el comportamiento canino",
		"chatUpsaleV2_17": "Apoyo tanto emocional como práctico para el entrenamiento",
		"chatUpsaleV2_18": "Reduzca el estrés y la frustración durante el entrenamiento",
		"chatUpsaleV2_19": "Disfrute de una guía personalizada adaptada a usted y a su perro",
		"chatUpsaleV2_20": "Consiga apoyo profesional para lograr los máximos resultados",
		"chatUpsaleV2_21": "Cupos limitados",
		"chatUpsaleV2_22": "Quedan cupos exclusivos",
		"chatUpsaleV2_23": "Acceso al chat con adiestrador canino experto durante 4 semanas:",
		"chatUpsaleV2_24": "Descuento extra limitado del 75%:",
		"chatUpsaleV2_25": "Total",
		"chatUpsaleV2_26": "Obtenga ayuda experta ahora",
		"chatUpsaleV2_27": "Continuar sin chat con adiestrador canino",
		"chatUpsaleV2_28": "¿Puedo hacer cualquier pregunta sobre mi perro?",
		"chatUpsaleV2_29": "¡Sí! Puede preguntar sobre comportamiento, entrenamiento, temas de cachorros o desafíos específicos que esté afrontando.",
		"chatUpsaleV2_30": "¿En cuánto tiempo recibiré una respuesta?",
		"chatUpsaleV2_31": "Nuestros adiestradores con experiencia suelen responder en un plazo de 24 horas en días laborables.",
		"chatUpsaleV2_32": "¿Necesito experiencia previa de entrenamiento?",
		"chatUpsaleV2_33": "Para nada. Nuestros adiestradores le guían paso a paso, tanto si es principiante como si es un dueño con experiencia."
	},
	"zh": {
		"global \ninstruction": "",
		"safe": "您的信息是安全的",
		"information": "我们不会出售或出租您的个人联系信息用于任何营销目的。",
		"secure_checkout": "安全结账",
		"encrypted": "所有信息均已加密，并通过安全套接字层协议无风险传输。",
		"help": "需要帮助吗？",
		"contact": "联系我们",
		"here": "这里.",
		"undefined": "",
		"featured": "如 featured in 所示",
		"main_title": "狗训练课程",
		"per_year": "每年",
		"special_offer": "特价优惠",
		"card_number": "卡号",
		"card_expiry": "卡片过期",
		"security_number": "安全号码",
		"email": "电子邮件",
		"To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of __period__ and at the full, not discounted, price of __fullPriceText__ To learn more visit our <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">terms of use</a>.": "付款信息",
		"secure_server": "安全服务器",
		"pay": "支付",
		"enter_your_email": "请输入你的电子邮件",
		"comment_1": "在几年的压力巨大的岁月里，我完全失去了身材，增了一些脂肪，但我没有时间或动力去解决这个问题。一个家庭成员建议我使用Verv，现在我每天都依赖我的教练！",
		"comment_2": "Verv让我享受在家锻炼，一个月内我减掉了7公斤。这款应用程序如果你和我一样是初学者，可以真的帮助你锻炼和减肥。",
		"success_story": "成功故事",
		"get_my_plan": "获取我的计划",
		"delimiter": "或者",
		"pay_buy_card": "用卡支付",
		"get_my_plan_warning_1": "为了避免任何中断，您同意您选择的订阅将自动延续到下一个续订周期",
		"get_my_plan_warning_2": "和全价，不打折的价格是",
		"get_my_plan_warning_3": "要了解更多，访问我们的",
		"get_my_plan_warning_text": "继续即表示您同意，如果您在第一次续订期结束前至少不取消24小时，将会自动收取您每 __period__ 的全价 __fullPriceText__ 直到您取消。",
		"terms_of_use": "使用条款",
		"privacy_policy": "隐私政策",
		"terms_conditions": "条款和条件",
		"privacy_policy_footer": "隐私政策",
		"terms_conditions_footer": "条款与条件",
		"guaranteed": "保证安全结账",
		"special_features": "为您提供的特殊功能",
		"calories_value": "千卡",
		"personalized_plan": "获取您的个性化计划：",
		"mobile_app": "带有您的计划的移动应用程序",
		"daily_programs": "针对不同目标的每日计划（燃烧脂肪、减少压力、增肌）",
		"audio_guided": "音频指导的锻炼",
		"easy_to_cook": "易于烹饪且美味的菜肴",
		"comprehensive_stats": "综合统计",
		"secret_tips": "培养健康习惯的秘密技巧",
		"mobile_app_tailor": "口袋里的定制计划",
		"daily_programs_for": "每日节目",
		"daily_programs_for_2": "为了不同的目标（燃烧脂肪、减轻压力、增加肌肉）",
		"audio_trainers": "专业培训师指南",
		"comprehensive_track": "通过终极统计跟踪您的进度",
		"price": "价格",
		"users_love": "用户喜欢我们的个性化计划",
		"alternative_review_name_1": "Therealtierra",
		"alternative_review_title_1": "很棒的应用程序！",
		"alternative_review_contentent_1": "我现在是第九周，我的身体变化很大！",
		"alternative_review_name_2": "网球女孩",
		"alternative_review_title_2": "它有效！",
		"alternative_review_contentent_2": "刚刚完成了程序。我喜欢！减掉了15公斤！！",
		"you_re_in": "你进来了！",
		"personal_plan_starts": "您的Verv个人计划今天开始，时间在 ticking。快来看看吧！",
		"app_by_link": "要进入您的程序，请通过链接下载应用程序",
		"download_now": "立即下载",
		"or": "或",
		"price_after_trial": "试用后的价格",
		"seven_days_trial_unlocked": "7天试用已解锁",
		"total_today": "今天总计",
		"reserved_price_for": "保留价格为",
		"new_subscritions1_title": "选择您的计划",
		"new_subscritions1_subscription1_line1": "半年计划",
		"new_subscritions1_subscription1_price1_time": "每周",
		"new_subscritions1_subscription2_line1": "3个月计划",
		"new_subscritions1_subscription2_price2_time": "每周",
		"new_subscritions1_subscription3_line1": "1个月计划",
		"new_subscritions1_subscription3_price3_time": "每周",
		"new_subscription_save": "保存",
		"new_subscritions_agreement": "继续即表示您同意",
		"new_subscritions_and": "和",
		"new_subscritions_subtitle": "我们的用户损失了1000万英镑",
		"new_subscritions_join": "加入我们数百万快乐的用户",
		"statistic_block_item1_text": "满分5星",
		"statistic_block_item2_text": "5星评级",
		"statistic_block_item3_text": "下载",
		"get_your_personalized_plan": "获取您的个性化计划",
		"for": "为",
		"new_subscription_save_mostPopular1MonthPrice": "最受欢迎的计划",
		"timer_additional_discount": "额外折扣刚刚应用 ",
		"timer_additional_discount_bold": "给你",
		"timer_offer_expires": "此优惠将在以下时间到期：",
		"Payment Successful": "",
		"payment_successful_title": "来自Verv团队的问候！",
		"payment_successful_download": "下载应用",
		"payment_successful_press": "按",
		"payment_successful_login": "使用电子邮件登录",
		"payment_successful_email": "请输入您的电子邮件",
		"payment_successful_code": "和您的确认代码：",
		"payment_successful_hit": "然后点击",
		"payment_successful_done": "完成",
		"payment_successful_description": "您已参与，享受您的个性化训练计划！",
		"Tariffs Variants": "",
		"tariff_title_choose": "选择您的计划",
		"tariff_title_get": "获取您的计划",
		"tariff_one_month": "1个月计划",
		"tariff_three_month": "3个月计划",
		"tariff_six_month": "6个月计划",
		"tariff_one_year": "1年计划",
		"tariff_one_week": "1周计划",
		"tariff_three_day": "3天计划",
		"tariff_per_year": "每年",
		"tariff_per_day": "每天",
		"tariff_per_days": "每3天",
		"tariff_per_week": "每周",
		"tariff_week": "周",
		"tariff_annual": "年度计划",
		"tariff_trial_one_week": "1周试用",
		"tariff_after": "之后 ",
		"tariff_save": "保存",
		"tariff_best_offer": "最佳报价",
		"tariff_most_popular": "最受欢迎",
		"tariff_limited_promo": "有限的促销价格",
		"tariff_6_for_3": "6个价格为3个",
		"tariff_first_month": "第一个月",
		"tariff_first_week": "第一周",
		"tariff_monthly": "每月",
		"tariff_quaterly": "季度的",
		"tariff_semiannually": "半年一次",
		"tariff_billed_every ": "每次收费 ",
		"tariff_year": "年",
		"tariff_month": "月",
		"tariff_months": "月",
		"tariff_months_variable": "个月",
		"tariff_organic_gift": "冥想计划",
		"tariff_full_price": "全价",
		"tariff_no_hidden_fees": "没有隐藏费用",
		"tariff_start_right_now": "现在就开始",
		"tariff_more_than": "超过1,000,000名活跃的Verv家庭成员",
		"tariff_intro_offer": "欢迎优惠",
		"Тарифы плиткой в ряд": "",
		"": "",
		"Checkout": "",
		"checkout_title": "选择支付方式",
		"insufficient_funds": "资金不足",
		"insufficient_we_have": "我们有一个",
		"insufficient_special_price": "特价",
		"insufficient_for_you": "给你",
		"checkout_edit_card": "编辑卡片",
		"checkout_pay_via": "通过支付",
		"checkout_paypal": "PayPal",
		"checkout_credit_card": "信用卡",
		"checkout_paypal_description": "您的付款将通过 PayPal 处理",
		"checkout_total_price": "总价",
		"checkout_warning_1": "为避免任何中断，您同意您选择的订阅将在继续更新期间自动延长",
		"checkout_warning_2": "以及全价，未打折的价格为",
		"checkout_warning_3": "要了解更多，请访问我们的",
		"spv2_warning": "为了避免任何中断，您同意您选择的订阅将自动延续至连续的续订期__________，且价格全额，而非折扣价__________。欲了解更多信息，请访问我们的<a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">使用条款</a>。",
		"checkout_offer_day_for": "天用于",
		"checkout_offer_days_for": "天用于",
		"checkout_offer_month_for": "月份为",
		"checkout_offer_months_for": "月份为",
		"checkout_offer_week_for": "一周用于",
		"Values": "",
		"value_kg": "千克",
		"value_pounds": "磅",
		"value_st": "st",
		"value_g": "g",
		"value_kcal": "千卡",
		"value_min": "分钟",
		"value_min_cooking": "分钟烹饪",
		"welcome_title": "欢迎来到 Verv Premium！",
		"item_1_title": "耶！",
		"item_1_description": "__weight__ 的目标体重现在就在眼前。",
		"item_2_title": "如何激活",
		"item_2_description": "通过下面的链接下载该应用，使用您的电子邮件 __mail__ 并输入该验证代码：__code__。",
		"item_2_description_2": "要更改电子邮件，请点击 <button id=\"changeMail\">这里</button>。",
		"item_3_title": "出了点问题吗？",
		"item_3_description": "详细说明已发送到您的电子邮件。如果您没有收到，请联系<a target=\"_blank\" href=\"mailto:support@verv.com?subject=登录问题 (simple-login)\">支持</a>。",
		"change": "确认",
		"change_mail": "在此更改您的电子邮件以激活高级",
		"email_warning": "请输入有效的电子邮件地址",
		"Promo Code Block": "",
		"promo_code_title": "优惠码已应用！",
		"promo_code_save": "% 折扣",
		"EveryDoggy": "",
		"dog_courses": "犬类课程",
		"why_we_best_active": "活跃用户。",
		"why_we_best_lessons": "视频课程。",
		"why_we_best_brain": "脑力游戏。",
		"why_we_best": "我们为什么是最好的？",
		"why_we_best_join": "加入我们的狗主人社区，与EveryDoggy一起尽力而为。",
		"why_we_best_enjoy": "享受你个性化的训练计划，量身定制以符合你和你狗狗的目标。",
		"why_we_best_keep": "通过70多种脑力游戏让您的狗保持精神和身体活跃。",
		"dog_problems": "快速解决行为问题",
		"dog_problems_choose": "选择您想要改善的不良行为",
		"dog_problems_leash": "牵引<br/>绳",
		"dog_problems_biting": "咬",
		"dog_problems_anxiety": "分离焦虑<br/>",
		"dog_problems_chewing": "破坏性的<br/>咀嚼",
		"dog_plan": "个性化训练计划",
		"dog_plan_our": "我们的训练程序完全根据您的狗的需求量身定制。",
		"dog_reviews": "狗主人对EveryDoggy的评价",
		"dog_reviews_text_1": "«非常清晰且易于理解的课程。我的小狗喜欢训练，而我们都学到了很多东西。」",
		"dog_reviews_name_1": "梅根和里奥",
		"dog_reviews_text_2": "“Zen”命令真是神奇。多亏了它，我的狗在兽医诊所接受治疗时超级平静。",
		"dog_reviews_name_2": "琳达·B.",
		"dog_reviews_text_3": "“谢谢你提供的点按训练课。我听说这很受欢迎，但不清楚如何使用它。我很快让我的狗熟悉了点按器，现在我们开始学习技巧。”",
		"dog_reviews_name_3": "杰克·L。",
		"join_text": "快乐的狗狗养成从EveryDoggy开始",
		"join_courses": "加入网络课程",
		"checkout_introductory": "入门优惠折扣",
		"checkout_personalized_plan": "您的个性化计划",
		"Personal plan": "",
		"goal_lose_weight": "有效的减肥计划，提供指导锻炼、营养追踪器和各种活动供您选择",
		"goal_gain_muscles": "有效的全身塑形程序，提供指导锻炼、营养跟踪器和各种活动供您选择",
		"goal_gain_healthier_life": "全身指导的健康新习惯，营养跟踪器和多种活动供您选择",
		"goal_gain_flexibility": "灵活性瑜伽课程，包括引导课程和舒缓音乐、营养跟踪器和各种其他活动",
		"goal_gain_build_endurance": "耐力训练计划，提供指导性的锻炼、营养跟踪和多种活动供您选择",
		"goal_love_myself": "多种提高自尊心的活动，指导冥想，瑜伽课程和全身锻炼",
		"body_type_apple": "针对苹果形身材的锻炼，以增强核心力量和瘦腰。",
		"body_type_pear": "梨形身体的锻炼，塑造你的臀部和大腿",
		"body_type_square": "适合方形身材的练习，以勾勒你的腰部并锻炼你的臀部",
		"body_type_hourglass": "针对沙漏形体的锻炼，帮助您获得惊人的效果",
		"body_type_triangle": "倒三角体型的锻炼，旨在增强你的臀部和大腿",
		"body_type_unknown": "锻炼，让你的身体轮廓更出色",
		"excercises_time_morning": "早晨锻炼可以提升你的新陈代谢，让你整天充满活力",
		"excercises_time_day": "完美融入您日程的锻炼，提升您的新陈代谢，并让您整天充满活力。",
		"excercises_time_evening": "晚间锻炼帮助你在漫长的一天后缓解压力，并为良好的睡眠做好准备。",
		"excercises_not_sure": "完美融入您日程的锻炼，促进您的新陈代谢，让您在一天中保持精力充沛",
		"diet_type_all": "简单健康的食谱",
		"diet_type_vegetarian": "健康的素食食谱",
		"diet_type_vegan": "健康的素食食谱",
		"diet_type_keto": "健康的生酮食谱",
		"personal_plan_providers_title": "",
		"special_features_title": "为您提供的特殊功能",
		"special_features_duration_minimum": "10分钟以下的快速会议",
		"special_features_duration_normal": "20分钟以内的便捷会议",
		"special_features_duration_maximum": "有效的会话超过20分钟",
		"special_features_duration_verv": "来自我们教练的便捷课程",
		"special_features_goal_lose_weight": "专家的秘密减肥秘诀",
		"special_features_goal_gain": "专家的秘密肌肉塑形技巧",
		"special_features_goal_health": "专家的健康秘密诀窍",
		"special_features_goal_flexibility": "来自专家的秘密灵活性技巧",
		"special_features_goal_endurance": "提高耐力的秘密技巧",
		"special_features_goal_love": "提升自信心的秘密技巧",
		"discount_activated": "50%的折扣已激活",
		"discount_no_activated": "50%折扣",
		"unlocked_with_promo": "使用促销代码解锁：",
		"use_with_button": "使用您的特殊促销代码：",
		"plan_optimal": "最佳",
		"plan_standard": "标准",
		"plan_basic": "基础",
		"plan_extra": "额外",
		"daypayback_review_name_1": "梅利贝丝",
		"daypayback_review_text_1": "",
		"daypayback_review_name_2": "katie_zu13",
		"daypayback_review_text_2": "我爱Verv！遵循我的个人锻炼和饮食计划帮助我恢复了身材并重新获得了信心！我从15分钟以内的短期健身锻炼开始，非常适合像我这样的初学者。然后我提高了耐力，锻炼时间增加到每次30-40分钟。在六个月内，我在Verv的帮助下慢慢而稳妥地减掉了25磅！",
		"daypayback_review_name_3": "Jean_leon1",
		"daypayback_review_text_3": "我在大学期间体重增加了很多。毕业后，我尝试了不同的饮食，这些饮食帮助我减肥，但这些体重总是在饮食结束几个月后重新回来。去年，我通过同事听说了Verv，决定试一试。凭借Verv的个性化推荐，我成功减掉了体重，并且在之后保持了下来！",
		"daypayback_review_name_4": "maryanne1993",
		"daypayback_review_text_4": "在经历了一次艰难的分手后，我决定改变我的生活，减肥并变得更健康。但我不知道从哪里开始。我不够自信去和别人一起锻炼，所以我决定尝试家庭训练应用，Verv出现在我的搜索中。它为我提供了一个量身定制的计划。我遵循了这个计划，成功地得到了我梦想中的身体！",
		"personal_plan_you_get": "通过您的个性化计划，您可获得",
		"goal": "目标",
		"goal_other": "训练您毛茸茸的朋友的课程",
		"goal_teaching_puppy": "教你的毛茸茸的朋友礼仪和服从的课程",
		"goal_surviving_puppy": "帮助您为与您的毛茸茸朋友相处的头几天做准备的课程",
		"goal_socializing_puppy": "帮助你社交你的毛茸茸朋友的课程",
		"goal_teaching_obedience": "教你的毛茸茸的朋友礼仪和服从的课程",
		"age_puppy": "来自我们专家的详细训练技巧，帮助您培养一只快乐且行为良好的小狗",
		"age_adult": "来自我们专家的详细训练技巧，帮助您以最有效的方式训练您的狗",
		"biting_yes": "逐步指导，以防止您的狗咬人",
		"biting_no": "与您的狗一起玩的有趣游戏",
		"biting_sometimes": "逐步指导以阻止你的狗咬人",
		"quick_tips": "快速简单的学习新命令的技巧",
		"potty_training_a_bit": "有效训练小狗上厕所的特别指南",
		"potty_training_yes": "特别指南教你的幼犬新有趣的把戏",
		"potty_training_no": "一本特别的指南，用于有效地训练您的小狗上厕所",
		"success screen": "",
		"success_screen_text_1": "感谢您的购买！",
		"success_screen_text_2": "按照下面的说明设置<br />您的帐户：",
		"success_screen_text_3": "前往您的 <b>账户</b>",
		"success_screen_text_4": "扫描 <b>二维码</b> 或点击 <b>链接</b>",
		"success_screen_text_5": "<b>下载</b>该应用",
		"success_screen_text_6": "<b>打开应用</b>并<b>享受</b><br />与您的狗狗训练!",
		"success_screen_text_7": "我们已经为您复制了QR码和链接，地址为 &nbsp;<b>example@gmail.com</b>",
		"success_screen_text_8": "如果应用中未申请高级帐户，请在欢迎屏幕上按 <b>‘联系我们’</b> 并联系支持团队。",
		"success_screen_text_9": "按下‘开始’按钮即表示我确认已查看并接受<a href=\"https://everydoggy.com/policy/\" target=\"_blank\">隐私政策</a>和<a href=\"https://everydoggy.com/terms/\" target=\"_blank\">条款和条件</a>，并在此同意处理我的个人数据。",
		"success_screen_text_10": "联系我们",
		"success_screen_text_11": "前往我的账户",
		"success_screen_text_12": "我们已通过电子邮件向您发送了重复的QR码和链接。",
		"success_screen_text_13": "您的 PDF 指南已发送至您的电子邮件 <b>v.stsiopina@gmail.com</b>。",
		"success_screen_text_14": "您的PDF指南已发送到您的电子邮件。",
		"success_screen_text_15": "如果在应用程序中未应用高级帐户，请在应用程序的欢迎屏幕上按<span>'登录'</span>链接，并输入我们发送给您的电子邮件和密码，地址为<b>stepinavalerie@gmail.com</b>",
		"success_screen_text_16": "如果在应用程序中没有应用高级帐户，请在应用程序的欢迎屏幕上点击 <span>'登录'</span> 链接，并输入我们通过电子邮件发送给您的电子邮件地址和密码。",
		"payment_text_1": "您的狗训练程序现在开始！",
		"payment_text_2": "Everydoggy应用将帮助您<span>快速且有趣地解决您狗狗的任何行为问题</span>。",
		"payment_text_3": "个人优惠到期",
		"payment_text_4": "我们的用户在开始与我们的专家进行训练后仅1周就注意到他们的狗行为的积极变化",
		"payment_text_5": "每只狗与教练",
		"payment_text_6": "每月平均命令数量",
		"payment_text_7": "每只狗都受益",
		"payment_text_8": "个性化犬只训练计划",
		"payment_text_9": "每天仅需15分钟即可拥有完美的宠物",
		"payment_text_10": "70多个易于理解的视频培训课程，快速获得结果",
		"payment_text_11": "80多款游戏和技巧，用于新技能和纯粹的乐趣",
		"payment_text_12": "关于卫生、健康和营养的建议",
		"payment_text_13": "在家和户外训练，无需设备",
		"payment_text_14": "我们的98%用户在与我们的专家开始训练后仅需1周就注意到他们狗狗行为的积极变化。",
		"payment_text_14_2": "<span>98%的用户</span>在与我们的专家开始训练仅1周后，注意到他们的狗的行为出现积极变化",
		"payment_text_15": "点击“获取我的计划”按钮，即表示您同意我们的<a href='https://everydoggy.com/terms/' target=\"_blank\" >条款和条件</a>和<a href='https://everydoggy.com/policy/' target=\"_blank\" >隐私政策</a>，<b>授权自动续订</b>您的订阅，在每个账单周期结束时，以<span>1个月</span>为单位，按全价<i>$29.99</i>加上适用税费。您可以在续订日期之前的任何时间取消您的订阅的自动续订。请查看我们的<a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >取消条款</a>以获取更多详细信息。",
		"payment_text_16": "点击“获取我的计划”按钮，即表示您同意我们的<a href='https://everydoggy.com/terms/' target='_blank'>条款和条件</a>以及<a href='https://everydoggy.com/policy/' target='_blank'>隐私政策</a>，并<b>授权自动续订</b>您每个账单周期结束时的订阅，周期为<span>1个月</span>，全价为<i>$29.99</i>加上适用税费。您可以在续订日期之前随时取消订阅的自动续订。有关更多详细信息，请查看我们的<a href='https://everydoggy.com/subscription-terms/' target='_blank'>取消条款</a>。",
		"payment_text_17": "有什么问题吗？",
		"payment_text_18": "只需给我们写信到 ",
		"payment_text_19": "它可以工作！",
		"payment_text_20": "刚刚和我们的小狗完成了服从训练课程，我喜欢！ 👏",
		"payment_text_21": "太棒了！",
		"payment_text_22": "",
		"payment_text_23": "",
		"payment_text_24": "",
		"payment_text_25": "",
		"payment_text_26": "",
		"payment_text_27": "",
		"payment_text_28": "",
		"payment_text_29": "",
		"payment_text_30": "",
		"payment_text_31": "",
		"payment_text_32": "",
		"payment_text_33": "",
		"payment_text_34": "",
		"payment_text_35": "",
		"payment_text_36": "",
		"payment_text_37": "",
		"payment_text_38": "",
		"payment_text_39": "",
		"payment_text_40": "",
		"payment_text_41": "",
		"payment_text_42": "",
		"payment_text_43": "",
		"payment_text_44": "",
		"payment_text_45": "",
		"payment_text_46": "",
		"payment_text_47": "",
		"payment_text_48": "",
		"payment_text_49": "",
		"payment_text_50": "",
		"payment_text_51": "",
		"payment_text_52": "",
		"payment_text_53": "",
		"payment_text_54": "",
		"payment_text_55": "",
		"payment_text_56": "",
		"payment_text_57": "",
		"payment_text_58": "",
		"payment_text_59": "",
		"payment_text_60": "",
		"payment_text_61": "",
		"payment_text_62": "",
		"payment_text_63": "",
		"payment_text_64": "",
		"payment_text_65": "",
		"payment_text_66": "",
		"payment_text_67": "",
		"payment_text_68": "",
		"payment_text_69": "",
		"payment_text_70": "",
		"payment_text_71": "",
		"payment_text_72": "",
		"payment_text_73": "",
		"payment_text_74": "",
		"payment_text_75": "",
		"payment_text_76": "",
		"payment_text_77": "",
		"payment_text_78": "",
		"payment_text_79": "",
		"payment_text_80": "",
		"payment_text_81": "",
		"payment_text_82": "You will only be charged <b>$6.99</b> today for your first week (details below)",
		"payment_text_83": "Your introductory period will last until <b>Oct 11, 2024</b>.",
		"payment_text_84": "You may cancel at any time before <b>Oct 10, 2024</b>, and you will not be charged.",
		"payment_text_85": "If you don’t cancel, Everydoggy will automatically continue your membership at the end of your introductory period and charge the membership fee (currently <b>$39.99 USD</b>) monthly until you cancel.",
		"payment_text_86": "No partial refunds. You can cancel your subscription anytime in your Account.",
		"payment_text_87": "Your subscription will be bound by our <a href='https://everydoggy.com/terms/' target=\"_blank\" >Terms and Conditions</a>, <a href='https://everydoggy.com/policy/' target=\"_blank\" >Privacy Policy</a> and <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Cancellation Terms</a>.",
		"payment_text_88": "Payment method",
		"payment_text_89": "EveryDoggy will use your payment details for seamless future payments",
		"payment_text_90": "Easy and private payments with Face/Touch ID",
		"payment_text_91": "Keeps your financial info safe with end-to-end encryption",
		"payment_text_92": "Protected by Apple Pay’s unique Device Account Number",
		"payment_text_93": "Your payment information is secure with SSL/TLS encryption",
		"payment_text_94": "Fast, convenient payment option",
		"payment_text_95": "Backed by PayPal’s industry-leading fraud protection",
		"payment_text_96": "Confirm purchase",
		"payment_text_97": "1-WEEK",
		"payment_text_98": "1-MONTH",
		"payment_text_99": "3-MONTH",
		"payment_text_100": "You will only be charged <b>$6.99</b> today for your first month (details below)",
		"payment_text_101": "You will only be charged <b>$6.99</b> today for your first 3 months (details below)",
		"payment_text_102": "Subscribe with",
		"payment_text_103": "By clicking ‘Get my plan’ button you agree with the  <a href='https://everydoggy.com/policy/' target=\"_blank\" >Privacy Policy</a>,  <a href='https://everydoggy.com/terms/' target=\"_blank\" >Terms and Conditions</a> and <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Cancellation Terms</a>",
		"payment_text_104": "Easy and private payments",
		"payment_text_105": "Credit Card",
		"payment_text_106": "Expiry date",
		"payment_text_107": "CVC",
		"payment_text_108": "",
		"payment_text_109": "",
		"payment_text_110": "",
		"payment_text_111": "",
		"payment_text_112": "",
		"payment_text_113": "",
		"payment_text_114": "",
		"payment_text_115": "",
		"payment_text_116": "",
		"payment_text_117": "",
		"payment_text_118": "",
		"payment_text_119": "",
		"payment_text_120": "",
		"payment_text_121": "",
		"payment_text_122": "",
		"payment_text_123": "",
		"payment_text_124": "",
		"payment_text_125": "",
		"payment_text_126": "",
		"payment_text_127": "",
		"payment_text_128": "Current level",
		"payment_text_129": "16 commands",
		"payment_text_130": "Goal",
		"payment_text_131": "50+ commands & obedience",
		"payment_text_132": "Experience noticeable progress",
		"payment_text_133": "Achieve obedience",
		"payment_text_134": "Keep your dog well-trained for life",
		"payment_text_135": "Save 53%",
		"payment_text_136": "Money-back Guarantee",
		"payment_text_137": "30-Day Money-Back Guarantee",
		"payment_text_138": "We believe that our plan may work for you and you'll get visible results in 4 weeks! We even are ready to return your money back if you don't see visible results and can demonstrate that you followed our plan.",
		"payment_text_139": "Find more about applicable limitations in our <a href=\"https://everydoggy.com/terms/#section5_2\" target=\"_blank\" rel=\"noreferrer\">terms of use</a>.",
		"payment_text_140": "Save 53%",
		"payment_text_141": "Your Dog Training Plan is ready!",
		"payment_text_142": "Obedience",
		"payment_text_143": "Knows Commands",
		"payment_text_144": "Toilet Accidents",
		"payment_text_145": "Frequent",
		"payment_text_146": "None",
		"payment_text_147": "Barking",
		"payment_text_148": "Barks at everything",
		"payment_text_149": "Quiet & Relaxed",
		"payment_text_150": "Biting & chewing",
		"payment_text_151": "Often",
		"payment_text_152": "Stopped",
		"payment_text_153": "Pulling the leash",
		"payment_text_154": "Always",
		"payment_text_155": "Walks calmly",
		"payment_text_156": "Anxiety When Left Alone",
		"payment_text_157": "Calm and independent",
		"payment_text_158": "Before",
		"payment_text_159": "After",
		"payment_text_160": "minutes",
		"payment_text_161": "seconds",
		"payment_text_162": "Proven. Tested. It Works",
		"payment_text_163": "Significant changes in a dog’s obedience",
		"payment_text_164": "Today",
		"payment_text_165": "Week 2",
		"payment_text_166": "Week 3",
		"payment_text_167": "Week 4",
		"payment_text_168": "What makes Everydoggy so effective",
		"payment_text_169": "Our users' success stories",
		"payment_text_170": "Crafted by Experts Who <span>Love Dogs</span>",
		"payment_text_171": "Every our course and lesson is grounded in scientific studies of dog training.",
		"payment_text_172": "Build a strong bond with your dog, try EveryDoggy!",
		"payment_text_173": "Proven. Tested. It Works",
		"payment_text_174": "<span>93% of our users</span> notice significant changes in their dog’s behavior within the first month of training.",
		"payment_text_175": "With EveryDoggy",
		"payment_text_176": "Without EveryDoggy",
		"payment_text_177": "Today",
		"payment_text_178": "Week 14",
		"payment_text_179": "Week 16",
		"payment_text_180": "Week 18",
		"payment_text_181": "About Luna",
		"payment_text_182": "My puppy kept having accidents in the house. Everydoggy gave us a clear routine, and it actually worked!",
		"payment_text_183": "About Cooper",
		"payment_text_184": "Our pup used to nip at everyone during playtime. The app gave us step-by-step guidance, and it worked!",
		"payment_text_185": "About Bella",
		"payment_text_186": "Our dog chewed everything – from shoes to the couch. The app helped us redirect that energy!",
		"payment_text_187": "About Charlie",
		"payment_text_188": "Leash pulling was a daily struggle. Thanks to the app, walks are now enjoyable and stress-free.",
		"payment_text_189": "Potty trained",
		"payment_text_190": "Solved biting",
		"payment_text_191": "Chewing solved",
		"payment_text_192": "Leash pulling solved",
		"payment_text_193": "",
		"payment_text_194": "",
		"payment_text_195": "",
		"payment_text_196": "",
		"payment_text_197": "",
		"payment_text_198": "",
		"payment_text_199": "",
		"payment_text_200": "",
		"payment_text_201": "",
		"payment_text_202": "",
		"payment_text_203": "",
		"payment_text_204": "",
		"payment_text_205": "",
		"payment_text_206": "",
		"payment_text_207": "",
		"payment_text_208": "",
		"payment_text_209": "",
		"payment_text_210": "",
		"payment_text_211": "",
		"payment_text_212": "",
		"payment_text_213": "",
		"payment_text_214": "",
		"payment_text_215": "",
		"payment_text_216": "",
		"payment_text_217": "",
		"payment_text_218": "",
		"payment_text_219": "",
		"payment_text_220": "",
		"payment_text_221": "",
		"payment_text_222": "",
		"payment_text_223": "",
		"payment_text_224": "",
		"payment_text_225": "",
		"payment_text_226": "最后机会！",
		"payment_text_227": "",
		"payment_text_228": "",
		"payment_text_229": "",
		"payment_text_230": "",
		"payment_text_231": "",
		"payment_text_232": "",
		"payment_text_233": "",
		"payment_text_234": "",
		"payment_text_235": "",
		"payment_text_236": "",
		"payment_text_237": "",
		"payment_text_238": "",
		"payment_text_239": "",
		"payment_text_240": "",
		"payment_text_241": "",
		"payment_text_242": "",
		"payment_text_243": "",
		"payment_text_244": "",
		"payment_text_245": "",
		"payment_text_246": "",
		"payment_text_247": "",
		"payment_text_248": "",
		"payment_text_249": "",
		"payment_text_250": "",
		"payment_text_251": "",
		"payment_text_252": "",
		"payment_text_253": "",
		"payment_text_254": "",
		"payment_text_255": "",
		"payment_text_256": "",
		"payment_text_257": "",
		"payment_text_258": "",
		"payment_text_259": "",
		"payment_text_260": "",
		"payment_text_261": "",
		"payment_text_262": "",
		"payment_text_263": "狗语翻译器",
		"payment_text_264": "读懂你的狗狗。<br/> 看到结果",
		"payment_text_265": "通过分析狗狗的信号和行为，服从训练效果会更好",
		"payment_text_266": "基于狗狗吠叫和行为分析制定的个性化训练计划",
		"payment_text_267": "训练更快，<br />快乐加倍！",
		"payment_text_268": "获取终极幼犬训练指南",
		"payment_text_269": "获取终极狗狗训练指南",
		"payment_text_270": "告别如厕问题！用循序渐进的方法，快速教会狗狗养成正确的如厕习惯。",
		"payment_text_271": "保护好您的鞋子和手指！用简单方法，帮助幼犬改掉乱咬和乱啃的习惯。",
		"payment_text_272": "为狗狗打造一个安全、舒适的空间，同时教会它在笼内保持平静和安心。",
		"payment_text_273": "解锁一整套专家技巧，涵盖行为、服从训练以及与狗狗相处的日常生活。",
		"payment_text_274": "用经过验证且易于上手的方法，纠正狗狗在家里和散步时的不良行为。",
		"payment_text_275": "让学习变得更有趣！掌握表扬和奖励的方法，立刻激发狗狗的积极性。",
		"payment_text_276": "教会狗狗的不只是基础指令！从重要的安全指令到适合各年龄狗狗的有趣精彩技巧，全面掌握。",
		"payment_text_277": "让狗狗的<br />进步 <span>加快 2 倍！</span>",
		"payment_text_278": "实用指南：",
		"payment_text_279": "会员专享 98% 折扣",
		"payment_text_280": "会员专享 70% 折扣",
		"payment_text_281": "",
		"payment_text_282": "",
		"payment_text_283": "",
		"payment_text_284": "",
		"payment_text_285": "",
		"payment_text_286": "",
		"payment_text_287": "",
		"payment_text_288": "",
		"payment_text_289": "",
		"payment_text_290": "",
		"payment_text_291": "",
		"payment_text_292": "",
		"payment_text_293": "",
		"payment_text_294": "",
		"payment_text_295": "",
		"payment_text_296": "",
		"payment_text_297": "",
		"payment_text_298": "",
		"payment_text_299": "",
		"payment_text_300": "",
		"payment_text_301": "",
		"payment_text_302": "",
		"payment_text_303": "",
		"payment_text_304": "",
		"payment_text_305": "",
		"payment_text_306": "",
		"payment_text_307": "",
		"payment_text_308": "",
		"payment_text_309": "",
		"payment_text_310": "",
		"payment_text_311": "",
		"payment_text_312": "",
		"payment_text_313": "",
		"payment_text_314": "",
		"payment_text_315": "",
		"payment_text_316": "",
		"payment_text_317": "",
		"payment_text_318": "",
		"payment_text_319": "",
		"payment_text_320": "",
		"payment_text_321": "",
		"payment_text_322": "",
		"payment_text_323": "",
		"payment_text_324": "",
		"payment_text_325": "",
		"payment_text_326": "",
		"payment_text_327": "",
		"payment_text_328": "",
		"payment_text_329": "",
		"payment_text_330": "",
		"payment_text_331": "",
		"payment_text_332": "",
		"payment_text_333": "",
		"payment_text_334": "",
		"payment_text_335": "",
		"payment_text_336": "",
		"payment_text_337": "",
		"payment_text_338": "",
		"payment_text_339": "",
		"payment_text_340": "",
		"payment_text_341": "",
		"payment_text_342": "",
		"payment_text_343": "",
		"payment_text_344": "",
		"payment_text_345": "",
		"payment_text_346": "",
		"payment_text_347": "",
		"payment_text_348": "",
		"payment_text_349": "",
		"payment_text_350": "",
		"payment_text_351": "",
		"payment_text_352": "",
		"payment_text_353": "",
		"payment_text_354": "",
		"payment_text_355": "",
		"payment_text_356": "",
		"payment_text_357": "",
		"payment_text_358": "",
		"payment_text_359": "",
		"payment_text_360": "",
		"payment_text_361": "",
		"payment_text_362": "",
		"payment_text_363": "",
		"payment_text_364": "",
		"payment_text_365": "",
		"payment_text_366": "",
		"payment_text_367": "",
		"payment_text_368": "",
		"payment_text_369": "",
		"payment_text_370": "",
		"payment_text_371": "",
		"payment_text_372": "",
		"payment_text_373": "",
		"payment_text_374": "",
		"payment_text_375": "",
		"payment_text_376": "",
		"payment_text_377": "",
		"payment_text_378": "",
		"payment_text_379": "",
		"payment_text_380": "",
		"payment_text_381": "",
		"payment_text_382": "",
		"payment_text_383": "",
		"payment_text_384": "",
		"payment_text_385": "",
		"payment_text_386": "",
		"payment_text_387": "",
		"payment_text_388": "",
		"payment_text_389": "",
		"pdfUpselling": "",
		"pdfUpselling_1": "<span>Kickstart your journey to an obedient dog:</span> Grab an ultimate guide to dog raising training",
		"pdfUpselling_2": "<span>Kickstart your journey to an obedient dog:</span> Grab an ultimate guide to puppy raising and training",
		"pdfUpselling_3": "Get your <span>personal plan</span>",
		"pdfUpselling_4": "Unlock the <span>practical guide</span>",
		"pdfUpselling_5": "Behavior correction (indoors & outdoors)",
		"pdfUpselling_6": "How to praise and reward your dog",
		"pdfUpselling_7": "Various commands",
		"pdfUpselling_8": "Enrichment games & much more",
		"pdfUpselling_9": "Potty training",
		"pdfUpselling_10": "Stop biting & chewing",
		"pdfUpselling_11": "Crate training",
		"pdfUpselling_12": "Plus 43 other helpful tips and solutions",
		"pdfUpselling_13": "Total today",
		"pdfUpselling_14": "Unlock guide",
		"pdfUpselling_15": "Unlock with",
		"pdfUpselling_16": "Continue without guide",
		"chatUpsale_1": "",
		"chatUpsale_2": "",
		"chatUpsale_3": "",
		"chatUpsale_4": "",
		"chatUpsale_5": "",
		"chatUpsale_6": "",
		"chatUpsale_7": "",
		"chatUpsale_8": "",
		"chatUpsale_9": "",
		"chatUpsale_10": "",
		"chatUpsale_11": "",
		"chatUpsale_12": "",
		"chatUpsale_13": "",
		"chatUpsale_14": "",
		"chatUpsale_15": "",
		"checkoutV2_text1": "",
		"checkoutV2_text2": "",
		"checkoutV2_text3": "",
		"checkoutV2_text4": "",
		"checkoutV2_text5": "",
		"checkoutV2_text6": "",
		"checkoutV2_text7": "",
		"checkoutV2_text8": "",
		"checkoutV2_text9": "",
		"checkoutV2_text10": "",
		"checkoutV2_text11": "",
		"error_1": "",
		"error_2": "",
		"error_3": "",
		"error_4": "",
		"error_5": "",
		"error_6": "",
		"error_7": "",
		"error_8": "",
		"error_9": "",
		"error_10": "",
		"disclaimerV2_text_1": "",
		"disclaimerV2_text_2": "",
		"disclaimerV2_text_3": "",
		"chatUpsaleV2_1": "",
		"chatUpsaleV2_2": "",
		"chatUpsaleV2_3": "",
		"chatUpsaleV2_4": "",
		"chatUpsaleV2_5": "",
		"chatUpsaleV2_6": "",
		"chatUpsaleV2_7": "",
		"chatUpsaleV2_8": "",
		"chatUpsaleV2_9": "",
		"chatUpsaleV2_10": "",
		"chatUpsaleV2_11": "",
		"chatUpsaleV2_12": "",
		"chatUpsaleV2_13": "",
		"chatUpsaleV2_14": "",
		"chatUpsaleV2_15": "",
		"chatUpsaleV2_16": "",
		"chatUpsaleV2_17": "",
		"chatUpsaleV2_18": "",
		"chatUpsaleV2_19": "",
		"chatUpsaleV2_20": "",
		"chatUpsaleV2_21": "",
		"chatUpsaleV2_22": "",
		"chatUpsaleV2_23": "",
		"chatUpsaleV2_24": "",
		"chatUpsaleV2_25": "",
		"chatUpsaleV2_26": "",
		"chatUpsaleV2_27": "",
		"chatUpsaleV2_28": "",
		"chatUpsaleV2_29": "",
		"chatUpsaleV2_30": "",
		"chatUpsaleV2_31": "",
		"chatUpsaleV2_32": "",
		"chatUpsaleV2_33": ""
	},
	"ja": {
		"global \ninstruction": "",
		"safe": "あなたの情報は安全です",
		"information": "私たちは、あなたの個人連絡先情報をいかなるマーケティング目的にも販売したり賃貸したりしません。",
		"secure_checkout": "安全なチェックアウト",
		"encrypted": "すべての情報は暗号化され、リスクなしでセキュアソケットレイヤー（SSL）プロトコルを使用して送信されます。",
		"help": "何かお手伝いしましょうか？",
		"contact": "ご連絡ください",
		"here": "ここ。",
		"undefined": "",
		"featured": "特集されているのは",
		"main_title": "犬のトレーニングコース",
		"per_year": "年間",
		"special_offer": "特別提供",
		"card_number": "カード番号",
		"card_expiry": "カードの有効期限が切れます",
		"security_number": "セキュリティ番号",
		"email": "電子メール",
		"To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of __period__ and at the full, not discounted, price of __fullPriceText__ To learn more visit our <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">terms of use</a>.": "支払い情報",
		"secure_server": "安全なサーバー",
		"pay": "支払う",
		"enter_your_email": "メールアドレスを入力してください",
		"comment_1": "数年にわたるストレスの多い時期に、私は完全に体型を失い、少し脂肪がついてしまいましたが、そのことで何かをするための時間もモティベーションもありませんでした。家族の一員がVervを提案してくれ、今では毎日私のコーチを頼りにしています！",
		"comment_2": "Vervは私に自宅でのワークアウトを楽しませてくれ、1ヶ月で7kg減りました。このアプリは、私のような初心者が運動や減量するのに本当に役立つかもしれません。",
		"success_story": "成功の物語",
		"get_my_plan": "私のプランを取得する",
		"delimiter": "または",
		"pay_buy_card": "カードで支払う",
		"get_my_plan_warning_1": "中断を避けるために、選択したサブスクリプションは自動的に次回の更新期間に延長されることに同意します",
		"get_my_plan_warning_2": "そして、割引のない正規価格で",
		"get_my_plan_warning_3": "詳細を知るには、私たちのサイトを訪れてください",
		"get_my_plan_warning_text": "続行することで、初回更新期間の終了前に少なくとも24時間前にキャンセルしなかった場合、__period__ ごとに __fullPriceText__ の全額が自動的に請求されることに同意したことになります。",
		"terms_of_use": "利用規約",
		"privacy_policy": "プライバシーポリシー",
		"terms_conditions": "利用規約",
		"privacy_policy_footer": "プライバシーポリシー",
		"terms_conditions_footer": "利用規約",
		"guaranteed": "保証された安全なチェックアウト",
		"special_features": "あなたのための特別な機能",
		"calories_value": "kcal",
		"personalized_plan": "あなたのパーソナライズされたプランを取得：",
		"mobile_app": "あなたのプランを持つモバイルアプリ",
		"daily_programs": "異なる目標のための日常プログラム（脂肪を燃焼する、ストレスを減らす、筋肉を増やす）",
		"audio_guided": "音声ガイド付きワークアウト",
		"easy_to_cook": "簡単に作れて美味しい料理",
		"comprehensive_stats": "包括的な統計",
		"secret_tips": "健康的な習慣を育む秘密のヒント",
		"mobile_app_tailor": "ポケットに入ったオーダーメイドのプラン",
		"daily_programs_for": "日々のプログラム",
		"daily_programs_for_2": "異なる目標のために（脂肪を燃焼、ストレスを軽減、筋肉を増やす）",
		"audio_trainers": "プロフェッショナルトレーナーガイド",
		"comprehensive_track": "究極の統計で進捗を追跡",
		"price": "価格",
		"users_love": "ユーザーは私たちのパーソナライズプランを気に入っています",
		"alternative_review_name_1": "Therealtierra",
		"alternative_review_title_1": "素晴らしいアプリ！",
		"alternative_review_contentent_1": "私は9週目です、そして私の体は大きく変わりました！",
		"alternative_review_name_2": "テニスガール",
		"alternative_review_title_2": "動きます！",
		"alternative_review_contentent_2": "プログラムを終えました。大好きです。15kg減りました！！",
		"you_re_in": "あなたは参加しました！",
		"personal_plan_starts": "あなたのVerv個人プランは今日から始まります。時間が迫っていますので、ぜひチェックしてください！",
		"app_by_link": "プログラムに入るには、リンクからアプリをダウンロードしてください",
		"download_now": "今すぐダウンロード",
		"or": "または",
		"price_after_trial": "トライアル後の価格",
		"seven_days_trial_unlocked": "7日間のトライアルが解除されました",
		"total_today": "今日の合計",
		"reserved_price_for": "予想価格は",
		"new_subscritions1_title": "プランを選択してください",
		"new_subscritions1_subscription1_line1": "半年計画",
		"new_subscritions1_subscription1_price1_time": "週ごと",
		"new_subscritions1_subscription2_line1": "3ヶ月プラン",
		"new_subscritions1_subscription2_price2_time": "週ごとに",
		"new_subscritions1_subscription3_line1": "1ヶ月プラン",
		"new_subscritions1_subscription3_price3_time": "週ごとに",
		"new_subscription_save": "保存する",
		"new_subscritions_agreement": "続行することにより、あなたは同意します",
		"new_subscritions_and": "と",
		"new_subscritions_subtitle": "私たちのユーザーは1000万ポンドを失いました",
		"new_subscritions_join": "数百万の満足しているユーザーに参加してください",
		"statistic_block_item1_text": "5つ星中",
		"statistic_block_item2_text": "5つ星評価",
		"statistic_block_item3_text": "ダウンロード",
		"get_your_personalized_plan": "あなたのパーソナライズプランを取得する",
		"for": "のために",
		"new_subscription_save_mostPopular1MonthPrice": "最も人気のあるプラン",
		"timer_additional_discount": "追加割引が適用されました ",
		"timer_additional_discount_bold": "あなたのために",
		"timer_offer_expires": "このオファーは以下の時間で期限切れになります：",
		"Payment Successful": "",
		"payment_successful_title": "Vervチームからこんにちは！",
		"payment_successful_download": "アプリをダウンロード",
		"payment_successful_press": "押す",
		"payment_successful_login": "メールでログイン",
		"payment_successful_email": "メールアドレスを入力してください",
		"payment_successful_code": "と確認コード：",
		"payment_successful_hit": "次にタップします",
		"payment_successful_done": "完了",
		"payment_successful_description": "参加しました。パーソナライズされたトレーニングプランをお楽しみください！",
		"Tariffs Variants": "",
		"tariff_title_choose": "プランを選択してください",
		"tariff_title_get": "プランを取得する",
		"tariff_one_month": "1ヶ月プラン",
		"tariff_three_month": "3ヶ月プラン",
		"tariff_six_month": "6ヶ月プラン",
		"tariff_one_year": "1年間プラン",
		"tariff_one_week": "1週間のプラン",
		"tariff_three_day": "3日間プラン",
		"tariff_per_year": "毎年",
		"tariff_per_day": "1日あたり",
		"tariff_per_days": "3日ごとに",
		"tariff_per_week": "毎週",
		"tariff_week": "週",
		"tariff_annual": "年間プラン",
		"tariff_trial_one_week": "1週間のトライアル",
		"tariff_after": "後ろ ",
		"tariff_save": "保存",
		"tariff_best_offer": "最高のオファー",
		"tariff_most_popular": "最も人気のある",
		"tariff_limited_promo": "限定プロモーション価格",
		"tariff_6_for_3": "6個で3個の価格",
		"tariff_first_month": "最初の月",
		"tariff_first_week": "最初の週",
		"tariff_monthly": "毎月",
		"tariff_quaterly": "四半期ごとの",
		"tariff_semiannually": "半年ごとに",
		"tariff_billed_every ": "毎回請求される ",
		"tariff_year": "年",
		"tariff_month": "月",
		"tariff_months": "ヶ月",
		"tariff_months_variable": "月",
		"tariff_organic_gift": "瞑想プラン",
		"tariff_full_price": "定価",
		"tariff_no_hidden_fees": "隠れた料金はありません",
		"tariff_start_right_now": "今すぐ始めてください",
		"tariff_more_than": "Vervファミリーのアクティブメンバーは100万人以上",
		"tariff_intro_offer": "初回限定オファー",
		"Тарифы плиткой в ряд": "",
		"": "",
		"Checkout": "",
		"checkout_title": "支払い方法を選択",
		"insufficient_funds": "資金不足",
		"insufficient_we_have": "私たちは持っています",
		"insufficient_special_price": "特別価格",
		"insufficient_for_you": "あなたのために",
		"checkout_edit_card": "カードを編集",
		"checkout_pay_via": "で支払う",
		"checkout_paypal": "PayPal",
		"checkout_credit_card": "クレジットカード",
		"checkout_paypal_description": "お支払いはPayPalを通じて処理されます",
		"checkout_total_price": "合計金額",
		"checkout_warning_1": "中断を避けるために、選択したサブスクリプションが次の更新期間に自動的に延長されることに同意します。",
		"checkout_warning_2": "そして、割引されていない通常価格で",
		"checkout_warning_3": "詳細については、私たちのサイトをご覧ください",
		"spv2_warning": "中断を避けるために、選択したサブスクリプションは自動的に次の更新期間 __________ および _________ の通常価格で更新されることに同意します。詳しくは、当社の<a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">利用規約</a>をご覧ください。",
		"checkout_offer_day_for": "日のための",
		"checkout_offer_days_for": "日のための",
		"checkout_offer_month_for": "月のための",
		"checkout_offer_months_for": "ヶ月のための",
		"checkout_offer_week_for": "週間の",
		"Values": "",
		"value_kg": "kg",
		"value_pounds": "ポンド",
		"value_st": "st",
		"value_g": "g",
		"value_kcal": "kcal",
		"value_min": "分",
		"value_min_cooking": "調理分",
		"welcome_title": "Verv Premiumへようこそ！",
		"item_1_title": "やった！",
		"item_1_description": "__weight__ の目標体重がもうすぐそこです。",
		"item_2_title": "アクティブ化する方法",
		"item_2_description": "以下のリンクを使用してアプリをダウンロードし、メール __mail__ を使用し、この検証コードを入力してください: __code__。",
		"item_2_description_2": "メールアドレスを変更するには、<button id=\"changeMail\">ここ</button>をクリックしてください。",
		"item_3_title": "何かがうまくいかなかった？",
		"item_3_description": "詳細な指示があなたのメールに送信されました。受け取っていない場合は、<a target=\"_blank\" href=\"mailto:support@verv.com?subject=ログインの問題 (simple-login)\">サポート</a>に連絡してください。",
		"change": "確認する",
		"change_mail": "ここでメールアドレスを変更してプレミアムを有効にします",
		"email_warning": "有効なメールアドレスを入力してください",
		"Promo Code Block": "",
		"promo_code_title": "プロモコードが適用されました！",
		"promo_code_save": "% 割引",
		"EveryDoggy": "",
		"dog_courses": "犬のコース",
		"why_we_best_active": "アクティブユーザー。",
		"why_we_best_lessons": "ビデオレッスン。",
		"why_we_best_brain": "脳のゲーム。",
		"why_we_best": "なぜ私たちが最高なのか？",
		"why_we_best_join": "私たちの犬の飼い主コミュニティに参加して、EveryDoggyと一緒に全力を尽くしましょう。",
		"why_we_best_enjoy": "あなたとあなたの犬の目標に合わせたパーソナライズされたトレーニングプランをお楽しみください。",
		"why_we_best_keep": "70以上の脳トレゲームで犬を心身ともにアクティブに保ちましょう。",
		"dog_problems": "行動問題に対する迅速な解決策",
		"dog_problems_choose": "改善したい望ましくない行動を選択してください",
		"dog_problems_leash": "リード<br/>引っ張り",
		"dog_problems_biting": "噛む",
		"dog_problems_anxiety": "分離不安<br/>",
		"dog_problems_chewing": "破壊的な<br/>咀嚼",
		"dog_plan": "パーソナライズされたトレーニングプラン",
		"dog_plan_our": "私たちのトレーニングプログラムは、あなたの犬のニーズに100％合わせて作られています。",
		"dog_reviews": "犬の親がEveryDoggyについて言うこと",
		"dog_reviews_text_1": "「とても明確でわかりやすいレッスンです。私の子犬はトレーニングが好きで、私たちは両方ともたくさんのことを学びました。」",
		"dog_reviews_name_1": "メーガンとレオ",
		"dog_reviews_text_2": "「ゼン」コマンドは素晴らしいです。それのおかげで、私の犬は獣医クリニックでの処置中、超落ち着いています。",
		"dog_reviews_name_2": "リンダ・B.",
		"dog_reviews_text_3": "「クリックトレーニングのレッスンをありがとう。とても人気があると聞いていますが、どう使うかは不明でした。私はすぐに犬にクリックを紹介し、今、私たちはトリックを学び始めました。」",
		"dog_reviews_name_3": "ジェイク・L.",
		"join_text": "幸せな犬の育て方はEveryDoggyから始まります",
		"join_courses": "ウェブコースに参加する",
		"checkout_introductory": "初回入会特典割引",
		"checkout_personalized_plan": "あなたのパーソナライズされたプラン",
		"Personal plan": "",
		"goal_lose_weight": "効果的な減量プログラムで、ガイド付きワークアウト、栄養トラッカー、さまざまなアクティビティが用意されています",
		"goal_gain_muscles": "効果的な全身トーニングプログラム、ガイド付きワークアウト、栄養追跡機能、さまざまなアクティビティを提供します",
		"goal_gain_healthier_life": "全身を使ったガイド付きの健康的なルーチン、栄養トラッカー、さまざまなアクティビティをご用意しています",
		"goal_gain_flexibility": "フレキシビリティのためのヨガプログラム、ガイド付きセッションと穏やかな音楽、栄養トラッカー、さまざまなアクティビティを提供します。",
		"goal_gain_build_endurance": "ガイド付きワークアウト、栄養トラッカー、さまざまなアクティビティを提供する持久力トレーニングプログラム",
		"goal_love_myself": "自尊心を高めるためのさまざまなアクティビティ、ガイド付き瞑想、ヨガセッション、全身ワークアウト",
		"body_type_apple": "リンゴ型の体に合わせたエクササイズで、コアをトーンアップし、ウエストをスリムにします。",
		"body_type_pear": "洋なし型の体のための運動、ヒップと太ももを引き締める",
		"body_type_square": "ウエストを定義し、グルーツを鍛えるための四角形の体型向けのエクササイズ",
		"body_type_hourglass": "驚くべき結果を得るための砂時計型の体のためのエクササイズ",
		"body_type_triangle": "逆三角形の体型を強化するためのエクササイズで、あなたの hips と thighs を鍛えます",
		"body_type_unknown": "体型を引き出すためのエクササイズ",
		"excercises_time_morning": "朝のワークアウトであなたの代謝を促進し、一日中エネルギーを与えます",
		"excercises_time_day": "あなたのスケジュールに完璧にフィットし、代謝を促進し、一日中エネルギーを保つワークアウト。",
		"excercises_time_evening": "長い一日の後にストレスを和らげ、良い睡眠のための準備をするための夜のワークアウト。",
		"excercises_not_sure": "あなたのスケジュールに完璧にフィットし、代謝を促進し、一日中エネルギーを保つワークアウト",
		"diet_type_all": "簡単な健康レシピ",
		"diet_type_vegetarian": "健康的ベジタリアンレシピ",
		"diet_type_vegan": "健康的なビーガンレシピ",
		"diet_type_keto": "健康的ケトレシピ",
		"personal_plan_providers_title": "",
		"special_features_title": "あなたのための特別な機能",
		"special_features_duration_minimum": "10分未満のクイックセッション",
		"special_features_duration_normal": "20分以内の便利なセッション",
		"special_features_duration_maximum": "20分以上の効果的なセッション",
		"special_features_duration_verv": "私たちのコーチによる便利なセッション",
		"special_features_goal_lose_weight": "専門家からの秘密の減量ヒント",
		"special_features_goal_gain": "専門家からの秘密の筋肉トレーニングのヒント",
		"special_features_goal_health": "専門家からの秘密の健康ヒント",
		"special_features_goal_flexibility": "専門家からの秘密の柔軟性のヒント",
		"special_features_goal_endurance": "持久力を高めるための秘密のヒント",
		"special_features_goal_love": "自尊心を高めるための秘密のコツ",
		"discount_activated": "50％の割引が有効になりました",
		"discount_no_activated": "50%割引",
		"unlocked_with_promo": "プロモーションコードでアンロック：",
		"use_with_button": "特別なプロモーションコードを使用してください：",
		"plan_optimal": "最適",
		"plan_standard": "標準",
		"plan_basic": "基本",
		"plan_extra": "エクストラ",
		"daypayback_review_name_1": "メリーベス",
		"daypayback_review_text_1": "",
		"daypayback_review_name_2": "katie_zu13",
		"daypayback_review_text_2": "Vervが大好きです！私の個人的なトレーニングと食事プランに従うことで、体型を戻し、自信を取り戻すことができました！私のような初心者にぴったりの15分未満の短いフィットネスワークアウトから始めました。その後、持久力を高め、トレーニング時間は1セッションあたり30-40分に増えました。Vervのおかげで6か月で25ポンドをゆっくり確実に減らしました！",
		"daypayback_review_name_3": "Jean_leon1",
		"daypayback_review_text_3": "大学の間に体重が増えました。卒業後、いくつかのダイエットを試しましたが、その体重はいつもダイエットが終わった数ヶ月後には戻ってきてしまいました。昨年、同僚からVervのことを聞き、試してみることにしました。Vervのパーソナライズされた推奨により、私は体重を減らすことができ、その後も維持することができました！",
		"daypayback_review_name_4": "maryanne1993",
		"daypayback_review_text_4": "辛い別れの後、私は人生を変え、体重を減らし、健康になろうと決意しました。しかし、どこから始めていいかわかりませんでした。他の人と一緒に運動する自信がなかったので、家でのワークアウトアプリを試すことに決め、Vervが検索で見つかりました。私のニーズに合わせたプランを提供してくれました。私はそれに従い、夢の体を手に入れることができました！",
		"personal_plan_you_get": "あなたのパーソナライズされたプランで得られるものは",
		"goal": "目標",
		"goal_other": "あなたの毛むくじゃらの友達を訓練するためのレッスン",
		"goal_teaching_puppy": "毛むくじゃらの友達にマナーと服従を教えるレッスン",
		"goal_surviving_puppy": "あなたの毛むくじゃらの友達との最初の日々のために準備するのを助けるレッスン",
		"goal_socializing_puppy": "毛むくじゃらの友達を社交させるためのレッスン",
		"goal_teaching_obedience": "あなたの毛むくじゃらの友達にマナーと服従を教えるレッスン",
		"age_puppy": "私たちの専門家からの詳細なトレーニングのヒントで、幸せでお行儀の良い子犬を育てる手助けをします",
		"age_adult": "私たちの専門家からの詳細なトレーニングのヒントで、あなたの犬を最も効果的に訓練するのを手助けします",
		"biting_yes": "犬が噛むのを止めるためのステップバイステップの指示",
		"biting_no": "犬と遊ぶための楽しいゲーム",
		"biting_sometimes": "犬の噛みつきを止めるためのステップバイステップの指示",
		"quick_tips": "新しいコマンドを学ぶための簡単なヒント",
		"potty_training_a_bit": "子犬を効果的にトイレトレーニングするための特別なガイド",
		"potty_training_yes": "子犬に新しい楽しいトリックを教えるための特別なガイド",
		"potty_training_no": "子犬を効果的にトイレトレーニングするための特別なガイド",
		"success screen": "",
		"success_screen_text_1": "ご購入ありがとうございます！",
		"success_screen_text_2": "以下の指示に従って<br />アカウントを設定してください：",
		"success_screen_text_3": "あなたの<b>アカウント</b>に行く",
		"success_screen_text_4": "<b>QRコード</b>をスキャンするか、<b>リンク</b>をタップしてください",
		"success_screen_text_5": "<b>アプリを</b>ダウンロード",
		"success_screen_text_6": "<b>アプリを開いて</b>、<b>楽しんでください</b><br />あなたの犬とのトレーニングを！",
		"success_screen_text_7": "QRコードとリンクをあなたのために重複させました &nbsp;<b>example@gmail.com</b>",
		"success_screen_text_8": "アプリでプレミアムアカウントが適用されていない場合は、ウェルカム画面の<b>「お問い合わせ」</b>をタップしてサポートチームに連絡してください。",
		"success_screen_text_9": "「始める」ボタンを押すことで、私は<a href=\"https://everydoggy.com/policy/\" target=\"_blank\">プライバシーポリシー</a>および<a href=\"https://everydoggy.com/terms/\" target=\"_blank\">利用規約</a>について確認し、受け入れることを確認し、私の個人データの処理に同意します。",
		"success_screen_text_10": "お問い合わせ",
		"success_screen_text_11": "マイアカウントに移動",
		"success_screen_text_12": "重複したQRコードとリンクをメールでお送りしました。",
		"success_screen_text_13": "PDFガイドはあなたのメールアドレス<b>v.stsiopina@gmail.com</b>に送信されました。",
		"success_screen_text_14": "あなたのPDFガイドはあなたのメールに送信されました。",
		"success_screen_text_15": "アプリでプレミアムアカウントが適用されていない場合、アプリのウェルカム画面で<span>'ログイン'</span>リンクを押し、<b>stepinavalerie@gmail.com</b>に送信したメールアドレスとパスワードを入力してください。",
		"success_screen_text_16": "プレミアムアカウントがアプリに適用されていない場合は、アプリのウェルカム画面で<span>'ログイン'</span>リンクを押し、私たちがメールで送信したメールアドレスとパスワードを入力してください。",
		"payment_text_1": "あなたの犬のトレーニングプログラムは今始まります！",
		"payment_text_2": "Everydoggyアプリは、あなたの犬の行動問題を<span>素早く楽しく解決する</span>のを助けます。",
		"payment_text_3": "個別オファーは期限切れになります",
		"payment_text_4": "私たちのユーザーは、専門家とのトレーニングを始めてわずか1週間後に犬の行動にポジティブな変化に気づきます",
		"payment_text_5": "すべての犬 vs コーチ",
		"payment_text_6": "月あたりの平均コマンド数",
		"payment_text_7": "すべての犬が恩恵を受ける",
		"payment_text_8": "パーソナライズされた犬のトレーニングプラン",
		"payment_text_9": "完璧なペットのために、1日たった15分",
		"payment_text_10": "70以上のわかりやすいビデオトレーニングレッスンで迅速な結果を得る",
		"payment_text_11": "80以上のゲームとトリック、新しいスキルや楽しみのために",
		"payment_text_12": "衛生、健康、栄養に関するヒント",
		"payment_text_13": "自宅や屋外でトレーニング、器具は不要です",
		"payment_text_14": "私たちのユーザーの98％が、専門家とのトレーニングを始めてから1週間で、犬の行動にポジティブな変化を感じると答えています。",
		"payment_text_14_2": "<span>私たちのユーザーの98%</span>は、専門家とのトレーニングを開始して1週間後に犬の行動にポジティブな変化が見られると感じています",
		"payment_text_15": "「プランを取得」ボタンをクリックすると、私たちの<a href='https://everydoggy.com/terms/' target=\"_blank\" >利用規約</a>および<a href='https://everydoggy.com/policy/' target=\"_blank\" >プライバシーポリシー</a>に同意し、<b>サブスクリプションの自動更新を許可</b>します。各請求周期の終了時に<span>1か月</span>ごとに<i>$29.99</i>の全額と適用される税金がかかります。更新日の前にいつでもサブスクリプションの自動更新をキャンセルできます。詳細については、私たちの<a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >キャンセル規約</a>をご覧ください。",
		"payment_text_16": "「プランを取得する」ボタンをクリックすることで、当社の<a href='https://everydoggy.com/terms/' target='_blank'>利用規約</a>と<a href='https://everydoggy.com/policy/' target='_blank'>プライバシーポリシー</a>に同意し、<b>サブスクリプションの自動更新を承認</b>します。各請求周期の終了時に<input>1ヶ月</span>で<i>$29.99</i>の全額の価格に加え、適用される税金がかかります。更新日より前にサブスクリプションの自動更新をいつでもキャンセルできます。詳細については<a href='https://everydoggy.com/subscription-terms/' target='_blank'>キャンセル条件</a>をご確認ください。",
		"payment_text_17": "質問がありますか？",
		"payment_text_18": "私たちに次のアドレスで書いてください ",
		"payment_text_19": "動作します！",
		"payment_text_20": "子犬との服従訓練プログラムが終わったばかりです。好きです！ 👏",
		"payment_text_21": "素晴らしい！",
		"payment_text_22": "",
		"payment_text_23": "",
		"payment_text_24": "",
		"payment_text_25": "",
		"payment_text_26": "",
		"payment_text_27": "",
		"payment_text_28": "",
		"payment_text_29": "",
		"payment_text_30": "",
		"payment_text_31": "",
		"payment_text_32": "",
		"payment_text_33": "",
		"payment_text_34": "",
		"payment_text_35": "",
		"payment_text_36": "",
		"payment_text_37": "",
		"payment_text_38": "",
		"payment_text_39": "",
		"payment_text_40": "",
		"payment_text_41": "",
		"payment_text_42": "",
		"payment_text_43": "",
		"payment_text_44": "",
		"payment_text_45": "",
		"payment_text_46": "",
		"payment_text_47": "",
		"payment_text_48": "",
		"payment_text_49": "",
		"payment_text_50": "",
		"payment_text_51": "",
		"payment_text_52": "",
		"payment_text_53": "",
		"payment_text_54": "",
		"payment_text_55": "",
		"payment_text_56": "",
		"payment_text_57": "",
		"payment_text_58": "",
		"payment_text_59": "",
		"payment_text_60": "",
		"payment_text_61": "",
		"payment_text_62": "",
		"payment_text_63": "",
		"payment_text_64": "",
		"payment_text_65": "",
		"payment_text_66": "",
		"payment_text_67": "",
		"payment_text_68": "",
		"payment_text_69": "",
		"payment_text_70": "",
		"payment_text_71": "",
		"payment_text_72": "",
		"payment_text_73": "",
		"payment_text_74": "",
		"payment_text_75": "",
		"payment_text_76": "",
		"payment_text_77": "",
		"payment_text_78": "",
		"payment_text_79": "",
		"payment_text_80": "",
		"payment_text_81": "",
		"payment_text_82": "You will only be charged <b>$6.99</b> today for your first week (details below)",
		"payment_text_83": "Your introductory period will last until <b>Oct 11, 2024</b>.",
		"payment_text_84": "You may cancel at any time before <b>Oct 10, 2024</b>, and you will not be charged.",
		"payment_text_85": "If you don’t cancel, Everydoggy will automatically continue your membership at the end of your introductory period and charge the membership fee (currently <b>$39.99 USD</b>) monthly until you cancel.",
		"payment_text_86": "No partial refunds. You can cancel your subscription anytime in your Account.",
		"payment_text_87": "Your subscription will be bound by our <a href='https://everydoggy.com/terms/' target=\"_blank\" >Terms and Conditions</a>, <a href='https://everydoggy.com/policy/' target=\"_blank\" >Privacy Policy</a> and <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Cancellation Terms</a>.",
		"payment_text_88": "Payment method",
		"payment_text_89": "EveryDoggy will use your payment details for seamless future payments",
		"payment_text_90": "Easy and private payments with Face/Touch ID",
		"payment_text_91": "Keeps your financial info safe with end-to-end encryption",
		"payment_text_92": "Protected by Apple Pay’s unique Device Account Number",
		"payment_text_93": "Your payment information is secure with SSL/TLS encryption",
		"payment_text_94": "Fast, convenient payment option",
		"payment_text_95": "Backed by PayPal’s industry-leading fraud protection",
		"payment_text_96": "Confirm purchase",
		"payment_text_97": "1-WEEK",
		"payment_text_98": "1-MONTH",
		"payment_text_99": "3-MONTH",
		"payment_text_100": "You will only be charged <b>$6.99</b> today for your first month (details below)",
		"payment_text_101": "You will only be charged <b>$6.99</b> today for your first 3 months (details below)",
		"payment_text_102": "Subscribe with",
		"payment_text_103": "By clicking ‘Get my plan’ button you agree with the  <a href='https://everydoggy.com/policy/' target=\"_blank\" >Privacy Policy</a>,  <a href='https://everydoggy.com/terms/' target=\"_blank\" >Terms and Conditions</a> and <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Cancellation Terms</a>",
		"payment_text_104": "Easy and private payments",
		"payment_text_105": "Credit Card",
		"payment_text_106": "Expiry date",
		"payment_text_107": "CVC",
		"payment_text_108": "",
		"payment_text_109": "",
		"payment_text_110": "",
		"payment_text_111": "",
		"payment_text_112": "",
		"payment_text_113": "",
		"payment_text_114": "",
		"payment_text_115": "",
		"payment_text_116": "",
		"payment_text_117": "",
		"payment_text_118": "",
		"payment_text_119": "",
		"payment_text_120": "",
		"payment_text_121": "",
		"payment_text_122": "",
		"payment_text_123": "",
		"payment_text_124": "",
		"payment_text_125": "",
		"payment_text_126": "",
		"payment_text_127": "",
		"payment_text_128": "",
		"payment_text_129": "",
		"payment_text_130": "",
		"payment_text_131": "",
		"payment_text_132": "",
		"payment_text_133": "",
		"payment_text_134": "",
		"payment_text_135": "",
		"payment_text_136": "",
		"payment_text_137": "",
		"payment_text_138": "",
		"payment_text_139": "",
		"payment_text_140": "",
		"payment_text_141": "Your Dog Training Plan is ready!",
		"payment_text_142": "Obedience",
		"payment_text_143": "Knows Commands",
		"payment_text_144": "Toilet Accidents",
		"payment_text_145": "Frequent",
		"payment_text_146": "None",
		"payment_text_147": "Barking",
		"payment_text_148": "Barks at everything",
		"payment_text_149": "Quiet & Relaxed",
		"payment_text_150": "Biting & chewing",
		"payment_text_151": "Often",
		"payment_text_152": "Stopped",
		"payment_text_153": "Pulling the leash",
		"payment_text_154": "Always",
		"payment_text_155": "Walks calmly",
		"payment_text_156": "Anxiety When Left Alone",
		"payment_text_157": "Calm and independent",
		"payment_text_158": "Before",
		"payment_text_159": "After",
		"payment_text_160": "minutes",
		"payment_text_161": "seconds",
		"payment_text_162": "Proven. Tested. It Works",
		"payment_text_163": "Significant changes in a dog’s obedience",
		"payment_text_164": "Today",
		"payment_text_165": "Week 2",
		"payment_text_166": "Week 3",
		"payment_text_167": "Week 4",
		"payment_text_168": "What makes Everydoggy so effective",
		"payment_text_169": "Our users' success stories",
		"payment_text_170": "Crafted by Experts Who <span>Love Dogs</span>",
		"payment_text_171": "Every our course and lesson is grounded in scientific studies of dog training.",
		"payment_text_172": "Build a strong bond with your dog, try EveryDoggy!",
		"payment_text_173": "Proven. Tested. It Works",
		"payment_text_174": "<span>93% of our users</span> notice significant changes in their dog’s behavior within the first month of training.",
		"payment_text_175": "With EveryDoggy",
		"payment_text_176": "Without EveryDoggy",
		"payment_text_177": "Today",
		"payment_text_178": "Week 15",
		"payment_text_179": "Week 17",
		"payment_text_180": "Week 19",
		"payment_text_181": "About Luna",
		"payment_text_182": "My puppy kept having accidents in the house. Everydoggy gave us a clear routine, and it actually worked!",
		"payment_text_183": "About Cooper",
		"payment_text_184": "Our pup used to nip at everyone during playtime. The app gave us step-by-step guidance, and it worked!",
		"payment_text_185": "About Bella",
		"payment_text_186": "Our dog chewed everything – from shoes to the couch. The app helped us redirect that energy!",
		"payment_text_187": "About Charlie",
		"payment_text_188": "Leash pulling was a daily struggle. Thanks to the app, walks are now enjoyable and stress-free.",
		"payment_text_189": "Potty trained",
		"payment_text_190": "Solved biting",
		"payment_text_191": "Chewing solved",
		"payment_text_192": "Leash pulling solved",
		"payment_text_193": "",
		"payment_text_194": "",
		"payment_text_195": "",
		"payment_text_196": "",
		"payment_text_197": "",
		"payment_text_198": "",
		"payment_text_199": "",
		"payment_text_200": "",
		"payment_text_201": "",
		"payment_text_202": "",
		"payment_text_203": "",
		"payment_text_204": "",
		"payment_text_205": "",
		"payment_text_206": "",
		"payment_text_207": "",
		"payment_text_208": "",
		"payment_text_209": "",
		"payment_text_210": "",
		"payment_text_211": "",
		"payment_text_212": "",
		"payment_text_213": "",
		"payment_text_214": "",
		"payment_text_215": "",
		"payment_text_216": "",
		"payment_text_217": "",
		"payment_text_218": "",
		"payment_text_219": "",
		"payment_text_220": "",
		"payment_text_221": "",
		"payment_text_222": "",
		"payment_text_223": "",
		"payment_text_224": "",
		"payment_text_225": "",
		"payment_text_226": "ラストチャンス！",
		"payment_text_227": "",
		"payment_text_228": "",
		"payment_text_229": "",
		"payment_text_230": "",
		"payment_text_231": "",
		"payment_text_232": "",
		"payment_text_233": "",
		"payment_text_234": "",
		"payment_text_235": "",
		"payment_text_236": "",
		"payment_text_237": "",
		"payment_text_238": "",
		"payment_text_239": "",
		"payment_text_240": "",
		"payment_text_241": "",
		"payment_text_242": "",
		"payment_text_243": "",
		"payment_text_244": "",
		"payment_text_245": "",
		"payment_text_246": "",
		"payment_text_247": "",
		"payment_text_248": "",
		"payment_text_249": "",
		"payment_text_250": "",
		"payment_text_251": "",
		"payment_text_252": "",
		"payment_text_253": "",
		"payment_text_254": "",
		"payment_text_255": "",
		"payment_text_256": "",
		"payment_text_257": "",
		"payment_text_258": "",
		"payment_text_259": "",
		"payment_text_260": "",
		"payment_text_261": "",
		"payment_text_262": "",
		"payment_text_263": "犬語翻訳",
		"payment_text_264": "愛犬を理解しましょう。<br/> 結果を見てみましょう",
		"payment_text_265": "しぐさや行動の分析で、しつけはもっと良くなります",
		"payment_text_266": "愛犬の吠え声や行動の分析に基づく、パーソナライズされたトレーニングプラン",
		"payment_text_267": "しつけは2倍速く、<br />楽しさは2倍に！",
		"payment_text_268": "究極の子犬トレーニングガイドを手に入れましょう",
		"payment_text_269": "究極の犬のトレーニングガイドを手に入れましょう",
		"payment_text_270": "トイレの失敗にさようなら！ステップごとの方法で、正しいトイレ習慣をすばやく身につけさせましょう。",
		"payment_text_271": "靴も指も守りましょう！簡単な方法で、子犬の甘噛みや何でも噛むクセをやさしく直せます。",
		"payment_text_272": "愛犬のために安心できる快適な空間をつくりながら、クレートで落ち着いて過ごす習慣を教えましょう。",
		"payment_text_273": "行動、服従トレーニング、毎日の暮らしまで、専門家のコツをまとめて学べます。",
		"payment_text_274": "家でもお散歩中でも、わかりやすく実践しやすい方法で困った行動を直しましょう。",
		"payment_text_275": "学ぶ時間をもっと楽しく！ほめ方とごほうびのコツを身につけて、愛犬のやる気をすぐ引き出しましょう。",
		"payment_text_276": "基本だけでは終わりません！大切な安全コマンドから、どの年齢の犬でも楽しめる見映えのするトリックまで学べます。",
		"payment_text_277": "愛犬の<br />成長スピードを <span>2倍に！</span>",
		"payment_text_278": "実践ガイド：",
		"payment_text_279": "メンバー限定 98%OFF",
		"payment_text_280": "メンバー限定 70%OFF",
		"payment_text_281": "",
		"payment_text_282": "",
		"payment_text_283": "",
		"payment_text_284": "",
		"payment_text_285": "",
		"payment_text_286": "",
		"payment_text_287": "",
		"payment_text_288": "",
		"payment_text_289": "",
		"payment_text_290": "",
		"payment_text_291": "",
		"payment_text_292": "",
		"payment_text_293": "",
		"payment_text_294": "",
		"payment_text_295": "",
		"payment_text_296": "",
		"payment_text_297": "",
		"payment_text_298": "",
		"payment_text_299": "",
		"payment_text_300": "",
		"payment_text_301": "",
		"payment_text_302": "",
		"payment_text_303": "",
		"payment_text_304": "",
		"payment_text_305": "",
		"payment_text_306": "",
		"payment_text_307": "",
		"payment_text_308": "",
		"payment_text_309": "",
		"payment_text_310": "",
		"payment_text_311": "",
		"payment_text_312": "",
		"payment_text_313": "",
		"payment_text_314": "",
		"payment_text_315": "",
		"payment_text_316": "",
		"payment_text_317": "",
		"payment_text_318": "",
		"payment_text_319": "",
		"payment_text_320": "",
		"payment_text_321": "",
		"payment_text_322": "",
		"payment_text_323": "",
		"payment_text_324": "",
		"payment_text_325": "",
		"payment_text_326": "",
		"payment_text_327": "",
		"payment_text_328": "",
		"payment_text_329": "",
		"payment_text_330": "",
		"payment_text_331": "",
		"payment_text_332": "",
		"payment_text_333": "",
		"payment_text_334": "",
		"payment_text_335": "",
		"payment_text_336": "",
		"payment_text_337": "",
		"payment_text_338": "",
		"payment_text_339": "",
		"payment_text_340": "",
		"payment_text_341": "",
		"payment_text_342": "",
		"payment_text_343": "",
		"payment_text_344": "",
		"payment_text_345": "",
		"payment_text_346": "",
		"payment_text_347": "",
		"payment_text_348": "",
		"payment_text_349": "",
		"payment_text_350": "",
		"payment_text_351": "",
		"payment_text_352": "",
		"payment_text_353": "",
		"payment_text_354": "",
		"payment_text_355": "",
		"payment_text_356": "",
		"payment_text_357": "",
		"payment_text_358": "",
		"payment_text_359": "",
		"payment_text_360": "",
		"payment_text_361": "",
		"payment_text_362": "",
		"payment_text_363": "",
		"payment_text_364": "",
		"payment_text_365": "",
		"payment_text_366": "",
		"payment_text_367": "",
		"payment_text_368": "",
		"payment_text_369": "",
		"payment_text_370": "",
		"payment_text_371": "",
		"payment_text_372": "",
		"payment_text_373": "",
		"payment_text_374": "",
		"payment_text_375": "",
		"payment_text_376": "",
		"payment_text_377": "",
		"payment_text_378": "",
		"payment_text_379": "",
		"payment_text_380": "",
		"payment_text_381": "",
		"payment_text_382": "",
		"payment_text_383": "",
		"payment_text_384": "",
		"payment_text_385": "",
		"payment_text_386": "",
		"payment_text_387": "",
		"payment_text_388": "",
		"payment_text_389": "",
		"pdfUpselling": "",
		"pdfUpselling_1": "<span>Kickstart your journey to an obedient dog:</span> Grab an ultimate guide to dog raising training",
		"pdfUpselling_2": "<span>Kickstart your journey to an obedient dog:</span> Grab an ultimate guide to puppy raising and training",
		"pdfUpselling_3": "Get your <span>personal plan</span>",
		"pdfUpselling_4": "Unlock the <span>practical guide</span>",
		"pdfUpselling_5": "Behavior correction (indoors & outdoors)",
		"pdfUpselling_6": "How to praise and reward your dog",
		"pdfUpselling_7": "Various commands",
		"pdfUpselling_8": "Enrichment games & much more",
		"pdfUpselling_9": "Potty training",
		"pdfUpselling_10": "Stop biting & chewing",
		"pdfUpselling_11": "Crate training",
		"pdfUpselling_12": "Plus 43 other helpful tips and solutions",
		"pdfUpselling_13": "Total today",
		"pdfUpselling_14": "Unlock guide",
		"pdfUpselling_15": "Unlock with",
		"pdfUpselling_16": "Continue without guide",
		"chatUpsale_1": "",
		"chatUpsale_2": "",
		"chatUpsale_3": "",
		"chatUpsale_4": "",
		"chatUpsale_5": "",
		"chatUpsale_6": "",
		"chatUpsale_7": "",
		"chatUpsale_8": "",
		"chatUpsale_9": "",
		"chatUpsale_10": "",
		"chatUpsale_11": "",
		"chatUpsale_12": "",
		"chatUpsale_13": "",
		"chatUpsale_14": "",
		"chatUpsale_15": "",
		"checkoutV2_text1": "",
		"checkoutV2_text2": "",
		"checkoutV2_text3": "",
		"checkoutV2_text4": "",
		"checkoutV2_text5": "",
		"checkoutV2_text6": "",
		"checkoutV2_text7": "",
		"checkoutV2_text8": "",
		"checkoutV2_text9": "",
		"checkoutV2_text10": "",
		"checkoutV2_text11": "",
		"error_1": "",
		"error_2": "",
		"error_3": "",
		"error_4": "",
		"error_5": "",
		"error_6": "",
		"error_7": "",
		"error_8": "",
		"error_9": "",
		"error_10": "",
		"disclaimerV2_text_1": "",
		"disclaimerV2_text_2": "",
		"disclaimerV2_text_3": "",
		"chatUpsaleV2_1": "",
		"chatUpsaleV2_2": "",
		"chatUpsaleV2_3": "",
		"chatUpsaleV2_4": "",
		"chatUpsaleV2_5": "",
		"chatUpsaleV2_6": "",
		"chatUpsaleV2_7": "",
		"chatUpsaleV2_8": "",
		"chatUpsaleV2_9": "",
		"chatUpsaleV2_10": "",
		"chatUpsaleV2_11": "",
		"chatUpsaleV2_12": "",
		"chatUpsaleV2_13": "",
		"chatUpsaleV2_14": "",
		"chatUpsaleV2_15": "",
		"chatUpsaleV2_16": "",
		"chatUpsaleV2_17": "",
		"chatUpsaleV2_18": "",
		"chatUpsaleV2_19": "",
		"chatUpsaleV2_20": "",
		"chatUpsaleV2_21": "",
		"chatUpsaleV2_22": "",
		"chatUpsaleV2_23": "",
		"chatUpsaleV2_24": "",
		"chatUpsaleV2_25": "",
		"chatUpsaleV2_26": "",
		"chatUpsaleV2_27": "",
		"chatUpsaleV2_28": "",
		"chatUpsaleV2_29": "",
		"chatUpsaleV2_30": "",
		"chatUpsaleV2_31": "",
		"chatUpsaleV2_32": "",
		"chatUpsaleV2_33": ""
	},
	"ko": {
		"global \ninstruction": "",
		"safe": "귀하의 정보는 안전합니다",
		"information": "우리는 귀하의 개인 연락처 정보를 어떤 마케팅 목적에도 판매하거나 임대하지 않습니다.",
		"secure_checkout": "안전한 체크아웃",
		"encrypted": "모든 정보는 암호화되어 위험 없이 보안 소켓 계층(SSL) 프로토콜을 사용하여 전송됩니다.",
		"help": "도움이 필요하신가요?",
		"contact": "문의하기",
		"here": "여기.",
		"undefined": "",
		"featured": "소개된",
		"main_title": "개 훈련 과정",
		"per_year": "매년",
		"special_offer": "특별 제안",
		"card_number": "카드 번호",
		"card_expiry": "카드가 만료됩니다",
		"security_number": "보안 번호",
		"email": "이메일",
		"To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of __period__ and at the full, not discounted, price of __fullPriceText__ To learn more visit our <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">terms of use</a>.": "결제 정보",
		"secure_server": "보안 서버",
		"pay": "지불하다",
		"enter_your_email": "이메일을 입력하세요",
		"comment_1": "몇 년간의 스트레스가 많은 시간 동안 나는 완전히 몸매를 잃고 약간의 지방이 쪘지만, 그것에 대해 조치를 취할 시간이나 동기가 전혀 없었습니다. 가족 구성원이 Verv를 추천해 주었고 이제 매일 제 코치에게 의존하고 있습니다!",
		"comment_2": "Verv는 저에게 집에서 운동하는 즐거움을 주었고 한 달 만에 7kg를 감량했습니다. 이 앱은 저와 같은 초보자에게 운동과 체중 감량에 정말 도움이 될 수 있습니다.",
		"success_story": "성공 사례",
		"get_my_plan": "내 계획 가져오기",
		"delimiter": "또는",
		"pay_buy_card": "카드로 결제하기",
		"get_my_plan_warning_1": "중단을 피하기 위해 선택한 구독이 자동으로 다음 갱신 기간으로 연장된다는 것에 동의합니다",
		"get_my_plan_warning_2": "그리고 할인되지 않은 정가로",
		"get_my_plan_warning_3": "자세한 내용을 보려면 방문하십시오",
		"get_my_plan_warning_text": "계속하면 첫 번째 갱신 기간 종료 24시간 이전에 취소하지 않을 경우 __fullPriceText__가 매 __period__마다 자동으로 청구됨에 동의하는 것입니다.",
		"terms_of_use": "이용 약관",
		"privacy_policy": "개인정보 보호정책",
		"terms_conditions": "약관",
		"privacy_policy_footer": "개인정보 처리방침",
		"terms_conditions_footer": "약관",
		"guaranteed": "보장된 안전한 결제",
		"special_features": "당신을 위한 특별한 기능",
		"calories_value": "kcal",
		"personalized_plan": "개인화된 계획을 받으세요:",
		"mobile_app": "당신의 플랜이 포함된 모바일 앱",
		"daily_programs": "다양한 목표를 위한 일일 프로그램 (지방 태우기, 스트레스 감소, 근육 증가)",
		"audio_guided": "오디오 가이드 운동",
		"easy_to_cook": "조리하기 쉽고 맛있는 요리",
		"comprehensive_stats": "포괄적인 통계",
		"secret_tips": "건강한 습관을 기르는 비밀 팁",
		"mobile_app_tailor": "당신의 주머니에 맞춤형 계획",
		"daily_programs_for": "일일 프로그램",
		"daily_programs_for_2": "다양한 목표를 위해 (지방 연소, 스트레스 감소, 근육 증가)",
		"audio_trainers": "전문 트레이너 가이드",
		"comprehensive_track": "궁극적인 통계로 진행 상황을 추적하세요",
		"price": "가격",
		"users_love": "사용자들은 우리의 개인화된 플랜을 좋아합니다",
		"alternative_review_name_1": "Therealtierra",
		"alternative_review_title_1": "정말 좋은 앱입니다!",
		"alternative_review_contentent_1": "나는 9주째이고 내 몸은 엄청나게 변했습니다!",
		"alternative_review_name_2": "테니스 소녀",
		"alternative_review_title_2": "작동합니다!",
		"alternative_review_contentent_2": "프로그램을 막 끝냈습니다. 정말 좋아요. 15kg 감량했어요!!",
		"you_re_in": "당신은 참가했습니다!",
		"personal_plan_starts": "당신의 Verv 개인 계획이 오늘 시작되며 시간이 흐르고 있습니다. 확인해 보세요!",
		"app_by_link": "프로그램에 들어가려면 링크를 통해 앱을 다운로드하세요",
		"download_now": "지금 다운로드",
		"or": "또는",
		"price_after_trial": "체험 후 가격",
		"seven_days_trial_unlocked": "7일 무료 체험이 잠금 해제되었습니다",
		"total_today": "오늘 총계",
		"reserved_price_for": "예약 가격은",
		"new_subscritions1_title": "플랜을 선택하세요",
		"new_subscritions1_subscription1_line1": "반기 계획",
		"new_subscritions1_subscription1_price1_time": "주마다",
		"new_subscritions1_subscription2_line1": "3개월 계획",
		"new_subscritions1_subscription2_price2_time": "주마다",
		"new_subscritions1_subscription3_line1": "1개월 계획",
		"new_subscritions1_subscription3_price3_time": "주마다",
		"new_subscription_save": "저장",
		"new_subscritions_agreement": "계속하면 귀하는 동의하는 것입니다",
		"new_subscritions_and": "그리고",
		"new_subscritions_subtitle": "우리 사용자들은 1000만 파운드를 잃었습니다",
		"new_subscritions_join": "수백만 명의 행복한 사용자와 함께하세요",
		"statistic_block_item1_text": "5점 만점의 별",
		"statistic_block_item2_text": "5성급 평가",
		"statistic_block_item3_text": "다운로드",
		"get_your_personalized_plan": "맞춤형 계획을 받으세요",
		"for": "에 대한",
		"new_subscription_save_mostPopular1MonthPrice": "가장 인기 있는 계획",
		"timer_additional_discount": "추가 할인 적용되었습니다 ",
		"timer_additional_discount_bold": "당신을 위해",
		"timer_offer_expires": "이 제안은 다음 시간 내에 만료됩니다:",
		"Payment Successful": "",
		"payment_successful_title": "Verv 팀에서 인사드립니다!",
		"payment_successful_download": "앱을 다운로드",
		"payment_successful_press": "누르십시오",
		"payment_successful_login": "이메일로 로그인",
		"payment_successful_email": "이메일을 입력하세요",
		"payment_successful_code": "귀하의 확인 코드와:",
		"payment_successful_hit": "그런 다음 탭하세요",
		"payment_successful_done": "완료",
		"payment_successful_description": "들어오셨습니다. 개인화된 훈련 계획을 즐기세요!",
		"Tariffs Variants": "",
		"tariff_title_choose": "플랜을 선택하세요",
		"tariff_title_get": "계획 가져오기",
		"tariff_one_month": "1개월 계획",
		"tariff_three_month": "3개월 계획",
		"tariff_six_month": "6개월 계획",
		"tariff_one_year": "1년 계획",
		"tariff_one_week": "1주 계획",
		"tariff_three_day": "3일 계획",
		"tariff_per_year": "매년",
		"tariff_per_day": "하루에",
		"tariff_per_days": "3일마다",
		"tariff_per_week": "주당",
		"tariff_week": "주",
		"tariff_annual": "연간 계획",
		"tariff_trial_one_week": "1주 무료 체험",
		"tariff_after": "후 ",
		"tariff_save": "저장",
		"tariff_best_offer": "최고의 제안",
		"tariff_most_popular": "가장 인기 있는",
		"tariff_limited_promo": "한정 프로모션 가격",
		"tariff_6_for_3": "3개의 가격에 6개",
		"tariff_first_month": "첫 달",
		"tariff_first_week": "첫 주",
		"tariff_monthly": "매월",
		"tariff_quaterly": "분기별",
		"tariff_semiannually": "반기마다",
		"tariff_billed_every ": "매번 청구됩니다 ",
		"tariff_year": "년",
		"tariff_month": "개월",
		"tariff_months": "개월",
		"tariff_months_variable": "개월",
		"tariff_organic_gift": "명상 계획",
		"tariff_full_price": "정가",
		"tariff_no_hidden_fees": "숨겨진 수수료가 없습니다",
		"tariff_start_right_now": "지금 바로 시작하세요",
		"tariff_more_than": "Verv 가족의 활성 회원이 1,000,000명 이상입니다.",
		"tariff_intro_offer": "인트로 제공",
		"Тарифы плиткой в ряд": "",
		"": "",
		"Checkout": "",
		"checkout_title": "결제 방법을 선택하세요",
		"insufficient_funds": "자금 부족",
		"insufficient_we_have": "우리는 가지고 있습니다",
		"insufficient_special_price": "특별 가격",
		"insufficient_for_you": "당신을 위해",
		"checkout_edit_card": "카드 편집",
		"checkout_pay_via": "를 통해 결제",
		"checkout_paypal": "PayPal",
		"checkout_credit_card": "신용카드",
		"checkout_paypal_description": "귀하의 결제는 PayPal을 통해 처리됩니다",
		"checkout_total_price": "총 가격",
		"checkout_warning_1": "중단을 피하기 위해 선택한 구독이 다음 갱신 기간 동안 자동으로 연장됨에 동의합니다.",
		"checkout_warning_2": "그리고 할인되지 않은 정가로",
		"checkout_warning_3": "자세한 내용을 보려면 저희를 방문하세요",
		"spv2_warning": "중단을 피하기 위해 선택한 구독이 자동으로 __period__의 연장 기간으로 연장되며 __productDetailsAmount__의 정상가로 연장됨에 동의합니다. 자세한 내용은 저희의 <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">이용 약관</a>을 방문해 주십시오.",
		"checkout_offer_day_for": "의 날",
		"checkout_offer_days_for": "일수",
		"checkout_offer_month_for": "월에 대한",
		"checkout_offer_months_for": "개월 동안",
		"checkout_offer_week_for": "주 동안",
		"Values": "",
		"value_kg": "kg",
		"value_pounds": "파운드",
		"value_st": "st",
		"value_g": "g",
		"value_kcal": "kcal",
		"value_min": "분",
		"value_min_cooking": "요리 분",
		"welcome_title": "Verv Premium에 오신 것을 환영합니다!",
		"item_1_title": "우와!",
		"item_1_description": "__weight__의 목표 체중이 이제 눈앞에 있습니다.",
		"item_2_title": "활성화하는 방법",
		"item_2_description": "아래 링크를 사용하여 앱을 다운로드하고 이메일 __mail__을 사용한 후 이 검증 코드를 입력하세요: __code__.",
		"item_2_description_2": "이메일을 변경하려면 <button id=\"changeMail\">여기</button>를 클릭하세요.",
		"item_3_title": "뭔가 잘못됐나요?",
		"item_3_description": "상세한 지침이 귀하의 이메일로 발송되었습니다. 받지 못하셨다면 <a target=\"_blank\" href=\"mailto:support@verv.com?subject=로그인 문제 (simple-login)\">지원팀</a>에 문의하세요.",
		"change": "확인",
		"change_mail": "여기에서 이메일을 변경하여 프리미엄을 활성화하세요",
		"email_warning": "유효한 이메일 주소를 입력해 주세요",
		"Promo Code Block": "",
		"promo_code_title": "프로모션 코드가 적용되었습니다!",
		"promo_code_save": "% 할인",
		"EveryDoggy": "",
		"dog_courses": "개 코스",
		"why_we_best_active": "활성 사용자.",
		"why_we_best_lessons": "비디오 수업.",
		"why_we_best_brain": "두뇌 게임.",
		"why_we_best": "우리가 최고인 이유는 무엇인가요?",
		"why_we_best_join": "우리 개 부모 커뮤니티에 가입하고 EveryDoggy와 함께 최선을 다하세요.",
		"why_we_best_enjoy": "당신과 당신의 반려견의 목표에 맞춘 개인화된 훈련 계획을 즐기세요.",
		"why_we_best_keep": "70개 이상의 두뇌 게임으로 개를 정신적으로 그리고 신체적으로 활동적으로 유지하세요.",
		"dog_problems": "행동 문제에 대한 빠른 해결책",
		"dog_problems_choose": "개선하고 싶은 원치 않는 행동을 선택하세요",
		"dog_problems_leash": "리드줄<br/>당김",
		"dog_problems_biting": "물다",
		"dog_problems_anxiety": "분리 불안<br/>",
		"dog_problems_chewing": "파괴적인<br/>씹기",
		"dog_plan": "개인화된 훈련 계획",
		"dog_plan_our": "우리의 교육 프로그램은 귀하의 개의 요구에 100% 맞춤형입니다.",
		"dog_reviews": "개 보호자들이 EveryDoggy에 대해 말하는 것",
		"dog_reviews_text_1": "«매우 명확하고 따라 하기 쉬운 수업입니다. 내 강아지는 훈련하는 것을 좋아하고 우리는 모두 많은 것을 배웠습니다.»",
		"dog_reviews_name_1": "메간과 레오",
		"dog_reviews_text_2": "‘젠’ 명령어는 놀라운 효과를 냅니다. 덕분에 제 개는 수의사 병원에서 치료 중에 매우 차분해집니다.",
		"dog_reviews_name_2": "린다 B.",
		"dog_reviews_text_3": "“클리커 훈련 수업 감사합니다. 매우 인기가 있다고 들었지만 사용하는 방법이 명확하지 않았습니다. 저는 저희 개에게 클리커를 빠르게 익혔고, 이제 우리는 트릭을 배우기 시작했습니다.”",
		"dog_reviews_name_3": "제이크 L.",
		"join_text": "행복한 개 부모는 EveryDoggy로 시작합니다",
		"join_courses": "웹 강좌에 참여하기",
		"checkout_introductory": "신규 등록 할인",
		"checkout_personalized_plan": "귀하의 개인화된 계획",
		"Personal plan": "",
		"goal_lose_weight": "효과적인 체중 감량 프로그램으로 안내된 운동, 영양 추적기 및 다양한 활동이 제공됩니다.",
		"goal_gain_muscles": "효과적인 전신 조각 프로그램으로 안내 운동, 영양 추적기 및 다양한 활동을 제공합니다.",
		"goal_gain_healthier_life": "전체 몸을 위한 가이드 운동, 영양 추적기 및 다양한 활동을 포함한 새로운 건강 루틴",
		"goal_gain_flexibility": "유연성을 위한 요가 프로그램으로, 가이드 세션과 차분한 음악, 영양 추적기 및 다양한 활동이 포함되어 있습니다.",
		"goal_gain_build_endurance": "가이드 운동, 영양 추적기 및 다양한 활동이 포함된 지구력 훈련 프로그램",
		"goal_love_myself": "자존감을 높이기 위한 다양한 활동, 유도 명상, 요가 세션 및 전신 운동",
		"body_type_apple": "사과형 체형을 위한 운동으로 코어를 단련하고 허리를 슬림하게 유지하세요.",
		"body_type_pear": "배 모양의 몸을 위한 운동으로 엉덩이와 허벅지를 탄력있게 만드세요",
		"body_type_square": "허리를 정의하고 글루트를 운동하기 위한 사각형 체형을 위한 운동",
		"body_type_hourglass": "놀라운 결과를 얻기 위한 모래시계 형태의 몸을 위한 운동",
		"body_type_triangle": "거꾸로 된 삼각형 체형을 위한 엉덩이와 허벅지를 강화하는 운동",
		"body_type_unknown": "몸매를 살리기 위한 운동",
		"excercises_time_morning": "아침 운동으로 신진대사를 촉진하고 하루 종일 에너지를 불어넣으세요",
		"excercises_time_day": "당신의 일정에 완벽하게 맞는 운동, 신진대사를 촉진하고 하루 종일 에너지를 유지하세요.",
		"excercises_time_evening": "긴 하루를 마친 후 스트레스를 해소하고 편안한 수면을 준비하는 저녁 운동.",
		"excercises_not_sure": "당신의 일정에 완벽하게 맞춰지고, 신진대사를 촉진하며, 하루 종일 에너지를 유지하는 운동",
		"diet_type_all": "쉬운 건강 요리법",
		"diet_type_vegetarian": "건강한 채식 레시피",
		"diet_type_vegan": "건강한 비건 레시피",
		"diet_type_keto": "건강한 케토 레시피",
		"personal_plan_providers_title": "",
		"special_features_title": "당신을 위한 특별 기능",
		"special_features_duration_minimum": "10분 이내의 빠른 세션",
		"special_features_duration_normal": "20분 이내의 편리한 세션",
		"special_features_duration_maximum": "20분 이상의 효과적인 세션",
		"special_features_duration_verv": "우리 코치의 편리한 세션",
		"special_features_goal_lose_weight": "전문가의 비밀 체중 감량 팁",
		"special_features_goal_gain": "전문가의 비밀 근육 톤 트레이닝 팁",
		"special_features_goal_health": "전문가의 비밀 건강 팁",
		"special_features_goal_flexibility": "전문가의 비밀 유연성 팁",
		"special_features_goal_endurance": "지구력을 높이는 비밀 팁",
		"special_features_goal_love": "자존감을 높이는 비밀 팁",
		"discount_activated": "50% 할인 활성화",
		"discount_no_activated": "50% 할인",
		"unlocked_with_promo": "프로모션 코드로 잠금 해제됨:",
		"use_with_button": "특별 프로모션 코드를 사용하세요:",
		"plan_optimal": "최적",
		"plan_standard": "표준",
		"plan_basic": "기본",
		"plan_extra": "추가",
		"daypayback_review_name_1": "멜리베스",
		"daypayback_review_text_1": "",
		"daypayback_review_name_2": "katie_zu13",
		"daypayback_review_text_2": "Verv를 사랑합니다! 개인 운동 및 식단 계획을 따르는 것이 제 몸매를 되찾고 다시 자신감을 갖는 데 도움이 되었습니다! 저는 저와 같은 초보자에게 완벽한 15분 미만의 짧은 피트니스 운동으로 시작했습니다. 그 후, 저는 지구력을 키우게 되었고, 운동 시간은 세션당 30-40분으로 늘어났습니다. 6개월 동안 Verv와 함께 천천히 그러나 확실히 25파운드를 감량했습니다!",
		"daypayback_review_name_3": "Jean_leon1",
		"daypayback_review_text_3": "대학 시절에 체중이 많이 증가했습니다. 졸업 후 다양한 다이어트를 시도해 보았지만, 다이어트가 끝난 지 몇 달 후에는 항상 그 체중이 다시 돌아왔습니다. 작년에는 동료에게서 Verv에 대해 듣고 시도해 보기로 결정했습니다. Verv의 개인화된 추천 덕분에 체중을 줄이고 그 후에도 유지할 수 있었습니다!",
		"daypayback_review_name_4": "maryanne1993",
		"daypayback_review_text_4": "힘든 이별 후에 저는 제 삶을 바꾸기로 결심하고 체중을 줄이고 더 건강해지기로 했습니다. 그러나 어디서부터 시작해야 할지 몰랐습니다. 다른 사람들과 운동하는 자신감이 부족했기 때문에 집에서 운동할 수 있는 앱을 시도하기로 했고, Verv가 제 검색에 나타났습니다. 저의 필요에 맞춘 계획을 제공해 주었습니다. 저는 그것을 따라하며 꿈꾸던 몸매를 얻을 수 있었습니다!",
		"personal_plan_you_get": "귀하의 개인화된 계획으로 얻을 수 있는 것은",
		"goal": "목표",
		"goal_other": "털친구 훈련을 위한 수업",
		"goal_teaching_puppy": "털복숭이 친구에게 예의와 복종을 가르치는 수업",
		"goal_surviving_puppy": "털복숭이 친구와의 첫 날을 준비하는 데 도움이 되는 수업",
		"goal_socializing_puppy": "귀여운 친구를 사회화하는 데 도움이 되는 수업",
		"goal_teaching_obedience": "당신의 털복숭이 친구에게 매너와 복종을 가르치는 수업",
		"age_puppy": "당신이 행복하고 잘 훈련된 강아지를 기르는 데 도움이 되는 전문가의 자세한 훈련 팁",
		"age_adult": "우리 전문가의 자세한 훈련 팁으로 당신이 당신의 개를 가장 효과적으로 훈련할 수 있도록 도와줍니다",
		"biting_yes": "당신의 개가 물지 않도록 하는 단계별 지침",
		"biting_no": "당신의 개와 함께할 수 있는 재미있는 게임",
		"biting_sometimes": "개가 물지 않도록 하는 단계별 지침",
		"quick_tips": "새로운 명령을 배우기 위한 빠르고 쉬운 팁",
		"potty_training_a_bit": "강아지를 효과적으로 배변훈련하는 특별 가이드",
		"potty_training_yes": "강아지에게 새로운 재미있는 트릭을 가르치는 특별한 가이드",
		"potty_training_no": "강아지를 효과적으로 배변 훈련하는 특별한 가이드",
		"success screen": "",
		"success_screen_text_1": "구매해 주셔서 감사합니다!",
		"success_screen_text_2": "아래 지침에 따라<br />계정을 설정하세요:",
		"success_screen_text_3": "귀하의 <b>계정</b>으로 이동",
		"success_screen_text_4": "<b>QR 코드</b>를 스캔하거나 <b>링크</b>를 탭하세요",
		"success_screen_text_5": "<b>앱을</b> 다운로드",
		"success_screen_text_6": "<b>앱을 열고</b> <b>즐기세요</b><br />당신의 강아지와 함께 훈련하세요!",
		"success_screen_text_7": "우리는 당신을 위한 QR 코드와 링크를 복제했습니다 &nbsp;<b>example@gmail.com</b>",
		"success_screen_text_8": "프리미엄 계정이 앱에 적용되지 않은 경우, 환영 화면에서 <b>‘문의하기’</b>를 눌러 지원 팀에 문의하세요.",
		"success_screen_text_9": "‘시작하기’ 버튼을 누르면 <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">개인정보 처리방침</a>과 <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">이용 약관</a>을 검토하고 동의했으며, 제 개인 데이터 처리에 동의하는 것으로 간주됩니다.",
		"success_screen_text_10": "문의하기",
		"success_screen_text_11": "내 계정으로 가기",
		"success_screen_text_12": "중복된 QR 코드와 링크를 이메일로 보내드렸습니다.",
		"success_screen_text_13": "PDF 가이드가 귀하의 이메일 <b>v.stsiopina@gmail.com</b>로 전송되었습니다.",
		"success_screen_text_14": "귀하의 PDF 가이드가 귀하의 이메일로 전송되었습니다.",
		"success_screen_text_15": "프리미엄 계정이 앱에 적용되지 않은 경우 앱의 환영 화면에서 <span>'로그인'</span> 링크를 눌러 이메일과 <b>stepinavalerie@gmail.com</b>로 전송한 비밀번호를 입력하십시오.",
		"success_screen_text_16": "프리미엄 계정이 앱에 적용되지 않은 경우 앱의 환영 화면에서 <span>'로그인'</span> 링크를 누르고 이메일과 이메일로 보내드린 비밀번호를 입력하세요.",
		"payment_text_1": "당신의 개 훈련 프로그램이 지금 시작됩니다!",
		"payment_text_2": "Everydoggy 앱은 당신의 개의 행동 문제를 <span>빠르고 재미있게 해결하는 데 도움을 줄 것입니다</span>.",
		"payment_text_3": "개인 제안이 만료됩니다",
		"payment_text_4": "우리 사용자들은 전문가와의 훈련을 시작한 지 1주일 만에 강아지의 행동에서 긍정적인 변화를 느낍니다",
		"payment_text_5": "모든강아지 vs 코치",
		"payment_text_6": "월 평균 명령 수",
		"payment_text_7": "모든 강아지가 혜택을 봅니다",
		"payment_text_8": "개 맞춤 훈련 계획",
		"payment_text_9": "완벽한 반려동물을 위한 하루 15분",
		"payment_text_10": "빠른 결과를 위한 70개 이상의 이해하기 쉬운 비디오 교육 레슨",
		"payment_text_11": "80개 이상의 게임과 기술, 새로운 기술과 그냥 재미를 위해",
		"payment_text_12": "위생, 건강 및 영양에 대한 팁",
		"payment_text_13": "집과 야외에서 운동하세요, 장비는 필요 없습니다",
		"payment_text_14": "우리 사용자 중 98%가 전문가와의 훈련을 시작한 후 1주일 만에 강아지 행동에서 긍정적인 변화를 느꼈다고 응답했습니다.",
		"payment_text_14_2": "<span>우리 사용자 중 98%</span>가 전문가와의 훈련을 시작한 후 1주일 만에 개의 행동에서 긍정적인 변화를 느낍니다",
		"payment_text_15": "“내 계획 얻기” 버튼을 클릭하면 저희의 <a href='https://everydoggy.com/terms/' target=\"_blank\" >이용약관</a> 및 <a href='https://everydoggy.com/policy/' target=\"_blank\" >개인정보처리방침</a>에 동의하며, <b>구독의 자동 갱신을 승인합니다</b>. 매 청구 주기의 종료 시<span>1개월</span>마다 <i>$29.99</i>의 전체 가격과 적용 세금이 부과됩니다. 갱신일 이전에 언제든지 구독의 자동 갱신을 취소할 수 있습니다. 자세한 내용은 <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >취소 조건</a>을 확인하세요.",
		"payment_text_16": "“내 요금제 받기” 버튼을 클릭하면, 귀하는 우리의 <a href='https://everydoggy.com/terms/' target='_blank'>이용 약관</a> 및 <a href='https://everydoggy.com/policy/' target='_blank'>개인 정보 보호 정책</a>에 동의하며, <b>귀하의 구독이 자동으로 갱신되는 것을 허가합니다</b> 각 청구 주기 종료 시 <span>1개월</span>에 대해 전체 가격 <i>$29.99</i> 및 해당 세금이 적용됩니다. 갱신일 이전에 언제든지 구독의 자동 갱신을 취소할 수 있습니다. 더 자세한 내용은 <a href='https://everydoggy.com/subscription-terms/' target='_blank'>취소 조건</a>을 확인하십시오.",
		"payment_text_17": "질문이 있습니까?",
		"payment_text_18": "단순히 이 주소로 저희에게 글을 보내세요 ",
		"payment_text_19": "작동합니다!",
		"payment_text_20": "우리 강아지와 함께 복종 훈련 프로그램을 막 마쳤어요, 너무 좋아요! 👏",
		"payment_text_21": "환상적이에요!",
		"payment_text_22": "",
		"payment_text_23": "",
		"payment_text_24": "",
		"payment_text_25": "",
		"payment_text_26": "",
		"payment_text_27": "",
		"payment_text_28": "",
		"payment_text_29": "",
		"payment_text_30": "",
		"payment_text_31": "",
		"payment_text_32": "",
		"payment_text_33": "",
		"payment_text_34": "",
		"payment_text_35": "",
		"payment_text_36": "",
		"payment_text_37": "",
		"payment_text_38": "",
		"payment_text_39": "",
		"payment_text_40": "",
		"payment_text_41": "",
		"payment_text_42": "",
		"payment_text_43": "",
		"payment_text_44": "",
		"payment_text_45": "",
		"payment_text_46": "",
		"payment_text_47": "",
		"payment_text_48": "",
		"payment_text_49": "",
		"payment_text_50": "",
		"payment_text_51": "",
		"payment_text_52": "",
		"payment_text_53": "",
		"payment_text_54": "",
		"payment_text_55": "",
		"payment_text_56": "",
		"payment_text_57": "",
		"payment_text_58": "",
		"payment_text_59": "",
		"payment_text_60": "",
		"payment_text_61": "",
		"payment_text_62": "",
		"payment_text_63": "",
		"payment_text_64": "",
		"payment_text_65": "",
		"payment_text_66": "",
		"payment_text_67": "",
		"payment_text_68": "",
		"payment_text_69": "",
		"payment_text_70": "",
		"payment_text_71": "",
		"payment_text_72": "",
		"payment_text_73": "",
		"payment_text_74": "",
		"payment_text_75": "",
		"payment_text_76": "",
		"payment_text_77": "",
		"payment_text_78": "",
		"payment_text_79": "",
		"payment_text_80": "",
		"payment_text_81": "",
		"payment_text_82": "You will only be charged <b>$6.99</b> today for your first week (details below)",
		"payment_text_83": "Your introductory period will last until <b>Oct 11, 2024</b>.",
		"payment_text_84": "You may cancel at any time before <b>Oct 10, 2024</b>, and you will not be charged.",
		"payment_text_85": "If you don’t cancel, Everydoggy will automatically continue your membership at the end of your introductory period and charge the membership fee (currently <b>$39.99 USD</b>) monthly until you cancel.",
		"payment_text_86": "No partial refunds. You can cancel your subscription anytime in your Account.",
		"payment_text_87": "Your subscription will be bound by our <a href='https://everydoggy.com/terms/' target=\"_blank\" >Terms and Conditions</a>, <a href='https://everydoggy.com/policy/' target=\"_blank\" >Privacy Policy</a> and <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Cancellation Terms</a>.",
		"payment_text_88": "Payment method",
		"payment_text_89": "EveryDoggy will use your payment details for seamless future payments",
		"payment_text_90": "Easy and private payments with Face/Touch ID",
		"payment_text_91": "Keeps your financial info safe with end-to-end encryption",
		"payment_text_92": "Protected by Apple Pay’s unique Device Account Number",
		"payment_text_93": "Your payment information is secure with SSL/TLS encryption",
		"payment_text_94": "Fast, convenient payment option",
		"payment_text_95": "Backed by PayPal’s industry-leading fraud protection",
		"payment_text_96": "Confirm purchase",
		"payment_text_97": "1-WEEK",
		"payment_text_98": "1-MONTH",
		"payment_text_99": "3-MONTH",
		"payment_text_100": "You will only be charged <b>$6.99</b> today for your first month (details below)",
		"payment_text_101": "You will only be charged <b>$6.99</b> today for your first 3 months (details below)",
		"payment_text_102": "Subscribe with",
		"payment_text_103": "By clicking ‘Get my plan’ button you agree with the  <a href='https://everydoggy.com/policy/' target=\"_blank\" >Privacy Policy</a>,  <a href='https://everydoggy.com/terms/' target=\"_blank\" >Terms and Conditions</a> and <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Cancellation Terms</a>",
		"payment_text_104": "Easy and private payments",
		"payment_text_105": "Credit Card",
		"payment_text_106": "Expiry date",
		"payment_text_107": "CVC",
		"payment_text_108": "",
		"payment_text_109": "",
		"payment_text_110": "",
		"payment_text_111": "",
		"payment_text_112": "",
		"payment_text_113": "",
		"payment_text_114": "",
		"payment_text_115": "",
		"payment_text_116": "",
		"payment_text_117": "",
		"payment_text_118": "",
		"payment_text_119": "",
		"payment_text_120": "",
		"payment_text_121": "",
		"payment_text_122": "",
		"payment_text_123": "",
		"payment_text_124": "",
		"payment_text_125": "",
		"payment_text_126": "",
		"payment_text_127": "",
		"payment_text_128": "",
		"payment_text_129": "",
		"payment_text_130": "",
		"payment_text_131": "",
		"payment_text_132": "",
		"payment_text_133": "",
		"payment_text_134": "",
		"payment_text_135": "",
		"payment_text_136": "",
		"payment_text_137": "",
		"payment_text_138": "",
		"payment_text_139": "",
		"payment_text_140": "",
		"payment_text_141": "Your Dog Training Plan is ready!",
		"payment_text_142": "Obedience",
		"payment_text_143": "Knows Commands",
		"payment_text_144": "Toilet Accidents",
		"payment_text_145": "Frequent",
		"payment_text_146": "None",
		"payment_text_147": "Barking",
		"payment_text_148": "Barks at everything",
		"payment_text_149": "Quiet & Relaxed",
		"payment_text_150": "Biting & chewing",
		"payment_text_151": "Often",
		"payment_text_152": "Stopped",
		"payment_text_153": "Pulling the leash",
		"payment_text_154": "Always",
		"payment_text_155": "Walks calmly",
		"payment_text_156": "Anxiety When Left Alone",
		"payment_text_157": "Calm and independent",
		"payment_text_158": "Before",
		"payment_text_159": "After",
		"payment_text_160": "minutes",
		"payment_text_161": "seconds",
		"payment_text_162": "Proven. Tested. It Works",
		"payment_text_163": "Significant changes in a dog’s obedience",
		"payment_text_164": "Today",
		"payment_text_165": "Week 2",
		"payment_text_166": "Week 3",
		"payment_text_167": "Week 4",
		"payment_text_168": "What makes Everydoggy so effective",
		"payment_text_169": "Our users' success stories",
		"payment_text_170": "Crafted by Experts Who <span>Love Dogs</span>",
		"payment_text_171": "Every our course and lesson is grounded in scientific studies of dog training.",
		"payment_text_172": "Build a strong bond with your dog, try EveryDoggy!",
		"payment_text_173": "Proven. Tested. It Works",
		"payment_text_174": "<span>93% of our users</span> notice significant changes in their dog’s behavior within the first month of training.",
		"payment_text_175": "With EveryDoggy",
		"payment_text_176": "Without EveryDoggy",
		"payment_text_177": "Today",
		"payment_text_178": "Week 16",
		"payment_text_179": "Week 18",
		"payment_text_180": "Week 20",
		"payment_text_181": "About Luna",
		"payment_text_182": "My puppy kept having accidents in the house. Everydoggy gave us a clear routine, and it actually worked!",
		"payment_text_183": "About Cooper",
		"payment_text_184": "Our pup used to nip at everyone during playtime. The app gave us step-by-step guidance, and it worked!",
		"payment_text_185": "About Bella",
		"payment_text_186": "Our dog chewed everything – from shoes to the couch. The app helped us redirect that energy!",
		"payment_text_187": "About Charlie",
		"payment_text_188": "Leash pulling was a daily struggle. Thanks to the app, walks are now enjoyable and stress-free.",
		"payment_text_189": "Potty trained",
		"payment_text_190": "Solved biting",
		"payment_text_191": "Chewing solved",
		"payment_text_192": "Leash pulling solved",
		"payment_text_193": "",
		"payment_text_194": "",
		"payment_text_195": "",
		"payment_text_196": "",
		"payment_text_197": "",
		"payment_text_198": "",
		"payment_text_199": "",
		"payment_text_200": "",
		"payment_text_201": "",
		"payment_text_202": "",
		"payment_text_203": "",
		"payment_text_204": "",
		"payment_text_205": "",
		"payment_text_206": "",
		"payment_text_207": "",
		"payment_text_208": "",
		"payment_text_209": "",
		"payment_text_210": "",
		"payment_text_211": "",
		"payment_text_212": "",
		"payment_text_213": "",
		"payment_text_214": "",
		"payment_text_215": "",
		"payment_text_216": "",
		"payment_text_217": "",
		"payment_text_218": "",
		"payment_text_219": "",
		"payment_text_220": "",
		"payment_text_221": "",
		"payment_text_222": "",
		"payment_text_223": "",
		"payment_text_224": "",
		"payment_text_225": "",
		"payment_text_226": "마지막 기회!\r",
		"payment_text_227": "",
		"payment_text_228": "",
		"payment_text_229": "",
		"payment_text_230": "",
		"payment_text_231": "",
		"payment_text_232": "",
		"payment_text_233": "",
		"payment_text_234": "",
		"payment_text_235": "",
		"payment_text_236": "",
		"payment_text_237": "",
		"payment_text_238": "",
		"payment_text_239": "",
		"payment_text_240": "",
		"payment_text_241": "",
		"payment_text_242": "",
		"payment_text_243": "",
		"payment_text_244": "",
		"payment_text_245": "",
		"payment_text_246": "",
		"payment_text_247": "",
		"payment_text_248": "",
		"payment_text_249": "",
		"payment_text_250": "",
		"payment_text_251": "",
		"payment_text_252": "",
		"payment_text_253": "",
		"payment_text_254": "",
		"payment_text_255": "",
		"payment_text_256": "",
		"payment_text_257": "",
		"payment_text_258": "",
		"payment_text_259": "",
		"payment_text_260": "",
		"payment_text_261": "",
		"payment_text_262": "",
		"payment_text_263": "강아지 번역기",
		"payment_text_264": "반려견을 이해하세요.<br/> 결과를 확인해 보세요",
		"payment_text_265": "신호와 행동을 분석하면 복종 훈련 효과가 더 좋아집니다",
		"payment_text_266": "반려견의 짖음과 행동 분석을 바탕으로 한 맞춤형 훈련 계획",
		"payment_text_267": "훈련은 더 빠르게, <br />즐거움은 두 배로!",
		"payment_text_268": "최고의 퍼피 트레이닝 가이드를 만나보세요",
		"payment_text_269": "최고의 반려견 훈련 가이드를 만나보세요",
		"payment_text_270": "배변 문제와 작별하세요! 단계별 방법으로 반려견에게 올바른 배변 습관을 빠르게 가르칠 수 있어요.",
		"payment_text_271": "신발과 손가락을 지키세요! 쉬운 방법으로 강아지의 물기와 아무거나 씹는 습관을 부드럽게 바로잡아 보세요.",
		"payment_text_272": "반려견을 위한 안전하고 편안한 공간을 만들고, 크레이트 안에서 차분하고 안정감 있게 지내는 법을 가르쳐 주세요.",
		"payment_text_273": "행동, 복종 훈련, 일상생활까지 반려견과의 생활에 필요한 전문가 팁을 한 번에 만나보세요.",
		"payment_text_274": "검증됐고 따라 하기 쉬운 방법으로 집에서도 산책 중에도 원치 않는 행동을 바로잡아 보세요.",
		"payment_text_275": "배우는 시간을 더 즐겁게! 칭찬과 보상을 제대로 활용해 반려견의 의욕을 바로 끌어올리세요.",
		"payment_text_276": "기본만 가르치는 데서 끝나지 않아요! 꼭 필요한 안전 명령부터 모든 연령대의 반려견이 배울 수 있는 멋진 트릭까지 익혀 보세요.",
		"payment_text_277": "반려견의<br />성장을 <span>2배 더 빠르게!</span>",
		"payment_text_278": "실용 가이드:",
		"payment_text_279": "멤버 전용 98% 할인",
		"payment_text_280": "멤버 전용 70% 할인",
		"payment_text_281": "",
		"payment_text_282": "",
		"payment_text_283": "",
		"payment_text_284": "",
		"payment_text_285": "",
		"payment_text_286": "",
		"payment_text_287": "",
		"payment_text_288": "",
		"payment_text_289": "",
		"payment_text_290": "",
		"payment_text_291": "",
		"payment_text_292": "",
		"payment_text_293": "",
		"payment_text_294": "",
		"payment_text_295": "",
		"payment_text_296": "",
		"payment_text_297": "",
		"payment_text_298": "",
		"payment_text_299": "",
		"payment_text_300": "",
		"payment_text_301": "",
		"payment_text_302": "",
		"payment_text_303": "",
		"payment_text_304": "",
		"payment_text_305": "",
		"payment_text_306": "",
		"payment_text_307": "",
		"payment_text_308": "",
		"payment_text_309": "",
		"payment_text_310": "",
		"payment_text_311": "",
		"payment_text_312": "",
		"payment_text_313": "",
		"payment_text_314": "",
		"payment_text_315": "",
		"payment_text_316": "",
		"payment_text_317": "",
		"payment_text_318": "",
		"payment_text_319": "",
		"payment_text_320": "",
		"payment_text_321": "",
		"payment_text_322": "",
		"payment_text_323": "",
		"payment_text_324": "",
		"payment_text_325": "",
		"payment_text_326": "",
		"payment_text_327": "",
		"payment_text_328": "",
		"payment_text_329": "",
		"payment_text_330": "",
		"payment_text_331": "",
		"payment_text_332": "",
		"payment_text_333": "",
		"payment_text_334": "",
		"payment_text_335": "",
		"payment_text_336": "",
		"payment_text_337": "",
		"payment_text_338": "",
		"payment_text_339": "",
		"payment_text_340": "",
		"payment_text_341": "",
		"payment_text_342": "",
		"payment_text_343": "",
		"payment_text_344": "",
		"payment_text_345": "",
		"payment_text_346": "",
		"payment_text_347": "",
		"payment_text_348": "",
		"payment_text_349": "",
		"payment_text_350": "",
		"payment_text_351": "",
		"payment_text_352": "",
		"payment_text_353": "",
		"payment_text_354": "",
		"payment_text_355": "",
		"payment_text_356": "",
		"payment_text_357": "",
		"payment_text_358": "",
		"payment_text_359": "",
		"payment_text_360": "",
		"payment_text_361": "",
		"payment_text_362": "",
		"payment_text_363": "",
		"payment_text_364": "",
		"payment_text_365": "",
		"payment_text_366": "",
		"payment_text_367": "",
		"payment_text_368": "",
		"payment_text_369": "",
		"payment_text_370": "",
		"payment_text_371": "",
		"payment_text_372": "",
		"payment_text_373": "",
		"payment_text_374": "",
		"payment_text_375": "",
		"payment_text_376": "",
		"payment_text_377": "",
		"payment_text_378": "",
		"payment_text_379": "",
		"payment_text_380": "",
		"payment_text_381": "",
		"payment_text_382": "",
		"payment_text_383": "",
		"payment_text_384": "",
		"payment_text_385": "",
		"payment_text_386": "",
		"payment_text_387": "",
		"payment_text_388": "",
		"payment_text_389": "",
		"pdfUpselling": "",
		"pdfUpselling_1": "<span>Kickstart your journey to an obedient dog:</span> Grab an ultimate guide to dog raising training",
		"pdfUpselling_2": "<span>Kickstart your journey to an obedient dog:</span> Grab an ultimate guide to puppy raising and training",
		"pdfUpselling_3": "Get your <span>personal plan</span>",
		"pdfUpselling_4": "Unlock the <span>practical guide</span>",
		"pdfUpselling_5": "Behavior correction (indoors & outdoors)",
		"pdfUpselling_6": "How to praise and reward your dog",
		"pdfUpselling_7": "Various commands",
		"pdfUpselling_8": "Enrichment games & much more",
		"pdfUpselling_9": "Potty training",
		"pdfUpselling_10": "Stop biting & chewing",
		"pdfUpselling_11": "Crate training",
		"pdfUpselling_12": "Plus 43 other helpful tips and solutions",
		"pdfUpselling_13": "Total today",
		"pdfUpselling_14": "Unlock guide",
		"pdfUpselling_15": "Unlock with",
		"pdfUpselling_16": "Continue without guide",
		"chatUpsale_1": "",
		"chatUpsale_2": "",
		"chatUpsale_3": "",
		"chatUpsale_4": "",
		"chatUpsale_5": "",
		"chatUpsale_6": "",
		"chatUpsale_7": "",
		"chatUpsale_8": "",
		"chatUpsale_9": "",
		"chatUpsale_10": "",
		"chatUpsale_11": "",
		"chatUpsale_12": "",
		"chatUpsale_13": "",
		"chatUpsale_14": "",
		"chatUpsale_15": "",
		"checkoutV2_text1": "",
		"checkoutV2_text2": "",
		"checkoutV2_text3": "",
		"checkoutV2_text4": "",
		"checkoutV2_text5": "",
		"checkoutV2_text6": "",
		"checkoutV2_text7": "",
		"checkoutV2_text8": "",
		"checkoutV2_text9": "",
		"checkoutV2_text10": "",
		"checkoutV2_text11": "",
		"error_1": "",
		"error_2": "",
		"error_3": "",
		"error_4": "",
		"error_5": "",
		"error_6": "",
		"error_7": "",
		"error_8": "",
		"error_9": "",
		"error_10": "",
		"disclaimerV2_text_1": "",
		"disclaimerV2_text_2": "",
		"disclaimerV2_text_3": "",
		"chatUpsaleV2_1": "",
		"chatUpsaleV2_2": "",
		"chatUpsaleV2_3": "",
		"chatUpsaleV2_4": "",
		"chatUpsaleV2_5": "",
		"chatUpsaleV2_6": "",
		"chatUpsaleV2_7": "",
		"chatUpsaleV2_8": "",
		"chatUpsaleV2_9": "",
		"chatUpsaleV2_10": "",
		"chatUpsaleV2_11": "",
		"chatUpsaleV2_12": "",
		"chatUpsaleV2_13": "",
		"chatUpsaleV2_14": "",
		"chatUpsaleV2_15": "",
		"chatUpsaleV2_16": "",
		"chatUpsaleV2_17": "",
		"chatUpsaleV2_18": "",
		"chatUpsaleV2_19": "",
		"chatUpsaleV2_20": "",
		"chatUpsaleV2_21": "",
		"chatUpsaleV2_22": "",
		"chatUpsaleV2_23": "",
		"chatUpsaleV2_24": "",
		"chatUpsaleV2_25": "",
		"chatUpsaleV2_26": "",
		"chatUpsaleV2_27": "",
		"chatUpsaleV2_28": "",
		"chatUpsaleV2_29": "",
		"chatUpsaleV2_30": "",
		"chatUpsaleV2_31": "",
		"chatUpsaleV2_32": "",
		"chatUpsaleV2_33": ""
	},
	"tr": {
		"global \ninstruction": "",
		"safe": "Bilgileriniz güvendedir",
		"information": "Kişisel iletişim bilgilerinizi herhangi bir pazarlama amacıyla satmayacak veya kiralamayacağız.",
		"secure_checkout": "Güvenli ödeme",
		"encrypted": "Tüm bilgiler, Secure Sockets Layer (SSL) protokolü kullanılarak şifrelenir ve risksiz bir şekilde iletilir.",
		"help": "Yardımcı olabilir miyim?",
		"contact": "Bize ulaşın",
		"here": "burada.",
		"undefined": "",
		"featured": "Şurada yer alan",
		"main_title": "Köpek Eğitim Kursları",
		"per_year": "yılda",
		"special_offer": "Özel teklif",
		"card_number": "Kart numarası",
		"card_expiry": "Kartın süresi doluyor",
		"security_number": "Güvenlik numarası",
		"email": "E-posta",
		"To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of __period__ and at the full, not discounted, price of __fullPriceText__ To learn more visit our <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">terms of use</a>.": "Ödeme bilgileri",
		"secure_server": "Güvenli Sunucu",
		"pay": "Ödeme yapmak",
		"enter_your_email": "E-posta adresinizi girin",
		"comment_1": "Birkaç stresli yıl boyunca tamamen formumu kaybettim ve biraz yağlandım, ama bununla ilgili bir şeyler yapmak için ne zamanım ne de motivasyonum vardı. Bir aile üyesi Verv’i önerdi ve artık her gün koçuma güveniyorum!",
		"comment_2": "Verv, evdeki antrenmanlardan keyif almamı sağladı ve bir ayda 7 kg verdim. Bu uygulama, benim gibi bir acemiyseniz, egzersiz yapmanıza ve kilo vermenize gerçekten yardımcı olabilir.",
		"success_story": "Başarı hikayesi",
		"get_my_plan": "PLANIMI AL",
		"delimiter": "veya",
		"pay_buy_card": "Kartla Ödeme",
		"get_my_plan_warning_1": "Herhangi bir kesinti olmaması için seçtiğiniz aboneliğin bir sonraki yenileme dönemi için otomatik olarak uzatılacağını kabul edersiniz",
		"get_my_plan_warning_2": "ve indirimli olmayan tam fiyatı ile",
		"get_my_plan_warning_3": "Daha fazla bilgi için bizimkini ziyaret edin",
		"get_my_plan_warning_text": "Devam ederek, ilk yenileme döneminin sona ermesinden en az 24 saat önce iptal etmezseniz, __fullPriceText__ tam ücretinin her __period__ için otomatik olarak alınacağını kabul etmiş olursunuz.",
		"terms_of_use": "Kullanım Şartları",
		"privacy_policy": "Gizlilik Politikası",
		"terms_conditions": "Şartlar ve koşullar",
		"privacy_policy_footer": "Gizlilik Politikası",
		"terms_conditions_footer": "Şartlar ve koşullar",
		"guaranteed": "Garantili güvenli ödeme",
		"special_features": "Sizin için özel özellikler",
		"calories_value": "kcal",
		"personalized_plan": "Kişiselleştirilmiş planınızı alın:",
		"mobile_app": "Planınızla mobil uygulama",
		"daily_programs": "Farklı hedefler için günlük programlar (yağ yakma, stresi azaltma, kas kazanma)",
		"audio_guided": "Sesli rehberli egzersizler",
		"easy_to_cook": "Hazırlaması kolay ve lezzetli yemekler",
		"comprehensive_stats": "Kapsamlı istatistikler",
		"secret_tips": "Sağlıklı alışkanlıklar geliştirmek için gizli ipuçları",
		"mobile_app_tailor": "Cebinizdeki özel plan",
		"daily_programs_for": "Günlük programlar",
		"daily_programs_for_2": "Farklı hedefler için (yağ yakma, stresi azaltma, kas kazanma)",
		"audio_trainers": "Profesyonel eğitmen kılavuzları",
		"comprehensive_track": "En son istatistiklerle ilerlemenizi takip edin",
		"price": "Fiyat",
		"users_love": "Kullanıcılar Kişisel Planımızı seviyor",
		"alternative_review_name_1": "Therealtierra",
		"alternative_review_title_1": "Harika bir uygulama!",
		"alternative_review_contentent_1": "Ben 9. haftadayım ve vücudum çok değişti!",
		"alternative_review_name_2": "tenis kızı",
		"alternative_review_title_2": "Çalışıyor!",
		"alternative_review_contentent_2": "Programı bitirdim. Çok sevdim. 15 kg verdim!!",
		"you_re_in": "İçeridesin!",
		"personal_plan_starts": "Verv kişisel planınız bugünden başlıyor ve zaman hızla geçiyor. Yani kontrol edin!",
		"app_by_link": "Programınıza girmek için bağlantıdan uygulamayı indirin",
		"download_now": "Şimdi indir",
		"or": "veya",
		"price_after_trial": "Deneme sonrası fiyat",
		"seven_days_trial_unlocked": "7 günlük deneme sürümü açıldı",
		"total_today": "Bugün toplam",
		"reserved_price_for": "Rezerve fiyatı için",
		"new_subscritions1_title": "Planınızı seçin",
		"new_subscritions1_subscription1_line1": "Yarım yıl planı",
		"new_subscritions1_subscription1_price1_time": "haftada",
		"new_subscritions1_subscription2_line1": "3 aylık plan",
		"new_subscritions1_subscription2_price2_time": "haftada",
		"new_subscritions1_subscription3_line1": "1 aylık plan",
		"new_subscritions1_subscription3_price3_time": "haftada",
		"new_subscription_save": "KAYDET",
		"new_subscritions_agreement": "Devam ederek, kabul edersiniz",
		"new_subscritions_and": "ve",
		"new_subscritions_subtitle": "Kullanıcılarımız 10 milyon sterlin kaybetti",
		"new_subscritions_join": "Milyonlarca mutlu kullanıcıya katılın",
		"statistic_block_item1_text": "5 üzerinden yıldız",
		"statistic_block_item2_text": "5 yıldızlı puanlamalar",
		"statistic_block_item3_text": "indirmeler",
		"get_your_personalized_plan": "Kişiselleştirilmiş planınızı alın",
		"for": "için",
		"new_subscription_save_mostPopular1MonthPrice": "en popüler plan",
		"timer_additional_discount": "Ekstra indirim şimdi uygulandı ",
		"timer_additional_discount_bold": "senin için",
		"timer_offer_expires": "Bu teklif şurada sona eriyor:",
		"Payment Successful": "",
		"payment_successful_title": "Verv ekibinden merhaba!",
		"payment_successful_download": "Uygulamayı indirin",
		"payment_successful_press": "Bas",
		"payment_successful_login": "E-posta ile giriş yap",
		"payment_successful_email": "E-posta adresinizi girin",
		"payment_successful_code": "ve onay kodunuz:",
		"payment_successful_hit": "Sonra vurun",
		"payment_successful_done": "Tamam",
		"payment_successful_description": "İçindesiniz, kişiselleştirilmiş antrenman programınızın tadını çıkarın!",
		"Tariffs Variants": "",
		"tariff_title_choose": "Planınızı seçin",
		"tariff_title_get": "Planınızı alın",
		"tariff_one_month": "1 Aylık plan",
		"tariff_three_month": "3 Aylık plan",
		"tariff_six_month": "6 Aylık plan",
		"tariff_one_year": "1 Yıllık plan",
		"tariff_one_week": "1 Haftalık plan",
		"tariff_three_day": "3 Günlük plan",
		"tariff_per_year": "yılda",
		"tariff_per_day": "günde",
		"tariff_per_days": "her 3 günde bir",
		"tariff_per_week": "haftada",
		"tariff_week": "hafta",
		"tariff_annual": "Yıllık plan",
		"tariff_trial_one_week": "1 haftalık deneme",
		"tariff_after": "sonra ",
		"tariff_save": "Kaydet",
		"tariff_best_offer": "en iyi teklif",
		"tariff_most_popular": "en popüler",
		"tariff_limited_promo": "sınırlı promosyon fiyatı",
		"tariff_6_for_3": "3'ün fiyatına 6",
		"tariff_first_month": "ilk ay",
		"tariff_first_week": "ilk hafta",
		"tariff_monthly": "aylık",
		"tariff_quaterly": "üç aylık",
		"tariff_semiannually": "yarı yıllık",
		"tariff_billed_every ": "her sefer fatura edilir ",
		"tariff_year": "yıl",
		"tariff_month": "ay",
		"tariff_months": "aylar",
		"tariff_months_variable": "aylar",
		"tariff_organic_gift": "Meditasyon planı",
		"tariff_full_price": "Tam fiyat",
		"tariff_no_hidden_fees": "Gizli ücret yok",
		"tariff_start_right_now": "Hemen başlayın",
		"tariff_more_than": "Verv ailesinin 1.000.000'dan fazla aktif üyesi",
		"tariff_intro_offer": "GİRİŞ TEKLİFİ",
		"Тарифы плиткой в ряд": "",
		"": "",
		"Checkout": "",
		"checkout_title": "Ödeme yöntemini seçin",
		"insufficient_funds": "Yetersiz bakiye",
		"insufficient_we_have": "Bir şeye sahibiz",
		"insufficient_special_price": "özel fiyat",
		"insufficient_for_you": "senin için",
		"checkout_edit_card": "Kartı düzenle",
		"checkout_pay_via": "Üzerinden ödeme yap",
		"checkout_paypal": "PayPal",
		"checkout_credit_card": "Kredi kartı",
		"checkout_paypal_description": "Ödemeniz PayPal aracılığıyla işlenecektir",
		"checkout_total_price": "Toplam Fiyat",
		"checkout_warning_1": "Herhangi bir kesintiyi önlemek için seçtiğiniz aboneliğin ardışık yenileme dönemi için otomatik olarak uzatılacağını kabul edersiniz.",
		"checkout_warning_2": "ve indirimli olmayan tam fiyatıyla",
		"checkout_warning_3": "Daha fazla bilgi için bizim",
		"spv2_warning": "Herhangi bir kesintiyi önlemek için seçtiğiniz aboneliğin otomatik olarak __period__ süre boyunca ve __productDetailsAmount__ tam fiyatla, indirimli fiyat değil, uzatılacağını kabul edersiniz. Daha fazla bilgi için <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">kullanım şartlarımıza</a> göz atın.",
		"checkout_offer_day_for": "günü için",
		"checkout_offer_days_for": "günler için",
		"checkout_offer_month_for": "için ay",
		"checkout_offer_months_for": "aylar için",
		"checkout_offer_week_for": "hafta için",
		"Values": "",
		"value_kg": "kg",
		"value_pounds": "lb",
		"value_st": "st",
		"value_g": "g",
		"value_kcal": "kcal",
		"value_min": "dakika",
		"value_min_cooking": "dakika pişirme",
		"welcome_title": "Verv Premium'e hoş geldiniz!",
		"item_1_title": "Vay be!",
		"item_1_description": "__weight__ olan hedef kilonuz artık köşede.",
		"item_2_title": "Nasıl etkinleştirilir",
		"item_2_description": "Aşağıdaki bağlantıyı kullanarak uygulamayı indirin, e-posta __mail__'inizi kullanın ve bu doğrulama kodunu girin: __code__.",
		"item_2_description_2": "E-posta adresini değiştirmek için <button id=\"changeMail\">buraya</button> tıklayın.",
		"item_3_title": "Bir şeyler yanlış gitti mi?",
		"item_3_description": "Ayrıntılı bir talimat e-posta adresinize gönderildi. Eğer almadıysanız, <a target=\"_blank\" href=\"mailto:support@verv.com?subject=Giriş problemi (simple-login)\">destek</a> ile iletişime geçin.",
		"change": "Onayla",
		"change_mail": "Premium'i aktifleştirmek için e-posta adresinizi buradan değiştirin",
		"email_warning": "Lütfen geçerli bir e-posta adresi girin",
		"Promo Code Block": "",
		"promo_code_title": "Promo kodu uygulandı!",
		"promo_code_save": "% indirim",
		"EveryDoggy": "",
		"dog_courses": "köpek kursları",
		"why_we_best_active": "Aktif Kullanıcılar.",
		"why_we_best_lessons": "Video Dersleri.",
		"why_we_best_brain": "Zihin Oyunları.",
		"why_we_best": "Neden en iyisiyiz?",
		"why_we_best_join": "Köpek sahibi topluluğumuza katılın ve EveryDoggy ile elinizden gelenin en iyisini yapın.",
		"why_we_best_enjoy": "Sana ve köpeğinin hedeflerine yönelik kişiselleştirilmiş eğitim programının tadını çıkar.",
		"why_we_best_keep": "70'ten fazla beyin oyunu ile köpeğinizi zihinsel ve fiziksel olarak aktif tutun.",
		"dog_problems": "Davranış sorunlarına hızlı çözümler",
		"dog_problems_choose": "Geliştirmek istediğiniz istemediğiniz davranışları seçin",
		"dog_problems_leash": "Köpek<br/>tasma çekme",
		"dog_problems_biting": "Isırma",
		"dog_problems_anxiety": "Ayrılıkla ilgili kaygı<br/>",
		"dog_problems_chewing": "Yıkıcı<br/>Çiğneme",
		"dog_plan": "Kişiselleştirilmiş antrenman planı",
		"dog_plan_our": "Eğitim programımız, köpeğinizin ihtiyaçlarına %100 uygun olarak hazırlanmıştır.",
		"dog_reviews": "Köpek sahiplerinin EveryDoggy hakkında söyledikleri",
		"dog_reviews_text_1": "«Çok net ve takip etmesi kolay dersler. Yavru köpeğim eğitime bayılıyor ve ikimiz de çok şey öğrendik.»",
		"dog_reviews_name_1": "Megan ve Leo",
		"dog_reviews_text_2": "\"Zen\" komutu harikalar yaratıyor. Sayesinde köpeğim veteriner kliniğinde işlemler sırasında süper sakin.",
		"dog_reviews_name_2": "Linda B.",
		"dog_reviews_text_3": "“Clicker eğitimi dersi için teşekkürler. Çok popüler olduğunu duydum ama nasıl kullanılacağına dair net bir bilgi yoktu. Köpeğimi clicker ile hızlıca tanıştırdım ve şimdi numaralar öğrenmeye başladık.”",
		"dog_reviews_name_3": "Jake L.",
		"join_text": "Mutlu bir köpek ebeveynliği EveryDoggy ile başlar",
		"join_courses": "Web Kurslarına Katıl",
		"checkout_introductory": "Tanıtım teklifi indirimi",
		"checkout_personalized_plan": "Kişiselleştirilmiş planınız",
		"Personal plan": "",
		"goal_lose_weight": "Rehberli antrenmanlar, beslenme takipçisi ve sizin için bir dizi aktivite ile etkili bir kilo kaybı programı",
		"goal_gain_muscles": "Rehberli antrenmanlar, beslenme izleyici ve sizin için çeşitli aktivitelerle etkili bir tüm vücut tonlama programı",
		"goal_gain_healthier_life": "Vücut geliştirmeye yönelik rehberli tam beden egzersizleri, beslenme takipçisi ve sizin için çeşitli aktivitelerle yeni bir sağlıklı rutin",
		"goal_gain_flexibility": "Rehberli seanslar ve rahatlatıcı müzik, beslenme takipçisi ve çeşitli diğer etkinliklerle birlikte esneklik için yoga programı",
		"goal_gain_build_endurance": "Kılavuzlu egzersizler, beslenme izleyici ve sizin için çeşitli etkinlikler içeren dayanıklılık antrenman programı",
		"goal_love_myself": "Kendine güvenini artırmak için çeşitli aktiviteler, yönlendirilmiş meditasyonlar, yoga seansları ve tüm vücut antrenmanları",
		"body_type_apple": "Karakalem vücut yapısı için, karın kaslarınızı güçlendirip belinizi inceltmek üzere egzersizler.",
		"body_type_pear": "Armut şeklindeki beden için kalçalarınızı ve uyluklarınızı şekillendiren egzersizler",
		"body_type_square": "Belinizi tanımlamak ve gluteus kaslarınızı çalıştırmak için kare şeklindeki vücut için egzersizler",
		"body_type_hourglass": "Büyüleyici sonuçlar elde etmenize yardımcı olacak kum saati şeklindeki vücut için egzersizler",
		"body_type_triangle": "Ters üçgen vücut şekli için kalçalarınızı ve uyluklarınızı güçlendiren egzersizler",
		"body_type_unknown": "Vücut şeklinizi en iyi şekilde ortaya çıkarmak için egzersizler",
		"excercises_time_morning": "Metabolizmanızı artırmak ve tüm gün enerji sağlamak için sabah egzersizleri",
		"excercises_time_day": "Programınıza mükemmel bir şekilde uyan, metabolizmanızı hızlandıran ve gün boyunca enerjik kalmanızı sağlayan egzersizler.",
		"excercises_time_evening": "Uzun bir günün ardından stresi azaltmanıza ve iyi bir uyku için hazırlanmanıza yardımcı olacak akşam egzersizleri.",
		"excercises_not_sure": "Programınıza mükemmel uyum sağlayan, metabolizmanızı hızlandıran ve sizi gün boyu enerjik tutan antrenmanlar",
		"diet_type_all": "Kolay sağlıklı tarifler",
		"diet_type_vegetarian": "Sağlıklı vejetaryen tarifler",
		"diet_type_vegan": "Sağlıklı vegan tarifler",
		"diet_type_keto": "Sağlıklı keto tarifleri",
		"personal_plan_providers_title": "",
		"special_features_title": "Sizin için özel özellikler",
		"special_features_duration_minimum": "10 dakikanın altında hızlı oturumlar",
		"special_features_duration_normal": "20 dakikadan kısa pratik seanslar",
		"special_features_duration_maximum": "20 dakikadan uzun etkili oturumlar",
		"special_features_duration_verv": "Koçlarımızdan konforlu seanslar",
		"special_features_goal_lose_weight": "Uzmanlardan gizli kilo verme ipuçları",
		"special_features_goal_gain": "Uzmanlardan gelen gizli kas tonlama ipuçları",
		"special_features_goal_health": "Uzmanlardan gizli sağlık ipuçları",
		"special_features_goal_flexibility": "Uzmanlardan gizli esneklik ipuçları",
		"special_features_goal_endurance": "Dayanıklılığı artırmak için gizli ipuçları",
		"special_features_goal_love": "Özgüveni artırmak için gizli ipuçları",
		"discount_activated": "Yüzde 50 indirim etkinleştirildi",
		"discount_no_activated": "50% indirim",
		"unlocked_with_promo": "Promosyon kodu ile kilidi açıldı:",
		"use_with_button": "Özel promosyon kodunuzu kullanın:",
		"plan_optimal": "Optimal",
		"plan_standard": "STANDART",
		"plan_basic": "TEMEL",
		"plan_extra": "EKSTRA",
		"daypayback_review_name_1": "melliebeth",
		"daypayback_review_text_1": "",
		"daypayback_review_name_2": "katie_zu13",
		"daypayback_review_text_2": "Verv'i seviyorum! Kişisel antrenman ve yemek planımı takip etmek, forma girmeme ve tekrar özgüven kazanmama yardımcı oldu! Benim gibi bir acemi için mükemmel olan 15 dakikadan kısa fitness antrenmanlarıyla başladım. Sonra dayanıklılığımı artırdım ve antrenman sürem seans başına 30-40 dakikaya çıkmaya başladı. Verv ile 6 ayda yavaş ama kesin bir şekilde 25 pound (11.3 kg) kaybettim!",
		"daypayback_review_name_3": "Jean_leon1",
		"daypayback_review_text_3": "Üniversitede çok fazla kilo aldım. Mezun olduktan sonra bana kilo vermeme yardımcı olan farklı diyetler denedim, ama bu kilolar her zaman diyetten birkaç ay sonra geri geliyordu. Geçen yıl, bir meslektaşımdan Verv'i duydum ve denemeye karar verdim. Verv'in kişiselleştirilmiş önerileriyle kilo vermeyi başardım ve sonrasında da bu kiloyu korudum!",
		"daypayback_review_name_4": "maryanne1993",
		"daypayback_review_text_4": "Zor bir ayrılığın ardından hayatımı değiştirmeye, kilo vermeye ve daha sağlıklı olmaya karar verdim. Ama nereden başlayacağımı bilmiyordum. Diğerleriyle egzersiz yapacak kadar kendime güvenmiyordum, bu yüzden evde çalışma uygulamalarını denemeye karar verdim ve Verv aramamda karşıma çıktı. İhtiyaçlarıma uygun bir plan sundu. Onu takip ettim ve hayal ettiğim bedene kavuşmayı başardım!",
		"personal_plan_you_get": "Kişiselleştirilmiş planınızı aldığıınızda",
		"goal": "Hedef",
		"goal_other": "Tüylü arkadaşınızı eğitmek için dersler",
		"goal_teaching_puppy": "Kabarik arkadaşınıza olduğu gibi iyi davranış ve itaati öğretmek için dersler",
		"goal_surviving_puppy": "Küçük dostunuzla geçen ilk günlere hazırlanmanıza yardımcı olacak dersler",
		"goal_socializing_puppy": "Tüy dostunuzu sosyal hale getirmenize yardımcı olacak dersler",
		"goal_teaching_obedience": "Tüylü arkadaşınıza terbiye ve itaat etmeyi öğretmek için dersler",
		"age_puppy": "Size mutlu ve iyi huylu bir yavru yetiştirmenize yardımcı olacak uzmanlardan detaylı eğitim ipuçları",
		"age_adult": "Köpeğinizi en etkili şekilde eğitmenize yardımcı olacak uzmanlarımızdan detaylı eğitim ipuçları",
		"biting_yes": "Köpeğinizin ısırmasını durdurmak için adım adım talimatlar",
		"biting_no": "Köpeğinizle oynayabileceğiniz eğlenceli oyunlar",
		"biting_sometimes": "Köpeğinizin ısırmasını engellemek için adım adım talimatlar",
		"quick_tips": "Yeni komutları öğrenmek için hızlı ve kolay ipuçları",
		"potty_training_a_bit": "Köpeğinizi etkili bir şekilde tuvalet eğitimi vermek için özel bir rehber",
		"potty_training_yes": "Köpeğinize yeni eğlenceli numaralar öğretmek için özel kılavuzlar",
		"potty_training_no": "Köpeğinizi etkili bir şekilde tuvalet eğitimi vermek için özel bir rehber",
		"success screen": "",
		"success_screen_text_1": "Satın aldığınız için teşekkürler!",
		"success_screen_text_2": "Hesabınızı ayarlamak için aşağıdaki<br />talimatları izleyin:",
		"success_screen_text_3": "Hesabınıza git",
		"success_screen_text_4": "<b>QR kodunu</b> tara veya <b>bağlantıya</b> dokunun",
		"success_screen_text_5": "<b>Uygulamayı</b> indirin",
		"success_screen_text_6": "<b>Uygulamayı açın</b> ve <b>keyfini çıkarın</b><br />köpeğinizle eğitime!",
		"success_screen_text_7": "Sizin için QR kodu ve bağlantıyı &nbsp;<b>example@gmail.com</b> adresinde kopyaladık",
		"success_screen_text_8": "Premium hesap uygulamada uygulanmadıysa, karşılama ekranında <b>‘Bize Ulaşın’</b> butonuna basarak destek ekibimizle iletişime geçin.",
		"success_screen_text_9": "‘Başla’ butonuna basarak, <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Gizlilik Politikasını</a> ve <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Şartlar ve Koşulları</a> gözden geçirdiğimi ve kabul ettiğimi onaylıyor, kişisel verilerimin işlenmesine burada onay veriyorum.",
		"success_screen_text_10": "Bize ulaşın",
		"success_screen_text_11": "Hesabıma git",
		"success_screen_text_12": "Size e-posta ile tekrarlanan bir QR kodu ve bağlantı gönderdik.",
		"success_screen_text_13": "PDF kılavuzunuz e-posta adresinize <b>v.stsiopina@gmail.com</b> gönderildi.",
		"success_screen_text_14": "PDF rehberiniz e-posta adresinize gönderildi.",
		"success_screen_text_15": "Eğer premium hesap uygulamada uygulanmadıysa, uygulamanın hoş geldin ekranındaki <span>'Giriş yap'</span> bağlantısına tıklayın ve size <b>stepinavalerie@gmail.com</b> adresine gönderdiğimiz e-posta ve şifreyi girin.",
		"success_screen_text_16": "Eğer premium hesap uygulamada geçerli değilse, uygulamanın hoş geldin ekranında <span>'Giriş yap'</span> bağlantısına basın ve size e-posta ile gönderdiğimiz e-posta adresi ve şifreyi girin.",
		"payment_text_1": "Köpek eğitiminiz şimdi başlıyor!",
		"payment_text_2": "Everydoggy uygulaması, <span>köpeğinizin davranış sorunlarını hızlı ve eğlenceli bir şekilde çözmenize yardımcı olacaktır</span>.",
		"payment_text_3": "Kişisel teklif süresi doluyor",
		"payment_text_4": "kullanıcılarımız, uzmanlarımızla eğitim almaya başladıktan sadece 1 hafta sonra köpeklerinde olumlu değişiklikler fark ediyorlar",
		"payment_text_5": "HerKöpek vs Koçlar",
		"payment_text_6": "Ayda ortalama komut sayısı",
		"payment_text_7": "HerKöpek fayda sağlar",
		"payment_text_8": "Kişiselleştirilmiş köpek eğitimi planı",
		"payment_text_9": "Mükemmel bir evcil hayvan için günde sadece 15 dakika",
		"payment_text_10": "Hızlı sonuçlar için 70'ten fazla anlaşılır video eğitim dersi",
		"payment_text_11": "Yeni beceriler için 80'den fazla oyun ve hile, sadece eğlence için",
		"payment_text_12": "Hijyen, sağlık ve beslenme ipuçları",
		"payment_text_13": "Evde ve dışarıda antrenman yapın, ekipmana ihtiyaç yok",
		"payment_text_14": "Kullanıcılarımızın %98'i, uzmanlarımızla eğitime başladıktan sadece 1 hafta sonra köpeklerinin davranışlarında olumlu değişiklikler fark ediyor.",
		"payment_text_14_2": "<span>Kullanıcılarımızın %98'i</span>, uzmanlarımızla eğitim almaya başladıktan sadece 1 hafta sonra köpeklerinin davranışında olumlu değişiklikler fark ediyor",
		"payment_text_15": "“Planımı Al” butonuna tıklayarak, bizim <a href='https://everydoggy.com/terms/' target=\"_blank\" >Şartlar ve Koşullar</a> ve <a href='https://everydoggy.com/policy/' target=\"_blank\" >Gizlilik Politikasını</a> kabul etmiş olursunuz, <b>aboneliğinizin otomatik olarak yenilenmesini onaylıyorsunuz</b> her bir faturalama döngüsünün sonunda <span>1 ay</span> için tam fiyatı <i>$29.99</i> ve uygulanabilir vergileri ödeyerek. Yenileme tarihinden önce aboneliğinizin otomatik yenilenmesini istediğiniz zaman iptal edebilirsiniz. Daha fazla ayrıntı için <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >İptal Şartlarımızı</a> kontrol ediniz.",
		"payment_text_16": "“Planımı al” butonuna tıklayarak, <a href='https://everydoggy.com/terms/' target='_blank'>Şartlar ve Koşullarımızı</a> ve <a href='https://everydoggy.com/policy/' target='_blank'>Gizlilik Politikasını</a> kabul ediyorsunuz ve <b>aboneliğinizin her faturalama döngüsünün sonunda otomatik olarak yenilenmesine izin veriyorsunuz</b> <span>1 ay</span> için toplam fiyat <i>$29.99</i> artı uygulanabilir vergiler. Yenileme tarihinden önce aboneliğinizin otomatik yenilemesini istediğiniz zaman iptal edebilirsiniz. Daha fazla bilgi için <a href='https://everydoggy.com/subscription-terms/' target='_blank'>İptal Şartlarını</a> kontrol edin.",
		"payment_text_17": "Bir sorunuz var mı?",
		"payment_text_18": "Bize yalnızca şu adrese yazın ",
		"payment_text_19": "Çalışıyor!",
		"payment_text_20": "Köpeğimizle itaat eğitim programını yeni bitirdim, bayıldım! 👏",
		"payment_text_21": "Harika!",
		"payment_text_22": "Bu uygulamadan 💯 memnun olduğumu söyleyebilirim. Artık tuvalet sorunu yok, vay canına!",
		"payment_text_23": "Harika bir uygulama 🎉",
		"payment_text_24": "Köpeğimle eğitimin 3. ayındayız ve köpeğimin becerileri muazzam bir gelişim gösterdi!",
		"payment_text_25": "Denemeye değer",
		"payment_text_26": "Bir köpeği eğitmek için uzak ara en iyi uygulama!",
		"payment_text_27": "Kullanıcılarımızdan ilham alın",
		"payment_text_28": " Star Focus, Inc.",
		"payment_text_29": "Hâlâ sorularınız varsa bize <a href=\"mailto:welove@everydoggy.com\">welove@everydoggy.com</a> adresinden yazabilirsiniz.",
		"payment_text_30": "Sadece 7 günlük eğitimde gözle görülür sonuçlar",
		"payment_text_31": "Özel indirim ile kişisel planınızı alın",
		"payment_text_32": "Eğitime ne kadar erken başlarsanız o kadar iyi sonuçlar elde edersiniz",
		"payment_text_33": "Eğitim her köpek için gereklidir. Eğitim sadece davranış problemlerini ortadan kaldırmakla ilgili değil, aynı zamanda sosyalleşmek, köpeğinizle bir bağ kurmak ve sevginizi ifade etmekle de ilgilidir.",
		"payment_text_34": "Köpek sevgisiyle, köpek sevgisi için yaratıldı. Birinci sınıf uzmanlığa dayalıdır",
		"payment_text_35": "Uygulamada bulacağınız her şey en son araştırmalardan yararlanılarak hazırlanmıştır ve tamamen köpekleri merkeze alır.",
		"payment_text_36": "Köpeğiniz konuşabilseydi EveryDoggy'yi denemenizi isterdi!",
		"payment_text_37": "Bilgileriniz güvende",
		"payment_text_38": "Kişisel iletişim bilgilerinizi herhangi bir pazarlama amacıyla satmayız veya kiralamayız.",
		"payment_text_39": "Güvenli ödeme",
		"payment_text_40": "Tüm bilgiler şifrelenir ve risksiz bir şekilde iletilir.",
		"payment_text_41": "Yardıma mı ihtiyacınız var?",
		"payment_text_42": "Bize bir e-posta gönderin: <a href=\"mailto:welove@everydoggy.com\">welove@everydoggy.com</a>",
		"payment_text_43": "aylık",
		"payment_text_44": "devam et",
		"payment_text_45": "Kişiselleştirilmiş Planınız:",
		"payment_text_46": "Başlangıç teklifi indirimi:",
		"payment_text_47": "Devam ederek şunları kabul etmiş olursunuz: <a href='https://everydoggy.com/terms/' target='_blank' rel=\"noreferrer\">Kullanım Şartları</a>, <a href='https://everydoggy.com/policy/' target='_blank' rel=\"noreferrer\">Gizlilik Politikası</a> ve <a href='https://everydoggy.com/subscription-terms/#subscription_cancellation' target='_blank' rel=\"noreferrer\">İptal Şartları</a>",
		"payment_text_48": "Aboneliğiniz şu tarihe kadar sürer:",
		"payment_text_49": "Aboneliğinizi, abonelik sürenizin sona ermesinden en az 24 saat öncesine kadar dilediğiniz zaman ücretsiz olarak iptal edebilirsiniz.",
		"payment_text_50": "İptal etmediğiniz takdirde üyeliğiniz, 1 aylık aboneliğinizin sonunda otomatik olarak yenilenecektir. Siz iptal işlemini gerçekleştirene dek EveryDoggy'nin üyelik ücreti olan <b>$</b><i>$29.99</i> sizden tahsil edilecektir.",
		"payment_text_51": "Şu anda kısmi üyelikler için para iadesi veya kredi seçenekleri sunmuyoruz.",
		"payment_text_52": "Kişisel eğitmen",
		"payment_text_53": "Köpek okulu",
		"payment_text_54": "YouTube dersleri",
		"payment_text_55": "Kitaplar",
		"payment_text_56": "haftalık",
		"payment_text_57": "Önemli ölçüde daha iyi sonuçlar",
		"payment_text_58": "EveryDoggy ile",
		"payment_text_59": "EveryDoggy olmadan",
		"payment_text_60": "Şimdi",
		"payment_text_61": "1 hafta sonra",
		"payment_text_62": "Bu son şansınız",
		"payment_text_63": "%65 oranındaki özel indirimi kaçırmayın ve köpeğinizin komutları ne kadar hızlı öğrenip yerine getirebildiğini keşfedin!",
		"payment_text_64": "%65 indirim elde edin",
		"payment_text_65": "52 HAFTALIK PLAN",
		"payment_text_66": "4 HAFTALIK PLAN",
		"payment_text_67": "12 HAFTALIK PLAN",
		"payment_text_68": "hafta",
		"payment_text_69": "Ocak",
		"payment_text_70": "Şubat",
		"payment_text_71": "Mart",
		"payment_text_72": "Nisan",
		"payment_text_73": "Mayıs",
		"payment_text_74": "Haziran",
		"payment_text_75": "Temmuz",
		"payment_text_76": "Ağustos",
		"payment_text_77": "Eylül",
		"payment_text_78": "Ekim",
		"payment_text_79": "Kasım",
		"payment_text_80": "Aralık",
		"payment_text_81": "Lütfen geçerli bir e-posta adresi girin",
		"payment_text_82": "",
		"payment_text_83": "Başlangıç döneminiz <b>11 Ekim 2024</b> tarihine kadar sürecektir.",
		"payment_text_84": "<b>10 Ekim 2024</b> tarihinden önce istediğiniz zaman iptal edebilirsiniz, ücret alınmayacaktır.",
		"payment_text_85": "İptal etmezseniz, Everydoggy üyeliğinizi tanıtım döneminizin sonunda otomatik olarak devam ettirecek ve siz iptal edene kadar üyelik ücretini (şu anda <b> 39,99 USD</b>) <span>aylık olarak</span> tahsil edecektir.",
		"payment_text_86": "",
		"payment_text_87": "",
		"payment_text_88": "Ödeme yöntemi",
		"payment_text_89": "",
		"payment_text_90": "",
		"payment_text_91": "",
		"payment_text_92": "",
		"payment_text_93": "Ödeme bilgileriniz SSL/TLS şifrelemesiyle güvenlidir",
		"payment_text_94": "",
		"payment_text_95": "",
		"payment_text_96": "",
		"payment_text_97": "",
		"payment_text_98": "",
		"payment_text_99": "",
		"payment_text_100": "",
		"payment_text_101": "",
		"payment_text_102": "",
		"payment_text_103": "Planımı al' düğmesine tıklayarak <a href='https://everydoggy.com/policy/' target=\"_blank\" >Gizlilik Politikasını</a>, <a href='https://everydoggy.com/terms/' target=\"_blank\" >Şartlar ve Koşulları</a> ve <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >İptal Şartlarını</a> kabul etmiş olursunuz",
		"payment_text_104": "Kolay ve özel ödemeler",
		"payment_text_105": "Kredi Kartı",
		"payment_text_106": "Son kullanma tarihi",
		"payment_text_107": "CVC",
		"payment_text_108": "harika başlangıç",
		"payment_text_109": "1 haftalık plan",
		"payment_text_110": "Everydoggy uygulaması, <span>tuvalet sorunlarını ve diğer köpek davranışı problemlerini</span> hızla ve eğlenceli bir şekilde çözmeye yardımcı olur.",
		"payment_text_111": "Güvenli ödeme",
		"payment_text_112": "<span>Köpeğiniz</span> için kişiselleştirilmiş eğitim planı",
		"payment_text_113": "Eğitim için düdük ve tıklama cihazı",
		"payment_text_114": "Evcil hayvanınız için 80'i aşkın oyun ve numara",
		"payment_text_115": "30'u aşkın sağlık ipucu ve makalesi",
		"payment_text_116": "🔥 Az önce <span>$113.50&nbsp;</span> tasarruf ettiniz 🔥",
		"payment_text_117": "7 Günlük plan",
		"payment_text_118": "\"Planımı al\" düğmesine tıklayarak, <a href='https://everydoggy.com/terms/' target=\"_blank\" >Şartlar ve Koşullarımızı</a> ve <a href='https://everydoggy.com/policy/' target=\"_blank\" >Gizlilik Politikamızı</a> kabul etmiş ve aboneliğinizin <b>otomatik yenilenmesine yetki vermiş</b> olursunuz. Bugün, tanıtım döneminizin ilk <span class=\"trialPeriod\">7 günü</span> için yalnızca <span class=\"trialPrice\">4,99 $</span> ücretlendirileceksiniz. İptal etmezseniz, Everydoggy tanıtım döneminizin sonunda üyeliğinizi otomatik olarak devam ettirecek ve siz iptal edene kadar her <span class='period'>ay</span> <span class='price'>39,99 $</span> üyelik ücreti tahsil edecektir. Aboneliğinizin otomatik yenilenmesini yenileme tarihinden önce istediğiniz zaman iptal edebilirsiniz. Daha fazla ayrıntı için İptal Koşullarımıza bakın.",
		"payment_text_119": "7 gün",
		"payment_text_120": "Bugün ilk <span>12 haftanız</span> için yalnızca <b>29,99 $</b> ücretlendirileceksiniz (ayrıntılar aşağıda)",
		"payment_text_121": "Everydoggy uygulaması, köpeğinizin doğru yerde <span>tuvaletini yapması</span> konusunda <span>onu eğitmenizde</span> size yardımcı olacak ve <span>davranış sorunlarını</span> hızlı ve eğlenceli bir şekilde çözecektir.",
		"payment_text_122": "3 günde tuvalet eğitimi almış bir köpek",
		"payment_text_123": "Hesabınız bu e-postaya bağlıdır ve değiştirilemezdir",
		"payment_text_124": "Devam ederek <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Hüküm ve Koşullarımızı</a> ve <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Gizlilik Politikamızı</a> kabul eder ve <span>aboneliğinizin otomatik yenilenmesine izin verirsiniz</span>.",
		"payment_text_125": "26 HAFTALIK PLAN",
		"payment_text_126": "İptal etmezseniz, Everydoggy üyeliğinizi tanıtım döneminizin sonunda otomatik olarak devam ettirecek ve siz iptal edene kadar üyelik ücretini (şu anda <b>39,99 USD</b>) <span>her 3 ayda bir</span> tahsil edecektir.",
		"payment_text_127": "İptal etmezseniz, Everydoggy üyeliğinizi tanıtım döneminizin sonunda otomatik olarak devam ettirecek ve siz iptal edene kadar üyelik ücretini (şu anda <b>39,99 USD</b>) <span>her 6 ayda bir</span> tahsil edecektir.",
		"payment_text_128": "Mevcut seviye",
		"payment_text_129": "komut",
		"payment_text_130": "Hedef",
		"payment_text_131": "50+ komut ve itaat",
		"payment_text_132": "Gözle görülür bir ilerleme yaşayın",
		"payment_text_133": "İtaaat elde edin",
		"payment_text_134": "Köpeğinizi ömür boyu iyi eğitilmiş halde tutun",
		"payment_text_135": "%53 tasarruf edin",
		"payment_text_136": "Para İade Garantisi",
		"payment_text_137": "30 Günlük Para İade Garantisi",
		"payment_text_138": "Planımızın sizin için işe yarayabileceğine ve 4 hafta içinde gözle görülür sonuçlar alacağınıza inanıyoruz! Eğer görünür sonuçlar görmezseniz ve planımızı uyguladığınızı gösterebilirseniz paranızı iade etmeye bile hazırız.",
		"payment_text_139": "<a href=\"https://everydoggy.com/terms/#section5_2\" target=\"_blank\" rel=\"noreferrer\">Kullanım şartlarımızda</a> geçerli sınırlamalar hakkında daha fazla bilgi edinin.",
		"payment_text_140": "%65 tasarruf edin",
		"payment_text_141": "Köpeğinin Eğitim Planı Hazır!",
		"payment_text_142": "İtaat",
		"payment_text_143": "Komutları Biliyor",
		"payment_text_144": "Tuvalet Kazaları",
		"payment_text_145": "Sık",
		"payment_text_146": "Hiç",
		"payment_text_147": "Havlama",
		"payment_text_148": "Her şeye havlıyor",
		"payment_text_149": "Sessiz ve Sakin",
		"payment_text_150": "Isırma ve çiğneme",
		"payment_text_151": "Sık",
		"payment_text_152": "Durdu",
		"payment_text_153": "Tasmayı çekme",
		"payment_text_154": "Her zaman",
		"payment_text_155": "Sakince yürüyor",
		"payment_text_156": "Yalnız Kaldığında Kaygı",
		"payment_text_157": "Sakin ve bağımsız",
		"payment_text_158": "Önce",
		"payment_text_159": "Sonra",
		"payment_text_160": "dakika",
		"payment_text_161": "saniye",
		"payment_text_162": "Kanıtlandı. Test Edildi. İşe Yarıyor",
		"payment_text_163": "Köpeğinizin eğitilmesinde önemli değişiklikler",
		"payment_text_164": "Bugün",
		"payment_text_165": "2. Hafta",
		"payment_text_166": "3. Hafta",
		"payment_text_167": "4. Hafta",
		"payment_text_168": "Everydoggy'yi bu kadar etkili yapan şey",
		"payment_text_169": "Kullanıcılarımızın başarı hikayeleri",
		"payment_text_170": "<span>Köpekleri Seven</span> Uzmanlar Tarafından Hazırlandı",
		"payment_text_171": "Her kursumuz ve dersimiz, köpek eğitimi üzerine yapılan bilimsel çalışmalara dayanmaktadır.",
		"payment_text_172": "Köpeğinizle güçlü bir bağ kurun, EveryDoggy'yi deneyin!",
		"payment_text_173": "Kanıtlandı. Test Edildi. İşe Yarıyor",
		"payment_text_174": "<span>Kullanıcılarımızın %93'ü</span>, eğitimin ilk ayında köpeklerinin davranışlarında kayda değer değişiklikler fark ediyor.",
		"payment_text_175": "EveryDoggy ile",
		"payment_text_176": "EveryDoggy olmadan",
		"payment_text_177": "Bugün",
		"payment_text_178": "2. Hafta",
		"payment_text_179": "4. Hafta",
		"payment_text_180": "6. Hafta",
		"payment_text_181": "Luna Hakkında",
		"payment_text_182": "Yavru köpeğim evde sürekli kazalar yaşıyordu. Everydoggy bize net bir rutin sağladı ve bu gerçekten işe yaradı!",
		"payment_text_183": "Cooper Hakkında",
		"payment_text_184": "Yavru köpeğimiz oyun sırasında herkesi ısırırdı. Uygulama bize adım adım rehberlik etti ve bu işe yaradı!",
		"payment_text_185": "Bella Hakkında",
		"payment_text_186": "Köpeğimiz ayakkabılardan kanepeye kadar her şeyi çiğniyordu. Uygulama bu enerjiyi başka tarafa yönlendirmemize yardımcı oldu!",
		"payment_text_187": "Charlie Hakkında",
		"payment_text_188": "Tasma çekme konusu her gün bize zorluk çkarıyordu. Uygulama sayesinde, yürüyüşler artık keyifli ve stressiz.",
		"payment_text_189": "Tuvalet eğitimi",
		"payment_text_190": "Isırma sorunu çözüldü",
		"payment_text_191": "Çiğneme sorunu çözüldü",
		"payment_text_192": "Tasma çekme sorunu çözüldü",
		"payment_text_193": "<span>Kullanıcılarımızın %93'ü</span>, eğitimin ilk ayında <span>köpeklerinin davranışlarında ve itaatinde</span> önemli değişiklikler fark ediyor.</span>",
		"payment_text_194": "Kullanıcılarımız sonuçlara hayran kalıyor!",
		"payment_text_195": "Köpeğinizle hemen eğitime başlayın!",
		"payment_text_196": "İptal etmezseniz, Everydoggy tanıtım sürenizin sonunda üyeliğinizi otomatik olarak devam ettirecek ve iptal edene kadar üyelik ücretini (şu anda <b>$39,99 USD</b>) <span>iki haftada bir</span> tahsil edecektir.",
		"payment_text_197": "Para İade Garantisi",
		"payment_text_198": "30 Günlük Para İade Garantisi",
		"payment_text_199": "Planımızın sizin için işe yarayabileceğine ve 4 hafta içinde gözle görülür sonuçlar alacağınıza inanıyoruz! Eğer görünür sonuçlar görmezseniz ve planımızı uyguladığınızı gösterebilirseniz paranızı iade etmeye bile hazırız.",
		"payment_text_200": "<a href=\"https://everydoggy.com/terms/#section5_2\" target=\"_blank\" rel=\"noreferrer\">Kullanım şartlarımızda</a> geçerli sınırlamalar hakkında daha fazla bilgi edinin.",
		"payment_text_201": "Çok sık sorulan bir soru:",
		"payment_text_202": "Eğitimlerden sonuç almak ne kadar sürer?",
		"payment_text_203": "Çoğu köpek daha ilk seanstan sonra ilerleme gösterir ve birkaç hafta içinde gözle görülür ve önemli sonuçlar elde edilir!",
		"payment_text_204": "Everydoggy uygulaması bir eğitmenle çalışmak kadar etkili mi?",
		"payment_text_205": "Evet, hatta çok daha etkilidir. Sadece haftada bir eğitmenle yapılan derslerle sınırlı kalmadan kendi temponuzda her gün eğitim alabilir, adım adım ilerleyen açıklayıcı dersleri takip edebilir ve öğrendiklerinizi düzenli olarak pekiştirebilirsiniz.",
		"payment_text_206": "Eğitim sonuçları kalıcı mı?",
		"payment_text_207": "Evet! İyi davranışları pekiştirmeye devam ettiğiniz sürece sonuçlar kalıcı olur.",
		"payment_text_208": "%72 indirim elde edin",
		"payment_text_209": "%72 oranındaki özel indirimi kaçırmayın ve köpeğinizin komutları ne kadar hızlı öğrenip yerine getirebildiğini keşfedin!",
		"payment_text_210": "Başka bir ödeme yöntemiyle devam edin",
		"payment_text_211": "Buy with",
		"payment_text_212": "MUHTEŞEM CUMA İNDİRİMİ!",
		"payment_text_213": "",
		"payment_text_214": "",
		"payment_text_215": "",
		"payment_text_216": "",
		"payment_text_217": "",
		"payment_text_218": "Yavru köpek eğitim programınız şimdi başlıyor!",
		"payment_text_219": "Everydoggy uygulamasıyla <span>yavru köpeğinizin en erken günlerinden</span> itibaren eğitin ve <span>kusursuz uslu bir köpek</span> elde edin!",
		"payment_text_220": "uzmanlarımızla eğitime başladıktan sadece 1 hafta sonra kullanıcılarımız yavru köpeğinin davranışında olumlu değişimler fark ediyor",
		"payment_text_221": "6 aydan küçük yavru köpekler için kişiselleştirilmiş eğitim planı",
		"payment_text_222": "6–12 aylık yavru köpekler için kişiselleştirilmiş eğitim planı",
		"payment_text_223": "3 Milyon Yavru Köpekle Kanıtlandı",
		"payment_text_224": "Bir köpeğin itaatinde belirgin değişimler",
		"payment_text_225": "%70 indirim elde edin",
		"payment_text_226": "SON ŞANS!\r",
		"payment_text_227": "24 HAFTALIK PLAN",
		"payment_text_228": "İhtiyacınız olan son köpek eğitimi programı şimdi başlıyor!",
		"payment_text_229": "Kalıcı sonuçlar için kişiselleştirilmiş köpek eğitimi plan\n",
		"payment_text_230": "Tek program.<br />\nÖmür boyu iyi davranış",
		"payment_text_231": "Köpeğin yaşı",
		"payment_text_232": "Eğitim süresi",
		"payment_text_233": "Kalıcı sonuçlar",
		"payment_text_234": "0-1 yaş",
		"payment_text_235": "1-3 yaş",
		"payment_text_236": "3-5 yaş",
		"payment_text_237": "5+ yaş",
		"payment_text_238": "1-2 yıl",
		"payment_text_239": "3 yıl",
		"payment_text_240": "4 yıl",
		"payment_text_241": "2-7 yıl",
		"payment_text_242": "8 yıl",
		"payment_text_243": "9 yıl",
		"payment_text_244": "10+ yıl",
		"payment_text_245": "",
		"payment_text_246": "",
		"payment_text_247": "",
		"payment_text_248": "",
		"payment_text_249": "",
		"payment_text_250": "",
		"payment_text_251": "",
		"payment_text_252": "",
		"payment_text_253": "",
		"payment_text_254": "",
		"payment_text_255": "",
		"payment_text_256": "",
		"payment_text_257": "",
		"payment_text_258": "",
		"payment_text_259": "",
		"payment_text_260": "",
		"payment_text_261": "",
		"payment_text_262": "",
		"payment_text_263": "Köpek Çevirmeni",
		"payment_text_264": "Köpeğinizi anlayın.<br/> Sonuçları görün",
		"payment_text_265": "Sinyal ve davranış analiziyle itaat eğitimi gelişir",
		"payment_text_266": "Köpeğinizin havlaması ve davranışlarının analizine dayalı kişiselleştirilmiş eğitim planı",
		"payment_text_267": "İki kat daha hızlı, <br />iki kat daha keyifli!",
		"payment_text_268": "En kapsamlı yavru köpek eğitim rehberini alın",
		"payment_text_269": "En kapsamlı köpek eğitim rehberini alın",
		"payment_text_270": "Tuvalet sorunlarına veda edin! Adım adım yöntemlerle köpeğinize doğru tuvalet alışkanlığını hızla kazandırın.",
		"payment_text_271": "Ayakkabılarınızı ve parmaklarınızı koruyun! Yavru köpeğinizin ısırma ve her şeyi kemirme alışkanlığını basit yöntemlerle bırakmasına yardımcı olun.",
		"payment_text_272": "Köpeğiniz için güvenli ve huzurlu bir alan oluşturun, aynı zamanda kafeste sakin ve rahat kalmayı öğretin.",
		"payment_text_273": "Davranış, itaat ve köpeğinizle günlük yaşam için uzman ipuçlarından oluşan eksiksiz bir rehbere erişin.",
		"payment_text_274": "Evde ve yürüyüşlerde istenmeyen davranışları, etkili ve kolay uygulanabilir yöntemlerle düzeltin.",
		"payment_text_275": "Öğrenmeyi keyifli hâle getirin! Köpeğinizi hemen motive etmek için övgü ve ödülü doğru kullanmayı öğrenin.",
		"payment_text_276": "Köpeğinize temel komutlardan fazlasını öğretin! Güvenlik için gerekli komutlardan her yaştan köpek için etkileyici numaralara kadar her şeyi öğrenin.",
		"payment_text_277": "Köpeğinizin<br /> gelişimini <span>2 kat hızlandırın!</span>",
		"payment_text_278": "Pratik rehber:",
		"payment_text_279": "İNDİRİM 98% yalnızca üyelere özel",
		"payment_text_280": "İNDİRİM 70% yalnızca üyelere özel",
		"payment_text_281": "Köpeğiniz için veteriner destek programınız şimdi başlıyor!",
		"payment_text_282": "Everydoggy’nin <span>uzman veteriner desteğiyle</span> köpeğinizin sağlığına iyi bakın ve <span>sağlıklı, uslu bir köpek yetiştirin</span>, daha az endişeyle!",
		"payment_text_283": "Anında veteriner sohbet desteği — randevu yok, bekleme yok",
		"payment_text_284": "Daha doğru yönlendirme almak için fotoğraf paylaşın",
		"payment_text_285": "Sıcak çarpması, yaralanmalar veya donma gibi acil durumlar için ilk yardımı öğrenin",
		"payment_text_286": "Güncel aşı ve kontrol takvimlerini takip edin",
		"payment_text_287": "Dişler, kulaklar, gözler, tırnaklar, iç parazit uygulamaları ve daha fazlası için bakım ipuçları alın",
		"payment_text_288": "Köpeğinizin sağlığı konusunda kendinizden daha emin olun ve her gün daha az endişe duyun",
		"payment_text_289": "Everydoggy VET’i bu kadar etkili yapan şey ne",
		"payment_text_290": "3M+ köpek sahibi tarafından tercih ediliyor",
		"payment_text_291": "Güvenebileceğiniz veteriner desteğiyle istediğiniz zaman sohbet edin",
		"payment_text_292": "Köpeğinizi Everydoggy uygulamasıyla eğitin ve <span>mükemmel terbiyeli bir dostun</span> tadını çıkarın!",
		"payment_text_293": "3 milyon köpek üzerinde kanıtlandı",
		"payment_text_294": "Köpeğinize özel hazırlanmış kişisel eğitim planı",
		"payment_text_295": "Yavru köpeğim ishal olduğunda bir veterinerden hızlıca tavsiye aldım ve tam olarak ne yapmam gerektiğini öğrendim. Bu bana çok stres yaşatmadı, aksine büyük bir rahatlama sağladı.",
		"payment_text_296": "Tavsiyeler net ve güvenilir. Her zaman güvenebileceğim bir uzmanın yanımda olduğunu hissediyorum.",
		"payment_text_297": "Köpeğimin cildinde tahriş ve sürekli kaşınma olduğunda kullandım. Yönlendirmeler çok açıktı ve hemen içim rahatladı.",
		"payment_text_298": "Yeni bir yavru köpek sahibi olarak bu benim için inanılmaz faydalı oldu. Artık tahmin yürütmek zorunda kalmıyorum.",
		"payment_text_299": "kullanıcılarımız veteriner desteğimiz sayesinde köpeklerinin sağlığı konusunda kendini daha güvende hisseder ve daha az endişelenir",
		"payment_text_300": "<span>Kullanıcılarımızın %98’i</span> veteriner desteğimiz sayesinde köpeklerinin sağlığı konusunda kendini daha güvende hissediyor ve daha az endişeleniyor",
		"payment_text_301": "Köpeğiniz için kişiselleştirilmiş oyun ve iletişim programınız <span>şimdi başlıyor</span>!",
		"payment_text_302": "Everydoggy ile <span>köpeğinizi daha iyi anlayacaksınız</span>, <span>birlikte daha çok keyif alacaksınız</span> ve <span>kalıcı bir bağ kuracaksınız</span>!",
		"payment_text_303": "3M+ kullanıcı",
		"payment_text_304": "Köpekleriyle hayatın tadını çıkarıyor",
		"payment_text_305": "Şimdi",
		"payment_text_306": "Köpeğinizi anlama",
		"payment_text_307": "Köpeğinizle iletişim",
		"payment_text_308": "Oyundan keyif alma",
		"payment_text_309": "Bağ",
		"payment_text_310": "Köpeğinizle iletişim ve oyun için kişiselleştirilmiş program",
		"payment_text_311": "Köpeğinizin havlamalarını AI Havlama ile çevirin ve anlayın",
		"payment_text_312": "🎁 Hoş geldin indiriminiz uygulandı:",
		"payment_text_313": "<span>53%</span> İNDİRİM",
		"payment_text_314": "Köpeğinize özel eğitim programınız şimdi başlıyor!",
		"payment_text_315": "Hızlı sonuçlar görün ve iyi davranışlı bir köpekle hayatın tadını çıkarın!",
		"payment_text_316": "Öğrenilen komutlar:",
		"payment_text_317": "İtaat seviyesi:",
		"payment_text_318": "Düşük",
		"payment_text_319": "Yüksek",
		"payment_text_320": "<span>Köpeğiniz</span> için kişiselleştirilmiş eğitim programı hazır!",
		"payment_text_321": "Eğitim profili",
		"payment_text_322": "Köpeğin ırkı",
		"payment_text_323": "Yaş",
		"payment_text_324": "Davranış sorunları",
		"payment_text_325": "Mevcut seviye",
		"payment_text_326": "3 milyondan fazla",
		"payment_text_327": "köpek sahibi sonuçların keyfini çıkarıyor",
		"payment_text_328": "Ashley K. ve Moly",
		"payment_text_329": "Günlük eğitim görevlerinin bu kadar basit olmasına bayılıyorum. Köpeğim artık gerçekten dinliyor!",
		"payment_text_330": "Kevin R. ve Tommy",
		"payment_text_331": "Tuvalet eğitimi en büyük zorluğumuzdu. Gerçekten işe yarayan tek şey bu program oldu.",
		"payment_text_332": "Chloe N. ve Ami",
		"payment_text_333": "Yavru köpeğim eskiden her şeyi kemirirdi. Şimdi sadece oyuncaklarına yöneliyor!",
		"payment_text_334": "Daniel H. ve Cherry",
		"payment_text_335": "Her şeyin küçük adımlara bölünmesini sevdim. Köpeğim komutları beklediğimden daha hızlı öğrendi.",
		"payment_text_336": "Yavru köpeğiniz için stressiz eğitim planınız şimdi başlıyor!",
		"payment_text_337": "Köpeğiniz için stressiz eğitim planınız şimdi başlıyor!",
		"payment_text_338": "Köpeğinizin kişiselleştirilmiş beslenme ve sağlık planı şimdi başlıyor!",
		"payment_text_339": "Köpek maması etiketlerini tarayın, uzman beslenme tavsiyeleri alın ve köpeğinizin <span>sağlıklı ve mutlu</span> kalmasına yardımcı olun!",
		"payment_text_340": "Mama etiketlerini tarayın. Köpeğinizin sağlığını koruyun",
		"payment_text_341": "Köpek maması etiketlerini tarayın; içerikleri ve kaliteyi hızlıca anlayın",
		"payment_text_342": "Köpeğinizin ihtiyaçlarına göre uyarlanmış beslenme önerileri alın",
		"payment_text_343": "Mama etiketi tarayıcısı gerçekten oyunu değiştirdi. Köpeğimin mamasında gerçekte ne olduğunu anında biliyorum.",
		"payment_text_344": "Köpeğimin sağlığını takip etmek ve beslenmesini iyileştirmek için harika bir araç. Sonuçlar fark ediliyor!",
		"payment_text_345": "Bu uygulama köpeğimin beslenmesini yönetmeyi çok daha kolay hale getirdi. Kişiselleştirilmiş ipuçlarına bayılıyorum!",
		"payment_text_346": "Sanki köpeğimin dilini öğrenmişim gibi — artık havlamaları bile anlamlı geliyor.",
		"payment_text_347": "Oyunlar harika. Köpeğim her seferinde çok heyecanlanıyor!",
		"payment_text_348": "Oynuyoruz, bağ kuruyoruz ve sonunda köpeğimin bana ne anlatmak istediğini anlıyorum!",
		"payment_text_349": "kullanıcılarımızın köpeklerinin sağlığı konusunda kendilerini daha güvende hissetmelerini ve uygulamamız sayesinde daha az endişelenmelerini sağlıyor",
		"payment_text_350": "EveryDoggy’yi bu kadar etkili yapan şey ne",
		"payment_text_351": "<span>Kullanıcılarımızın %98’i</span> köpeklerinin sağlığı konusunda daha güvende hissediyor ve planımızla daha az endişeleniyor",
		"payment_text_352": "Başlangıç",
		"payment_text_353": "Küçük köpeğiniz için kişiselleştirilmiş eğitim programınız şimdi başlıyor!",
		"payment_text_354": "Köpeğiniz için kişiselleştirilmiş K9 eğitim programınız şimdi başlıyor!",
		"payment_text_355": "Hızlı sonuç alın: köpeğiniz ilk komutta dinlesin.",
		"payment_text_356": "Sadece birkaç haftada büyük fark oldu. Köpeğim sonunda ilk seferde dinliyor.",
		"payment_text_357": "Köpeğimi gezdirmek artık stresli değil. Kontrol tamamen bende.",
		"payment_text_358": "Kaostan sakin davranışa çok hızlı geçtik. Harika bir program.",
		"payment_text_359": "İlk komutta itaat gerçekten işe yarıyor. Bunun mümkün olduğunu düşünmemiştim.",
		"payment_text_360": "Köpekler için kişiselleştirilmiş K9 eğitim planı",
		"payment_text_361": "",
		"payment_text_362": "",
		"payment_text_363": "",
		"payment_text_364": "",
		"payment_text_365": "",
		"payment_text_366": "",
		"payment_text_367": "",
		"payment_text_368": "",
		"payment_text_369": "",
		"payment_text_370": "",
		"payment_text_371": "",
		"payment_text_372": "",
		"payment_text_373": "",
		"payment_text_374": "",
		"payment_text_375": "",
		"payment_text_376": "",
		"payment_text_377": "",
		"payment_text_378": "",
		"payment_text_379": "",
		"payment_text_380": "",
		"payment_text_381": "",
		"payment_text_382": "",
		"payment_text_383": "",
		"payment_text_384": "<span>İtaatkâr bir köpeğe giden yola çık:</span> en kapsamlı K9 reaktivite rehberini al",
		"payment_text_385": "<span>K9 Reaktivite Pratik Rehberi</span>'nin kilidini aç",
		"payment_text_386": "Köpeğinin tetikleyiciler varken seni dinlemesini sağla",
		"payment_text_387": "Tepkilerin büyümesine izin vermeden onları durdur",
		"payment_text_388": "Köpeğin çığırından çıktığında yeniden kontrolü sağla",
		"payment_text_389": "Köpeğini insanlara, diğer köpeklere ve arabalara aşırı tepki vermekten vazgeçir",
		"pdfUpselling": "",
		"pdfUpselling_1": "<span>İtaatkâr bir köpek için yolculuğuna başla:</span> Köpek yetiştirme eğitimi için kapsamlı bir rehber edin",
		"pdfUpselling_2": "<span>İtaatkâr bir köpek için yolculuğuna başla:</span> Yavru köpek yetiştirme eğitimi için kapsamlı bir rehber edin",
		"pdfUpselling_3": "Kişisel <span>planını edin</span>",
		"pdfUpselling_4": "<span>Pratik rehberin</span> kilidini aç",
		"pdfUpselling_5": "Davranış düzeltme (iç mekan & dış mekan)",
		"pdfUpselling_6": "Köpeğini nasıl övmeli ve ödüllendirmelisin?",
		"pdfUpselling_7": "Çeşitli komutlar",
		"pdfUpselling_8": "Zenginleştirme oyunları & çok daha fazlası",
		"pdfUpselling_9": "Tuvalet eğitimi",
		"pdfUpselling_10": "Isırma ve çiğnemeyi bırakma",
		"pdfUpselling_11": "Kafes eğitimi",
		"pdfUpselling_12": "Artı 43 diğer yararlı ipucu ve çözüm",
		"pdfUpselling_13": "Bugünün toplamı",
		"pdfUpselling_14": "Rehberin kilidini aç",
		"pdfUpselling_15": "Şunla kilit aç:",
		"pdfUpselling_16": "Rehber olmadan devam et",
		"chatUpsale_1": "Köpek eğitmeni sohbeti",
		"chatUpsale_2": "Köpeğin davranışını tanımlayın. Çözüm bizde",
		"chatUpsale_3": "Gerçek insan Köpek Eğitmeni Uzmanlarımızla sınırsız olarak sohbet edin",
		"chatUpsale_4": "Everydoggy'den beklediğinizden fazlasını elde edebilirsiniz!",
		"chatUpsale_5": "Destek ×2",
		"chatUpsale_6": "EveryDoggy planı",
		"chatUpsale_7": "Köpek eğitmeni sohbeti",
		"chatUpsale_8": "Kendi başınıza eğitim",
		"chatUpsale_9": "SINIRSIZ ERİŞİM",
		"chatUpsale_10": "Uzman Eğitmen Sohbeti ile sonuçları arttırın!",
		"chatUpsale_11": "sohbet erişimi",
		"chatUpsale_12": "30 Günlük",
		"chatUpsale_13": "90 Günlük",
		"chatUpsale_14": "Köpek eğitmeni sohbeti olmadan devam et",
		"chatUpsale_15": "Köpek eğitmeni sohbetine sınırsız erişim",
		"checkoutV2_text1": "toplam",
		"checkoutV2_text2": "Face/Touch Kimliği ile kolay ve özel ödemeler",
		"checkoutV2_text3": "Finansal bilgilerinizi uçtan uca şifrelemeyle güvende tutar",
		"checkoutV2_text4": "Apple Pay'in benzersiz Cihaz Hesap Numarasıyla korunmaktadır",
		"checkoutV2_text5": "Hızlı, rahat ödeme seçeneğidir",
		"checkoutV2_text6": "Finansal bilgilerinizi uçtan uca şifrelemeyle güvende tutar",
		"checkoutV2_text7": "PayPal'ın sektör lideri dolandırıcılık korumasıyla desteklenir",
		"checkoutV2_text8": "Para İade Garantisi",
		"checkoutV2_text9": "Ödeme",
		"checkoutV2_text10": "Ödeme bilgileri",
		"checkoutV2_text11": "Korunuyor",
		"error_1": "Ödeme reddedildi. Lütfen kart bilgilerini kontrol edin ve tekrar deneyin.",
		"error_2": "Ödeme reddedildi. Lütfen kart bilgilerini kontrol edin ve tekrar deneyin.",
		"error_3": "Yetersiz bakiye. Lütfen başka bir kart veya ödeme yöntemi deneyin.",
		"error_4": "Kartınızın süresi doldu. Lütfen başka bir kart veya ödeme yöntemi deneyin.",
		"error_5": "Kartınız işlenirken bir hata oluştu. Lütfen tekrar deneyin.",
		"error_6": "Güvenlik kodu yanlış. Lütfen kart bilgilerini kontrol edin ve tekrar deneyin.",
		"error_7": "American Express kartları şu anda desteklenmiyor. Lütfen başka bir kart veya ödeme yöntemi deneyin.",
		"error_8": "Ödeme reddedildi. Lütfen kart bilgilerini kontrol edin ve tekrar deneyin.",
		"error_9": "Ödeme reddedildi. Bu e-posta zaten aktif bir abonelikle ilişkilendirilmiş.",
		"error_10": "Ödeme reddedildi. Çok fazla deneme yapıldı veya kart limiti aşıldı. Lütfen daha sonra tekrar deneyin.",
		"disclaimerV2_text_1": "Devam ederek, <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Şartlar ve Koşullarımızı</a> ve <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Gizlilik Politikamızı</a> kabul etmiş ve aboneliğinizin otomatik olarak yenilenmesine onay vermiş olursunuz. İlk hafta için bugün sizden yalnızca <span class=\"price1\">$1.99</span> tahsil edilecektir. İptal etmezseniz, Everydoggy deneme sürenizin sonunda aboneliğinizi otomatik olarak yeniler ve abonelik ücretini (şu anda <span class=\"price2\">$29.99</span>) siz iptal edene kadar her 2 haftada bir tahsil eder.\r\n\n",
		"disclaimerV2_text_2": "Devam ederek, <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Şartlar ve Koşullarımızı</a> ve <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Gizlilik Politikamızı</a> kabul etmiş ve aboneliğinizin otomatik olarak yenilenmesine izin vermiş olursunuz.\r\nBugün, ilk 4 haftanız için sizden yalnızca <span class=\"price1\">$6.99</span> tahsil edilecektir. \r\nİptal etmezseniz, Everydoggy deneme sürenizin sonunda aboneliğinizi otomatik olarak yeniler ve \r\nabonelik ücretini (şu anda <span class=\"price2\">$29.99</span>) siz iptal edene kadar her 2 haftada bir tahsil eder.\r\n\n",
		"disclaimerV2_text_3": "Devam ederek, <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Şartlar ve Koşullarımızı</a> ve <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Gizlilik Politikamızı</a> kabul etmiş ve aboneliğinizin otomatik olarak yenilenmesine izin vermiş olursunuz.\r\nBugün, ilk 12 haftanız için sizden yalnızca <span class=\"price1\">$14.99</span> tahsil edilecektir. \r\nİptal etmezseniz, Everydoggy deneme sürenizin sonunda aboneliğinizi otomatik olarak yeniler ve \r\nabonelik ücretini (şu anda <span class=\"price2\">$49.99</span>) siz iptal edene kadar her 4 haftada bir tahsil eder.\r\n",
		"chatUpsaleV2_1": "Köpek eğitmeni sohbeti",
		"chatUpsaleV2_2": "Bir köpek davranış uzmanıyla eğitim yapın",
		"chatUpsaleV2_3": "Planınıza deneyimli köpek eğitmenlerinden sınırsız sohbet desteği ekleyin",
		"chatUpsaleV2_4": "Eğitmenle",
		"chatUpsaleV2_5": "Verimlilik",
		"chatUpsaleV2_6": "Gerçek bir uzmandan net yanıtlar",
		"chatUpsaleV2_7": "Köpeğiniz için kişiselleştirilmiş öneriler",
		"chatUpsaleV2_8": "Daha az hatayla daha hızlı sonuçlar",
		"chatUpsaleV2_9": "Sakin, kendinden emin bir eğitim süreci",
		"chatUpsaleV2_10": "Eğitmensiz",
		"chatUpsaleV2_11": "Doğru yapıp yapmadığınızı tahmin etmek",
		"chatUpsaleV2_12": "Yavaş ilerleme ve tekrarlanan hatalar",
		"chatUpsaleV2_13": "İstenmeyen davranışın nedenlerinin belirsiz olması",
		"chatUpsaleV2_14": "Siz ve köpeğiniz için hayal kırıklığı",
		"chatUpsaleV2_15": "Her köpek farklıdır. Kendi köpeğiniz için uzman desteği alın!",
		"chatUpsaleV2_16": "En zor köpek davranışı sorularına bile yanıt alın",
		"chatUpsaleV2_17": "Hem duygusal hem de uygulamalı eğitim desteği alın",
		"chatUpsaleV2_18": "Eğitimde stres ve hayal kırıklığını azaltın",
		"chatUpsaleV2_19": "Size ve köpeğinize özel, kişiselleştirilmiş yönlendirmeden yararlanın",
		"chatUpsaleV2_20": "Maksimum sonuçlar için profesyonel destek alın",
		"chatUpsaleV2_21": "Sınırlı Kontenjan",
		"chatUpsaleV2_22": "Kalan özel kontenjanlar",
		"chatUpsaleV2_23": "4 haftalık uzman köpek eğitmeni sohbet erişimi:",
		"chatUpsaleV2_24": "Sınırlı ekstra %65 indirim:",
		"chatUpsaleV2_25": "Toplam",
		"chatUpsaleV2_26": "Şimdi uzman desteği alın",
		"chatUpsaleV2_27": "Köpek eğitmeni sohbeti olmadan devam et",
		"chatUpsaleV2_28": "Köpeğim hakkında her türlü soruyu sorabilir miyim?",
		"chatUpsaleV2_29": "Evet! Davranış, eğitim, yavru köpek sorunları veya karşılaştığınız özel zorluklar hakkında sorabilirsiniz.",
		"chatUpsaleV2_30": "Ne kadar sürede yanıt alırım?",
		"chatUpsaleV2_31": "Deneyimli eğitmenlerimiz hafta içi genellikle 24 saat içinde yanıt verir.",
		"chatUpsaleV2_32": "Daha önce eğitim deneyimine ihtiyacım var mı?",
		"chatUpsaleV2_33": "Hiç gerek yok. Eğitmenlerimiz, ister yeni başlayın ister deneyimli bir sahip olun, sizi adım adım yönlendirir."
	},
	"pl": {
		"global \ninstruction": "",
		"safe": "Twoje informacje są bezpieczne",
		"information": "Nie sprzedamy ani nie wynajmiemy Twoich osobistych danych kontaktowych w żadnych celach marketingowych.",
		"secure_checkout": "Bezpieczna płatność",
		"encrypted": "Wszystkie informacje są szyfrowane i przesyłane bez ryzyka za pomocą protokołu Secure Sockets Layer.",
		"help": "Potrzebujesz pomocy?",
		"contact": "Skontaktuj się z nami",
		"here": "tutaj.",
		"undefined": "",
		"featured": "Jak przedstawiono w",
		"main_title": "Kursy szkolenia psów",
		"per_year": "rocznie",
		"special_offer": "Oferta specjalna",
		"card_number": "Numer karty",
		"card_expiry": "Karta wygasa",
		"security_number": "Numer bezpieczeństwa",
		"email": "Email",
		"To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of __period__ and at the full, not discounted, price of __fullPriceText__ To learn more visit our <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">terms of use</a>.": "Informacje o płatności",
		"secure_server": "Bezpieczny serwer",
		"pay": "Zapłać",
		"enter_your_email": "Wprowadź swój e-mail",
		"comment_1": "Podczas kilku stresujących lat całkowicie straciłem formę i przytyłem, ale nie miałem czasu ani motywacji, by coś z tym zrobić. Jeden z członków rodziny zasugerował Verv i teraz codziennie polegam na moim trenerze!",
		"comment_2": "Verv sprawił, że polubiłem treningi w domu i w ciągu miesiąca schudłem 7 kg. Ta aplikacja naprawdę może pomóc Ci w ćwiczeniach i odchudzaniu, jeśli jesteś początkujący jak ja.",
		"success_story": "Historia sukcesu",
		"get_my_plan": "ZGARNIJ MÓJ PLAN",
		"delimiter": "lub",
		"pay_buy_card": "Płać kartą",
		"get_my_plan_warning_1": "Aby uniknąć zakłóceń, zgadzasz się, że wybrana subskrypcja zostanie automatycznie przedłużona na następny okres odnawiania wynoszący",
		"get_my_plan_warning_2": "i po pełnej, nieprzecenionej cenie",
		"get_my_plan_warning_3": "Aby dowiedzieć się więcej, odwiedź nasz",
		"get_my_plan_warning_text": "Kontynuując, zgadzasz się, że jeśli nie anulujesz co najmniej 24 godziny przed końcem pierwszego okresu odnawiania, zostanie ci automatycznie naliczona pełna cena __fullPriceText__ co __period__ aż do anulowania.",
		"terms_of_use": "Zasady użytkowania",
		"privacy_policy": "Polityka prywatności",
		"terms_conditions": "Warunki i zasady",
		"privacy_policy_footer": "Polityka prywatności",
		"terms_conditions_footer": "Warunki korzystania",
		"guaranteed": "Gwarantowane bezpieczne zakupy",
		"special_features": "Specjalne funkcje dla ciebie",
		"calories_value": "kcal",
		"personalized_plan": "Zdobądź swój spersonalizowany plan:",
		"mobile_app": "Aplikacja mobilna z twoim planem",
		"daily_programs": "Codzienne programy dla różnych celów (spalanie tłuszczu, redukcja stresu, przyrost masy mięśniowej)",
		"audio_guided": "Treningi z audio przewodnikiem",
		"easy_to_cook": "Łatwe w przygotowaniu i smaczne dania",
		"comprehensive_stats": "Kompleksowe statystyki",
		"secret_tips": "Sekretne wskazówki dotyczące rozwijania zdrowych nawyków",
		"mobile_app_tailor": "Dopasowany plan w twojej kieszeni",
		"daily_programs_for": "Programy codzienne",
		"daily_programs_for_2": "Dla różnych celów (spalanie tłuszczu, redukcja stresu, przyrost masy mięśniowej)",
		"audio_trainers": "Poradniki profesjonalnych trenerów",
		"comprehensive_track": "Śledź swój postęp dzięki ostatecznym statystykom",
		"price": "Cena",
		"users_love": "Użytkownicy kochają nasz Spersonalizowany Plan",
		"alternative_review_name_1": "Therealtierra",
		"alternative_review_title_1": "Świetna aplikacja!",
		"alternative_review_contentent_1": "Jestem w dziewiątym tygodniu i moje ciało zmieniło się niesamowicie!",
		"alternative_review_name_2": "dziewczyna tenisowa",
		"alternative_review_title_2": "To działa!",
		"alternative_review_contentent_2": "Właśnie skończyłem program. Uwielbiam to. Zredukowałem 15 kg!!",
		"you_re_in": "Jesteś w środku!",
		"personal_plan_starts": "Twój osobisty plan Verv zaczyna się dzisiaj, a czas biegnie. Więc sprawdź to!",
		"app_by_link": "Aby wejść do swojego programu, pobierz aplikację za pomocą linku",
		"download_now": "Pobierz teraz",
		"or": "lub",
		"price_after_trial": "Cena po próbie",
		"seven_days_trial_unlocked": "7-dniowa wersja próbna odblokowana",
		"total_today": "Łącznie dzisiaj",
		"reserved_price_for": "Cena rezerwacyjna na",
		"new_subscritions1_title": "Wybierz swój plan",
		"new_subscritions1_subscription1_line1": "Plan półroczny",
		"new_subscritions1_subscription1_price1_time": "na tydzień",
		"new_subscritions1_subscription2_line1": "3-miesięczny plan",
		"new_subscritions1_subscription2_price2_time": "na tydzień",
		"new_subscritions1_subscription3_line1": "1-miesięczny plan",
		"new_subscritions1_subscription3_price3_time": "na tydzień",
		"new_subscription_save": "ZAPISZ",
		"new_subscritions_agreement": "Kontynuując, zgadzasz się z",
		"new_subscritions_and": "i",
		"new_subscritions_subtitle": "Nasi użytkownicy stracili 10 milionów funtów",
		"new_subscritions_join": "Dołącz do milionów naszych zadowolonych użytkowników",
		"statistic_block_item1_text": "Gwiazdki z 5",
		"statistic_block_item2_text": "oceny 5 gwiazdek",
		"statistic_block_item3_text": "pobrania",
		"get_your_personalized_plan": "Zdobądź swój spersonalizowany plan",
		"for": "za",
		"new_subscription_save_mostPopular1MonthPrice": "najbardziej popularny plan",
		"timer_additional_discount": "Dodatkowy rabat zastosowany właśnie ",
		"timer_additional_discount_bold": "dla ciebie",
		"timer_offer_expires": "Ta oferta wygasa za:",
		"Payment Successful": "",
		"payment_successful_title": "Cześć od zespołu Verv!",
		"payment_successful_download": "Pobierz aplikację",
		"payment_successful_press": "Naciśnij",
		"payment_successful_login": "Zaloguj się za pomocą e-maila",
		"payment_successful_email": "Wprowadź swój adres e-mail",
		"payment_successful_code": "i twój kod potwierdzający:",
		"payment_successful_hit": "Następnie dotknij",
		"payment_successful_done": "Zrobione",
		"payment_successful_description": "Jesteś w środku, ciesz się swoim spersonalizowanym planem treningowym!",
		"Tariffs Variants": "",
		"tariff_title_choose": "Wybierz swój plan",
		"tariff_title_get": "Zdobądź swój plan",
		"tariff_one_month": "Plan 1-miesięczny",
		"tariff_three_month": "Plan na 3 miesiące",
		"tariff_six_month": "Plan na 6 miesięcy",
		"tariff_one_year": "Plan na 1 rok",
		"tariff_one_week": "Plan na 1 tydzień",
		"tariff_three_day": "3-dniowy plan",
		"tariff_per_year": "rocznie",
		"tariff_per_day": "na dzień",
		"tariff_per_days": "co 3 dni",
		"tariff_per_week": "na tydzień",
		"tariff_week": "tydzień",
		"tariff_annual": "Plan roczny",
		"tariff_trial_one_week": "1-tygodniowy okres próbny",
		"tariff_after": "po ",
		"tariff_save": "Zapisz",
		"tariff_best_offer": "najlepsza oferta",
		"tariff_most_popular": "najbardziej popularny",
		"tariff_limited_promo": "ograniczona cena promocyjna",
		"tariff_6_for_3": "6 w cenie 3",
		"tariff_first_month": "pierwszy miesiąc",
		"tariff_first_week": "pierwszy tydzień",
		"tariff_monthly": "miesięczny",
		"tariff_quaterly": "kwartalowy",
		"tariff_semiannually": "półrocznie",
		"tariff_billed_every ": "fakturowane co ",
		"tariff_year": "rok",
		"tariff_month": "miesiąc",
		"tariff_months": "miesiące",
		"tariff_months_variable": "miesiące",
		"tariff_organic_gift": "Plan medytacji",
		"tariff_full_price": "Pełna cena",
		"tariff_no_hidden_fees": "Brak ukrytych opłat",
		"tariff_start_right_now": "Zacznij teraz",
		"tariff_more_than": "Ponad 1 000 000 aktywnych członków rodziny Verv",
		"tariff_intro_offer": "OFERTA WPROWADZAJĄCA",
		"Тарифы плиткой в ряд": "",
		"": "",
		"Checkout": "",
		"checkout_title": "Wybierz metodę płatności",
		"insufficient_funds": "Niewystarczające środki",
		"insufficient_we_have": "Mamy",
		"insufficient_special_price": "specjalna cena",
		"insufficient_for_you": "dla ciebie",
		"checkout_edit_card": "Edytuj kartę",
		"checkout_pay_via": "Zapłać przez",
		"checkout_paypal": "PayPal",
		"checkout_credit_card": "Karta kredytowa",
		"checkout_paypal_description": "Twoja płatność zostanie przetworzona za pośrednictwem PayPal",
		"checkout_total_price": "Całkowita cena",
		"checkout_warning_1": "Aby uniknąć jakichkolwiek zakłóceń, zgadzasz się, że wybrana subskrypcja będzie automatycznie przedłużana na kolejny okres odnawiania",
		"checkout_warning_2": "i po pełnej, a nie obniżonej, cenie",
		"checkout_warning_3": "Aby dowiedzieć się więcej, odwiedź nasz",
		"spv2_warning": "Aby uniknąć jakichkolwiek zakłóceń, zgadzasz się, że wybrana przez Ciebie subskrypcja zostanie automatycznie przedłużona na kolejny okres odnowienia __________ i w pełnej, a nie zniżonej cenie __________. Aby dowiedzieć się więcej, odwiedź nasze <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">warunki korzystania</a>.",
		"checkout_offer_day_for": "dzień na",
		"checkout_offer_days_for": "dni na",
		"checkout_offer_month_for": "miesiąc dla",
		"checkout_offer_months_for": "miesiące dla",
		"checkout_offer_week_for": "tydzień dla",
		"Values": "",
		"value_kg": "kg",
		"value_pounds": "funt",
		"value_st": "st",
		"value_g": "g",
		"value_kcal": "kcal",
		"value_min": "min",
		"value_min_cooking": "minuty gotowania",
		"welcome_title": "Witamy w Verv Premium!",
		"item_1_title": "Hurra!",
		"item_1_description": "Twój docelowy ciężar __weight__ jest teraz tuż za rogiem.",
		"item_2_title": "Jak aktywować",
		"item_2_description": "Pobierz aplikację korzystając z poniższego linku, użyj swojego adresu e-mail __mail__ i wprowadź ten kod weryfikacyjny: __code__.",
		"item_2_description_2": "Aby zmienić adres e-mail, kliknij <button id=\"changeMail\">tutaj</button>.",
		"item_3_title": "Coś poszło nie tak?",
		"item_3_description": "Szczegółowa instrukcja została wysłana na Twój e-mail. Jeśli jej nie otrzymałeś, skontaktuj się z <a target=\"_blank\" href=\"mailto:support@verv.com?subject=Problem z logowaniem (simple-login)\">wsparciem</a>.",
		"change": "Potwierdź",
		"change_mail": "Zmień swój adres e-mail tutaj, aby aktywować Premium",
		"email_warning": "Proszę wpisać prawidłowy adres e-mail",
		"Promo Code Block": "",
		"promo_code_title": "Kod promocyjny został zastosowany!",
		"promo_code_save": "% zniżki",
		"EveryDoggy": "",
		"dog_courses": "kursy dla psów",
		"why_we_best_active": "Aktywni użytkownicy.",
		"why_we_best_lessons": "Lekcje wideo.",
		"why_we_best_brain": "Gry mózgowe.",
		"why_we_best": "Dlaczego jesteśmy najlepsi?",
		"why_we_best_join": "Dołącz do naszej społeczności rodziców psów i zrób wszystko, co w twojej mocy z EveryDoggy.",
		"why_we_best_enjoy": "Ciesz się swoim spersonalizowanym planem treningowym, dostosowanym do twoich i twojego psa celów.",
		"why_we_best_keep": "Utrzymuj swoją psa w aktywności umysłowej i fizycznej za pomocą ponad 70 gier logicznych.",
		"dog_problems": "Szybkie rozwiązania problemów behawioralnych",
		"dog_problems_choose": "Wybierz niepożądane zachowania, które chciałbyś poprawić",
		"dog_problems_leash": "Smycz<br/>ciągnięcie",
		"dog_problems_biting": "Gryzienie",
		"dog_problems_anxiety": "Lęk separacyjny<br/>",
		"dog_problems_chewing": "Destrukcyjne<br/>żucie",
		"dog_plan": "Spersonalizowany plan treningowy",
		"dog_plan_our": "Nasz program szkoleniowy jest w 100% dostosowany do potrzeb twojego psa.",
		"dog_reviews": "Co mówią właściciele psów o EveryDoggy",
		"dog_reviews_text_1": "«Bardzo jasne i łatwe do zrozumienia lekcje. Mój szczeniak uwielbia treningi i obaj wiele się nauczyliśmy.»",
		"dog_reviews_name_1": "Megan i Leo",
		"dog_reviews_text_2": "Polecenie „Zen” czyni cuda. Dzięki niemu mój pies jest super spokojny w klinice weterynaryjnej podczas zabiegów.",
		"dog_reviews_name_2": "Linda B.",
		"dog_reviews_text_3": "„Dziękuję za lekcję treningową z klikerem. Słyszałem, że jest bardzo popularny, ale nie było jasne, jak go używać. Szybko oswoiłem swojego psa z klikerem i teraz zaczęliśmy uczyć się sztuczek.”",
		"dog_reviews_name_3": "Jake L.",
		"join_text": "Szczęśliwe wychowanie psa zaczyna się od EveryDoggy",
		"join_courses": "Dołącz do kursów internetowych",
		"checkout_introductory": "Zniżka na ofertę wprowadzającą",
		"checkout_personalized_plan": "Twój spersonalizowany plan",
		"Personal plan": "",
		"goal_lose_weight": "Skuteczny program odchudzania z dedykowanymi treningami, trackerem diety i różnorodnymi aktywnościami dla Ciebie",
		"goal_gain_muscles": "Skuteczny program tonizacji całego ciała z prowadzonymi treningami, trackerem żywieniowym i różnorodnymi aktywnościami dla Ciebie",
		"goal_gain_healthier_life": "Nowa zdrowa rutyna z kompleksowymi treningami, trackerem żywieniowym i różnorodnymi aktywnościami dla ciebie",
		"goal_gain_flexibility": "Program jogi na elastyczność z sesjami prowadzonymi, kojącą muzyką, trackerem żywności i szeregiem innych aktywności",
		"goal_gain_build_endurance": "Program treningu wytrzymałościowego z kierowanymi treningami, trackerem żywieniowym i różnorodnymi aktywnościami dla Ciebie",
		"goal_love_myself": "Różnorodność zajęć zwiększających Twoją pewność siebie, medytacje prowadzone, sesje jogi i treningi całego ciała",
		"body_type_apple": "Ćwiczenia dla ciała w kształcie jabłka, aby wzmocnić mięśnie brzucha i wyszczuplić talię.",
		"body_type_pear": "Ćwiczenia dla ciała w kształcie gruszki, aby ujędrnić biodra i uda",
		"body_type_square": "Ćwiczenia dla ciała o kwadratowym kształcie, aby zdefiniować talię i pracować nad pośladkami",
		"body_type_hourglass": "Ćwiczenia dla sylwetki w kształcie klepsydry, które pomogą ci osiągnąć zdumiewające wyniki",
		"body_type_triangle": "Ćwiczenia dla ciała w kształcie odwróconego trójkąta wzmacniające Twoje biodra i uda",
		"body_type_unknown": "Ćwiczenia, aby wydobyć to, co najlepsze z twojej sylwetki",
		"excercises_time_morning": "Poranne treningi, aby zwiększyć metabolizm i dać energię na cały dzień",
		"excercises_time_day": "Treningi, które idealnie wpisują się w twój harmonogram, przyspieszają metabolizm i utrzymują cię pełnym energii przez cały dzień.",
		"excercises_time_evening": "Wieczorne treningi, które pomogą ci zredukować stres po długim dniu i przygotować się do dobrego snu.",
		"excercises_not_sure": "Treningi, które idealnie pasują do twojego harmonogramu, przyspieszają twój metabolizm i utrzymują cię w energii przez cały dzień",
		"diet_type_all": "Łatwe zdrowe przepisy",
		"diet_type_vegetarian": "Zdrowe wegetariańskie przepisy",
		"diet_type_vegan": "Zdrowe wegańskie przepisy",
		"diet_type_keto": "Zdrowe przepisy keto",
		"personal_plan_providers_title": "",
		"special_features_title": "Specjalne funkcje dla Ciebie",
		"special_features_duration_minimum": "Szybkie sesje trwające poniżej 10 minut",
		"special_features_duration_normal": "Wygodne sesje trwające mniej niż 20 minut",
		"special_features_duration_maximum": "Skuteczne sesje trwające ponad 20 minut",
		"special_features_duration_verv": "Wygodne sesje od naszych trenerów",
		"special_features_goal_lose_weight": "Sekretne porady dotyczące utraty wagi od ekspertów",
		"special_features_goal_gain": "Sekretne porady dotyczące tonizacji mięśni od ekspertów",
		"special_features_goal_health": "Tajne zdrowotne wskazówki od ekspertów",
		"special_features_goal_flexibility": "Sekretne wskazówki dotyczące elastyczności od ekspertów",
		"special_features_goal_endurance": "Sekretne wskazówki na zwiększenie wytrzymałości",
		"special_features_goal_love": "Sekretne wskazówki na zwiększenie poczucia własnej wartości",
		"discount_activated": "Aktywowany rabat 50%",
		"discount_no_activated": "50% zniżki",
		"unlocked_with_promo": "Odblokowane za pomocą kodu promocyjnego:",
		"use_with_button": "Użyj swojego specjalnego kodu promocyjnego:",
		"plan_optimal": "Optymalny",
		"plan_standard": "STANDARD",
		"plan_basic": "PODSTAWOWY",
		"plan_extra": "DODATKOWE",
		"daypayback_review_name_1": "melliebeth",
		"daypayback_review_text_1": "",
		"daypayback_review_name_2": "katie_zu13",
		"daypayback_review_text_2": "Kocham Verv! Śledzenie mojego osobistego planu treningowego i żywieniowego pomogło mi wrócić do formy i na nowo zdobyć pewność siebie! Zacząłem od krótkich treningów fitness trwających mniej niż 15 minut, które były idealne dla początkującego jak ja. Następnie zwiększyłem swoją wytrzymałość, a czas moich treningów wzrósł do 30-40 minut na sesję. Powoli, ale pewnie schudłem 25 funtów (około 11 kg) w ciągu 6 miesięcy z Verv!",
		"daypayback_review_name_3": "Jean_leon1",
		"daypayback_review_text_3": "W czasie studiów przytyłem sporo. Po ukończeniu studiów próbowałem różnych diet, które pomogły mi schudnąć, ale ta waga zawsze wracała po kilku miesiącach po zakończeniu diety. W zeszłym roku usłyszałem o Verv od mojego kolegi i postanowiłem spróbować. Dzięki spersonalizowanym rekomendacjom Verv udało mi się schudnąć i utrzymać wagę!",
		"daypayback_review_name_4": "maryanne1993",
		"daypayback_review_text_4": "Po trudnym rozstaniu postanowiłam zmienić swoje życie, schudnąć i stać się zdrowsza. Nie wiedziałam jednak, od czego zacząć. Nie czułam się wystarczająco pewnie, ćwicząc z innymi, więc postanowiłam spróbować aplikacji do ćwiczeń w domu, a Verv pojawił się w moim wyszukiwaniu. Zaproponował mi plan dostosowany do moich potrzeb. Trzymałam się go i udało mi się uzyskać ciało moich marzeń!",
		"personal_plan_you_get": "Z osobistym planem otrzymujesz",
		"goal": "Cel",
		"goal_other": "Lekcje dla treningu twojego futrzastego przyjaciela",
		"goal_teaching_puppy": "Lekcje, aby nauczyć twojego futrzastego przyjaciela manier i posłuszeństwa",
		"goal_surviving_puppy": "Lekcje, które pomogą Ci przygotować się na pierwsze dni z Twoim futrzanym przyjacielem",
		"goal_socializing_puppy": "Lekcje, które pomogą ci zsocjalizować twojego futrzanego przyjaciela",
		"goal_teaching_obedience": "Lekcje nauki dobrych manier i posłuszeństwa dla twojego futrzanego przyjaciela",
		"age_puppy": "Szczegółowe porady dotyczące szkolenia od naszych ekspertów, które pomogą Ci wychować szczęśliwego i dobrze wychowanego szczeniaka",
		"age_adult": "Szczegółowe porady dotyczące treningu od naszych ekspertów, aby pomóc Ci trenować swojego psa w najskuteczniejszy sposób",
		"biting_yes": "Krok po kroku instrukcje, jak powstrzymać psa od gryzienia",
		"biting_no": "Zabawne gry do grania z twoim psem",
		"biting_sometimes": "Instrukcje krok po kroku, jak powstrzymać swojego psa od gryzienia",
		"quick_tips": "Szybkie i łatwe wskazówki dotyczące nauki nowych poleceń",
		"potty_training_a_bit": "Specjalny przewodnik dotyczący skutecznego nauki pupila do załatwiania się",
		"potty_training_yes": "Specjalne poradniki, aby nauczyć twojego szczeniaka nowych fajnych sztuczek",
		"potty_training_no": "Specjalny przewodnik dotyczący skutecznego szkolenia szczeniaka w zakresie załatwiania się",
		"success screen": "",
		"success_screen_text_1": "Dziękujemy za zakupy!",
		"success_screen_text_2": "Postępuj zgodnie z poniższymi instrukcjami, aby skonfigurować<br />swoje konto:",
		"success_screen_text_3": "Przejdź do swojego <b>konto</b>",
		"success_screen_text_4": "Skanuj <b>kod QR</b> lub dotknij <b>linku</b>",
		"success_screen_text_5": "<b>Pobierz</b> aplikację",
		"success_screen_text_6": "<b>Otwórz aplikację</b> i <b>ciesz się</b><br />szkoleniem ze swoim psem!",
		"success_screen_text_7": "Skopiowaliśmy kod QR i link do Ciebie pod adresem &nbsp;<b>example@gmail.com</b>",
		"success_screen_text_8": "Jeśli konto premium nie zostało zastosowane w aplikacji, naciśnij <b>‘Skontaktuj się z nami’</b> na ekranie powitalnym i skontaktuj się z naszym zespołem wsparcia.",
		"success_screen_text_9": "Naciskając przycisk „Rozpocznij”, potwierdzam, że zapoznałem się z i akceptuję <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Politykę prywatności</a> oraz <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Regulamin</a> i niniejszym zgadzam się na przetwarzanie moich danych osobowych.",
		"success_screen_text_10": "Skontaktuj się z nami",
		"success_screen_text_11": "Przejdź do mojego konta",
		"success_screen_text_12": "Wysłaliśmy Ci zduplikowany kod QR i link na e-mail.",
		"success_screen_text_13": "Twój przewodnik PDF został wysłany na Twój adres e-mail <b>v.stsiopina@gmail.com</b>.",
		"success_screen_text_14": "Twój przewodnik PDF został wysłany na Twój adres e-mail.",
		"success_screen_text_15": "Jeśli konto premium nie zostało aktywowane w aplikacji, naciśnij link <span>'Zaloguj się'</span> na ekranie powitalnym w aplikacji i wprowadź swój adres e-mail oraz hasło, które wysłaliśmy na <b>stepinavalerie@gmail.com</b>",
		"success_screen_text_16": "Jeśli konto premium nie zostało zastosowane w aplikacji, naciśnij link <span>'Zaloguj się'</span> na ekranie powitanie w aplikacji i wprowadź swój adres e-mail oraz hasło, które wysłaliśmy do Ciebie e-mailem.",
		"payment_text_1": "Twój program szkolenia psów zaczyna się teraz!",
		"payment_text_2": "Aplikacja Everydoggy pomoże <span>szybko i wesoło rozwiązać jakiekolwiek problemy behawioralne Twojego psa</span>.",
		"payment_text_3": "Oferta osobista wygasa",
		"payment_text_4": "nasi użytkownicy zauważają pozytywne zmiany w zachowaniu swoich psów zaledwie tydzień po rozpoczęciu szkolenia z naszymi ekspertami",
		"payment_text_5": "KażdyPies kontra Trenerzy",
		"payment_text_6": "Średnia liczba komend miesięcznie",
		"payment_text_7": "KażdyPies odnosi korzyści",
		"payment_text_8": "Spersonalizowany plan treningowy dla psów",
		"payment_text_9": "Tylko 15 minut dziennie do idealnego zwierzaka",
		"payment_text_10": "Ponad 70 łatwych do zrozumienia lekcji wideo dla szybkich wyników",
		"payment_text_11": "Ponad 80 gier i sztuczek dla nowych umiejętności i po prostu dla zabawy",
		"payment_text_12": "Porady dotyczące higieny, zdrowia i odżywiania",
		"payment_text_13": "Trenuj w domu i na świeżym powietrzu, bez potrzeby sprzętu",
		"payment_text_14": "98% naszych użytkowników zauważa pozytywne zmiany w zachowaniu swojego psa już po 1 tygodniu od rozpoczęcia treningu z naszymi ekspertami.",
		"payment_text_14_2": "<span>98% naszych użytkowników</span> zauważa pozytywne zmiany w zachowaniu swojego psa już po 1 tygodniu treningu z naszymi ekspertami",
		"payment_text_15": "Klikając przycisk „Zdobądź mój plan”, wyrażasz zgodę na nasze <a href='https://everydoggy.com/terms/' target=\"_blank\" >Warunki i zasady</a> oraz <a href='https://everydoggy.com/policy/' target=\"_blank\" >Politykę prywatności</a>, <b>zezwalasz na automatyczne odnawianie</b> subskrypcji na koniec każdego cyklu rozliczeniowego <span>1 miesiąc</span> po pełnej cenie <i>$29.99</i> plus obowiązujące podatki. Możesz anulować automatyczne odnawianie subskrypcji w dowolnym momencie przed datą odnowienia. Sprawdź nasze <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Warunki anulowania</a> w celu uzyskania dalszych informacji.",
		"payment_text_16": "Klikając przycisk „Zdobądź mój plan”, akceptujesz nasze <a href='https://everydoggy.com/terms/' target='_blank'>Warunki korzystania</a> oraz <a href='https://everydoggy.com/policy/' target='_blank'>Politykę prywatności</a>, <b>wyrażasz zgodę na automatyczne odnowienie</b> subskrypcji na koniec każdego cyklu rozliczeniowego <span>1 miesiąc</span> po pełnej cenie <i>$29.99</i> plus obowiązujące podatki. Możesz anulować automatyczne odnowienie subskrypcji w dowolnym momencie przed datą odnowienia. Sprawdź nasze <a href='https://everydoggy.com/subscription-terms/' target='_blank'>Warunki anulowania</a> po więcej szczegółów.",
		"payment_text_17": "Masz pytanie?",
		"payment_text_18": "Po prostu napisz do nas na ",
		"payment_text_19": "To działa!",
		"payment_text_20": "Właśnie ukończyłem program posłuszeństwa z naszym szczeniakiem, uwielbiam to! 👏",
		"payment_text_21": "Fantastycznie!",
		"payment_text_22": "Muszę powiedzieć, że jestem 💯 zadowolony z tej aplikacji. Nigdy więcej problemów z nocnikiem, wow! ",
		"payment_text_23": "Świetna apka 🎉",
		"payment_text_24": "Trenujemy z moim psem już trzeci miesiąc i jego umiejętności poprawiły się niesamowicie!",
		"payment_text_25": "Warto spróbować",
		"payment_text_26": "Zdecydowanie najlepsza aplikacja do szkolenia psa!",
		"payment_text_27": "Zainspiruj się naszymi użytkownikami",
		"payment_text_28": " Star Focus, Inc.",
		"payment_text_29": "Jeśli nadal masz pytania, napisz do nas na <a href=\"mailto:welove@everydoggy.com\">welove@everydoggy.com</a>",
		"payment_text_30": "Widoczne rezultaty już po 7 dniach treningu",
		"payment_text_31": "Zdobądź swój osobisty plan ze specjalnym rabatem",
		"payment_text_32": "Im wcześniej rozpoczniesz trening, tym lepsze rezultaty osiągniesz",
		"payment_text_33": "Szkolenie jest niezbędne dla każdego psa. Nie chodzi tylko o eliminowanie problemów behawioralnych, ale także o socjalizację, budowanie więzi z psem i wyrażanie swojego przywiązania.",
		"payment_text_34": "Stworzone z miłości do psów. Bazując na wiedzy światowej klasy ekspertów\n",
		"payment_text_35": "Wszystko, co znajdziesz w aplikacji, opiera się na najnowszych badaniach i jest w całości poświęcone psom.",
		"payment_text_36": "Gdyby Twój pies potrafił mówić, poprosiłby Cię o wypróbowanie EveryDoggy! ",
		"payment_text_37": "Twoje dane są bezpieczne",
		"payment_text_38": "Nie sprzedamy ani nie użyczymy Twoich osobistych danych kontaktowych w jakichkolwiek celach marketingowych.",
		"payment_text_39": "Bezpieczna płatność",
		"payment_text_40": "Wszystkie informacje są szyfrowane i przesyłane bez ryzyka.",
		"payment_text_41": "Potrzebujesz pomocy",
		"payment_text_42": "Wyślij nam e-mail: <a href=\"mailto:welove@everydoggy.com\">welove@everydoggy.com</a>",
		"payment_text_43": "miesięczny",
		"payment_text_44": "kontynuuj",
		"payment_text_45": "Twój spersonalizowany plan:",
		"payment_text_46": "Rabat dla nowych klientów:",
		"payment_text_47": "Kontynuując, akceptujesz następujące dokumenty: <a href='https://everydoggy.com/terms/' target='_blank' rel=\"noreferrer\">Warunki Korzystania</a>, <a href='https://everydoggy.com/policy/' target='_blank' rel=\"noreferrer\">Polityka Prywatności</a> i <a href='https://everydoggy.com/subscription-terms/#subscription_cancellation' target='_blank' rel=\"noreferrer\">Warunki Anulowania</a>",
		"payment_text_48": "Twoja subskrypcja obowiązuje do",
		"payment_text_49": "Możesz ją anulować w każdej chwili. Jeśli zrobisz to co najmniej 24 godziny przed terminem wygaśnięcia subskrypcji, nie poniesiesz opłaty.",
		"payment_text_50": "Jeżeli nie zrezygnujesz, Twoje członkostwo automatycznie odnowi się pod koniec miesięcznej subskrypcji. Do czasu jej anulowania będziesz ponosić opłatę członkowską EveryDoggy w wys. <b>$</b><i>$29.99</i>.",
		"payment_text_51": "Obecnie nie oferujemy zwrotu pieniędzy ani kredytu sklepowego za częściowe członkostwo.",
		"payment_text_52": "Osobisty treser",
		"payment_text_53": "Szkoła dla psów",
		"payment_text_54": "Lekcje na YouTubie",
		"payment_text_55": "Książki",
		"payment_text_56": "co tydzień",
		"payment_text_57": "Zdecydowanie lepsze efekty",
		"payment_text_58": "Z pomocą EveryDoggy",
		"payment_text_59": "Bez pomocy EveryDoggy",
		"payment_text_60": "Teraz",
		"payment_text_61": "Po tygodniu",
		"payment_text_62": "To Twoja ostatnia szansa",
		"payment_text_63": "Nie przeocz wyjątkowej 65% zniżki i odkryj, jak szybko Twój pies opanuje i wykona komendy!",
		"payment_text_64": "Zyskaj 65% rabatu",
		"payment_text_65": "52-TYGODNIOWY PLAN",
		"payment_text_66": "4-TYGODNIOWY PLAN",
		"payment_text_67": "12-TYGODNIOWY PLAN",
		"payment_text_68": "tygodnie",
		"payment_text_69": "Stycznia",
		"payment_text_70": "Lutego",
		"payment_text_71": "Marca",
		"payment_text_72": "Kwietnia",
		"payment_text_73": "Maja",
		"payment_text_74": "Czerwca",
		"payment_text_75": "Lipca",
		"payment_text_76": "Sierpnia",
		"payment_text_77": "Września",
		"payment_text_78": "Października",
		"payment_text_79": "Listopada",
		"payment_text_80": "Grudnia",
		"payment_text_81": "Wpisz prawidłowy adres e-mail",
		"payment_text_82": "",
		"payment_text_83": "Okres wstępny będzie trwał do <b>11 października 2024</b> r.",
		"payment_text_84": "Możesz zrezygnować w dowolnej chwili przed <b>10 października 2024</b> r. Nie obciążymy Cię wtedy opłatą.",
		"payment_text_85": "Jeśli nie anulujesz subskrypcji, Everydoggy automatycznie przedłuży Twoje członkostwo pod koniec okresu wstępnego i będzie <span>co miesiąc</span> naliczać opłatę członkowską (obecnie w wys. <b>39,99 $</b>), dopóki nie zrezygnujesz.",
		"payment_text_86": "",
		"payment_text_87": "",
		"payment_text_88": "Metoda płatności",
		"payment_text_89": "",
		"payment_text_90": "",
		"payment_text_91": "",
		"payment_text_92": "",
		"payment_text_93": "Twoje dane płatnicze są zabezpieczone szyfrowaniem SSL/TLS.",
		"payment_text_94": "",
		"payment_text_95": "",
		"payment_text_96": "",
		"payment_text_97": "",
		"payment_text_98": "",
		"payment_text_99": "",
		"payment_text_100": "",
		"payment_text_101": "",
		"payment_text_102": "",
		"payment_text_103": "Klikając przycisk „Uzyskaj mój plan”, akceptujesz\n<a href='https://everydoggy.com/policy/' target=\"_blank\">Politykę prywatności</a>,\n<a href='https://everydoggy.com/terms/' target=\"_blank\">Regulamin</a>\noraz <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\">Warunki anulowania</a>.",
		"payment_text_104": "Łatwe i prywatne płatności",
		"payment_text_105": "Karta kredytowa",
		"payment_text_106": "Data ważności",
		"payment_text_107": "Kod CVC",
		"payment_text_108": "dobry start",
		"payment_text_109": "1-tygodniowy plan",
		"payment_text_110": "Aplikacja Everydoggy szybko i w pełen zabawy sposób pomoże w <span>rozwiązaniu problemów z załatwianiem się oraz innych problemów behawioralnych psa</span>.",
		"payment_text_111": "Bezpieczna płatność",
		"payment_text_112": "Spersonalizowany plan treningowy dla <span>twojego psa</span>",
		"payment_text_113": "Gwizdek i kliker do treningu",
		"payment_text_114": "80+ gier dla twojego zwierzaka",
		"payment_text_115": "30+ porad i artykułów o zdrowiu",
		"payment_text_116": "🔥 Właśnie zaoszczędziłeś/aś <span>$113.50&nbsp;</span>🔥",
		"payment_text_117": "7-dniowy plan",
		"payment_text_118": "Klikając przycisk „Zdobądź plan”, akceptujesz <a href='https://everydoggy.com/terms/' target=\"_blank\" >Regulamin</a> i <a href='https://everydoggy.com/policy/' target=\"_blank\" >Politykę prywatności</a> oraz <b>autoryzujesz automatyczne odnawianie</b> subskrypcji. Obciążymy Cię dziś jedynie kwotą <span class=\"trialPrice\">4,99 $</span> za pierwsze <span class=\"trialPeriod\">7 dni</span> okresu wstępnego. Jeśli nie zrezygnujesz, Everydoggy automatycznie przedłuży Twoje członkostwo pod koniec wspomnianego okresu i będzie co <span class='period'>miesiąc</span> naliczać opłatę członkowską w wys. <span class='price'>39,99 $</span>, dopóki nie zrezygnujesz. W dowolnej chwili przed upływem daty odnowienia możesz anulować automatyczne odnawianie subskrypcji. Aby poznać więcej szczegółów, zapoznaj się z warunkami rezygnacji.",
		"payment_text_119": "7 dni",
		"payment_text_120": "Obciążymy Cię dziś jedynie kwotą <b>29,99 $</b> za pierwsze <span>12 tygodni</span> (poniżej znajdziesz szczegóły)",
		"payment_text_121": "Aplikacja Everydoggy <span>pomoże wyszkolić</span> Twojego psa, aby <span>załatwiał się</span> w odpowiednim miejscu, a także szybko <span>rozwiązuje problemy behawioralne</span> w zabawny sposób.",
		"payment_text_122": "Pies nauczy się czystości w 3 dni!",
		"payment_text_123": "Ten adres e-mail jest powiązany z Twoim kontem i nie można go zmienić",
		"payment_text_124": "Kontynuując, zgadzasz się z naszymi <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Warunkami</a> i <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Polityką prywatności</a> oraz <span>wyrażasz zgodę na automatyczne odnowienie subskrypcji</span>.",
		"payment_text_125": "26-TYGODNIOWY PLAN",
		"payment_text_126": "Jeśli nie anulujesz subskrypcji, Everydoggy automatycznie przedłuży Twoje członkostwo pod koniec okresu wstępnego i będzie <span>co 3 miesiące</span> naliczać opłatę członkowską (obecnie w wys. <b>39,99 $</b>), dopóki nie zrezygnujesz.",
		"payment_text_127": "Jeśli nie anulujesz subskrypcji, Everydoggy automatycznie przedłuży Twoje członkostwo pod koniec okresu wstępnego i będzie <span>co 6 miesiące</span> naliczać opłatę członkowską (obecnie w wys. <b>39,99 $</b>), dopóki nie zrezygnujesz.",
		"payment_text_128": "Aktualny poziom",
		"payment_text_129": "komend",
		"payment_text_130": "Cel",
		"payment_text_131": "Ponad 50 komend i posłuszeństwo",
		"payment_text_132": "Zauważalny postęp",
		"payment_text_133": "Osiągnięcie posłuszeństwa",
		"payment_text_134": "Solidne wyszkolenie Twojego psa na całe życie",
		"payment_text_135": "Oszczędź 53%",
		"payment_text_136": "Gwarancja zwrotu pieniędzy",
		"payment_text_137": "30-dniowa gwarancja zwrotu pieniędzy",
		"payment_text_138": "Wierzymy, że nasz plan zadziała w przypadku Twojego psa i że zauważysz widoczne rezultaty w ciągu 4 tygodni! Jesteśmy nawet gotowi zwrócić Ci pieniądze, jeśli nie zobaczysz efektów i będziesz w stanie wykazać, że stosowano się do naszego planu.",
		"payment_text_139": "Więcej informacji o obowiązujących ograniczeniach znajdziesz w naszych <a href=\"https://everydoggy.com/terms/#section5_2\" target=\"_blank\" rel=\"noreferrer\">warunkach użytkowania</a>.\n",
		"payment_text_140": "Oszczędź 65%",
		"payment_text_141": "Twój plan szkolenia psa jest gotowy!",
		"payment_text_142": "Posłuszeństwo",
		"payment_text_143": "Zna komendy",
		"payment_text_144": "Wypadki toaletowe",
		"payment_text_145": "Często",
		"payment_text_146": "Brak",
		"payment_text_147": "Szczekanie",
		"payment_text_148": "Szczeka na wszystko",
		"payment_text_149": "Spokojny i zrelaksowany",
		"payment_text_150": "Gryzienie i żucie",
		"payment_text_151": "Często",
		"payment_text_152": "Zniknęło",
		"payment_text_153": "Ciągnięcie smyczy",
		"payment_text_154": "Zawsze",
		"payment_text_155": "Chodzi spokojnie",
		"payment_text_156": "Niepokój, gdy zostaje sam",
		"payment_text_157": "Spokojny i niezależny",
		"payment_text_158": "Przed",
		"payment_text_159": "Po",
		"payment_text_160": "minuty",
		"payment_text_161": "sekundy",
		"payment_text_162": "Sprawdzone. Przetestowane. Działa",
		"payment_text_163": "Znaczące zmiany w zachowaniu psa",
		"payment_text_164": "Dzisiaj",
		"payment_text_165": "Tydzień 2",
		"payment_text_166": "Tydzień 3",
		"payment_text_167": "Tydzień 4",
		"payment_text_168": "Dlaczego EveryDoggy ma taką skuteczność",
		"payment_text_169": "Historie sukcesu naszych użytkowników",
		"payment_text_170": "Dzieło ekspertów, którzy <span>kochają psy</span>",
		"payment_text_171": "Każdy nasz kurs i lekcja opierają się na naukowych badaniach dotyczących treningu psów.",
		"payment_text_172": "Zbuduj silną więź ze swoim psem – wypróbuj EveryDoggy!",
		"payment_text_173": "Sprawdzone. Przetestowane. Działa",
		"payment_text_174": "<span>93% użytkowników</span> zauważa znaczną poprawę w zachowaniu psa już w trakcie pierwszego miesiąca treningu.",
		"payment_text_175": "Z EveryDoggy",
		"payment_text_176": "Bez EveryDoggy",
		"payment_text_177": "Dzisiaj",
		"payment_text_178": "Tydzień 2",
		"payment_text_179": "Tydzień 4",
		"payment_text_180": "Tydzień 6",
		"payment_text_181": "Historia Luny",
		"payment_text_182": "Mój szczeniak ciągle załatwiał się w domu. Z EveryDoggy wprowadziliśmy stałą rutynę – to i naprawdę zadziałało!",
		"payment_text_183": "Historia Coopera",
		"payment_text_184": "Nasz pies podgryzał wszystkich podczas zabawy. Aplikacja poprowadziła nas krok po kroku – i udało się!",
		"payment_text_185": "Historia Belli",
		"payment_text_186": "Nasz pies gryzł wszystko – od butów po kanapę. Aplikacja pomogła nam przekierować tę energię!",
		"payment_text_187": "Historia Charliego",
		"payment_text_188": "Szarpanie smyczy było naszym codziennym problemem. Dzięki aplikacji spacery stały się pozbawioną stresu przyjemnością.",
		"payment_text_189": "Nauczyła się załatwiać na zewnątrz",
		"payment_text_190": "Rozwiązany problem z gryzieniem",
		"payment_text_191": "Koniec z gryzieniem przedmiotów",
		"payment_text_192": "Zlikwidowane szarpanie na smyczy",
		"payment_text_193": "<span>93% naszych użytkowników</span> zauważa znaczną poprawę w zakresie <span>zachowania i posłuszeństwa psa</span> już w ciągu pierwszego miesiąca treningu.</span>",
		"payment_text_194": "Nasi użytkownicy są zachwyceni efektami!",
		"payment_text_195": "Od razu rozpocznij szkolenie swojego psa!",
		"payment_text_196": "Jeśli nie anulujesz, Twoje członkostwo w Everydoggy zostanie automatycznie przedłużone po zakończeniu okresu wstępnego i <span>co dwa tygodnie</span> pobierana będzie opłata członkowska (obecnie <b>39,99 USD</b>), aż do momentu anulowania.",
		"payment_text_197": "Gwarancja zwrotu pieniędzy",
		"payment_text_198": "30-dniowa gwarancja zwrotu pieniędzy",
		"payment_text_199": "Wierzymy, że nasz plan zadziała w przypadku Twojego psa i że zauważysz widoczne rezultaty w ciągu 4 tygodni! Jesteśmy nawet gotowi zwrócić Ci pieniądze, jeśli nie zobaczysz efektów i będziesz w stanie wykazać, że stosowano się do naszego planu.",
		"payment_text_200": "Więcej informacji o obowiązujących ograniczeniach znajdziesz w naszych <a href=\"https://everydoggy.com/terms/#section5_2\" target=\"_blank\" rel=\"noreferrer\">warunkach użytkowania</a>.\n",
		"payment_text_201": "Ludzie często pytają",
		"payment_text_202": "Po jakim czasie pojawią się efekty szkolenia?",
		"payment_text_203": "Większość psów robi postępy już po pierwszej sesji – a w ciągu kilku tygodni można osiągnąć znaczące, a wręcz imponujące rezultaty!",
		"payment_text_204": "Czy aplikacja Everydoggy jest równie skuteczna jak praca z trenerem?",
		"payment_text_205": "Tak, a nawet bardziej – możesz trenować codziennie we własnym tempie, korzystać z przedstawionych jasno i krok po kroku lekcji oraz regularnie utrwalać umiejętności, a nie tylko raz w tygodniu spotykać się z trenerem.",
		"payment_text_206": "Czy efekty szkolenia są trwałe?",
		"payment_text_207": "Tak! Jeśli będziesz konsekwentnie utrwalać dobre nawyki, rezultaty zostaną z Twoim psem na całe życie.",
		"payment_text_208": "Zyskaj 72% rabatu",
		"payment_text_209": "Nie przeocz wyjątkowej 72% zniżki i odkryj, jak szybko Twój pies opanuje i wykona komendy!",
		"payment_text_210": "Kontynuuj, korzystając z innej metody płatności",
		"payment_text_211": "Buy with",
		"payment_text_212": "CZARNOPIĄTKOWA WYPRZEDAŻ!",
		"payment_text_213": "",
		"payment_text_214": "",
		"payment_text_215": "",
		"payment_text_216": "",
		"payment_text_217": "",
		"payment_text_218": "Program treningu Twojego szczeniaka startuje teraz!",
		"payment_text_219": "Trenuj z aplikacją Everydoggy od <span>najwcześniejszych dni twojego szczeniaka</span> i zyskaj <span>idealnie posłusznego psa</span>!",
		"payment_text_220": "naszych użytkowników zauważa pozytywne zmiany w zachowaniu szczeniaka już po 1 tygodniu od rozpoczęcia treningu z naszymi ekspertami",
		"payment_text_221": "Spersonalizowany plan treningowy dla szczeniąt poniżej 6 miesięcy",
		"payment_text_222": "Spersonalizowany plan treningowy dla szczeniąt w wieku 6–12 miesięcy",
		"payment_text_223": "Sprawdzone na 3 milionach szczeniąt",
		"payment_text_224": "Wyraźne zmiany w posłuszeństwie psa",
		"payment_text_225": "Zyskaj 70% rabatu",
		"payment_text_226": "OSTATNIA SZANSA!\r",
		"payment_text_227": "24-TYGODNIOWY PLAN",
		"payment_text_228": "Ostatni program treningu psa, jakiego będą Państwo potrzebować, zaczyna się teraz!",
		"payment_text_229": "Spersonalizowany plan treningu psa dla trwałych efektów",
		"payment_text_230": "Jeden program.<br />\nDobre zachowanie na długo",
		"payment_text_231": "Wiek psa",
		"payment_text_232": "Czas treningu",
		"payment_text_233": "Trwałe efekty",
		"payment_text_234": "0-1 rok",
		"payment_text_235": "1-3 lata",
		"payment_text_236": "3-5 lat",
		"payment_text_237": "5+ lat",
		"payment_text_238": "1-2 lata",
		"payment_text_239": "3 lata",
		"payment_text_240": "4 lata",
		"payment_text_241": "2-7 lat",
		"payment_text_242": "8 lat",
		"payment_text_243": "9 lat",
		"payment_text_244": "10+ lat",
		"payment_text_245": "",
		"payment_text_246": "",
		"payment_text_247": "",
		"payment_text_248": "",
		"payment_text_249": "",
		"payment_text_250": "",
		"payment_text_251": "",
		"payment_text_252": "",
		"payment_text_253": "",
		"payment_text_254": "",
		"payment_text_255": "",
		"payment_text_256": "",
		"payment_text_257": "",
		"payment_text_258": "",
		"payment_text_259": "",
		"payment_text_260": "",
		"payment_text_261": "",
		"payment_text_262": "",
		"payment_text_263": "Psi tłumacz",
		"payment_text_264": "Zrozum swojego psa.<br/> Zobacz efekty",
		"payment_text_265": "Posłuszeństwo poprawia się dzięki analizie sygnałów i zachowania",
		"payment_text_266": "Spersonalizowany plan szkolenia psa oparty na analizie jego szczekania i zachowania",
		"payment_text_267": "Dwa razy szybciej, <br />dwa razy więcej frajdy!",
		"payment_text_268": "Odbierz kompletny przewodnik szkolenia szczeniaka",
		"payment_text_269": "Odbierz kompletny przewodnik szkolenia psa",
		"payment_text_270": "Koniec z problemami z załatwianiem się! Metody krok po kroku pomogą szybko nauczyć psa załatwiania się we właściwym miejscu.",
		"payment_text_271": "Chroń buty i palce! Proste metody pomogą oduczyć szczeniaka gryzienia i podgryzania wszystkiego dookoła.",
		"payment_text_272": "Stwórz dla psa bezpieczne i spokojne miejsce, a przy okazji naucz go spokojnego przebywania w klatce.",
		"payment_text_273": "Zyskaj pełen zestaw eksperckich wskazówek dotyczących zachowania, posłuszeństwa i codziennego życia z psem.",
		"payment_text_274": "Koryguj niepożądane zachowania w domu i na spacerach dzięki skutecznym i prostym metodom.",
		"payment_text_275": "Spraw, by nauka była przyjemnością! Naucz się dobrze wykorzystywać pochwały i nagrody, by od razu motywować psa.",
		"payment_text_276": "Naucz psa czegoś więcej niż podstaw! Poznasz wszystko: od komend ważnych dla bezpieczeństwa po efektowne sztuczki dla psów w każdym wieku.",
		"payment_text_277": "Przyspiesz<br /> postępy swojego psa <span>2x!</span>",
		"payment_text_278": "Praktyczny przewodnik:",
		"payment_text_279": "RABAT 98% tylko dla członków",
		"payment_text_280": "RABAT 70% tylko dla członków",
		"payment_text_281": "Twój program opieki weterynaryjnej dla psa zaczyna się już teraz!",
		"payment_text_282": "Dbaj o zdrowie swojego psa z <span>profesjonalnym wsparciem weterynaryjnym</span> od Everydoggy i <span>wychowaj zdrowego, dobrze ułożonego psa</span> z mniejszym stresem!",
		"payment_text_283": "Natychmiastowe wsparcie weterynaryjne na czacie — bez wizyt i bez czekania",
		"payment_text_284": "Udostępniaj zdjęcia, aby otrzymywać trafniejsze wskazówki",
		"payment_text_285": "Poznaj zasady pierwszej pomocy w nagłych sytuacjach, takich jak udar cieplny, urazy czy odmrożenia",
		"payment_text_286": "Bądź na bieżąco z aktualnymi harmonogramami szczepień i badań kontrolnych",
		"payment_text_287": "Korzystaj ze wskazówek dotyczących pielęgnacji zębów, uszu, oczu, pazurów, odrobaczania i nie tylko",
		"payment_text_288": "Zyskaj większy spokój o zdrowie swojego psa i martw się mniej każdego dnia",
		"payment_text_289": "Co sprawia, że Everydoggy VET jest tak skuteczny",
		"payment_text_290": "Zaufało nam ponad 3 mln właścicieli psów",
		"payment_text_291": "Czatuj w każdej chwili ze wsparciem weterynaryjnym, na którym możesz polegać",
		"payment_text_292": "Trenuj swojego psa z aplikacją Everydoggy i ciesz się <span>idealnie wychowanym towarzyszem</span>!",
		"payment_text_293": "Sprawdzone na 3 milionach psów",
		"payment_text_294": "Spersonalizowany plan treningu dopasowany do twojego psa",
		"payment_text_295": "Kiedy mój szczeniak miał biegunkę, szybko dostałam poradę od weterynarza i dokładnie wiedziałam, co robić. To oszczędziło mi mnóstwo stresu.",
		"payment_text_296": "Porady są jasne i rzetelne. Czuję, że zawsze mam przy sobie specjalistę, któremu mogę zaufać.",
		"payment_text_297": "Użyłam tego, gdy mój pies miał podrażnioną skórę i ciągle się drapał. Wskazówki były jasne i od razu poczułam spokój.",
		"payment_text_298": "Jako nowy opiekun szczeniaka uznałem to za niezwykle przydatne. Nie muszę już zgadywać.",
		"payment_text_299": "naszych użytkowników czuje się pewniej, jeśli chodzi o zdrowie swojego psa, i mniej się martwi dzięki naszemu wsparciu weterynaryjnemu",
		"payment_text_300": "<span>98% naszych użytkowników</span> czuje się pewniej, jeśli chodzi o zdrowie swojego psa, i mniej się martwi dzięki naszemu wsparciu weterynaryjnemu",
		"payment_text_301": "Twój spersonalizowany program zabawy i komunikacji <span>zaczyna się już teraz</span>!",
		"payment_text_302": "Z Everydoggy możesz <span>lepiej rozumieć swojego psa</span>, <span>mieć więcej radości ze wspólnego czasu</span> i <span>budować trwałą więź</span>!",
		"payment_text_303": "3+ mln użytkowników",
		"payment_text_304": "Cieszą się życiem ze swoimi psami",
		"payment_text_305": "Teraz",
		"payment_text_306": "Rozumienie psa",
		"payment_text_307": "Komunikacja z psem",
		"payment_text_308": "Radość z zabawy",
		"payment_text_309": "Więź",
		"payment_text_310": "Spersonalizowany program komunikacji i zabawy z twoim psem",
		"payment_text_311": "Tłumacz i rozumiej szczekanie swojego psa z AI Szczekanie",
		"payment_text_312": "🎁 Twój rabat powitalny został naliczony:",
		"payment_text_313": "<span>53%</span> ZNIŻKI",
		"payment_text_314": "Twój spersonalizowany program szkolenia psa zaczyna się teraz!",
		"payment_text_315": "Szybko zobacz efekty i ciesz się życiem z dobrze ułożonym psem!",
		"payment_text_316": "Nauczone komendy:",
		"payment_text_317": "Poziom posłuszeństwa:",
		"payment_text_318": "Niski",
		"payment_text_319": "Wysoki",
		"payment_text_320": "Spersonalizowany program szkolenia dla <span>twojego psa</span> jest gotowy!",
		"payment_text_321": "Profil treningowy",
		"payment_text_322": "Rasa psa",
		"payment_text_323": "Wiek",
		"payment_text_324": "Problemy behawioralne",
		"payment_text_325": "Obecny poziom",
		"payment_text_326": "Ponad 3 miliony",
		"payment_text_327": "opiekunów psów już cieszy się efektami",
		"payment_text_328": "Ashley K. i Moly",
		"payment_text_329": "Uwielbiam to, jak proste są codzienne zadania treningowe. Mój pies naprawdę mnie teraz słucha!",
		"payment_text_330": "Kevin R. i Tommy",
		"payment_text_331": "Nauka czystości była naszym największym wyzwaniem. Ten program jako jedyny naprawdę zadziałał.",
		"payment_text_332": "Chloe N. i Ami",
		"payment_text_333": "Mój szczeniak kiedyś gryzł wszystko. Teraz wybiera tylko swoje zabawki!",
		"payment_text_334": "Daniel H. i Cherry",
		"payment_text_335": "Spodobało mi się, że wszystko jest podzielone na małe kroki. Mój pies nauczył się komend szybciej, niż się spodziewałem.",
		"payment_text_336": "Twój plan treningu szczeniaka bez stresu zaczyna się teraz!",
		"payment_text_337": "Twój plan treningu psa bez stresu zaczyna się teraz!",
		"payment_text_338": "Twój spersonalizowany plan żywienia i zdrowia psa zaczyna się teraz!",
		"payment_text_339": "Skanuj etykiety karmy dla psów, otrzymuj porady żywieniowe od ekspertów i dbaj o to, by twój pies był <span>zdrowy i szczęśliwy</span>!",
		"payment_text_340": "Skanuj etykiety karmy. Chroń zdrowie swojego psa",
		"payment_text_341": "Skanuj etykiety karmy dla psów i szybko sprawdzaj skład oraz jakość",
		"payment_text_342": "Otrzymuj porady żywieniowe dopasowane do potrzeb twojego psa",
		"payment_text_343": "Skaner etykiet karmy to prawdziwa rewolucja. Od razu wiem, co naprawdę znajduje się w karmie mojego psa.",
		"payment_text_344": "Świetne narzędzie do monitorowania zdrowia mojego psa i poprawy jego diety. Widać efekty!",
		"payment_text_345": "Ta aplikacja sprawiła, że zarządzanie żywieniem mojego psa stało się dużo łatwiejsze. Uwielbiam spersonalizowane wskazówki!",
		"payment_text_346": "To tak, jakbym nauczyła się języka mojej suczki — teraz nawet szczekanie ma sens.",
		"payment_text_347": "Gry są niesamowite. Mój pies za każdym razem jest podekscytowany!",
		"payment_text_348": "Bawimy się, budujemy więź i wreszcie rozumiem, co moja suczka chce mi powiedzieć!",
		"payment_text_349": "naszych użytkowników czuje się pewniej w kwestii zdrowia swojego psa i mniej się martwi dzięki naszej aplikacji",
		"payment_text_350": "Co sprawia, że EveryDoggy jest tak skuteczne",
		"payment_text_351": "<span>98% naszych użytkowników</span> pewniej dba o zdrowie swojego psa i mniej się martwi z naszym planem",
		"payment_text_352": "Początkujący",
		"payment_text_353": "Twój spersonalizowany program szkolenia małego psa zaczyna się teraz!",
		"payment_text_354": "Twój spersonalizowany program treningu K9 dla psa zaczyna się teraz!",
		"payment_text_355": "Zobacz szybkie efekty: pies będzie reagować na pierwszą komendę.",
		"payment_text_356": "Ogromna różnica już po kilku tygodniach. Mój pies wreszcie reaguje za pierwszym razem.",
		"payment_text_357": "Spacery z psem nie są już stresujące. Teraz mam wszystko pod kontrolą.",
		"payment_text_358": "Bardzo szybko przeszliśmy od chaosu do spokojnego zachowania. Świetny program.",
		"payment_text_359": "Posłuszeństwo na pierwszą komendę naprawdę działa. Nie sądziłam, że to możliwe.",
		"payment_text_360": "Spersonalizowany plan treningu K9 dla psa",
		"payment_text_361": "",
		"payment_text_362": "",
		"payment_text_363": "",
		"payment_text_364": "",
		"payment_text_365": "",
		"payment_text_366": "",
		"payment_text_367": "",
		"payment_text_368": "",
		"payment_text_369": "",
		"payment_text_370": "",
		"payment_text_371": "",
		"payment_text_372": "",
		"payment_text_373": "",
		"payment_text_374": "",
		"payment_text_375": "",
		"payment_text_376": "",
		"payment_text_377": "",
		"payment_text_378": "",
		"payment_text_379": "",
		"payment_text_380": "",
		"payment_text_381": "",
		"payment_text_382": "",
		"payment_text_383": "",
		"payment_text_384": "<span>Zacznij drogę do posłusznego psa:</span> zgarnij kompletny przewodnik K9 o reaktywności",
		"payment_text_385": "Odblokuj <span>Praktyczny poradnik K9 o reaktywności</span>",
		"payment_text_386": "Spraw, by pies słuchał cię przy wyzwalaczach",
		"payment_text_387": "Zatrzymuj reakcje, nie pozwalając im narosnąć",
		"payment_text_388": "Odzyskaj kontrolę, gdy pies traci panowanie",
		"payment_text_389": "Oducz psa gwałtownego reagowania na ludzi, inne psy i samochody",
		"pdfUpselling": "",
		"pdfUpselling_1": "<span>Rozpocznij drogę prowadzącą do posłusznego psa:</span> Skorzystaj z najlepszego poradnika do szkolenia psów",
		"pdfUpselling_2": "<span>Rozpocznij drogę prowadzącą do posłusznego psa:</span> Skorzystaj z najlepszego poradnika do szkolenia psów",
		"pdfUpselling_3": "Odbierz swój <span>osobisty plan</span>",
		"pdfUpselling_4": "Odblokuj <span>praktyczny poradnik</span>",
		"pdfUpselling_5": "Korekta zachowania (w pomieszczeniach i na zewnątrz)",
		"pdfUpselling_6": "Jak chwalić i nagradzać psa",
		"pdfUpselling_7": "Różne polecenia",
		"pdfUpselling_8": "Zabawy rozwijające i wiele więcej",
		"pdfUpselling_9": "Trening korzystania z nocnika",
		"pdfUpselling_10": "Eliminacja gryzienia i żucia",
		"pdfUpselling_11": "Przystosowanie do korzystania z klatki",
		"pdfUpselling_12": "Plus 43 inne pomocne wskazówki i rozwiązania",
		"pdfUpselling_13": "Łącznie dzisiaj",
		"pdfUpselling_14": "Odblokuj poradnik",
		"pdfUpselling_15": "Odblokuj za pomocą",
		"pdfUpselling_16": "Kontynuuj bez poradnika",
		"chatUpsale_1": "Czat z trenerem psów",
		"chatUpsale_2": "Opisz zachowanie psa. My znajdziemy rozwiązanie.",
		"chatUpsale_3": "Czatuj bez ograniczeń z naszymi rzeczywistymi ekspertami od tresury psów",
		"chatUpsale_4": "Everydoggy przerośnie twoje oczekiwania!",
		"chatUpsale_5": "Przyspieszenie×2",
		"chatUpsale_6": "Plan EveryDoggy",
		"chatUpsale_7": "Czat z trenerem psów",
		"chatUpsale_8": "Trening we własnym zakresie",
		"chatUpsale_9": "NIEOGRANICZONY DOSTĘP",
		"chatUpsale_10": "Zwiększ wyniki dzięki czatowi z trenerem ekspertem!",
		"chatUpsale_11": "dostęp do czatu",
		"chatUpsale_12": "30-dniowy",
		"chatUpsale_13": "90-dniowy",
		"chatUpsale_14": "Kontynuuj bez czatu z trenerem psów",
		"chatUpsale_15": "Czat z trenerem psów nieograniczony dostęp",
		"checkoutV2_text1": "razem",
		"checkoutV2_text2": "Łatwe i prywatne płatności za pomocą Face/Touch ID",
		"checkoutV2_text3": "Chroni Twoje dane finansowe dzięki szyfrowaniu end-to-end",
		"checkoutV2_text4": "Chronione unikalnym numerem urządzenia Apple Pay",
		"checkoutV2_text5": "Szybka i wygodna metoda płatności",
		"checkoutV2_text6": "Chroni Twoje dane finansowe dzięki szyfrowaniu end-to-end",
		"checkoutV2_text7": "Wspierane przez wiodącą w branży ochronę przed oszustwami PayPal",
		"checkoutV2_text8": "Gwarancja zwrotu pieniędzy",
		"checkoutV2_text9": "Finalizacja<br />zamówienia",
		"checkoutV2_text10": "Informacje o płatności",
		"checkoutV2_text11": "Chronione",
		"error_1": "Płatność została odrzucona. Sprawdź dane karty i spróbuj ponownie.",
		"error_2": "Płatność została odrzucona. Sprawdź dane karty i spróbuj ponownie.",
		"error_3": "Niewystarczające środki na koncie. Spróbuj użyć innej karty lub metody płatności.",
		"error_4": "Upłynął termin ważności karty. Spróbuj użyć innej karty lub metody płatności.",
		"error_5": "Podczas przetwarzania karty wystąpił błąd. Spróbuj ponownie.",
		"error_6": "Kod bezpieczeństwa jest błędny. Sprawdź dane karty i spróbuj ponownie.",
		"error_7": "Karty American Express nie są obecnie obsługiwane. Spróbuj użyć innej karty lub metody płatności.",
		"error_8": "Płatność została odrzucona. Sprawdź dane karty i spróbuj ponownie.",
		"error_9": "Płatność została odrzucona. Ten adres e-mail jest już powiązany z aktywną subskrypcją.",
		"error_10": "Odrzucono płatność. Było za dużo prób lub przekroczono limit karty. Spróbuj ponownie później.",
		"disclaimerV2_text_1": "Kontynuując, akceptują Państwo nasze <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Warunki korzystania</a> oraz <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Politykę prywatności</a> i wyrażają zgodę na automatyczne odnawianie subskrypcji. Dziś zostanie Państwu naliczona tylko opłata w wysokości <span class=\"price1\">$1.99</span> za pierwszy tydzień. Jeśli Państwo nie anulują, Everydoggy automatycznie przedłuży Państwa subskrypcję po zakończeniu okresu próbnego i będzie pobierać opłatę za subskrypcję (obecnie <span class=\"price2\">$29.99</span>) co 2 tygodnie, aż do anulowania.\r\n",
		"disclaimerV2_text_2": "Kontynuując, akceptują Państwo nasze <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Warunki korzystania</a> oraz <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Politykę prywatności</a> i wyrażają Państwo zgodę na automatyczne odnawianie Państwa subskrypcji.\r\nDziś zostanie Państwu naliczona jedynie opłata w wysokości <span class=\"price1\">$6.99</span> za pierwsze 4 tygodnie. \r\nJeśli Państwo nie anulują, Everydoggy automatycznie przedłuży Państwa subskrypcję po zakończeniu okresu próbnego i \r\nbędzie pobierać opłatę za subskrypcję (obecnie <span class=\"price2\">$29.99</span>) co 2 tygodnie, aż do anulowania.\r\n",
		"disclaimerV2_text_3": "Kontynuując, akceptują Państwo nasze <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Warunki korzystania</a> oraz <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Politykę prywatności</a> i wyrażają Państwo zgodę na automatyczne odnawianie Państwa subskrypcji.\r\nDziś zostanie Państwu naliczona jedynie opłata w wysokości <span class=\"price1\">$14.99</span> za pierwsze 12 tygodni. \r\nJeśli Państwo nie anulują, Everydoggy automatycznie przedłuży Państwa subskrypcję po zakończeniu okresu próbnego i \r\nbędzie pobierać opłatę za subskrypcję (obecnie <span class=\"price2\">$49.99</span>) co 4 tygodnie, aż do anulowania.\r\n",
		"chatUpsaleV2_1": "Czat z trenerem psów",
		"chatUpsaleV2_2": "Trenuj z ekspertem od zachowania psów",
		"chatUpsaleV2_3": "Dodaj do swojego planu nielimitowane wsparcie na czacie od doświadczonych trenerów psów",
		"chatUpsaleV2_4": "Z trenerem",
		"chatUpsaleV2_5": "Skuteczność",
		"chatUpsaleV2_6": "Jasne odpowiedzi od prawdziwego eksperta",
		"chatUpsaleV2_7": "Spersonalizowane wskazówki dla Twojego psa",
		"chatUpsaleV2_8": "Szybsze efekty i mniej błędów",
		"chatUpsaleV2_9": "Spokojny, pewny siebie proces treningu",
		"chatUpsaleV2_10": "Bez trenera",
		"chatUpsaleV2_11": "Zgadywanie, czy robisz to dobrze",
		"chatUpsaleV2_12": "Powolne postępy i powtarzające się błędy",
		"chatUpsaleV2_13": "Niejasne przyczyny złego zachowania",
		"chatUpsaleV2_14": "Frustracja dla Pani/Pana i psa",
		"chatUpsaleV2_15": "Każdy pies jest inny. Skorzystaj z pomocy eksperta dla swojego!",
		"chatUpsaleV2_16": "Odpowiedzi nawet na najtrudniejsze pytania o zachowanie psa",
		"chatUpsaleV2_17": "Wsparcie zarówno emocjonalne, jak i praktyczne w treningu",
		"chatUpsaleV2_18": "Mniej stresu i frustracji podczas treningu",
		"chatUpsaleV2_19": "Spersonalizowane prowadzenie dopasowane do Pani/Pana i psa",
		"chatUpsaleV2_20": "Zapewnij sobie profesjonalne wsparcie dla maksymalnych efektów",
		"chatUpsaleV2_21": "Liczba miejsc ograniczona",
		"chatUpsaleV2_22": "Zostały ostatnie miejsca",
		"chatUpsaleV2_23": "4-tygodniowy dostęp do czatu z ekspertem — trenerem psów:",
		"chatUpsaleV2_24": "Dodatkowa zniżka 65% — oferta ograniczona:",
		"chatUpsaleV2_25": "Razem",
		"chatUpsaleV2_26": "Uzyskaj pomoc eksperta teraz",
		"chatUpsaleV2_27": "Kontynuuj bez czatu z trenerem psów",
		"chatUpsaleV2_28": "Czy mogę zadać dowolne pytanie o mojego psa?",
		"chatUpsaleV2_29": "Tak! Możesz pytać o zachowanie, trening, problemy ze szczeniakiem lub konkretne wyzwania, z którymi się mierzysz.",
		"chatUpsaleV2_30": "Jak szybko otrzymam odpowiedź?",
		"chatUpsaleV2_31": "Nasi doświadczeni trenerzy zwykle odpowiadają w ciągu 24 godzin w dni robocze.",
		"chatUpsaleV2_32": "Czy potrzebuję wcześniejszego doświadczenia w treningu?",
		"chatUpsaleV2_33": "Wcale nie. Nasi trenerzy poprowadzą Cię krok po kroku — niezależnie od tego, czy dopiero zaczynasz, czy masz doświadczenie."
	},
	"uk": {
		"global \ninstruction": "",
		"safe": "Ваша інформація в безпеці",
		"information": "Ми не будемо продавати або орендувати вашу особисту контактну інформацію для будь-яких маркетингових цілей.",
		"secure_checkout": "Безпечна покупка",
		"encrypted": "Вся інформація шифрується та передається без ризику за допомогою протоколу Secure Sockets Layer.",
		"help": "Потрібна допомога?",
		"contact": "Зв’яжіться з нами",
		"here": "тут.",
		"undefined": "",
		"featured": "Як зазначено в",
		"main_title": "Курси дресирування собак",
		"per_year": "на рік",
		"special_offer": "Спеціальна пропозиція",
		"card_number": "Номер картки",
		"card_expiry": "Термін дії картки закінчується",
		"security_number": "Номер безпеки",
		"email": "Електронна пошта",
		"To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of __period__ and at the full, not discounted, price of __fullPriceText__ To learn more visit our <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">terms of use</a>.": "Інформація про платіж",
		"secure_server": "Безпечний сервер",
		"pay": "Заплатити",
		"enter_your_email": "Введіть вашу електронну пошту",
		"comment_1": "Протягом кількох стресових років я повністю втратив форму і набрав трохи жиру, але у мене не було ні часу, ні мотивації щось з цим зробити. Один з членів родини порадив Verv, і тепер я щодня покладаюся на свого тренера!",
		"comment_2": "Verv змусив мене полюбити домашні тренування, і я скинув 7 кг за місяць. Ця програма дійсно може допомогти вам займатися спортом і худнути, якщо ви новачок, як і я.",
		"success_story": "Історія успіху",
		"get_my_plan": "ОТРИМАТИ МОЙ ПЛАН",
		"delimiter": "або",
		"pay_buy_card": "Оплатити карткою",
		"get_my_plan_warning_1": "Щоб уникнути будь-яких перерв, ви погоджуєтеся, що вибраний вами підписка буде автоматично продовжена на наступний період оновлення",
		"get_my_plan_warning_2": "і за повною, не зниженою ціною",
		"get_my_plan_warning_3": "Щоб дізнатися більше, відвідайте наш",
		"get_my_plan_warning_text": "Продовжуючи, ви погоджуєтеся з тим, що якщо ви не скасуєте підписку принаймні за 24 години до закінчення першого періоду продовження, з вас автоматично стягуватиметься повна ціна __fullPriceText__ кожні __period__ до тих пір, поки ви не скасуєте.",
		"terms_of_use": "Умови використання",
		"privacy_policy": "Політика конфіденційності",
		"terms_conditions": "Умови та положення",
		"privacy_policy_footer": "Політика конфіденційності",
		"terms_conditions_footer": "Умови та положення",
		"guaranteed": "Гарантований безпечний чек-аут",
		"special_features": "Спеціальні функції для вас",
		"calories_value": "ккал",
		"personalized_plan": "Отримайте свій персоналізований план:",
		"mobile_app": "Мобільний додаток з вашим планом",
		"daily_programs": "Щоденні програми для різних цілей (зниження жиру, зменшення стресу, набір м’язів)",
		"audio_guided": "Аудіо-гідіровані тренування",
		"easy_to_cook": "Легкі у приготуванні та смачні страви",
		"comprehensive_stats": "Комплексна статистика",
		"secret_tips": "Таємні поради щодо формування здорових звичок",
		"mobile_app_tailor": "Індивідуальний план у вашій кишені",
		"daily_programs_for": "Щоденні програми",
		"daily_programs_for_2": "Для різних цілей (спалювання жиру, зменшення стресу, набір м'язової маси)",
		"audio_trainers": "Посібники професійних тренерів",
		"comprehensive_track": "Слідкуйте за своїм прогресом з остаточною статистикою",
		"price": "Ціна",
		"users_love": "Користувачі люблять наш Персоналізований План",
		"alternative_review_name_1": "Therealtierra",
		"alternative_review_title_1": "Чудовий додаток!",
		"alternative_review_contentent_1": "Я на дев’ятому тижні, і моє тіло змінилося неймовірно!",
		"alternative_review_name_2": "тенісна дівчина",
		"alternative_review_title_2": "Це працює!",
		"alternative_review_contentent_2": "Тільки що закінчив програму. Мені це подобається. Скинув 15 кг!!",
		"you_re_in": "Ви всередині!",
		"personal_plan_starts": "Ваш особистий план Verv починається сьогодні, і час спливає. Тож перегляньте його!",
		"app_by_link": "Щоб увійти у вашу програму, завантажте додаток за посиланням",
		"download_now": "Скачати зараз",
		"or": "або",
		"price_after_trial": "Цена після пробного періоду",
		"seven_days_trial_unlocked": "7-дневний безкоштовний пробний доступ відкрито",
		"total_today": "Сьогодні всього",
		"reserved_price_for": "Резервна ціна для",
		"new_subscritions1_title": "Виберіть свій план",
		"new_subscritions1_subscription1_line1": "Піврічний план",
		"new_subscritions1_subscription1_price1_time": "на тиждень",
		"new_subscritions1_subscription2_line1": "3-місячний план",
		"new_subscritions1_subscription2_price2_time": "за тиждень",
		"new_subscritions1_subscription3_line1": "1-місячний план",
		"new_subscritions1_subscription3_price3_time": "на тиждень",
		"new_subscription_save": "ЗБЕРЕГТИ",
		"new_subscritions_agreement": "Продовжуючи, ви погоджуєтесь з",
		"new_subscritions_and": "і",
		"new_subscritions_subtitle": "Наші користувачі втратили 10 мільйонів фунтів",
		"new_subscritions_join": "Приєднуйтесь до мільйонів наших щасливих користувачів",
		"statistic_block_item1_text": "Зірки з 5",
		"statistic_block_item2_text": "оцінки 5 зірок",
		"statistic_block_item3_text": "завантаження",
		"get_your_personalized_plan": "Отримайте свій персоналізований план",
		"for": "для",
		"new_subscription_save_mostPopular1MonthPrice": "найпопулярніший план",
		"timer_additional_discount": "Додаткова знижка застосована щойно ",
		"timer_additional_discount_bold": "для вас",
		"timer_offer_expires": "Ця пропозиція закінчується через:",
		"Payment Successful": "",
		"payment_successful_title": "Привіт від команди Verv!",
		"payment_successful_download": "Завантажте додаток",
		"payment_successful_press": "Натисніть",
		"payment_successful_login": "Увійти за допомогою електронної пошти",
		"payment_successful_email": "Введіть вашу електронну пошту",
		"payment_successful_code": "і ваш код підтвердження:",
		"payment_successful_hit": "Потім натисніть",
		"payment_successful_done": "Готово",
		"payment_successful_description": "Ви всередині, насолоджуйтеся своїм персоналізованим планом тренувань!",
		"Tariffs Variants": "",
		"tariff_title_choose": "Виберіть свій план",
		"tariff_title_get": "Отримайте свій план",
		"tariff_one_month": "1-місячний план",
		"tariff_three_month": "3-місячний план",
		"tariff_six_month": "6-місячний план",
		"tariff_one_year": "1-річний план",
		"tariff_one_week": "План на 1 тиждень",
		"tariff_three_day": "3-денний план",
		"tariff_per_year": "на рік",
		"tariff_per_day": "на день",
		"tariff_per_days": "кожні 3 дні",
		"tariff_per_week": "на тиждень",
		"tariff_week": "тиждень",
		"tariff_annual": "Річний план",
		"tariff_trial_one_week": "1-тижневий безкоштовний період",
		"tariff_after": "після ",
		"tariff_save": "Зберегти",
		"tariff_best_offer": "краща пропозиція",
		"tariff_most_popular": "найпопулярніший",
		"tariff_limited_promo": "обмежена промо-ціна",
		"tariff_6_for_3": "6 за ціною 3",
		"tariff_first_month": "перший місяць",
		"tariff_first_week": "перший тиждень",
		"tariff_monthly": "щомісячний",
		"tariff_quaterly": "щоквартальний",
		"tariff_semiannually": "напіврічно",
		"tariff_billed_every ": "виставляється рахунок щомісяця ",
		"tariff_year": "рік",
		"tariff_month": "місяць",
		"tariff_months": "місяці",
		"tariff_months_variable": "місяці",
		"tariff_organic_gift": "План медитації",
		"tariff_full_price": "Повна ціна",
		"tariff_no_hidden_fees": "Без прихованих зборів",
		"tariff_start_right_now": "Почніть прямо зараз",
		"tariff_more_than": "Більше 1 000 000 активних членів родини Verv",
		"tariff_intro_offer": "ПРОПОНУЄМО ВСТУПНУ ЗНИЖКУ",
		"Тарифы плиткой в ряд": "",
		"": "",
		"Checkout": "",
		"checkout_title": "Виберіть метод оплати",
		"insufficient_funds": "Недостатньо коштів",
		"insufficient_we_have": "У нас є",
		"insufficient_special_price": "спеціальна ціна",
		"insufficient_for_you": "для вас",
		"checkout_edit_card": "Редагувати картку",
		"checkout_pay_via": "Оплатити через",
		"checkout_paypal": "PayPal",
		"checkout_credit_card": "Кредитна картка",
		"checkout_paypal_description": "Ваш платіж буде оброблений через PayPal",
		"checkout_total_price": "Загальна ціна",
		"checkout_warning_1": "Щоб уникнути будь-яких перерв, ви погоджуєтеся, що обрана вами підписка буде автоматично продовжена на наступний період поновлення",
		"checkout_warning_2": "і за повною, а не зі знижкою, ціною",
		"checkout_warning_3": "Щоб дізнатися більше, відвідайте наш",
		"spv2_warning": "Щоб уникнути перерв, ви погоджуєтеся, що обрана вами підписка буде автоматично продовжена на наступний період __________ і за повною, а не зі знижкою ціною __________. Щоб дізнатися більше, відвідайте наші <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">умови використання</a>.",
		"checkout_offer_day_for": "день для",
		"checkout_offer_days_for": "дні для",
		"checkout_offer_month_for": "місяць для",
		"checkout_offer_months_for": "місяці для",
		"checkout_offer_week_for": "тиждень для",
		"Values": "",
		"value_kg": "кг",
		"value_pounds": "фунт",
		"value_st": "ст",
		"value_g": "г",
		"value_kcal": "ккал",
		"value_min": "хв",
		"value_min_cooking": "хвилин приготування",
		"welcome_title": "Ласкаво просимо до Verv Premium!",
		"item_1_title": "Ура!",
		"item_1_description": "Ваш цільовий вага __weight__ тепер вже зовсім близько.",
		"item_2_title": "Як активувати",
		"item_2_description": "Завантажте додаток, використовуючи посилання нижче, використайте свою електронну пошту __mail__ та введіть цей код підтвердження: __code__.",
		"item_2_description_2": "Щоб змінити електронну пошту, натисніть <button id=\"changeMail\">тут</button>.",
		"item_3_title": "Щось пішло не так?",
		"item_3_description": "Детальна інструкція була надіслана на вашу електронну пошту. Якщо ви її не отримали, зв’яжіться з <a target=\"_blank\" href=\"mailto:support@verv.com?subject=Проблема з входом (simple-login)\">підтримкою</a>.",
		"change": "Підтвердити",
		"change_mail": "Змініть свою електронну пошту тут, щоб активувати Premium",
		"email_warning": "Будь ласка, введіть дійсну адресу електронної пошти",
		"Promo Code Block": "",
		"promo_code_title": "Промокод застосовано!",
		"promo_code_save": "% знижки",
		"EveryDoggy": "",
		"dog_courses": "курси для собак",
		"why_we_best_active": "Активні користувачі.",
		"why_we_best_lessons": "Відеоуроки.",
		"why_we_best_brain": "Ігри для розуму.",
		"why_we_best": "Чому ми найкращі?",
		"why_we_best_join": "Приєднуйтеся до нашої спільноти власників собак і робіть все можливе з EveryDoggy.",
		"why_we_best_enjoy": "Насолоджуйтеся вашим персоналізованим планом тренувань, адаптованим до ваших та цілей вашого собаки.",
		"why_we_best_keep": "Тримайте вашу собаку розумно та фізично активною з понад 70 іграми для розуму.",
		"dog_problems": "Швидкі рішення поведінкових проблем",
		"dog_problems_choose": "Виберіть небажані поведінки, які ви хотіли б покращити",
		"dog_problems_leash": "Повідок<br/>тягне",
		"dog_problems_biting": "Укус",
		"dog_problems_anxiety": "Тривога при розлуці<br/>",
		"dog_problems_chewing": "Руйнівне<br/>жування",
		"dog_plan": "Персоналізований план тренувань",
		"dog_plan_our": "Наша програма тренувань на 100% відповідає потребам вашої собаки.",
		"dog_reviews": "Що кажуть власники собак про EveryDoggy",
		"dog_reviews_text_1": "«Дуже зрозумілі та прості для сприйняття заняття. Моє щеня любить тренуватися, і ми обидва багато чого навчились.»",
		"dog_reviews_name_1": "Мegan та Лео",
		"dog_reviews_text_2": "Команда «Зен» творить дива. Завдяки їй моя собака суперспокійна в ветеринарній клініці під час процедур.",
		"dog_reviews_name_2": "Лінда Б.",
		"dog_reviews_text_3": "«Дякую за урок клікера. Я чув, що це дуже популярно, але не було ясно, як його використовувати. Я швидко ознайомив свого собаку з клікером, і тепер ми почали вивчати трюки.»",
		"dog_reviews_name_3": "Джейк Л.",
		"join_text": "Щасливе батьківство собак починається з EveryDoggy",
		"join_courses": "Приєднатися до веб-курсів",
		"checkout_introductory": "Знижка на вступну пропозицію",
		"checkout_personalized_plan": "Ваш персоналізований план",
		"Personal plan": "",
		"goal_lose_weight": "Ефективна програма схуднення з тренуваннями під керівництвом, трекером харчування та різноманітними активностями для вас",
		"goal_gain_muscles": "Ефективна програма тонізації всього тіла з навчальними тренуваннями, трекером харчування та різноманітними активностями для вас",
		"goal_gain_healthier_life": "Нова здорова рутина з повнотілом під керівництвом, трекером харчування та різноманітними активностями для вас",
		"goal_gain_flexibility": "Йога-програма для гнучкості з керованими сесіями, заспокійливою музикою, трекером харчування та різноманітними іншими активностями",
		"goal_gain_build_endurance": "Програма тренувань на витривалість з керованими тренуваннями, трекером харчування та різноманітними активностями для вас",
		"goal_love_myself": "Різноманіття заходів для підвищення самооцінки, керовані медитації, заняття йогою та тренування для всього тіла",
		"body_type_apple": "Вправи для яблучної форми тіла для зміцнення вашого ядра та зменшення талії.",
		"body_type_pear": "Вправи для тіла в формі груші, щоб підтягнути стегна і сідниці",
		"body_type_square": "Вправи для квадратної форми тіла, щоб визначити талію та працювати над сідницями",
		"body_type_hourglass": "Вправи для фігури у формі пісочного годинника, щоб допомогти вам досягти вражаючих результатів",
		"body_type_triangle": "Вправи для тіла у формі перевернутого трикутника для зміцнення ваших стегон і сідниць",
		"body_type_unknown": "Вправи, щоб показати найкраще у вашій фігурі",
		"excercises_time_morning": "Ранкові тренування для підвищення вашого метаболізму та енергії на цілий день",
		"excercises_time_day": "Тренування, які ідеально підходять до вашого розкладу, активізують ваш метаболізм і допомагають вам залишатися енергійним протягом дня.",
		"excercises_time_evening": "Вечірні тренування, які допоможуть вам зняти стрес після важкого дня та підготувати до хорошого сну.",
		"excercises_not_sure": "Тренування, які ідеально вписуються у ваш графік, пришвидшують ваш метаболізм і підтримують вас в енергії цілий день",
		"diet_type_all": "Легкі здорові рецепти",
		"diet_type_vegetarian": "Здорові вегетаріанські рецепти",
		"diet_type_vegan": "Корисні веганські рецепти",
		"diet_type_keto": "Здорові кето-рецепти",
		"personal_plan_providers_title": "",
		"special_features_title": "Спеціальні можливості для вас",
		"special_features_duration_minimum": "Швидкі сесії до 10 хвилин",
		"special_features_duration_normal": "Зручні сесії тривалістю менш ніж 20 хвилин",
		"special_features_duration_maximum": "Ефективні сесії тривалістю понад 20 хвилин",
		"special_features_duration_verv": "Зручні сесії від наших тренерів",
		"special_features_goal_lose_weight": "Секретні поради зниження ваги від експертів",
		"special_features_goal_gain": "Секретні поради щодо тонусування м'язів від експертів",
		"special_features_goal_health": "Секретні поради зі здоров'я від експертів",
		"special_features_goal_flexibility": "Секретні поради з гнучкості від експертів",
		"special_features_goal_endurance": "Секретні поради для підвищення витривалості",
		"special_features_goal_love": "Секретні поради для підвищення самооцінки",
		"discount_activated": "Активація знижки 50%",
		"discount_no_activated": "50% знижка",
		"unlocked_with_promo": "Розблоковано за допомогою промокоду:",
		"use_with_button": "Використовуйте свій спеціальний промокод:",
		"plan_optimal": "Оптимально",
		"plan_standard": "СТАНДАРТ",
		"plan_basic": "БАЗОВИЙ",
		"plan_extra": "ДОПОВНЕННЯ",
		"daypayback_review_name_1": "меллібет",
		"daypayback_review_text_1": "",
		"daypayback_review_name_2": "кейт_зу13",
		"daypayback_review_text_2": "Я люблю Verv! Дотримування мого особистого плану тренувань і харчування допомогло мені повернутися у форму та знову стати впевненим у собі! Я почав з коротких фітнес-тренувань до 15 хвилин, які були ідеальними для початківця, як я. Потім я збільшив свою витривалість, і час моїх тренувань збільшився до 30-40 хвилин за сесію. Я повільно, але впевнено скидав 25 фунтів за 6 місяців із Verv!",
		"daypayback_review_name_3": "Жан_леон1",
		"daypayback_review_text_3": "Під час навчання в університеті я сильно поправився. Після випуску я пробував різні дієти, які допомогли мені схуднути, але вага завжди поверталася через кілька місяців після закінчення дієти. Минулого року я почув про Verv від мого колеги і вирішив спробувати. Завдяки персоналізованим рекомендаціям Verv мені вдалося схуднути і зберегти вагу після цього!",
		"daypayback_review_name_4": "maryanne1993",
		"daypayback_review_text_4": "Після важкого розриву я вирішила змінити своє життя, схуднути та стати здоровішою. Але я не знала, з чого почати. Я не почувалася достатньо впевненою, щоб займатися з іншими, тому вирішила спробувати програми для домашніх тренувань, і Verv потрапив у мій пошук. Він запропонував мені план, адаптований до моїх потреб. Я дотримувалася його і змогла отримати тіло своїх мрій!",
		"personal_plan_you_get": "З вашим персоналізованим планом ви отримаєте",
		"goal": "Мета",
		"goal_other": "Уроки для тренування вашого пухнастого друга",
		"goal_teaching_puppy": "Уроки для навчання вашого пухнастого друга манерам і слухняності",
		"goal_surviving_puppy": "Уроки, які допоможуть вам підготуватися до перших днів з вашим пухнастим другом",
		"goal_socializing_puppy": "Уроки, щоб допомогти вам соціалізувати вашого пухнастого друга",
		"goal_teaching_obedience": "Уроки для навчання вашого пухнастого друга манерам і слухняності",
		"age_puppy": "Детальні поради з навчання від наших експертів, щоб допомогти вам виростити щасливого та вихованого щеня",
		"age_adult": "Детальні поради з тренування від наших експертів, щоб допомогти вам тренувати вашу собаку найбільш ефективним способом",
		"biting_yes": "Покрокові інструкції, як зупинити вашу собаку від укусу",
		"biting_no": "Розважальні ігри для гри з вашим собакою",
		"biting_sometimes": "Покрокові інструкції, як зупинити вашого собаку від кусання",
		"quick_tips": "Швидкі та легкі поради щодо вивчення нових команд",
		"potty_training_a_bit": "Спеціальний посібник з ефективного привчання вашого щеняти до туалету",
		"potty_training_yes": "Спеціальні посібники, щоб навчити вашого щеняти новим веселим трюкам",
		"potty_training_no": "Спеціальний путівник щодо ефективного привчання цуценяти до туалету",
		"success screen": "",
		"success_screen_text_1": "Дякуємо за вашу покупку!",
		"success_screen_text_2": "Слідуйте інструкціям нижче, щоб налаштувати<br />ваш обліковий запис:",
		"success_screen_text_3": "Перейдіть до вашого <b>аккаунту</b>",
		"success_screen_text_4": "Скануйте <b>QR-код</b> або натисніть <b>на посилання</b>",
		"success_screen_text_5": "<b>Завантажте</b> додаток",
		"success_screen_text_6": "<b>Відкрийте додаток</b> і <b>насолоджуйтесь</b><br />тренуванням з вашим собакою!",
		"success_screen_text_7": "Ми дублиювали QR-код та посилання для вас на &nbsp;<b>example@gmail.com</b>",
		"success_screen_text_8": "Якщо преміум-акаунт не був застосований в додатку, натисніть <b>‘Зв'язатися з нами’</b> на екрані вітання і зв'яжіться з нашою службою підтримки.",
		"success_screen_text_9": "Натискаючи кнопку «Розпочати», я підтверджую, що ознайомлений та приймаю <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Політику конфіденційності</a> та <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Умови використання</a>, і цим я погоджуюсь на обробку моїх персональних даних.",
		"success_screen_text_10": "Зв'яжіться з нами",
		"success_screen_text_11": "Перейти до мого акаунту",
		"success_screen_text_12": "Ми надіслали вам дублікат QR-коду та посилання електронною поштою.",
		"success_screen_text_13": "Ваш PDF посібник був надісланий на вашу електронну пошту <b>v.stsiopina@gmail.com</b>.",
		"success_screen_text_14": "Ваш PDF посібник був надісланий на вашу електронну пошту.",
		"success_screen_text_15": "Якщо преміум-акаунт не було застосовано в додатку, натисніть посилання <span>'Увійти'</span> на екрані привітання в додатку та введіть свою електронну пошту та пароль, який ми надіслали вам на <b>stepinavalerie@gmail.com</b>",
		"success_screen_text_16": "Якщо преміум-акаунт не було активовано в додатку, натисніть на посилання <span>'Увійти'</span> на екрані привітання та введіть свою електронну пошту та пароль, який ми надіслали вам електронною поштою.",
		"payment_text_1": "Ваша програма навчання собак починається зараз!",
		"payment_text_2": "Додаток Everydoggy допоможе вам <span>швидко та з задоволенням вирішити будь-які проблеми поведінки вашого собаки</span>.",
		"payment_text_3": "Персональна пропозиція закінчується",
		"payment_text_4": "наші користувачі помічають позитивні зміни в поведінці своїх собак всього через 1 тиждень після початку тренувань з нашими експертами",
		"payment_text_5": "КоженПес проти Тренерів",
		"payment_text_6": "Середня кількість команд за місяць",
		"payment_text_7": "КоженСобака отримує вигоду",
		"payment_text_8": "Персоналізований план тренування для собак",
		"payment_text_9": "Лише 15 хвилин на день для ідеального домашнього улюбленця",
		"payment_text_10": "Більше 70 легких для розуміння відеоуроків для швидких результатів",
		"payment_text_11": "80+ ігор і трюків для нових навичок і просто для задоволення",
		"payment_text_12": "Поради щодо гігієни, здоров'я та харчування",
		"payment_text_13": "Тренуйте вдома та на вулиці, обладнання не потрібне",
		"payment_text_14": "98% наших користувачів помічають позитивні зміни в поведінці своїх собак вже через 1 тиждень після початку тренування з нашими експертами.",
		"payment_text_14_2": "<span>98% наших користувачів</span> помічають позитивні зміни в поведінці своїх собак всього за 1 тиждень після початку навчання з нашими експертами",
		"payment_text_15": "Натискаючи кнопку «Отримати мій план», ви погоджуєтеся з нашими <a href='https://everydoggy.com/terms/' target=\"_blank\" >Умовами та положеннями</a> та <a href='https://everydoggy.com/policy/' target=\"_blank\" >Політикою конфіденційності</a>, <b>даєте згоду на автоматичне продовження</b> вашої підписки в кінці кожного розрахункового періоду <span>1 місяць</span> за повною ціною <i>$29.99</i> плюс податки. Ви можете скасувати автоматичне продовження вашої підписки в будь-який час до дати продовження. Перегляньте наші <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Умови скасування</a> для отримання додаткової інформації.",
		"payment_text_16": "Натискаючи кнопку «Отримати свій план», ви погоджуєтеся з нашими <a href='https://everydoggy.com/terms/' target='_blank'>Умовами та положеннями</a> та <a href='https://everydoggy.com/policy/' target='_blank'>Політикою конфіденційності</a>, <b>надаєте дозвіл на автоматичне продовження</b> вашої підписки в кінці кожного розрахункового циклу <span>1 місяць</span> за повною ціною <i>$29.99</i> плюс податки, що підлягають сплаті. Ви можете скасувати автоматичне продовження вашої підписки в будь-який час до дати продовження. Перевірте наші <a href='https://everydoggy.com/subscription-terms/' target='_blank'>Умови скасування</a> для отримання додаткової інформації.",
		"payment_text_17": "У вас є питання?",
		"payment_text_18": "Просто напишіть нам на ",
		"payment_text_19": "Це працює!",
		"payment_text_20": "Щойно завершив програму з послушання з нашим щеням, мені це подобається! 👏",
		"payment_text_21": "Чудово!",
		"payment_text_22": "Можу сказати, що я на 💯 задоволена цим застосунком. Більше жодних проблем із туалетом, вау!",
		"payment_text_23": "Чудовий застосунок 🎉",
		"payment_text_24": "Ми на третьому місяці тренувань з моїм собакою, і його навички значно покращилися!",
		"payment_text_25": "Варто спробувати",
		"payment_text_26": "Безумовно, найкращий застосунок для дресирування собак!",
		"payment_text_27": "Надихайтеся нашими користувачами!",
		"payment_text_28": " Star Focus, Inc.",
		"payment_text_29": "Якщо у вас є ще питання, просто напишіть нам на <a href=\"mailto:welove@everydoggy.com\">welove@everydoggy.com</a>",
		"payment_text_30": "Видимі результати всього через 7 днів тренувань",
		"payment_text_31": "Отримайте свій персоналізований план зі спеціальною знижкою",
		"payment_text_32": "Чим раніше ви почнете тренування, тим кращих результатів досягнете",
		"payment_text_33": "Дресирування необхідне кожному собаці. Це не тільки усунення проблем з поведінкою, але й соціалізація, встановлення зв'язку з вашим собакою та вираження вашої любові.",
		"payment_text_34": "Створено з любові і для <span>любові</span> до собак. Засновано на світовому досвіді",
		"payment_text_35": "Все, що ви знайдете в додатку, засновано на останніх дослідженнях і повністю орієнтовано на собак.",
		"payment_text_36": "Якби ваш собака міг говорити, він би попросив вас спробувати EveryDoggy!",
		"payment_text_37": "Ваша інформація в безпеці",
		"payment_text_38": "Ми не будемо продавати вашу контактну інформацію для будь-яких маркетингових цілей.",
		"payment_text_39": "Безпечна оплата",
		"payment_text_40": "Вся інформація зашифрована та передається без ризику.",
		"payment_text_41": "Потрібна допомога?",
		"payment_text_42": "Напишіть нам на email: <a href=\"mailto:welove@everydoggy.com\">welove@everydoggy.com</a>",
		"payment_text_43": "щомісяця",
		"payment_text_44": "продовжити",
		"payment_text_45": "Ваш персоналізований план:",
		"payment_text_46": "Знижка за вступною пропозицією:",
		"payment_text_47": "Продовжуючи, ви погоджуєтесь з <a href='https://everydoggy.com/terms/' target='_blank' rel=\"noreferrer\">Умовами використання</a>, <a href='https://everydoggy.com/policy/' target='_blank' rel=\"noreferrer\">Політикою конфіденційності</a> та <a href='https://everydoggy.com/subscription-terms/#subscription_cancellation' target='_blank' rel=\"noreferrer\">Умовами скасування</a>.",
		"payment_text_48": "Ваша підписка триває до",
		"payment_text_49": "Ви можете скасувати підписку в будь-який час без оплати за 24 години до закінчення підписки.",
		"payment_text_50": "Якщо ви не скасуєте підписку, ваше членство автоматично продовжиться в кінці вашого <span>1 month</span>. З вас буде стягуватися плата за членство EveryDoggy у розмірі <b>$</b><i>$29.99</i>, поки ви не скасуєте підписку.",
		"payment_text_51": "Наразі ми не пропонуємо повернення або компенсації за часткове використання підписки.",
		"payment_text_52": "Осо-бистий <br>тренер",
		"payment_text_53": "Школа <br> для собак",
		"payment_text_54": "Уроки <br> на YouTube",
		"payment_text_55": "Книги",
		"payment_text_56": "щотижня",
		"payment_text_57": "Значно кращі результати",
		"payment_text_58": "З EveryDoggy",
		"payment_text_59": "Без EveryDoggy",
		"payment_text_60": "Зараз",
		"payment_text_61": "Через 1 тиждень",
		"payment_text_62": "Це ваш останній шанс",
		"payment_text_63": "Не пропустіть унікальну знижку 65% і дізнайтеся, як швидко ваш собака навчиться виконувати команди!",
		"payment_text_64": "Отримати знижку 65%",
		"payment_text_65": "52-ТИЖНЕВИЙ ПЛАН",
		"payment_text_66": "4-ТИЖНЕВИЙ ПЛАН",
		"payment_text_67": "12-ТИЖНЕВИЙ ПЛАН",
		"payment_text_68": "тижні",
		"payment_text_69": "Січня",
		"payment_text_70": "Лютого",
		"payment_text_71": "Березня",
		"payment_text_72": "Квітня",
		"payment_text_73": "Травня",
		"payment_text_74": "Червня",
		"payment_text_75": "Липня",
		"payment_text_76": "Серпня",
		"payment_text_77": "Вересня",
		"payment_text_78": "Жовтня",
		"payment_text_79": "Листопада",
		"payment_text_80": "Грудня",
		"payment_text_81": "Будь ласка, введіть правильну адресу електронної пошти.",
		"payment_text_82": "",
		"payment_text_83": "Ваш ознайомчий період триватиме до <b>11 жовтня 2024 року</b>.",
		"payment_text_84": "Ви можете скасувати підписку в будь-який час до <b>10 жовтня 2024 року</b>, і з вас не буде стягнуто оплату.",
		"payment_text_85": "Якщо ви не скасуєте підписку, Everydoggy автоматично продовжить ваше членство після закінчення ознайомчого періоду та стягуватиме <span>щомісячну</span> абонентську плату (наразі <b>$39.99 USD</b>), доки ви її не скасуєте.",
		"payment_text_86": "",
		"payment_text_87": "",
		"payment_text_88": "Спосіб оплати",
		"payment_text_89": "",
		"payment_text_90": "",
		"payment_text_91": "",
		"payment_text_92": "",
		"payment_text_93": "Ваша платіжна інформація захищена шифруванням SSL/TLS.",
		"payment_text_94": "",
		"payment_text_95": "",
		"payment_text_96": "",
		"payment_text_97": "",
		"payment_text_98": "",
		"payment_text_99": "",
		"payment_text_100": "",
		"payment_text_101": "",
		"payment_text_102": "",
		"payment_text_103": "Натискаючи кнопку «Отримати мій план», ви погоджуєтеся з\n<a href='https://everydoggy.com/policy/' target=\"_blank\" rel=\"noreferrer\">Політикою конфіденційності</a>,\n<a href='https://everydoggy.com/terms/' target=\"_blank\" rel=\"noreferrer\">Умовами використання</a>\nта <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" rel=\"noreferrer\">Умовами скасування</a>.",
		"payment_text_104": "Прості та конфіденційні платежі",
		"payment_text_105": "Номер карти",
		"payment_text_106": "Термін дії",
		"payment_text_107": "CVC",
		"payment_text_108": "чудовий старт",
		"payment_text_109": "1-тижневий план",
		"payment_text_110": "Додаток Everydoggy допоможе <span>вирішити проблеми з туалетом та будь-які інші проблеми з поведінкою собаки</span> швидко та легко.",
		"payment_text_111": "Безпечна оплата",
		"payment_text_112": "Персоналізований план тренувань для <span>вашого собаки</span>",
		"payment_text_113": "Свисток і клікер для тренувань",
		"payment_text_114": "80+ ігор і трюків для вашого улюбленця",
		"payment_text_115": "30+ порад і статей з догляду за здоров’ям",
		"payment_text_116": "🔥 Ви щойно заощадили <span>$113.50&nbsp;</span>🔥",
		"payment_text_117": "7-денний план",
		"payment_text_118": "Натискаючи кнопку «Отримати мій план», ви погоджуєтеся з нашими <a href='https://everydoggy.com/terms/' target=\"_blank\">Умовами та положеннями</a> і <a href='https://everydoggy.com/policy/' target=\"_blank\">Політикою конфіденційності</a> та <b>авторизуєте автоматичне продовження</b> вашої підписки. Сьогодні з вас буде списано лише <span class=\"trialPrice\">$4.99</span> за перші <span class=\"trialPeriod\">7 днів</span> ознайомчого періоду. Якщо ви не скасуєте підписку, Everydoggy автоматично продовжить ваше членство після завершення ознайомчого періоду та стягуватиме абонентську плату у розмірі <span class='price'>$39.99</span> кожен <span class='period'>місяць</span> до скасування. Ви можете скасувати автоматичне продовження підписки в будь-який час до дати продовження. Докладніше дивіться в наших Умовах скасування.",
		"payment_text_119": "7 днів",
		"payment_text_120": "Сьогодні з вас буде списано лише <b>$29.99</b> за перші <span>12 тижнів</span> (подробиці нижче).",
		"payment_text_121": "Everydoggy <span>допоможе навчити</span> вашого собаку <span>ходити в туалет</span> у правильному місці та <span>виправити проблеми з поведінкою</span> швидко і весело.",
		"payment_text_122": "Привчіть собаку до туалету за 3 дні!",
		"payment_text_123": "Ваш профіль прив’язаний до цього email і не може бути змінений",
		"payment_text_124": "Продовжуючи, ви погоджуєтесь з нашими <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Умовами</a> та <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Політикою конфіденційності</a> та <span>надаєте дозвіл на автоматичне продовження</span> вашої підписки.",
		"payment_text_125": "26-ТИЖНЕВИЙ ПЛАН",
		"payment_text_126": "Якщо ви не скасуєте підписку, Everydoggy автоматично продовжить ваше членство після закінчення ознайомчого періоду та стягуватиме <span>кожні 3 місяці</span> абонентську плату (наразі <b>$39.99 USD</b>), доки ви її не скасуєте.",
		"payment_text_127": "Якщо ви не скасуєте підписку, Everydoggy автоматично продовжить ваше членство після закінчення ознайомчого періоду та стягуватиме <span>кожні 6 місяців</span> абонентську плату (наразі <b>$39.99 USD</b>), доки ви її не скасуєте.",
		"payment_text_128": "Поточний рівень",
		"payment_text_129": "команд",
		"payment_text_130": "Мета",
		"payment_text_131": "Понад 50 команд і слухняність",
		"payment_text_132": "Відчуйте помітний прогрес",
		"payment_text_133": "Досягніть слухняності",
		"payment_text_134": "Підтримуйте гарну поведінку собаки протягом усього життя",
		"payment_text_135": "Заощаджуйте 53%",
		"payment_text_136": "Гарантія повернення грошей",
		"payment_text_137": "30-денна гарантія повернення грошей",
		"payment_text_138": "Ми впевнені, що наш план підійде вам, і ви побачите помітні результати за 4 тижні! Ми навіть готові повернути вам гроші, якщо ви не побачите результату й зможете довести, що дотримувалися нашого плану.",
		"payment_text_139": "Дізнайтеся більше про обмеження в наших <a href=\"https://everydoggy.com/terms/#section5_2\" target=\"_blank\" rel=\"noreferrer\">умовах використання</a>.",
		"payment_text_140": "Заощаджуйте 65%",
		"payment_text_141": "План тренування вашого собаки готовий!",
		"payment_text_142": "Послух",
		"payment_text_143": "Знає команди",
		"payment_text_144": "Туалетні казуси",
		"payment_text_145": "Часто",
		"payment_text_146": "Жодного",
		"payment_text_147": "Гавкання",
		"payment_text_148": "Гавкає на все",
		"payment_text_149": "Тихий і розслаблений",
		"payment_text_150": "Кусання та жування",
		"payment_text_151": "Часто",
		"payment_text_152": "Припинилось",
		"payment_text_153": "Смикання повідця",
		"payment_text_154": "Завжди",
		"payment_text_155": "Йде спокійно",
		"payment_text_156": "Тривожиться, залишаючись сам",
		"payment_text_157": "Спокійний та незалежний",
		"payment_text_158": "До",
		"payment_text_159": "Після",
		"payment_text_160": "хвилин",
		"payment_text_161": "секунд",
		"payment_text_162": "Гарантовано. Перевірено. Працює",
		"payment_text_163": "Значні зміни в слухняності собаки",
		"payment_text_164": "Сьогодні",
		"payment_text_165": "Тиждень 2",
		"payment_text_166": "Тиждень 3",
		"payment_text_167": "Тиждень 4",
		"payment_text_168": "Що робить Everydoggy таким ефективним",
		"payment_text_169": "Історії успіху від наших користувачів",
		"payment_text_170": "Від експертів, які <span>люблять собак</span>",
		"payment_text_171": "Кожен наш курс і урок ґрунтується на дослідженнях з дресування собак.",
		"payment_text_172": "Створіть міцну дружбу з вашим собакою, спробуйте EveryDoggy!",
		"payment_text_173": "Доведено. Перевірено. Працює",
		"payment_text_174": "<span>93% наших користувачів</span> помічають значні зміни у поведінці своїх собак упродовж першого місяця тренувань.",
		"payment_text_175": "З EveryDoggy",
		"payment_text_176": "Без EveryDoggy",
		"payment_text_177": "Сьогодні",
		"payment_text_178": "Тиждень 2",
		"payment_text_179": "Тиждень 4",
		"payment_text_180": "Тиждень 6",
		"payment_text_181": "Про Луну",
		"payment_text_182": "З моїм цуценям постійно траплялись казуси у будинку. Everydoggy запропонував нам чітку рутину, яка справді спрацювала!",
		"payment_text_183": "Про Купера",
		"payment_text_184": "Наш цуцик раніше кусав усіх під час гри. Цей застосунок надав нам покрокове керівництво, і воно спрацювало!",
		"payment_text_185": "Про Беллу",
		"payment_text_186": "Наша собака жувала все, від взуття до дивана. Цей застосунок допоміг нам переспрямувати цю енергію!",
		"payment_text_187": "Про Чарлі",
		"payment_text_188": "Смикання повідця було щоденною проблемою. Завдяки цьому застосунку, прогулянки стали приємними та позбавленими стресу.",
		"payment_text_189": "Навчені ходити на горщик",
		"payment_text_190": "Вирішена проблема кусання",
		"payment_text_191": "Вирішена проблема жування",
		"payment_text_192": "Вирішена проблема смикання повідця",
		"payment_text_193": "<span>93% наших користувачів</span> помічають суттєві зміни в <span>поведінці та дисципліні своїх собак</span> уже в перший місяць тренувань.</span>",
		"payment_text_194": "Наші користувачі в захваті від результатів!",
		"payment_text_195": "Почніть тренуватися зі своїм собакою просто зараз!",
		"payment_text_196": "Якщо ви не скасуєте підписку, Everydoggy автоматично продовжить вашу участь після завершення вступного періоду та стягуватиме плату за участь (наразі <b>$39.99 USD</b>) <span>раз на два тижні</span>, доки ви не скасуєте.",
		"payment_text_197": "Гарантія повернення грошей",
		"payment_text_198": "30-денна гарантія повернення грошей",
		"payment_text_199": "Ми впевнені, що наш план підійде вам, і ви побачите помітні результати за 4 тижні! Ми навіть готові повернути вам гроші, якщо ви не побачите результату й зможете довести, що дотримувалися нашого плану.",
		"payment_text_200": "Дізнайтеся більше про обмеження в наших <a href=\"https://everydoggy.com/terms/#section5_2\" target=\"_blank\" rel=\"noreferrer\">умовах використання</a>.",
		"payment_text_201": "Нас часто запитують",
		"payment_text_202": "Скільки часу знадобиться, щоб побачити результати від тренувань?",
		"payment_text_203": "Більшість собак показують прогрес уже після першого заняття – і протягом кількох тижнів ви побачите вражаючі, значні результати!",
		"payment_text_204": "Чи таке ж ефективне застосунок Everydoggy, як і робота з тренером?",
		"payment_text_205": "Так, і навіть ефективніше – ви можете тренуватися щодня у власному темпі, дотримуватися зрозумілих покрокових уроків і постійно закріплювати навички, а не лише раз на тиждень із тренером.",
		"payment_text_206": "Результати тренувань зберігаються назавжди?",
		"payment_text_207": "Так! Поки ви продовжуєте закріплювати хороші звички, результати зберігаються на все життя.",
		"payment_text_208": "Отримати знижку 72%",
		"payment_text_209": "Не пропустіть унікальну знижку 72% і дізнайтеся, як швидко ваша собака навчиться виконувати команди!",
		"payment_text_210": "Продовжити з іншим способом оплати",
		"payment_text_211": "Купити з",
		"payment_text_212": "ЗНИЖКА ДО ЧОРНОЇ П’ЯТНИЦІ!",
		"payment_text_213": "",
		"payment_text_214": "",
		"payment_text_215": "",
		"payment_text_216": "",
		"payment_text_217": "",
		"payment_text_218": "Програма тренувань для вашого цуценяти починається вже зараз!",
		"payment_text_219": "Тренуйтеся з додатком Everydoggy з <span>найперших днів вашого цуценяти</span> і отримайте <span>ідеально слухняного собаку</span>!",
		"payment_text_220": "наших користувачів помічають позитивні зміни в поведінці цуценяти вже через 1 тиждень після початку тренувань з нашими експертами",
		"payment_text_221": "Персоналізований план тренувань для цуценят до 6 місяців",
		"payment_text_222": "Персоналізований план тренувань для цуценят 6–12 місяців",
		"payment_text_223": "Перевірено на 3 мільйонах цуценят",
		"payment_text_224": "Відчутні зміни у слухняності собаки",
		"payment_text_225": "Отримати знижку 70%",
		"payment_text_226": "ОСТАННІЙ ШАНС!\r",
		"payment_text_227": "24-ТИЖНЕВИЙ ПЛАН",
		"payment_text_228": "Остання програма дресирування собаки, яка вам знадобиться, починається зараз!",
		"payment_text_229": "Персоналізований план дресирування собаки для тривалих результатів",
		"payment_text_230": "Одна програма.<br />\nХороша поведінка назавжди",
		"payment_text_231": "Вік собаки",
		"payment_text_232": "Час дресирування",
		"payment_text_233": "Тривалі результати",
		"payment_text_234": "0-1 рік",
		"payment_text_235": "1-3 роки",
		"payment_text_236": "3-5 років",
		"payment_text_237": "5+ років",
		"payment_text_238": "1-2 роки",
		"payment_text_239": "3 роки",
		"payment_text_240": "4 роки",
		"payment_text_241": "2-7 років",
		"payment_text_242": "8 років",
		"payment_text_243": "9 років",
		"payment_text_244": "10+ років",
		"payment_text_245": "",
		"payment_text_246": "",
		"payment_text_247": "",
		"payment_text_248": "",
		"payment_text_249": "",
		"payment_text_250": "",
		"payment_text_251": "",
		"payment_text_252": "",
		"payment_text_253": "",
		"payment_text_254": "",
		"payment_text_255": "",
		"payment_text_256": "",
		"payment_text_257": "",
		"payment_text_258": "",
		"payment_text_259": "",
		"payment_text_260": "",
		"payment_text_261": "",
		"payment_text_262": "",
		"payment_text_263": "Собачий перекладач",
		"payment_text_264": "Зрозумійте свого собаку.<br/> Побачте результат",
		"payment_text_265": "Слухняність покращується завдяки аналізу сигналів і поведінки",
		"payment_text_266": "Персоналізований план дресирування на основі аналізу гавкоту та поведінки вашого собаки",
		"payment_text_267": "Удвічі швидше, <br />удвічі цікавіше!",
		"payment_text_268": "Отримайте повний гід із дресирування цуценяти",
		"payment_text_269": "Отримайте повний гід із дресирування собаки",
		"payment_text_270": "Попрощайтеся з проблемами з туалетом! Покрокові методи допоможуть швидко привчити собаку ходити в туалет у правильному місці.",
		"payment_text_271": "Бережіть взуття й пальці! Прості методи допоможуть відучити цуценя кусатися й гризти все підряд.",
		"payment_text_272": "Створіть для собаки безпечний і затишний простір та спокійно привчіть її до клітки.",
		"payment_text_273": "Отримайте повний набір порад від експертів щодо поведінки, слухняності й щоденного життя з собакою.",
		"payment_text_274": "Скоригуйте небажану поведінку вдома й на прогулянках за допомогою простих і дієвих методів.",
		"payment_text_275": "Зробіть навчання цікавим! Опануйте похвалу й заохочення, щоб одразу мотивувати собаку.",
		"payment_text_276": "Навчіть собаку не лише базових команд! Ви опануєте все: від важливих команд для безпеки до ефектних трюків для собак будь-якого віку.",
		"payment_text_277": "Прискорте<br /> прогрес вашої собаки <span>у 2 рази!</span>",
		"payment_text_278": "Практичний гід:",
		"payment_text_279": "ЗНИЖКА 98% лише для учасників",
		"payment_text_280": "ЗНИЖКА 70% лише для учасників",
		"payment_text_281": "Твоя програма ветеринарної підтримки для собаки починається просто зараз!",
		"payment_text_282": "Дбай про здоров’я своєї собаки з <span>підтримкою досвідчених ветлікарів</span> від Everydoggy і <span>виховуй здорову, слухняну собаку</span> з меншими тривогами",
		"payment_text_283": "Миттєва підтримка ветлікаря в чаті — без запису й без очікування",
		"payment_text_284": "Надсилай фото, щоб отримати точніші рекомендації",
		"payment_text_285": "Дізнайся про першу допомогу в екстрених ситуаціях, як-от тепловий удар, травми чи обмороження",
		"payment_text_286": "Стеж за актуальними графіками вакцинації та профілактичних оглядів",
		"payment_text_287": "Отримуй поради щодо догляду за зубами, вухами, очима, кігтями, дегельмінтизації та не тільки",
		"payment_text_288": "Почувайся впевненіше щодо здоров’я своєї собаки й менше хвилюйся щодня",
		"payment_text_289": "Що робить Everydoggy VET таким ефективним",
		"payment_text_290": "Нам довіряють понад 3 млн власників собак",
		"payment_text_291": "Спілкуйся в чаті будь-коли з ветлікарем, на якого можна покластися",
		"payment_text_292": "Тренуйте собаку з застосунком Everydoggy і насолоджуйтеся <span>ідеально вихованим компаньйоном</span>!",
		"payment_text_293": "Перевірено на 3 мільйонах собак",
		"payment_text_294": "Персональний план дресирування, створений для вашого собаки",
		"payment_text_295": "Коли в мого цуценяти була діарея, я швидко отримала пораду від ветлікаря й точно знала, що робити. Це позбавило мене великого стресу.",
		"payment_text_296": "Поради чіткі й надійні. У мене є відчуття, що поруч завжди є фахівець, якому можна довіряти.",
		"payment_text_297": "Я скористалася цим, коли в мого собаки було подразнення шкіри й постійний свербіж. Поради були чіткими, і я одразу відчула полегшення.",
		"payment_text_298": "Як новий власник цуценяти, я вважаю це неймовірно корисним. Мені більше не доводиться здогадуватися.",
		"payment_text_299": "наших користувачів почуваються впевненіше щодо здоров’я свого собаки та менше хвилюються завдяки нашій ветеринарній підтримці",
		"payment_text_300": "<span>98% наших користувачів</span> почуваються впевненіше щодо здоров’я свого собаки та менше хвилюються завдяки нашій ветеринарній підтримці",
		"payment_text_301": "Ваша персоналізована програма ігор і спілкування <span>починається просто зараз</span>!",
		"payment_text_302": "З Everydoggy ви зможете <span>краще розуміти свого собаку</span>, <span>отримувати більше радості від часу разом</span> і <span>побудувати міцний зв’язок</span>!",
		"payment_text_303": "3+ млн користувачів",
		"payment_text_304": "Насолоджуються життям зі своїми собаками",
		"payment_text_305": "Зараз",
		"payment_text_306": "Розуміння собаки",
		"payment_text_307": "Спілкування з собакою",
		"payment_text_308": "Задоволення від гри",
		"payment_text_309": "Зв’язок",
		"payment_text_310": "Персоналізована програма спілкування та ігор із вашим собакою",
		"payment_text_311": "Перекладайте й розумійте гавкіт свого собаки з AI Гавкіт",
		"payment_text_312": "🎁 Вашу вітальну знижку застосовано:",
		"payment_text_313": "<span>53%</span> ЗНИЖКИ",
		"payment_text_314": "Ваша персональна програма дресирування собаки починається зараз!",
		"payment_text_315": "Швидко побачте результат і насолоджуйтеся життям із вихованим собакою!",
		"payment_text_316": "Вивчено команд:",
		"payment_text_317": "Рівень слухняності:",
		"payment_text_318": "Низький",
		"payment_text_319": "Високий",
		"payment_text_320": "Персональна програма дресирування для <span>вашого собаки</span> готова!",
		"payment_text_321": "Профіль тренування",
		"payment_text_322": "Порода собаки",
		"payment_text_323": "Вік",
		"payment_text_324": "Проблеми з поведінкою",
		"payment_text_325": "Поточний рівень",
		"payment_text_326": "Понад 3 мільйони",
		"payment_text_327": "власників собак уже радіють результатам",
		"payment_text_328": "Ashley K. і Moly",
		"payment_text_329": "Мені подобається, які прості щоденні завдання для тренування. Мій собака тепер справді слухається!",
		"payment_text_330": "Kevin R. і Tommy",
		"payment_text_331": "Привчання до туалету було нашою найбільшою складністю. Ця програма була єдиним, що справді спрацювало.",
		"payment_text_332": "Chloe N. і Ami",
		"payment_text_333": "Раніше моє цуценя гризло все підряд. Тепер він обирає тільки свої іграшки!",
		"payment_text_334": "Daniel H. і Cherry",
		"payment_text_335": "Мені сподобалося, що все поділено на маленькі кроки. Мій собака вивчив команди швидше, ніж я очікував.",
		"payment_text_336": "Ваш план дресирування цуценяти без стресу починається вже зараз!",
		"payment_text_337": "Ваш план дресирування собаки без стресу починається вже зараз!",
		"payment_text_338": "Ваш персональний план харчування та здоров’я собаки починається вже зараз!",
		"payment_text_339": "Скануйте склад корму, отримуйте поради експертів із харчування та допомагайте своєму собаці залишатися <span>здоровим і щасливим</span>!",
		"payment_text_340": "Скануйте склад корму. Захистіть здоров’я свого собаки",
		"payment_text_341": "Скануйте склад корму та швидко дізнавайтеся про інгредієнти й якість",
		"payment_text_342": "Отримуйте персональні рекомендації з годування з урахуванням потреб вашого собаки",
		"payment_text_343": "Сканер складу корму — це справжня знахідка. Тепер я одразу розумію, що насправді в кормі мого собаки.",
		"payment_text_344": "Чудовий інструмент, щоб стежити за здоров’ям і покращувати раціон мого собаки. Помітні результати!",
		"payment_text_345": "З цим застосунком мені стало набагато простіше стежити за харчуванням мого собаки. Дуже подобаються персональні поради!",
		"payment_text_346": "Наче я вивчила мову своєї собаки — тепер навіть гавкіт має сенс.",
		"payment_text_347": "Ігри просто чудові. Мій собака щоразу в захваті!",
		"payment_text_348": "Ми граємо, стаємо ближчими, і я нарешті розумію, що хоче сказати мій собака!",
		"payment_text_349": "наших користувачів почуваються впевненіше щодо здоров’я свого собаки й менше хвилюються завдяки нашому застосунку",
		"payment_text_350": "Що робить EveryDoggy таким ефективним",
		"payment_text_351": "<span>98% наших користувачів</span> впевненіше дбають про здоров’я свого собаки й менше хвилюються з нашим планом",
		"payment_text_352": "Новачок",
		"payment_text_353": "Ваша персональна програма дресирування маленького собаки починається зараз!",
		"payment_text_354": "Ваша персоналізована програма K9-тренувань для собаки починається зараз!",
		"payment_text_355": "Отримайте швидкий результат: собака слухатиметься з першої команди!",
		"payment_text_356": "Величезна різниця всього за кілька тижнів. Мій собака нарешті слухається з першого разу.",
		"payment_text_357": "Прогулянки з собакою більше не викликають стресу. Тепер усе під контролем.",
		"payment_text_358": "Від хаосу до спокійної поведінки, і дуже швидко. Чудова програма.",
		"payment_text_359": "Слухняність із першої команди справді працює. Я й не думала, що це можливо.",
		"payment_text_360": "Персоналізований план K9-тренувань для собаки",
		"payment_text_361": "",
		"payment_text_362": "",
		"payment_text_363": "",
		"payment_text_364": "",
		"payment_text_365": "",
		"payment_text_366": "",
		"payment_text_367": "",
		"payment_text_368": "",
		"payment_text_369": "",
		"payment_text_370": "",
		"payment_text_371": "",
		"payment_text_372": "",
		"payment_text_373": "",
		"payment_text_374": "",
		"payment_text_375": "",
		"payment_text_376": "",
		"payment_text_377": "",
		"payment_text_378": "",
		"payment_text_379": "",
		"payment_text_380": "",
		"payment_text_381": "",
		"payment_text_382": "",
		"payment_text_383": "",
		"payment_text_384": "<span>Почніть шлях до слухняного собаки:</span> отримайте вичерпний K9-посібник з реактивності",
		"payment_text_385": "Відкрийте доступ до <span>практичного K9-посібника з реактивності</span>",
		"payment_text_386": "Навчіть собаку слухатися вас поряд із тригерами",
		"payment_text_387": "Зупиняйте реакції, не даючи їм посилитися",
		"payment_text_388": "Повертайте контроль, коли собака зривається",
		"payment_text_389": "Відучіть собаку гостро реагувати на людей, інших собак і машини",
		"pdfUpselling": "",
		"pdfUpselling_1": "<span>Розпочніть шлях до слухняного собаки:</span> отримайте повний посібник з виховання та дресирування собак",
		"pdfUpselling_2": "<span>Розпочніть шлях до слухняного собаки:</span> отримайте повний посібник з виховання та дресирування цуценят",
		"pdfUpselling_3": "Отримайте свій <span>персональний план</span>",
		"pdfUpselling_4": "Відкрийте <span>практичний посібник</span>",
		"pdfUpselling_5": "Корекція поведінки (вдома та на вулиці)",
		"pdfUpselling_6": "Як хвалити та винагороджувати собаку",
		"pdfUpselling_7": "Різноманітні команди",
		"pdfUpselling_8": "Розвиваючі ігри та багато іншого",
		"pdfUpselling_9": "Привчання до туалету",
		"pdfUpselling_10": "Зупиніть кусання та жування",
		"pdfUpselling_11": "Тренування з використанням клітки",
		"pdfUpselling_12": "Плюс ще 43 корисні поради та рішення",
		"pdfUpselling_13": "Загальна сума на сьогодні",
		"pdfUpselling_14": "Відкрити посібник",
		"pdfUpselling_15": "Відкрити за допомогою",
		"pdfUpselling_16": "Продовжити без посібника",
		"chatUpsale_1": "Чат з кінологом",
		"chatUpsale_2": "Опишіть поведінку вашого собаки. Рішення — за нами!",
		"chatUpsale_3": "Спілкуйтеся з нашими справжніми експертами-кінологами без обмежень.",
		"chatUpsale_4": "Отримайте від EveryDoggy більше, ніж очікуєте!",
		"chatUpsale_5": "Прискорення ×2",
		"chatUpsale_6": "План EveryDoggy",
		"chatUpsale_7": "Чат з кінологом",
		"chatUpsale_8": "Тренування самостійно",
		"chatUpsale_9": "БЕЗЛІМІТНИЙ ДОСТУП",
		"chatUpsale_10": "Прискорте результати за допомогою чату з експертом-кінологом!",
		"chatUpsale_11": "Доступ до чату",
		"chatUpsale_12": "30 днів",
		"chatUpsale_13": "90 днів",
		"chatUpsale_14": "Продовжити без чату з кінологом",
		"chatUpsale_15": "Чат з кінологом необмежений доступ",
		"checkoutV2_text1": "разом",
		"checkoutV2_text2": "Прості й конфіденційні платежі з Face/Touch ID",
		"checkoutV2_text3": "Захищає вашу фінансову інформацію за допомогою наскрізного шифрування",
		"checkoutV2_text4": "Захищено за допомогою унікального номера пристрою Apple Pay",
		"checkoutV2_text5": "Швидкий і зручний спосіб оплати",
		"checkoutV2_text6": "Захищає вашу фінансову інформацію за допомогою наскрізного шифрування",
		"checkoutV2_text7": "Підтримується передовим захистом від шахрайства PayPal",
		"checkoutV2_text8": "Гарантія повернення грошей",
		"checkoutV2_text9": "Оформлення<br />замовлення",
		"checkoutV2_text10": "Платіжна інформація",
		"checkoutV2_text11": "Захищено",
		"error_1": "Платіж відхилено. Будь ласка, перевірте дані картки та спробуйте ще раз.",
		"error_2": "Платіж відхилено. Будь ласка, перевірте дані картки та спробуйте ще раз.",
		"error_3": "Недостатньо коштів. Будь ласка, спробуйте іншу картку або спосіб оплати.",
		"error_4": "Термін дії вашої картки минув. Будь ласка, спробуйте іншу картку або спосіб оплати.",
		"error_5": "Виникла помилка під час обробки вашої картки. Будь ласка, спробуйте ще раз.",
		"error_6": "Невірний код безпеки. Будь ласка, перевірте дані картки та спробуйте ще раз.",
		"error_7": "Картки American Express наразі не підтримуються. Будь ласка, спробуйте іншу картку або спосіб оплати.",
		"error_8": "Платіж відхилено. Будь ласка, перевірте дані картки та спробуйте ще раз.",
		"error_9": "Платіж відхилено. Ця електронна адреса вже прив’язана до активної підписки.",
		"error_10": "Платіж відхилено. Забагато спроб або перевищено ліміт картки. Будь ласка, спробуйте пізніше.",
		"disclaimerV2_text_1": "Продовжуючи, Ви погоджуєтесь з нашими <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Умовами та положеннями</a> і <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Політикою конфіденційності</a> та надаєте дозвіл на автоматичне поновлення Вашої підписки. Сьогодні з Вас буде стягнуто лише <span class=\"price1\">$1.99</span> за перший тиждень. Якщо Ви не скасуєте підписку, Everydoggy автоматично продовжить Вашу підписку після завершення пробного періоду та стягуватиме плату за підписку (наразі <span class=\"price2\">$29.99</span>) кожні 2 тижні, доки Ви не скасуєте підписку.\r\n\n",
		"disclaimerV2_text_2": "Продовжуючи, Ви погоджуєтесь з нашими <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Умовами та положеннями</a> і <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Політикою конфіденційності</a> та надаєте дозвіл на автоматичне поновлення Вашої підписки.\r\nСьогодні з Вас буде стягнуто лише <span class=\"price1\">$6.99</span> за перші 4 тижні. \r\nЯкщо Ви не скасуєте підписку, Everydoggy автоматично продовжить Вашу підписку після завершення пробного періоду і \r\nстягуватиме плату за підписку (наразі <span class=\"price2\">$29.99</span>) кожні 2 тижні, доки Ви не скасуєте підписку.\r\n",
		"disclaimerV2_text_3": "Продовжуючи, Ви погоджуєтесь з нашими <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Умовами та положеннями</a> і <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Політикою конфіденційності</a> та надаєте дозвіл на автоматичне поновлення Вашої підписки.\r\nСьогодні з Вас буде стягнуто лише <span class=\"price1\">$14.99</span> за перші 12 тижнів. \r\nЯкщо Ви не скасуєте підписку, Everydoggy автоматично продовжить Вашу підписку після завершення пробного періоду і \r\nстягуватиме плату за підписку (наразі <span class=\"price2\">$49.99</span>) кожні 4 тижні, доки Ви не скасуєте підписку.\r\n",
		"chatUpsaleV2_1": "Чат із кінологом",
		"chatUpsaleV2_2": "Тренуйтеся з експертом із поведінки собак",
		"chatUpsaleV2_3": "Додайте до свого плану необмежену підтримку в чаті від досвідчених кінологів",
		"chatUpsaleV2_4": "З кінологом",
		"chatUpsaleV2_5": "Ефективність",
		"chatUpsaleV2_6": "Чіткі відповіді від справжнього експерта",
		"chatUpsaleV2_7": "Персональні поради для вашого собаки",
		"chatUpsaleV2_8": "Швидші результати з меншою кількістю помилок",
		"chatUpsaleV2_9": "Спокійний, упевнений процес навчання",
		"chatUpsaleV2_10": "Без кінолога",
		"chatUpsaleV2_11": "Сумніви, чи все ви робите правильно",
		"chatUpsaleV2_12": "Повільний прогрес і повторювані помилки",
		"chatUpsaleV2_13": "Незрозумілі причини поганої поведінки",
		"chatUpsaleV2_14": "Розчарування для вас і вашого собаки",
		"chatUpsaleV2_15": "Кожен собака різний. Отримайте допомогу експерта саме для вашого!",
		"chatUpsaleV2_16": "Відповіді навіть на найскладніші запитання про поведінку собаки",
		"chatUpsaleV2_17": "Підтримка і емоційна, і практична під час навчання",
		"chatUpsaleV2_18": "Менше стресу та розчарування під час тренувань",
		"chatUpsaleV2_19": "Персональні рекомендації, адаптовані для вас і вашого собаки",
		"chatUpsaleV2_20": "Отримайте професійну підтримку для максимальних результатів",
		"chatUpsaleV2_21": "Кількість місць обмежена",
		"chatUpsaleV2_22": "Залишилися останні місця",
		"chatUpsaleV2_23": "Доступ до чату з кінологом-експертом на 4 тижні:",
		"chatUpsaleV2_24": "Додаткова знижка 65% — обмежено:",
		"chatUpsaleV2_25": "Разом",
		"chatUpsaleV2_26": "Отримати допомогу експерта зараз",
		"chatUpsaleV2_27": "Продовжити без чату з кінологом",
		"chatUpsaleV2_28": "Чи можу я поставити будь-яке запитання про свого собаку?",
		"chatUpsaleV2_29": "Так! Ви можете запитувати про поведінку, дресирування, питання зі щеням або конкретні труднощі, з якими ви стикаєтеся.",
		"chatUpsaleV2_30": "Як швидко я отримаю відповідь?",
		"chatUpsaleV2_31": "Наші досвідчені кінологи зазвичай відповідають протягом 24 годин у будні дні.",
		"chatUpsaleV2_32": "Чи потрібен мені попередній досвід дресирування?",
		"chatUpsaleV2_33": "Зовсім ні. Наші кінологи ведуть вас крок за кроком — незалежно від того, ви новачок чи досвідчений власник."
	},
	"nl": {
		"global \ninstruction": "",
		"safe": "Uw informatie is veilig",
		"information": "We zullen uw persoonlijke contactinformatie onder geen enkele marketingdoeleinden verkopen of verhuren.",
		"secure_checkout": "Veilige afrekening",
		"encrypted": "Alle informatie wordt versleuteld verzonden zonder risico met behulp van een Secure Sockets Layer-protocol.",
		"help": "Heeft u hulp nodig?",
		"contact": "Neem contact met ons op",
		"here": "hier.",
		"undefined": "",
		"featured": "Zoals vermeld in",
		"main_title": "Hondentrainingscursussen",
		"per_year": "per jaar",
		"special_offer": "Speciale aanbieding",
		"card_number": "Kaartnummer",
		"card_expiry": "Kaart verloopt",
		"security_number": "Beveiligingsnummer",
		"email": "E-mail",
		"To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of __period__ and at the full, not discounted, price of __fullPriceText__ To learn more visit our <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">terms of use</a>.": "Betalingsinformatie",
		"secure_server": "Veilige server",
		"pay": "Betalen",
		"enter_your_email": "Voer uw e-mailadres in",
		"comment_1": "Tijdens een aantal stressvolle jaren ben ik helemaal uit vorm geraakt en heb ik een beetje vet aangekomen, maar ik had geen tijd of motivatie om er iets aan te doen. Een familielid stelde Verv voor en nu vertrouw ik dagelijks op mijn Coach!",
		"comment_2": "Verv heeft ervoor gezorgd dat ik thuis workouts leuk vond en ik ben in een maand 7 kg kwijtgeraakt. Deze app kan je echt helpen met trainen en afvallen als je een beginner bent zoals ik.",
		"success_story": "Succesverhaal",
		"get_my_plan": "KRIJG MIJN PLAN",
		"delimiter": "of",
		"pay_buy_card": "Betaal met kaart",
		"get_my_plan_warning_1": "Om onderbrekingen te voorkomen, stemt u ermee in dat het door u gekozen abonnement automatisch wordt verlengd voor een opvolgende verlengingsperiode van",
		"get_my_plan_warning_2": "en tegen de volle, niet-kortingsprijs van",
		"get_my_plan_warning_3": "Voor meer informatie, bezoek onze",
		"get_my_plan_warning_text": "Door door te gaan, gaat u akkoord met het feit dat als u niet minimaal 24 uur voor het einde van de eerste verlengingsperiode annuleert, u automatisch de volle prijs van __fullPriceText__ elke __period__ in rekening wordt gebracht totdat u annuleert.",
		"terms_of_use": "Gebruiksvoorwaarden",
		"privacy_policy": "Privacybeleid",
		"terms_conditions": "Voorwaarden",
		"privacy_policy_footer": "Privacybeleid",
		"terms_conditions_footer": "Voorwaarden",
		"guaranteed": "Gegarandeerde veilige afreken",
		"special_features": "Speciale functies voor jou",
		"calories_value": "kcal",
		"personalized_plan": "Krijg uw persoonlijke plan:",
		"mobile_app": "Mobiele app met uw plan",
		"daily_programs": "Dagelijkse programma's voor verschillende doelen (vet verbranden, stress verminderen, spieropbouw)",
		"audio_guided": "Audio-geleide workouts",
		"easy_to_cook": "Gemakkelijk te koken en lekkere gerechten",
		"comprehensive_stats": "Omvangrijke statistieken",
		"secret_tips": "Geheime tips voor het ontwikkelen van gezonde gewoonten",
		"mobile_app_tailor": "Op maat gemaakt plan in je zak",
		"daily_programs_for": "Dagprogramma's",
		"daily_programs_for_2": "Voor verschillende doelen (vet verbranden, stress verminderen, spieropbouw)",
		"audio_trainers": "Gidsen van professionele trainers",
		"comprehensive_track": "Volg uw voortgang met ultieme statistieken",
		"price": "Prijs",
		"users_love": "Gebruikers houden van ons Persoonlijk Plan",
		"alternative_review_name_1": "Therealtierra",
		"alternative_review_title_1": " Geweldige app!",
		"alternative_review_contentent_1": "Ik ben op mijn negende week en mijn lichaam is enorm veranderd!",
		"alternative_review_name_2": "tennismeisje",
		"alternative_review_title_2": "Het werkt!",
		"alternative_review_contentent_2": "Ik heb het programma net afgerond. Ik hou ervan. 15 kg kwijt!!",
		"you_re_in": "Je bent binnen!",
		"personal_plan_starts": "Je persoonlijke Verv-plan begint vandaag en de klok tikt. Kijk er dus naar!",
		"app_by_link": "Om uw programma te betreden, download de app via de link",
		"download_now": "Nu downloaden",
		"or": "of",
		"price_after_trial": "Prijs na proefperiode",
		"seven_days_trial_unlocked": "7-daagse proefversie ontgrendeld",
		"total_today": "Totaal vandaag",
		"reserved_price_for": "Gereserveerde prijs voor",
		"new_subscritions1_title": "Kies uw plan",
		"new_subscritions1_subscription1_line1": "Haljaarsplan",
		"new_subscritions1_subscription1_price1_time": "per week",
		"new_subscritions1_subscription2_line1": "3-maandenplan",
		"new_subscritions1_subscription2_price2_time": "per week",
		"new_subscritions1_subscription3_line1": "1-maand plan",
		"new_subscritions1_subscription3_price3_time": "per week",
		"new_subscription_save": "OPSLAAN",
		"new_subscritions_agreement": "Door door te gaan, stem je in met",
		"new_subscritions_and": "en",
		"new_subscritions_subtitle": "Onze gebruikers hebben 10 miljoen pond verloren",
		"new_subscritions_join": "Sluit je aan bij miljoenen van onze tevreden gebruikers",
		"statistic_block_item1_text": "Sterren uit 5",
		"statistic_block_item2_text": "5-sterrenbeoordelingen",
		"statistic_block_item3_text": "downloads",
		"get_your_personalized_plan": "Krijg je gepersonaliseerd plan",
		"for": "voor",
		"new_subscription_save_mostPopular1MonthPrice": "het populairste plan",
		"timer_additional_discount": "Extra korting net toegepast ",
		"timer_additional_discount_bold": "voor jou",
		"timer_offer_expires": "Dit aanbod verloopt over:",
		"Payment Successful": "",
		"payment_successful_title": "Hallo van het Verv-team!",
		"payment_successful_download": "Download de app",
		"payment_successful_press": "Druk",
		"payment_successful_login": "Log in met e-mail",
		"payment_successful_email": "Voer uw e-mailadres in",
		"payment_successful_code": "en uw bevestigingcode:",
		"payment_successful_hit": "Dan tik op",
		"payment_successful_done": "Klaar",
		"payment_successful_description": "Je bent binnen, geniet van je gepersonaliseerd trainingsplan!",
		"Tariffs Variants": "",
		"tariff_title_choose": "Kies uw plan",
		"tariff_title_get": "Krijg uw plan",
		"tariff_one_month": "1-maandplan",
		"tariff_three_month": "3-maandenplan",
		"tariff_six_month": "6-maandenplan",
		"tariff_one_year": "1-jaarplan",
		"tariff_one_week": "1-week plan",
		"tariff_three_day": "3-dagenplan",
		"tariff_per_year": "per jaar",
		"tariff_per_day": "per dag",
		"tariff_per_days": "om de 3 dagen",
		"tariff_per_week": "per week",
		"tariff_week": "week",
		"tariff_annual": "Jaarplan",
		"tariff_trial_one_week": "1-week proefperiode",
		"tariff_after": "na ",
		"tariff_save": "Opslaan",
		"tariff_best_offer": "beste aanbieding",
		"tariff_most_popular": "meest populair",
		"tariff_limited_promo": "beperkte promotieprijs",
		"tariff_6_for_3": "6 voor de prijs van 3",
		"tariff_first_month": "eerste maand",
		"tariff_first_week": "eerste week",
		"tariff_monthly": "maandelijks",
		"tariff_quaterly": "kwartaal",
		"tariff_semiannually": "halfjaarlijks",
		"tariff_billed_every ": "in rekening gebracht elke ",
		"tariff_year": "jaar",
		"tariff_month": "maand",
		"tariff_months": "maanden",
		"tariff_months_variable": "maanden",
		"tariff_organic_gift": "Meditatieplan",
		"tariff_full_price": "Volledige prijs",
		"tariff_no_hidden_fees": "Geen verborgen kosten",
		"tariff_start_right_now": "Begin nu",
		"tariff_more_than": "Meer dan 1.000.000 actieve leden van de Verv-familie",
		"tariff_intro_offer": "INTRODUCEER AANBIEDING",
		"Тарифы плиткой в ряд": "",
		"": "",
		"Checkout": "",
		"checkout_title": "Selecteer een betaalmethode",
		"insufficient_funds": "Onvoldoende saldo",
		"insufficient_we_have": "We hebben een",
		"insufficient_special_price": "speciale prijs",
		"insufficient_for_you": "voor jou",
		"checkout_edit_card": "Kaart bewerken",
		"checkout_pay_via": "Betalen via",
		"checkout_paypal": "PayPal",
		"checkout_credit_card": "Creditcard",
		"checkout_paypal_description": "Uw betaling wordt verwerkt via PayPal",
		"checkout_total_price": "Totaalprijs",
		"checkout_warning_1": "Om onderbrekingen te voorkomen, stemt u ermee in dat het door u geselecteerde abonnement automatisch wordt verlengd voor een volgende verlengingsperiode van",
		"checkout_warning_2": "en voor de volle, niet afgeprijsde, prijs van",
		"checkout_warning_3": "Voor meer informatie, bezoek onze",
		"spv2_warning": "Om onderbrekingen te voorkomen, gaat u ermee akkoord dat het abonnement dat u hebt geselecteerd automatisch wordt verlengd voor een opvolgende verlengingsperiode van __________ en tegen de volle prijs, niet met korting, __________. Voor meer informatie kunt u onze <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">gebruikersvoorwaarden</a> bekijken.",
		"checkout_offer_day_for": "dag voor",
		"checkout_offer_days_for": "dagen voor",
		"checkout_offer_month_for": "maand voor",
		"checkout_offer_months_for": "maanden voor",
		"checkout_offer_week_for": "week voor",
		"Values": "",
		"value_kg": "kg",
		"value_pounds": "lbs",
		"value_st": "st",
		"value_g": "g",
		"value_kcal": "kcal",
		"value_min": "min",
		"value_min_cooking": "minuten koken",
		"welcome_title": "Welkom bij Verv Premium!",
		"item_1_title": "Joepie!",
		"item_1_description": "Je streefgewicht van __weight__ is nu dichtbij.",
		"item_2_title": "Hoe te activeren",
		"item_2_description": "Download de app via de onderstaande link, gebruik je e-mail __mail__ en voer deze validatiecode in: __code__.",
		"item_2_description_2": "Om de e-mail te veranderen, klik <button id=\"changeMail\">hier</button>.",
		"item_3_title": "Er is iets misgegaan?",
		"item_3_description": "Een gedetailleerde instructie is naar uw e-mail verzonden. Als u deze niet heeft ontvangen, neem dan contact op met <a target=\"_blank\" href=\"mailto:support@verv.com?subject=Probleem met inloggen (simple-login)\">de support</a>.",
		"change": "Bevestigen",
		"change_mail": "Verander hier je e-mail om Premium te activeren",
		"email_warning": "Vul alstublieft een geldig e-mailadres in",
		"Promo Code Block": "",
		"promo_code_title": "Promotiecode toegepast!",
		"promo_code_save": "% korting",
		"EveryDoggy": "",
		"dog_courses": "hondencursussen",
		"why_we_best_active": "Actieve gebruikers.",
		"why_we_best_lessons": "Videolessen.",
		"why_we_best_brain": "Breinspellen.",
		"why_we_best": "Waarom zijn wij de beste?",
		"why_we_best_join": "Sluit je aan bij onze hondenbezittersgemeenschap en doe je best met EveryDoggy.",
		"why_we_best_enjoy": "Geniet van je gepersonaliseerd trainingsplan, afgestemd op jouw doelen en die van je hond.",
		"why_we_best_keep": "Houd je hond mentaal en fysiek actief met meer dan 70 hersenspellen.",
		"dog_problems": "Snelle oplossingen voor gedragsproblemen",
		"dog_problems_choose": "Kies de ongewenste gedragingen die je wilt verbeteren",
		"dog_problems_leash": "Leiband<br/>trekken",
		"dog_problems_biting": "Bijten",
		"dog_problems_anxiety": "Scheiding angst<br/>",
		"dog_problems_chewing": "Destructief<br/>kauwen",
		"dog_plan": "Persoonlijk trainingsplan",
		"dog_plan_our": "Ons trainingsprogramma is 100% afgestemd op de behoeften van uw hond.",
		"dog_reviews": "Wat hondenbezitters zeggen over EveryDoggy",
		"dog_reviews_text_1": "«Zeer duidelijke en gemakkelijk te volgen lessen. Mijn puppy vindt het leuk om te trainen en we hebben allebei veel geleerd.»",
		"dog_reviews_name_1": "Megan en Leo",
		"dog_reviews_text_2": "De \"Zen\"-opdracht doet wonderen. Dankzij het is mijn hond superkalme tijdens de procedures in de dierenkliniek.",
		"dog_reviews_name_2": "Linda B.",
		"dog_reviews_text_3": "„Bedankt voor de clicker-training les. Ik heb gehoord dat het erg populair is, maar het was onduidelijk hoe het te gebruiken. Ik heb mijn hond snel vertrouwd gemaakt met de clicker en nu zijn we begonnen met het leren van trucs.”",
		"dog_reviews_name_3": "Jake L.",
		"join_text": "Gelukkig hondenouderschap begint met EveryDoggy",
		"join_courses": "Doe mee aan webcursussen",
		"checkout_introductory": "Introductieaanbod korting",
		"checkout_personalized_plan": "Uw gepersonaliseerde plan",
		"Personal plan": "",
		"goal_lose_weight": "Effectief afvallen programma met geleide trainingen, voedingsmonitor en een verscheidenheid aan activiteiten voor jou",
		"goal_gain_muscles": "Effectief totaal lichaamsverstevigingsprogramma met begeleide trainingen, voedings tracker en een verscheidenheid aan activiteiten voor jou",
		"goal_gain_healthier_life": "Nieuwe gezonde routine met begeleide full-body workouts, voedingsdesk en een verscheidenheid aan activiteiten voor jou",
		"goal_gain_flexibility": "Yoga-programma voor flexibiliteit met begeleide sessies en rustgevende muziek, voedingsmonitor en een verscheidenheid aan andere activiteiten",
		"goal_gain_build_endurance": "Uithoudingsvermogen training programma met begeleide workouts, voedingsmonitor en een verscheidenheid aan activiteiten voor jou",
		"goal_love_myself": "Een verscheidenheid aan activiteiten om uw zelfvertrouwen te vergroten, begeleide meditaties, yogasessies en full body workouts",
		"body_type_apple": "Oefeningen voor een appelvormig lichaam om je core te versterken en je taille te versmallen.",
		"body_type_pear": "Oefeningen voor een peer-gevormd lichaam om je heupen en bovenbenen te verstevigen",
		"body_type_square": "Oefeningen voor een vierkant lichaam om je taille te definiëren en je billen te trainen",
		"body_type_hourglass": "Oefeningen voor een zandloper-vormig lichaam om je te helpen verbazingwekkende resultaten te behalen",
		"body_type_triangle": "Oefeningen voor een omgekeerde driehoek lichaamsvorm om je heupen en dijen te versterken",
		"body_type_unknown": "Oefeningen om het beste uit je lichaamshouding te halen",
		"excercises_time_morning": "Ochtendoefeningen om je metabolisme te stimuleren en je de hele dag energie te geven",
		"excercises_time_day": "Workouts die perfect in uw schema passen, uw metabolisme verhogen en u de hele dag energie geven.",
		"excercises_time_evening": "Avondtrainingen om je te helpen stress te verlichten na een lange dag en je voor te bereiden op een goede nachtrust.",
		"excercises_not_sure": "Workouts die perfect in uw schema passen, uw metabolisme stimuleren en u de hele dag energiek houden",
		"diet_type_all": "Gemakkelijke gezonde recepten",
		"diet_type_vegetarian": "Gezonde vegetarische recepten",
		"diet_type_vegan": "Gezonde vegan recepten",
		"diet_type_keto": "Gezonde keto-recepten",
		"personal_plan_providers_title": "",
		"special_features_title": "Speciale functies voor jou",
		"special_features_duration_minimum": "Snelle sessies van minder dan 10 minuten",
		"special_features_duration_normal": "Handige sessies van minder dan 20 minuten",
		"special_features_duration_maximum": "Effectieve sessies van meer dan 20 minuten",
		"special_features_duration_verv": "Gemakkelijke sessies van onze coaches",
		"special_features_goal_lose_weight": "Geheime afvaltips van experts",
		"special_features_goal_gain": "Geheime spierverstevigingstips van experts",
		"special_features_goal_health": "Geheime gezondheidstips van experts",
		"special_features_goal_flexibility": "Geheime flexibiliteitstips van experts",
		"special_features_goal_endurance": "Geheime tips om uithoudingsvermogen te verbeteren",
		"special_features_goal_love": "Geheime tips voor een boost in zelfvertrouwen",
		"discount_activated": "50% korting geactiveerd",
		"discount_no_activated": "50% korting",
		"unlocked_with_promo": "Ontgrendeld met de promotiecode:",
		"use_with_button": "Gebruik uw speciale promotiecode:",
		"plan_optimal": "Optimaal",
		"plan_standard": "STANDAARD",
		"plan_basic": "BASIS",
		"plan_extra": "EXTRA",
		"daypayback_review_name_1": "melliebeth",
		"daypayback_review_text_1": "",
		"daypayback_review_name_2": "katie_zu13",
		"daypayback_review_text_2": "Ik hou van Verv! Het volgen van mijn persoonlijke trainings- en maaltijdplan heeft me geholpen om weer in shape te komen en weer zelfvertrouwen te krijgen! Ik begon met korte fitness-workouts van minder dan 15 minuten, perfect voor een beginner zoals ik. Daarna heb ik mijn uithoudingsvermogen opgebouwd en mijn trainingstijd steeg naar 30-40 minuten per sessie. Ik heb langzaam maar zeker 25 pond (11,3 kg) verloren in 6 maanden met Verv!",
		"daypayback_review_name_3": "Jean_leon1",
		"daypayback_review_text_3": "Ik ben tijdens mijn studie veel gewicht aangekomen. Na mijn afstuderen heb ik verschillende diëten geprobeerd die me hielpen af te vallen, maar dat gewicht kwam altijd terug enkele maanden nadat het dieet voorbij was. Vorig jaar hoorde ik van Verv van een collega en besloot het een kans te geven. Met Verv's gepersonaliseerde aanbevelingen is het me gelukt om af te vallen en het erna ook vast te houden!",
		"daypayback_review_name_4": "maryanne1993",
		"daypayback_review_text_4": "Na een moeilijke break-up besloot ik mijn leven te veranderen, af te vallen en gezonder te worden. Maar ik wist niet waar ik moest beginnen. Ik voelde me niet zeker genoeg om met anderen te trainen, dus besloot ik thuis workout-apps uit te proberen en Verv kwam op mijn pad. Het bood me een plan dat op mijn behoeften was afgestemd. Ik volgde het en slaagde erin het lichaam van mijn dromen te krijgen!",
		"personal_plan_you_get": "Met uw gepersonaliseerd plan krijgt u",
		"goal": "Doel",
		"goal_other": "Lessen voor het trainen van je harige vriend",
		"goal_teaching_puppy": "Lessen om uw harige vriend manieren en gehoorzaamheid te leren",
		"goal_surviving_puppy": "Lessen om je te helpen voorbereiden op de eerste dagen met je harige vriend",
		"goal_socializing_puppy": "Lesssen om je harige vriendje te helpen socialiseren",
		"goal_teaching_obedience": "Lessen om je harige vriend manieren en gehoorzaamheid bij te brengen",
		"age_puppy": "Gedetailleerde trainingsadviezen van onze experts om je te helpen een gelukkige en goed opgevoede pup groot te brengen",
		"age_adult": "Gedetailleerde trainingstips van onze experts om je te helpen je hond op de meest effectieve manier te trainen",
		"biting_yes": "Stapsgewijze instructies om je hond te stoppen met bijten",
		"biting_no": "Vermakelijke spellen om met je hond te spelen",
		"biting_sometimes": "Stap-voor-stap instructies om te voorkomen dat je hond bijt",
		"quick_tips": "Snelle en gemakkelijke tips voor het leren van nieuwe opdrachten",
		"potty_training_a_bit": "Een speciale gids om je pup effectief zindelijk te maken",
		"potty_training_yes": "Speciale gidsen om je pup nieuwe leuke trucjes te leren",
		"potty_training_no": "Een speciale gids om je pup effectief zindelijk te maken",
		"success screen": "",
		"success_screen_text_1": "Bedankt voor uw aankoop!",
		"success_screen_text_2": "Volg de onderstaande instructies om uw<br />account in te stellen:",
		"success_screen_text_3": "Ga naar uw <b>account</b>",
		"success_screen_text_4": "Scan <b>QR-code</b> of tik op <b>de link</b>",
		"success_screen_text_5": "<b>Download</b> de app",
		"success_screen_text_6": "<b>Open de app</b> en <b>geniet</b><br />van de training met je hond!",
		"success_screen_text_7": "We hebben de QR-code en de link voor u gedupliceerd naar &nbsp;<b>example@gmail.com</b>",
		"success_screen_text_8": "Als het premiumaccount niet in de app is toegepast, druk dan op <b>‘Neem contact met ons op’</b> op het welkomstscherm en neem contact op met ons ondersteuningsteam.",
		"success_screen_text_9": "Door op de knop 'Aan de slag' te drukken, bevestig ik dat ik de <a href=\"https://everydoggy.com/policy/\" target=\"_blank\">Privacy Policy</a> en de <a href=\"https://everydoggy.com/terms/\" target=\"_blank\">Algemene Voorwaarden</a> heb bekeken en accepteer, en ga ik hierbij akkoord met de verwerking van mijn persoonsgegevens.",
		"success_screen_text_10": "Neem contact met ons op",
		"success_screen_text_11": "Ga naar mijn account",
		"success_screen_text_12": "We hebben je een geduplicateerde QR-code en link per e-mail gestuurd.",
		"success_screen_text_13": "Je PDF-gids is naar je e-mailadres <b>v.stsiopina@gmail.com</b> gestuurd.",
		"success_screen_text_14": "Uw PDF-gids is naar uw e-mail verzonden.",
		"success_screen_text_15": "Als het premiumaccount niet in de app is toegepast, druk dan op de <span>'Inloggen'</span> link op het welkomstscherm in de app en voer uw e-mail en het wachtwoord in dat we naar <b>stepinavalerie@gmail.com</b> hebben gestuurd.",
		"success_screen_text_16": "Als het premiumaccount niet is toegepast in de app, klik dan op de <span>'Inloggen'</span> link op het welkomstscherm in de app en voer uw e-mail en het wachtwoord in dat we u per e-mail hebben gestuurd.",
		"payment_text_1": "Jouw honden trainingsprogramma begint nu!",
		"payment_text_2": "De Everydoggy-app helpt om <span>elke gedragsprobleem van uw hond snel en met plezier op te lossen</span>.",
		"payment_text_3": "Persoonlijk aanbod verloopt",
		"payment_text_4": "van onze gebruikers merken positieve veranderingen in het gedrag van hun hond slechts 1 week na het begin van de training met onze experts",
		"payment_text_5": "ElkeHond vs Coaches",
		"payment_text_6": "Gemiddeld aantal opdrachten per maand",
		"payment_text_7": "ElkeHond profiteert",
		"payment_text_8": "Persoonlijk trainingsplan voor honden",
		"payment_text_9": "Slechts 15 minuten per dag voor een perfect huisdier",
		"payment_text_10": "Meer dan 70 gemakkelijk te begrijpen video-traininglessen voor snelle resultaten",
		"payment_text_11": "80+ spellen en trucs voor nieuwe vaardigheden en gewoon voor de lol",
		"payment_text_12": "Tips over hygiëne, gezondheid en voeding",
		"payment_text_13": "Train thuis en buiten, geen apparatuur nodig",
		"payment_text_14": "98% van onze gebruikers merkt binnen 1 week na het starten van de training met onze experts positieve veranderingen in het gedrag van hun hond op.",
		"payment_text_14_2": "<span>98% van onze gebruikers</span> merkt positieve veranderingen in het gedrag van hun hond al na 1 week training met onze experts",
		"payment_text_15": "Door op de knop 'Mijn plan krijgen' te klikken, stem je in met onze <a href='https://everydoggy.com/terms/' target=\"_blank\" >Algemene Voorwaarden</a> en <a href='https://everydoggy.com/policy/' target=\"_blank\" >Privacybeleid</a>, <b>geef je toestemming voor automatische vernieuwing</b> van je abonnement aan het einde van elke factureringscyclus van <span>1 maand</span> tegen de volle prijs van <i>$29.99</i> plus eventuele belastingen. Je kunt de automatische vernieuwing van je abonnement op elk moment vóór de vernieuwingsdatum annuleren. Kijk voor meer details in onze <a href='https://everydoggy.com/subscription-terms/' target=\"_blank\" >Annuleringsvoorwaarden</a>.",
		"payment_text_16": "Door op de knop ‘Krijg mijn plan’ te klikken, stemt u in met onze <a href='https://everydoggy.com/terms/' target='_blank'>Algemene Voorwaarden</a> en <a href='https://everydoggy.com/policy/' target='_blank'>Privacybeleid</a>, <b>geeft u toestemming voor automatische vernieuwing</b> van uw abonnement aan het einde van elke factureringscyclus van <span>1 maand</span> tegen de volle prijs van <i>$29.99</i> plus toepasselijke belastingen. U kunt de automatische verlenging van uw abonnement op elk moment vóór de verlengingsdatum annuleren. Bekijk onze <a href='https://everydoggy.com/subscription-terms/' target='_blank'>Annuleringsvoorwaarden</a> voor meer details.",
		"payment_text_17": "Heeft u een vraag?",
		"payment_text_18": "Schrijf gewoon naar ons op ",
		"payment_text_19": "Het werkt!",
		"payment_text_20": "Ik heb net het gehoorzaamheidsprogramma met onze puppy afgerond, ik hou ervan! 👏",
		"payment_text_21": "Fantastisch!",
		"payment_text_22": "",
		"payment_text_23": "",
		"payment_text_24": "",
		"payment_text_25": "",
		"payment_text_26": "",
		"payment_text_27": "",
		"payment_text_28": "",
		"payment_text_29": "",
		"payment_text_30": "",
		"payment_text_31": "",
		"payment_text_32": "",
		"payment_text_33": "",
		"payment_text_34": "",
		"payment_text_35": "",
		"payment_text_36": "",
		"payment_text_37": "",
		"payment_text_38": "",
		"payment_text_39": "",
		"payment_text_40": "",
		"payment_text_41": "",
		"payment_text_42": "",
		"payment_text_43": "",
		"payment_text_44": "",
		"payment_text_45": "",
		"payment_text_46": "",
		"payment_text_47": "",
		"payment_text_48": "",
		"payment_text_49": "",
		"payment_text_50": "",
		"payment_text_51": "",
		"payment_text_52": "",
		"payment_text_53": "",
		"payment_text_54": "",
		"payment_text_55": "",
		"payment_text_56": "",
		"payment_text_57": "",
		"payment_text_58": "",
		"payment_text_59": "",
		"payment_text_60": "",
		"payment_text_61": "",
		"payment_text_62": "",
		"payment_text_63": "",
		"payment_text_64": "",
		"payment_text_65": "",
		"payment_text_66": "",
		"payment_text_67": "",
		"payment_text_68": "",
		"payment_text_69": "",
		"payment_text_70": "",
		"payment_text_71": "",
		"payment_text_72": "",
		"payment_text_73": "",
		"payment_text_74": "",
		"payment_text_75": "",
		"payment_text_76": "",
		"payment_text_77": "",
		"payment_text_78": "",
		"payment_text_79": "",
		"payment_text_80": "",
		"payment_text_81": "",
		"payment_text_82": "",
		"payment_text_83": "",
		"payment_text_84": "",
		"payment_text_85": "",
		"payment_text_86": "",
		"payment_text_87": "",
		"payment_text_88": "",
		"payment_text_89": "",
		"payment_text_90": "",
		"payment_text_91": "",
		"payment_text_92": "",
		"payment_text_93": "",
		"payment_text_94": "",
		"payment_text_95": "",
		"payment_text_96": "",
		"payment_text_97": "",
		"payment_text_98": "",
		"payment_text_99": "",
		"payment_text_100": "",
		"payment_text_101": "",
		"payment_text_102": "",
		"payment_text_103": "",
		"payment_text_104": "",
		"payment_text_105": "",
		"payment_text_106": "",
		"payment_text_107": "",
		"payment_text_108": "",
		"payment_text_109": "",
		"payment_text_110": "",
		"payment_text_111": "",
		"payment_text_112": "",
		"payment_text_113": "",
		"payment_text_114": "",
		"payment_text_115": "",
		"payment_text_116": "",
		"payment_text_117": "",
		"payment_text_118": "",
		"payment_text_119": "",
		"payment_text_120": "",
		"payment_text_121": "",
		"payment_text_122": "",
		"payment_text_123": "",
		"payment_text_124": "",
		"payment_text_125": "",
		"payment_text_126": "",
		"payment_text_127": "",
		"payment_text_128": "",
		"payment_text_129": "",
		"payment_text_130": "",
		"payment_text_131": "",
		"payment_text_132": "",
		"payment_text_133": "",
		"payment_text_134": "",
		"payment_text_135": "",
		"payment_text_136": "",
		"payment_text_137": "",
		"payment_text_138": "",
		"payment_text_139": "",
		"payment_text_140": "",
		"payment_text_141": "",
		"payment_text_142": "",
		"payment_text_143": "",
		"payment_text_144": "",
		"payment_text_145": "",
		"payment_text_146": "",
		"payment_text_147": "",
		"payment_text_148": "",
		"payment_text_149": "",
		"payment_text_150": "",
		"payment_text_151": "",
		"payment_text_152": "",
		"payment_text_153": "",
		"payment_text_154": "",
		"payment_text_155": "",
		"payment_text_156": "",
		"payment_text_157": "",
		"payment_text_158": "",
		"payment_text_159": "",
		"payment_text_160": "",
		"payment_text_161": "",
		"payment_text_162": "",
		"payment_text_163": "",
		"payment_text_164": "",
		"payment_text_165": "",
		"payment_text_166": "",
		"payment_text_167": "",
		"payment_text_168": "",
		"payment_text_169": "",
		"payment_text_170": "",
		"payment_text_171": "",
		"payment_text_172": "",
		"payment_text_173": "",
		"payment_text_174": "",
		"payment_text_175": "",
		"payment_text_176": "",
		"payment_text_177": "",
		"payment_text_178": "",
		"payment_text_179": "",
		"payment_text_180": "",
		"payment_text_181": "",
		"payment_text_182": "",
		"payment_text_183": "",
		"payment_text_184": "",
		"payment_text_185": "",
		"payment_text_186": "",
		"payment_text_187": "",
		"payment_text_188": "",
		"payment_text_189": "",
		"payment_text_190": "",
		"payment_text_191": "",
		"payment_text_192": "",
		"payment_text_193": "",
		"payment_text_194": "",
		"payment_text_195": "",
		"payment_text_196": "",
		"payment_text_197": "",
		"payment_text_198": "",
		"payment_text_199": "",
		"payment_text_200": "",
		"payment_text_201": "",
		"payment_text_202": "",
		"payment_text_203": "",
		"payment_text_204": "",
		"payment_text_205": "",
		"payment_text_206": "",
		"payment_text_207": "",
		"payment_text_208": "",
		"payment_text_209": "",
		"payment_text_210": "",
		"payment_text_211": "",
		"payment_text_212": "",
		"payment_text_213": "",
		"payment_text_214": "",
		"payment_text_215": "",
		"payment_text_216": "",
		"payment_text_217": "",
		"payment_text_218": "",
		"payment_text_219": "",
		"payment_text_220": "",
		"payment_text_221": "",
		"payment_text_222": "",
		"payment_text_223": "",
		"payment_text_224": "",
		"payment_text_225": "",
		"payment_text_226": "LAATSTE KANS!",
		"payment_text_227": "",
		"payment_text_228": "",
		"payment_text_229": "",
		"payment_text_230": "",
		"payment_text_231": "",
		"payment_text_232": "",
		"payment_text_233": "",
		"payment_text_234": "",
		"payment_text_235": "",
		"payment_text_236": "",
		"payment_text_237": "",
		"payment_text_238": "",
		"payment_text_239": "",
		"payment_text_240": "",
		"payment_text_241": "",
		"payment_text_242": "",
		"payment_text_243": "",
		"payment_text_244": "",
		"payment_text_245": "",
		"payment_text_246": "",
		"payment_text_247": "",
		"payment_text_248": "",
		"payment_text_249": "",
		"payment_text_250": "",
		"payment_text_251": "",
		"payment_text_252": "",
		"payment_text_253": "",
		"payment_text_254": "",
		"payment_text_255": "",
		"payment_text_256": "",
		"payment_text_257": "",
		"payment_text_258": "",
		"payment_text_259": "",
		"payment_text_260": "",
		"payment_text_261": "",
		"payment_text_262": "",
		"payment_text_263": "",
		"payment_text_264": "",
		"payment_text_265": "",
		"payment_text_266": "",
		"payment_text_267": "",
		"payment_text_268": "",
		"payment_text_269": "",
		"payment_text_270": "",
		"payment_text_271": "",
		"payment_text_272": "",
		"payment_text_273": "",
		"payment_text_274": "",
		"payment_text_275": "",
		"payment_text_276": "",
		"payment_text_277": "",
		"payment_text_278": "",
		"payment_text_279": "",
		"payment_text_280": "",
		"payment_text_281": "",
		"payment_text_282": "",
		"payment_text_283": "",
		"payment_text_284": "",
		"payment_text_285": "",
		"payment_text_286": "",
		"payment_text_287": "",
		"payment_text_288": "",
		"payment_text_289": "",
		"payment_text_290": "",
		"payment_text_291": "",
		"payment_text_292": "",
		"payment_text_293": "",
		"payment_text_294": "",
		"payment_text_295": "",
		"payment_text_296": "",
		"payment_text_297": "",
		"payment_text_298": "",
		"payment_text_299": "",
		"payment_text_300": "",
		"payment_text_301": "",
		"payment_text_302": "",
		"payment_text_303": "",
		"payment_text_304": "",
		"payment_text_305": "",
		"payment_text_306": "",
		"payment_text_307": "",
		"payment_text_308": "",
		"payment_text_309": "",
		"payment_text_310": "",
		"payment_text_311": "",
		"payment_text_312": "",
		"payment_text_313": "",
		"payment_text_314": "",
		"payment_text_315": "",
		"payment_text_316": "",
		"payment_text_317": "",
		"payment_text_318": "",
		"payment_text_319": "",
		"payment_text_320": "",
		"payment_text_321": "",
		"payment_text_322": "",
		"payment_text_323": "",
		"payment_text_324": "",
		"payment_text_325": "",
		"payment_text_326": "",
		"payment_text_327": "",
		"payment_text_328": "",
		"payment_text_329": "",
		"payment_text_330": "",
		"payment_text_331": "",
		"payment_text_332": "",
		"payment_text_333": "",
		"payment_text_334": "",
		"payment_text_335": "",
		"payment_text_336": "",
		"payment_text_337": "",
		"payment_text_338": "",
		"payment_text_339": "",
		"payment_text_340": "",
		"payment_text_341": "",
		"payment_text_342": "",
		"payment_text_343": "",
		"payment_text_344": "",
		"payment_text_345": "",
		"payment_text_346": "",
		"payment_text_347": "",
		"payment_text_348": "",
		"payment_text_349": "",
		"payment_text_350": "",
		"payment_text_351": "",
		"payment_text_352": "",
		"payment_text_353": "",
		"payment_text_354": "",
		"payment_text_355": "",
		"payment_text_356": "",
		"payment_text_357": "",
		"payment_text_358": "",
		"payment_text_359": "",
		"payment_text_360": "",
		"payment_text_361": "",
		"payment_text_362": "",
		"payment_text_363": "",
		"payment_text_364": "",
		"payment_text_365": "",
		"payment_text_366": "",
		"payment_text_367": "",
		"payment_text_368": "",
		"payment_text_369": "",
		"payment_text_370": "",
		"payment_text_371": "",
		"payment_text_372": "",
		"payment_text_373": "",
		"payment_text_374": "",
		"payment_text_375": "",
		"payment_text_376": "",
		"payment_text_377": "",
		"payment_text_378": "",
		"payment_text_379": "",
		"payment_text_380": "",
		"payment_text_381": "",
		"payment_text_382": "",
		"payment_text_383": "",
		"payment_text_384": "",
		"payment_text_385": "",
		"payment_text_386": "",
		"payment_text_387": "",
		"payment_text_388": "",
		"payment_text_389": "",
		"pdfUpselling": "",
		"pdfUpselling_1": "",
		"pdfUpselling_2": "",
		"pdfUpselling_3": "",
		"pdfUpselling_4": "",
		"pdfUpselling_5": "",
		"pdfUpselling_6": "",
		"pdfUpselling_7": "",
		"pdfUpselling_8": "",
		"pdfUpselling_9": "",
		"pdfUpselling_10": "",
		"pdfUpselling_11": "",
		"pdfUpselling_12": "",
		"pdfUpselling_13": "",
		"pdfUpselling_14": "",
		"pdfUpselling_15": "",
		"pdfUpselling_16": "",
		"chatUpsale_1": "",
		"chatUpsale_2": "",
		"chatUpsale_3": "",
		"chatUpsale_4": "",
		"chatUpsale_5": "",
		"chatUpsale_6": "",
		"chatUpsale_7": "",
		"chatUpsale_8": "",
		"chatUpsale_9": "",
		"chatUpsale_10": "",
		"chatUpsale_11": "",
		"chatUpsale_12": "",
		"chatUpsale_13": "",
		"chatUpsale_14": "",
		"chatUpsale_15": "",
		"checkoutV2_text1": "",
		"checkoutV2_text2": "",
		"checkoutV2_text3": "",
		"checkoutV2_text4": "",
		"checkoutV2_text5": "",
		"checkoutV2_text6": "",
		"checkoutV2_text7": "",
		"checkoutV2_text8": "",
		"checkoutV2_text9": "",
		"checkoutV2_text10": "",
		"checkoutV2_text11": "",
		"error_1": "",
		"error_2": "",
		"error_3": "",
		"error_4": "",
		"error_5": "",
		"error_6": "",
		"error_7": "",
		"error_8": "",
		"error_9": "",
		"error_10": "",
		"disclaimerV2_text_1": "",
		"disclaimerV2_text_2": "",
		"disclaimerV2_text_3": "",
		"chatUpsaleV2_1": "",
		"chatUpsaleV2_2": "",
		"chatUpsaleV2_3": "",
		"chatUpsaleV2_4": "",
		"chatUpsaleV2_5": "",
		"chatUpsaleV2_6": "",
		"chatUpsaleV2_7": "",
		"chatUpsaleV2_8": "",
		"chatUpsaleV2_9": "",
		"chatUpsaleV2_10": "",
		"chatUpsaleV2_11": "",
		"chatUpsaleV2_12": "",
		"chatUpsaleV2_13": "",
		"chatUpsaleV2_14": "",
		"chatUpsaleV2_15": "",
		"chatUpsaleV2_16": "",
		"chatUpsaleV2_17": "",
		"chatUpsaleV2_18": "",
		"chatUpsaleV2_19": "",
		"chatUpsaleV2_20": "",
		"chatUpsaleV2_21": "",
		"chatUpsaleV2_22": "",
		"chatUpsaleV2_23": "",
		"chatUpsaleV2_24": "",
		"chatUpsaleV2_25": "",
		"chatUpsaleV2_26": "",
		"chatUpsaleV2_27": "",
		"chatUpsaleV2_28": "",
		"chatUpsaleV2_29": "",
		"chatUpsaleV2_30": "",
		"chatUpsaleV2_31": "",
		"chatUpsaleV2_32": "",
		"chatUpsaleV2_33": ""
	},
	"da": {
		"global \ninstruction": "",
		"safe": "",
		"information": "",
		"secure_checkout": "",
		"encrypted": "",
		"help": "",
		"contact": "",
		"here": "",
		"undefined": "",
		"featured": "",
		"main_title": "",
		"per_year": "",
		"special_offer": "",
		"card_number": "",
		"card_expiry": "",
		"security_number": "",
		"email": "",
		"To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of __period__ and at the full, not discounted, price of __fullPriceText__ To learn more visit our <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">terms of use</a>.": "",
		"secure_server": "",
		"pay": "",
		"enter_your_email": "",
		"comment_1": "",
		"comment_2": "",
		"success_story": "",
		"get_my_plan": "",
		"delimiter": "",
		"pay_buy_card": "",
		"get_my_plan_warning_1": "",
		"get_my_plan_warning_2": "",
		"get_my_plan_warning_3": "",
		"get_my_plan_warning_text": "",
		"terms_of_use": "",
		"privacy_policy": "",
		"terms_conditions": "",
		"privacy_policy_footer": "",
		"terms_conditions_footer": "",
		"guaranteed": "",
		"special_features": "",
		"calories_value": "",
		"personalized_plan": "",
		"mobile_app": "",
		"daily_programs": "",
		"audio_guided": "",
		"easy_to_cook": "",
		"comprehensive_stats": "",
		"secret_tips": "",
		"mobile_app_tailor": "",
		"daily_programs_for": "",
		"daily_programs_for_2": "",
		"audio_trainers": "",
		"comprehensive_track": "",
		"price": "",
		"users_love": "",
		"alternative_review_name_1": "",
		"alternative_review_title_1": "",
		"alternative_review_contentent_1": "",
		"alternative_review_name_2": "",
		"alternative_review_title_2": "",
		"alternative_review_contentent_2": "",
		"you_re_in": "",
		"personal_plan_starts": "",
		"app_by_link": "",
		"download_now": "",
		"or": "",
		"price_after_trial": "",
		"seven_days_trial_unlocked": "",
		"total_today": "",
		"reserved_price_for": "",
		"new_subscritions1_title": "",
		"new_subscritions1_subscription1_line1": "",
		"new_subscritions1_subscription1_price1_time": "",
		"new_subscritions1_subscription2_line1": "",
		"new_subscritions1_subscription2_price2_time": "",
		"new_subscritions1_subscription3_line1": "",
		"new_subscritions1_subscription3_price3_time": "",
		"new_subscription_save": "",
		"new_subscritions_agreement": "",
		"new_subscritions_and": "",
		"new_subscritions_subtitle": "",
		"new_subscritions_join": "",
		"statistic_block_item1_text": "",
		"statistic_block_item2_text": "",
		"statistic_block_item3_text": "",
		"get_your_personalized_plan": "",
		"for": "",
		"new_subscription_save_mostPopular1MonthPrice": "",
		"timer_additional_discount": "",
		"timer_additional_discount_bold": "",
		"timer_offer_expires": "",
		"Payment Successful": "",
		"payment_successful_title": "",
		"payment_successful_download": "",
		"payment_successful_press": "",
		"payment_successful_login": "",
		"payment_successful_email": "",
		"payment_successful_code": "",
		"payment_successful_hit": "",
		"payment_successful_done": "",
		"payment_successful_description": "",
		"Tariffs Variants": "",
		"tariff_title_choose": "",
		"tariff_title_get": "",
		"tariff_one_month": "",
		"tariff_three_month": "",
		"tariff_six_month": "",
		"tariff_one_year": "",
		"tariff_one_week": "",
		"tariff_three_day": "",
		"tariff_per_year": "",
		"tariff_per_day": "",
		"tariff_per_days": "",
		"tariff_per_week": "",
		"tariff_week": "",
		"tariff_annual": "",
		"tariff_trial_one_week": "",
		"tariff_after": "",
		"tariff_save": "",
		"tariff_best_offer": "",
		"tariff_most_popular": "",
		"tariff_limited_promo": "",
		"tariff_6_for_3": "",
		"tariff_first_month": "",
		"tariff_first_week": "",
		"tariff_monthly": "",
		"tariff_quaterly": "",
		"tariff_semiannually": "",
		"tariff_billed_every ": "",
		"tariff_year": "",
		"tariff_month": "",
		"tariff_months": "",
		"tariff_months_variable": "",
		"tariff_organic_gift": "",
		"tariff_full_price": "",
		"tariff_no_hidden_fees": "",
		"tariff_start_right_now": "",
		"tariff_more_than": "",
		"tariff_intro_offer": "",
		"Тарифы плиткой в ряд": "",
		"": "",
		"Checkout": "",
		"checkout_title": "",
		"insufficient_funds": "",
		"insufficient_we_have": "",
		"insufficient_special_price": "",
		"insufficient_for_you": "",
		"checkout_edit_card": "",
		"checkout_pay_via": "",
		"checkout_paypal": "",
		"checkout_credit_card": "",
		"checkout_paypal_description": "",
		"checkout_total_price": "",
		"checkout_warning_1": "",
		"checkout_warning_2": "",
		"checkout_warning_3": "",
		"spv2_warning": "",
		"checkout_offer_day_for": "",
		"checkout_offer_days_for": "",
		"checkout_offer_month_for": "",
		"checkout_offer_months_for": "",
		"checkout_offer_week_for": "",
		"Values": "",
		"value_kg": "",
		"value_pounds": "",
		"value_st": "",
		"value_g": "",
		"value_kcal": "",
		"value_min": "",
		"value_min_cooking": "",
		"welcome_title": "",
		"item_1_title": "",
		"item_1_description": "",
		"item_2_title": "",
		"item_2_description": "",
		"item_2_description_2": "",
		"item_3_title": "",
		"item_3_description": "",
		"change": "",
		"change_mail": "",
		"email_warning": "",
		"Promo Code Block": "",
		"promo_code_title": "",
		"promo_code_save": "",
		"EveryDoggy": "",
		"dog_courses": "",
		"why_we_best_active": "",
		"why_we_best_lessons": "",
		"why_we_best_brain": "",
		"why_we_best": "",
		"why_we_best_join": "",
		"why_we_best_enjoy": "",
		"why_we_best_keep": "",
		"dog_problems": "",
		"dog_problems_choose": "",
		"dog_problems_leash": "",
		"dog_problems_biting": "",
		"dog_problems_anxiety": "",
		"dog_problems_chewing": "",
		"dog_plan": "",
		"dog_plan_our": "",
		"dog_reviews": "",
		"dog_reviews_text_1": "",
		"dog_reviews_name_1": "",
		"dog_reviews_text_2": "",
		"dog_reviews_name_2": "",
		"dog_reviews_text_3": "",
		"dog_reviews_name_3": "",
		"join_text": "",
		"join_courses": "",
		"checkout_introductory": "",
		"checkout_personalized_plan": "",
		"Personal plan": "",
		"goal_lose_weight": "",
		"goal_gain_muscles": "",
		"goal_gain_healthier_life": "",
		"goal_gain_flexibility": "",
		"goal_gain_build_endurance": "",
		"goal_love_myself": "",
		"body_type_apple": "",
		"body_type_pear": "",
		"body_type_square": "",
		"body_type_hourglass": "",
		"body_type_triangle": "",
		"body_type_unknown": "",
		"excercises_time_morning": "",
		"excercises_time_day": "",
		"excercises_time_evening": "",
		"excercises_not_sure": "",
		"diet_type_all": "",
		"diet_type_vegetarian": "",
		"diet_type_vegan": "",
		"diet_type_keto": "",
		"personal_plan_providers_title": "",
		"special_features_title": "",
		"special_features_duration_minimum": "",
		"special_features_duration_normal": "",
		"special_features_duration_maximum": "",
		"special_features_duration_verv": "",
		"special_features_goal_lose_weight": "",
		"special_features_goal_gain": "",
		"special_features_goal_health": "",
		"special_features_goal_flexibility": "",
		"special_features_goal_endurance": "",
		"special_features_goal_love": "",
		"discount_activated": "",
		"discount_no_activated": "",
		"unlocked_with_promo": "",
		"use_with_button": "",
		"plan_optimal": "",
		"plan_standard": "",
		"plan_basic": "",
		"plan_extra": "",
		"daypayback_review_name_1": "",
		"daypayback_review_text_1": "",
		"daypayback_review_name_2": "",
		"daypayback_review_text_2": "",
		"daypayback_review_name_3": "",
		"daypayback_review_text_3": "",
		"daypayback_review_name_4": "",
		"daypayback_review_text_4": "",
		"personal_plan_you_get": "",
		"goal": "",
		"goal_other": "",
		"goal_teaching_puppy": "",
		"goal_surviving_puppy": "",
		"goal_socializing_puppy": "",
		"goal_teaching_obedience": "",
		"age_puppy": "",
		"age_adult": "",
		"biting_yes": "",
		"biting_no": "",
		"biting_sometimes": "",
		"quick_tips": "",
		"potty_training_a_bit": "",
		"potty_training_yes": "",
		"potty_training_no": "",
		"success screen": "",
		"success_screen_text_1": "",
		"success_screen_text_2": "",
		"success_screen_text_3": "",
		"success_screen_text_4": "",
		"success_screen_text_5": "",
		"success_screen_text_6": "",
		"success_screen_text_7": "",
		"success_screen_text_8": "",
		"success_screen_text_9": "",
		"success_screen_text_10": "",
		"success_screen_text_11": "",
		"success_screen_text_12": "",
		"success_screen_text_13": "",
		"success_screen_text_14": "",
		"success_screen_text_15": "",
		"success_screen_text_16": "",
		"payment_text_1": "",
		"payment_text_2": "",
		"payment_text_3": "",
		"payment_text_4": "",
		"payment_text_5": "",
		"payment_text_6": "",
		"payment_text_7": "",
		"payment_text_8": "",
		"payment_text_9": "",
		"payment_text_10": "",
		"payment_text_11": "",
		"payment_text_12": "",
		"payment_text_13": "",
		"payment_text_14": "",
		"payment_text_14_2": "",
		"payment_text_15": "",
		"payment_text_16": "",
		"payment_text_17": "",
		"payment_text_18": "",
		"payment_text_19": "",
		"payment_text_20": "",
		"payment_text_21": "",
		"payment_text_22": "",
		"payment_text_23": "",
		"payment_text_24": "",
		"payment_text_25": "",
		"payment_text_26": "",
		"payment_text_27": "",
		"payment_text_28": "",
		"payment_text_29": "",
		"payment_text_30": "",
		"payment_text_31": "",
		"payment_text_32": "",
		"payment_text_33": "",
		"payment_text_34": "",
		"payment_text_35": "",
		"payment_text_36": "",
		"payment_text_37": "",
		"payment_text_38": "",
		"payment_text_39": "",
		"payment_text_40": "",
		"payment_text_41": "",
		"payment_text_42": "",
		"payment_text_43": "",
		"payment_text_44": "",
		"payment_text_45": "",
		"payment_text_46": "",
		"payment_text_47": "",
		"payment_text_48": "",
		"payment_text_49": "",
		"payment_text_50": "",
		"payment_text_51": "",
		"payment_text_52": "",
		"payment_text_53": "",
		"payment_text_54": "",
		"payment_text_55": "",
		"payment_text_56": "",
		"payment_text_57": "",
		"payment_text_58": "",
		"payment_text_59": "",
		"payment_text_60": "",
		"payment_text_61": "",
		"payment_text_62": "",
		"payment_text_63": "",
		"payment_text_64": "",
		"payment_text_65": "",
		"payment_text_66": "",
		"payment_text_67": "",
		"payment_text_68": "",
		"payment_text_69": "",
		"payment_text_70": "",
		"payment_text_71": "",
		"payment_text_72": "",
		"payment_text_73": "",
		"payment_text_74": "",
		"payment_text_75": "",
		"payment_text_76": "",
		"payment_text_77": "",
		"payment_text_78": "",
		"payment_text_79": "",
		"payment_text_80": "",
		"payment_text_81": "",
		"payment_text_82": "",
		"payment_text_83": "",
		"payment_text_84": "",
		"payment_text_85": "",
		"payment_text_86": "",
		"payment_text_87": "",
		"payment_text_88": "",
		"payment_text_89": "",
		"payment_text_90": "",
		"payment_text_91": "",
		"payment_text_92": "",
		"payment_text_93": "",
		"payment_text_94": "",
		"payment_text_95": "",
		"payment_text_96": "",
		"payment_text_97": "",
		"payment_text_98": "",
		"payment_text_99": "",
		"payment_text_100": "",
		"payment_text_101": "",
		"payment_text_102": "",
		"payment_text_103": "",
		"payment_text_104": "",
		"payment_text_105": "",
		"payment_text_106": "",
		"payment_text_107": "",
		"payment_text_108": "",
		"payment_text_109": "",
		"payment_text_110": "",
		"payment_text_111": "",
		"payment_text_112": "",
		"payment_text_113": "",
		"payment_text_114": "",
		"payment_text_115": "",
		"payment_text_116": "",
		"payment_text_117": "",
		"payment_text_118": "",
		"payment_text_119": "",
		"payment_text_120": "",
		"payment_text_121": "",
		"payment_text_122": "",
		"payment_text_123": "",
		"payment_text_124": "",
		"payment_text_125": "",
		"payment_text_126": "",
		"payment_text_127": "",
		"payment_text_128": "",
		"payment_text_129": "",
		"payment_text_130": "",
		"payment_text_131": "",
		"payment_text_132": "",
		"payment_text_133": "",
		"payment_text_134": "",
		"payment_text_135": "",
		"payment_text_136": "",
		"payment_text_137": "",
		"payment_text_138": "",
		"payment_text_139": "",
		"payment_text_140": "",
		"payment_text_141": "",
		"payment_text_142": "",
		"payment_text_143": "",
		"payment_text_144": "",
		"payment_text_145": "",
		"payment_text_146": "",
		"payment_text_147": "",
		"payment_text_148": "",
		"payment_text_149": "",
		"payment_text_150": "",
		"payment_text_151": "",
		"payment_text_152": "",
		"payment_text_153": "",
		"payment_text_154": "",
		"payment_text_155": "",
		"payment_text_156": "",
		"payment_text_157": "",
		"payment_text_158": "",
		"payment_text_159": "",
		"payment_text_160": "",
		"payment_text_161": "",
		"payment_text_162": "",
		"payment_text_163": "",
		"payment_text_164": "",
		"payment_text_165": "",
		"payment_text_166": "",
		"payment_text_167": "",
		"payment_text_168": "",
		"payment_text_169": "",
		"payment_text_170": "",
		"payment_text_171": "",
		"payment_text_172": "",
		"payment_text_173": "",
		"payment_text_174": "",
		"payment_text_175": "",
		"payment_text_176": "",
		"payment_text_177": "",
		"payment_text_178": "",
		"payment_text_179": "",
		"payment_text_180": "",
		"payment_text_181": "",
		"payment_text_182": "",
		"payment_text_183": "",
		"payment_text_184": "",
		"payment_text_185": "",
		"payment_text_186": "",
		"payment_text_187": "",
		"payment_text_188": "",
		"payment_text_189": "",
		"payment_text_190": "",
		"payment_text_191": "",
		"payment_text_192": "",
		"payment_text_193": "",
		"payment_text_194": "",
		"payment_text_195": "",
		"payment_text_196": "",
		"payment_text_197": "",
		"payment_text_198": "",
		"payment_text_199": "",
		"payment_text_200": "",
		"payment_text_201": "",
		"payment_text_202": "",
		"payment_text_203": "",
		"payment_text_204": "",
		"payment_text_205": "",
		"payment_text_206": "",
		"payment_text_207": "",
		"payment_text_208": "",
		"payment_text_209": "",
		"payment_text_210": "",
		"payment_text_211": "",
		"payment_text_212": "",
		"payment_text_213": "",
		"payment_text_214": "",
		"payment_text_215": "",
		"payment_text_216": "",
		"payment_text_217": "",
		"payment_text_218": "",
		"payment_text_219": "",
		"payment_text_220": "",
		"payment_text_221": "",
		"payment_text_222": "",
		"payment_text_223": "",
		"payment_text_224": "",
		"payment_text_225": "",
		"payment_text_226": "",
		"payment_text_227": "",
		"payment_text_228": "",
		"payment_text_229": "",
		"payment_text_230": "",
		"payment_text_231": "",
		"payment_text_232": "",
		"payment_text_233": "",
		"payment_text_234": "",
		"payment_text_235": "",
		"payment_text_236": "",
		"payment_text_237": "",
		"payment_text_238": "",
		"payment_text_239": "",
		"payment_text_240": "",
		"payment_text_241": "",
		"payment_text_242": "",
		"payment_text_243": "",
		"payment_text_244": "",
		"payment_text_245": "",
		"payment_text_246": "",
		"payment_text_247": "",
		"payment_text_248": "",
		"payment_text_249": "",
		"payment_text_250": "",
		"payment_text_251": "",
		"payment_text_252": "",
		"payment_text_253": "",
		"payment_text_254": "",
		"payment_text_255": "",
		"payment_text_256": "",
		"payment_text_257": "",
		"payment_text_258": "",
		"payment_text_259": "",
		"payment_text_260": "",
		"payment_text_261": "",
		"payment_text_262": "",
		"payment_text_263": "",
		"payment_text_264": "",
		"payment_text_265": "",
		"payment_text_266": "",
		"payment_text_267": "",
		"payment_text_268": "",
		"payment_text_269": "",
		"payment_text_270": "",
		"payment_text_271": "",
		"payment_text_272": "",
		"payment_text_273": "",
		"payment_text_274": "",
		"payment_text_275": "",
		"payment_text_276": "",
		"payment_text_277": "",
		"payment_text_278": "",
		"payment_text_279": "",
		"payment_text_280": "",
		"payment_text_281": "",
		"payment_text_282": "",
		"payment_text_283": "",
		"payment_text_284": "",
		"payment_text_285": "",
		"payment_text_286": "",
		"payment_text_287": "",
		"payment_text_288": "",
		"payment_text_289": "",
		"payment_text_290": "",
		"payment_text_291": "",
		"payment_text_292": "",
		"payment_text_293": "",
		"payment_text_294": "",
		"payment_text_295": "",
		"payment_text_296": "",
		"payment_text_297": "",
		"payment_text_298": "",
		"payment_text_299": "",
		"payment_text_300": "",
		"payment_text_301": "",
		"payment_text_302": "",
		"payment_text_303": "",
		"payment_text_304": "",
		"payment_text_305": "",
		"payment_text_306": "",
		"payment_text_307": "",
		"payment_text_308": "",
		"payment_text_309": "",
		"payment_text_310": "",
		"payment_text_311": "",
		"payment_text_312": "",
		"payment_text_313": "",
		"payment_text_314": "",
		"payment_text_315": "",
		"payment_text_316": "",
		"payment_text_317": "",
		"payment_text_318": "",
		"payment_text_319": "",
		"payment_text_320": "",
		"payment_text_321": "",
		"payment_text_322": "",
		"payment_text_323": "",
		"payment_text_324": "",
		"payment_text_325": "",
		"payment_text_326": "",
		"payment_text_327": "",
		"payment_text_328": "",
		"payment_text_329": "",
		"payment_text_330": "",
		"payment_text_331": "",
		"payment_text_332": "",
		"payment_text_333": "",
		"payment_text_334": "",
		"payment_text_335": "",
		"payment_text_336": "",
		"payment_text_337": "",
		"payment_text_338": "",
		"payment_text_339": "",
		"payment_text_340": "",
		"payment_text_341": "",
		"payment_text_342": "",
		"payment_text_343": "",
		"payment_text_344": "",
		"payment_text_345": "",
		"payment_text_346": "",
		"payment_text_347": "",
		"payment_text_348": "",
		"payment_text_349": "",
		"payment_text_350": "",
		"payment_text_351": "",
		"payment_text_352": "",
		"payment_text_353": "",
		"payment_text_354": "",
		"payment_text_355": "",
		"payment_text_356": "",
		"payment_text_357": "",
		"payment_text_358": "",
		"payment_text_359": "",
		"payment_text_360": "",
		"payment_text_361": "",
		"payment_text_362": "",
		"payment_text_363": "",
		"payment_text_364": "",
		"payment_text_365": "",
		"payment_text_366": "",
		"payment_text_367": "",
		"payment_text_368": "",
		"payment_text_369": "",
		"payment_text_370": "",
		"payment_text_371": "",
		"payment_text_372": "",
		"payment_text_373": "",
		"payment_text_374": "",
		"payment_text_375": "",
		"payment_text_376": "",
		"payment_text_377": "",
		"payment_text_378": "",
		"payment_text_379": "",
		"payment_text_380": "",
		"payment_text_381": "",
		"payment_text_382": "",
		"payment_text_383": "",
		"payment_text_384": "",
		"payment_text_385": "",
		"payment_text_386": "",
		"payment_text_387": "",
		"payment_text_388": "",
		"payment_text_389": "",
		"pdfUpselling": "",
		"pdfUpselling_1": "",
		"pdfUpselling_2": "",
		"pdfUpselling_3": "",
		"pdfUpselling_4": "",
		"pdfUpselling_5": "",
		"pdfUpselling_6": "",
		"pdfUpselling_7": "",
		"pdfUpselling_8": "",
		"pdfUpselling_9": "",
		"pdfUpselling_10": "",
		"pdfUpselling_11": "",
		"pdfUpselling_12": "",
		"pdfUpselling_13": "",
		"pdfUpselling_14": "",
		"pdfUpselling_15": "",
		"pdfUpselling_16": "",
		"chatUpsale_1": "",
		"chatUpsale_2": "",
		"chatUpsale_3": "",
		"chatUpsale_4": "",
		"chatUpsale_5": "",
		"chatUpsale_6": "",
		"chatUpsale_7": "",
		"chatUpsale_8": "",
		"chatUpsale_9": "",
		"chatUpsale_10": "",
		"chatUpsale_11": "",
		"chatUpsale_12": "",
		"chatUpsale_13": "",
		"chatUpsale_14": "",
		"chatUpsale_15": "",
		"checkoutV2_text1": "",
		"checkoutV2_text2": "",
		"checkoutV2_text3": "",
		"checkoutV2_text4": "",
		"checkoutV2_text5": "",
		"checkoutV2_text6": "",
		"checkoutV2_text7": "",
		"checkoutV2_text8": "",
		"checkoutV2_text9": "",
		"checkoutV2_text10": "",
		"checkoutV2_text11": "",
		"error_1": "",
		"error_2": "",
		"error_3": "",
		"error_4": "",
		"error_5": "",
		"error_6": "",
		"error_7": "",
		"error_8": "",
		"error_9": "",
		"error_10": "",
		"disclaimerV2_text_1": "",
		"disclaimerV2_text_2": "",
		"disclaimerV2_text_3": "",
		"chatUpsaleV2_1": "",
		"chatUpsaleV2_2": "",
		"chatUpsaleV2_3": "",
		"chatUpsaleV2_4": "",
		"chatUpsaleV2_5": "",
		"chatUpsaleV2_6": "",
		"chatUpsaleV2_7": "",
		"chatUpsaleV2_8": "",
		"chatUpsaleV2_9": "",
		"chatUpsaleV2_10": "",
		"chatUpsaleV2_11": "",
		"chatUpsaleV2_12": "",
		"chatUpsaleV2_13": "",
		"chatUpsaleV2_14": "",
		"chatUpsaleV2_15": "",
		"chatUpsaleV2_16": "",
		"chatUpsaleV2_17": "",
		"chatUpsaleV2_18": "",
		"chatUpsaleV2_19": "",
		"chatUpsaleV2_20": "",
		"chatUpsaleV2_21": "",
		"chatUpsaleV2_22": "",
		"chatUpsaleV2_23": "",
		"chatUpsaleV2_24": "",
		"chatUpsaleV2_25": "",
		"chatUpsaleV2_26": "",
		"chatUpsaleV2_27": "",
		"chatUpsaleV2_28": "",
		"chatUpsaleV2_29": "",
		"chatUpsaleV2_30": "",
		"chatUpsaleV2_31": "",
		"chatUpsaleV2_32": "",
		"chatUpsaleV2_33": ""
	},
	"instruction": {
		"global \ninstruction": "",
		"safe": "",
		"information": "",
		"secure_checkout": "",
		"encrypted": "",
		"help": "",
		"contact": "",
		"here": "",
		"undefined": "",
		"featured": "",
		"main_title": "",
		"per_year": "",
		"special_offer": "",
		"card_number": "",
		"card_expiry": "",
		"security_number": "",
		"email": "",
		"To avoid any disruption, you agree that the subscription you selected will automatically be extended for a successive renewal period of __period__ and at the full, not discounted, price of __fullPriceText__ To learn more visit our <a class=\"link\" href=\"https://app.everydoggy.com/terms/\" target=\"_blank\">terms of use</a>.": "",
		"secure_server": "",
		"pay": "",
		"enter_your_email": "",
		"comment_1": "",
		"comment_2": "",
		"success_story": "",
		"get_my_plan": "",
		"delimiter": "",
		"pay_buy_card": "",
		"get_my_plan_warning_1": "",
		"get_my_plan_warning_2": "",
		"get_my_plan_warning_3": "",
		"get_my_plan_warning_text": "",
		"terms_of_use": "",
		"privacy_policy": "",
		"terms_conditions": "",
		"privacy_policy_footer": "",
		"terms_conditions_footer": "",
		"guaranteed": "",
		"special_features": "",
		"calories_value": "",
		"personalized_plan": "",
		"mobile_app": "",
		"daily_programs": "",
		"audio_guided": "",
		"easy_to_cook": "",
		"comprehensive_stats": "",
		"secret_tips": "",
		"mobile_app_tailor": "",
		"daily_programs_for": "",
		"daily_programs_for_2": "",
		"audio_trainers": "",
		"comprehensive_track": "",
		"price": "",
		"users_love": "",
		"alternative_review_name_1": "",
		"alternative_review_title_1": "",
		"alternative_review_contentent_1": "",
		"alternative_review_name_2": "",
		"alternative_review_title_2": "",
		"alternative_review_contentent_2": "",
		"you_re_in": "",
		"personal_plan_starts": "",
		"app_by_link": "",
		"download_now": "",
		"or": "",
		"price_after_trial": "",
		"seven_days_trial_unlocked": "",
		"total_today": "",
		"reserved_price_for": "",
		"new_subscritions1_title": "",
		"new_subscritions1_subscription1_line1": "",
		"new_subscritions1_subscription1_price1_time": "",
		"new_subscritions1_subscription2_line1": "",
		"new_subscritions1_subscription2_price2_time": "",
		"new_subscritions1_subscription3_line1": "",
		"new_subscritions1_subscription3_price3_time": "",
		"new_subscription_save": "",
		"new_subscritions_agreement": "",
		"new_subscritions_and": "",
		"new_subscritions_subtitle": "",
		"new_subscritions_join": "",
		"statistic_block_item1_text": "",
		"statistic_block_item2_text": "",
		"statistic_block_item3_text": "",
		"get_your_personalized_plan": "",
		"for": "",
		"new_subscription_save_mostPopular1MonthPrice": "",
		"timer_additional_discount": "",
		"timer_additional_discount_bold": "",
		"timer_offer_expires": "",
		"Payment Successful": "",
		"payment_successful_title": "",
		"payment_successful_download": "",
		"payment_successful_press": "",
		"payment_successful_login": "",
		"payment_successful_email": "",
		"payment_successful_code": "",
		"payment_successful_hit": "",
		"payment_successful_done": "",
		"payment_successful_description": "",
		"Tariffs Variants": "",
		"tariff_title_choose": "",
		"tariff_title_get": "",
		"tariff_one_month": "",
		"tariff_three_month": "",
		"tariff_six_month": "",
		"tariff_one_year": "",
		"tariff_one_week": "",
		"tariff_three_day": "",
		"tariff_per_year": "",
		"tariff_per_day": "",
		"tariff_per_days": "",
		"tariff_per_week": "",
		"tariff_week": "",
		"tariff_annual": "",
		"tariff_trial_one_week": "",
		"tariff_after": "",
		"tariff_save": "",
		"tariff_best_offer": "",
		"tariff_most_popular": "",
		"tariff_limited_promo": "",
		"tariff_6_for_3": "",
		"tariff_first_month": "",
		"tariff_first_week": "",
		"tariff_monthly": "",
		"tariff_quaterly": "",
		"tariff_semiannually": "",
		"tariff_billed_every ": "",
		"tariff_year": "",
		"tariff_month": "",
		"tariff_months": "",
		"tariff_months_variable": "",
		"tariff_organic_gift": "",
		"tariff_full_price": "",
		"tariff_no_hidden_fees": "",
		"tariff_start_right_now": "",
		"tariff_more_than": "",
		"tariff_intro_offer": "",
		"Тарифы плиткой в ряд": "",
		"": "",
		"Checkout": "",
		"checkout_title": "",
		"insufficient_funds": "",
		"insufficient_we_have": "",
		"insufficient_special_price": "",
		"insufficient_for_you": "",
		"checkout_edit_card": "",
		"checkout_pay_via": "",
		"checkout_paypal": "",
		"checkout_credit_card": "",
		"checkout_paypal_description": "",
		"checkout_total_price": "",
		"checkout_warning_1": "",
		"checkout_warning_2": "",
		"checkout_warning_3": "",
		"spv2_warning": "",
		"checkout_offer_day_for": "",
		"checkout_offer_days_for": "",
		"checkout_offer_month_for": "",
		"checkout_offer_months_for": "",
		"checkout_offer_week_for": "",
		"Values": "",
		"value_kg": "",
		"value_pounds": "",
		"value_st": "",
		"value_g": "",
		"value_kcal": "",
		"value_min": "",
		"value_min_cooking": "",
		"welcome_title": "",
		"item_1_title": "",
		"item_1_description": "",
		"item_2_title": "",
		"item_2_description": "",
		"item_2_description_2": "",
		"item_3_title": "",
		"item_3_description": "",
		"change": "",
		"change_mail": "",
		"email_warning": "",
		"Promo Code Block": "",
		"promo_code_title": "",
		"promo_code_save": "",
		"EveryDoggy": "",
		"dog_courses": "",
		"why_we_best_active": "",
		"why_we_best_lessons": "",
		"why_we_best_brain": "",
		"why_we_best": "",
		"why_we_best_join": "",
		"why_we_best_enjoy": "",
		"why_we_best_keep": "",
		"dog_problems": "",
		"dog_problems_choose": "",
		"dog_problems_leash": "",
		"dog_problems_biting": "",
		"dog_problems_anxiety": "",
		"dog_problems_chewing": "",
		"dog_plan": "",
		"dog_plan_our": "",
		"dog_reviews": "",
		"dog_reviews_text_1": "",
		"dog_reviews_name_1": "",
		"dog_reviews_text_2": "",
		"dog_reviews_name_2": "",
		"dog_reviews_text_3": "",
		"dog_reviews_name_3": "",
		"join_text": "",
		"join_courses": "",
		"checkout_introductory": "",
		"checkout_personalized_plan": "",
		"Personal plan": "",
		"goal_lose_weight": "",
		"goal_gain_muscles": "",
		"goal_gain_healthier_life": "",
		"goal_gain_flexibility": "",
		"goal_gain_build_endurance": "",
		"goal_love_myself": "",
		"body_type_apple": "",
		"body_type_pear": "",
		"body_type_square": "",
		"body_type_hourglass": "",
		"body_type_triangle": "",
		"body_type_unknown": "",
		"excercises_time_morning": "",
		"excercises_time_day": "",
		"excercises_time_evening": "",
		"excercises_not_sure": "",
		"diet_type_all": "",
		"diet_type_vegetarian": "",
		"diet_type_vegan": "",
		"diet_type_keto": "",
		"personal_plan_providers_title": "",
		"special_features_title": "",
		"special_features_duration_minimum": "",
		"special_features_duration_normal": "",
		"special_features_duration_maximum": "",
		"special_features_duration_verv": "",
		"special_features_goal_lose_weight": "",
		"special_features_goal_gain": "",
		"special_features_goal_health": "",
		"special_features_goal_flexibility": "",
		"special_features_goal_endurance": "",
		"special_features_goal_love": "",
		"discount_activated": "",
		"discount_no_activated": "",
		"unlocked_with_promo": "",
		"use_with_button": "",
		"plan_optimal": "",
		"plan_standard": "",
		"plan_basic": "",
		"plan_extra": "",
		"daypayback_review_name_1": "",
		"daypayback_review_text_1": "",
		"daypayback_review_name_2": "",
		"daypayback_review_text_2": "",
		"daypayback_review_name_3": "",
		"daypayback_review_text_3": "",
		"daypayback_review_name_4": "",
		"daypayback_review_text_4": "",
		"personal_plan_you_get": "",
		"goal": "",
		"goal_other": "",
		"goal_teaching_puppy": "",
		"goal_surviving_puppy": "",
		"goal_socializing_puppy": "",
		"goal_teaching_obedience": "",
		"age_puppy": "",
		"age_adult": "",
		"biting_yes": "",
		"biting_no": "",
		"biting_sometimes": "",
		"quick_tips": "",
		"potty_training_a_bit": "",
		"potty_training_yes": "",
		"potty_training_no": "",
		"success screen": "",
		"success_screen_text_1": "",
		"success_screen_text_2": "",
		"success_screen_text_3": "",
		"success_screen_text_4": "",
		"success_screen_text_5": "",
		"success_screen_text_6": "",
		"success_screen_text_7": "",
		"success_screen_text_8": "",
		"success_screen_text_9": "",
		"success_screen_text_10": "",
		"success_screen_text_11": "",
		"success_screen_text_12": "",
		"success_screen_text_13": "",
		"success_screen_text_14": "",
		"success_screen_text_15": "",
		"success_screen_text_16": "",
		"payment_text_1": "",
		"payment_text_2": "",
		"payment_text_3": "",
		"payment_text_4": "",
		"payment_text_5": "",
		"payment_text_6": "",
		"payment_text_7": "",
		"payment_text_8": "",
		"payment_text_9": "",
		"payment_text_10": "",
		"payment_text_11": "",
		"payment_text_12": "",
		"payment_text_13": "",
		"payment_text_14": "",
		"payment_text_14_2": "",
		"payment_text_15": "",
		"payment_text_16": "",
		"payment_text_17": "",
		"payment_text_18": "",
		"payment_text_19": "",
		"payment_text_20": "",
		"payment_text_21": "",
		"payment_text_22": "",
		"payment_text_23": "",
		"payment_text_24": "",
		"payment_text_25": "",
		"payment_text_26": "",
		"payment_text_27": "",
		"payment_text_28": "",
		"payment_text_29": "",
		"payment_text_30": "",
		"payment_text_31": "",
		"payment_text_32": "",
		"payment_text_33": "",
		"payment_text_34": "",
		"payment_text_35": "",
		"payment_text_36": "",
		"payment_text_37": "",
		"payment_text_38": "",
		"payment_text_39": "",
		"payment_text_40": "",
		"payment_text_41": "",
		"payment_text_42": "",
		"payment_text_43": "",
		"payment_text_44": "",
		"payment_text_45": "",
		"payment_text_46": "",
		"payment_text_47": "",
		"payment_text_48": "",
		"payment_text_49": "",
		"payment_text_50": "",
		"payment_text_51": "",
		"payment_text_52": "",
		"payment_text_53": "",
		"payment_text_54": "",
		"payment_text_55": "",
		"payment_text_56": "",
		"payment_text_57": "",
		"payment_text_58": "",
		"payment_text_59": "",
		"payment_text_60": "",
		"payment_text_61": "",
		"payment_text_62": "",
		"payment_text_63": "",
		"payment_text_64": "",
		"payment_text_65": "",
		"payment_text_66": "",
		"payment_text_67": "",
		"payment_text_68": "",
		"payment_text_69": "",
		"payment_text_70": "",
		"payment_text_71": "",
		"payment_text_72": "",
		"payment_text_73": "",
		"payment_text_74": "",
		"payment_text_75": "",
		"payment_text_76": "",
		"payment_text_77": "",
		"payment_text_78": "",
		"payment_text_79": "",
		"payment_text_80": "",
		"payment_text_81": "",
		"payment_text_82": "",
		"payment_text_83": "",
		"payment_text_84": "",
		"payment_text_85": "",
		"payment_text_86": "",
		"payment_text_87": "",
		"payment_text_88": "",
		"payment_text_89": "",
		"payment_text_90": "",
		"payment_text_91": "",
		"payment_text_92": "",
		"payment_text_93": "",
		"payment_text_94": "",
		"payment_text_95": "",
		"payment_text_96": "",
		"payment_text_97": "",
		"payment_text_98": "",
		"payment_text_99": "",
		"payment_text_100": "",
		"payment_text_101": "",
		"payment_text_102": "",
		"payment_text_103": "",
		"payment_text_104": "",
		"payment_text_105": "",
		"payment_text_106": "",
		"payment_text_107": "",
		"payment_text_108": "",
		"payment_text_109": "",
		"payment_text_110": "",
		"payment_text_111": "",
		"payment_text_112": "",
		"payment_text_113": "",
		"payment_text_114": "",
		"payment_text_115": "",
		"payment_text_116": "",
		"payment_text_117": "",
		"payment_text_118": "",
		"payment_text_119": "",
		"payment_text_120": "",
		"payment_text_121": "",
		"payment_text_122": "",
		"payment_text_123": "",
		"payment_text_124": "",
		"payment_text_125": "",
		"payment_text_126": "",
		"payment_text_127": "",
		"payment_text_128": "",
		"payment_text_129": "",
		"payment_text_130": "",
		"payment_text_131": "",
		"payment_text_132": "",
		"payment_text_133": "",
		"payment_text_134": "",
		"payment_text_135": "",
		"payment_text_136": "",
		"payment_text_137": "",
		"payment_text_138": "",
		"payment_text_139": "",
		"payment_text_140": "",
		"payment_text_141": "",
		"payment_text_142": "",
		"payment_text_143": "",
		"payment_text_144": "",
		"payment_text_145": "",
		"payment_text_146": "",
		"payment_text_147": "",
		"payment_text_148": "",
		"payment_text_149": "",
		"payment_text_150": "",
		"payment_text_151": "",
		"payment_text_152": "",
		"payment_text_153": "",
		"payment_text_154": "",
		"payment_text_155": "",
		"payment_text_156": "",
		"payment_text_157": "",
		"payment_text_158": "",
		"payment_text_159": "",
		"payment_text_160": "",
		"payment_text_161": "",
		"payment_text_162": "",
		"payment_text_163": "",
		"payment_text_164": "",
		"payment_text_165": "",
		"payment_text_166": "",
		"payment_text_167": "",
		"payment_text_168": "",
		"payment_text_169": "",
		"payment_text_170": "",
		"payment_text_171": "",
		"payment_text_172": "",
		"payment_text_173": "",
		"payment_text_174": "",
		"payment_text_175": "",
		"payment_text_176": "",
		"payment_text_177": "",
		"payment_text_178": "",
		"payment_text_179": "",
		"payment_text_180": "",
		"payment_text_181": "",
		"payment_text_182": "",
		"payment_text_183": "",
		"payment_text_184": "",
		"payment_text_185": "",
		"payment_text_186": "",
		"payment_text_187": "",
		"payment_text_188": "",
		"payment_text_189": "",
		"payment_text_190": "",
		"payment_text_191": "",
		"payment_text_192": "",
		"payment_text_193": "",
		"payment_text_194": "",
		"payment_text_195": "",
		"payment_text_196": "",
		"payment_text_197": "",
		"payment_text_198": "",
		"payment_text_199": "",
		"payment_text_200": "",
		"payment_text_201": "",
		"payment_text_202": "",
		"payment_text_203": "",
		"payment_text_204": "",
		"payment_text_205": "",
		"payment_text_206": "",
		"payment_text_207": "",
		"payment_text_208": "",
		"payment_text_209": "",
		"payment_text_210": "",
		"payment_text_211": "",
		"payment_text_212": "",
		"payment_text_213": "",
		"payment_text_214": "",
		"payment_text_215": "",
		"payment_text_216": "",
		"payment_text_217": "",
		"payment_text_218": "",
		"payment_text_219": "",
		"payment_text_220": "",
		"payment_text_221": "",
		"payment_text_222": "",
		"payment_text_223": "",
		"payment_text_224": "",
		"payment_text_225": "",
		"payment_text_226": "",
		"payment_text_227": "",
		"payment_text_228": "",
		"payment_text_229": "",
		"payment_text_230": "",
		"payment_text_231": "",
		"payment_text_232": "",
		"payment_text_233": "",
		"payment_text_234": "",
		"payment_text_235": "",
		"payment_text_236": "",
		"payment_text_237": "",
		"payment_text_238": "",
		"payment_text_239": "",
		"payment_text_240": "",
		"payment_text_241": "",
		"payment_text_242": "",
		"payment_text_243": "",
		"payment_text_244": "",
		"payment_text_245": "",
		"payment_text_246": "",
		"payment_text_247": "",
		"payment_text_248": "",
		"payment_text_249": "",
		"payment_text_250": "",
		"payment_text_251": "",
		"payment_text_252": "",
		"payment_text_253": "",
		"payment_text_254": "",
		"payment_text_255": "",
		"payment_text_256": "",
		"payment_text_257": "",
		"payment_text_258": "",
		"payment_text_259": "",
		"payment_text_260": "",
		"payment_text_261": "",
		"payment_text_262": "",
		"payment_text_263": "",
		"payment_text_264": "",
		"payment_text_265": "",
		"payment_text_266": "",
		"payment_text_267": "",
		"payment_text_268": "",
		"payment_text_269": "",
		"payment_text_270": "",
		"payment_text_271": "",
		"payment_text_272": "",
		"payment_text_273": "",
		"payment_text_274": "",
		"payment_text_275": "",
		"payment_text_276": "",
		"payment_text_277": "",
		"payment_text_278": "",
		"payment_text_279": "",
		"payment_text_280": "",
		"payment_text_281": "",
		"payment_text_282": "",
		"payment_text_283": "",
		"payment_text_284": "",
		"payment_text_285": "",
		"payment_text_286": "",
		"payment_text_287": "",
		"payment_text_288": "",
		"payment_text_289": "",
		"payment_text_290": "",
		"payment_text_291": "",
		"payment_text_292": "",
		"payment_text_293": "",
		"payment_text_294": "",
		"payment_text_295": "",
		"payment_text_296": "",
		"payment_text_297": "",
		"payment_text_298": "",
		"payment_text_299": "",
		"payment_text_300": "",
		"payment_text_301": "",
		"payment_text_302": "",
		"payment_text_303": "",
		"payment_text_304": "",
		"payment_text_305": "",
		"payment_text_306": "",
		"payment_text_307": "",
		"payment_text_308": "",
		"payment_text_309": "",
		"payment_text_310": "",
		"payment_text_311": "",
		"payment_text_312": "",
		"payment_text_313": "",
		"payment_text_314": "",
		"payment_text_315": "",
		"payment_text_316": "",
		"payment_text_317": "",
		"payment_text_318": "",
		"payment_text_319": "",
		"payment_text_320": "",
		"payment_text_321": "",
		"payment_text_322": "",
		"payment_text_323": "",
		"payment_text_324": "",
		"payment_text_325": "",
		"payment_text_326": "",
		"payment_text_327": "",
		"payment_text_328": "",
		"payment_text_329": "",
		"payment_text_330": "",
		"payment_text_331": "",
		"payment_text_332": "",
		"payment_text_333": "",
		"payment_text_334": "",
		"payment_text_335": "",
		"payment_text_336": "",
		"payment_text_337": "",
		"payment_text_338": "",
		"payment_text_339": "",
		"payment_text_340": "",
		"payment_text_341": "",
		"payment_text_342": "",
		"payment_text_343": "",
		"payment_text_344": "",
		"payment_text_345": "",
		"payment_text_346": "",
		"payment_text_347": "",
		"payment_text_348": "",
		"payment_text_349": "",
		"payment_text_350": "",
		"payment_text_351": "",
		"payment_text_352": "",
		"payment_text_353": "",
		"payment_text_354": "",
		"payment_text_355": "",
		"payment_text_356": "",
		"payment_text_357": "",
		"payment_text_358": "",
		"payment_text_359": "",
		"payment_text_360": "",
		"payment_text_361": "",
		"payment_text_362": "",
		"payment_text_363": "",
		"payment_text_364": "",
		"payment_text_365": "",
		"payment_text_366": "",
		"payment_text_367": "",
		"payment_text_368": "",
		"payment_text_369": "",
		"payment_text_370": "",
		"payment_text_371": "",
		"payment_text_372": "",
		"payment_text_373": "",
		"payment_text_374": "",
		"payment_text_375": "",
		"payment_text_376": "",
		"payment_text_377": "",
		"payment_text_378": "",
		"payment_text_379": "",
		"payment_text_380": "",
		"payment_text_381": "",
		"payment_text_382": "",
		"payment_text_383": "",
		"payment_text_384": "",
		"payment_text_385": "",
		"payment_text_386": "",
		"payment_text_387": "",
		"payment_text_388": "",
		"payment_text_389": "",
		"pdfUpselling": "",
		"pdfUpselling_1": "",
		"pdfUpselling_2": "",
		"pdfUpselling_3": "",
		"pdfUpselling_4": "",
		"pdfUpselling_5": "",
		"pdfUpselling_6": "",
		"pdfUpselling_7": "",
		"pdfUpselling_8": "",
		"pdfUpselling_9": "",
		"pdfUpselling_10": "",
		"pdfUpselling_11": "",
		"pdfUpselling_12": "",
		"pdfUpselling_13": "",
		"pdfUpselling_14": "",
		"pdfUpselling_15": "",
		"pdfUpselling_16": "",
		"chatUpsale_1": "",
		"chatUpsale_2": "",
		"chatUpsale_3": "",
		"chatUpsale_4": "",
		"chatUpsale_5": "",
		"chatUpsale_6": "",
		"chatUpsale_7": "",
		"chatUpsale_8": "",
		"chatUpsale_9": "",
		"chatUpsale_10": "",
		"chatUpsale_11": "",
		"chatUpsale_12": "",
		"chatUpsale_13": "",
		"chatUpsale_14": "",
		"chatUpsale_15": "",
		"checkoutV2_text1": "",
		"checkoutV2_text2": "",
		"checkoutV2_text3": "",
		"checkoutV2_text4": "",
		"checkoutV2_text5": "",
		"checkoutV2_text6": "",
		"checkoutV2_text7": "",
		"checkoutV2_text8": "",
		"checkoutV2_text9": "",
		"checkoutV2_text10": "",
		"checkoutV2_text11": "",
		"error_1": "",
		"error_2": "",
		"error_3": "",
		"error_4": "",
		"error_5": "",
		"error_6": "",
		"error_7": "",
		"error_8": "",
		"error_9": "",
		"error_10": "",
		"disclaimerV2_text_1": "",
		"disclaimerV2_text_2": "",
		"disclaimerV2_text_3": "",
		"chatUpsaleV2_1": "",
		"chatUpsaleV2_2": "",
		"chatUpsaleV2_3": "",
		"chatUpsaleV2_4": "",
		"chatUpsaleV2_5": "",
		"chatUpsaleV2_6": "",
		"chatUpsaleV2_7": "",
		"chatUpsaleV2_8": "",
		"chatUpsaleV2_9": "",
		"chatUpsaleV2_10": "",
		"chatUpsaleV2_11": "",
		"chatUpsaleV2_12": "",
		"chatUpsaleV2_13": "",
		"chatUpsaleV2_14": "",
		"chatUpsaleV2_15": "",
		"chatUpsaleV2_16": "",
		"chatUpsaleV2_17": "",
		"chatUpsaleV2_18": "",
		"chatUpsaleV2_19": "",
		"chatUpsaleV2_20": "",
		"chatUpsaleV2_21": "",
		"chatUpsaleV2_22": "",
		"chatUpsaleV2_23": "",
		"chatUpsaleV2_24": "",
		"chatUpsaleV2_25": "",
		"chatUpsaleV2_26": "",
		"chatUpsaleV2_27": "",
		"chatUpsaleV2_28": "",
		"chatUpsaleV2_29": "",
		"chatUpsaleV2_30": "",
		"chatUpsaleV2_31": "",
		"chatUpsaleV2_32": "",
		"chatUpsaleV2_33": ""
	}
}
